export interface LocaleEntry {
  id: string;
  en: string;
  fr: string;
  es: string;
  de: string;
  pl: string;
  ru: string;
  uk: string;
  ko: string;
  zh: string;
  ja: string;
}

export interface LocaleData {
  type: string;
  entries: LocaleEntry[];
}

export const localeData: LocaleData[] =
  [{
    'type': 'items',
    'entries': [{
      'id': 'AcornItem',
      'en': 'Acorn',
      'fr': 'Gland',
      'es': 'Bellota',
      'de': 'Eichel',
      'pl': 'Żołądź',
      'ru': 'Желудь',
      'uk': 'Жолудь',
      'ko': '도토리',
      'zh': '橡子',
      'ja': 'どんぐり'
    }, {
      'id': 'AcornPowderItem',
      'en': 'Acorn Powder',
      'fr': 'Poudre de gland',
      'es': 'polvo de bellota',
      'de': 'Eichelpulver',
      'pl': 'Proszek żołędziowy',
      'ru': 'желудь порошок',
      'uk': 'Жолудевий порошок',
      'ko': '도토리가루',
      'zh': '橡子粉',
      'ja': 'どんぐり粉'
    }, {
      'id': 'AdornedAshlarBasaltBenchItem',
      'en': 'Adorned Ashlar Basalt Bench',
      'fr': 'Banc orné de basalte en pierre de taille',
      'es': 'Banco de basalto sillar adornado',
      'de': 'Geschmückte Ashlar-Basalt-Bank',
      'pl': 'Zdobiona ławka bazaltowa z Ashlar',
      'ru': 'Украшенная базальтовая скамья из тесаного камня',
      'uk': 'Прикрашена базальтова лавка',
      'ko': '장식된 Ashlar 현무암 벤치',
      'zh': '装饰的方石玄武岩长凳',
      'ja': '装飾された切石玄武岩のベンチ'
    }, {
      'id': 'AdornedAshlarBasaltChairItem',
      'en': 'Adorned Ashlar Basalt Chair',
      'fr': 'Chaise en basalte en pierre de taille ornée',
      'es': 'Silla de basalto sillería adornada',
      'de': 'Geschmückter Ashlar-Basalt-Stuhl',
      'pl': 'Zdobione krzesło bazaltowe z Ashlar',
      'ru': 'Украшенный базальтовый стул из ашлара',
      'uk': 'Прикрашене базальтове крісло',
      'ko': '장식된 Ashlar 현무암 의자',
      'zh': '装饰的 Ashlar 玄武岩椅子',
      'ja': '装飾された切石玄武岩の椅子'
    }, {
      'id': 'AdornedAshlarBasaltTableItem',
      'en': 'Adorned Ashlar Basalt Table',
      'fr': 'Table de basalte en pierre de taille ornée',
      'es': 'Mesa Adornada de Sillería Basalto',
      'de': 'Geschmückter Ashlar-Basalt-Tisch',
      'pl': 'Zdobiony stół bazaltowy z Ashlar',
      'ru': 'Украшенный базальтовый стол из тесаного камня',
      'uk': 'Прикрашений базальтовий стіл',
      'ko': '장식된 Ashlar 현무암 테이블',
      'zh': '装饰的方石玄武岩桌',
      'ja': '装飾された切石玄武岩テーブル'
    }, {
      'id': 'AdornedAshlarGneissBenchItem',
      'en': 'Adorned Ashlar Gneiss Bench',
      'fr': 'Banc orné de gneiss en pierre de taille',
      'es': 'Banco de sillar gneis adornado',
      'de': 'Geschmückte Quader-Gneis-Bank',
      'pl': 'Zdobiona ławka Ashlar Gnejs',
      'ru': 'Украшенная скамья из ашлара из гнейса',
      'uk': 'Прикрашена лавка з ґнейсу',
      'ko': '장식된 Ashlar 편마암 벤치',
      'zh': '装饰的方石片麻岩长凳',
      'ja': '装飾された切石片麻岩ベンチ'
    }, {
      'id': 'AdornedAshlarGneissChairItem',
      'en': 'Adorned Ashlar Gneiss Chair',
      'fr': 'Chaise en gneiss en pierre de taille ornée',
      'es': 'Silla Gneiss Sillar Adornada',
      'de': 'Geschmückter Ashlar-Gneis-Stuhl',
      'pl': 'Zdobione krzesło Ashlar Gneiss',
      'ru': 'Украшенное кресло из ашлара из гнейса',
      'uk': 'Прикрашений стілець Ashlar Gneiss',
      'ko': '장식된 Ashlar 편마암 의자',
      'zh': '装饰的 Ashlar 片麻岩椅子',
      'ja': '装飾された切石片麻岩の椅子'
    }, {
      'id': 'AdornedAshlarGneissTableItem',
      'en': 'Adorned Ashlar Gneiss Table',
      'fr': 'Table en gneiss en pierre de taille ornée',
      'es': 'Mesa Adornada de Sillería Gneiss',
      'de': 'Geschmückter Quader-Gneis-Tisch',
      'pl': 'Zdobiony stół Ashlar Gnejs',
      'ru': 'Украшенный стол из ашлара из гнейса',
      'uk': 'Прикрашений столик з ґнейсу',
      'ko': '장식된 Ashlar 편마암 테이블',
      'zh': '装饰的方石片麻岩桌',
      'ja': '装飾された切石片麻岩テーブル'
    }, {
      'id': 'AdornedAshlarGraniteBenchItem',
      'en': 'Adorned Ashlar Granite Bench',
      'fr': 'Banc de granit orné de pierre de taille',
      'es': 'Banco de granito sillar adornado',
      'de': 'Geschmückte Granitbank aus Quaderstein',
      'pl': 'Zdobiona ławka z granitu Ashlar',
      'ru': 'Украшенная гранитная скамья из тесаного камня',
      'uk': 'Прикрашена гранітна лавка з тесену',
      'ko': '장식된 Ashlar 화강암 벤치',
      'zh': '装饰的方石花岗岩长凳',
      'ja': '装飾された切石花崗岩のベンチ'
    }, {
      'id': 'AdornedAshlarGraniteChairItem',
      'en': 'Adorned Ashlar Granite Chair',
      'fr': 'Chaise en granit de pierre de taille ornée',
      'es': 'Silla de granito sillar adornado',
      'de': 'Geschmückter Ashlar-Granit-Stuhl',
      'pl': 'Zdobione krzesło granitowe Ashlar',
      'ru': 'Украшенное гранитное кресло из ашлара',
      'uk': 'Прикрашений гранітний стілець Ashlar',
      'ko': '장식된 Ashlar 화강암 의자',
      'zh': '装饰的阿什拉花岗岩椅子',
      'ja': '装飾された切石花崗岩の椅子'
    }, {
      'id': 'AdornedAshlarGraniteTableItem',
      'en': 'Adorned Ashlar Granite Table',
      'fr': 'Table en granit de pierre de taille ornée',
      'es': 'Mesa de granito sillar adornado',
      'de': 'Geschmückter Granittisch aus Quaderstein',
      'pl': 'Zdobiony stół z granitu Ashlar',
      'ru': 'Украшенный гранитный стол из тесаного камня',
      'uk': 'Прикрашений гранітний стіл з тесаного каменю',
      'ko': '장식된 Ashlar 화강암 테이블',
      'zh': '装饰的方石花岗岩桌',
      'ja': '装飾された切石花崗岩のテーブル'
    }, {
      'id': 'AdornedAshlarLimestoneBenchItem',
      'en': 'Adorned Ashlar Limestone Bench',
      'fr': 'Banc orné de pierre calcaire Ashlar',
      'es': 'Banco de piedra caliza sillar adornado',
      'de': 'Geschmückte Ashlar Kalksteinbank',
      'pl': 'Zdobiona ławka z wapienia Ashlar',
      'ru': 'Украшенная скамья из ашларового известняка',
      'uk': 'Прикрашена вапнякова лава з тесену',
      'ko': '장식된 Ashlar 석회암 벤치',
      'zh': '装饰的 Ashlar 石灰石长凳',
      'ja': '装飾された切石石灰岩のベンチ'
    }, {
      'id': 'AdornedAshlarLimestoneChairItem',
      'en': 'Adorned Ashlar Limestone Chair',
      'fr': 'Chaise en pierre calcaire ornée de pierre de taille',
      'es': 'Silla de sillería caliza adornada',
      'de': 'Geschmückter Ashlar-Kalkstein-Stuhl',
      'pl': 'Zdobione krzesło z wapienia Ashlar',
      'ru': 'Украшенное известняковое кресло из ашлара',
      'uk': 'Прикрашене крісло з вапняку',
      'ko': '장식된 Ashlar 석회암 의자',
      'zh': '装饰的 Ashlar 石灰石椅子',
      'ja': '装飾された切石石灰岩の椅子'
    }, {
      'id': 'AdornedAshlarLimestoneTableItem',
      'en': 'Adorned Ashlar Limestone Table',
      'fr': 'Table en pierre calcaire ornée de pierre de taille',
      'es': 'Mesa de sillería caliza adornada',
      'de': 'Geschmückter Ashlar-Kalkstein-Tisch',
      'pl': 'Zdobiony stół wapienny z Ashlar',
      'ru': 'Украшенный стол из ашлара из известняка',
      'uk': 'Прикрашений столик з вапняку',
      'ko': '장식된 Ashlar 석회암 테이블',
      'zh': '装饰的方石石灰石桌',
      'ja': '装飾された切石石灰岩のテーブル'
    }, {
      'id': 'AdornedAshlarSandstoneBenchItem',
      'en': 'Adorned Ashlar Sandstone Bench',
      'fr': 'Banc en grès orné de pierres de taille',
      'es': 'Banco de piedra arenisca sillar adornado',
      'de': 'Geschmückte Sandsteinbank aus Quaderstein',
      'pl': 'Zdobiona ławka z piaskowca Ashlar',
      'ru': 'Украшенная скамья из ашларового песчаника',
      'uk': 'Прикрашена лавка з пісковика з пісковика',
      'ko': '장식된 Ashlar 사암 벤치',
      'zh': '装饰的 Ashlar 砂岩长凳',
      'ja': '装飾された切石砂岩ベンチ'
    }, {
      'id': 'AdornedAshlarSandstoneChairItem',
      'en': 'Adorned Ashlar Sandstone Chair',
      'fr': 'Chaise en grès Ashlar ornée',
      'es': 'Silla de sillería arenisca adornada',
      'de': 'Geschmückter Ashlar-Stuhl aus Sandstein',
      'pl': 'Zdobione krzesło z piaskowca Ashlar',
      'ru': 'Украшенное кресло из ашлара из песчаника',
      'uk': 'Прикрашене крісло з пісковика',
      'ko': '장식된 Ashlar 사암 의자',
      'zh': '装饰的 Ashlar 砂岩椅子',
      'ja': '装飾された切石砂岩の椅子'
    }, {
      'id': 'AdornedAshlarSandstoneTableItem',
      'en': 'Adorned Ashlar Sandstone Table',
      'fr': 'Table ornée de grès de pierre de taille',
      'es': 'Mesa de sillería arenisca adornada',
      'de': 'Geschmückter Quader-Sandstein-Tisch',
      'pl': 'Zdobiony stół z piaskowca Ashlar',
      'ru': 'Украшенный стол из ашларового песчаника',
      'uk': 'Прикрашений стіл з пісковика з тесеня',
      'ko': '장식된 Ashlar 사암 테이블',
      'zh': '装饰的方石砂岩桌',
      'ja': '装飾された切石砂岩テーブル'
    }, {
      'id': 'AdornedAshlarShaleBenchItem',
      'en': 'Adorned Ashlar Shale Bench',
      'fr': 'Banc de schiste ashlar orné',
      'es': 'Banco de esquisto de sillería adornado',
      'de': 'Geschmückte Ashlar Shale Bank',
      'pl': 'Zdobiona ławka z łupków Ashlar',
      'ru': 'Украшенная скамья из сланца из ашлара',
      'uk': 'Прикрашена лавка з сланцевого дерева',
      'ko': '장식된 Ashlar 셰일 벤치',
      'zh': '装饰的 Ashlar 页岩板凳',
      'ja': '装飾された切石頁岩ベンチ'
    }, {
      'id': 'AdornedAshlarShaleChairItem',
      'en': 'Adorned Ashlar Shale Chair',
      'fr': 'Chaise en schiste de pierre de taille ornée',
      'es': 'Silla de esquisto de sillería adornada',
      'de': 'Geschmückter Ashlar Shale Chair',
      'pl': 'Zdobione krzesło z łupków Ashlar',
      'ru': 'Украшенное сланцевое кресло из ашлара',
      'uk': 'Прикрашений крісло Ashlar Shale',
      'ko': '장식된 Ashlar 혈암 의자',
      'zh': '装饰的 Ashlar 页岩椅',
      'ja': '装飾された切石頁岩の椅子'
    }, {
      'id': 'AdornedAshlarShaleTableItem',
      'en': 'Adorned Ashlar Shale Table',
      'fr': 'Table de schiste taillée ornée',
      'es': 'Mesa de esquisto sillería adornada',
      'de': 'Geschmückter Ashlar Shale Table',
      'pl': 'Zdobiony stół łupkowy z Ashlar',
      'ru': 'Украшенный сланцевый стол из ашлара',
      'uk': 'Прикрашений сланцевий стіл',
      'ko': '장식된 Ashlar 혈암 테이블',
      'zh': '装饰的 Ashlar 页岩桌',
      'ja': '装飾された切石頁岩テーブル'
    }, {
      'id': 'AdornedAshlarStoneBenchItem',
      'en': 'Adorned Ashlar Stone Bench',
      'fr': 'Banc en pierre de taille ornée',
      'es': 'Banco de sillería adornada',
      'de': 'Geschmückte Quadersteinbank',
      'pl': 'Zdobiona kamienna ławka Ashlar',
      'ru': 'Украшенная скамья из тесаного камня',
      'uk': 'Прикрашена кам’яна лавка з тесену',
      'ko': '장식된 Ashlar 돌 벤치',
      'zh': '装饰的 Ashlar 石凳',
      'ja': '飾られた切石の石のベンチ'
    }, {
      'id': 'AdornedAshlarStoneChairItem',
      'en': 'Adorned Ashlar Stone Chair',
      'fr': 'Chaise en pierre de taille ornée',
      'es': 'Silla de sillería adornada',
      'de': 'Geschmückter Quaderstein-Stuhl',
      'pl': 'Zdobione kamienne krzesło Ashlar',
      'ru': 'Украшенное каменное кресло из ашлара',
      'uk': 'Прикрашене кам\u0027яне крісло',
      'ko': '장식된 Ashlar 돌 의자',
      'zh': '装饰阿什拉石椅',
      'ja': '飾られた切石石の椅子'
    }, {
      'id': 'AdornedAshlarStoneTableItem',
      'en': 'Adorned Ashlar Stone Table',
      'fr': 'Table en pierre de taille ornée',
      'es': 'Mesa de sillería adornada',
      'de': 'Geschmückter Quadersteintisch',
      'pl': 'Zdobiony kamienny stół z Ashlar',
      'ru': 'Украшенный стол из тесаного камня',
      'uk': 'Прикрашений кам’яний стіл з тесену',
      'ko': '장식된 Ashlar 돌 테이블',
      'zh': '装饰的方石桌',
      'ja': '飾られた切石石のテーブル'
    }, {
      'id': 'AdvancedBakingUpgradeItem',
      'en': 'Advanced Baking Upgrade',
      'fr': 'Mise à niveau de cuisson avancée',
      'es': 'Actualización avanzada de horneado',
      'de': 'Fortgeschrittenes Back-Upgrade',
      'pl': 'Zaawansowana aktualizacja pieczenia',
      'ru': 'Расширенное обновление выпечки',
      'uk': 'Розширене оновлення випічки',
      'ko': '고급 베이킹 업그레이드',
      'zh': '高级烘焙升级',
      'ja': '高度なベーキングアップグレード'
    }, {
      'id': 'AdvancedCarpentryTableItem',
      'en': 'Advanced Carpentry Table',
      'fr': 'Table de menuiserie avancée',
      'es': 'Mesa de Carpintería Avanzada',
      'de': 'Tischlertisch für Fortgeschrittene',
      'pl': 'Zaawansowany stół stolarski',
      'ru': 'Усовершенствованный столярный стол',
      'uk': 'Розширений столярний стол',
      'ko': '고급 목공 테이블',
      'zh': '高级木工桌',
      'ja': '高度な木工テーブル'
    }, {
      'id': 'AdvancedCircuitItem',
      'en': 'Advanced Circuit',
      'fr': 'Circuit avancé',
      'es': 'Circuito Avanzado',
      'de': 'Erweiterte Schaltung',
      'pl': 'Zaawansowany obwód',
      'ru': 'Расширенная схема',
      'uk': 'Розширена схема',
      'ko': '고급 회로',
      'zh': '高级电路',
      'ja': '高度な回路'
    }, {
      'id': 'AdvancedCombustionEngineItem',
      'en': 'Advanced Combustion Engine',
      'fr': 'Moteur à combustion avancé',
      'es': 'Motor de combustión avanzado',
      'de': 'Fortschrittlicher Verbrennungsmotor',
      'pl': 'Zaawansowany silnik spalinowy',
      'ru': 'Усовершенствованный двигатель внутреннего сгорания',
      'uk': 'Розширений двигун внутрішнього згоряння',
      'ko': '고급 연소 엔진',
      'zh': '先进的内燃机',
      'ja': '高度な燃焼エンジン'
    }, {
      'id': 'AdvancedCookingUpgradeItem',
      'en': 'Advanced Cooking Upgrade',
      'fr': 'Amélioration de la cuisine avancée',
      'es': 'Actualización de cocina avanzada',
      'de': 'Fortgeschrittenes Koch-Upgrade',
      'pl': 'Zaawansowana aktualizacja gotowania',
      'ru': 'Расширенное кулинарное обновление',
      'uk': 'Розширене оновлення приготування їжі',
      'ko': '고급 요리 업그레이드',
      'zh': '高级烹饪升级',
      'ja': '高度な料理のアップグレード'
    }, {
      'id': 'AdvancedMasonryTableItem',
      'en': 'Advanced Masonry Table',
      'fr': 'Table de maçonnerie avancée',
      'es': 'Mesa de albañilería avanzada',
      'de': 'Fortgeschrittener Mauerwerkstisch',
      'pl': 'Zaawansowany stół murarski',
      'ru': 'Усовершенствованная таблица каменной кладки',
      'uk': 'Розширений стіл для кладки',
      'ko': '고급 벽돌 테이블',
      'zh': '高级砌体表',
      'ja': '高度な組積造テーブル'
    }, {
      'id': 'AdvancedMasonryUpgradeItem',
      'en': 'Advanced Masonry Upgrade',
      'fr': 'Mise à niveau avancée de la maçonnerie',
      'es': 'Actualización avanzada de mampostería',
      'de': 'Fortgeschrittenes Mauerwerk-Upgrade',
      'pl': 'Zaawansowana modernizacja murów',
      'ru': 'Продвинутое обновление каменной кладки',
      'uk': 'Розширене оновлення кладки',
      'ko': '고급 벽돌 업그레이드',
      'zh': '高级砌体升级',
      'ja': '高度な組積造のアップグレード'
    }, {
      'id': 'Advanced Research',
      'en': 'Advanced Research',
      'fr': 'Recherche avancée',
      'es': 'Investigación avanzada',
      'de': 'Fortgeschrittene Forschung',
      'pl': 'Zaawansowane badania',
      'ru': 'Расширенные исследования',
      'uk': 'Передові дослідження',
      'ko': '고급 연구',
      'zh': '高级研究',
      'ja': '先端研究'
    }, {
      'id': 'AdvancedSmeltingUpgradeItem',
      'en': 'Advanced Smelting Upgrade',
      'fr': 'Mise à niveau avancée de la fusion',
      'es': 'Actualización de fundición avanzada',
      'de': 'Fortgeschrittenes Schmelz-Upgrade',
      'pl': 'Zaawansowane Ulepszenie Wytapiania',
      'ru': 'Усовершенствованная плавка',
      'uk': 'Розширене оновлення плавлення',
      'ko': '고급 제련 업그레이드',
      'zh': '高级冶炼升级',
      'ja': '高度な製錬のアップグレード'
    }, {
      'id': 'AdvancedTailoringTableItem',
      'en': 'Advanced Tailoring Table',
      'fr': 'Table de couture avancée',
      'es': 'Mesa de Sastrería Avanzada',
      'de': 'Tabelle für fortgeschrittene Schneiderei',
      'pl': 'Zaawansowana tabela krawiectwa',
      'ru': 'Усовершенствованная таблица пошива',
      'uk': 'Розширений стіл для пошиття',
      'ko': '고급 재봉 테이블',
      'zh': '高级裁缝表',
      'ja': '高度な仕立てテーブル'
    }, {
      'id': 'AdvancedUpgradeLvl1Item',
      'en': 'Advanced Upgrade 1',
      'fr': 'Mise à niveau avancée 1',
      'es': 'Actualización avanzada 1',
      'de': 'Erweitertes Upgrade 1',
      'pl': 'Zaawansowana aktualizacja 1',
      'ru': 'Расширенное обновление 1',
      'uk': 'Розширене оновлення 1',
      'ko': '고급 업그레이드 1',
      'zh': '高级升级 1',
      'ja': '高度なアップグレード1'
    }, {
      'id': 'AdvancedUpgradeLvl2Item',
      'en': 'Advanced Upgrade 2',
      'fr': 'Mise à niveau avancée 2',
      'es': 'Actualización avanzada 2',
      'de': 'Erweitertes Upgrade 2',
      'pl': 'Zaawansowana aktualizacja 2',
      'ru': 'Расширенное обновление 2',
      'uk': 'Розширене оновлення 2',
      'ko': '고급 업그레이드 2',
      'zh': '高级升级 2',
      'ja': '高度なアップグレード2'
    }, {
      'id': 'AdvancedUpgradeLvl3Item',
      'en': 'Advanced Upgrade 3',
      'fr': 'Mise à niveau avancée 3',
      'es': 'Actualización avanzada 3',
      'de': 'Erweitertes Upgrade 3',
      'pl': 'Zaawansowana aktualizacja 3',
      'ru': 'Расширенное обновление 3',
      'uk': 'Розширене оновлення 3',
      'ko': '고급 업그레이드 3',
      'zh': '进阶升级 3',
      'ja': '高度なアップグレード3'
    }, {
      'id': 'AdvancedUpgradeLvl4Item',
      'en': 'Advanced Upgrade 4',
      'fr': 'Mise à niveau avancée 4',
      'es': 'Actualización avanzada 4',
      'de': 'Erweitertes Upgrade 4',
      'pl': 'Zaawansowana aktualizacja 4',
      'ru': 'Расширенное обновление 4',
      'uk': 'Розширене оновлення 4',
      'ko': '고급 업그레이드 4',
      'zh': '高级升级 4',
      'ja': '高度なアップグレード4'
    }, {
      'id': 'AgaveLeavesItem',
      'en': 'Agave Leaves',
      'fr': 'Feuilles d\u0027agaves',
      'es': 'hojas de agave',
      'de': 'Agavenblätter',
      'pl': 'Liście agawy',
      'ru': 'Листья агавы',
      'uk': 'Листя агави',
      'ko': '용설란 잎',
      'zh': '龙舌兰叶',
      'ja': 'リュウゼツランの葉'
    }, {
      'id': 'AgaveSeedItem',
      'en': 'Agave Seed',
      'fr': 'Graine d\u0027agave',
      'es': 'Semilla de agave',
      'de': 'Agavensamen',
      'pl': 'Nasiona agawy',
      'ru': 'Семена агавы',
      'uk': 'Насіння агави',
      'ko': '용설란 씨앗',
      'zh': '龙舌兰种子',
      'ja': 'リュウゼツランの種'
    }, {
      'id': 'AgoutiCarcassItem',
      'en': 'Agouti Carcass',
      'fr': 'Carcasse agouti',
      'es': 'canal agutí',
      'de': 'Agouti-Kadaver',
      'pl': 'Tusza Aguti',
      'ru': 'Туша агути',
      'uk': 'Туша агуті',
      'ko': '아구티 시체',
      'zh': '刺鼠尸体',
      'ja': 'アグーチの死骸'
    }, {
      'id': 'AgoutiEnchiladasItem',
      'en': 'Agouti Enchiladas',
      'fr': 'Enchiladas agouti',
      'es': 'Enchiladas Agutí',
      'de': 'Agouti-Enchiladas',
      'pl': 'Aguti Enchiladas',
      'ru': 'Агути Энчиладас',
      'uk': 'Агуті Енчіладас',
      'ko': '아구티 엔칠라다스',
      'zh': '刺鼠辣酱',
      'ja': 'アグーチエンチラーダ'
    }, {
      'id': 'AgricultureResearchPaperAdvancedItem',
      'en': 'Agriculture Research Paper Advanced',
      'fr': 'Document de recherche agricole avancé',
      'es': 'Trabajo de investigación agrícola avanzado',
      'de': 'Landwirtschaftliches Forschungspapier für Fortgeschrittene',
      'pl': 'Zaawansowany dokument z badań rolnictwa',
      'ru': 'Сельскохозяйственная исследовательская работа Advanced',
      'uk': 'Дослідження сільського господарства Advanced',
      'ko': '농업 연구 논문 고급',
      'zh': '农业研究论文高级',
      'ja': '農業研究論文アドバンスト'
    }, {
      'id': 'AgricultureResearchPaperModernItem',
      'en': 'Agriculture Research Paper Modern',
      'fr': 'Document de recherche agricole moderne',
      'es': 'Papel de investigación agrícola moderno',
      'de': 'Agrarwissenschaftliches Papier Modern',
      'pl': 'Nowoczesna praca naukowa w dziedzinie rolnictwa',
      'ru': 'Современная сельскохозяйственная исследовательская работа',
      'uk': 'Дослідження сільського господарства Сучасні',
      'ko': '농업 연구 논문 현대',
      'zh': '现代农业研究论文',
      'ja': '現代農業研究論文'
    }, {
      'id': 'AlligatorCarcassItem',
      'en': 'Alligator Carcass',
      'fr': 'Carcasse d\u0027alligator',
      'es': 'Cadáver de cocodrilo',
      'de': 'Alligator-Kadaver',
      'pl': 'Tusza aligatora',
      'ru': 'Туша аллигатора',
      'uk': 'Тушка алігатора',
      'ko': '악어 시체',
      'zh': '鳄鱼尸体',
      'ja': 'ワニの死骸'
    }, {
      'id': 'AmanitaMushroomSporesItem',
      'en': 'Amanita Mushroom Spores',
      'fr': 'Spores de champignons amanites',
      'es': 'Esporas de Hongo Amanita',
      'de': 'Amanita-Pilzsporen',
      'pl': 'Zarodniki grzybów Amanita',
      'ru': 'Споры мухомора',
      'uk': 'Спори грибів мухомору',
      'ko': '아마니타 버섯 포자',
      'zh': '鹅膏菌孢子',
      'ja': 'ベニテングタケの胞子'
    }, {
      'id': 'AmanitaMushroomsItem',
      'en': 'Amanita Mushrooms',
      'fr': 'Champignons Amanite',
      'es': 'Hongos Amanita',
      'de': 'Amanita-Pilze',
      'pl': 'Amanita Grzyby',
      'ru': 'Мухомор грибы',
      'uk': 'Мухомор',
      'ko': '아마니타 버섯',
      'zh': '鹅膏菌',
      'ja': 'ベニテングタケ'
    }, {
      'id': 'AmendmentsItem',
      'en': 'Amendments',
      'fr': 'Modifications',
      'es': 'Enmiendas',
      'de': 'Änderungen',
      'pl': 'Poprawki',
      'ru': 'Поправки',
      'uk': 'Поправки',
      'ko': '수정안',
      'zh': '修正',
      'ja': '修正'
    }, {
      'id': 'Animal',
      'en': 'Animal',
      'fr': 'Animal',
      'es': 'Animal',
      'de': 'Tier',
      'pl': 'Zwierzę',
      'ru': 'Животное',
      'uk': 'Тварина',
      'ko': '동물',
      'zh': '动物',
      'ja': '動物'
    }, {
      'id': 'AnvilItem',
      'en': 'Anvil',
      'fr': 'Enclume',
      'es': 'Yunque',
      'de': 'Amboss',
      'pl': 'Kowadło',
      'ru': 'Наковальня',
      'uk': 'Наковадло',
      'ko': '모루',
      'zh': '砧',
      'ja': 'アンビル'
    }, {
      'id': 'ArcticWillowSeedItem',
      'en': 'Arctic Willow Seed',
      'fr': 'Graine de saule arctique',
      'es': 'Semilla de sauce ártico',
      'de': 'Arktischer Weidensamen',
      'pl': 'Nasiona wierzby arktycznej',
      'ru': 'Семя арктической ивы',
      'uk': 'Насіння арктичної верби',
      'ko': '북극 버드나무 씨앗',
      'zh': '北极柳种子',
      'ja': '北極のヤナギの種'
    }, {
      'id': 'ArrastraItem',
      'en': 'Arrastra',
      'fr': 'Arrastra',
      'es': 'arrastra',
      'de': 'Arrastra',
      'pl': 'Arrastra',
      'ru': 'Аррастра',
      'uk': 'Аррастра',
      'ko': '아라스트라',
      'zh': '阿拉斯特拉',
      'ja': 'アラストラ'
    }, {
      'id': 'ArrowItem',
      'en': 'Arrow',
      'fr': 'Flèche',
      'es': 'Flecha',
      'de': 'Pfeil',
      'pl': 'Strzałka',
      'ru': 'Стрелка',
      'uk': 'Стрілка',
      'ko': '화살',
      'zh': '箭',
      'ja': '矢印'
    }, {
      'id': 'AshlarBasaltItem',
      'en': 'Ashlar Basalt',
      'fr': 'Basalte de pierre de taille',
      'es': 'Basalto de sillería',
      'de': 'Basaltquader',
      'pl': 'Aszlar bazalt',
      'ru': 'Ашлар Базальт',
      'uk': 'Ашларовий базальт',
      'ko': 'Ashlar 현무암',
      'zh': '方石玄武岩',
      'ja': '切石玄武岩'
    }, {
      'id': 'AshlarBasaltBenchItem',
      'en': 'Ashlar Basalt Bench',
      'fr': 'Banc de basalte en pierre de taille',
      'es': 'Banco de sillería de basalto',
      'de': 'Ashlar Basaltbank',
      'pl': 'Ławka bazaltowa Ashlar',
      'ru': 'Ашлар Базальтовая скамья',
      'uk': 'Базальтова лавка',
      'ko': 'Ashlar 현무암 벤치',
      'zh': '方石玄武岩台',
      'ja': '切石玄武岩ベンチ'
    }, {
      'id': 'AshlarBasaltChairItem',
      'en': 'Ashlar Basalt Chair',
      'fr': 'Chaise en basalte en pierre de taille',
      'es': 'Silla de sillería de basalto',
      'de': 'Ashlar-Basalt-Stuhl',
      'pl': 'Krzesło bazaltowe Ashlar',
      'ru': 'Ашлар Базальт Стул',
      'uk': 'Ашлар базальтовий стілець',
      'ko': 'Ashlar 현무암 의자',
      'zh': '方石玄武岩椅',
      'ja': '切石玄武岩チェア'
    }, {
      'id': 'AshlarBasaltDoorItem',
      'en': 'Ashlar Basalt Door',
      'fr': 'Porte en basalte en pierre de taille',
      'es': 'Puerta de sillería de basalto',
      'de': 'Ashlar Basalttür',
      'pl': 'Ashlar bazaltowe drzwi',
      'ru': 'Ашларская базальтовая дверь',
      'uk': 'Базальтові двері',
      'ko': 'Ashlar 현무암 문',
      'zh': '方石玄武岩门',
      'ja': '切石玄武岩ドア'
    }, {
      'id': 'AshlarBasaltFireplaceItem',
      'en': 'Ashlar Basalt Fireplace',
      'fr': 'Cheminée en basalte de pierre de taille',
      'es': 'Chimenea de sillería de basalto',
      'de': 'Ashlar Basaltkamin',
      'pl': 'Ashlar bazaltowy kominek',
      'ru': 'Ашлар Базальт Камин',
      'uk': 'Тесневий базальтовий камін',
      'ko': 'Ashlar 현무암 벽난로',
      'zh': 'Ashlar玄武岩壁炉',
      'ja': '切石玄武岩暖炉'
    }, {
      'id': 'AshlarBasaltTableItem',
      'en': 'Ashlar Basalt Table',
      'fr': 'Table en basalte en pierre de taille',
      'es': 'Mesa de sillería de basalto',
      'de': 'Ashlar Basalt Tisch',
      'pl': 'Stół bazaltowy Ashlar',
      'ru': 'Ашлар Базальтовый Стол',
      'uk': 'Таблиця з тесеневого базальту',
      'ko': 'Ashlar 현무암 테이블',
      'zh': '方石玄武岩台',
      'ja': '切石玄武岩テーブル'
    }, {
      'id': 'AshlarGneissItem',
      'en': 'Ashlar Gneiss',
      'fr': 'Gneiss de pierre de taille',
      'es': 'Gneis sillar',
      'de': 'Quader Gneis',
      'pl': 'Ashlar Gnejs',
      'ru': 'Ашлар Гнейс',
      'uk': 'Ашлар Гнейс',
      'ko': 'Ashlar 편마암',
      'zh': '方石片麻岩',
      'ja': '切石片麻岩'
    }, {
      'id': 'AshlarGneissBenchItem',
      'en': 'Ashlar Gneiss Bench',
      'fr': 'Banc en gneiss en pierre de taille',
      'es': 'Banco de sillar gneis',
      'de': 'Ashlar Gneis Bank',
      'pl': 'Ławka Ashlar Gnejs',
      'ru': 'Скамья Ашлар Гнейс',
      'uk': 'Лавка з ґнейсу',
      'ko': 'Ashlar 편마암 벤치',
      'zh': '方石片麻岩台',
      'ja': '切石片麻岩ベンチ'
    }, {
      'id': 'AshlarGneissChairItem',
      'en': 'Ashlar Gneiss Chair',
      'fr': 'Chaise en gneiss de pierre de taille',
      'es': 'Silla Ashlar Gneiss',
      'de': 'Ashlar Gneis-Stuhl',
      'pl': 'Krzesło Ashlar Gnejs',
      'ru': 'Ашлар Гнейс Стул',
      'uk': 'Крісло Ashlar Gneiss',
      'ko': 'Ashlar 편마암 의자',
      'zh': '阿什拉片麻岩椅子',
      'ja': '切石片麻岩チェア'
    }, {
      'id': 'AshlarGneissDoorItem',
      'en': 'Ashlar Gneiss Door',
      'fr': 'Porte en gneiss de pierre de taille',
      'es': 'Puerta de Sillería Gneis',
      'de': 'Quader-Gneis-Tür',
      'pl': 'Ashlar Gnejsowe drzwi',
      'ru': 'Ашлар Гнейс Дверь',
      'uk': 'Двері з ґнейсу',
      'ko': 'Ashlar 편마암 문',
      'zh': '方石片麻岩门',
      'ja': '切石片麻岩ドア'
    }, {
      'id': 'AshlarGneissFireplaceItem',
      'en': 'Ashlar Gneiss Fireplace',
      'fr': 'Cheminée en gneiss de pierre de taille',
      'es': 'Chimenea de sillar gneis',
      'de': 'Ashlar Gneis Kamin',
      'pl': 'Kominek Ashlar Gnejs',
      'ru': 'Ашлар Гнейс Камин',
      'uk': 'Камін з тепленого гнейсу',
      'ko': 'Ashlar 편마암 벽난로',
      'zh': 'Ashlar片麻岩壁炉',
      'ja': '切石片麻岩暖炉'
    }, {
      'id': 'AshlarGneissTableItem',
      'en': 'Ashlar Gneiss Table',
      'fr': 'Table de gneiss en pierre de taille',
      'es': 'Mesa Sillar Gneiss',
      'de': 'Ashlar Gneis-Tabelle',
      'pl': 'Ashlar Gnejs Stół',
      'ru': 'Стол Ашлар Гнейс',
      'uk': 'Гнейсовий стіл',
      'ko': 'Ashlar 편마암 테이블',
      'zh': '方石片麻岩台',
      'ja': '切石片麻岩テーブル'
    }, {
      'id': 'AshlarGraniteItem',
      'en': 'Ashlar Granite',
      'fr': 'Granit de pierre de taille',
      'es': 'Granito sillar',
      'de': 'Quader Granit',
      'pl': 'Granit Ashlar',
      'ru': 'Ашлар Гранит',
      'uk': 'Ашларовий граніт',
      'ko': 'Ashlar 화강암',
      'zh': '方石花岗岩',
      'ja': '切石花崗岩'
    }, {
      'id': 'AshlarGraniteBenchItem',
      'en': 'Ashlar Granite Bench',
      'fr': 'Banc en granit de pierre de taille',
      'es': 'Banco de granito sillar',
      'de': 'Ashlar-Granit-Bank',
      'pl': 'Ławka granitowa Ashlar',
      'ru': 'Ашлар Гранитная скамья',
      'uk': 'Гранітна лава з тесену',
      'ko': 'Ashlar 화강암 벤치',
      'zh': '方石花岗岩长凳',
      'ja': '切石花崗岩のベンチ'
    }, {
      'id': 'AshlarGraniteChairItem',
      'en': 'Ashlar Granite Chair',
      'fr': 'Chaise en granit de pierre de taille',
      'es': 'Silla Granito Sillar',
      'de': 'Ashlar-Granit-Stuhl',
      'pl': 'Krzesło granitowe Ashlar',
      'ru': 'Ашлар Гранит Стул',
      'uk': 'Гранітний стілець Ashlar',
      'ko': 'Ashlar 화강암 의자',
      'zh': '阿什拉花岗岩椅子',
      'ja': '切石花崗岩の椅子'
    }, {
      'id': 'AshlarGraniteDoorItem',
      'en': 'Ashlar Granite Door',
      'fr': 'Porte en granit de pierre de taille',
      'es': 'Puerta de Granito de Sillería',
      'de': 'Quader Granittür',
      'pl': 'Drzwi granitowe Ashlar',
      'ru': 'Ашлар Гранитная Дверь',
      'uk': 'Гранітні двері',
      'ko': 'Ashlar 화강암 문',
      'zh': '方石花岗岩门',
      'ja': '切石花崗岩のドア'
    }, {
      'id': 'AshlarGraniteFireplaceItem',
      'en': 'Ashlar Granite Fireplace',
      'fr': 'Cheminée en granit de pierre de taille',
      'es': 'Chimenea de sillería de granito',
      'de': 'Ashlar-Granit-Kamin',
      'pl': 'Ashlar granitowy kominek',
      'ru': 'Ашлар Гранитный Камин',
      'uk': 'Камін з граніту',
      'ko': 'Ashlar 화강암 벽난로',
      'zh': '方石花岗岩壁炉',
      'ja': '切石花崗岩の暖炉'
    }, {
      'id': 'AshlarGraniteTableItem',
      'en': 'Ashlar Granite Table',
      'fr': 'Table en granit de pierre de taille',
      'es': 'Mesa de granito sillar',
      'de': 'Ashlar Granittisch',
      'pl': 'Stół z granitu Ashlar',
      'ru': 'Ашлар Гранитный Стол',
      'uk': 'Стіл з граніту з тесену',
      'ko': 'Ashlar 화강암 테이블',
      'zh': '方石花岗岩台',
      'ja': '切石花崗岩テーブル'
    }, {
      'id': 'AshlarLargeBasaltFountainItem',
      'en': 'Ashlar Large Basalt Fountain',
      'fr': 'Grande fontaine en basalte en pierre de taille',
      'es': 'Fuente Grande de Basalto de Sillar',
      'de': 'Ashlar großer Basaltbrunnen',
      'pl': 'Ashlar Duża Bazaltowa Fontanna',
      'ru': 'Большой базальтовый фонтан Ашлар',
      'uk': 'Великий базальтовий фонтан Ashlar',
      'ko': 'Ashlar 대형 현무암 분수',
      'zh': '方石大型玄武岩喷泉',
      'ja': '切石の大きな玄武岩の噴水'
    }, {
      'id': 'AshlarLargeGneissFountainItem',
      'en': 'Ashlar Large Gneiss Fountain',
      'fr': 'Grande fontaine en gneiss en pierre de taille',
      'es': 'Fuente Grande de Gneis de Sillar',
      'de': 'Ashlar großer Gneisbrunnen',
      'pl': 'Ashlar Duża Gnejsowa Fontanna',
      'ru': 'Большой гнейсовый фонтан Ашлар',
      'uk': 'Великий гнейсовий фонтан',
      'ko': 'Ashlar 대형 편마암 분수',
      'zh': 'Ashlar 大型片麻岩喷泉',
      'ja': '切石片麻岩噴水'
    }, {
      'id': 'AshlarLargeGraniteFountainItem',
      'en': 'Ashlar Large Granite Fountain',
      'fr': 'Grande fontaine en granit Ashlar',
      'es': 'Fuente Grande de Granito de Sillar',
      'de': 'Ashlar großer Granitbrunnen',
      'pl': 'Duża granitowa fontanna Ashlar',
      'ru': 'Ашлар Большой Гранитный Фонтан',
      'uk': 'Великий гранітний фонтан Ashlar',
      'ko': 'Ashlar 대형 화강암 분수',
      'zh': '方石大型花岗岩喷泉',
      'ja': '切石大花崗岩の噴水'
    }, {
      'id': 'AshlarLargeLimestoneFountainItem',
      'en': 'Ashlar Large Limestone Fountain',
      'fr': 'Grande fontaine en pierre calcaire Ashlar',
      'es': 'Fuente Grande de Piedra Caliza de Sillar',
      'de': 'Ashlar großer Kalksteinbrunnen',
      'pl': 'Ashlar Duża wapienna fontanna',
      'ru': 'Большой известняковый фонтан Ашлар',
      'uk': 'Великий вапняковий фонтан Ashlar',
      'ko': 'Ashlar 대형 석회암 분수',
      'zh': 'Ashlar 大型石灰石喷泉',
      'ja': '切石の大きな石灰岩の噴水'
    }, {
      'id': 'AshlarLargeSandstoneFountainItem',
      'en': 'Ashlar Large Sandstone Fountain',
      'fr': 'Grande fontaine en grès Ashlar',
      'es': 'Fuente Grande de Arenisca de Sillar',
      'de': 'Ashlar großer Sandsteinbrunnen',
      'pl': 'Duża fontanna z piaskowca Ashlar',
      'ru': 'Большой фонтан из песчаника Ашлар',
      'uk': 'Великий фонтан з пісковика',
      'ko': 'Ashlar 대형 사암 분수',
      'zh': 'Ashlar 大型砂岩喷泉',
      'ja': '切石の大きな砂岩の噴水'
    }, {
      'id': 'AshlarLargeShaleFountainItem',
      'en': 'Ashlar Large Shale Fountain',
      'fr': 'Grande fontaine en schiste Ashlar',
      'es': 'Fuente Grande de Esquisto de Sillar',
      'de': 'Ashlar großer Schieferbrunnen',
      'pl': 'Duża fontanna łupkowa Ashlar',
      'ru': 'Большой сланцевый фонтан Ашлар',
      'uk': 'Великий сланцевий фонтан Ashlar',
      'ko': 'Ashlar 대형 셰일 분수',
      'zh': 'Ashlar大型页岩喷泉',
      'ja': '切石大型頁岩噴水'
    }, {
      'id': 'AshlarLargeStoneFountainItem',
      'en': 'Ashlar Large Stone Fountain',
      'fr': 'Grande fontaine en pierre de taille',
      'es': 'Fuente Grande de Piedra de Sillería',
      'de': 'Ashlar großer Steinbrunnen',
      'pl': 'Duża kamienna fontanna Ashlar',
      'ru': 'Большой каменный фонтан Ашлар',
      'uk': 'Великий кам\u0027яний фонтан',
      'ko': 'Ashlar 대형 돌 분수',
      'zh': '方石大石喷泉',
      'ja': '切石の大きな石の噴水'
    }, {
      'id': 'AshlarLimestoneItem',
      'en': 'Ashlar Limestone',
      'fr': 'Calcaire de pierre de taille',
      'es': 'Piedra caliza sillar',
      'de': 'Quader Kalkstein',
      'pl': 'Wapień Ashlar',
      'ru': 'Ашлар Известняк',
      'uk': 'Тесниний вапняк',
      'ko': 'Ashlar 석회암',
      'zh': '方石石灰石',
      'ja': '切石石灰岩'
    }, {
      'id': 'AshlarLimestoneBenchItem',
      'en': 'Ashlar Limestone Bench',
      'fr': 'Banc en pierre calcaire Ashlar',
      'es': 'Banco de sillería caliza',
      'de': 'Ashlar Kalksteinbank',
      'pl': 'Ławka wapienna Ashlar',
      'ru': 'Скамейка из ашларского известняка',
      'uk': 'Вапнякова лава з тесеня',
      'ko': 'Ashlar 석회암 벤치',
      'zh': 'Ashlar石灰石长凳',
      'ja': '切石石灰岩のベンチ'
    }, {
      'id': 'AshlarLimestoneChairItem',
      'en': 'Ashlar Limestone Chair',
      'fr': 'Chaise en pierre calcaire Ashlar',
      'es': 'Silla de sillería caliza',
      'de': 'Ashlar-Kalkstein-Stuhl',
      'pl': 'Krzesło z wapienia Ashlar',
      'ru': 'Стул Ашлар Известняк',
      'uk': 'Стілець з вапняку Ashlar',
      'ko': 'Ashlar 석회암 의자',
      'zh': 'Ashlar 石灰石椅子',
      'ja': '切石石灰岩の椅子'
    }, {
      'id': 'AshlarLimestoneDoorItem',
      'en': 'Ashlar Limestone Door',
      'fr': 'Porte en pierre calcaire Ashlar',
      'es': 'Puerta de sillería caliza',
      'de': 'Ashlar Kalksteintür',
      'pl': 'Drzwi z wapienia Ashlar',
      'ru': 'Ашлар Известняковая Дверь',
      'uk': 'Двері з вапняку',
      'ko': 'Ashlar 석회암 문',
      'zh': '方石石灰石门',
      'ja': '切石石灰岩のドア'
    }, {
      'id': 'AshlarLimestoneFireplaceItem',
      'en': 'Ashlar Limestone Fireplace',
      'fr': 'Cheminée en pierre calcaire de pierre de taille',
      'es': 'Chimenea de sillería caliza',
      'de': 'Ashlar Kalksteinkamin',
      'pl': 'Ashlar wapienny kominek',
      'ru': 'Камин из известняка Ашлар',
      'uk': 'Камін з вапняку',
      'ko': 'Ashlar 석회암 벽난로',
      'zh': 'Ashlar石灰石壁炉',
      'ja': '切石石灰岩の暖炉'
    }, {
      'id': 'AshlarLimestoneTableItem',
      'en': 'Ashlar Limestone Table',
      'fr': 'Table en pierre calcaire Ashlar',
      'es': 'Mesa de sillería caliza',
      'de': 'Ashlar Kalksteintisch',
      'pl': 'Stół z wapienia Ashlar',
      'ru': 'Стол из известняка Ашлар',
      'uk': 'Стіл з вапняку',
      'ko': 'Ashlar 석회암 테이블',
      'zh': '方石石灰石桌',
      'ja': '切石石灰岩テーブル'
    }, {
      'id': 'AshlarSandstoneItem',
      'en': 'Ashlar Sandstone',
      'fr': 'Grès de pierre de taille',
      'es': 'Arenisca sillar',
      'de': 'Quader Sandstein',
      'pl': 'Piaskowiec Ashlar',
      'ru': 'Ашлар Песчаник',
      'uk': 'Пісковик з каменю',
      'ko': 'Ashlar 사암',
      'zh': '方石砂岩',
      'ja': '切石砂岩'
    }, {
      'id': 'AshlarSandstoneBenchItem',
      'en': 'Ashlar Sandstone Bench',
      'fr': 'Banc en grès Ashlar',
      'es': 'Banco de sillería de arenisca',
      'de': 'Ashlar Sandsteinbank',
      'pl': 'Ławka z piaskowca Ashlar',
      'ru': 'Скамейка из песчаника Ашлар',
      'uk': 'Лавка з пісковика з ясеня',
      'ko': 'Ashlar 사암 벤치',
      'zh': 'Ashlar砂岩台',
      'ja': '切石砂岩ベンチ'
    }, {
      'id': 'AshlarSandstoneChairItem',
      'en': 'Ashlar Sandstone Chair',
      'fr': 'Chaise en grès de pierre de taille',
      'es': 'Silla de sillería de arenisca',
      'de': 'Ashlar Sandstein-Stuhl',
      'pl': 'Krzesło z piaskowca Ashlar',
      'ru': 'Стул Ашлар из песчаника',
      'uk': 'Крісло з пісковика Ashlar',
      'ko': 'Ashlar 사암 의자',
      'zh': 'Ashlar砂岩椅',
      'ja': '切石砂岩チェア'
    }, {
      'id': 'AshlarSandstoneDoorItem',
      'en': 'Ashlar Sandstone Door',
      'fr': 'Porte en grès de pierre de taille',
      'es': 'Puerta de sillería de arenisca',
      'de': 'Quader Sandsteintür',
      'pl': 'Drzwi z piaskowca Ashlar',
      'ru': 'Дверь из песчаника Ашлара',
      'uk': 'Двері з пісковика',
      'ko': 'Ashlar 사암 문',
      'zh': '方石砂岩门',
      'ja': '切石砂岩ドア'
    }, {
      'id': 'AshlarSandstoneFireplaceItem',
      'en': 'Ashlar Sandstone Fireplace',
      'fr': 'Cheminée en grès de pierre de taille',
      'es': 'Chimenea de sillería de arenisca',
      'de': 'Ashlar Sandsteinkamin',
      'pl': 'Kominek z piaskowca Ashlar',
      'ru': 'Камин из песчаника Ашлар',
      'uk': 'Камін з пісковика',
      'ko': 'Ashlar 사암 벽난로',
      'zh': 'Ashlar砂岩壁炉',
      'ja': '切石砂岩暖炉'
    }, {
      'id': 'AshlarSandstoneTableItem',
      'en': 'Ashlar Sandstone Table',
      'fr': 'Table en grès de pierre de taille',
      'es': 'Mesa de sillería de arenisca',
      'de': 'Ashlar Sandsteintisch',
      'pl': 'Stół z piaskowca Ashlar',
      'ru': 'Стол из песчаника Ашлар',
      'uk': 'Стіл з пісковика з тесеня',
      'ko': 'Ashlar 사암 테이블',
      'zh': '方石砂岩台',
      'ja': '切石砂岩テーブル'
    }, {
      'id': 'AshlarShaleItem',
      'en': 'Ashlar Shale',
      'fr': 'Schiste de pierre de taille',
      'es': 'Esquisto de sillería',
      'de': 'Ashlar-Schiefer',
      'pl': 'Ashlar Shale',
      'ru': 'Ашлар Шейл',
      'uk': 'Ашлар Сланець',
      'ko': '애슐라 셰일',
      'zh': '方石页岩',
      'ja': '切石頁岩'
    }, {
      'id': 'AshlarShaleBenchItem',
      'en': 'Ashlar Shale Bench',
      'fr': 'Banc de schiste de pierre de taille',
      'es': 'Banco de esquisto sillar',
      'de': 'Bank aus Ashlar-Schiefer',
      'pl': 'Ławka łupkowa Ashlar',
      'ru': 'Ашлар Сланцевая скамья',
      'uk': 'Ашлар сланцева лава',
      'ko': 'Ashlar 셰일 벤치',
      'zh': 'Ashlar页岩台',
      'ja': '切石頁岩ベンチ'
    }, {
      'id': 'AshlarShaleChairItem',
      'en': 'Ashlar Shale Chair',
      'fr': 'Chaise de schiste de pierre de taille',
      'es': 'Silla de esquisto de sillería',
      'de': 'Ashlar-Schiefer-Stuhl',
      'pl': 'Krzesło łupkowe Ashlar',
      'ru': 'Стул Ашлар Сланец',
      'uk': 'Крісло Ashlar Shale',
      'ko': 'Ashlar 혈암 의자',
      'zh': 'Ashlar 页岩椅',
      'ja': '切石頁岩チェア'
    }, {
      'id': 'AshlarShaleDoorItem',
      'en': 'Ashlar Shale Door',
      'fr': 'Porte de schiste de pierre de taille',
      'es': 'Puerta de pizarra de sillería',
      'de': 'Ashlar-Schiefer-Tür',
      'pl': 'Drzwi łupkowe Ashlar',
      'ru': 'Ашларская сланцевая дверь',
      'uk': 'Ashlar Shale Door',
      'ko': 'Ashlar 혈암 문',
      'zh': 'Ashlar页岩门',
      'ja': '切石頁岩ドア'
    }, {
      'id': 'AshlarShaleFireplaceItem',
      'en': 'Ashlar Shale Fireplace',
      'fr': 'Cheminée en schiste de pierre de taille',
      'es': 'Chimenea de pizarra de sillería',
      'de': 'Kamin aus Ashlar-Schiefer',
      'pl': 'Kominek łupkowy Ashlar',
      'ru': 'Ашларский сланцевый камин',
      'uk': 'Камін з сланцевого каміння',
      'ko': 'Ashlar 혈암 벽난로',
      'zh': 'Ashlar页岩壁炉',
      'ja': '切石頁岩暖炉'
    }, {
      'id': 'AshlarShaleTableItem',
      'en': 'Ashlar Shale Table',
      'fr': 'Table de schiste ashlar',
      'es': 'Mesa de esquisto sillar',
      'de': 'Ashlar Shale Tisch',
      'pl': 'Stół łupkowy Ashlar',
      'ru': 'Сланцевый стол Ашлар',
      'uk': 'Ашларовий сланцевий стіл',
      'ko': 'Ashlar 셰일 테이블',
      'zh': '方石页岩台',
      'ja': '切石頁岩テーブル'
    }, {
      'id': 'AshlarSmallBasaltFountainItem',
      'en': 'Ashlar Small Basalt Fountain',
      'fr': 'Petite fontaine en basalte en pierre de taille',
      'es': 'Fuente Pequeña de Basalto de Sillar',
      'de': 'Ashlar kleiner Basaltbrunnen',
      'pl': 'Ashlar Mała Bazaltowa Fontanna',
      'ru': 'Маленький базальтовый фонтан Ашлар',
      'uk': 'Малий базальтовий фонтан з тесену',
      'ko': 'Ashlar 작은 현무암 분수',
      'zh': 'Ashlar 小玄武岩喷泉',
      'ja': '切石玄武岩の噴水'
    }, {
      'id': 'AshlarSmallGneissFountainItem',
      'en': 'Ashlar Small Gneiss Fountain',
      'fr': 'Petite fontaine en gneiss en pierre de taille',
      'es': 'Fuente pequeña de sillar gneis',
      'de': 'Ashlar Kleiner Gneisbrunnen',
      'pl': 'Ashlar Mała Fontanna Gnejsowa',
      'ru': 'Маленький гнейсовый фонтан Ашлар',
      'uk': 'Малий гнейсовий фонтан',
      'ko': 'Ashlar 작은 편마암 분수',
      'zh': 'Ashlar 小型片麻岩喷泉',
      'ja': '切石片麻岩噴水'
    }, {
      'id': 'AshlarSmallGraniteFountainItem',
      'en': 'Ashlar Small Granite Fountain',
      'fr': 'Petite fontaine en granit Ashlar',
      'es': 'Fuente pequeña de granito de sillería',
      'de': 'Ashlar Kleiner Granitbrunnen',
      'pl': 'Mała granitowa fontanna Ashlar',
      'ru': 'Маленький гранитный фонтан Ашлар',
      'uk': 'Малий гранітний фонтан Ashlar',
      'ko': 'Ashlar 작은 화강암 분수',
      'zh': '方石小花岗岩喷泉',
      'ja': '切石小さな花崗岩の噴水'
    }, {
      'id': 'AshlarSmallLimestoneFountainItem',
      'en': 'Ashlar Small Limestone Fountain',
      'fr': 'Petite fontaine en pierre calcaire Ashlar',
      'es': 'Fuente Pequeña de Piedra Caliza de Sillar',
      'de': 'Ashlar Kleiner Kalksteinbrunnen',
      'pl': 'Ashlar Mała Fontanna Wapienna',
      'ru': 'Маленький известняковый фонтан Ашлар',
      'uk': 'Малий вапняковий фонтан Ashlar',
      'ko': 'Ashlar 작은 석회암 분수',
      'zh': 'Ashlar 小石灰石喷泉',
      'ja': '切石の小さな石灰岩の噴水'
    }, {
      'id': 'AshlarSmallSandstoneFountainItem',
      'en': 'Ashlar Small Sandstone Fountain',
      'fr': 'Petite fontaine en grès Ashlar',
      'es': 'Fuente Pequeña de Arenisca de Sillar',
      'de': 'Ashlar Kleiner Sandsteinbrunnen',
      'pl': 'Mała fontanna z piaskowca Ashlar',
      'ru': 'Маленький фонтан из песчаника Ашлар',
      'uk': 'Невеликий фонтан з пісковика',
      'ko': 'Ashlar 작은 사암 분수',
      'zh': 'Ashlar 小砂岩喷泉',
      'ja': '切石の小さな砂岩の噴水'
    }, {
      'id': 'AshlarSmallShaleFountainItem',
      'en': 'Ashlar Small Shale Fountain',
      'fr': 'Petite fontaine de schiste en pierre de taille',
      'es': 'Fuente pequeña de esquisto de sillería',
      'de': 'Ashlar kleiner Schieferbrunnen',
      'pl': 'Ashlar Mała Fontanna Łupkowa',
      'ru': 'Маленький сланцевый фонтан Ашлар',
      'uk': 'Малий сланцевий фонтан Ashlar',
      'ko': 'Ashlar 작은 혈암 분수',
      'zh': 'Ashlar 小型页岩喷泉',
      'ja': '切石頁岩噴水'
    }, {
      'id': 'AshlarSmallStoneFountainItem',
      'en': 'Ashlar Small Stone Fountain',
      'fr': 'Petite fontaine en pierre de taille',
      'es': 'Fuente Pequeña de Piedra de Sillería',
      'de': 'Ashlar kleiner Steinbrunnen',
      'pl': 'Mała kamienna fontanna Ashlar',
      'ru': 'Маленький каменный фонтан Ашлар',
      'uk': 'Невеликий кам\u0027яний фонтан з тесену',
      'ko': 'Ashlar 작은 돌 분수',
      'zh': '方石小石喷泉',
      'ja': '切石の小さな石の噴水'
    }, {
      'id': 'AshlarStone',
      'en': 'Ashlar Stone',
      'fr': 'Pierre de taille',
      'es': 'Piedra de sillería',
      'de': 'Quaderstein',
      'pl': 'Kamień Ashlara',
      'ru': 'Ашлар Стоун',
      'uk': 'Ашларовий камінь',
      'ko': 'Ashlar 돌',
      'zh': '方石',
      'ja': '切石'
    }, {
      'id': 'AshlarStoneBenchItem',
      'en': 'Ashlar Stone Bench',
      'fr': 'Banc en pierre de taille',
      'es': 'Banco de piedra de sillería',
      'de': 'Ashlar Steinbank',
      'pl': 'Kamienna ławka Ashlar',
      'ru': 'Каменная скамья Ашлара',
      'uk': 'Кам\u0027яна лавка з тесену',
      'ko': 'Ashlar 돌 벤치',
      'zh': '阿什拉石凳',
      'ja': '切石ベンチ'
    }, {
      'id': 'AshlarStoneChairItem',
      'en': 'Ashlar Stone Chair',
      'fr': 'Chaise en pierre de taille',
      'es': 'Silla de piedra sillar',
      'de': 'Ashlar Steinstuhl',
      'pl': 'Kamienne krzesło Ashlar',
      'ru': 'Каменный стул Ашлар',
      'uk': 'Кам\u0027яний стілець Ashlar',
      'ko': 'Ashlar 돌 의자',
      'zh': '方石椅',
      'ja': '切石の椅子'
    }, {
      'id': 'AshlarStoneDoorItem',
      'en': 'Ashlar Stone Door',
      'fr': 'Porte en pierre de taille',
      'es': 'Puerta de piedra de sillería',
      'de': 'Quadersteintür',
      'pl': 'Kamienne drzwi z Ashlar',
      'ru': 'Ашларская каменная дверь',
      'uk': 'Кам\u0027яні двері',
      'ko': 'Ashlar 돌 문',
      'zh': '方石门',
      'ja': '切石の石の扉'
    }, {
      'id': 'AshlarStoneFireplaceItem',
      'en': 'Ashlar Stone Fireplace',
      'fr': 'Cheminée en pierre de taille',
      'es': 'Chimenea de sillería',
      'de': 'Kamin aus Quaderstein',
      'pl': 'Kominek z kamienia Ashlar',
      'ru': 'Ашларский каменный камин',
      'uk': 'Камін з тесневого каменю',
      'ko': 'Ashlar 돌 벽난로',
      'zh': 'Ashlar石壁炉',
      'ja': '切石石暖炉'
    }, {
      'id': 'AshlarStoneTableItem',
      'en': 'Ashlar Stone Table',
      'fr': 'Table en pierre de taille',
      'es': 'Mesa de Piedra de Sillería',
      'de': 'Quadersteintisch',
      'pl': 'Kamienny stół z Ashlar',
      'ru': 'Каменный стол из ашлара',
      'uk': 'Кам\u0027яний стіл з тесену',
      'ko': 'Ashlar 돌 테이블',
      'zh': '方石桌',
      'ja': '切石テーブル'
    }, {
      'id': 'AsphaltConcreteItem',
      'en': 'Asphalt Concrete',
      'fr': 'Béton d\u0027asphalte',
      'es': 'Hormigón asfáltico',
      'de': 'Asphalt, Beton',
      'pl': 'Beton asfaltowy',
      'ru': 'Асфальт Бетон',
      'uk': 'Асфальтобетон',
      'ko': '아스팔트 콘크리트',
      'zh': '沥青混凝土',
      'ja': 'アスファルトコンクリート'
    }, {
      'id': 'AssemblyLineItem',
      'en': 'Assembly Line',
      'fr': 'Ligne d\u0027assemblage',
      'es': 'Linea de ensamblaje',
      'de': 'Fließband',
      'pl': 'Linia produkcyjna',
      'ru': 'Сборочная линия',
      'uk': 'Лінія збірки',
      'ko': '조립 라인',
      'zh': '流水线',
      'ja': '組み立てライン'
    }, {
      'id': 'AutomaticLoomItem',
      'en': 'Automatic Loom',
      'fr': 'Métier à tisser automatique',
      'es': 'Telar Automático',
      'de': 'Automatischer Webstuhl',
      'pl': 'Automatyczne krosno',
      'ru': 'Автоматический ткацкий станок',
      'uk': 'Автоматичний ткацький верстат',
      'ko': '자동 베틀',
      'zh': '自动织机',
      'ja': '自動織機'
    }, {
      'id': 'AutumnStewItem',
      'en': 'Autumn Stew',
      'fr': 'Ragoût d\u0027automne',
      'es': 'Estofado de Otoño',
      'de': 'Herbsteintopf',
      'pl': 'Jesienny Gulasz',
      'ru': 'Осеннее рагу',
      'uk': 'Осіннє рагу',
      'ko': '가을 스튜',
      'zh': '秋炖',
      'ja': '秋のシチュー'
    }, {
      'id': 'AxeItem',
      'en': 'Axe',
      'fr': 'Hache',
      'es': 'Hacha',
      'de': 'Axt',
      'pl': 'Topór',
      'ru': 'Топор',
      'uk': 'сокира',
      'ko': '도끼',
      'zh': '斧头',
      'ja': '斧'
    }, {
      'id': 'BakedAgaveItem',
      'en': 'Baked Agave',
      'fr': 'Agave au four',
      'es': 'Agave al horno',
      'de': 'Gebackene Agave',
      'pl': 'Pieczona Agawa',
      'ru': 'Запеченная агава',
      'uk': 'Запечена агава',
      'ko': '구운 용설란',
      'zh': '烤龙舌兰',
      'ja': '焼きリュウゼツラン'
    }, {
      'id': 'BakedBeetItem',
      'en': 'Baked Beet',
      'fr': 'Betterave au four',
      'es': 'Remolacha al horno',
      'de': 'Gebackene Rübe',
      'pl': 'Pieczony Burak',
      'ru': 'Запеченная свекла',
      'uk': 'Запечений буряк',
      'ko': '구운 비트',
      'zh': '烤甜菜',
      'ja': '焼きたてのビート'
    }, {
      'id': 'BakedCornItem',
      'en': 'Baked Corn',
      'fr': 'Maïs au four',
      'es': 'Maíz al horno',
      'de': 'Gebackener Mais',
      'pl': 'Pieczona Kukurydza',
      'ru': 'Запеченная кукуруза',
      'uk': 'Запечена кукурудза',
      'ko': '구운 옥수수',
      'zh': '烤玉米',
      'ja': '焼きとうもろこし'
    }, {
      'id': 'BakedHeartOfPalmItem',
      'en': 'Baked Heart Of Palm',
      'fr': 'Cœur de palmier au four',
      'es': 'Palmito al horno',
      'de': 'Gebackenes Palmenherz',
      'pl': 'Pieczone Serce Palmowe',
      'ru': 'Запеченное Сердце Пальмы',
      'uk': 'Запечене серце пальми',
      'ko': '구운된 야자수',
      'zh': '烤棕榈心',
      'ja': '焼きたてのハートオブパーム'
    }, {
      'id': 'BakedMeatItem',
      'en': 'Baked Meat',
      'fr': 'Viande au Four',
      'es': 'Carne al horno',
      'de': 'Gebackenes Fleisch',
      'pl': 'Pieczone Mięso',
      'ru': 'Запеченное мясо',
      'uk': 'Запечене м\u0027ясо',
      'ko': '구운 고기',
      'zh': '焗肉',
      'ja': '焼き肉'
    }, {
      'id': 'BakedRoastItem',
      'en': 'Baked Roast',
      'fr': 'Rôti au four',
      'es': 'Asado Al Horno',
      'de': 'Gebackener Braten',
      'pl': 'Pieczona Pieczeń',
      'ru': 'Запеченное жаркое',
      'uk': 'Запечена печеня',
      'ko': '구운 로스트',
      'zh': '焗烤',
      'ja': '焼きたての焙煎'
    }, {
      'id': 'BakedTaroItem',
      'en': 'Baked Taro',
      'fr': 'Taro au four',
      'es': 'Taro al horno',
      'de': 'Gebackener Taro',
      'pl': 'Pieczony Taro',
      'ru': 'Запеченное Таро',
      'uk': 'Запечене Таро',
      'ko': '구운 타로',
      'zh': '烤芋头',
      'ja': '焼き里芋'
    }, {
      'id': 'BakedTomatoItem',
      'en': 'Baked Tomato',
      'fr': 'Tomate au four',
      'es': 'tomate al horno',
      'de': 'Gebackene Tomate',
      'pl': 'Pieczony Pomidor',
      'ru': 'Запеченный помидор',
      'uk': 'Запечений помідор',
      'ko': '구운 토마토',
      'zh': '烤番茄',
      'ja': '焼きトマト'
    }, {
      'id': 'BakedVegetable',
      'en': 'Baked Vegetable',
      'fr': 'Légumes au four',
      'es': 'Verdura al horno',
      'de': 'Gebackenes Gemüse',
      'pl': 'Pieczone Warzywa',
      'ru': 'Запеченный овощ',
      'uk': 'Запечений овоч',
      'ko': '구운 야채',
      'zh': '烤蔬菜',
      'ja': '焼き野菜'
    }, {
      'id': 'BakeryOvenItem',
      'en': 'Bakery Oven',
      'fr': 'Four de boulangerie',
      'es': 'Horno de panadería',
      'de': 'Bäckerei Ofen',
      'pl': 'Piekarnik',
      'ru': 'Пекарня печь',
      'uk': 'Пекарня',
      'ko': '베이커리 오븐',
      'zh': '面包烤箱',
      'ja': 'ベーカリーオーブン'
    }, {
      'id': 'BakingUpgradeItem',
      'en': 'Baking Upgrade',
      'fr': 'Mise à niveau de cuisson',
      'es': 'Mejora para hornear',
      'de': 'Back-Upgrade',
      'pl': 'Ulepszenie pieczenia',
      'ru': 'Обновление выпечки',
      'uk': 'Оновлення випічки',
      'ko': '베이킹 업그레이드',
      'zh': '烘焙升级',
      'ja': 'ベーキングアップグレード'
    }, {
      'id': 'BallotBoxItem',
      'en': 'Ballot Box',
      'fr': 'Urne électorale',
      'es': 'Urna electoral',
      'de': 'Wahlurne',
      'pl': 'Urna wyborcza',
      'ru': 'Избирательная урна',
      'uk': 'Виборча урна',
      'ko': '투표함',
      'zh': '选票箱',
      'ja': '投票箱'
    }, {
      'id': 'BandanaItem',
      'en': 'Bandana',
      'fr': 'Bandana',
      'es': 'Pañuelo',
      'de': 'Bandana',
      'pl': 'Chustka',
      'ru': 'Бандана',
      'uk': 'Бандана',
      'ko': '두건',
      'zh': '头巾',
      'ja': 'バンダナ'
    }, {
      'id': 'BanhXeoItem',
      'en': 'Banh Xeo',
      'fr': 'Banh Xéo',
      'es': 'Banh Xeo',
      'de': 'Banh Xeo',
      'pl': 'Banh Xeo',
      'ru': 'Банх Ксео',
      'uk': 'Banh Xeo',
      'ko': '반쎄오',
      'zh': 'Banh Xeo',
      'ja': 'バインセオ'
    }, {
      'id': 'BankItem',
      'en': 'Bank',
      'fr': 'Banque',
      'es': 'Banco',
      'de': 'Bank',
      'pl': 'Bank',
      'ru': 'Банк',
      'uk': 'банк',
      'ko': '은행',
      'zh': '银行',
      'ja': '銀行'
    }, {
      'id': 'BannockItem',
      'en': 'Bannock',
      'fr': 'Bannock',
      'es': 'Bannock',
      'de': 'Bannock',
      'pl': 'Bannock',
      'ru': 'Баннок',
      'uk': 'Беннок',
      'ko': '배녹',
      'zh': '班诺克',
      'ja': 'バノック'
    }, {
      'id': 'BarrelItem',
      'en': 'Barrel',
      'fr': 'Baril',
      'es': 'Barril',
      'de': 'Fass',
      'pl': 'Beczka',
      'ru': 'Бочка',
      'uk': 'Бочка',
      'ko': '통',
      'zh': '桶',
      'ja': 'たる'
    }, {
      'id': 'BarrelCactusSeedItem',
      'en': 'Barrel Cactus Seed',
      'fr': 'Graine de cactus baril',
      'es': 'Semilla de cactus barril',
      'de': 'Fass-Kaktus-Samen',
      'pl': 'Nasiona kaktusa beczkowego',
      'ru': 'Семя бочонка кактуса',
      'uk': 'Насіння кактуса бочки',
      'ko': '배럴 선인장 씨앗',
      'zh': '桶装仙人掌种子',
      'ja': 'バレルサボテンシード'
    }, {
      'id': 'BasaltItem',
      'en': 'Basalt',
      'fr': 'Basalte',
      'es': 'Basalto',
      'de': 'Basalt',
      'pl': 'Bazalt',
      'ru': 'Базальт',
      'uk': 'базальтовий',
      'ko': '현무암',
      'zh': '玄武岩',
      'ja': '玄武岩'
    }, {
      'id': 'BasicBackpackItem',
      'en': 'Basic Backpack',
      'fr': 'Sac à dos de base',
      'es': 'Mochila Básica',
      'de': 'Einfacher Rucksack',
      'pl': 'Podstawowy plecak',
      'ru': 'Базовый рюкзак',
      'uk': 'Базовий рюкзак',
      'ko': '기본 백팩',
      'zh': '基本款背包',
      'ja': 'ベーシックバックパック'
    }, {
      'id': 'BasicCircuitItem',
      'en': 'Basic Circuit',
      'fr': 'Circuit de base',
      'es': 'Circuito básico',
      'de': 'Grundschaltung',
      'pl': 'Obwód podstawowy',
      'ru': 'Базовая схема',
      'uk': 'Базовий контур',
      'ko': '기본 회로',
      'zh': '基本电路',
      'ja': '基本回路'
    }, {
      'id': 'BasicEngineeringUpgradeItem',
      'en': 'Basic Engineering Upgrade',
      'fr': 'Mise à niveau d\u0027ingénierie de base',
      'es': 'Actualización de ingeniería básica',
      'de': 'Basic Engineering-Upgrade',
      'pl': 'Podstawowe ulepszenie inżynierii',
      'ru': 'Базовое техническое обновление',
      'uk': 'Базове інженерне оновлення',
      'ko': '기본 엔지니어링 업그레이드',
      'zh': '基础工程升级',
      'ja': '基本的なエンジニアリングのアップグレード'
    }, {
      'id': 'Basic Research',
      'en': 'Basic Research',
      'fr': 'Recherche basique',
      'es': 'Investigación básica',
      'de': 'Grundlagenforschung',
      'pl': 'Podstawowe badania',
      'ru': 'Фундаментальные исследования',
      'uk': 'Фундаментальні дослідження',
      'ko': '기본 연구',
      'zh': '基础研究',
      'ja': '基礎研究'
    }, {
      'id': 'BasicSaladItem',
      'en': 'Basic Salad',
      'fr': 'Salade de base',
      'es': 'Ensalada Básica',
      'de': 'Einfacher Salat',
      'pl': 'Sałatka podstawowa',
      'ru': 'Основной салат',
      'uk': 'Базовий салат',
      'ko': '기본 샐러드',
      'zh': '基本沙拉',
      'ja': 'ベーシックサラダ'
    }, {
      'id': 'BasicUpgradeLvl1Item',
      'en': 'Basic Upgrade 1',
      'fr': 'Mise à niveau de base 1',
      'es': 'Actualización básica 1',
      'de': 'Basis-Upgrade 1',
      'pl': 'Ulepszenie podstawowe 1',
      'ru': 'Базовое обновление 1',
      'uk': 'Базове оновлення 1',
      'ko': '기본 업그레이드 1',
      'zh': '基础升级1',
      'ja': '基本アップグレード1'
    }, {
      'id': 'BasicUpgradeLvl2Item',
      'en': 'Basic Upgrade 2',
      'fr': 'Mise à niveau de base 2',
      'es': 'Actualización básica 2',
      'de': 'Basis-Upgrade 2',
      'pl': 'Ulepszenie podstawowe 2',
      'ru': 'Базовое обновление 2',
      'uk': 'Базове оновлення 2',
      'ko': '기본 업그레이드 2',
      'zh': '基本升级 2',
      'ja': '基本アップグレード2'
    }, {
      'id': 'BasicUpgradeLvl3Item',
      'en': 'Basic Upgrade 3',
      'fr': 'Mise à niveau de base 3',
      'es': 'Actualización básica 3',
      'de': 'Basis-Upgrade 3',
      'pl': 'Ulepszenie podstawowe 3',
      'ru': 'Базовое обновление 3',
      'uk': 'Базове оновлення 3',
      'ko': '기본 업그레이드 3',
      'zh': '基本升级 3',
      'ja': '基本アップグレード3'
    }, {
      'id': 'BasicUpgradeLvl4Item',
      'en': 'Basic Upgrade 4',
      'fr': 'Mise à niveau de base 4',
      'es': 'Actualización básica 4',
      'de': 'Basis-Upgrade 4',
      'pl': 'Ulepszenie podstawowe 4',
      'ru': 'Базовое обновление 4',
      'uk': 'Базове оновлення 4',
      'ko': '기본 업그레이드 4',
      'zh': '基本升级 4',
      'ja': '基本アップグレード4'
    }, {
      'id': 'BassItem',
      'en': 'Bass',
      'fr': 'Basse',
      'es': 'Bajo',
      'de': 'Bass',
      'pl': 'Gitara basowa',
      'ru': 'Бас',
      'uk': 'Бас',
      'ko': '베이스',
      'zh': '低音',
      'ja': 'ベース'
    }, {
      'id': 'BathtubItem',
      'en': 'Bathtub',
      'fr': 'Baignoire',
      'es': 'Bañera',
      'de': 'Badewanne',
      'pl': 'Wanna',
      'ru': 'Ванна',
      'uk': 'Ванна',
      'ko': '목욕통',
      'zh': '浴缸',
      'ja': 'バスタブ'
    }, {
      'id': 'BeanPasteItem',
      'en': 'Bean Paste',
      'fr': 'Pâte de haricots',
      'es': 'Pasta de judías',
      'de': 'Bohnen Paste',
      'pl': 'Pasta z fasoli',
      'ru': 'Бобовая паста',
      'uk': 'Бобова паста',
      'ko': '된장',
      'zh': '豆沙',
      'ja': '味噌'
    }, {
      'id': 'BeanSproutItem',
      'en': 'Bean Sprout',
      'fr': 'germe de haricot',
      'es': 'Brotes de soja',
      'de': 'Bohnensprosse',
      'pl': 'kiełki fasoli',
      'ru': 'Бобовый росток',
      'uk': 'Квасоля паросток',
      'ko': '콩나물',
      'zh': '豆芽',
      'ja': 'もやし'
    }, {
      'id': 'BeansItem',
      'en': 'Beans',
      'fr': 'Des haricots',
      'es': 'Frijoles',
      'de': 'Bohnen',
      'pl': 'fasolki',
      'ru': 'Бобы',
      'uk': 'Квасоля',
      'ko': '콩',
      'zh': '豆子',
      'ja': '豆'
    }, {
      'id': 'BearSUPREMEItem',
      'en': 'Bear S U P R E M E',
      'fr': 'Ours S U P R E M E',
      'es': 'Oso SUPREMO',
      'de': 'Bär S U P R E M E',
      'pl': 'Niedźwiedź S U P R E M E',
      'ru': 'Медведь С У П Р Е М Е',
      'uk': 'Ведмідь С У П Р Е М Е',
      'ko': '베어 SU P R E M E',
      'zh': '熊 S U P R E M E',
      'ja': 'ベアSUP R E M E'
    }, {
      'id': 'BearclawItem',
      'en': 'Bearclaw',
      'fr': 'Griffe d\u0027ours',
      'es': 'Garra de oso',
      'de': 'Bärentatze',
      'pl': 'Niedźwiedzi pazur',
      'ru': 'Медвежий коготь',
      'uk': 'Ведмежий кіготь',
      'ko': '곰 발톱',
      'zh': '熊爪',
      'ja': 'ベアクロウ'
    }, {
      'id': 'BearpackItem',
      'en': 'Bearpack',
      'fr': 'meute d\u0027ours',
      'es': 'manada de osos',
      'de': 'Bärenpack',
      'pl': 'Bearpack',
      'ru': 'Медвежья стая',
      'uk': 'Ведмежий ранець',
      'ko': '베어팩',
      'zh': '熊包',
      'ja': 'ベアパック'
    }, {
      'id': 'BeetItem',
      'en': 'Beet',
      'fr': 'Betterave',
      'es': 'Remolacha',
      'de': 'Rübe',
      'pl': 'Buraczany',
      'ru': 'Свекла',
      'uk': 'буряк',
      'ko': '비트',
      'zh': '甜菜',
      'ja': 'ビート'
    }, {
      'id': 'BeetCampfireSaladItem',
      'en': 'Beet Campfire Salad',
      'fr': 'Salade de feu de camp de betteraves',
      'es': 'Ensalada De Fogata De Remolacha',
      'de': 'Rote-Bete-Lagerfeuersalat',
      'pl': 'Sałatka Ogniskowa z Buraków',
      'ru': 'Салат из свеклы у костра',
      'uk': 'Салат з буряка',
      'ko': '비트 캠프파이어 샐러드',
      'zh': '甜菜篝火沙拉',
      'ja': 'ビートキャンプファイヤーサラダ'
    }, {
      'id': 'BeetGreensItem',
      'en': 'Beet Greens',
      'fr': 'Feuilles de betterave',
      'es': 'Hojas de remolacha',
      'de': 'Rübengrün',
      'pl': 'Buraki',
      'ru': 'Зелень свеклы',
      'uk': 'Зелень буряка',
      'ko': '비트 그린',
      'zh': '甜菜叶',
      'ja': 'ビートグリーン'
    }, {
      'id': 'BeetSeedItem',
      'en': 'Beet Seed',
      'fr': 'Graine de betterave',
      'es': 'Semilla de remolacha',
      'de': 'Rübensamen',
      'pl': 'Nasiona buraka',
      'ru': 'Семена свеклы',
      'uk': 'Насіння буряка',
      'ko': '비트 씨',
      'zh': '甜菜种子',
      'ja': 'ビートシード'
    }, {
      'id': 'BerryExtractFertilizerItem',
      'en': 'Berry Extract Fertilizer',
      'fr': 'Engrais aux extraits de baies',
      'es': 'Fertilizante de extracto de bayas',
      'de': 'Dünger mit Beerenextrakt',
      'pl': 'Nawóz z ekstraktem z jagód',
      'ru': 'Удобрение из экстракта ягод',
      'uk': 'Добриво з екстрактом ягід',
      'ko': '베리 추출물 비료',
      'zh': '浆果提取物肥料',
      'ja': 'ベリーエキス肥料'
    }, {
      'id': 'BigBackpackItem',
      'en': 'Big Backpack',
      'fr': 'Grand sac à dos',
      'es': 'mochila grande',
      'de': 'Großer Rucksack',
      'pl': 'Duży plecak',
      'ru': 'Большой рюкзак',
      'uk': 'Великий рюкзак',
      'ko': '큰 배낭',
      'zh': '大背包',
      'ja': 'ビッグバックパック'
    }, {
      'id': 'BigBluestemSeedItem',
      'en': 'Big Bluestem Seed',
      'fr': 'Grande graine de barbon',
      'es': 'Gran semilla de tallo azul',
      'de': 'Großer Bluestem-Samen',
      'pl': 'Duże nasiona niebieskiej łodygi',
      'ru': 'Семя большого голубого стебля',
      'uk': 'Велике насіння блакитного стебла',
      'ko': '큰 블루스템 씨앗',
      'zh': '大蓝茎种子',
      'ja': 'ビッグブルーステムシード'
    }, {
      'id': 'BighornCarcassItem',
      'en': 'Bighorn Carcass',
      'fr': 'Carcasse de mouflon d\u0027Amérique',
      'es': 'Cadáver de Bighorn',
      'de': 'Bighorn-Kadaver',
      'pl': 'Tusza Bighorn',
      'ru': 'Туша снежного рога',
      'uk': 'Туша великого рога',
      'ko': '큰뿔사체',
      'zh': '大角牛尸体',
      'ja': 'ビッグホーンカーカス'
    }, {
      'id': 'BiodieselItem',
      'en': 'Biodiesel',
      'fr': 'Biodiesel',
      'es': 'biodiésel',
      'de': 'Biodiesel',
      'pl': 'Biodiesel',
      'ru': 'Биодизель',
      'uk': 'Біодизель',
      'ko': '바이오디젤',
      'zh': '生物柴油',
      'ja': 'バイオディーゼル'
    }, {
      'id': 'BirchLogItem',
      'en': 'Birch Log',
      'fr': 'Bûche de bouleau',
      'es': 'tronco de abedul',
      'de': 'Birkenstamm',
      'pl': 'Dziennik brzozowy',
      'ru': 'Березовый бревно',
      'uk': 'Березовий колод',
      'ko': '자작나무 통나무',
      'zh': '桦木原木',
      'ja': '白樺の丸太'
    }, {
      'id': 'BirchSeedItem',
      'en': 'Birch Seed',
      'fr': 'Graine de bouleau',
      'es': 'Semilla de abedul',
      'de': 'Birkensamen',
      'pl': 'Nasiona brzozy',
      'ru': 'Березовое семя',
      'uk': 'Березове насіння',
      'ko': '자작나무 씨앗',
      'zh': '桦木种子',
      'ja': '白樺の種'
    }, {
      'id': 'BisonCarcassItem',
      'en': 'Bison Carcass',
      'fr': 'Carcasse de bison',
      'es': 'cadáver de bisonte',
      'de': 'Bisonkadaver',
      'pl': 'Tusza żubra',
      'ru': 'Туша бизона',
      'uk': 'Тушка бізона',
      'ko': '들소 시체',
      'zh': '野牛尸体',
      'ja': 'バイソンの死骸'
    }, {
      'id': 'BisonChowFunItem',
      'en': 'Bison Chow Fun',
      'fr': 'Plaisir de manger du bison',
      'es': 'bisonte chow divertido',
      'de': 'Bison-Chow-Spaß',
      'pl': 'Żubr chow zabawa',
      'ru': 'Развлечение с бизонами',
      'uk': 'Бізон-чау Fun',
      'ko': '들소 차우 재미',
      'zh': '野牛周乐趣',
      'ja': 'バイソンチョウフン'
    }, {
      'id': 'BisonMountItem',
      'en': 'Bison Mount',
      'fr': 'Mont bison',
      'es': 'Monte bisonte',
      'de': 'Bison-Berg',
      'pl': 'Góra żubra',
      'ru': 'Бизон Маунт',
      'uk': 'Гора бізона',
      'ko': '들소 산',
      'zh': '野牛山',
      'ja': 'バイソンマウント'
    }, {
      'id': 'BlastFurnaceItem',
      'en': 'Blast Furnace',
      'fr': 'Haut fourneau',
      'es': 'Alto horno',
      'de': 'Hochofen',
      'pl': 'Wielki Piec',
      'ru': 'Доменная печь',
      'uk': 'Доменна піч',
      'ko': '고로',
      'zh': '高炉',
      'ja': '溶鉱炉'
    }, {
      'id': 'Block',
      'en': 'Block',
      'fr': 'Bloquer',
      'es': 'Bloquear',
      'de': 'Block',
      'pl': 'Blok',
      'ru': 'Блокировать',
      'uk': 'Блокувати',
      'ko': '차단하다',
      'zh': '堵塞',
      'ja': 'ブロック'
    }, {
      'id': 'BloodMealFertilizerItem',
      'en': 'Blood Meal Fertilizer',
      'fr': 'Engrais de farine de sang',
      'es': 'Fertilizante de harina de sangre',
      'de': 'Blutmehldünger',
      'pl': 'Nawóz do mączki krwi',
      'ru': 'Удобрение для кровяной муки',
      'uk': 'Добриво з кров\u0027яного борошна',
      'ko': '혈식비료',
      'zh': '血粉肥',
      'ja': '血粉肥料'
    }, {
      'id': 'BloomeryItem',
      'en': 'Bloomery',
      'fr': 'Floraison',
      'es': 'Floración',
      'de': 'Bloomery',
      'pl': 'Bloomery',
      'ru': 'Блумери',
      'uk': 'Блумері',
      'ko': '블루메리',
      'zh': '布卢梅里',
      'ja': '塊鉄炉'
    }, {
      'id': 'BlueSharkItem',
      'en': 'Blue Shark',
      'fr': 'Requin bleu',
      'es': 'Tiburón azul',
      'de': 'Blauer Hai',
      'pl': 'Żarłacz błękitny',
      'ru': 'Синяя акула',
      'uk': 'Блакитна акула',
      'ko': '푸른 상어',
      'zh': '蓝鲨',
      'ja': 'ヨシキリザメ'
    }, {
      'id': 'BoardItem',
      'en': 'Board',
      'fr': 'Planche',
      'es': 'Junta',
      'de': 'Tafel',
      'pl': 'Tablica',
      'ru': 'Доска',
      'uk': 'дошка',
      'ko': '판자',
      'zh': '木板',
      'ja': 'ボード'
    }, {
      'id': 'WoodBoard',
      'en': 'Board',
      'fr': 'Planche',
      'es': 'Junta',
      'de': 'Tafel',
      'pl': 'Tablica',
      'ru': 'Доска',
      'uk': 'дошка',
      'ko': '판자',
      'zh': '木板',
      'ja': 'ボード'
    }, {
      'id': 'BoardOfElectionsItem',
      'en': 'Board Of Elections',
      'fr': 'Conseil des élections',
      'es': 'Junta de Elecciones',
      'de': 'Wahlvorstand',
      'pl': 'Rada Wyborcza',
      'ru': 'Избирательная комиссия',
      'uk': 'Виборча рада',
      'ko': '선거관리위원회',
      'zh': '选举委员会',
      'ja': '選挙管理委員会'
    }, {
      'id': 'BoiledGrainsItem',
      'en': 'Boiled Grains',
      'fr': 'Céréales bouillies',
      'es': 'Granos hervidos',
      'de': 'Gekochte Körner',
      'pl': 'Gotowane Ziarna',
      'ru': 'Вареные зерна',
      'uk': 'Варені зерна',
      'ko': '삶은 곡물',
      'zh': '煮熟的谷物',
      'ja': 'ゆでた穀物'
    }, {
      'id': 'BoiledRiceItem',
      'en': 'Boiled Rice',
      'fr': 'Riz bouilli',
      'es': 'Arroz hervido',
      'de': 'Gekochter Reis',
      'pl': 'Ugotowany ryż',
      'ru': 'Отварной рис',
      'uk': 'Варений рис',
      'ko': '삶은 쌀',
      'zh': '煮好的饭',
      'ja': 'ご飯'
    }, {
      'id': 'BoiledSausageItem',
      'en': 'Boiled Sausage',
      'fr': 'Saucisse bouillie',
      'es': 'Salchicha Cocida',
      'de': 'Brühwurst',
      'pl': 'Kiełbasa Gotowana',
      'ru': 'Вареная колбаса',
      'uk': 'Варена ковбаса',
      'ko': '삶은 소시지',
      'zh': '煮香肠',
      'ja': 'ゆでソーセージ'
    }, {
      'id': 'BoilerItem',
      'en': 'Boiler',
      'fr': 'Chaudière',
      'es': 'Caldera',
      'de': 'Kessel',
      'pl': 'Bojler',
      'ru': 'Паровой котел',
      'uk': 'Котел',
      'ko': '보일러',
      'zh': '锅炉',
      'ja': 'ボイラー'
    }, {
      'id': 'BoleteMushroomSporesItem',
      'en': 'Bolete Mushroom Spores',
      'fr': 'Spores de champignons bolets',
      'es': 'Esporas de hongos bolete',
      'de': 'Bolete-Pilz-Sporen',
      'pl': 'Zarodniki grzybów borowików',
      'ru': 'Споры грибов подберезовика',
      'uk': 'Спори грибів підберезників',
      'ko': '볼레트 버섯 포자',
      'zh': '牛肝菌蘑菇孢子',
      'ja': 'ヤマドリタケの胞子'
    }, {
      'id': 'BoleteMushroomsItem',
      'en': 'Bolete Mushrooms',
      'fr': 'Bolets',
      'es': 'Hongos Boletes',
      'de': 'Steinpilze',
      'pl': 'Podgrzybki',
      'ru': 'Подберезовики',
      'uk': 'Гриби підосичники',
      'ko': '볼레트 버섯',
      'zh': '牛肝菌蘑菇',
      'ja': 'ヤマドリタケ'
    }, {
      'id': 'BookshelfItem',
      'en': 'Bookshelf',
      'fr': 'Étagère à livres',
      'es': 'Estante para libros',
      'de': 'Bücherregal',
      'pl': 'Półka na książki',
      'ru': 'Книжная полка',
      'uk': 'Книжкова полиця',
      'ko': '책장',
      'zh': '书架',
      'ja': '本棚'
    }, {
      'id': 'BowItem',
      'en': 'Bow',
      'fr': 'Arc',
      'es': 'Arco',
      'de': 'Verneigung',
      'pl': 'Kokarda',
      'ru': 'Лук',
      'uk': 'Лук',
      'ko': '절하다',
      'zh': '弓',
      'ja': '弓'
    }, {
      'id': 'BrazierItem',
      'en': 'Brazier',
      'fr': 'Brasero',
      'es': 'Brasero',
      'de': 'Kohlebecken',
      'pl': 'Kotlarz',
      'ru': 'Мангал',
      'uk': 'Мангал',
      'ko': '화로',
      'zh': '火盆',
      'ja': '火鉢'
    }, {
      'id': 'BreadItem',
      'en': 'Bread',
      'fr': 'Pain',
      'es': 'Pan de molde',
      'de': 'Brot',
      'pl': 'Chleb',
      'ru': 'Хлеб',
      'uk': 'Хліб',
      'ko': '빵',
      'zh': '面包',
      'ja': 'パン'
    }, {
      'id': 'Bread',
      'en': 'Bread',
      'fr': 'Pain',
      'es': 'Pan de molde',
      'de': 'Brot',
      'pl': 'Chleb',
      'ru': 'Хлеб',
      'uk': 'Хліб',
      'ko': '빵',
      'zh': '面包',
      'ja': 'パン'
    }, {
      'id': 'BrickItem',
      'en': 'Brick',
      'fr': 'Brique',
      'es': 'Ladrillo',
      'de': 'Backstein',
      'pl': 'Cegła',
      'ru': 'Кирпич',
      'uk': 'Цегла',
      'ko': '벽돌',
      'zh': '砖',
      'ja': 'レンガ'
    }, {
      'id': 'BrickFireplaceItem',
      'en': 'Brick Fireplace',
      'fr': 'Cheminée en brique',
      'es': 'Chimenea de ladrillo',
      'de': 'Gemauerter Kamin',
      'pl': 'Kominek ceglany',
      'ru': 'Кирпичный камин',
      'uk': 'Цегляний камін',
      'ko': '벽돌 벽난로',
      'zh': '砖壁炉',
      'ja': 'レンガ造りの暖炉'
    }, {
      'id': 'BuilderBootsItem',
      'en': 'Builder Boots',
      'fr': 'Bottes de constructeur',
      'es': 'Botas de constructor',
      'de': 'Builder-Stiefel',
      'pl': 'Buty budowniczego',
      'ru': 'Сапоги строителя',
      'uk': 'Будівельні чоботи',
      'ko': '빌더 부츠',
      'zh': '建设者靴子',
      'ja': 'ビルダーブーツ'
    }, {
      'id': 'BuilderGlovesItem',
      'en': 'Builder Gloves',
      'fr': 'Gants de constructeur',
      'es': 'Guantes de constructor',
      'de': 'Baumeister-Handschuhe',
      'pl': 'Rękawice Budownicze',
      'ru': 'Строительные перчатки',
      'uk': 'Рукавички будівельники',
      'ko': '빌더 장갑',
      'zh': '生成器手套',
      'ja': 'ビルダーグローブ'
    }, {
      'id': 'BuilderHelmetItem',
      'en': 'Builder Helmet',
      'fr': 'Casque de constructeur',
      'es': 'Casco de constructor',
      'de': 'Baumeister-Helm',
      'pl': 'Hełm budowniczego',
      'ru': 'Строительный шлем',
      'uk': 'Шолом будівельника',
      'ko': '빌더 헬멧',
      'zh': '生成器头盔',
      'ja': 'ビルダーヘルメット'
    }, {
      'id': 'BuilderOverallsItem',
      'en': 'Builder Overalls',
      'fr': 'Salopette de constructeur',
      'es': 'Overoles de constructor',
      'de': 'Builder-Overalls',
      'pl': 'Kombinezon budowniczego',
      'ru': 'Спецодежда строителя',
      'uk': 'Комбінезон будівельника',
      'ko': '빌더 작업복',
      'zh': '建设者工作服',
      'ja': 'ビルダーオーバーオール'
    }, {
      'id': 'BuilderShirtItem',
      'en': 'Builder Shirt',
      'fr': 'Chemise de constructeur',
      'es': 'Camisa de constructor',
      'de': 'Erbauer-Shirt',
      'pl': 'Koszula budowniczego',
      'ru': 'Рубашка строителя',
      'uk': 'Сорочка будівельника',
      'ko': '빌더 셔츠',
      'zh': '建设者衬衫',
      'ja': 'ビルダーシャツ'
    }, {
      'id': 'BullrushSeedItem',
      'en': 'Bullrush Seed',
      'fr': 'Graine de Bullrush',
      'es': 'Semilla de espadaña',
      'de': 'Bullrush-Samen',
      'pl': 'Nasiona Bullrush',
      'ru': 'Семена бычьего тростника',
      'uk': 'Насіння кичуку',
      'ko': '불러시 씨앗',
      'zh': '牛蒡种子',
      'ja': 'ブルラッシュシード'
    }, {
      'id': 'BunchgrassSeedItem',
      'en': 'Bunchgrass Seed',
      'fr': 'Graine de graminée touffue',
      'es': 'Semilla de pasto',
      'de': 'Bunchgras-Samen',
      'pl': 'Nasiona kiści trawy',
      'ru': 'Семена дернины',
      'uk': 'Насіння грона',
      'ko': '번치 그래스 씨앗',
      'zh': '丛草种子',
      'ja': 'バンチグラスシード'
    }, {
      'id': 'ButcheryTableItem',
      'en': 'Butchery Table',
      'fr': 'Table de boucherie',
      'es': 'Mesa de Carnicería',
      'de': 'Metzgerei-Tabelle',
      'pl': 'Stół rzeźniczy',
      'ru': 'Мясной стол',
      'uk': 'М\u0027ясний стіл',
      'ko': '도살 테이블',
      'zh': '屠宰台',
      'ja': '肉屋のテーブル'
    }, {
      'id': 'ButcheryUpgradeItem',
      'en': 'Butchery Upgrade',
      'fr': 'Amélioration de la boucherie',
      'es': 'Actualización de carnicería',
      'de': 'Metzgerei-Upgrade',
      'pl': 'Ulepszenie rzeźni',
      'ru': 'Обновление мясной лавки',
      'uk': 'Оновлення м\u0027ясних заводів',
      'ko': '도살 업그레이드',
      'zh': '屠宰场升级',
      'ja': '肉屋のアップグレード'
    }, {
      'id': 'CO2CanisterItem',
      'en': 'C O2 Canister',
      'fr': 'Cartouche de C O2',
      'es': 'Bote de CO2',
      'de': 'CO2-Kanister',
      'pl': 'Kanister CO2',
      'ru': 'Канистра C O2',
      'uk': 'C O2 каністра',
      'ko': 'CO2 캐니스터',
      'zh': '二氧化碳罐',
      'ja': 'CO2キャニスター'
    }, {
      'id': 'CamasAshFertilizerItem',
      'en': 'Camas Ash Fertilizer',
      'fr': 'Engrais de cendres Camas',
      'es': 'Fertilizante Ceniza Camas',
      'de': 'Camas-Aschendünger',
      'pl': 'Nawóz Camas Ash',
      'ru': 'Камас Зола Удобрение',
      'uk': 'Добриво з попелу Камас',
      'ko': '카마스 재 비료',
      'zh': '卡马斯灰肥',
      'ja': 'カマス灰肥料'
    }, {
      'id': 'CamasBreadItem',
      'en': 'Camas Bread',
      'fr': 'Pain Camas',
      'es': 'Pan Camas',
      'de': 'Camas-Brot',
      'pl': 'Chleb',
      'ru': 'Камас Хлеб',
      'uk': 'Камас Хліб',
      'ko': '카마스 빵',
      'zh': '卡马斯面包',
      'ja': 'キャマスパン'
    }, {
      'id': 'CamasBulbItem',
      'en': 'Camas Bulb',
      'fr': 'Camas Ampoule',
      'es': 'Bombilla Camas',
      'de': 'Camas-Birne',
      'pl': 'Żarówka Cama',
      'ru': 'Камас Лампа',
      'uk': 'Лампа Камас',
      'ko': '카마스 전구',
      'zh': '卡马斯灯泡',
      'ja': 'カマス球根'
    }, {
      'id': 'CamasBulbBakeItem',
      'en': 'Camas Bulb Bake',
      'fr': 'Cuisson au bulbe de Camas',
      'es': 'Camas Bulbo Horneado',
      'de': 'Camas Bulb Bake',
      'pl': 'Camas Piec Żarówki',
      'ru': 'Выпечка из луковицы Камас',
      'uk': 'Випічка з цибулиною Camas',
      'ko': '카마스 전구 굽기',
      'zh': '卡马斯灯泡烘烤',
      'ja': 'カマス球根焼き'
    }, {
      'id': 'CamasPasteItem',
      'en': 'Camas Paste',
      'fr': 'Camas Pâte',
      'es': 'Pasta Camas',
      'de': 'Camas-Paste',
      'pl': 'Pasta Cama',
      'ru': 'Камас Паста',
      'uk': 'Камас паста',
      'ko': '카마스 페이스트',
      'zh': '卡马斯糊',
      'ja': 'カマスペースト'
    }, {
      'id': 'CamoPantsItem',
      'en': 'Camo Pants',
      'fr': 'Pantalon camouflage',
      'es': 'Pantalones de camuflaje',
      'de': 'Camo-Hose',
      'pl': 'Spodnie moro',
      'ru': 'Камуфляжные штаны',
      'uk': 'Камуфляжні штани',
      'ko': '카모 팬츠',
      'zh': '迷彩裤',
      'ja': 'カモパンツ'
    }, {
      'id': 'CamoShirtItem',
      'en': 'Camo Shirt',
      'fr': 'Chemise camouflage',
      'es': 'Camisa de camuflaje',
      'de': 'Camo-Shirt',
      'pl': 'Koszula moro',
      'ru': 'Камуфляжная рубашка',
      'uk': 'камуфляжна сорочка',
      'ko': '카모 셔츠',
      'zh': '迷彩衬衫',
      'ja': 'カモシャツ'
    }, {
      'id': 'CampfireItem',
      'en': 'Campfire',
      'fr': 'Feu de camp',
      'es': 'Hoguera',
      'de': 'Lagerfeuer',
      'pl': 'Ognisko',
      'ru': 'Костер',
      'uk': 'Вогонь',
      'ko': '캠프 불',
      'zh': '营火',
      'ja': 'キャンプファイヤー'
    }, {
      'id': 'CampfireCookingUpgradeItem',
      'en': 'Campfire Cooking Upgrade',
      'fr': 'Amélioration de la cuisson au feu de camp',
      'es': 'Actualización de cocina de fogata',
      'de': 'Lagerfeuerkoch-Upgrade',
      'pl': 'Ulepszenie gotowania przy ognisku',
      'ru': 'Улучшение кулинарии у костра',
      'uk': 'Оновлення для приготування їжі на вогні',
      'ko': '캠프파이어 요리 업그레이드',
      'zh': '营火烹饪升级',
      'ja': 'キャンプファイヤークッキングのアップグレード'
    }, {
      'id': 'CampfireRoastItem',
      'en': 'Campfire Roast',
      'fr': 'Rôti de feu de camp',
      'es': 'asado de fogata',
      'de': 'Lagerfeuerbraten',
      'pl': 'Pieczeń przy ognisku',
      'ru': 'Жаркое у костра',
      'uk': 'Смаження на вогні',
      'ko': '캠프파이어 로스트',
      'zh': '营火烤',
      'ja': 'キャンプファイヤーロースト'
    }, {
      'id': 'CampfireSaladItem',
      'en': 'Campfire Salad',
      'fr': 'Salade de feu de camp',
      'es': 'Ensalada De Fogata',
      'de': 'Lagerfeuersalat',
      'pl': 'Sałatka Ogniskowa',
      'ru': 'Салат у костра',
      'uk': 'Салат з багаттям',
      'ko': '캠프파이어 샐러드',
      'zh': '营火沙拉',
      'ja': 'キャンプファイヤーサラダ'
    }, {
      'id': 'CampfireSalad',
      'en': 'Campfire Salad',
      'fr': 'Salade de feu de camp',
      'es': 'Ensalada De Fogata',
      'de': 'Lagerfeuersalat',
      'pl': 'Sałatka Ogniskowa',
      'ru': 'Салат у костра',
      'uk': 'Салат з багаттям',
      'ko': '캠프파이어 샐러드',
      'zh': '营火沙拉',
      'ja': 'キャンプファイヤーサラダ'
    }, {
      'id': 'CampfireStewItem',
      'en': 'Campfire Stew',
      'fr': 'Ragoût de feu de camp',
      'es': 'Estofado de fogata',
      'de': 'Eintopf am Lagerfeuer',
      'pl': 'Gulasz z Ogniska',
      'ru': 'Похлебка у костра',
      'uk': 'Тушковане вогнище',
      'ko': '캠프파이어 스튜',
      'zh': '营火炖菜',
      'ja': 'キャンプファイヤーシチュー'
    }, {
      'id': 'CampsiteItem',
      'en': 'Campsite',
      'fr': 'Site de camp',
      'es': 'Cámping',
      'de': 'Campingplatz',
      'pl': 'Obozowisko',
      'ru': 'Кемпинг',
      'uk': 'Кемпінг',
      'ko': '캠프장',
      'zh': '营地',
      'ja': 'キャンプ場'
    }, {
      'id': 'CandleStandItem',
      'en': 'Candle Stand',
      'fr': 'Chandelier',
      'es': 'Candelabro',
      'de': 'Kerzenständer',
      'pl': 'Świecznik',
      'ru': 'Подсвечник',
      'uk': 'Підсвічник',
      'ko': '캔들 스탠드',
      'zh': '烛台',
      'ja': 'ろうそく立て'
    }, {
      'id': 'CapitolItem',
      'en': 'Capitol',
      'fr': 'Capitole',
      'es': 'Capitolio',
      'de': 'Kapitol',
      'pl': 'Kapitol',
      'ru': 'Капитолий',
      'uk': 'Капітолій',
      'ko': '국회 의사당',
      'zh': '国会大厦',
      'ja': '国会議事堂'
    }, {
      'id': 'CaprisItem',
      'en': 'Capris',
      'fr': 'Capri',
      'es': 'Capris',
      'de': 'Caprihosen',
      'pl': 'Capris',
      'ru': 'Капри',
      'uk': 'Капрі',
      'ko': '카프리스',
      'zh': '七分裤',
      'ja': 'カプリパンツ'
    }, {
      'id': 'CarpentryAdvancedUpgradeItem',
      'en': 'Carpentry Advanced Upgrade',
      'fr': 'Mise à niveau avancée de la menuiserie',
      'es': 'Actualización avanzada de carpintería',
      'de': 'Zimmerei-Upgrade für Fortgeschrittene',
      'pl': 'Zaawansowana modernizacja stolarki',
      'ru': 'Столярное дело Продвинутое обновление',
      'uk': 'Розширене оновлення столярних виробів',
      'ko': '목공 고급 업그레이드',
      'zh': '木工高级升级',
      'ja': 'カーペントリーアドバンストアップグレード'
    }, {
      'id': 'CarpentryBasicUpgradeItem',
      'en': 'Carpentry Basic Upgrade',
      'fr': 'Mise à niveau de base de la menuiserie',
      'es': 'Actualización básica de carpintería',
      'de': 'Zimmerei-Basis-Upgrade',
      'pl': 'Podstawowe ulepszenie stolarki',
      'ru': 'Плотницкое базовое обновление',
      'uk': 'Базове оновлення столярних виробів',
      'ko': '목공 기본 업그레이드',
      'zh': '木工基础升级',
      'ja': '大工の基本的なアップグレード'
    }, {
      'id': 'CarpentryTableItem',
      'en': 'Carpentry Table',
      'fr': 'Tableau de menuiserie',
      'es': 'Mesa de carpintería',
      'de': 'Tischlertisch',
      'pl': 'Stół stolarski',
      'ru': 'Столярный стол',
      'uk': 'Столярний стіл',
      'ko': '목공 테이블',
      'zh': '木工桌',
      'ja': '大工のテーブル'
    }, {
      'id': 'CarvedPumpkinItem',
      'en': 'Carved Pumpkin',
      'fr': 'Citrouille sculptée',
      'es': 'Calabaza Tallada',
      'de': 'Geschnitzter Kürbis',
      'pl': 'Rzeźbiona Dynia',
      'ru': 'Резная тыква',
      'uk': 'Різьблений гарбуз',
      'ko': '새겨진 호박',
      'zh': '雕刻南瓜',
      'ja': '刻まれたカボチャ'
    }, {
      'id': 'CastIronBedItem',
      'en': 'Cast Iron Bed',
      'fr': 'Lit en fonte',
      'es': 'Cama de hierro fundido',
      'de': 'Bett aus Gusseisen',
      'pl': 'Żeliwne łóżko',
      'ru': 'Чугунная кровать',
      'uk': 'Чавунне ліжко',
      'ko': '무쇠 침대',
      'zh': '铸铁床',
      'ja': '鋳鉄製ベッド'
    }, {
      'id': 'CastIronRoyalBedItem',
      'en': 'Cast Iron Royal Bed',
      'fr': 'Lit royal en fonte',
      'es': 'Cama real de hierro fundido',
      'de': 'Königliches Bett aus Gusseisen',
      'pl': 'Żeliwne łóżko królewskie',
      'ru': 'Чугунная королевская кровать',
      'uk': 'Чавунне королівське ліжко',
      'ko': '무쇠 로얄 침대',
      'zh': '铸铁皇家床',
      'ja': '鋳鉄製ロイヤルベッド'
    }, {
      'id': 'CastIronStoveItem',
      'en': 'Cast Iron Stove',
      'fr': 'Poêle en fonte',
      'es': 'Estufa de hierro fundido',
      'de': 'Ofen aus Gusseisen',
      'pl': 'Piec żeliwny',
      'ru': 'Чугунная печь',
      'uk': 'Чавунна піч',
      'ko': '무쇠 스토브',
      'zh': '铸铁炉',
      'ja': '鋳鉄ストーブ'
    }, {
      'id': 'CedarLogItem',
      'en': 'Cedar Log',
      'fr': 'Bûche de cèdre',
      'es': 'tronco de cedro',
      'de': 'Zedernstamm',
      'pl': 'Log cedrowy',
      'ru': 'Кедровое бревно',
      'uk': 'Кедрова колода',
      'ko': '삼나무 통나무',
      'zh': '雪松原木',
      'ja': '杉の丸太'
    }, {
      'id': 'CedarSeedItem',
      'en': 'Cedar Seed',
      'fr': 'Graine de cèdre',
      'es': 'Semilla de cedro',
      'de': 'Zedernsamen',
      'pl': 'Nasiona cedru',
      'ru': 'Кедровое семя',
      'uk': 'Насіння кедра',
      'ko': '삼나무 씨앗',
      'zh': '雪松种子',
      'ja': '杉の種'
    }, {
      'id': 'CeibaLogItem',
      'en': 'Ceiba Log',
      'fr': 'Bûche Ceiba',
      'es': 'Tronco de Ceiba',
      'de': 'Ceiba-Protokoll',
      'pl': 'Ceiba Log',
      'ru': 'Сейба Лог',
      'uk': 'журнал Ceiba',
      'ko': '세이바 로그',
      'zh': '木棉原木',
      'ja': 'セイバログ'
    }, {
      'id': 'CeibaSeedItem',
      'en': 'Ceiba Seed',
      'fr': 'Graine de Ceiba',
      'es': 'Semilla de Ceiba',
      'de': 'Ceiba-Samen',
      'pl': 'Nasiona Ceiby',
      'ru': 'Семена сейбы',
      'uk': 'Сейба Сід',
      'ko': '세이바 씨',
      'zh': '木棉种子',
      'ja': 'セイバシード'
    }, {
      'id': 'CeilingCandleItem',
      'en': 'Ceiling Candle',
      'fr': 'Bougie de plafond',
      'es': 'Vela de techo',
      'de': 'Deckenkerze',
      'pl': 'Świeca sufitowa',
      'ru': 'Потолочная свеча',
      'uk': 'Стельова свічка',
      'ko': '천장 양초',
      'zh': '天花板蜡烛',
      'ja': 'シーリングキャンドル'
    }, {
      'id': 'CelluloseFiberItem',
      'en': 'Cellulose Fiber',
      'fr': 'Fibre cellulosique',
      'es': 'Fibra de celulosa',
      'de': 'Zellulosefaser',
      'pl': 'Włókno celulozowe',
      'ru': 'Целлюлозное волокно',
      'uk': 'Целюлозна клітковина',
      'ko': '셀룰로오스 섬유',
      'zh': '纤维素纤维',
      'ja': 'セルロース繊維'
    }, {
      'id': 'CementItem',
      'en': 'Cement',
      'fr': 'Ciment',
      'es': 'Cemento',
      'de': 'Zement',
      'pl': 'Cement',
      'ru': 'Цемент',
      'uk': 'Цемент',
      'ko': '시멘트',
      'zh': '水泥',
      'ja': 'セメント'
    }, {
      'id': 'CementKilnItem',
      'en': 'Cement Kiln',
      'fr': 'Four à ciment',
      'es': 'horno de cemento',
      'de': 'Zementofen',
      'pl': 'Cementownia',
      'ru': 'Цементная печь',
      'uk': 'Цементна піч',
      'ko': '시멘트 가마',
      'zh': '水泥窑',
      'ja': 'セメントキルン'
    }, {
      'id': 'CensusBureauItem',
      'en': 'Census Bureau',
      'fr': 'Bureau de recensement',
      'es': 'Oficina del Censo',
      'de': 'Statistik Amt',
      'pl': 'Biuro Spisu Ludności',
      'ru': 'Бюро переписи населения',
      'uk': 'Бюро перепису населення',
      'ko': '인구조사국',
      'zh': '人口普查局',
      'ja': '国勢調査局'
    }, {
      'id': 'CerealGermItem',
      'en': 'Cereal Germ',
      'fr': 'Germe de céréales',
      'es': 'germen de cereales',
      'de': 'Getreidekeim',
      'pl': 'Zarodek zbóż',
      'ru': 'Зерновые зародыши',
      'uk': 'Зародки злаків',
      'ko': '시리얼 세균',
      'zh': '谷物胚芽',
      'ja': '穀物胚芽'
    }, {
      'id': 'ChainsawItem',
      'en': 'Chainsaw',
      'fr': 'Tronçonneuse',
      'es': 'motosierra',
      'de': 'Kettensäge',
      'pl': 'Piła łańcuchowa',
      'ru': 'Бензопила',
      'uk': 'Бензопила',
      'ko': '전기톱',
      'zh': '电锯',
      'ja': 'チェーンソー'
    }, {
      'id': 'ChairItem',
      'en': 'Chair',
      'fr': 'Chaise',
      'es': 'Silla',
      'de': 'Stuhl',
      'pl': 'Krzesło',
      'ru': 'Стул',
      'uk': 'Стілець',
      'ko': '의자',
      'zh': '椅子',
      'ja': '椅子'
    }, {
      'id': 'CharcoalItem',
      'en': 'Charcoal',
      'fr': 'charbon',
      'es': 'Carbón',
      'de': 'Holzkohle',
      'pl': 'Węgiel drzewny',
      'ru': 'Древесный уголь',
      'uk': 'Деревне вугілля',
      'ko': '숯',
      'zh': '木炭',
      'ja': '木炭'
    }, {
      'id': 'CharredAgaveItem',
      'en': 'Charred Agave',
      'fr': 'Agave carbonisé',
      'es': 'Agave carbonizado',
      'de': 'Verkohlte Agave',
      'pl': 'Zwęglona agawa',
      'ru': 'Обугленная агава',
      'uk': 'Обвуглена агава',
      'ko': '그을린 용설란',
      'zh': '烧焦的龙舌兰',
      'ja': '焦げたリュウゼツラン'
    }, {
      'id': 'CharredBeansItem',
      'en': 'Charred Beans',
      'fr': 'Haricots carbonisés',
      'es': 'Frijoles Carbonizados',
      'de': 'Verkohlte Bohnen',
      'pl': 'Zwęglona Fasola',
      'ru': 'Обугленные бобы',
      'uk': 'Обвуглені боби',
      'ko': '그을린 콩',
      'zh': '烧焦的豆子',
      'ja': '焦げた豆'
    }, {
      'id': 'CharredBeetItem',
      'en': 'Charred Beet',
      'fr': 'Betterave carbonisée',
      'es': 'Remolacha carbonizada',
      'de': 'Verkohlte Rüben',
      'pl': 'Zwęglony Burak',
      'ru': 'Обугленная свекла',
      'uk': 'Обвуглений буряк',
      'ko': '그을린 비트',
      'zh': '烧焦的甜菜',
      'ja': '焦げたビート'
    }, {
      'id': 'CharredCactusFruitItem',
      'en': 'Charred Cactus Fruit',
      'fr': 'Fruit de cactus carbonisé',
      'es': 'Fruta de cactus carbonizada',
      'de': 'Verkohlte Kaktusfrucht',
      'pl': 'Zwęglony owoc kaktusa',
      'ru': 'Обугленный плод кактуса',
      'uk': 'Плоди обвугленого кактуса',
      'ko': '그을린 선인장 열매',
      'zh': '烧焦的仙人掌果实',
      'ja': '焦げたサボテンの果実'
    }, {
      'id': 'CharredCamasBulbItem',
      'en': 'Charred Camas Bulb',
      'fr': 'Ampoule Camas carbonisée',
      'es': 'Bulbo de Camas carbonizado',
      'de': 'Verkohlte Camas-Birne',
      'pl': 'Zwęglona żarówka Cama',
      'ru': 'Обугленная лампочка Камас',
      'uk': 'Обвуглена лампа Камас',
      'ko': '그을린 카마스 전구',
      'zh': '烧焦的卡马斯灯泡',
      'ja': '焦げたカマッシア球根'
    }, {
      'id': 'CharredCornItem',
      'en': 'Charred Corn',
      'fr': 'Maïs carbonisé',
      'es': 'Maíz carbonizado',
      'de': 'Verkohlter Mais',
      'pl': 'Zwęglona Kukurydza',
      'ru': 'Обугленная кукуруза',
      'uk': 'Обвуглена кукурудза',
      'ko': '그을린 옥수수',
      'zh': '烧焦的玉米',
      'ja': '焦げたトウモロコシ'
    }, {
      'id': 'CharredFireweedShootsItem',
      'en': 'Charred Fireweed Shoots',
      'fr': 'Pousses d\u0027épilobe carbonisées',
      'es': 'Brotes carbonizados de hierba de fuego',
      'de': 'Verkohlte Fireweed-Triebe',
      'pl': 'Zwęglone pędy Fireweed',
      'ru': 'Обугленные побеги кипрея',
      'uk': 'Пагони обвугленого вогнища',
      'ko': '그을린 Fireweed 싹',
      'zh': '烧焦的杂草芽',
      'ja': '焦げたヤナギランのシュート'
    }, {
      'id': 'CharredFishItem',
      'en': 'Charred Fish',
      'fr': 'Poisson carbonisé',
      'es': 'pescado carbonizado',
      'de': 'Verkohlter Fisch',
      'pl': 'Zwęglona Ryba',
      'ru': 'Обугленная рыба',
      'uk': 'Обвуглена риба',
      'ko': '그을린 생선',
      'zh': '烧焦的鱼',
      'ja': '焦げた魚'
    }, {
      'id': 'CharredHeartOfPalmItem',
      'en': 'Charred Heart Of Palm',
      'fr': 'Coeur de palmier carbonisé',
      'es': 'Corazón de palmito carbonizado',
      'de': 'Verkohltes Herz der Palme',
      'pl': 'Zwęglone Serce Palmy',
      'ru': 'Обугленное сердце пальмы',
      'uk': 'Обвуглене серце пальми',
      'ko': '손바닥의 그을린 심장',
      'zh': '烧焦的棕榈心',
      'ja': '焦げたハートオブパーム'
    }, {
      'id': 'CharredMeatItem',
      'en': 'Charred Meat',
      'fr': 'Viande carbonisée',
      'es': 'Carne Carbonizada',
      'de': 'Verkohltes Fleisch',
      'pl': 'Zwęglone Mięso',
      'ru': 'Обугленное мясо',
      'uk': 'Обвуглене м\u0027ясо',
      'ko': '그을린 고기',
      'zh': '烧焦的肉',
      'ja': '焦げた肉'
    }, {
      'id': 'CharredMushroomsItem',
      'en': 'Charred Mushrooms',
      'fr': 'Champignons carbonisés',
      'es': 'Champiñones carbonizados',
      'de': 'Verkohlte Pilze',
      'pl': 'Zwęglone Grzyby',
      'ru': 'Обугленные грибы',
      'uk': 'Обвуглені гриби',
      'ko': '그을린 버섯',
      'zh': '烧焦的蘑菇',
      'ja': '焦げたきのこ'
    }, {
      'id': 'CharredPapayaItem',
      'en': 'Charred Papaya',
      'fr': 'Papaye carbonisée',
      'es': 'Papaya carbonizada',
      'de': 'Verkohlte Papaya',
      'pl': 'Zwęglona Papaja',
      'ru': 'Обугленная папайя',
      'uk': 'Обвуглена папайя',
      'ko': '그을린 파파야',
      'zh': '烧焦的木瓜',
      'ja': '焦げたパパイヤ'
    }, {
      'id': 'CharredPineappleItem',
      'en': 'Charred Pineapple',
      'fr': 'Ananas carbonisé',
      'es': 'Piña carbonizada',
      'de': 'Verkohlte Ananas',
      'pl': 'Zwęglony Ananas',
      'ru': 'Обугленный ананас',
      'uk': 'Обвуглений ананас',
      'ko': '그을린 파인애플',
      'zh': '烧焦的菠萝',
      'ja': '焦げたパイナップル'
    }, {
      'id': 'CharredSausageItem',
      'en': 'Charred Sausage',
      'fr': 'Saucisse carbonisée',
      'es': 'salchicha carbonizada',
      'de': 'Verkohlte Wurst',
      'pl': 'Pieczona Kiełbasa',
      'ru': 'Обугленная колбаса',
      'uk': 'Обвуглена ковбаса',
      'ko': '그을린 소시지',
      'zh': '烧焦的香肠',
      'ja': '焦げたソーセージ'
    }, {
      'id': 'CharredTaroItem',
      'en': 'Charred Taro',
      'fr': 'Taro carbonisé',
      'es': 'Taro carbonizado',
      'de': 'Verkohlter Taro',
      'pl': 'Zwęglony Taro',
      'ru': 'Обугленное Таро',
      'uk': 'Обвуглене Таро',
      'ko': '그을린 타로',
      'zh': '烧焦芋头',
      'ja': '焦げた太郎'
    }, {
      'id': 'CharredTomatoItem',
      'en': 'Charred Tomato',
      'fr': 'Tomate carbonisée',
      'es': 'tomate asado',
      'de': 'Verkohlte Tomate',
      'pl': 'Zwęglony Pomidor',
      'ru': 'Обугленный помидор',
      'uk': 'Обвуглений помідор',
      'ko': '그을린 토마토',
      'zh': '烧焦的番茄',
      'ja': '焦げたトマト'
    }, {
      'id': 'ChefHatItem',
      'en': 'Chef Hat',
      'fr': 'Toque',
      'es': 'Sombrero de cocinero',
      'de': 'Kochmütze',
      'pl': 'Kapelusz szefa kuchni',
      'ru': 'Шляпа шеф-повара',
      'uk': 'Капелюх шеф-кухаря',
      'ko': '요리사 모자',
      'zh': '厨师帽',
      'ja': 'シェフハット'
    }, {
      'id': 'ChefPantsItem',
      'en': 'Chef Pants',
      'fr': 'Pantalon de cuisine',
      'es': 'Pantalones de cocinero',
      'de': 'Kochhose',
      'pl': 'Spodnie szefa kuchni',
      'ru': 'Брюки шеф-повара',
      'uk': 'Штани шеф-кухаря',
      'ko': '요리사 바지',
      'zh': '厨师裤',
      'ja': 'シェフパンツ'
    }, {
      'id': 'ChefShirtItem',
      'en': 'Chef Shirt',
      'fr': 'Chemise de chef',
      'es': 'Camisa de cocinero',
      'de': 'Koch-Shirt',
      'pl': 'Koszula szefa kuchni',
      'ru': 'Рубашка шеф-повара',
      'uk': 'Сорочка шеф-кухаря',
      'ko': '요리사 셔츠',
      'zh': '厨师衬衫',
      'ja': 'シェフシャツ'
    }, {
      'id': 'ChefShoesItem',
      'en': 'Chef Shoes',
      'fr': 'Chaussures de cuisine',
      'es': 'Zapatos de cocinero',
      'de': 'Kochschuhe',
      'pl': 'Buty szefa kuchni',
      'ru': 'Обувь для поваров',
      'uk': 'Взуття шеф-кухаря',
      'ko': '요리사 신발',
      'zh': '厨师鞋',
      'ja': 'シェフの靴'
    }, {
      'id': 'ClamItem',
      'en': 'Clam',
      'fr': 'Palourde',
      'es': 'Almeja',
      'de': 'Muschel',
      'pl': 'Małż',
      'ru': 'Моллюск',
      'uk': 'молюск',
      'ko': '대합',
      'zh': '蛤',
      'ja': 'あさり'
    }, {
      'id': 'ClamChowderItem',
      'en': 'Clam Chowder',
      'fr': 'Chaudrée de palourdes',
      'es': 'Sopa de almejas',
      'de': 'Muschelsuppe',
      'pl': 'Chowder z mięczaków',
      'ru': 'Похлебка из моллюсков',
      'uk': 'Юшка з молюсків',
      'ko': '옥수수 잡탕',
      'zh': '蛤蜊杂烩',
      'ja': 'クラムチャウダー'
    }, {
      'id': 'ClayItem',
      'en': 'Clay',
      'fr': 'Argile',
      'es': 'Arcilla',
      'de': 'Ton',
      'pl': 'Glina',
      'ru': 'Глина',
      'uk': 'Глина',
      'ko': '점토',
      'zh': '粘土',
      'ja': '粘土'
    }, {
      'id': 'ClothItem',
      'en': 'Cloth',
      'fr': 'Chiffon',
      'es': 'Tela',
      'de': 'Tuch',
      'pl': 'Płótno',
      'ru': 'Ткань',
      'uk': 'Тканина',
      'ko': '천',
      'zh': '布',
      'ja': '布'
    }, {
      'id': 'ClothBeltItem',
      'en': 'Cloth Belt',
      'fr': 'Ceinture en tissu',
      'es': 'Cinturón de tela',
      'de': 'Stoffgürtel',
      'pl': 'Płócienny pasek',
      'ru': 'Тканевый пояс',
      'uk': 'Пояс із тканини',
      'ko': '천 벨트',
      'zh': '布腰带',
      'ja': '布ベルト'
    }, {
      'id': 'ClothCapeItem',
      'en': 'Cloth Cape',
      'fr': 'Cape en tissu',
      'es': 'capa de tela',
      'de': 'Stoffumhang',
      'pl': 'Peleryna z materiału',
      'ru': 'Тканевая накидка',
      'uk': 'Накидка з тканини',
      'ko': '천망토',
      'zh': '布斗篷',
      'ja': '布ケープ'
    }, {
      'id': 'Clothes',
      'en': 'Clothes',
      'fr': 'Vêtements',
      'es': 'Ropa',
      'de': 'Kleidung',
      'pl': 'Odzież',
      'ru': 'Одежда',
      'uk': 'Одяг',
      'ko': '옷',
      'zh': '衣服',
      'ja': '服'
    }, {
      'id': 'CoalItem',
      'en': 'Coal',
      'fr': 'Charbon',
      'es': 'Carbón',
      'de': 'Kohle',
      'pl': 'Węgiel',
      'ru': 'Каменный уголь',
      'uk': 'Вугілля',
      'ko': '석탄',
      'zh': '煤炭',
      'ja': '石炭'
    }, {
      'id': 'Coal',
      'en': 'Coal',
      'fr': 'Charbon',
      'es': 'Carbón',
      'de': 'Kohle',
      'pl': 'Węgiel',
      'ru': 'Каменный уголь',
      'uk': 'Вугілля',
      'ko': '석탄',
      'zh': '煤炭',
      'ja': '石炭'
    }, {
      'id': 'CodItem',
      'en': 'Cod',
      'fr': 'la morue',
      'es': 'Bacalao',
      'de': 'Kabeljau',
      'pl': 'Dorsz',
      'ru': 'Треска',
      'uk': 'тріска',
      'ko': '대구',
      'zh': '鳕鱼',
      'ja': 'タラ'
    }, {
      'id': 'CombustionEngineItem',
      'en': 'Combustion Engine',
      'fr': 'Moteur à combustion',
      'es': 'Motor de combustión',
      'de': 'Verbrennungsmotor',
      'pl': 'Silnik spalinowy',
      'ru': 'Двигатель внутреннего сгорания',
      'uk': 'Двигун внутрішнього згоряння',
      'ko': '연소 엔진',
      'zh': '内燃机',
      'ja': '燃焼エンジン'
    }, {
      'id': 'CombustionGeneratorItem',
      'en': 'Combustion Generator',
      'fr': 'Générateur de combustion',
      'es': 'Generador de combustión',
      'de': 'Verbrennungsgenerator',
      'pl': 'Generator spalania',
      'ru': 'Генератор внутреннего сгорания',
      'uk': 'Генератор горіння',
      'ko': '연소 발생기',
      'zh': '燃烧发生器',
      'ja': '燃焼発生器'
    }, {
      'id': 'CompositeBirchBenchItem',
      'en': 'Composite Birch Bench',
      'fr': 'Banc en bouleau composite',
      'es': 'Banco de abedul compuesto',
      'de': 'Sitzbank aus Birkenholz',
      'pl': 'Kompozytowa ławka brzozowa',
      'ru': 'Композитная скамья из березы',
      'uk': 'Композитна березова лавка',
      'ko': '합성 자작나무 벤치',
      'zh': '复合桦木长凳',
      'ja': '複合バーチベンチ'
    }, {
      'id': 'CompositeBirchChairItem',
      'en': 'Composite Birch Chair',
      'fr': 'Chaise en bouleau composite',
      'es': 'Silla de abedul compuesto',
      'de': 'Zusammengesetzter Birken-Stuhl',
      'pl': 'Kompozytowe krzesło brzozowe',
      'ru': 'Композитный березовый стул',
      'uk': 'Композитний березовий стілець',
      'ko': '합성 자작나무 의자',
      'zh': '复合桦木椅子',
      'ja': 'コンポジットバーチチェア'
    }, {
      'id': 'CompositeBirchDoorItem',
      'en': 'Composite Birch Door',
      'fr': 'Porte en bouleau composite',
      'es': 'Puerta de abedul compuesto',
      'de': 'Komposittür aus Birke',
      'pl': 'Kompozytowe drzwi brzozowe',
      'ru': 'Композитная березовая дверь',
      'uk': 'Композитні березові двері',
      'ko': '합성 자작 나무 문',
      'zh': '复合桦木门',
      'ja': '複合バーチドア'
    }, {
      'id': 'CompositeBirchLumberItem',
      'en': 'Composite Birch Lumber',
      'fr': 'Bois de bouleau composite',
      'es': 'Madera de abedul compuesta',
      'de': 'Zusammengesetztes Birkenholz',
      'pl': 'Kompozytowa tarcica brzozowa',
      'ru': 'Композитный пиломатериал из березы',
      'uk': 'Композитні березові пиломатеріали',
      'ko': '합성 자작나무 목재',
      'zh': '复合桦木',
      'ja': '複合バーチ材'
    }, {
      'id': 'CompositeBirchTableItem',
      'en': 'Composite Birch Table',
      'fr': 'Table en bouleau composite',
      'es': 'Mesa de abedul compuesto',
      'de': 'Zusammengesetzter Birkentisch',
      'pl': 'Kompozytowy stół brzozowy',
      'ru': 'Композитный стол из березы',
      'uk': 'Композитний стіл береза',
      'ko': '복합 자작 나무 테이블',
      'zh': '复合桦木桌',
      'ja': 'コンポジットバーチテーブル'
    }, {
      'id': 'CompositeBowItem',
      'en': 'Composite Bow',
      'fr': 'Arc composite',
      'es': 'Arco compuesto',
      'de': 'Zusammengesetzter Bogen',
      'pl': 'Kompozytowy łuk',
      'ru': 'Композитный лук',
      'uk': 'Композитний лук',
      'ko': '합성 활',
      'zh': '复合弓',
      'ja': '複合弓'
    }, {
      'id': 'CompositeCedarBenchItem',
      'en': 'Composite Cedar Bench',
      'fr': 'Banc en cèdre composite',
      'es': 'Banco de cedro compuesto',
      'de': 'Zusammengesetzte Zedernbank',
      'pl': 'Kompozytowa ławka cedrowa',
      'ru': 'Композитная кедровая скамья',
      'uk': 'Композитна кедрова лава',
      'ko': '합성 삼나무 벤치',
      'zh': '复合雪松长凳',
      'ja': '複合杉ベンチ'
    }, {
      'id': 'CompositeCedarChairItem',
      'en': 'Composite Cedar Chair',
      'fr': 'Chaise en cèdre composite',
      'es': 'Silla de cedro compuesto',
      'de': 'Zusammengesetzter Zeder-Stuhl',
      'pl': 'Krzesło kompozytowe cedrowe',
      'ru': 'Композитный кедровый стул',
      'uk': 'Композитний кедровий стілець',
      'ko': '합성 삼나무 의자',
      'zh': '复合雪松椅',
      'ja': '複合杉椅子'
    }, {
      'id': 'CompositeCedarDoorItem',
      'en': 'Composite Cedar Door',
      'fr': 'Porte en cèdre composite',
      'es': 'Puerta de cedro compuesto',
      'de': 'Zusammengesetzte Zederntür',
      'pl': 'Kompozytowe drzwi cedrowe',
      'ru': 'Композитная кедровая дверь',
      'uk': 'Композитні двері з кедра',
      'ko': '합성 삼나무 문',
      'zh': '复合雪松门',
      'ja': '複合杉のドア'
    }, {
      'id': 'CompositeCedarLumberItem',
      'en': 'Composite Cedar Lumber',
      'fr': 'Bois de cèdre composite',
      'es': 'Madera de cedro compuesta',
      'de': 'Zusammengesetztes Zedernholz',
      'pl': 'Tarcica kompozytowa cedrowa',
      'ru': 'Композитный кедровый пиломатериал',
      'uk': 'Композитний кедровий пиломатеріал',
      'ko': '합성 삼나무 목재',
      'zh': '复合雪松材',
      'ja': '複合杉材'
    }, {
      'id': 'CompositeCedarTableItem',
      'en': 'Composite Cedar Table',
      'fr': 'Table en cèdre composite',
      'es': 'Mesa de cedro compuesto',
      'de': 'Tisch aus Zedernholz',
      'pl': 'Kompozytowy stół cedrowy',
      'ru': 'Композитный Кедровый Стол',
      'uk': 'Композитний кедровий стіл',
      'ko': '합성 삼나무 테이블',
      'zh': '复合雪松桌',
      'ja': '複合杉テーブル'
    }, {
      'id': 'CompositeCeibaBenchItem',
      'en': 'Composite Ceiba Bench',
      'fr': 'Banc Ceiba Composite',
      'es': 'Banco Ceiba Compuesto',
      'de': 'Zusammengesetzte Ceiba-Bank',
      'pl': 'Kompozytowa ławka Ceiba',
      'ru': 'Композитная скамья Ceiba',
      'uk': 'Композитна лавка Ceiba',
      'ko': '복합 Ceiba 벤치',
      'zh': '复合木棉板凳',
      'ja': 'コンポジットセイバベンチ'
    }, {
      'id': 'CompositeCeibaChairItem',
      'en': 'Composite Ceiba Chair',
      'fr': 'Chaise Ceiba composite',
      'es': 'Silla Ceiba Compuesto',
      'de': 'Zusammengesetzter Ceiba-Stuhl',
      'pl': 'Krzesło kompozytowe Ceiba',
      'ru': 'Композитный Сейба Стул',
      'uk': 'Композитний стілець Ceiba',
      'ko': '합성 Ceiba 의자',
      'zh': '复合木棉椅',
      'ja': 'コンポジットセイバチェア'
    }, {
      'id': 'CompositeCeibaDoorItem',
      'en': 'Composite Ceiba Door',
      'fr': 'Porte composite Ceiba',
      'es': 'Puerta Ceiba Compuesta',
      'de': 'Zusammengesetzte Ceiba-Tür',
      'pl': 'Kompozytowe drzwi Ceiba',
      'ru': 'Композитная дверь Сейба',
      'uk': 'Композитні двері Ceiba',
      'ko': '복합 Ceiba 도어',
      'zh': '复合木棉门',
      'ja': '複合セイバドア'
    }, {
      'id': 'CompositeCeibaLumberItem',
      'en': 'Composite Ceiba Lumber',
      'fr': 'Bois composite Ceiba',
      'es': 'Madera de Ceiba Compuesta',
      'de': 'Ceiba-Verbundholz',
      'pl': 'Tarcica kompozytowa Ceiba',
      'ru': 'Композитный пиломатериал Сейба',
      'uk': 'Композитний пиломатеріал Ceiba',
      'ko': '합성 Ceiba 목재',
      'zh': '复合木棉',
      'ja': '複合セイバ材'
    }, {
      'id': 'CompositeCeibaTableItem',
      'en': 'Composite Ceiba Table',
      'fr': 'Table composite Ceiba',
      'es': 'Mesa Ceiba compuesta',
      'de': 'Zusammengesetzter Ceiba-Tisch',
      'pl': 'Kompozytowy stół Ceiba',
      'ru': 'Композитный стол сейба',
      'uk': 'Композитний стіл Сейба',
      'ko': '복합 Ceiba 테이블',
      'zh': '复合木棉桌',
      'ja': '複合セイバテーブル'
    }, {
      'id': 'CompositeFillerItem',
      'en': 'Composite Filler',
      'fr': 'Charge composite',
      'es': 'Relleno compuesto',
      'de': 'Komposit-Füller',
      'pl': 'Wypełniacz kompozytowy',
      'ru': 'Композитный наполнитель',
      'uk': 'Композитний наповнювач',
      'ko': '복합 필러',
      'zh': '复合填料',
      'ja': '複合フィラー'
    }, {
      'id': 'CompositeFirBenchItem',
      'en': 'Composite Fir Bench',
      'fr': 'Banc en sapin composite',
      'es': 'Banco de abeto compuesto',
      'de': 'Komposit-Tannenbank',
      'pl': 'Kompozytowa ławka jodłowa',
      'ru': 'Композитная еловая скамья',
      'uk': 'Композитна ялиця лавка',
      'ko': '복합 전나무 벤치',
      'zh': '复合冷杉板凳',
      'ja': '複合ファーベンチ'
    }, {
      'id': 'CompositeFirChairItem',
      'en': 'Composite Fir Chair',
      'fr': 'Chaise en sapin composite',
      'es': 'Silla de abeto compuesto',
      'de': 'Zusammengesetzter Tannen-Stuhl',
      'pl': 'Kompozytowe krzesło jodłowe',
      'ru': 'Композитный еловый стул',
      'uk': 'Композитний ялиновий стілець',
      'ko': '복합 전나무 의자',
      'zh': '复合杉木椅',
      'ja': '複合ファーチェア'
    }, {
      'id': 'CompositeFirDoorItem',
      'en': 'Composite Fir Door',
      'fr': 'Porte en sapin composite',
      'es': 'Puerta de abeto compuesto',
      'de': 'Zusammengesetzte Tanne Tür',
      'pl': 'Kompozytowe drzwi jodłowe',
      'ru': 'Композитная еловая дверь',
      'uk': 'Композитні ялинові двері',
      'ko': '복합 전나무 문',
      'zh': '复合杉木门',
      'ja': '複合モミドア'
    }, {
      'id': 'CompositeFirLumberItem',
      'en': 'Composite Fir Lumber',
      'fr': 'Bois de sapin composite',
      'es': 'Madera de abeto compuesta',
      'de': 'Zusammengesetztes Tannenholz',
      'pl': 'Kompozytowa tarcica jodłowa',
      'ru': 'Композитный пиломатериал',
      'uk': 'Композитний пиломатеріал',
      'ko': '복합 전나무 목재',
      'zh': '复合杉木',
      'ja': '複合モミ材'
    }, {
      'id': 'CompositeFirTableItem',
      'en': 'Composite Fir Table',
      'fr': 'Table en sapin composite',
      'es': 'Mesa de abeto compuesto',
      'de': 'Komposit-Tannentisch',
      'pl': 'Kompozytowy stół jodłowy',
      'ru': 'Композитный еловый стол',
      'uk': 'Композитний ялиновий стіл',
      'ko': '복합 전나무 테이블',
      'zh': '复合杉木桌',
      'ja': '複合モミテーブル'
    }, {
      'id': 'CompositeHardwoodBenchItem',
      'en': 'Composite Hardwood Bench',
      'fr': 'Banc en bois dur composite',
      'es': 'Banco de madera dura compuesta',
      'de': 'Sitzbank aus Hartholz',
      'pl': 'Kompozytowa ławka z twardego drewna',
      'ru': 'Композитная скамья из твердой древесины',
      'uk': 'Композитна лавка з твердих порід дерева',
      'ko': '합성 견목 벤치',
      'zh': '复合硬木长凳',
      'ja': '複合広葉樹ベンチ'
    }, {
      'id': 'CompositeHardwoodChairItem',
      'en': 'Composite Hardwood Chair',
      'fr': 'Chaise en bois dur composite',
      'es': 'Silla de madera compuesta',
      'de': 'Komposit-Hartholz-Stuhl',
      'pl': 'Krzesło kompozytowe z twardego drewna',
      'ru': 'Композитный деревянный стул',
      'uk': 'Крісло з композитної деревини',
      'ko': '합성 나무 의자',
      'zh': '复合硬木椅',
      'ja': '複合広葉樹椅子'
    }, {
      'id': 'CompositeHardwoodDoorItem',
      'en': 'Composite Hardwood Door',
      'fr': 'Porte en bois dur composite',
      'es': 'Puerta de madera compuesta',
      'de': 'Komposit-Hartholztür',
      'pl': 'Drzwi kompozytowe z twardego drewna',
      'ru': 'Композитная деревянная дверь',
      'uk': 'Композитні двері з твердих порід дерева',
      'ko': '합성 나무 문',
      'zh': '复合硬木门',
      'ja': '複合広葉樹ドア'
    }, {
      'id': 'CompositeHardwoodTableItem',
      'en': 'Composite Hardwood Table',
      'fr': 'Table en bois dur composite',
      'es': 'Mesa de madera compuesta',
      'de': 'Komposit-Hartholz-Tisch',
      'pl': 'Kompozytowy stół z twardego drewna',
      'ru': 'Композитный стол из твердой древесины',
      'uk': 'Композитний стіл з твердих порід дерева',
      'ko': '합성 견목 테이블',
      'zh': '复合硬木桌',
      'ja': '複合広葉樹テーブル'
    }, {
      'id': 'CompositeJoshuaBenchItem',
      'en': 'Composite Joshua Bench',
      'fr': 'Banc Joshua en composite',
      'es': 'Banco Joshua compuesto',
      'de': 'Komposit-Joshua-Bank',
      'pl': 'Kompozytowa ławka Joshua',
      'ru': 'Композитная скамья Джошуа',
      'uk': 'Композитна лава Джошуа',
      'ko': '합성 조슈아 벤치',
      'zh': '复合约书亚长凳',
      'ja': 'コンポジットジョシュアベンチ'
    }, {
      'id': 'CompositeJoshuaChairItem',
      'en': 'Composite Joshua Chair',
      'fr': 'Chaise Joshua composite',
      'es': 'Silla Joshua de material compuesto',
      'de': 'Zusammengesetzter Joshua-Stuhl',
      'pl': 'Kompozytowe krzesło Joshua',
      'ru': 'Композитный стул Джошуа',
      'uk': 'Композитне крісло Джошуа',
      'ko': '합성 조슈아 의자',
      'zh': '复合约书亚椅',
      'ja': '複合ジョシュアチェア'
    }, {
      'id': 'CompositeJoshuaDoorItem',
      'en': 'Composite Joshua Door',
      'fr': 'Porte composite Joshua',
      'es': 'Puerta Joshua compuesta',
      'de': 'Zusammengesetzte Joshua-Tür',
      'pl': 'Kompozytowe drzwi Joshua',
      'ru': 'Композитная дверь Джошуа',
      'uk': 'Композитні двері Джошуа',
      'ko': '합성 조슈아 도어',
      'zh': '复合约书亚门',
      'ja': '複合ジョシュアドア'
    }, {
      'id': 'CompositeJoshuaLumberItem',
      'en': 'Composite Joshua Lumber',
      'fr': 'Bois composite Joshua',
      'es': 'Madera de Josué compuesta',
      'de': 'Zusammengesetztes Joshua Lumber',
      'pl': 'Kompozyt Joshua Lumber',
      'ru': 'Композитный Джошуа Ламбер',
      'uk': 'Композит Джошуа Ламбер',
      'ko': '합성 조슈아 목재',
      'zh': '复合约书亚木材',
      'ja': '複合ジョシュア材木'
    }, {
      'id': 'CompositeJoshuaTableItem',
      'en': 'Composite Joshua Table',
      'fr': 'Table Joshua composite',
      'es': 'Mesa compuesta Joshua',
      'de': 'Zusammengesetzter Joshua-Tisch',
      'pl': 'Kompozytowy stół Joshua',
      'ru': 'Композитный стол Джошуа',
      'uk': 'Композитний стіл Джошуа',
      'ko': '합성 조슈아 테이블',
      'zh': '复合约书亚桌',
      'ja': '複合ジョシュアテーブル'
    }, {
      'id': 'CompositeLumberItem',
      'en': 'Composite Lumber',
      'fr': 'Bois composite',
      'es': 'madera compuesta',
      'de': 'Verbundholz',
      'pl': 'Tarcica kompozytowa',
      'ru': 'Композитный пиломатериал',
      'uk': 'Композитні пиломатеріали',
      'ko': '합성목재',
      'zh': '复合木材',
      'ja': '複合材'
    }, {
      'id': 'CompositeLumber',
      'en': 'Composite Lumber',
      'fr': 'Bois composite',
      'es': 'madera compuesta',
      'de': 'Verbundholz',
      'pl': 'Tarcica kompozytowa',
      'ru': 'Композитный пиломатериал',
      'uk': 'Композитні пиломатеріали',
      'ko': '합성목재',
      'zh': '复合木材',
      'ja': '複合材'
    }, {
      'id': 'CompositeLumberBenchItem',
      'en': 'Composite Lumber Bench',
      'fr': 'Banc en bois composite',
      'es': 'Banco de madera compuesta',
      'de': 'Verbundholzbank',
      'pl': 'Kompozytowa ławka do drewna',
      'ru': 'Композитная скамейка из пиломатериалов',
      'uk': 'Композитний пиломатеріал',
      'ko': '합성목재 벤치',
      'zh': '复合木材工作台',
      'ja': '複合材木ベンチ'
    }, {
      'id': 'CompositeLumberChairItem',
      'en': 'Composite Lumber Chair',
      'fr': 'Chaise en bois composite',
      'es': 'Silla de madera compuesta',
      'de': 'Stuhl aus zusammengesetztem Bauholz',
      'pl': 'Krzesło z drewna kompozytowego',
      'ru': 'Композитный деревянный стул',
      'uk': 'Крісло з композитного пиломатеріалу',
      'ko': '합성목재 의자',
      'zh': '复合木椅',
      'ja': '複合材木椅子'
    }, {
      'id': 'CompositeLumberDoorItem',
      'en': 'Composite Lumber Door',
      'fr': 'Porte en bois composite',
      'es': 'Puerta de madera compuesta',
      'de': 'Verbundholztür',
      'pl': 'Drzwi z kompozytu drewna',
      'ru': 'Композитная деревянная дверь',
      'uk': 'Композитні двері з деревини',
      'ko': '합성목재 문',
      'zh': '复合木门',
      'ja': '複合材木ドア'
    }, {
      'id': 'CompositeLumberTableItem',
      'en': 'Composite Lumber Table',
      'fr': 'Table de bois composite',
      'es': 'Mesa de madera compuesta',
      'de': 'Tisch aus Verbundholz',
      'pl': 'Kompozytowy stół do tarcicy',
      'ru': 'Композитный стол из пиломатериалов',
      'uk': 'Композитний пиломатеріал',
      'ko': '합성목재 테이블',
      'zh': '复合木材表',
      'ja': '複合材木テーブル'
    }, {
      'id': 'CompositeOakBenchItem',
      'en': 'Composite Oak Bench',
      'fr': 'Banc en chêne composite',
      'es': 'Banco de roble compuesto',
      'de': 'Verbundbank aus Eiche',
      'pl': 'Kompozytowa ławka dębowa',
      'ru': 'Композитная дубовая скамья',
      'uk': 'Композитна дубова лавка',
      'ko': '복합 오크 벤치',
      'zh': '复合橡木长凳',
      'ja': '複合オークベンチ'
    }, {
      'id': 'CompositeOakChairItem',
      'en': 'Composite Oak Chair',
      'fr': 'Chaise en chêne composite',
      'es': 'Silla de roble compuesto',
      'de': 'Komposit-Stuhl aus Eiche',
      'pl': 'Krzesło dębowe kompozytowe',
      'ru': 'Композитный Дубовый Стул',
      'uk': 'Композитний дубовий стілець',
      'ko': '복합 오크 의자',
      'zh': '复合橡木椅',
      'ja': 'コンポジットオークチェア'
    }, {
      'id': 'CompositeOakDoorItem',
      'en': 'Composite Oak Door',
      'fr': 'Porte en chêne composite',
      'es': 'Puerta de roble compuesto',
      'de': 'Komposittür aus Eiche',
      'pl': 'Kompozytowe drzwi dębowe',
      'ru': 'Композитная дубовая дверь',
      'uk': 'Композитні дубові двері',
      'ko': '복합 오크 도어',
      'zh': '复合橡木门',
      'ja': '複合オークドア'
    }, {
      'id': 'CompositeOakLumberItem',
      'en': 'Composite Oak Lumber',
      'fr': 'Bois de chêne composite',
      'es': 'Madera de roble compuesta',
      'de': 'Kompositholz aus Eiche',
      'pl': 'Kompozytowa tarcica dębowa',
      'ru': 'Композитный дубовый пиломатериал',
      'uk': 'Композитний дубовий пиломатеріал',
      'ko': '복합 참나무 목재',
      'zh': '复合橡木',
      'ja': '複合オーク材'
    }, {
      'id': 'CompositeOakTableItem',
      'en': 'Composite Oak Table',
      'fr': 'Table en chêne composite',
      'es': 'Mesa de roble compuesto',
      'de': 'Komposit-Eiche Tisch',
      'pl': 'Kompozytowy stół dębowy',
      'ru': 'Композитный дубовый стол',
      'uk': 'Композитний дубовий стіл',
      'ko': '복합 오크 테이블',
      'zh': '复合橡木桌',
      'ja': '複合オークテーブル'
    }, {
      'id': 'CompositePalmBenchItem',
      'en': 'Composite Palm Bench',
      'fr': 'Banc en palmier composite',
      'es': 'Banco de palma compuesto',
      'de': 'Composite-Palmenbank',
      'pl': 'Kompozytowa ławka palmowa',
      'ru': 'Композитная пальмовая скамья',
      'uk': 'Композитна пальмова лавка',
      'ko': '복합 팜 벤치',
      'zh': '复合掌上凳',
      'ja': 'コンポジットパームベンチ'
    }, {
      'id': 'CompositePalmChairItem',
      'en': 'Composite Palm Chair',
      'fr': 'Chaise en palmier composite',
      'es': 'Silla de palma compuesta',
      'de': 'Zusammengesetzter Palmen-Stuhl',
      'pl': 'Kompozytowe krzesło palmowe',
      'ru': 'Композитный пальмовый стул',
      'uk': 'Композитне крісло для пальм',
      'ko': '복합 팜 체어',
      'zh': '复合棕榈椅',
      'ja': '複合パームチェア'
    }, {
      'id': 'CompositePalmDoorItem',
      'en': 'Composite Palm Door',
      'fr': 'Porte palme composite',
      'es': 'Puerta de palma compuesta',
      'de': 'Zusammengesetzte Palmentür',
      'pl': 'Kompozytowe drzwi palmowe',
      'ru': 'Композитная пальмовая дверь',
      'uk': 'Композитні двері Palm',
      'ko': '복합 팜 도어',
      'zh': '复合棕榈门',
      'ja': 'コンポジットパームドア'
    }, {
      'id': 'CompositePalmLumberItem',
      'en': 'Composite Palm Lumber',
      'fr': 'Bois de palme composite',
      'es': 'Madera de palma compuesta',
      'de': 'Zusammengesetztes Palmenholz',
      'pl': 'Kompozytowa tarcica palmowa',
      'ru': 'Композитная пальмовая древесина',
      'uk': 'Композитні пальмові пиломатеріали',
      'ko': '합성 야자 목재',
      'zh': '复合棕榈材',
      'ja': '複合ヤシ材'
    }, {
      'id': 'CompositePalmTableItem',
      'en': 'Composite Palm Table',
      'fr': 'Table en palmier composite',
      'es': 'Mesa de palma compuesta',
      'de': 'Zusammengesetzter Palmentisch',
      'pl': 'Kompozytowy stół palmowy',
      'ru': 'Композитный пальмовый стол',
      'uk': 'Композитний стіл Palm',
      'ko': '복합 팜 테이블',
      'zh': '复合掌上桌',
      'ja': '複合パームテーブル'
    }, {
      'id': 'CompositeRedwoodBenchItem',
      'en': 'Composite Redwood Bench',
      'fr': 'Banc en séquoia composite',
      'es': 'Banco de secoya compuesto',
      'de': 'Komposit-Redwood-Bank',
      'pl': 'Kompozytowa ławka sekwoja',
      'ru': 'Композитная скамья из красного дерева',
      'uk': 'Композитна лава з червоного дерева',
      'ko': '복합 레드우드 벤치',
      'zh': '复合红木长凳',
      'ja': '複合レッドウッドベンチ'
    }, {
      'id': 'CompositeRedwoodChairItem',
      'en': 'Composite Redwood Chair',
      'fr': 'Chaise en séquoia composite',
      'es': 'Silla de madera de secuoya compuesta',
      'de': 'Zusammengesetzter Redwood-Stuhl',
      'pl': 'Krzesło kompozytowe Redwood',
      'ru': 'Композитный стул из красного дерева',
      'uk': 'Композитний стілець з червоного дерева',
      'ko': '합성 레드우드 의자',
      'zh': '复合红木椅',
      'ja': '複合レッドウッドチェア'
    }, {
      'id': 'CompositeRedwoodDoorItem',
      'en': 'Composite Redwood Door',
      'fr': 'Porte en séquoia composite',
      'es': 'Puerta compuesta de secoya',
      'de': 'Zusammengesetzte Redwood-Tür',
      'pl': 'Kompozytowe drzwi sekwojowe',
      'ru': 'Композитная дверь из красного дерева',
      'uk': 'Композитні двері з червоного дерева',
      'ko': '복합 레드우드 도어',
      'zh': '复合红木门',
      'ja': '複合レッドウッドドア'
    }, {
      'id': 'CompositeRedwoodLumberItem',
      'en': 'Composite Redwood Lumber',
      'fr': 'Bois de séquoia composite',
      'es': 'Madera de secuoya compuesta',
      'de': 'Rotholz-Verbundholz',
      'pl': 'Kompozytowa tarcica sekwojowa',
      'ru': 'Композитные пиломатериалы из красного дерева',
      'uk': 'Композитні пиломатеріали червоного дерева',
      'ko': '복합 레드우드 목재',
      'zh': '复合红木木材',
      'ja': '複合レッドウッド材'
    }, {
      'id': 'CompositeRedwoodTableItem',
      'en': 'Composite Redwood Table',
      'fr': 'Table en séquoia composite',
      'es': 'Mesa de secoya compuesta',
      'de': 'Zusammengesetzter Redwood-Tisch',
      'pl': 'Kompozytowy stół sekwojowy',
      'ru': 'Композитный стол из красного дерева',
      'uk': 'Композитний стіл з червоного дерева',
      'ko': '복합 레드우드 테이블',
      'zh': '复合红木桌',
      'ja': '複合レッドウッドテーブル'
    }, {
      'id': 'CompositeSaguaroBenchItem',
      'en': 'Composite Saguaro Bench',
      'fr': 'Banc Saguaro composite',
      'es': 'Banco Saguaro de material compuesto',
      'de': 'Composite-Saguaro-Bank',
      'pl': 'Kompozytowa ławka Saguaro',
      'ru': 'Композитная скамья Сагуаро',
      'uk': 'Композитна лавка Saguaro',
      'ko': '합성 사와로 벤치',
      'zh': '复合仙人掌长凳',
      'ja': 'コンポジットサグアロベンチ'
    }, {
      'id': 'CompositeSaguaroChairItem',
      'en': 'Composite Saguaro Chair',
      'fr': 'Chaise Saguaro composite',
      'es': 'Silla Saguaro de material compuesto',
      'de': 'Saguaro-Stuhl aus Verbundwerkstoff',
      'pl': 'Krzesło kompozytowe Saguaro',
      'ru': 'Композитный стул Сагуаро',
      'uk': 'Композитний стілець Saguaro',
      'ko': '합성 사와로 의자',
      'zh': '复合仙人掌椅',
      'ja': 'コンポジットサグアロチェア'
    }, {
      'id': 'CompositeSaguaroDoorItem',
      'en': 'Composite Saguaro Door',
      'fr': 'Porte composite Saguaro',
      'es': 'Puerta Saguaro Compuesto',
      'de': 'Zusammengesetzte Saguaro-Tür',
      'pl': 'Kompozytowe drzwi Saguaro',
      'ru': 'Композитная дверь Сагуаро',
      'uk': 'Композитні двері Saguaro',
      'ko': '합성 사와로 도어',
      'zh': '复合仙人掌门',
      'ja': '複合サグアロドア'
    }, {
      'id': 'CompositeSaguaroLumberItem',
      'en': 'Composite Saguaro Lumber',
      'fr': 'Bois composite Saguaro',
      'es': 'Madera Saguaro Compuesta',
      'de': 'Saguaro-Verbundholz',
      'pl': 'Tarcica kompozytowa Saguaro',
      'ru': 'Композитные пиломатериалы Сагуаро',
      'uk': 'Композитний пиломатеріал Saguaro',
      'ko': '합성 사와로 목재',
      'zh': '复合仙人掌木材',
      'ja': '複合サグアロ材'
    }, {
      'id': 'CompositeSaguaroTableItem',
      'en': 'Composite Saguaro Table',
      'fr': 'Table Saguaro Composite',
      'es': 'Mesa Compuesto Saguaro',
      'de': 'Zusammengesetzter Saguaro-Tisch',
      'pl': 'Kompozytowy stół Saguaro',
      'ru': 'Композитный стол Сагуаро',
      'uk': 'Композитний стіл Saguaro',
      'ko': '합성 사와로 테이블',
      'zh': '复合仙人掌桌',
      'ja': '複合サグアロテーブル'
    }, {
      'id': 'CompositeSoftwoodBenchItem',
      'en': 'Composite Softwood Bench',
      'fr': 'Banc en résineux composite',
      'es': 'Banco de madera blanda compuesta',
      'de': 'Bank aus Weichholz aus Verbundwerkstoff',
      'pl': 'Kompozytowa ławka z drewna iglastego',
      'ru': 'Композитная скамейка из хвойных пород дерева',
      'uk': 'Композитна лавка з хвойних порід',
      'ko': '합성 침엽수 벤치',
      'zh': '复合软木长凳',
      'ja': '複合針葉樹ベンチ'
    }, {
      'id': 'CompositeSoftwoodChairItem',
      'en': 'Composite Softwood Chair',
      'fr': 'Chaise en résineux composite',
      'es': 'Silla de madera blanda compuesta',
      'de': 'Komposit-Weichholz-Stuhl',
      'pl': 'Krzesło kompozytowe z drewna iglastego',
      'ru': 'Композитный стул из хвойных пород дерева',
      'uk': 'Композитний стілець з хвойних порід',
      'ko': '합성 침엽수 의자',
      'zh': '复合软木椅',
      'ja': '複合針葉樹チェア'
    }, {
      'id': 'CompositeSoftwoodDoorItem',
      'en': 'Composite Softwood Door',
      'fr': 'Porte en bois résineux composite',
      'es': 'Puerta de madera blanda compuesta',
      'de': 'Komposittür aus Weichholz',
      'pl': 'Drzwi kompozytowe z drewna iglastego',
      'ru': 'Композитная дверь из хвойного дерева',
      'uk': 'Композитні двері з хвойних порід',
      'ko': '합성 침엽수 문',
      'zh': '复合软木门',
      'ja': '複合針葉樹ドア'
    }, {
      'id': 'CompositeSoftwoodTableItem',
      'en': 'Composite Softwood Table',
      'fr': 'Table en résineux composite',
      'es': 'Mesa de madera blanda compuesta',
      'de': 'Composite-Weichholz-Tisch',
      'pl': 'Kompozytowy stół z drewna iglastego',
      'ru': 'Композитный стол из хвойных пород дерева',
      'uk': 'Композитний стіл з хвойних порід',
      'ko': '합성 침엽수 테이블',
      'zh': '复合软木桌',
      'ja': '複合針葉樹テーブル'
    }, {
      'id': 'CompositeSpruceBenchItem',
      'en': 'Composite Spruce Bench',
      'fr': 'Banc en épicéa composite',
      'es': 'Banco de abeto compuesto',
      'de': 'Bank aus Fichtenholz',
      'pl': 'Kompozytowa ławka świerkowa',
      'ru': 'Композитная еловая скамья',
      'uk': 'Композитна ялина лавка',
      'ko': '합성 가문비나무 벤치',
      'zh': '复合云杉长凳',
      'ja': '複合スプルースベンチ'
    }, {
      'id': 'CompositeSpruceChairItem',
      'en': 'Composite Spruce Chair',
      'fr': 'Chaise en épicéa composite',
      'es': 'Silla de abeto compuesto',
      'de': 'Kompositstuhl aus Fichte',
      'pl': 'Kompozytowe krzesło świerkowe',
      'ru': 'Стул из композитной ели',
      'uk': 'Композитний ялиновий стілець',
      'ko': '합성 가문비나무 의자',
      'zh': '复合云杉椅',
      'ja': '複合スプルースチェア'
    }, {
      'id': 'CompositeSpruceDoorItem',
      'en': 'Composite Spruce Door',
      'fr': 'Porte en épicéa composite',
      'es': 'Puerta de abeto compuesto',
      'de': 'Komposittür aus Fichte',
      'pl': 'Kompozytowe drzwi świerkowe',
      'ru': 'Композитная еловая дверь',
      'uk': 'Композитні ялинові двері',
      'ko': '합성 가문비나무 문',
      'zh': '复合云杉门',
      'ja': '複合スプルースドア'
    }, {
      'id': 'CompositeSpruceLumberItem',
      'en': 'Composite Spruce Lumber',
      'fr': 'Bois d\u0027épicéa composite',
      'es': 'Madera de abeto compuesta',
      'de': 'Kompositholz aus Fichte',
      'pl': 'Kompozytowa tarcica świerkowa',
      'ru': 'Композитный пиломатериал из ели',
      'uk': 'Композитні пиломатеріали ялини',
      'ko': '합성 가문비나무',
      'zh': '复合云杉材',
      'ja': '複合スプルース材'
    }, {
      'id': 'CompositeSpruceTableItem',
      'en': 'Composite Spruce Table',
      'fr': 'Table en épicéa composite',
      'es': 'Mesa de abeto compuesto',
      'de': 'Komposittisch aus Fichte',
      'pl': 'Kompozytowy stół świerkowy',
      'ru': 'Композитный стол из ели',
      'uk': 'Композитний ялиновий стіл',
      'ko': '합성 가문비나무 테이블',
      'zh': '复合云杉桌',
      'ja': '複合スプルーステーブル'
    }, {
      'id': 'CompositesUpgradeItem',
      'en': 'Composites Upgrade',
      'fr': 'Mise à niveau des composites',
      'es': 'Actualización de compuestos',
      'de': 'Composites-Upgrade',
      'pl': 'Uaktualnienie kompozytów',
      'ru': 'Обновление композитов',
      'uk': 'Оновлення композитів',
      'ko': '합성물 업그레이드',
      'zh': '复合材料升级',
      'ja': 'コンポジットのアップグレード'
    }, {
      'id': 'CompostItem',
      'en': 'Compost',
      'fr': 'Compost',
      'es': 'Compost',
      'de': 'Kompost',
      'pl': 'Kompost',
      'ru': 'Компост',
      'uk': 'Компост',
      'ko': '퇴비',
      'zh': '堆肥',
      'ja': '堆肥'
    }, {
      'id': 'CompostFertilizerItem',
      'en': 'Compost Fertilizer',
      'fr': 'Engrais composté',
      'es': 'Fertilizante de compost',
      'de': 'Kompostdünger',
      'pl': 'Nawóz kompostowy',
      'ru': 'Компостное удобрение',
      'uk': 'Компостне добриво',
      'ko': '퇴비 비료',
      'zh': '堆肥',
      'ja': '堆肥肥料'
    }, {
      'id': 'ComputerLabItem',
      'en': 'Computer Lab',
      'fr': 'Salle informatique',
      'es': 'Laboratorio de computación',
      'de': 'Computerlabor',
      'pl': 'Laboratorium komputerowe',
      'ru': 'Компьютерная лаборатория',
      'uk': 'Комп\u0027ютерна лабораторія',
      'ko': '컴퓨터 실',
      'zh': '计算机实验室',
      'ja': 'コンピューター室'
    }, {
      'id': 'Concrete',
      'en': 'Concrete',
      'fr': 'Béton',
      'es': 'Concreto',
      'de': 'Beton',
      'pl': 'Beton',
      'ru': 'Конкретный',
      'uk': 'Бетон',
      'ko': '콘크리트',
      'zh': '具体的',
      'ja': 'コンクリート'
    }, {
      'id': 'ConstructionPostItem',
      'en': 'Construction Post',
      'fr': 'Poste de construction',
      'es': 'Puesto de construcción',
      'de': 'Baupost',
      'pl': 'Stanowisko budowlane',
      'ru': 'Строительный пост',
      'uk': 'Будівельний пост',
      'ko': '건설 포스트',
      'zh': '建设岗位',
      'ja': '建設ポスト'
    }, {
      'id': 'ContractBoardItem',
      'en': 'Contract Board',
      'fr': 'Comité des contrats',
      'es': 'Junta de contratos',
      'de': 'Vertragsausschuss',
      'pl': 'Zarząd kontraktowy',
      'ru': 'Совет по контрактам',
      'uk': 'Договірна рада',
      'ko': '계약 위원회',
      'zh': '合约委员会',
      'ja': '契約委員会'
    }, {
      'id': 'CookeinaMushroomSporesItem',
      'en': 'Cookeina Mushroom Spores',
      'fr': 'Spores de champignons Cookeina',
      'es': 'Esporas de hongos Cookeina',
      'de': 'Cookeina Pilzsporen',
      'pl': 'Zarodniki grzybów Cookeina',
      'ru': 'Споры грибов кукеины',
      'uk': 'Спори грибів Cookeina',
      'ko': '쿠케이나 버섯 포자',
      'zh': 'Cookeina蘑菇孢子',
      'ja': 'クッケイナきのこ胞子'
    }, {
      'id': 'CookeinaMushroomsItem',
      'en': 'Cookeina Mushrooms',
      'fr': 'Champignons Cookeina',
      'es': 'Champiñones Cookeina',
      'de': 'Cookeina-Pilze',
      'pl': 'Grzyby Cookeina',
      'ru': 'Кулинарные грибы',
      'uk': 'Гриби Cookeina',
      'ko': '쿠케이나 버섯',
      'zh': '库克伊纳蘑菇',
      'ja': 'クッケイナきのこ'
    }, {
      'id': 'CookingUpgradeItem',
      'en': 'Cooking Upgrade',
      'fr': 'Amélioration de la cuisine',
      'es': 'Mejora de cocina',
      'de': 'Koch-Upgrade',
      'pl': 'Ulepszenie gotowania',
      'ru': 'Кулинарное обновление',
      'uk': 'Оновлення приготування їжі',
      'ko': '요리 업그레이드',
      'zh': '烹饪升级',
      'ja': '料理のアップグレード'
    }, {
      'id': 'CopperBarItem',
      'en': 'Copper Bar',
      'fr': 'Barre de cuivre',
      'es': 'Barra de cobre',
      'de': 'Kupfer Barren',
      'pl': 'Miedziana sztabka',
      'ru': 'Медный слиток',
      'uk': 'Мідний злиток',
      'ko': '구리 바',
      'zh': '铜条',
      'ja': '銅棒'
    }, {
      'id': 'CopperConcentrateItem',
      'en': 'Copper Concentrate',
      'fr': 'Concentré de cuivre',
      'es': 'Concentrado de cobre',
      'de': 'Kupferkonzentrat',
      'pl': 'Koncentrat miedzi',
      'ru': 'Медный концентрат',
      'uk': 'Мідний концентрат',
      'ko': '구리 정광',
      'zh': '铜精矿',
      'ja': '銅精鉱'
    }, {
      'id': 'CopperOreItem',
      'en': 'Copper Ore',
      'fr': 'Minerai de cuivre',
      'es': 'Mina de cobre',
      'de': 'Kupfererz',
      'pl': 'Ruda miedzi',
      'ru': 'Медная руда',
      'uk': 'Мідна руда',
      'ko': '구리 광석',
      'zh': '铜矿',
      'ja': '銅鉱石'
    }, {
      'id': 'CopperPipeItem',
      'en': 'Copper Pipe',
      'fr': 'Tuyau de cuivre',
      'es': 'Tubo de cobre',
      'de': 'Kupferrohr',
      'pl': 'Miedziana rura',
      'ru': 'Медная труба',
      'uk': 'Мідна труба',
      'ko': '구리 파이프',
      'zh': '铜管',
      'ja': '銅管'
    }, {
      'id': 'CopperWiringItem',
      'en': 'Copper Wiring',
      'fr': 'Câblage en cuivre',
      'es': 'Cableado de cobre',
      'de': 'Kupferverdrahtung',
      'pl': 'Okablowanie miedziane',
      'ru': 'Медная проводка',
      'uk': 'Мідна проводка',
      'ko': '구리 배선',
      'zh': '铜线',
      'ja': '銅配線'
    }, {
      'id': 'CornItem',
      'en': 'Corn',
      'fr': 'Maïs',
      'es': 'Maíz',
      'de': 'Mais',
      'pl': 'kukurydza',
      'ru': 'Кукуруза',
      'uk': 'Кукурудза',
      'ko': '옥수수',
      'zh': '玉米',
      'ja': 'トウモロコシ'
    }, {
      'id': 'CornFrittersItem',
      'en': 'Corn Fritters',
      'fr': 'Beignets de maïs',
      'es': 'Frituras de maíz',
      'de': 'Mais-Krapfen',
      'pl': 'Placki Kukurydziane',
      'ru': 'Кукурузные оладьи',
      'uk': 'Кукурудзяні оладки',
      'ko': '옥수수 튀김',
      'zh': '玉米油条',
      'ja': 'コーンフリッター'
    }, {
      'id': 'CornSeedItem',
      'en': 'Corn Seed',
      'fr': 'Graine de maïs',
      'es': 'Semilla de maiz',
      'de': 'Maissamen',
      'pl': 'Nasiona kukurydzy',
      'ru': 'Семена кукурузы',
      'uk': 'Насіння кукурудзи',
      'ko': '옥수수 씨',
      'zh': '玉米种子',
      'ja': 'とうもろこしの種'
    }, {
      'id': 'CornStarchItem',
      'en': 'Corn Starch',
      'fr': 'Fécule de maïs',
      'es': 'Maicena',
      'de': 'Maisstärke',
      'pl': 'Skrobia kukurydziana',
      'ru': 'Кукурузный крахмал',
      'uk': 'Кукурудзяний крохмаль',
      'ko': '옥수수 전분',
      'zh': '玉米淀粉',
      'ja': 'コーンスターチ'
    }, {
      'id': 'CornmealItem',
      'en': 'Cornmeal',
      'fr': 'semoule de maïs',
      'es': 'Harina de maíz',
      'de': 'Mahlzeit mit Getreide',
      'pl': 'Mąka kukurydziana',
      'ru': 'Кукурузная мука',
      'uk': 'Кукурудзяне борошно',
      'ko': '옥수수 가루',
      'zh': '棒子面',
      'ja': 'コーンミール'
    }, {
      'id': 'CorrugatedSteelItem',
      'en': 'Corrugated Steel',
      'fr': 'Acier ondulé',
      'es': 'Acero corrugado',
      'de': 'Wellblech',
      'pl': 'Stal falista',
      'ru': 'Гофрированная сталь',
      'uk': 'Гофрована сталь',
      'ko': '골판지 강철',
      'zh': '波纹钢',
      'ja': '段ボール鋼'
    }, {
      'id': 'CorrugatedSteelDoorItem',
      'en': 'Corrugated Steel Door',
      'fr': 'Porte en acier ondulé',
      'es': 'Puerta de acero corrugado',
      'de': 'Wellblechtür',
      'pl': 'Drzwi ze stali falistej',
      'ru': 'Дверь из гофрированной стали',
      'uk': 'Гофровані сталеві двері',
      'ko': '골판지 강철 문',
      'zh': '波纹钢门',
      'ja': '段ボール鋼製ドア'
    }, {
      'id': 'CorrugatedSteelFenceDoorItem',
      'en': 'Corrugated Steel Fence Door',
      'fr': 'Porte de clôture en acier ondulé',
      'es': 'Puerta de valla de acero corrugado',
      'de': 'Gewellte Stahlzaun-Tür',
      'pl': 'Drzwi ogrodzeniowe ze stali falistej',
      'ru': 'Дверь забора из гофрированной стали',
      'uk': 'Двері з гофрованої сталі',
      'ko': '골판지 강철 울타리 문',
      'zh': '波纹钢栅栏门',
      'ja': '段ボール鋼製柵ドア'
    }, {
      'id': 'CottonBollItem',
      'en': 'Cotton Boll',
      'fr': 'Capsule de coton',
      'es': 'Cápsula de algodón',
      'de': 'Baumwollkapsel',
      'pl': 'Bawełna',
      'ru': 'Хлопковая коробочка',
      'uk': 'Бавовняна коробочка',
      'ko': '코튼 볼',
      'zh': '棉铃',
      'ja': 'コットンボール'
    }, {
      'id': 'CottonCarpetItem',
      'en': 'Cotton Carpet',
      'fr': 'Tapis en coton',
      'es': 'Alfombra de algodón',
      'de': 'Baumwollteppich',
      'pl': 'Dywan bawełniany',
      'ru': 'Хлопковый ковер',
      'uk': 'Бавовняний килим',
      'ko': '면 카펫',
      'zh': '棉地毯',
      'ja': 'コットンカーペット'
    }, {
      'id': 'CottonCurtainsItem',
      'en': 'Cotton Curtains',
      'fr': 'Rideaux en coton',
      'es': 'Cortinas de algodón',
      'de': 'Baumwollvorhänge',
      'pl': 'Zasłony bawełniane',
      'ru': 'Хлопковые шторы',
      'uk': 'Бавовняні штори',
      'ko': '면 커튼',
      'zh': '棉窗帘',
      'ja': '綿のカーテン'
    }, {
      'id': 'CottonFabricItem',
      'en': 'Cotton Fabric',
      'fr': 'Tissu en coton',
      'es': 'Tela de algodón',
      'de': 'Baumwollfabrik',
      'pl': 'Tkanina bawełniana',
      'ru': 'Хлопковая фабрика',
      'uk': 'Бавовняна тканина',
      'ko': '코튼 원단',
      'zh': '棉织物',
      'ja': '綿織物'
    }, {
      'id': 'CottonSeedItem',
      'en': 'Cotton Seed',
      'fr': 'Graine de coton',
      'es': 'Semilla de algodón',
      'de': 'Baumwollsaat',
      'pl': 'Nasiona bawełny',
      'ru': 'Семена хлопка',
      'uk': 'Насіння бавовни',
      'ko': '목화씨',
      'zh': '棉籽',
      'ja': '綿実'
    }, {
      'id': 'CottonThreadItem',
      'en': 'Cotton Thread',
      'fr': 'Fil de coton',
      'es': 'Hilo de algodón',
      'de': 'Baumwollfaden',
      'pl': 'Nici bawełniane',
      'ru': 'Хлопковая нить',
      'uk': 'Бавовняна нитка',
      'ko': '면사',
      'zh': '棉线',
      'ja': '綿糸'
    }, {
      'id': 'CouchItem',
      'en': 'Couch',
      'fr': 'Canapé',
      'es': 'Sofá',
      'de': 'Couch',
      'pl': 'Kanapa',
      'ru': 'Диван',
      'uk': 'Диван',
      'ko': '침상',
      'zh': '长椅',
      'ja': 'ソファー'
    }, {
      'id': 'CourtItem',
      'en': 'Court',
      'fr': 'Rechercher',
      'es': 'Tribunal',
      'de': 'Gericht',
      'pl': 'Sąd',
      'ru': 'Суд',
      'uk': 'суд',
      'ko': '법원',
      'zh': '法庭',
      'ja': '裁判所'
    }, {
      'id': 'CoyoteCarcassItem',
      'en': 'Coyote Carcass',
      'fr': 'Carcasse de coyote',
      'es': 'Cadáver de coyote',
      'de': 'Kojotenkadaver',
      'pl': 'Tusza kojota',
      'ru': 'Туша койота',
      'uk': 'Тушка койота',
      'ko': '코요테 시체',
      'zh': '土狼尸体',
      'ja': 'コヨーテの死骸'
    }, {
      'id': 'CrabCarcassItem',
      'en': 'Crab Carcass',
      'fr': 'Carcasse de crabe',
      'es': 'Canal de cangrejo',
      'de': 'Krabbenkadaver',
      'pl': 'Tusza kraba',
      'ru': 'Крабовая туша',
      'uk': 'Тушка краба',
      'ko': '게 사체',
      'zh': '蟹胴体',
      'ja': 'カニの死骸'
    }, {
      'id': 'CrabPotItem',
      'en': 'Crab Pot',
      'fr': 'Casserole de crabe',
      'es': 'olla de cangrejo',
      'de': 'Krabbentopf',
      'pl': 'Garnek z krabem',
      'ru': 'Крабовый горшок',
      'uk': 'Крабовий горщик',
      'ko': '게 냄비',
      'zh': '蟹锅',
      'ja': 'カニ鍋'
    }, {
      'id': 'Crafting Table',
      'en': 'Crafting Table',
      'fr': 'Table d\u0027artisanat',
      'es': 'Mesa de artesanía',
      'de': 'Basteltisch',
      'pl': 'Stół Rzemieślniczy',
      'ru': 'Верстак',
      'uk': 'Стіл для рукоділля',
      'ko': '공예 테이블',
      'zh': '工作台',
      'ja': 'クラフトテーブル'
    }, {
      'id': 'CraneItem',
      'en': 'Crane',
      'fr': 'Grue',
      'es': 'Grua',
      'de': 'Kran',
      'pl': 'Dźwig',
      'ru': 'кран',
      'uk': 'Журавель',
      'ko': '두루미',
      'zh': '起重机',
      'ja': 'クレーン'
    }, {
      'id': 'CreosoteBushSeedItem',
      'en': 'Creosote Bush Seed',
      'fr': 'Graine de brousse de créosote',
      'es': 'Semilla de arbusto de creosota',
      'de': 'Kreosot-Bush-Samen',
      'pl': 'Nasiona krzewu kreozotowego',
      'ru': 'Семена креозотового куста',
      'uk': 'Насіння куща креозоту',
      'ko': '크레오소트 부시 씨앗',
      'zh': '杂酚油灌木种子',
      'ja': 'クレオソートブッシュシード'
    }, {
      'id': 'CriminiMushroomSporesItem',
      'en': 'Crimini Mushroom Spores',
      'fr': 'Spores de champignons Crimini',
      'es': 'Esporas de Hongo Crimini',
      'de': 'Crimini-Pilzsporen',
      'pl': 'Zarodniki grzybów Crimini',
      'ru': 'Споры грибов кримини',
      'uk': 'Спори грибів Криміні',
      'ko': '크리미니 버섯 포자',
      'zh': '克里米尼蘑菇孢子',
      'ja': 'クリミニマッシュルーム胞子'
    }, {
      'id': 'CriminiMushroomsItem',
      'en': 'Crimini Mushrooms',
      'fr': 'Champignons Crimini',
      'es': 'Champiñones Crimini',
      'de': 'Crimini-Pilze',
      'pl': 'Crimini Grzyby',
      'ru': 'Грибы Кримини',
      'uk': 'Гриби Криміні',
      'ko': '크리미니 버섯',
      'zh': '克里米尼蘑菇',
      'ja': 'クリミニマッシュルーム'
    }, {
      'id': 'CrimsonSaladItem',
      'en': 'Crimson Salad',
      'fr': 'Salade Pourpre',
      'es': 'Ensalada Carmesí',
      'de': 'Purpurroter Salat',
      'pl': 'Sałatka Karmazynowa',
      'ru': 'Малиновый салат',
      'uk': 'Багряний салат',
      'ko': '크림슨 샐러드',
      'zh': '深红色沙拉',
      'ja': 'クリムゾンサラダ'
    }, {
      'id': 'CrispyBaconItem',
      'en': 'Crispy Bacon',
      'fr': 'Bacon croustillant',
      'es': 'Tocino crujiente',
      'de': 'Knuspriger Schinken',
      'pl': 'Chrupiący bekon',
      'ru': 'Хрустящий бекон',
      'uk': 'Хрусткий бекон',
      'ko': '바삭한 베이컨',
      'zh': '脆培根',
      'ja': 'クリスピーベーコン'
    }, {
      'id': 'Crop',
      'en': 'Crop',
      'fr': 'Recadrer',
      'es': 'Cultivo',
      'de': 'Ernte',
      'pl': 'Przyciąć',
      'ru': 'Обрезать',
      'uk': 'Урожай',
      'ko': '수확고',
      'zh': '庄稼',
      'ja': '作物'
    }, {
      'id': 'CropSeed',
      'en': 'Crop Seed',
      'fr': 'Graine de culture',
      'es': 'semilla de cultivo',
      'de': 'Saatgut ernten',
      'pl': 'Nasiona upraw',
      'ru': 'Семена урожая',
      'uk': 'Насіння культури',
      'ko': '작물 종자',
      'zh': '作物种子',
      'ja': '作物の種'
    }, {
      'id': 'CrushedBasaltItem',
      'en': 'Crushed Basalt',
      'fr': 'Basalte concassé',
      'es': 'Basalto triturado',
      'de': 'Zerkleinerter Basalt',
      'pl': 'kruszony bazalt',
      'ru': 'Базальтовый щебень',
      'uk': 'Подрібнений базальт',
      'ko': '으깬 현무암',
      'zh': '碎玄武岩',
      'ja': '砕いた玄武岩'
    }, {
      'id': 'CrushedCoalItem',
      'en': 'Crushed Coal',
      'fr': 'Charbon concassé',
      'es': 'carbón triturado',
      'de': 'Zerkleinerte Kohle',
      'pl': 'Kruszony Węgiel',
      'ru': 'Щебень Уголь',
      'uk': 'Подрібнене вугілля',
      'ko': '분쇄된 석탄',
      'zh': '碎煤',
      'ja': '砕いた石炭'
    }, {
      'id': 'CrushedCopperOreItem',
      'en': 'Crushed Copper Ore',
      'fr': 'Minerai de cuivre broyé',
      'es': 'Mineral de cobre triturado',
      'de': 'Zerkleinertes Kupfererz',
      'pl': 'Kruszona Ruda Miedzi',
      'ru': 'Дробленая медная руда',
      'uk': 'Подрібнена мідна руда',
      'ko': '분쇄된 구리 광석',
      'zh': '碎铜矿石',
      'ja': '砕いた銅鉱石'
    }, {
      'id': 'CrushedGneissItem',
      'en': 'Crushed Gneiss',
      'fr': 'Gneiss concassé',
      'es': 'Gneis triturado',
      'de': 'Zerkleinerter Gneis',
      'pl': 'Zmiażdżony Gnejs',
      'ru': 'Дробленый гнейс',
      'uk': 'Подрібнений гнейс',
      'ko': '으깬 편마암',
      'zh': '碎片麻岩',
      'ja': '砕いた片麻岩'
    }, {
      'id': 'CrushedGoldOreItem',
      'en': 'Crushed Gold Ore',
      'fr': 'Minerai d\u0027or broyé',
      'es': 'Mineral de oro triturado',
      'de': 'Zerkleinertes Golderz',
      'pl': 'Kruszona Ruda Złota',
      'ru': 'Дробленая золотая руда',
      'uk': 'Подрібнена золота руда',
      'ko': '으깬 금광석',
      'zh': '碎金矿石',
      'ja': '砕いた金鉱石'
    }, {
      'id': 'CrushedGraniteItem',
      'en': 'Crushed Granite',
      'fr': 'Granit concassé',
      'es': 'granito triturado',
      'de': 'Zerkleinerter Granit',
      'pl': 'Kruszony Granit',
      'ru': 'Дробленый гранит',
      'uk': 'Щебінь Гранітний',
      'ko': '분쇄된 화강암',
      'zh': '碎花岗岩',
      'ja': '砕いた花崗岩'
    }, {
      'id': 'CrushedIronOreItem',
      'en': 'Crushed Iron Ore',
      'fr': 'Minerai de fer broyé',
      'es': 'Mineral de hierro triturado',
      'de': 'Zerkleinertes Eisenerz',
      'pl': 'Kruszona Ruda Żelaza',
      'ru': 'Дробленая железная руда',
      'uk': 'Подрібнена залізна руда',
      'ko': '분쇄된 철광석',
      'zh': '碎铁矿石',
      'ja': '砕いた鉄鉱石'
    }, {
      'id': 'CrushedLimestoneItem',
      'en': 'Crushed Limestone',
      'fr': 'Calcaire concassé',
      'es': 'piedra caliza triturada',
      'de': 'Zerkleinerter Kalkstein',
      'pl': 'Kruszony Wapień',
      'ru': 'Известняковый щебень',
      'uk': 'Подрібнений вапняк',
      'ko': '분쇄된 석회암',
      'zh': '碎石灰石',
      'ja': '砕いた石灰岩'
    }, {
      'id': 'CrushedMixedRockItem',
      'en': 'Crushed Mixed Rock',
      'fr': 'Roche mixte concassée',
      'es': 'Roca mixta triturada',
      'de': 'Zerkleinertes gemischtes Gestein',
      'pl': 'Kruszony Mieszany Rock',
      'ru': 'Дробленый смешанный рок',
      'uk': 'Подрібнена змішана порода',
      'ko': '으깬 혼합 바위',
      'zh': '粉碎的混合岩石',
      'ja': '砕いたミックスロック'
    }, {
      'id': 'CrushedOilShaleItem',
      'en': 'Crushed Oil Shale',
      'fr': 'Schistes bitumineux broyés',
      'es': 'Esquisto bituminoso triturado',
      'de': 'Zerkleinerter Ölschiefer',
      'pl': 'Kruszony łupek naftowy',
      'ru': 'Измельченный горючий сланец',
      'uk': 'Подрібнений горючий сланець',
      'ko': '분쇄된 오일 셰일',
      'zh': '碎油页岩',
      'ja': '砕いたオイルシェール'
    }, {
      'id': 'CrushedRock',
      'en': 'Crushed Rock',
      'fr': 'Pierre concassée',
      'es': 'Roca triturada',
      'de': 'Zerkleinertes Gestein',
      'pl': 'Kruszona Skała',
      'ru': 'Дробленый камень',
      'uk': 'Щебінь',
      'ko': '으깬 바위',
      'zh': '碎石',
      'ja': '砕いた岩'
    }, {
      'id': 'CrushedSandstoneItem',
      'en': 'Crushed Sandstone',
      'fr': 'Grès concassé',
      'es': 'Arenisca triturada',
      'de': 'Zerkleinerter Sandstein',
      'pl': 'Kruszony Piaskowiec',
      'ru': 'Щебень песчаник',
      'uk': 'Щебінь піщаник',
      'ko': '분쇄된 사암',
      'zh': '碎砂岩',
      'ja': '砕いた砂岩'
    }, {
      'id': 'CrushedShaleItem',
      'en': 'Crushed Shale',
      'fr': 'Schiste concassé',
      'es': 'esquisto triturado',
      'de': 'Zerkleinerter Schiefer',
      'pl': 'Kruszony łupek',
      'ru': 'Дробленый сланец',
      'uk': 'Подрібнений сланец',
      'ko': '분쇄된 혈암',
      'zh': '碎页岩',
      'ja': '砕いた頁岩'
    }, {
      'id': 'CrushedSlagItem',
      'en': 'Crushed Slag',
      'fr': 'Laitier broyé',
      'es': 'Escoria triturada',
      'de': 'Zerkleinerte Schlacke',
      'pl': 'kruszony żużel',
      'ru': 'Дробленый шлак',
      'uk': 'Подрібнений шлак',
      'ko': '분쇄된 슬래그',
      'zh': '碎渣',
      'ja': '砕いたスラグ'
    }, {
      'id': 'CrushedStoneItem',
      'en': 'Crushed Stone',
      'fr': 'Pierre concassée',
      'es': 'Grava',
      'de': 'Schotter',
      'pl': 'Skruszony kamień',
      'ru': 'Разрушенный камень',
      'uk': 'Щебінь',
      'ko': '쇄석',
      'zh': '碎石',
      'ja': '砕石'
    }, {
      'id': 'CulinaryResearchPaperAdvancedItem',
      'en': 'Culinary Research Paper Advanced',
      'fr': 'Document de recherche culinaire avancé',
      'es': 'Trabajo de investigación culinaria avanzada',
      'de': 'Kulinarisches Forschungspapier für Fortgeschrittene',
      'pl': 'Zaawansowany artykuł do badań kulinarnych',
      'ru': 'Кулинарная исследовательская работа Advanced',
      'uk': 'Кулінарна наукова робота Advanced',
      'ko': '요리 연구 논문 고급',
      'zh': '烹饪研究论文高级',
      'ja': '料理研究論文Advanced'
    }, {
      'id': 'CulinaryResearchPaperBasicItem',
      'en': 'Culinary Research Paper Basic',
      'fr': 'Document de recherche culinaire de base',
      'es': 'Trabajo básico de investigación culinaria',
      'de': 'Kulinarisches Forschungspapier Basic',
      'pl': 'Artykuł do badań kulinarnych Basic',
      'ru': 'Кулинарная исследовательская работа Basic',
      'uk': 'Кулінарна наукова робота Basic',
      'ko': '요리연구논문 기초',
      'zh': '烹饪研究论文基础',
      'ja': '料理研究論文基本'
    }, {
      'id': 'CulinaryResearchPaperModernItem',
      'en': 'Culinary Research Paper Modern',
      'fr': 'Document de recherche culinaire moderne',
      'es': 'Documento de investigación culinaria moderno',
      'de': 'Kulinarisches Forschungspapier Modern',
      'pl': 'Artykuł do badań kulinarnych Nowoczesny',
      'ru': 'Кулинарная исследовательская работа Модерн',
      'uk': 'Кулінарні дослідження Сучасні',
      'ko': '요리 연구 논문 현대',
      'zh': '现代烹饪研究论文',
      'ja': '現代料理研究論文'
    }, {
      'id': 'CurrencyExchangeItem',
      'en': 'Currency Exchange',
      'fr': 'Échange de devises',
      'es': 'Cambio de divisas',
      'de': 'Geldwechsel',
      'pl': 'Wymiana walut',
      'ru': 'Обмен валюты',
      'uk': 'Обмін валюти',
      'ko': '환전소',
      'zh': '货币兑换',
      'ja': '為替'
    }, {
      'id': 'CuttingEdgeCookingUpgradeItem',
      'en': 'Cutting Edge Cooking Upgrade',
      'fr': 'Mise à niveau de cuisson de pointe',
      'es': 'Actualización de cocina de vanguardia',
      'de': 'Modernstes Koch-Upgrade',
      'pl': 'Najnowocześniejsze ulepszenie gotowania',
      'ru': 'Новейшее обновление кулинарии',
      'uk': 'Новітнє оновлення кулінарії',
      'ko': '최첨단 요리 업그레이드',
      'zh': '尖端烹饪升级',
      'ja': '最先端の料理のアップグレード'
    }, {
      'id': 'DeerCarcassItem',
      'en': 'Deer Carcass',
      'fr': 'Carcasse de cerf',
      'es': 'cadáver de venado',
      'de': 'Hirschkadaver',
      'pl': 'Tusza jelenia',
      'ru': 'Туша оленя',
      'uk': 'Тушка оленя',
      'ko': '사슴 시체',
      'zh': '鹿尸体',
      'ja': '鹿の死骸'
    }, {
      'id': 'DendrologyResearchPaperAdvancedItem',
      'en': 'Dendrology Research Paper Advanced',
      'fr': 'Document de recherche en dendrologie avancé',
      'es': 'Trabajo de investigación de dendrología avanzada',
      'de': 'Dendrologische Forschungsarbeit Fortgeschritten',
      'pl': 'Zaawansowany artykuł badawczy dendrologiczny',
      'ru': 'Дендрологическая исследовательская работа Advanced',
      'uk': 'Дослідницька робота з дендрології Advanced',
      'ko': '덴드롤로지 연구 논문 고급',
      'zh': '树木学研究论文高级',
      'ja': '樹木学研究論文Advanced'
    }, {
      'id': 'DendrologyResearchPaperBasicItem',
      'en': 'Dendrology Research Paper Basic',
      'fr': 'Document de recherche sur la dendrologie',
      'es': 'Documento de investigación de dendrología básico',
      'de': 'Dendrologisches Forschungspapier Basic',
      'pl': 'Podstawowy papier do badań dendrologicznych',
      'ru': 'Базовый исследовательский документ по дендрологии',
      'uk': 'Дендрологічна наукова робота Basic',
      'ko': '덴드로로지 연구논문 기초',
      'zh': '树木学研究论文基础',
      'ja': '樹木学研究論文基本'
    }, {
      'id': 'DendrologyResearchPaperModernItem',
      'en': 'Dendrology Research Paper Modern',
      'fr': 'Document de recherche sur la dendrologie moderne',
      'es': 'Documento de investigación de dendrología moderno',
      'de': 'Dendrologische Forschungsarbeit Modern',
      'pl': 'Nowoczesny papier do badań dendrologicznych',
      'ru': 'Дендрологическая исследовательская работа «Современный»',
      'uk': 'Дендрологічна наукова робота Сучасні',
      'ko': '덴드롤로지 연구 논문 모던',
      'zh': '现代树木学研究论文',
      'ja': '樹木学研究論文モダン'
    }, {
      'id': 'DerpyHatItem',
      'en': 'Derpy Hat',
      'fr': 'Chapeau Derpy',
      'es': 'Sombrero Derpy',
      'de': 'Derpy-Hut',
      'pl': 'Derpy kapelusz',
      'ru': 'Дерпи Шляпа',
      'uk': 'Капелюх Дерпі',
      'ko': '더피 모자',
      'zh': '小呆帽',
      'ja': 'ダーピーハット'
    }, {
      'id': 'DirtItem',
      'en': 'Dirt',
      'fr': 'Saleté',
      'es': 'Suciedad',
      'de': 'Schmutz',
      'pl': 'Brud',
      'ru': 'Грязь',
      'uk': 'Бруд',
      'ko': '흙',
      'zh': '污垢',
      'ja': '泥'
    }, {
      'id': 'DirtRampItem',
      'en': 'Dirt Ramp',
      'fr': 'Rampe de terre',
      'es': 'rampa de tierra',
      'de': 'Dirt-Rampe',
      'pl': 'Brudna rampa',
      'ru': 'Грязевая рампа',
      'uk': 'Брудова рампа',
      'ko': '더트 램프',
      'zh': '土坡道',
      'ja': 'ダートランプ'
    }, {
      'id': 'DistributionStationItem',
      'en': 'Distribution Station',
      'fr': 'Poste de distribution',
      'es': 'Estación de distribución',
      'de': 'Verteilerstation',
      'pl': 'Stacja dystrybucyjna',
      'ru': 'Распределительная станция',
      'uk': 'Розподільна станція',
      'ko': '유통 스테이션',
      'zh': '配送站',
      'ja': '配電所'
    }, {
      'id': 'DoorItem',
      'en': 'Door',
      'fr': 'Porte',
      'es': 'Puerta',
      'de': 'Tür',
      'pl': 'Drzwi',
      'ru': 'Дверь',
      'uk': 'двері',
      'ko': '문',
      'zh': '门',
      'ja': 'ドア'
    }, {
      'id': 'DumpsterCompostItem',
      'en': 'Dumpster Compost',
      'fr': 'Compost de benne',
      'es': 'Abono de basura',
      'de': 'Müllcontainer Kompost',
      'pl': 'Kompost na śmietnik',
      'ru': 'Мусорный Компост',
      'uk': 'Смітник Компост',
      'ko': '쓰레기통 퇴비',
      'zh': '垃圾箱堆肥',
      'ja': 'ゴミ容器堆肥'
    }, {
      'id': 'DumpsterGarbageItem',
      'en': 'Dumpster Garbage',
      'fr': 'Déchets de la benne',
      'es': 'basurero',
      'de': 'Müllcontainer',
      'pl': 'Śmieci na śmietnik',
      'ru': 'Мусор в мусорном баке',
      'uk': 'Смітник для сміття',
      'ko': '쓰레기 수거통',
      'zh': '垃圾箱垃圾',
      'ja': 'ゴミ箱のゴミ'
    }, {
      'id': 'DumpsterRecycleItem',
      'en': 'Dumpster Recycle',
      'fr': 'Recyclage de la benne',
      'es': 'Reciclaje de basureros',
      'de': 'Müllcontainer recyceln',
      'pl': 'Kosz na śmieci',
      'ru': 'Мусорный контейнер',
      'uk': 'Переробка смітника',
      'ko': '쓰레기 수거통 재활용',
      'zh': '垃圾箱回收',
      'ja': 'ゴミ箱のリサイクル'
    }, {
      'id': 'DwarfWillowSeedItem',
      'en': 'Dwarf Willow Seed',
      'fr': 'Graine de saule nain',
      'es': 'Semilla de sauce enano',
      'de': 'Zwergweidensamen',
      'pl': 'Nasiona wierzby karłowatej',
      'ru': 'Семя карликовой ивы',
      'uk': 'Насіння карликової верби',
      'ko': '드워프 버드나무 씨앗',
      'zh': '矮柳种子',
      'ja': 'ドワーフウィローシード'
    }, {
      'id': 'EaselItem',
      'en': 'Easel',
      'fr': 'Chevalet',
      'es': 'Caballete',
      'de': 'Staffelei',
      'pl': 'Sztaluga',
      'ru': 'Мольберт',
      'uk': 'Мольберт',
      'ko': '화가',
      'zh': '画架',
      'ja': 'イーゼル'
    }, {
      'id': 'EckoStatueItem',
      'en': 'Ecko Statue',
      'fr': 'Statuette d\u0027Ecko',
      'es': 'Estatua de Ecko',
      'de': 'Ecko-Statue',
      'pl': 'Posąg Ecko',
      'ru': 'Статуя Эко',
      'uk': 'Статуя Еко',
      'ko': '에코 동상',
      'zh': '埃科雕像',
      'ja': 'エッコ像'
    }, {
      'id': 'EckoTheDolphinItem',
      'en': 'Ecko The Dolphin',
      'fr': 'Ecko le dauphin',
      'es': 'Ecko el delfín',
      'de': 'Ecko der Delphin',
      'pl': 'Delfin Ecko',
      'ru': 'Эко Дельфин',
      'uk': 'Дельфін Еко',
      'ko': '에코 더 돌고래',
      'zh': '埃科海豚',
      'ja': 'Ecko The Dolphin'
    }, {
      'id': 'EcoylentItem',
      'en': 'Ecoylent',
      'fr': 'Ecoylent',
      'es': 'ecolent',
      'de': 'Ecoylent',
      'pl': 'Ecoylent',
      'ru': 'Экойлент',
      'uk': 'Екойлент',
      'ko': '에코일런트',
      'zh': '环保型',
      'ja': 'エコイレント'
    }, {
      'id': 'ElectricLatheItem',
      'en': 'Electric Lathe',
      'fr': 'Tour électrique',
      'es': 'torno electrico',
      'de': 'Elektrische Drehmaschine',
      'pl': 'Tokarka elektryczna',
      'ru': 'Электрический токарный станок',
      'uk': 'Електричний токарний верстат',
      'ko': '전동선반',
      'zh': '电动车床',
      'ja': '電気旋盤'
    }, {
      'id': 'ElectricMachinistTableItem',
      'en': 'Electric Machinist Table',
      'fr': 'Table de machiniste électrique',
      'es': 'Mesa de maquinista eléctrico',
      'de': 'Elektrischer Maschinistentisch',
      'pl': 'Elektryczny stół mechanika',
      'ru': 'Электромеханический стол',
      'uk': 'Стіл електричного машиніста',
      'ko': '전기 기계공 테이블',
      'zh': '电动机械师表',
      'ja': '電気機械工テーブル'
    }, {
      'id': 'ElectricMotorItem',
      'en': 'Electric Motor',
      'fr': 'Moteur électrique',
      'es': 'Motor eléctrico',
      'de': 'Elektromotor',
      'pl': 'Silnik elektryczny',
      'ru': 'Электродвигатель',
      'uk': 'Електричний двигун',
      'ko': '전기 모터',
      'zh': '电动马达',
      'ja': '電気モーター'
    }, {
      'id': 'ElectricPlanerItem',
      'en': 'Electric Planer',
      'fr': 'Rabot électrique',
      'es': 'Cepilladora eléctrica',
      'de': 'Elektrohobel',
      'pl': 'Strugarka elektryczna',
      'ru': 'Электрический рубанок',
      'uk': 'Електричний рубанок',
      'ko': '전기 대패',
      'zh': '电刨',
      'ja': '電気かんなな'
    }, {
      'id': 'ElectricStampingPressItem',
      'en': 'Electric Stamping Press',
      'fr': 'Presse à emboutir électrique',
      'es': 'Prensa de estampado eléctrica',
      'de': 'Elektrische Stanzpresse',
      'pl': 'Elektryczna prasa do tłoczenia',
      'ru': 'Электрический штамповочный пресс',
      'uk': 'Електричний штампувальний прес',
      'ko': '전기 스탬핑 프레스',
      'zh': '电动冲压机',
      'ja': '電気スタンピングプレス'
    }, {
      'id': 'ElectricWallLampItem',
      'en': 'Electric Wall Lamp',
      'fr': 'Applique murale électrique',
      'es': 'Lámpara de pared eléctrica',
      'de': 'Elektrische Wandleuchte',
      'pl': 'Elektryczna lampa ścienna',
      'ru': 'Электрическая настенная лампа',
      'uk': 'Електричний настінний світильник',
      'ko': '전기 벽 램프',
      'zh': '电动壁灯',
      'ja': '電気ウォールランプ'
    }, {
      'id': 'ElectricWaterPumpItem',
      'en': 'Electric Water Pump',
      'fr': 'Pompe à eau électrique',
      'es': 'Bomba de agua eléctrica',
      'de': 'Elektrische Wasserpumpe',
      'pl': 'Elektryczna pompa wodna',
      'ru': 'Электрический водяной насос',
      'uk': 'Електричний водяний насос',
      'ko': '전기 워터 펌프',
      'zh': '电动水泵',
      'ja': '電動送水ポンプ'
    }, {
      'id': 'ElectronicsAssemblyItem',
      'en': 'Electronics Assembly',
      'fr': 'Assemblage électronique',
      'es': 'Montaje de electrónica',
      'de': 'Elektronikmontage',
      'pl': 'Montaż elektroniki',
      'ru': 'Сборка электроники',
      'uk': 'Збірка електроніки',
      'ko': '전자제품 조립',
      'zh': '电子组装',
      'ja': 'エレクトロニクスアセンブリ'
    }, {
      'id': 'ElectronicsUpgradeItem',
      'en': 'Electronics Upgrade',
      'fr': 'Mise à niveau électronique',
      'es': 'Actualización de la electrónica',
      'de': 'Elektronik-Upgrade',
      'pl': 'Aktualizacja elektroniki',
      'ru': 'Модернизация электроники',
      'uk': 'Оновлення електроніки',
      'ko': '전자제품 업그레이드',
      'zh': '电子升级',
      'ja': 'エレクトロニクスのアップグレード'
    }, {
      'id': 'ElevatorCallPostItem',
      'en': 'Elevator Call Post',
      'fr': 'Poste d\u0027appel d\u0027ascenseur',
      'es': 'Puesto de llamada de ascensor',
      'de': 'Aufzugrufstelle',
      'pl': 'Winda Call Post',
      'ru': 'Сообщение вызова лифта',
      'uk': 'Пост виклику ліфта',
      'ko': '엘리베이터 호출 포스트',
      'zh': '电梯呼叫站',
      'ja': 'エレベーターコールポスト'
    }, {
      'id': 'ElkCarcassItem',
      'en': 'Elk Carcass',
      'fr': 'Carcasse d\u0027élan',
      'es': 'cadáver de alce',
      'de': 'Elch-Kadaver',
      'pl': 'Tusza łosia',
      'ru': 'Туша лося',
      'uk': 'Тушка лося',
      'ko': '엘크 시체',
      'zh': '麋鹿尸体',
      'ja': 'エルクカーカス'
    }, {
      'id': 'ElkMountItem',
      'en': 'Elk Mount',
      'fr': 'Mont Elk',
      'es': 'Monte alce',
      'de': 'Elchberg',
      'pl': 'Góra Łosia',
      'ru': 'Лось Маунт',
      'uk': 'Лосина гора',
      'ko': '엘크 마운트',
      'zh': '麋鹿山',
      'ja': 'エルクマウント'
    }, {
      'id': 'ElkSkypiercerItem',
      'en': 'Elk Skypiercer',
      'fr': 'Elk Skypiercer',
      'es': 'Alce perforacielos',
      'de': 'Elch Skypiercer',
      'pl': 'Ełk Skypiercer',
      'ru': 'Лось Скайпирсер',
      'uk': 'Лось Скайпірсер',
      'ko': '엘크 스카이피어서',
      'zh': '麋鹿空中列车',
      'ja': 'エルクスカイピアサー'
    }, {
      'id': 'ElkTacoItem',
      'en': 'Elk Taco',
      'fr': 'Taco au wapiti',
      'es': 'Taco de alce',
      'de': 'Elch-Taco',
      'pl': 'Ełk Taco',
      'ru': 'Лосиный тако',
      'uk': 'Лось тако',
      'ko': '엘크 타코',
      'zh': '麋鹿塔可',
      'ja': 'エルクタコス'
    }, {
      'id': 'ElkWellingtonItem',
      'en': 'Elk Wellington',
      'fr': 'Wapiti Wellington',
      'es': 'Alce Wellington',
      'de': 'Elch Wellington',
      'pl': 'Ełk Wellington',
      'ru': 'Лось Веллингтон',
      'uk': 'Лось Веллінгтон',
      'ko': '엘크 웰링턴',
      'zh': '麋鹿惠灵顿',
      'ja': 'エルクウェリントン'
    }, {
      'id': 'EngineeringResearchPaperAdvancedItem',
      'en': 'Engineering Research Paper Advanced',
      'fr': 'Document de recherche en ingénierie avancé',
      'es': 'Trabajo de investigación de ingeniería avanzado',
      'de': 'Technisches Forschungspapier für Fortgeschrittene',
      'pl': 'Zaawansowany papier badawczy inżynierski',
      'ru': 'Инженерно-исследовательская работа Advanced',
      'uk': 'Інженерно-дослідницька робота Advanced',
      'ko': '공학 연구 논문 고급',
      'zh': '工程研究论文高级',
      'ja': '工学研究論文Advanced'
    }, {
      'id': 'EngineeringResearchPaperModernItem',
      'en': 'Engineering Research Paper Modern',
      'fr': 'Document de recherche en ingénierie moderne',
      'es': 'Papel de investigación de ingeniería moderno',
      'de': 'Engineering Research Paper Modern',
      'pl': 'Nowoczesny papier do badań inżynierskich',
      'ru': 'Инженерно-исследовательская работа Модерн',
      'uk': 'Інженерно-дослідна робота Сучасні',
      'ko': '공학 연구 논문 현대',
      'zh': '现代工程研究论文',
      'ja': '現代工学研究論文'
    }, {
      'id': 'EpoxyItem',
      'en': 'Epoxy',
      'fr': 'Époxy',
      'es': 'Epoxy',
      'de': 'Epoxid',
      'pl': 'Żywica epoksydowa',
      'ru': 'Эпоксидная смола',
      'uk': 'Епоксидна смола',
      'ko': '에폭시',
      'zh': '环氧树脂',
      'ja': 'エポキシ'
    }, {
      'id': 'EthanolItem',
      'en': 'Ethanol',
      'fr': 'Éthanol',
      'es': 'Etanol',
      'de': 'Äthanol',
      'pl': 'Etanol',
      'ru': 'Этиловый спирт',
      'uk': 'етанол',
      'ko': '에탄올',
      'zh': '乙醇',
      'ja': 'エタノール'
    }, {
      'id': 'ExcavatorItem',
      'en': 'Excavator',
      'fr': 'Excavatrice',
      'es': 'Excavador',
      'de': 'Bagger',
      'pl': 'Koparka',
      'ru': 'Экскаватор',
      'uk': 'Екскаватор',
      'ko': '굴착기',
      'zh': '挖掘机',
      'ja': '掘削機'
    }, {
      'id': 'ExecutiveOfficeItem',
      'en': 'Executive Office',
      'fr': 'Bureau exécutif',
      'es': 'Oficina Ejecutiva',
      'de': 'Vorstandsbüro',
      'pl': 'Biuro Wykonawcze',
      'ru': 'Исполнительный офис',
      'uk': 'Виконавчий офіс',
      'ko': '행정실',
      'zh': '行政办公室',
      'ja': '事務局'
    }, {
      'id': 'ExplorerBeltItem',
      'en': 'Explorer Belt',
      'fr': 'Ceinture d\u0027explorateur',
      'es': 'Cinturón de explorador',
      'de': 'Explorer-Gürtel',
      'pl': 'Pas Odkrywcy',
      'ru': 'Пояс исследователя',
      'uk': 'Пояс дослідника',
      'ko': '탐험가 허리띠',
      'zh': '探险者腰带',
      'ja': 'エクスプローラーベルト'
    }, {
      'id': 'ExplorerBootsItem',
      'en': 'Explorer Boots',
      'fr': 'Bottes d\u0027explorateur',
      'es': 'Botas de explorador',
      'de': 'Explorer-Stiefel',
      'pl': 'Buty Odkrywcy',
      'ru': 'Ботинки исследователя',
      'uk': 'Черевики Explorer',
      'ko': '익스플로러 부츠',
      'zh': '探险者靴子',
      'ja': 'エクスプローラーブーツ'
    }, {
      'id': 'ExplorerGlovesItem',
      'en': 'Explorer Gloves',
      'fr': 'Gants d\u0027explorateur',
      'es': 'Guantes de explorador',
      'de': 'Explorer-Handschuhe',
      'pl': 'Rękawiczki Odkrywcy',
      'ru': 'Перчатки исследователя',
      'uk': 'Рукавички Explorer',
      'ko': '탐험가 장갑',
      'zh': '探险者手套',
      'ja': 'エクスプローラーグローブ'
    }, {
      'id': 'ExplorerHatItem',
      'en': 'Explorer Hat',
      'fr': 'Chapeau d\u0027explorateur',
      'es': 'Sombrero de explorador',
      'de': 'Explorer-Hut',
      'pl': 'Kapelusz Odkrywcy',
      'ru': 'Шляпа исследователя',
      'uk': 'Капелюх дослідника',
      'ko': '탐험가 모자',
      'zh': '探险者帽',
      'ja': 'エクスプローラーハット'
    }, {
      'id': 'ExplorerPantsItem',
      'en': 'Explorer Pants',
      'fr': 'Pantalon d\u0027explorateur',
      'es': 'Pantalones de explorador',
      'de': 'Explorer-Hose',
      'pl': 'Spodnie Odkrywcy',
      'ru': 'Брюки исследователя',
      'uk': 'Штани Explorer',
      'ko': '탐험가 바지',
      'zh': '探险家裤',
      'ja': 'エクスプローラーパンツ'
    }, {
      'id': 'ExplorerShirtItem',
      'en': 'Explorer Shirt',
      'fr': 'Chemise d\u0027explorateur',
      'es': 'Camisa de explorador',
      'de': 'Explorer-Shirt',
      'pl': 'Koszula Odkrywcy',
      'ru': 'Рубашка исследователя',
      'uk': 'Сорочка Explorer',
      'ko': '탐험가 셔츠',
      'zh': '探险者衬衫',
      'ja': 'エクスプローラーシャツ'
    }, {
      'id': 'Fabric',
      'en': 'Fabric',
      'fr': 'Tissu',
      'es': 'Tela',
      'de': 'Stoff',
      'pl': 'Tkanina',
      'ru': 'Ткань',
      'uk': 'Тканина',
      'ko': '구조',
      'zh': '织物',
      'ja': 'ファブリック'
    }, {
      'id': 'FantasticForestPizzaItem',
      'en': 'Fantastic Forest Pizza',
      'fr': 'Pizza fantastique de la forêt',
      'es': 'Fantástica pizza del bosque',
      'de': 'Fantastische Waldpizza',
      'pl': 'Fantastyczna Leśna Pizza',
      'ru': 'Фантастическая лесная пицца',
      'uk': 'Фантастична лісова піца',
      'ko': '판타스틱 포레스트 피자',
      'zh': '神奇的森林披萨',
      'ja': 'ファンタスティックフォレストピザ'
    }, {
      'id': 'FarmerBootsItem',
      'en': 'Farmer Boots',
      'fr': 'Bottes de fermier',
      'es': 'Botas de granjero',
      'de': 'Bauernstiefel',
      'pl': 'Buty Rolnika',
      'ru': 'Ботинки фермера',
      'uk': 'Фермерські чоботи',
      'ko': '농부 부츠',
      'zh': '农夫靴',
      'ja': 'ファーマーブーツ'
    }, {
      'id': 'FarmerGlovesItem',
      'en': 'Farmer Gloves',
      'fr': 'Gants de fermier',
      'es': 'Guantes de granjero',
      'de': 'Bauernhandschuhe',
      'pl': 'Rękawice rolnika',
      'ru': 'Фермерские перчатки',
      'uk': 'Фермерські рукавички',
      'ko': '농부 장갑',
      'zh': '农夫手套',
      'ja': 'ファーマーグローブ'
    }, {
      'id': 'FarmerHatItem',
      'en': 'Farmer Hat',
      'fr': 'Chapeau de fermier',
      'es': 'Sombrero de granjero',
      'de': 'Bauernhut',
      'pl': 'Kapelusz Rolnika',
      'ru': 'Шляпа фермера',
      'uk': 'Фермерський капелюх',
      'ko': '농부 모자',
      'zh': '农夫帽',
      'ja': 'ファーマーハット'
    }, {
      'id': 'FarmerOverallsItem',
      'en': 'Farmer Overalls',
      'fr': 'Salopette de fermier',
      'es': 'overoles de granjero',
      'de': 'Landwirt-Overalls',
      'pl': 'Kombinezon rolnika',
      'ru': 'Фермерский комбинезон',
      'uk': 'Фермерський комбінезон',
      'ko': '농부 작업복',
      'zh': '农民工装裤',
      'ja': 'ファーマーオーバーオール'
    }, {
      'id': 'FarmerShirtItem',
      'en': 'Farmer Shirt',
      'fr': 'Chemise de fermier',
      'es': 'Camisa de granjero',
      'de': 'Bauern-Shirt',
      'pl': 'Koszula Rolnika',
      'ru': 'Рубашка фермера',
      'uk': 'Фермерська сорочка',
      'ko': '농부 셔츠',
      'zh': '农夫衬衫',
      'ja': 'ファーマーシャツ'
    }, {
      'id': 'FarmersTableItem',
      'en': 'Farmers Table',
      'fr': 'Tableau des agriculteurs',
      'es': 'Mesa de agricultores',
      'de': 'Bauerntisch',
      'pl': 'Tabela rolników',
      'ru': 'Таблица фермеров',
      'uk': 'Фермерський стіл',
      'ko': '농부 테이블',
      'zh': '农民表',
      'ja': 'ファーマーズテーブル'
    }, {
      'id': 'FarmingUpgradeItem',
      'en': 'Farming Upgrade',
      'fr': 'Amélioration de l\u0027agriculture',
      'es': 'Mejora agrícola',
      'de': 'Landwirtschafts-Upgrade',
      'pl': 'Ulepszenie rolnictwa',
      'ru': 'Улучшение сельского хозяйства',
      'uk': 'Оновлення сільського господарства',
      'ko': '파밍 업그레이드',
      'zh': '农业升级',
      'ja': '農業のアップグレード'
    }, {
      'id': 'Fat',
      'en': 'Fat',
      'fr': 'Gros',
      'es': 'gordo',
      'de': 'Fett',
      'pl': 'Tłuszcz',
      'ru': 'Толстый',
      'uk': 'Жир',
      'ko': '지방',
      'zh': '胖的',
      'ja': '太い'
    }, {
      'id': 'FernCampfireSaladItem',
      'en': 'Fern Campfire Salad',
      'fr': 'Salade de feu de camp de fougère',
      'es': 'Ensalada de fogata de helecho',
      'de': 'Farn-Lagerfeuer-Salat',
      'pl': 'Sałatka z Ogniskiem Paproci',
      'ru': 'Салат из папоротника у костра',
      'uk': 'Салат з папороті',
      'ko': '고사리 모닥불 샐러드',
      'zh': '蕨类篝火沙拉',
      'ja': 'シダキャンプファイヤーサラダ'
    }, {
      'id': 'FernSporeItem',
      'en': 'Fern Spore',
      'fr': 'Spore de fougère',
      'es': 'Espora de helecho',
      'de': 'Farnspore',
      'pl': 'Zarodnik paproci',
      'ru': 'споры папоротника',
      'uk': 'Спор папороті',
      'ko': '고사리 포자',
      'zh': '蕨类孢子',
      'ja': 'シダの胞子'
    }, {
      'id': 'Fertilizer',
      'en': 'Fertilizer',
      'fr': 'Engrais',
      'es': 'Fertilizante',
      'de': 'Dünger',
      'pl': 'Nawóz',
      'ru': 'Удобрение',
      'uk': 'Добриво',
      'ko': '비료',
      'zh': '肥料',
      'ja': '肥料'
    }, {
      'id': 'FertilizerFiller',
      'en': 'Fertilizer Filler',
      'fr': 'Charge d\u0027engrais',
      'es': 'Llenadora de fertilizantes',
      'de': 'Düngemittelfüller',
      'pl': 'Wypełniacz nawozów',
      'ru': 'Наполнитель удобрений',
      'uk': 'Наповнювач добрив',
      'ko': '비료 필러',
      'zh': '肥料填料',
      'ja': '肥料フィラー'
    }, {
      'id': 'FertilizersUpgradeItem',
      'en': 'Fertilizers Upgrade',
      'fr': 'Amélioration des engrais',
      'es': 'Actualización de fertilizantes',
      'de': 'Düngemittel-Upgrade',
      'pl': 'Ulepszenie nawozów',
      'ru': 'Обновление удобрений',
      'uk': 'Оновлення добрив',
      'ko': '비료 업그레이드',
      'zh': '肥料升级',
      'ja': '肥料のアップグレード'
    }, {
      'id': 'FiberFillerItem',
      'en': 'Fiber Filler',
      'fr': 'Remplissage de fibres',
      'es': 'Relleno de fibra',
      'de': 'Faserfüller',
      'pl': 'Wypełniacz włóknisty',
      'ru': 'Волокнистый наполнитель',
      'uk': 'Волокнистий наповнювач',
      'ko': '섬유 충전재',
      'zh': '纤维填料',
      'ja': 'ファイバーフィラー'
    }, {
      'id': 'FiberglassItem',
      'en': 'Fiberglass',
      'fr': 'Fibre de verre',
      'es': 'Fibra de vidrio',
      'de': 'Fiberglas',
      'pl': 'Włókno szklane',
      'ru': 'Стекловолокно',
      'uk': 'Скловолокно',
      'ko': '유리 섬유',
      'zh': '玻璃纤维',
      'ja': 'グラスファイバー'
    }, {
      'id': 'FiddleheadsItem',
      'en': 'Fiddleheads',
      'fr': 'Têtes de violon',
      'es': 'cabezas de violín',
      'de': 'Fiddleheads',
      'pl': 'Skrzypkowie',
      'ru': 'Фиддлхеды',
      'uk': 'Fiddleheads',
      'ko': '피들헤드',
      'zh': '小提琴头',
      'ja': '渦巻き状若葉'
    }, {
      'id': 'FieldCampfireStewItem',
      'en': 'Field Campfire Stew',
      'fr': 'Ragoût de feu de camp',
      'es': 'Estofado de fogata de campo',
      'de': 'Eintopf am Lagerfeuer',
      'pl': 'Gulasz z Ogniska Polowego',
      'ru': 'Похлебка на полевом костре',
      'uk': 'Тушковане польове багаття',
      'ko': '필드 캠프파이어 스튜',
      'zh': '野营火炖菜',
      'ja': 'フィールドキャンプファイヤーシチュー'
    }, {
      'id': 'FilmyFernSporeItem',
      'en': 'Filmy Fern Spore',
      'fr': 'Spore de fougère vaporeuse',
      'es': 'Espora de helecho transparente',
      'de': 'Hauchdünne Farnspore',
      'pl': 'Filmy Paproć Zarodnik',
      'ru': 'Племенная спора папоротника',
      'uk': 'Плівкова спора папороті',
      'ko': '필름 같은 고사리 포자',
      'zh': '薄膜蕨孢子',
      'ja': 'フィルム状のシダの胞子'
    }, {
      'id': 'FirLogItem',
      'en': 'Fir Log',
      'fr': 'Bûche de sapin',
      'es': 'tronco de abeto',
      'de': 'Tannenprotokoll',
      'pl': 'Jodła Log',
      'ru': 'Еловое бревно',
      'uk': 'Ялиновий колод',
      'ko': '전나무 로그',
      'zh': '杉木原木',
      'ja': 'モミログ'
    }, {
      'id': 'FirSeedItem',
      'en': 'Fir Seed',
      'fr': 'Graine de sapin',
      'es': 'Semilla de abeto',
      'de': 'Tannensamen',
      'pl': 'Jodła Nasiona',
      'ru': 'Семя пихты',
      'uk': 'Насіння ялиці',
      'ko': '전나무 씨앗',
      'zh': '冷杉种子',
      'ja': 'モミの種'
    }, {
      'id': 'FireweedSeedItem',
      'en': 'Fireweed Seed',
      'fr': 'Graine d\u0027épilobe',
      'es': 'Semilla de hierba de fuego',
      'de': 'Fireweed-Samen',
      'pl': 'Nasiona Fireweed',
      'ru': 'Семя кипрея',
      'uk': 'Насіння вогневого водоросту',
      'ko': '파이어위드 씨',
      'zh': '杂草种子',
      'ja': 'ファイアウィードシード'
    }, {
      'id': 'FireweedShootsItem',
      'en': 'Fireweed Shoots',
      'fr': 'Pousses d\u0027épilobe',
      'es': 'brotes de hierba de fuego',
      'de': 'Weidenröschen schießt',
      'pl': 'Pędy Fireweed',
      'ru': 'Побеги кипрея',
      'uk': 'Пагони вогнища',
      'ko': '파이어위드 싹',
      'zh': '杂草芽',
      'ja': 'ヤナギランシュート'
    }, {
      'id': 'Fish',
      'en': 'Fish',
      'fr': 'Poisson',
      'es': 'Pez',
      'de': 'Fische',
      'pl': 'Ryba',
      'ru': 'Рыбы',
      'uk': 'риба',
      'ko': '생선',
      'zh': '鱼',
      'ja': '魚'
    }, {
      'id': 'FishNChipsItem',
      'en': 'Fish N Chips',
      'fr': 'Poisson et frites',
      'es': 'Pescado y patatas fritas',
      'de': 'Fisch und Pommes',
      'pl': 'Ryba z frytkami',
      'ru': 'Рыба и чипсы',
      'uk': 'Фіш-н-чіпси',
      'ko': '피쉬앤칩스',
      'zh': '炸鱼薯条',
      'ja': 'フィッシュアンドチップス'
    }, {
      'id': 'FishTrapItem',
      'en': 'Fish Trap',
      'fr': 'Piège à poisson',
      'es': 'Trampa para peces',
      'de': 'Fischfalle',
      'pl': 'Pułapka na ryby',
      'ru': 'Рыбная ловушка',
      'uk': 'Пастка для риби',
      'ko': '물고기 덫',
      'zh': '捕鱼器',
      'ja': 'フィッシュトラップ'
    }, {
      'id': 'FisheryItem',
      'en': 'Fishery',
      'fr': 'Pêcherie',
      'es': 'Pesquería',
      'de': 'Fischerei',
      'pl': 'Rybołówstwo',
      'ru': 'Рыболовство',
      'uk': 'Рибальство',
      'ko': '어업',
      'zh': '渔业',
      'ja': '水産'
    }, {
      'id': 'FlatSteelItem',
      'en': 'Flat Steel',
      'fr': 'Acier plat',
      'es': 'Acero plano',
      'de': 'Flachstahl',
      'pl': 'Płaska stal',
      'ru': 'Плоская сталь',
      'uk': 'Плоска сталь',
      'ko': '플랫 스틸',
      'zh': '扁钢',
      'ja': '平鋼'
    }, {
      'id': 'FlatSteelDoorItem',
      'en': 'Flat Steel Door',
      'fr': 'Porte en acier plat',
      'es': 'Puerta de acero plana',
      'de': 'Flache Stahltür',
      'pl': 'Płaskie drzwi stalowe',
      'ru': 'Плоская стальная дверь',
      'uk': 'Плоскі сталеві двері',
      'ko': '플랫 스틸 도어',
      'zh': '扁钢门',
      'ja': 'フラットスチールドア'
    }, {
      'id': 'FlatbreadItem',
      'en': 'Flatbread',
      'fr': 'Galette',
      'es': 'Pan plano',
      'de': 'Fladenbrot',
      'pl': 'Podpłomyk',
      'ru': 'Лепешка',
      'uk': 'лепешки',
      'ko': '플랫브레드',
      'zh': '大饼',
      'ja': 'フラットブレッド'
    }, {
      'id': 'FlourItem',
      'en': 'Flour',
      'fr': 'Farine',
      'es': 'Harina',
      'de': 'Mehl',
      'pl': 'Mąka',
      'ru': 'Мука',
      'uk': 'Борошно',
      'ko': '밀가루',
      'zh': '面粉',
      'ja': '小麦粉'
    }, {
      'id': 'Food',
      'en': 'Food',
      'fr': 'Aliments',
      'es': 'Alimento',
      'de': 'Essen',
      'pl': 'Żywność',
      'ru': 'Еда',
      'uk': 'Харчування',
      'ko': '음식',
      'zh': '食物',
      'ja': '食べ物'
    }, {
      'id': 'FoxCarcassItem',
      'en': 'Fox Carcass',
      'fr': 'Carcasse de renard',
      'es': 'carcasa de zorro',
      'de': 'Fuchskadaver',
      'pl': 'Tusza lisa',
      'ru': 'Тушка лисы',
      'uk': 'Тушка лисиці',
      'ko': '여우 시체',
      'zh': '狐狸尸体',
      'ja': 'キツネの死骸'
    }, {
      'id': 'FramedGlassItem',
      'en': 'Framed Glass',
      'fr': 'Verre encadré',
      'es': 'Vidrio enmarcado',
      'de': 'Gerahmtes Glas',
      'pl': 'Oprawione szkło',
      'ru': 'Стекло в рамке',
      'uk': 'Скло в рамці',
      'ko': '액자 유리',
      'zh': '框架玻璃',
      'ja': '額入りガラス'
    }, {
      'id': 'FramedGlassDoorItem',
      'en': 'Framed Glass Door',
      'fr': 'Porte en verre encadrée',
      'es': 'puerta de vidrio enmarcada',
      'de': 'Gerahmte Glastür',
      'pl': 'Oprawione szklane drzwi',
      'ru': 'Стеклянная дверь в рамке',
      'uk': 'Скляні двері в рамці',
      'ko': '액자 유리 도어',
      'zh': '框架玻璃门',
      'ja': '額入りガラスドア'
    }, {
      'id': 'FriedCamasItem',
      'en': 'Fried Camas',
      'fr': 'Camas frits',
      'es': 'Camas Fritas',
      'de': 'Gebratene Camas',
      'pl': 'smażone kamasze',
      'ru': 'Жареный Камас',
      'uk': 'Смажений Камас',
      'ko': '튀긴 카마스',
      'zh': '炸卡马斯',
      'ja': '揚げキャマス'
    }, {
      'id': 'FriedFiddleheadsItem',
      'en': 'Fried Fiddleheads',
      'fr': 'Têtes de violon frites',
      'es': 'Cabezas de violín fritas',
      'de': 'Gebratene Fiddleheads',
      'pl': 'Smażone Fiddleheads',
      'ru': 'Жареные Фиддлхеды',
      'uk': 'Смажені Фіддлхеси',
      'ko': '튀긴 피들 헤드',
      'zh': '炸蕨菜',
      'ja': '揚げ渦巻き状若葉'
    }, {
      'id': 'FriedHareHaunchesItem',
      'en': 'Fried Hare Haunches',
      'fr': 'Cuissots de lièvre frits',
      'es': 'Ancas de liebre fritas',
      'de': 'Gebratene Hasenkeulen',
      'pl': 'Smażony Udziec Zająca',
      'ru': 'Жареные заячьи бедра',
      'uk': 'Смажені заячі горби',
      'ko': '튀긴 토끼',
      'zh': '炸兔腿',
      'ja': 'フライドヘアハンチ'
    }, {
      'id': 'FriedHeartsOfPalmItem',
      'en': 'Fried Hearts Of Palm',
      'fr': 'Coeurs de palmier frits',
      'es': 'Corazones De Palm Fritos',
      'de': 'Gebratene Palmenherzen',
      'pl': 'Smażone Serca Palmowe',
      'ru': 'Жареные сердца пальмы',
      'uk': 'Смажені пальмові серця',
      'ko': '튀긴 하트 오브 팜',
      'zh': '油炸棕榈心',
      'ja': '手のひらの揚げハート'
    }, {
      'id': 'FriedTaroItem',
      'en': 'Fried Taro',
      'fr': 'Taro frit',
      'es': 'Taro Frito',
      'de': 'Gebratener Taro',
      'pl': 'Smażony Taro',
      'ru': 'Жареное Таро',
      'uk': 'Смажене Таро',
      'ko': '튀긴 타로',
      'zh': '炸芋头',
      'ja': '揚げ太郎'
    }, {
      'id': 'FriedTomatoesItem',
      'en': 'Fried Tomatoes',
      'fr': 'Tomates Frites',
      'es': 'tomates fritos',
      'de': 'Gebratene Tomaten',
      'pl': 'Smażone Pomidory',
      'ru': 'Жареные помидоры',
      'uk': 'Смажені помідори',
      'ko': '튀긴 토마토',
      'zh': '炸番茄',
      'ja': '揚げトマト'
    }, {
      'id': 'FriedVegetable',
      'en': 'Fried Vegetable',
      'fr': 'Légumes frits',
      'es': 'Verdura Frita',
      'de': 'Gebratenes Gemüse',
      'pl': 'Smażone Warzywa',
      'ru': 'Жареный овощ',
      'uk': 'Смажений овоч',
      'ko': '튀긴 야채',
      'zh': '炒蔬菜',
      'ja': '揚げ野菜'
    }, {
      'id': 'FriedVegetablesItem',
      'en': 'Fried Vegetables',
      'fr': 'Légumes frits',
      'es': 'Verduras fritas',
      'de': 'Gebratenes Gemüse',
      'pl': 'Smażone warzywa',
      'ru': 'Жареные овощи',
      'uk': 'Смажені овочі',
      'ko': '튀긴 야채',
      'zh': '炒蔬菜',
      'ja': '揚げ野菜'
    }, {
      'id': 'FrothFloatationCellItem',
      'en': 'Froth Floatation Cell',
      'fr': 'Cellule de flottation de mousse',
      'es': 'Celda de flotación de espuma',
      'de': 'Schaumflotationszelle',
      'pl': 'Komórka flotacyjna piany',
      'ru': 'Ячейка пенной флотации',
      'uk': 'Піна флотаційна комірка',
      'ko': '거품 부유 셀',
      'zh': '泡沫浮选池',
      'ja': '泡浮選セル'
    }, {
      'id': 'Fruit',
      'en': 'Fruit',
      'fr': 'Fruit',
      'es': 'Fruta',
      'de': 'Obst',
      'pl': 'Owoc',
      'ru': 'Фрукты',
      'uk': 'Фрукти',
      'ko': '과일',
      'zh': '水果',
      'ja': 'フルーツ'
    }, {
      'id': 'FruitMuffinItem',
      'en': 'Fruit Muffin',
      'fr': 'Muffin aux fruits',
      'es': 'Magdalena de frutas',
      'de': 'Frucht-Muffin',
      'pl': 'babeczka owocowa',
      'ru': 'Фруктовый кекс',
      'uk': 'Фруктовий мафін',
      'ko': '과일 머핀',
      'zh': '水果松饼',
      'ja': 'フルーツマフィン'
    }, {
      'id': 'FruitSaladItem',
      'en': 'Fruit Salad',
      'fr': 'Salade de fruit',
      'es': 'Ensalada de frutas',
      'de': 'Fruchtsalat',
      'pl': 'Sałatka owocowa',
      'ru': 'Фруктовый салат',
      'uk': 'Фруктовий салат',
      'ko': '과일 샐러드',
      'zh': '水果沙拉',
      'ja': 'フルーツサラダ'
    }, {
      'id': 'FruitTartItem',
      'en': 'Fruit Tart',
      'fr': 'Tarte aux fruits',
      'es': 'Pastel de fruta',
      'de': 'Obstkuchen',
      'pl': 'tarta owocowa',
      'ru': 'Фруктовый пирог',
      'uk': 'Фруктовий тарт',
      'ko': '과일 타르트',
      'zh': '水果挞',
      'ja': 'フルーツタルト'
    }, {
      'id': 'Fuel',
      'en': 'Fuel',
      'fr': 'Le carburant',
      'es': 'Combustible',
      'de': 'Treibstoff',
      'pl': 'Paliwo',
      'ru': 'Топливо',
      'uk': 'Паливо',
      'ko': '연료',
      'zh': '汽油',
      'ja': '燃料'
    }, {
      'id': 'Fungus',
      'en': 'Fungus',
      'fr': 'Champignon',
      'es': 'Hongo',
      'de': 'Pilz',
      'pl': 'Grzyb',
      'ru': 'Грибок',
      'uk': 'Грибок',
      'ko': '진균류',
      'zh': '菌',
      'ja': '真菌'
    }, {
      'id': 'FurPeltItem',
      'en': 'Fur Pelt',
      'fr': 'Peau de fourrure',
      'es': 'Piel de piel',
      'de': 'Fell',
      'pl': 'Futro',
      'ru': 'Меховая шкура',
      'uk': 'Хутряна шкіра',
      'ko': '모피 펠트',
      'zh': '毛皮',
      'ja': 'ファーペルト'
    }, {
      'id': 'GardenBootsItem',
      'en': 'Garden Boots',
      'fr': 'Bottes de jardin',
      'es': 'Botas de jardín',
      'de': 'Gartenstiefel',
      'pl': 'Buty ogrodowe',
      'ru': 'Садовые сапоги',
      'uk': 'Садові чоботи',
      'ko': '가든 부츠',
      'zh': '花园靴',
      'ja': 'ガーデンブーツ'
    }, {
      'id': 'GasolineItem',
      'en': 'Gasoline',
      'fr': 'De l\u0027essence',
      'es': 'Gasolina',
      'de': 'Benzin',
      'pl': 'Benzyna',
      'ru': 'Бензин',
      'uk': 'Бензин',
      'ko': '가솔린',
      'zh': '汽油',
      'ja': 'ガソリン'
    }, {
      'id': 'GatheringResearchPaperBasicItem',
      'en': 'Gathering Research Paper Basic',
      'fr': 'Collecte de documents de recherche de base',
      'es': 'Recopilación de trabajos de investigación básicos',
      'de': 'Sammeln von Forschungspapieren Basic',
      'pl': 'Zbieranie podstawowego papieru badawczego',
      'ru': 'Сбор исследовательской работы Базовый',
      'uk': 'Збір наукової роботи Basic',
      'ko': '연구논문 기초수집',
      'zh': '收集研究论文基础',
      'ja': '研究論文の基本'
    }, {
      'id': 'GearboxItem',
      'en': 'Gearbox',
      'fr': 'Boîte de vitesses',
      'es': 'Caja de cambios',
      'de': 'Getriebe',
      'pl': 'Skrzynia biegów',
      'ru': 'Коробка передач',
      'uk': 'Коробка передач',
      'ko': '변속 장치',
      'zh': '变速箱',
      'ja': 'ギアボックス'
    }, {
      'id': 'GeologyResearchPaperAdvancedItem',
      'en': 'Geology Research Paper Advanced',
      'fr': 'Document de recherche en géologie avancé',
      'es': 'Trabajo de investigación de geología avanzada',
      'de': 'Geologisches Forschungspapier für Fortgeschrittene',
      'pl': 'Zaawansowany artykuł badawczy z zakresu geologii',
      'ru': 'Исследовательская работа по геологии Advanced',
      'uk': 'Геологічна наукова робота Advanced',
      'ko': '지질학 연구 논문 고급',
      'zh': '地质研究论文高级',
      'ja': '地質学研究論文Advanced'
    }, {
      'id': 'GeologyResearchPaperBasicItem',
      'en': 'Geology Research Paper Basic',
      'fr': 'Document de recherche en géologie de base',
      'es': 'Trabajo de investigación de geología básico',
      'de': 'Geologisches Forschungspapier Basic',
      'pl': 'Podstawowy artykuł badawczy z geologii',
      'ru': 'Базовая исследовательская работа по геологии',
      'uk': 'Геологічна наукова робота Basic',
      'ko': '지질학 연구논문 기초',
      'zh': '地质研究论文基础',
      'ja': '地質学研究論文基本'
    }, {
      'id': 'GeologyResearchPaperModernItem',
      'en': 'Geology Research Paper Modern',
      'fr': 'Document de recherche en géologie moderne',
      'es': 'Papel de investigación de geología moderno',
      'de': 'Geologische Forschungsarbeit Modern',
      'pl': 'Współczesna praca naukowa z zakresu geologii',
      'ru': 'Геологическая исследовательская работа Модерн',
      'uk': 'Наукова робота з геології Сучасний',
      'ko': '지질학 연구 논문 현대',
      'zh': '地质研究论文现代',
      'ja': '地質学研究論文モダン'
    }, {
      'id': 'GiantCactusFruitItem',
      'en': 'Giant Cactus Fruit',
      'fr': 'Fruit de cactus géant',
      'es': 'Fruta de cactus gigante',
      'de': 'Riesige Kaktusfrucht',
      'pl': 'Owoc Olbrzymiego Kaktusa',
      'ru': 'Гигантский плод кактуса',
      'uk': 'Гігантські плоди кактуса',
      'ko': '거대한 선인장 열매',
      'zh': '巨型仙人掌果实',
      'ja': 'ジャイアントサボテンフルーツ'
    }, {
      'id': 'GigotSleeveShirtItem',
      'en': 'Gigot Sleeve Shirt',
      'fr': 'Chemise à manches Gigot',
      'es': 'Camisa de manga Gigot',
      'de': 'Hemd mit Gigot-Ärmeln',
      'pl': 'Koszula z rękawami Gigot',
      'ru': 'Рубашка с рукавами Gigot',
      'uk': 'Сорочка з рукавом Gigot',
      'ko': '지고트 슬리브 셔츠',
      'zh': 'Gigot 袖衬衫',
      'ja': 'ギゴットスリーブシャツ'
    }, {
      'id': 'GlassItem',
      'en': 'Glass',
      'fr': 'Verre',
      'es': 'Vidrio',
      'de': 'Glas',
      'pl': 'Szkło',
      'ru': 'Стакан',
      'uk': 'Скло',
      'ko': '유리',
      'zh': '玻璃',
      'ja': 'ガラス'
    }, {
      'id': 'GlassworkingAdvancedUpgradeItem',
      'en': 'Glassworking Advanced Upgrade',
      'fr': 'Mise à niveau avancée du travail du verre',
      'es': 'Actualización avanzada de cristalería',
      'de': 'Erweitertes Upgrade für die Glasbearbeitung',
      'pl': 'Zaawansowana modernizacja obróbki szkła',
      'ru': 'Расширенное обновление стеклообработки',
      'uk': 'Розширене оновлення скла',
      'ko': '유리세공 고급 업그레이드',
      'zh': '玻璃加工高级升级',
      'ja': 'Glassworking Advanced Upgrade'
    }, {
      'id': 'GlassworkingModernUpgradeItem',
      'en': 'Glassworking Modern Upgrade',
      'fr': 'Mise à niveau moderne du travail du verre',
      'es': 'Actualización moderna de cristalería',
      'de': 'Glasverarbeitung Modernes Upgrade',
      'pl': 'Nowoczesna modernizacja obróbki szkła',
      'ru': 'Стеклообработка Современное обновление',
      'uk': 'Сучасне оновлення склообробки',
      'ko': '유리세공 모던 업그레이드',
      'zh': '玻璃加工现代升级',
      'ja': 'Glassworkingモダンアップグレード'
    }, {
      'id': 'GneissItem',
      'en': 'Gneiss',
      'fr': 'Gneiss',
      'es': 'Gneis',
      'de': 'Gneis',
      'pl': 'Gnejs',
      'ru': 'гнейс',
      'uk': 'гнейс',
      'ko': '편마암',
      'zh': '片麻岩',
      'ja': '片麻岩'
    }, {
      'id': 'GoatMountItem',
      'en': 'Goat Mount',
      'fr': 'Monture de chèvre',
      'es': 'Monte Cabra',
      'de': 'Ziegenberg',
      'pl': 'Koza Góra',
      'ru': 'Козья гора',
      'uk': 'Козячий гора',
      'ko': '염소 산',
      'zh': '山羊山',
      'ja': 'ヤギの山'
    }, {
      'id': 'GoldBarItem',
      'en': 'Gold Bar',
      'fr': 'Lingot d\u0027or',
      'es': 'Barra de oro',
      'de': 'Goldbarren',
      'pl': 'Sztabka złota',
      'ru': 'Золотой слиток',
      'uk': 'Золотий бар',
      'ko': '골드 바',
      'zh': '金条',
      'ja': 'ゴールドバー'
    }, {
      'id': 'GoldConcentrateItem',
      'en': 'Gold Concentrate',
      'fr': 'Concentré d\u0027or',
      'es': 'concentrado de oro',
      'de': 'Goldkonzentrat',
      'pl': 'Złoty Koncentrat',
      'ru': 'Золотой концентрат',
      'uk': 'Золотий концентрат',
      'ko': '금 농축액',
      'zh': '金精矿',
      'ja': '金精鉱'
    }, {
      'id': 'GoldFlakesItem',
      'en': 'Gold Flakes',
      'fr': 'Paillettes d\u0027or',
      'es': 'Copos de oro',
      'de': 'Goldflocken',
      'pl': 'Złote płatki',
      'ru': 'Золотые хлопья',
      'uk': 'Золоті пластівці',
      'ko': '골드 플레이크',
      'zh': '金箔',
      'ja': 'ゴールドフレーク'
    }, {
      'id': 'GoldOreItem',
      'en': 'Gold Ore',
      'fr': 'Le minerai d\u0027or',
      'es': 'Metal de oro',
      'de': 'Golderz',
      'pl': 'Ruda złota',
      'ru': 'Золотая руда',
      'uk': 'Золота руда',
      'ko': '금 광석',
      'zh': '金矿',
      'ja': '金鉱石'
    }, {
      'id': 'GoldWiringItem',
      'en': 'Gold Wiring',
      'fr': 'Câblage doré',
      'es': 'Cableado de oro',
      'de': 'Goldverdrahtung',
      'pl': 'Złote okablowanie',
      'ru': 'Золотая проводка',
      'uk': 'Золота проводка',
      'ko': '금 배선',
      'zh': '金线',
      'ja': 'ゴールド配線'
    }, {
      'id': 'GovernmentOfficeItem',
      'en': 'Government Office',
      'fr': 'Bureau du gouvernement',
      'es': 'Oficina gubernamental',
      'de': 'Regierungsbüro',
      'pl': 'Biuro rządu',
      'ru': 'Государственное учреждение',
      'uk': 'Урядова канцелярія',
      'ko': '관공서',
      'zh': '政府办公室',
      'ja': '官公庁'
    }, {
      'id': 'Grain',
      'en': 'Grain',
      'fr': 'Grain',
      'es': 'Grano',
      'de': 'Getreide',
      'pl': 'Ziarno',
      'ru': 'Зерно',
      'uk': 'Зернові',
      'ko': '곡물',
      'zh': '粮食',
      'ja': '粒'
    }, {
      'id': 'GraniteItem',
      'en': 'Granite',
      'fr': 'Granit',
      'es': 'Granito',
      'de': 'Granit',
      'pl': 'Granit',
      'ru': 'Гранит',
      'uk': 'Граніт',
      'ko': '화강암',
      'zh': '花岗岩',
      'ja': '花崗岩'
    }, {
      'id': 'GrassSeedItem',
      'en': 'Grass Seed',
      'fr': 'Semences de gazon',
      'es': 'Semilla de pasto',
      'de': 'Grassamen',
      'pl': 'Nasiona Trawy',
      'ru': 'Семя травы',
      'uk': 'Насіння трави',
      'ko': '잔디 씨앗',
      'zh': '草种',
      'ja': '草の種'
    }, {
      'id': 'Greens',
      'en': 'Greens',
      'fr': 'Légumes verts',
      'es': 'Verduras',
      'de': 'Grüne',
      'pl': 'Warzywa',
      'ru': 'Зелень',
      'uk': 'Зелень',
      'ko': '푸성귀',
      'zh': '青菜',
      'ja': 'グリーンズ'
    }, {
      'id': 'HandPlowItem',
      'en': 'Hand Plow',
      'fr': 'Charrue à main',
      'es': 'Arado de mano',
      'de': 'Handpflug',
      'pl': 'Pług ręczny',
      'ru': 'Ручной плуг',
      'uk': 'Ручний плуг',
      'ko': '손 쟁기',
      'zh': '手犁',
      'ja': 'ハンドプラウ'
    }, {
      'id': 'HangingLongSteelSignItem',
      'en': 'Hanging Long Steel Sign',
      'fr': 'Long signe en acier suspendu',
      'es': 'Letrero colgante de acero largo',
      'de': 'Hängendes langes Stahlschild',
      'pl': 'Wiszący długi znak ze stali',
      'ru': 'Подвесной длинный стальной знак',
      'uk': 'Висяча довга сталь знак',
      'ko': '교수형 긴 강철 기호',
      'zh': '悬挂长钢标志',
      'ja': '長い鋼の看板をぶら下げ'
    }, {
      'id': 'HangingSteelFramedSignItem',
      'en': 'Hanging Steel Framed Sign',
      'fr': 'Enseigne suspendue en acier',
      'es': 'Letrero colgante con marco de acero',
      'de': 'Schild zum Aufhängen mit Stahlrahmen',
      'pl': 'Wiszący znak ze stalową ramą',
      'ru': 'Подвесной стальной каркасный знак',
      'uk': 'Висячі сталевий каркас знак',
      'ko': '교수형 강철 액자 기호',
      'zh': '悬挂钢架标志',
      'ja': 'ぶら下げ鉄骨看板'
    }, {
      'id': 'HangingSteelMineSignItem',
      'en': 'Hanging Steel Mine Sign',
      'fr': 'Signe de mine d\u0027acier suspendu',
      'es': 'Letrero colgante de mina de acero',
      'de': 'Hängendes Stahlbergwerk-Schild',
      'pl': 'Wiszący znak kopalni stali',
      'ru': 'Подвесной стальной знак шахты',
      'uk': 'Знак висячої сталі міни',
      'ko': '교수형 철강 광산 기호',
      'zh': '悬挂钢矿标志',
      'ja': 'ぶら下がっている鋼鉱山の看板'
    }, {
      'id': 'HangingSteelPlainSignItem',
      'en': 'Hanging Steel Plain Sign',
      'fr': 'Signe uni en acier suspendu',
      'es': 'Letrero simple de acero colgante',
      'de': 'Schild zum Aufhängen aus Stahl',
      'pl': 'Wiszący zwykły znak ze stali',
      'ru': 'Подвесной стальной простой знак',
      'uk': 'Висячі сталевий простий знак',
      'ko': '교수형 강철 일반 기호',
      'zh': '挂钢平原标志',
      'ja': 'ぶら下がっている鋼のプレーンサイン'
    }, {
      'id': 'HangingSteelShopSignItem',
      'en': 'Hanging Steel Shop Sign',
      'fr': 'Enseigne de magasin en acier suspendue',
      'es': 'Letrero de tienda de acero colgante',
      'de': 'Hängendes Ladenschild aus Stahl',
      'pl': 'Wiszący znak sklepu ze stali',
      'ru': 'Висячий стальной знак магазина',
      'uk': 'Висить сталевий магазин знак',
      'ko': '교수형 철강 상점 기호',
      'zh': '挂钢店招牌',
      'ja': 'ぶら下がっている鉄鋼店の看板'
    }, {
      'id': 'Hardwood',
      'en': 'Hardwood',
      'fr': 'Bois franc',
      'es': 'Madera dura',
      'de': 'Hartholz',
      'pl': 'Drewno liściaste',
      'ru': 'лиственных пород',
      'uk': 'Листяні породи',
      'ko': '견목',
      'zh': '硬木',
      'ja': '広葉樹'
    }, {
      'id': 'HardyBeardItem',
      'en': 'Hardy Beard',
      'fr': 'Barbe robuste',
      'es': 'Barba resistente',
      'de': 'Robuster Bart',
      'pl': 'Hardy Broda',
      'ru': 'Харди Борода',
      'uk': 'Витривала Борода',
      'ko': '하디 비어드',
      'zh': '哈迪胡子',
      'ja': 'ハーディビアード'
    }, {
      'id': 'HareCarcassItem',
      'en': 'Hare Carcass',
      'fr': 'Carcasse de lièvre',
      'es': 'Canal de liebre',
      'de': 'Hasenkadaver',
      'pl': 'Tusza zająca',
      'ru': 'Заячья туша',
      'uk': 'Тушка зайця',
      'ko': '토끼 시체',
      'zh': '野兔尸体',
      'ja': 'うさぎの死骸'
    }, {
      'id': 'HeartOfPalmItem',
      'en': 'Heart Of Palm',
      'fr': 'Coeur de palmier',
      'es': 'Palmito',
      'de': 'Herz der Palme',
      'pl': 'Serce palmy',
      'ru': 'Сердце пальмы',
      'uk': 'Серце пальми',
      'ko': '하트 오브 팜',
      'zh': '棕榈之心',
      'ja': 'ハートオブパーム'
    }, {
      'id': 'HeartyHometownPizzaItem',
      'en': 'Hearty Hometown Pizza',
      'fr': 'Pizza copieuse de la ville natale',
      'es': 'Pizza abundante de la ciudad natal',
      'de': 'Herzhafte Pizza aus der Heimatstadt',
      'pl': 'Obfita rodzinna pizza',
      'ru': 'Сытная пицца в родном городе',
      'uk': 'Сердечна піца рідного міста',
      'ko': '푸짐한 고향 피자',
      'zh': '丰盛的家乡披萨',
      'ja': '心のこもった故郷のピザ'
    }, {
      'id': 'HeatSinkItem',
      'en': 'Heat Sink',
      'fr': 'Dissipateur de chaleur',
      'es': 'Disipador de calor',
      'de': 'Kühlkörper',
      'pl': 'Radiator',
      'ru': 'Радиатор',
      'uk': 'Тепловідвід',
      'ko': '방열판',
      'zh': '散热器',
      'ja': 'ヒートシンク'
    }, {
      'id': 'HeliconiaSeedItem',
      'en': 'Heliconia Seed',
      'fr': 'Graine d\u0027héliconia',
      'es': 'Semilla de Heliconia',
      'de': 'Heliconia-Samen',
      'pl': 'Nasiona Heliconia',
      'ru': 'Семя геликонии',
      'uk': 'Насіння геліконії',
      'ko': '헬리코니아 씨앗',
      'zh': '葫芦科种子',
      'ja': 'ヘリコニアシード'
    }, {
      'id': 'HenleyItem',
      'en': 'Henley',
      'fr': 'Henley',
      'es': 'henley',
      'de': 'Henley',
      'pl': 'Henley',
      'ru': 'Хенли',
      'uk': 'Хенлі',
      'ko': '헨리',
      'zh': '亨利',
      'ja': 'ヘンリー'
    }, {
      'id': 'HewnBenchItem',
      'en': 'Hewn Bench',
      'fr': 'Banc taillé',
      'es': 'banco tallado',
      'de': 'Behauene Bank',
      'pl': 'Ciosana Ławka',
      'ru': 'Тесаная скамейка',
      'uk': 'Тесана лава',
      'ko': '깎은 벤치',
      'zh': '凿好的长凳',
      'ja': '切りっぱなしのベンチ'
    }, {
      'id': 'HewnChairItem',
      'en': 'Hewn Chair',
      'fr': 'Chaise taillée',
      'es': 'silla tallada',
      'de': 'Behauener Stuhl',
      'pl': 'Ciosane krzesło',
      'ru': 'Тесаный стул',
      'uk': 'Тесаний стілець',
      'ko': '깎은 의자',
      'zh': '椅子',
      'ja': '切りっぱなしの椅子'
    }, {
      'id': 'HewnDoorItem',
      'en': 'Hewn Door',
      'fr': 'Porte taillée',
      'es': 'puerta tallada',
      'de': 'Behauene Tür',
      'pl': 'Ociosane drzwi',
      'ru': 'Высеченная дверь',
      'uk': 'Тесані двері',
      'ko': '깎은 문',
      'zh': '凿门',
      'ja': '切りっぱなしのドア'
    }, {
      'id': 'HewnDresserItem',
      'en': 'Hewn Dresser',
      'fr': 'Commode taillée',
      'es': 'Cómoda tallada',
      'de': 'Behauene Kommode',
      'pl': 'Ciosy Kredens',
      'ru': 'Тесаный комод',
      'uk': 'Тесаний комод',
      'ko': '손질한 드레서',
      'zh': '修整梳妆台',
      'ja': '切りっぱなしドレッサー'
    }, {
      'id': 'HewnLogItem',
      'en': 'Hewn Log',
      'fr': 'Bûche taillée',
      'es': 'Tronco tallado',
      'de': 'Behauenes Protokoll',
      'pl': 'Ciosany dziennik',
      'ru': 'Тесаное бревно',
      'uk': 'Тесана колода',
      'ko': '절단 로그',
      'zh': '砍伐原木',
      'ja': '切りっぱなしログ'
    }, {
      'id': 'HewnLog',
      'en': 'Hewn Log',
      'fr': 'Bûche taillée',
      'es': 'Tronco tallado',
      'de': 'Behauenes Protokoll',
      'pl': 'Ciosany dziennik',
      'ru': 'Тесаное бревно',
      'uk': 'Тесана колода',
      'ko': '절단 로그',
      'zh': '砍伐原木',
      'ja': '切りっぱなしログ'
    }, {
      'id': 'HewnNightstandItem',
      'en': 'Hewn Nightstand',
      'fr': 'Table de chevet taillée',
      'es': 'Mesita de noche tallada',
      'de': 'Behauener Nachttisch',
      'pl': 'Ciosana szafka nocna',
      'ru': 'Тесаная тумбочка',
      'uk': 'Тесана тумбочка',
      'ko': '깎은 협탁',
      'zh': '凿好的床头柜',
      'ja': '切りっぱなしのナイトスタンド'
    }, {
      'id': 'HewnTableItem',
      'en': 'Hewn Table',
      'fr': 'Table taillée',
      'es': 'Mesa tallada',
      'de': 'Behauener Tisch',
      'pl': 'Ciosany stół',
      'ru': 'Тесаный стол',
      'uk': 'Тесаний стіл',
      'ko': '깎은 테이블',
      'zh': '凿好的桌子',
      'ja': '切りっぱなしのテーブル'
    }, {
      'id': 'HideAshFertilizerItem',
      'en': 'Hide Ash Fertilizer',
      'fr': 'Masquer l\u0027engrais de cendres',
      'es': 'Ocultar fertilizante de cenizas',
      'de': 'Aschedünger verstecken',
      'pl': 'Ukryj nawóz popiołowy',
      'ru': 'Скрыть удобрение золы',
      'uk': 'Сховати золу добрива',
      'ko': '재 비료 숨기기',
      'zh': '皮灰肥',
      'ja': '灰肥料を隠す'
    }, {
      'id': 'HosomakiItem',
      'en': 'Hosomaki',
      'fr': 'Hosomaki',
      'es': 'Hosomaki',
      'de': 'Hosomaki',
      'pl': 'Hosomaki',
      'ru': 'Хосомаки',
      'uk': 'Хосомакі',
      'ko': '호소마키',
      'zh': '细卷',
      'ja': '細巻'
    }, {
      'id': 'Housing',
      'en': 'Housing',
      'fr': 'Logement',
      'es': 'Alojamiento',
      'de': 'Gehäuse',
      'pl': 'Mieszkania',
      'ru': 'Корпус',
      'uk': 'Житло',
      'ko': '주택',
      'zh': '住房',
      'ja': 'ハウジング'
    }, {
      'id': 'HuckleberriesItem',
      'en': 'Huckleberries',
      'fr': 'Myrtilles',
      'es': 'arándanos',
      'de': 'Heidelbeeren',
      'pl': 'Borówki',
      'ru': 'Гекльберри',
      'uk': 'Гекльбері',
      'ko': '허클베리',
      'zh': '越橘',
      'ja': 'ハックルベリー'
    }, {
      'id': 'HuckleberryExtractItem',
      'en': 'Huckleberry Extract',
      'fr': 'Extrait de myrtille',
      'es': 'Extracto de arándano',
      'de': 'Heidelbeerextrakt',
      'pl': 'Ekstrakt z Borówki',
      'ru': 'Экстракт черники',
      'uk': 'Екстракт Гекльберрі',
      'ko': '허클베리 추출물',
      'zh': '越橘提取物',
      'ja': 'ハックルベリーエキス'
    }, {
      'id': 'HuckleberryFritterItem',
      'en': 'Huckleberry Fritter',
      'fr': 'Beignet aux myrtilles',
      'es': 'buñuelo de arándanos',
      'de': 'Heidelbeer-Fritte',
      'pl': 'Placki z Huckleberry',
      'ru': 'Гекльберри оладьи',
      'uk': 'Оладка Гекльберрі',
      'ko': '허클베리 튀김',
      'zh': '哈克贝利油条',
      'ja': 'ハックルベリーフリッター'
    }, {
      'id': 'HuckleberryPieItem',
      'en': 'Huckleberry Pie',
      'fr': 'Tarte aux myrtilles',
      'es': 'Pastel de arándanos',
      'de': 'Heidelbeerkuchen',
      'pl': 'Ciasto Huckleberry',
      'ru': 'Гекльберри пирог',
      'uk': 'Пиріг Гекльберрі',
      'ko': '허클베리 파이',
      'zh': '哈克贝利派',
      'ja': 'ハックルベリーパイ'
    }, {
      'id': 'HuckleberrySeedItem',
      'en': 'Huckleberry Seed',
      'fr': 'Graine de myrtille',
      'es': 'Semilla de arándano',
      'de': 'Heidelbeersamen',
      'pl': 'Nasiona Huckleberry',
      'ru': 'Семя Гекльберри',
      'uk': 'Насіння гекльберрі',
      'ko': '허클베리 씨',
      'zh': '越橘种子',
      'ja': 'ハックベリーシード'
    }, {
      'id': 'HydrocolloidsItem',
      'en': 'Hydrocolloids',
      'fr': 'Hydrocolloïdes',
      'es': 'hidrocoloides',
      'de': 'Hydrokolloide',
      'pl': 'hydrokoloidy',
      'ru': 'Гидроколлоиды',
      'uk': 'Гідроколоїди',
      'ko': '하이드로콜로이드',
      'zh': '水胶体',
      'ja': '親水コロイド'
    }, {
      'id': 'IceboxItem',
      'en': 'Icebox',
      'fr': 'Glacière',
      'es': 'Nevera',
      'de': 'Eisfach',
      'pl': 'Lodówka',
      'ru': 'Холодильник',
      'uk': 'Icebox',
      'ko': '아이스박스',
      'zh': '冰箱',
      'ja': 'アイスボックス'
    }, {
      'id': 'IndustrialElevatorItem',
      'en': 'Industrial Elevator',
      'fr': 'Ascenseur industriel',
      'es': 'Ascensor Industrial',
      'de': 'Industrieller Aufzug',
      'pl': 'Winda przemysłowa',
      'ru': 'Промышленный лифт',
      'uk': 'Промисловий ліфт',
      'ko': '산업용 엘리베이터',
      'zh': '工业电梯',
      'ja': '産業用エレベーター'
    }, {
      'id': 'IndustrialRefrigeratorItem',
      'en': 'Industrial Refrigerator',
      'fr': 'Réfrigérateur industriel',
      'es': 'Frigorífico Industrial',
      'de': 'Industrieller Kühlschrank',
      'pl': 'Lodówka przemysłowa',
      'ru': 'Промышленный холодильник',
      'uk': 'Промисловий холодильник',
      'ko': '산업용 냉장고',
      'zh': '工业冰箱',
      'ja': '産業用冷蔵庫'
    }, {
      'id': 'IndustryUpgradeItem',
      'en': 'Industry Upgrade',
      'fr': 'Mise à niveau de l\u0027industrie',
      'es': 'Actualización de la industria',
      'de': 'Industrie-Upgrade',
      'pl': 'Modernizacja przemysłu',
      'ru': 'Обновление отрасли',
      'uk': 'Оновлення промисловості',
      'ko': '산업 업그레이드',
      'zh': '产业升级',
      'ja': '業界のアップグレード'
    }, {
      'id': 'InfusedOilItem',
      'en': 'Infused Oil',
      'fr': 'Huile infusée',
      'es': 'Aceite infundido',
      'de': 'Infundiertes Öl',
      'pl': 'Olej w parze',
      'ru': 'Настоянное масло',
      'uk': 'Настояне масло',
      'ko': '주입 오일',
      'zh': '注入油',
      'ja': '注入オイル'
    }, {
      'id': 'InjectionMoldMachineItem',
      'en': 'Injection Mold Machine',
      'fr': 'Machine de moulage par injection',
      'es': 'Máquina de moldeo por inyección',
      'de': 'Spritzgussmaschine',
      'pl': 'Maszyna do formowania wtryskowego',
      'ru': 'Машина для литья под давлением',
      'uk': 'Машина для лиття під тиском',
      'ko': '사출 금형 기계',
      'zh': '注塑机',
      'ja': '射出成形機'
    }, {
      'id': 'IronAxeItem',
      'en': 'Iron Axe',
      'fr': 'Hache de fer',
      'es': 'hacha de hierro',
      'de': 'Eiserne Axt',
      'pl': 'Żelazny Topór',
      'ru': 'Железный топор',
      'uk': 'Залізна сокира',
      'ko': '철 도끼',
      'zh': '铁斧',
      'ja': '鉄の斧'
    }, {
      'id': 'IronAxleItem',
      'en': 'Iron Axle',
      'fr': 'Essieu en fer',
      'es': 'Eje de hierro',
      'de': 'Eiserne Achse',
      'pl': 'Żelazna oś',
      'ru': 'Железная ось',
      'uk': 'Залізна вісь',
      'ko': '아이언 액슬',
      'zh': '铁轴',
      'ja': 'アイアンアクスル'
    }, {
      'id': 'IronBarItem',
      'en': 'Iron Bar',
      'fr': 'Barre de fer',
      'es': 'Barra de acero',
      'de': 'Eisenstange',
      'pl': 'Żelazna sztabka',
      'ru': 'Железный слиток',
      'uk': 'Залізний злиток',
      'ko': '철괴',
      'zh': '铁条',
      'ja': '鉄棒'
    }, {
      'id': 'IronConcentrateItem',
      'en': 'Iron Concentrate',
      'fr': 'Concentré de fer',
      'es': 'concentrado de hierro',
      'de': 'Eisenkonzentrat',
      'pl': 'Koncentrat żelaza',
      'ru': 'Концентрат железа',
      'uk': 'Концентрат заліза',
      'ko': '철 농축액',
      'zh': '铁精矿',
      'ja': '鉄精鉱'
    }, {
      'id': 'IronGearItem',
      'en': 'Iron Gear',
      'fr': 'Engrenage de fer',
      'es': 'Engranaje de hierro',
      'de': 'Eisenzahnrad',
      'pl': 'Żelazny sprzęt',
      'ru': 'Железная шестерня',
      'uk': 'Iron Gear',
      'ko': '아이언 기어',
      'zh': '铁齿轮',
      'ja': 'アイアンギア'
    }, {
      'id': 'IronHammerItem',
      'en': 'Iron Hammer',
      'fr': 'Marteau de fer',
      'es': 'Martillo de hierro',
      'de': 'Eiserner Hammer',
      'pl': 'Żelazny Młot',
      'ru': 'Железный молот',
      'uk': 'Залізний молот',
      'ko': '철 망치',
      'zh': '铁锤',
      'ja': 'アイアンハンマー'
    }, {
      'id': 'IronHoeItem',
      'en': 'Iron Hoe',
      'fr': 'Fer Houe',
      'es': 'Azada de hierro',
      'de': 'Eiserne Hacke',
      'pl': 'żelazna motyka',
      'ru': 'Железная мотыга',
      'uk': 'Залізна мотика',
      'ko': '아이언 괭이',
      'zh': '铁锄',
      'ja': 'アイアンホー'
    }, {
      'id': 'IronMacheteItem',
      'en': 'Iron Machete',
      'fr': 'Machette en fer',
      'es': 'Machete de hierro',
      'de': 'Eiserne Machete',
      'pl': 'Żelazna maczeta',
      'ru': 'Железный мачете',
      'uk': 'Залізне мачете',
      'ko': '아이언 마체테',
      'zh': '铁砍刀',
      'ja': '鉄マチェーテ'
    }, {
      'id': 'IronOreItem',
      'en': 'Iron Ore',
      'fr': 'Minerai de fer',
      'es': 'Mineral de hierro',
      'de': 'Eisenerz',
      'pl': 'Ruda żelaza',
      'ru': 'Железная руда',
      'uk': 'Залізна руда',
      'ko': '철광석',
      'zh': '铁矿',
      'ja': '鉄鉱石'
    }, {
      'id': 'IronPickaxeItem',
      'en': 'Iron Pickaxe',
      'fr': 'Pioche en fer',
      'es': 'Pico de hierro',
      'de': 'Eiserne Spitzhacke',
      'pl': 'Żelazny Kilof',
      'ru': 'Железная кирка',
      'uk': 'Залізна кирка',
      'ko': '철 곡괭이',
      'zh': '铁镐',
      'ja': '鉄のつるはし'
    }, {
      'id': 'IronPipeItem',
      'en': 'Iron Pipe',
      'fr': 'Tuyau de fer',
      'es': 'Tubería de hierro',
      'de': 'Eisenrohr',
      'pl': 'Żelazna rura',
      'ru': 'Железная труба',
      'uk': 'Залізна труба',
      'ko': '철 파이프',
      'zh': '铁管',
      'ja': '鉄パイプ'
    }, {
      'id': 'PistonItem',
      'en': 'Iron Piston',
      'fr': 'Piston en fer',
      'es': 'Pistón de hierro',
      'de': 'Eisenkolben',
      'pl': 'Żelazny Tłok',
      'ru': 'Железный поршень',
      'uk': 'Залізний поршень',
      'ko': '아이언 피스톤',
      'zh': '铁活塞',
      'ja': '鉄ピストン'
    }, {
      'id': 'IronPlateItem',
      'en': 'Iron Plate',
      'fr': 'Plat en fer',
      'es': 'Placa de hierro',
      'de': 'Eisenplatte',
      'pl': 'Żelazny talerz',
      'ru': 'Железная пластина',
      'uk': 'Залізна плита',
      'ko': '철판',
      'zh': '铁板',
      'ja': '鉄板'
    }, {
      'id': 'IronRockDrillItem',
      'en': 'Iron Rock Drill',
      'fr': 'Perceuse à roche en fer',
      'es': 'Taladro de roca de hierro',
      'de': 'Iron Rock-Bohrer',
      'pl': 'Żelazna wiertarka do skał',
      'ru': 'Железная дрель',
      'uk': 'Залізна гірська дриль',
      'ko': '철 착암기',
      'zh': '铁凿岩机',
      'ja': 'アイアンロックドリル'
    }, {
      'id': 'IronSawBladeItem',
      'en': 'Iron Saw Blade',
      'fr': 'Lame de scie en fer',
      'es': 'hoja de sierra de hierro',
      'de': 'Sägeblatt aus Eisen',
      'pl': 'Żelazne ostrze piły',
      'ru': 'Железная пила',
      'uk': 'Залізна пилка',
      'ko': '철 톱날',
      'zh': '铁锯片',
      'ja': 'アイアンソーブレード'
    }, {
      'id': 'IronShovelItem',
      'en': 'Iron Shovel',
      'fr': 'Pelle en fer',
      'es': 'pala de hierro',
      'de': 'Eiserne Schaufel',
      'pl': 'Żelazna Łopata',
      'ru': 'Железная лопата',
      'uk': 'Залізна лопата',
      'ko': '철 삽',
      'zh': '铁锹',
      'ja': '鉄のシャベル'
    }, {
      'id': 'IronSickleItem',
      'en': 'Iron Sickle',
      'fr': 'Faucille de fer',
      'es': 'Hoz de hierro',
      'de': 'Eiserne Sichel',
      'pl': 'Żelazny Sierp',
      'ru': 'Железный серп',
      'uk': 'Залізний серп',
      'ko': '철 낫',
      'zh': '铁镰',
      'ja': 'アイアンシックル'
    }, {
      'id': 'IronWheelItem',
      'en': 'Iron Wheel',
      'fr': 'Roue de fer',
      'es': 'rueda de hierro',
      'de': 'Eisernes Rad',
      'pl': 'Żelazne koło',
      'ru': 'Железное колесо',
      'uk': 'Залізне колесо',
      'ko': '철 바퀴',
      'zh': '铁轮',
      'ja': 'アイアンホイール'
    }, {
      'id': 'JaguarCarcassItem',
      'en': 'Jaguar Carcass',
      'fr': 'Carcasse de jaguar',
      'es': 'carcasa de jaguar',
      'de': 'Jaguar-Karkasse',
      'pl': 'Tusza Jaguara',
      'ru': 'Тушка ягуара',
      'uk': 'Туша ягуара',
      'ko': '재규어 시체',
      'zh': '捷豹胴体',
      'ja': 'ジャガーカーカス'
    }, {
      'id': 'JawCrusherItem',
      'en': 'Jaw Crusher',
      'fr': 'Concasseur à mâchoires',
      'es': 'Rompe mandíbulas',
      'de': 'Kieferbrecher',
      'pl': 'Miażdżyciel szczęk',
      'ru': 'Зубодробилка, мордоворот',
      'uk': 'Щекова дробарка',
      'ko': '조 크러셔',
      'zh': '颚式破碎机',
      'ja': 'ジョークラッシャー'
    }, {
      'id': 'JointfirSeedItem',
      'en': 'Jointfir Seed',
      'fr': 'Graine de sapin',
      'es': 'Semilla de abeto común',
      'de': 'Jointfir-Samen',
      'pl': 'Nasiona jodły pospolitej',
      'ru': 'Семя ели',
      'uk': 'Насіння ялиці',
      'ko': '합동나무 씨앗',
      'zh': '联合冷杉种子',
      'ja': 'ジョイントファーシード'
    }, {
      'id': 'JoshuaLogItem',
      'en': 'Joshua Log',
      'fr': 'Journal de Josué',
      'es': 'Registro de Josué',
      'de': 'Josua Log',
      'pl': 'Joshua Log',
      'ru': 'Джошуа Лог',
      'uk': 'Джошуа Лог',
      'ko': '조슈아 로그',
      'zh': '约书亚日志',
      'ja': 'ジョシュアログ'
    }, {
      'id': 'JoshuaSeedItem',
      'en': 'Joshua Seed',
      'fr': 'Graine de Josué',
      'es': 'Semilla de Josué',
      'de': 'Joshua Seed',
      'pl': 'Nasienie Jozuego',
      'ru': 'Джошуа Сид',
      'uk': 'Сід Джошуа',
      'ko': '조슈아 시드',
      'zh': '约书亚种子',
      'ja': 'ジョシュアシード'
    }, {
      'id': 'JungleCampfireSaladItem',
      'en': 'Jungle Campfire Salad',
      'fr': 'Salade de feu de camp de la jungle',
      'es': 'Ensalada de fogata de la jungla',
      'de': 'Dschungel-Lagerfeuer-Salat',
      'pl': 'Sałatka z ogniska w dżungli',
      'ru': 'Салат у костра в джунглях',
      'uk': 'Салат з багаття в джунглях',
      'ko': '정글 캠프파이어 샐러드',
      'zh': '丛林营火沙拉',
      'ja': 'ジャングルキャンプファイヤーサラダ'
    }, {
      'id': 'JungleCampfireStewItem',
      'en': 'Jungle Campfire Stew',
      'fr': 'Ragoût de feu de camp dans la jungle',
      'es': 'Estofado de fogata en la jungla',
      'de': 'Eintopf am Lagerfeuer im Dschungel',
      'pl': 'Gulasz z ogniska w dżungli',
      'ru': 'Похлебка из джунглей у костра',
      'uk': 'Тушковане багаття в джунглях',
      'ko': '정글 캠프파이어 스튜',
      'zh': '丛林篝火炖菜',
      'ja': 'ジャングルキャンプファイヤーシチュー'
    }, {
      'id': 'KelpItem',
      'en': 'Kelp',
      'fr': 'Varech',
      'es': 'Quelpo',
      'de': 'Seetang',
      'pl': 'Wodorosty morskie',
      'ru': 'водоросли',
      'uk': 'Ламінарія',
      'ko': '켈프',
      'zh': '海带',
      'ja': '昆布'
    }, {
      'id': 'KelpSeedItem',
      'en': 'Kelp Seed',
      'fr': 'Graine de varech',
      'es': 'Semilla de algas',
      'de': 'Kelp-Samen',
      'pl': 'Nasiona wodorostów',
      'ru': 'Семена ламинарии',
      'uk': 'Насіння ламінарії',
      'ko': '다시마 씨앗',
      'zh': '海带种子',
      'ja': '昆布の種'
    }, {
      'id': 'KelpyCrabRollItem',
      'en': 'Kelpy Crab Roll',
      'fr': 'Rouleau de crabe Kelpy',
      'es': 'Rollo de cangrejo Kelpy',
      'de': 'Kelpy Crab Roll',
      'pl': 'Krab Kelpy',
      'ru': 'Келпи Краб Ролл',
      'uk': 'Крабовий рулет Келпі',
      'ko': '켈피 크랩 롤',
      'zh': '海带蟹卷',
      'ja': 'ケルピークラブロール'
    }, {
      'id': 'KilnItem',
      'en': 'Kiln',
      'fr': 'Four',
      'es': 'Horno',
      'de': 'Ofen',
      'pl': 'Suszarnia',
      'ru': 'печь',
      'uk': 'піч',
      'ko': '가마',
      'zh': '窑',
      'ja': '窯'
    }, {
      'id': 'KingFernSporeItem',
      'en': 'King Fern Spore',
      'fr': 'Spore de fougère royale',
      'es': 'Espora de helecho rey',
      'de': 'Königsfarn-Spore',
      'pl': 'Król Paproci Spore',
      'ru': 'Королевская спора папоротника',
      'uk': 'Спор короля папороті',
      'ko': '킹 고사리 포자',
      'zh': '王蕨孢子',
      'ja': 'シダの胞子王'
    }, {
      'id': 'KitchenItem',
      'en': 'Kitchen',
      'fr': 'Cuisine',
      'es': 'Cocina',
      'de': 'Küche',
      'pl': 'Kuchnia',
      'ru': 'Кухня',
      'uk': 'Кухня',
      'ko': '주방',
      'zh': '厨房',
      'ja': 'キッチン'
    }, {
      'id': 'LaboratoryItem',
      'en': 'Laboratory',
      'fr': 'Laboratoire',
      'es': 'Laboratorio',
      'de': 'Labor',
      'pl': 'Laboratorium',
      'ru': 'Лаборатория',
      'uk': 'лабораторія',
      'ko': '실혐실',
      'zh': '实验室',
      'ja': 'ラボ'
    }, {
      'id': 'LandClaimStakeItem',
      'en': 'Land Claim Stake',
      'fr': 'Enjeux de revendications territoriales',
      'es': 'Participación de reclamo de tierras',
      'de': 'Land-Claim-Stake',
      'pl': 'Udział w roszczeniach do gruntów',
      'ru': 'Земельный участок',
      'uk': 'Ставка земельної претензії',
      'ko': '토지 소유권 주장 지분',
      'zh': '土地债权股份',
      'ja': '土地請求権'
    }, {
      'id': 'LargeBathMatItem',
      'en': 'Large Bath Mat',
      'fr': 'Grand tapis de bain',
      'es': 'Alfombra de baño grande',
      'de': 'Große Badematte',
      'pl': 'Duża mata do kąpieli',
      'ru': 'Большой коврик для ванной',
      'uk': 'Великий килимок для ванни',
      'ko': '대형 목욕 매트',
      'zh': '大浴垫',
      'ja': 'ラージバスマット'
    }, {
      'id': 'LargeCorrugatedSteelDoorItem',
      'en': 'Large Corrugated Steel Door',
      'fr': 'Grande porte en acier ondulé',
      'es': 'Gran puerta de acero corrugado',
      'de': 'Große Wellblechtür',
      'pl': 'Duże drzwi ze stali falistej',
      'ru': 'Большая дверь из гофрированной стали',
      'uk': 'Великі гофровані сталеві двері',
      'ko': '대형 골판지 스틸 도어',
      'zh': '大型波纹钢门',
      'ja': '大きな段ボール鋼のドア'
    }, {
      'id': 'LargeFish',
      'en': 'Large Fish',
      'fr': 'Gros poisson',
      'es': 'pez grande',
      'de': 'Großer Fisch',
      'pl': 'Duża ryba',
      'ru': 'Большая рыба',
      'uk': 'Велика риба',
      'ko': '큰 물고기',
      'zh': '大鱼',
      'ja': '大きな魚'
    }, {
      'id': 'LargeHangingAshlarBasaltSignItem',
      'en': 'Large Hanging Ashlar Basalt Sign',
      'fr': 'Grande enseigne suspendue en basalte en pierre de taille',
      'es': 'Letrero Colgante Grande de Sillería de Basalto',
      'de': 'Großes hängendes Quader-Basalt-Schild',
      'pl': 'Duży wiszący znak bazaltowy z Ashlar',
      'ru': 'Большой висячий базальтовый знак из тесаного камня',
      'uk': 'Великий висячий висячий базальтовий знак',
      'ko': '큰 교수형 Ashlar 현무암 기호',
      'zh': '大型悬挂式方石玄武岩标志',
      'ja': '大きな切石玄武岩の看板'
    }, {
      'id': 'LargeHangingAshlarGneissSignItem',
      'en': 'Large Hanging Ashlar Gneiss Sign',
      'fr': 'Grande enseigne suspendue en gneiss en pierre de taille',
      'es': 'Letrero Colgante Grande de Sillería Gneis',
      'de': 'Großes hängendes Quader-Gneis-Schild',
      'pl': 'Duży wiszący znak gnejsowy Ashlar',
      'ru': 'Большой висячий знак из тесаного камня и гнейса',
      'uk': 'Великий висячий знак з тесеняного гнейсу',
      'ko': '큰 교수형 Ashlar 편마암 기호',
      'zh': '大型悬挂式方石片麻岩标志',
      'ja': '大きなハンギング切石片麻岩サイン'
    }, {
      'id': 'LargeHangingAshlarGraniteSignItem',
      'en': 'Large Hanging Ashlar Granite Sign',
      'fr': 'Grande enseigne suspendue en granit de pierre de taille',
      'es': 'Letrero colgante grande de granito sillar',
      'de': 'Großes Schild aus Granit zum Aufhängen',
      'pl': 'Duży wiszący znak granitowy Ashlar',
      'ru': 'Большой висячий гранитный знак из тесаного камня',
      'uk': 'Великий висячий гранітний знак',
      'ko': '큰 교수형 Ashlar 화강암 기호',
      'zh': '大型悬挂式方石花岗岩标牌',
      'ja': '大きな切石花崗岩の看板'
    }, {
      'id': 'LargeHangingAshlarLimestoneSignItem',
      'en': 'Large Hanging Ashlar Limestone Sign',
      'fr': 'Grande enseigne en pierre calcaire à suspendre',
      'es': 'Letrero Colgante Grande de Piedra Caliza de Sillería',
      'de': 'Großes hängendes Quader-Kalkstein-Schild',
      'pl': 'Duży wiszący znak wapienia Ashlar',
      'ru': 'Большой висячий знак из известняка из тесаного камня',
      'uk': 'Великий висить тесенний вапняк знак',
      'ko': '큰 교수형 Ashlar 석회암 표시',
      'zh': '大型悬挂式方石石灰石标志',
      'ja': '大きな切石石灰岩の看板'
    }, {
      'id': 'LargeHangingAshlarSandstoneSignItem',
      'en': 'Large Hanging Ashlar Sandstone Sign',
      'fr': 'Grande enseigne en grès à suspendre',
      'es': 'Letrero Colgante Grande de Arenisca de Sillería',
      'de': 'Großes hängendes Quader-Sandstein-Schild',
      'pl': 'Duży wiszący znak z piaskowca Ashlar',
      'ru': 'Большой висящий знак из песчаника из тесаного камня',
      'uk': 'Знак з великого висячого пісковика',
      'ko': '큰 교수형 Ashlar 사암 기호',
      'zh': '大型悬挂式方石砂岩标志',
      'ja': '大きなハンギング切石砂岩サイン'
    }, {
      'id': 'LargeHangingAshlarShaleSignItem',
      'en': 'Large Hanging Ashlar Shale Sign',
      'fr': 'Grande enseigne suspendue en pierre de taille',
      'es': 'Letrero colgante grande de esquisto de sillería',
      'de': 'Großes Schild aus Quaderstein zum Aufhängen',
      'pl': 'Duży wiszący znak łupków Ashlar',
      'ru': 'Большой висячий сланцевый знак из тесаного камня',
      'uk': 'Великий висячий сланцевий знак',
      'ko': '대형 교수형 Ashlar 셰일 사인',
      'zh': '大型悬挂式方石页岩标志',
      'ja': '大きな切石頁岩の看板'
    }, {
      'id': 'LargeHangingAshlarStoneSignItem',
      'en': 'Large Hanging Ashlar Stone Sign',
      'fr': 'Grande enseigne en pierre de taille à suspendre',
      'es': 'Letrero Colgante Grande de Sillería',
      'de': 'Großes hängendes Quadersteinschild',
      'pl': 'Duży wiszący znak z kamienia Ashlar',
      'ru': 'Большой висящий знак из тесаного камня',
      'uk': 'Великий висячий кам\u0027яний знак',
      'ko': '큰 교수형 Ashlar 돌 기호',
      'zh': '大型悬挂式方石标志',
      'ja': '大きなハンギング切石サイン'
    }, {
      'id': 'LargeHangingBirchSignItem',
      'en': 'Large Hanging Birch Sign',
      'fr': 'Grande enseigne suspendue en bouleau',
      'es': 'Letrero colgante grande de abedul',
      'de': 'Großes Hängeschild aus Birke',
      'pl': 'Duży wiszący znak brzozy',
      'ru': 'Большой висячий березовый знак',
      'uk': 'Великий висить береза знак',
      'ko': '대형 교수형 자작나무 간판',
      'zh': '大挂桦木标志',
      'ja': '大きなハンギングバーチサイン'
    }, {
      'id': 'LargeHangingCedarSignItem',
      'en': 'Large Hanging Cedar Sign',
      'fr': 'Grande enseigne suspendue en cèdre',
      'es': 'Letrero colgante grande de cedro',
      'de': 'Großes hängendes Zedernschild',
      'pl': 'Duży wiszący znak cedr',
      'ru': 'Большой висящий кедровый знак',
      'uk': 'Великий висить кедровий знак',
      'ko': '대형 교수형 삼나무 간판',
      'zh': '大型悬挂雪松标志',
      'ja': '大きなハンギングシダーサイン'
    }, {
      'id': 'LargeHangingCeibaSignItem',
      'en': 'Large Hanging Ceiba Sign',
      'fr': 'Grande enseigne suspendue Ceiba',
      'es': 'Letrero de Ceiba Colgante Grande',
      'de': 'Großes hängendes Ceiba-Schild',
      'pl': 'Duży wiszący znak Ceiba',
      'ru': 'Большая подвесная вывеска Ceiba',
      'uk': 'Великий висить знак Ceiba',
      'ko': '대형 교수형 Ceiba 사인',
      'zh': '大挂木棉标牌',
      'ja': '大きなハンギングセイバサイン'
    }, {
      'id': 'LargeHangingFirSignItem',
      'en': 'Large Hanging Fir Sign',
      'fr': 'Grande enseigne suspendue en sapin',
      'es': 'Gran cartel colgante de abeto',
      'de': 'Großes hängendes Tannenschild',
      'pl': 'Duży wiszący znak jodły',
      'ru': 'Большой висячий еловый знак',
      'uk': 'Великий висить ялиця знак',
      'ko': '대형 교수형 전나무 간판',
      'zh': '大挂冷杉标志',
      'ja': '大きなハンギングファーサイン'
    }, {
      'id': 'LargeHangingHardwoodSignItem',
      'en': 'Large Hanging Hardwood Sign',
      'fr': 'Grande enseigne en bois dur suspendue',
      'es': 'Letrero colgante grande de madera dura',
      'de': 'Großes Schild zum Aufhängen aus Hartholz',
      'pl': 'Duży wiszący znak z twardego drewna',
      'ru': 'Большая подвесная вывеска из твердой древесины',
      'uk': 'Великий висить листяних порід знак',
      'ko': '대형 교수형 나무 간판',
      'zh': '大型悬挂式硬木标牌',
      'ja': '大きなハンギング広葉樹サイン'
    }, {
      'id': 'LargeHangingJoshuaSignItem',
      'en': 'Large Hanging Joshua Sign',
      'fr': 'Grande enseigne Joshua à suspendre',
      'es': 'Cartel colgante grande de Joshua',
      'de': 'Großes hängendes Joshua-Schild',
      'pl': 'Duży wiszący znak Joshua',
      'ru': 'Большой висящий знак Джошуа',
      'uk': 'Великий висить знак Джошуа',
      'ko': '대형 교수형 조슈아 사인',
      'zh': '大挂约书亚标志',
      'ja': '大きなハンギングジョシュアサイン'
    }, {
      'id': 'LargeHangingLumberSignItem',
      'en': 'Large Hanging Lumber Sign',
      'fr': 'Grand panneau de bois suspendu',
      'es': 'Letrero de madera colgante grande',
      'de': 'Großes hängendes Holzschild',
      'pl': 'Duży wiszący znak drewna',
      'ru': 'Большой висячий деревянный знак',
      'uk': 'Великий висить пиломатеріали знак',
      'ko': '대형 교수형 목재 기호',
      'zh': '大型悬挂木材标志',
      'ja': '大きなハンギング材木看板'
    }, {
      'id': 'LargeHangingMortaredGraniteSignItem',
      'en': 'Large Hanging Mortared Granite Sign',
      'fr': 'Grande enseigne suspendue en granit mortier',
      'es': 'Letrero de granito con mortero colgante grande',
      'de': 'Großes Schild aus Granit zum Aufhängen',
      'pl': 'Duży wiszący szyld z zaprawy granitowej',
      'ru': 'Большой висящий гранитный знак из раствора',
      'uk': 'Великий висячий гранітний знак',
      'ko': '대형 교수형 모르타르 화강암 사인',
      'zh': '大型悬挂砂浆花岗岩标志',
      'ja': '大きな吊りモルタル花崗岩のサイン'
    }, {
      'id': 'LargeHangingMortaredLimestoneSignItem',
      'en': 'Large Hanging Mortared Limestone Sign',
      'fr': 'Grande enseigne suspendue en calcaire mortier',
      'es': 'Letrero colgante grande de piedra caliza con mortero',
      'de': 'Großes Schild aus Kalkstein zum Aufhängen',
      'pl': 'Duży wiszący znak wapienia z zaprawą murarską',
      'ru': 'Большой висящий знак из известняка',
      'uk': 'Великий висячий знак з вапняку',
      'ko': '대형 교수형 모르타르 석회암 표지판',
      'zh': '大型悬挂砂浆石灰石标志',
      'ja': '大きな吊りモルタル石灰岩の看板'
    }, {
      'id': 'LargeHangingMortaredSandstoneSignItem',
      'en': 'Large Hanging Mortared Sandstone Sign',
      'fr': 'Grande enseigne suspendue en grès mortier',
      'es': 'Letrero colgante grande de piedra arenisca con mortero',
      'de': 'Großes hängendes Schild aus Sandstein',
      'pl': 'Duży wiszący szyld z zaprawionego piaskowca',
      'ru': 'Большой висящий знак из песчаника с раствором',
      'uk': 'Великий підвісний знак з пісковика',
      'ko': '대형 교수형 모르타르 사암 기호',
      'zh': '大型悬挂砂岩砂岩标志',
      'ja': '大きなぶら下がっているモルタル砂岩のサイン'
    }, {
      'id': 'LargeHangingMortaredStoneSignItem',
      'en': 'Large Hanging Mortared Stone Sign',
      'fr': 'Grand panneau en pierre mortier suspendu',
      'es': 'Letrero colgante grande de piedra con mortero',
      'de': 'Großes hängendes Schild aus gemörteltem Stein',
      'pl': 'Duży wiszący znak z zaprawą murarską',
      'ru': 'Большой висящий каменный знак из известкового раствора',
      'uk': 'Великий висячий кам\u0027яний знак',
      'ko': '대형 교수형 모르타르 스톤 사인',
      'zh': '大型悬挂式砂浆石标牌',
      'ja': '大きなハンギングモルタルストーンサイン'
    }, {
      'id': 'LargeHangingOakSignItem',
      'en': 'Large Hanging Oak Sign',
      'fr': 'Grande enseigne suspendue en chêne',
      'es': 'Letrero colgante grande de roble',
      'de': 'Großes Hängeschild aus Eiche',
      'pl': 'Duży wiszący znak dębu',
      'ru': 'Большой висячий дубовый знак',
      'uk': 'Великий висить дуб знак',
      'ko': '대형 교수형 오크 사인',
      'zh': '大挂橡木标志',
      'ja': '大きなハンギングオークサイン'
    }, {
      'id': 'LargeHangingPalmSignItem',
      'en': 'Large Hanging Palm Sign',
      'fr': 'Grand panneau de palmier suspendu',
      'es': 'Letrero grande colgante de palma',
      'de': 'Großes Palmenschild zum Aufhängen',
      'pl': 'Duży wiszący znak palmowy',
      'ru': 'Большой висячий знак пальмы',
      'uk': 'Великий висить Palm знак',
      'ko': '대형 교수형 팜 사인',
      'zh': '大型悬挂棕榈标志',
      'ja': '大きなハンギングパームサイン'
    }, {
      'id': 'LargeHangingRedwoodSignItem',
      'en': 'Large Hanging Redwood Sign',
      'fr': 'Grande enseigne suspendue en séquoia',
      'es': 'Letrero colgante grande de secoya',
      'de': 'Großes Redwood-Schild zum Aufhängen',
      'pl': 'Duży wiszący znak sekwoi',
      'ru': 'Большая подвесная вывеска из красного дерева',
      'uk': 'Великий висить Redwood знак',
      'ko': '대형 교수형 레드우드 사인',
      'zh': '大挂红木标志',
      'ja': '大きなハンギングレッドウッドサイン'
    }, {
      'id': 'LargeHangingSaguaroSignItem',
      'en': 'Large Hanging Saguaro Sign',
      'fr': 'Grande enseigne Saguaro à suspendre',
      'es': 'Cartel Saguaro Colgante Grande',
      'de': 'Großes hängendes Saguaro-Schild',
      'pl': 'Duży wiszący znak Saguaro',
      'ru': 'Большой висящий знак Сагуаро',
      'uk': 'Великий висить знак Saguaro',
      'ko': '대형 교수형 이구아로 표지판',
      'zh': '大挂仙人掌标志',
      'ja': '大きなハンギングサグアロサイン'
    }, {
      'id': 'LargeHangingSoftwoodSignItem',
      'en': 'Large Hanging Softwood Sign',
      'fr': 'Grande enseigne en bois résineux à suspendre',
      'es': 'Letrero colgante grande de madera blanda',
      'de': 'Großes Schild zum Aufhängen aus Weichholz',
      'pl': 'Duży wiszący znak z drewna iglastego',
      'ru': 'Большая подвесная вывеска из хвойных пород дерева',
      'uk': 'Великий висить знак хвойних порід',
      'ko': '대형 교수형 침엽수 사인',
      'zh': '大型悬挂软木标志',
      'ja': '大きなハンギング針葉樹サイン'
    }, {
      'id': 'LargeHangingSpruceSignItem',
      'en': 'Large Hanging Spruce Sign',
      'fr': 'Grande enseigne suspendue en épicéa',
      'es': 'Letrero colgante grande de abeto',
      'de': 'Großes hängendes Fichtenschild',
      'pl': 'Duży wiszący znak świerkowy',
      'ru': 'Большой висячий еловый знак',
      'uk': 'Великий висить ялина знак',
      'ko': '대형 교수형 가문비나무 간판',
      'zh': '大挂云杉标志',
      'ja': '大きなハンギングスプルースサイン'
    }, {
      'id': 'LargeHangingStoneSignItem',
      'en': 'Large Hanging Stone Sign',
      'fr': 'Grande enseigne en pierre suspendue',
      'es': 'Letrero de piedra colgante grande',
      'de': 'Großes hängendes Steinschild',
      'pl': 'Duży wiszący kamień znak',
      'ru': 'Большой висячий каменный знак',
      'uk': 'Великий висить кам\u0027яний знак',
      'ko': '대형 교수형 스톤 사인',
      'zh': '大挂石标牌',
      'ja': '大きな吊り石の看板'
    }, {
      'id': 'LargeHangingWoodSignItem',
      'en': 'Large Hanging Wood Sign',
      'fr': 'Grande enseigne en bois à suspendre',
      'es': 'Letrero de madera colgante grande',
      'de': 'Großes hängendes Holzschild',
      'pl': 'Duży wiszący znak drewna',
      'ru': 'Большой висячий деревянный знак',
      'uk': 'Великий висить дерев\u0027яний знак',
      'ko': '대형 교수형 나무 간판',
      'zh': '大挂木牌',
      'ja': '大きなハンギングウッドサイン'
    }, {
      'id': 'LargeLumberDoorItem',
      'en': 'Large Lumber Door',
      'fr': 'Grande porte en bois',
      'es': 'Puerta de madera grande',
      'de': 'Große Holztür',
      'pl': 'Duże drzwi do tarcicy',
      'ru': 'Большая деревянная дверь',
      'uk': 'Великі дерев\u0027яні двері',
      'ko': '대형 목재 문',
      'zh': '大木门',
      'ja': '大きな材木ドア'
    }, {
      'id': 'LargeLumberStockpileItem',
      'en': 'Large Lumber Stockpile',
      'fr': 'Grand stock de bois',
      'es': 'Gran reserva de madera',
      'de': 'Großer Holzvorrat',
      'pl': 'Duże zapasy drewna',
      'ru': 'Большой склад пиломатериалов',
      'uk': 'Великий запас пиломатеріалів',
      'ko': '대형 목재 비축',
      'zh': '大型木材库存',
      'ja': '大きな材木備蓄'
    }, {
      'id': 'LargeStandingAshlarBasaltSignItem',
      'en': 'Large Standing Ashlar Basalt Sign',
      'fr': 'Grand panneau de basalte en pierre de taille debout',
      'es': 'Letrero grande de basalto de sillería de pie',
      'de': 'Großes stehendes Quader-Basalt-Schild',
      'pl': 'Duży stojący znak bazaltowy z Ashlar',
      'ru': 'Большой стоячий базальтовый знак из тесаного камня',
      'uk': 'Великий стоячий тесенний базальтовий знак',
      'ko': '큰 서 Ashlar 현무암 기호',
      'zh': '大型立式方石玄武岩标志',
      'ja': '大きな切石玄武岩の看板'
    }, {
      'id': 'LargeStandingAshlarGneissSignItem',
      'en': 'Large Standing Ashlar Gneiss Sign',
      'fr': 'Grande enseigne en gneiss en pierre de taille debout',
      'es': 'Letrero grande de pie de sillería gneis',
      'de': 'Großes stehendes Quader-Gneis-Schild',
      'pl': 'Duży stojący znak gnejsowy Ashlar',
      'ru': 'Большой стоящий знак из тесаного камня',
      'uk': 'Великий стоячий знак з ялинового гнейсу',
      'ko': '대형 서 있는 Ashlar 편마암 기호',
      'zh': '大型立式方石片麻岩标志',
      'ja': '大きな切石片麻岩の看板'
    }, {
      'id': 'LargeStandingAshlarGraniteSignItem',
      'en': 'Large Standing Ashlar Granite Sign',
      'fr': 'Grande enseigne debout en granit de pierre de taille',
      'es': 'Gran letrero de granito de sillería de pie',
      'de': 'Großes stehendes Quader-Granit-Schild',
      'pl': 'Duży stojący znak granitowy Ashlar',
      'ru': 'Большой стоячий гранитный знак из тесаного камня',
      'uk': 'Великий стоячий гранітний знак',
      'ko': '큰 서 Ashlar 화강암 기호',
      'zh': '大型立式方石花岗岩标牌',
      'ja': '大きな切石花崗岩の看板'
    }, {
      'id': 'LargeStandingAshlarLimestoneSignItem',
      'en': 'Large Standing Ashlar Limestone Sign',
      'fr': 'Grande enseigne en pierre calcaire sur pied',
      'es': 'Letrero grande de piedra caliza de sillar de pie',
      'de': 'Großes stehendes Quader-Kalksteinschild',
      'pl': 'Duży stojący znak wapienia z Ashlar',
      'ru': 'Большой постоянный знак из известняка из тесаного камня',
      'uk': 'Великий стоїть тесенний вапняк знак',
      'ko': '큰 서 Ashlar 석회암 표시',
      'zh': '大型立式方石石灰石标志',
      'ja': '大きな切石石灰岩の看板'
    }, {
      'id': 'LargeStandingAshlarSandstoneSignItem',
      'en': 'Large Standing Ashlar Sandstone Sign',
      'fr': 'Grande enseigne debout en grès de pierre de taille',
      'es': 'Letrero grande de piedra arenisca de sillar de pie',
      'de': 'Großes stehendes Quader-Sandstein-Schild',
      'pl': 'Duży stojący znak z piaskowca Ashlar',
      'ru': 'Большой стоящий знак из песчаника из тесаного камня',
      'uk': 'Знак великого стоячого тесеняного пісковика',
      'ko': '큰 서 Ashlar 사암 기호',
      'zh': '大型立式方石砂岩标志',
      'ja': '大きな切石の砂岩の看板'
    }, {
      'id': 'LargeStandingAshlarShaleSignItem',
      'en': 'Large Standing Ashlar Shale Sign',
      'fr': 'Grande enseigne en pierre de taille sur pied',
      'es': 'Letrero de esquisto de sillería grande de pie',
      'de': 'Großes, stehendes Schild aus Quaderstein',
      'pl': 'Duży stojący znak łupków Ashlar',
      'ru': 'Большой стоячий знак из сланцевого камня',
      'uk': 'Великий стоячий сланцевий знак',
      'ko': '큰 서 있는 Ashlar 셰일 표시',
      'zh': '大型立式方石页岩标志',
      'ja': '大型切石頁岩標識'
    }, {
      'id': 'LargeStandingAshlarStoneSignItem',
      'en': 'Large Standing Ashlar Stone Sign',
      'fr': 'Grand panneau en pierre de taille debout',
      'es': 'Cartel grande de piedra de sillería de pie',
      'de': 'Großes stehendes Quadersteinschild',
      'pl': 'Duży stojący znak z kamienia Ashlar',
      'ru': 'Большой стоящий знак из тесаного камня',
      'uk': 'Великий стоячий знак з каменю',
      'ko': '큰 서 Ashlar 돌 기호',
      'zh': '大型立式方石标志',
      'ja': '大きな切石の石の看板'
    }, {
      'id': 'LargeStandingBirchSignItem',
      'en': 'Large Standing Birch Sign',
      'fr': 'Grande enseigne en bouleau sur pied',
      'es': 'Letrero grande de abedul de pie',
      'de': 'Großes stehendes Schild aus Birke',
      'pl': 'Duży stojący znak brzozy',
      'ru': 'Большой стоячий березовый знак',
      'uk': 'Знак великий стоячи берези',
      'ko': '대형 자작나무 간판',
      'zh': '大型站立桦木标志',
      'ja': '大きな立っている白樺の看板'
    }, {
      'id': 'LargeStandingCedarSignItem',
      'en': 'Large Standing Cedar Sign',
      'fr': 'Grande enseigne en cèdre sur pied',
      'es': 'Letrero grande de cedro de pie',
      'de': 'Großes stehendes Zedernschild',
      'pl': 'Duży stojący znak cedrowy',
      'ru': 'Большой постоянный кедровый знак',
      'uk': 'Великий стоячий кедровий знак',
      'ko': '대형 서 있는 삼나무 기호',
      'zh': '大型站立雪松标志',
      'ja': '大型スタンディングシダーサイン'
    }, {
      'id': 'LargeStandingCeibaSignItem',
      'en': 'Large Standing Ceiba Sign',
      'fr': 'Grande Enseigne Ceiba Debout',
      'es': 'Letrero de Ceiba de pie grande',
      'de': 'Großes stehendes Ceiba-Schild',
      'pl': 'Duży stojący znak Ceiba',
      'ru': 'Большой постоянный знак Ceiba',
      'uk': 'Великий стоїть знак Сейба',
      'ko': '대형 서 있는 Ceiba 사인',
      'zh': '大型木棉立牌',
      'ja': '大型スタンディングセイバサイン'
    }, {
      'id': 'LargeStandingFirSignItem',
      'en': 'Large Standing Fir Sign',
      'fr': 'Grande enseigne en sapin debout',
      'es': 'Gran cartel de abeto de pie',
      'de': 'Großes stehendes Tannenschild',
      'pl': 'Duży stojący znak jodły',
      'ru': 'Большой стоячий еловый знак',
      'uk': 'Знак великий стоячи ялиці',
      'ko': '대형 서 있는 전나무 기호',
      'zh': '大型常设冷杉标志',
      'ja': '大きな立っているモミのサイン'
    }, {
      'id': 'LargeStandingHardwoodSignItem',
      'en': 'Large Standing Hardwood Sign',
      'fr': 'Grande enseigne en bois dur sur pied',
      'es': 'Letrero grande de madera dura de pie',
      'de': 'Großes stehendes Schild aus Hartholz',
      'pl': 'Duży stojący znak z twardego drewna',
      'ru': 'Большой стоячий знак из твердой древесины',
      'uk': 'Великий стоїть листяних порід знак',
      'ko': '대형 서 있는 나무 간판',
      'zh': '大型站立式硬木标志',
      'ja': '大きな立っている広葉樹の看板'
    }, {
      'id': 'LargeStandingJoshuaSignItem',
      'en': 'Large Standing Joshua Sign',
      'fr': 'Grand panneau Josué debout',
      'es': 'Cartel de Josué grande de pie',
      'de': 'Großes stehendes Joshua-Schild',
      'pl': 'Duży stojący znak Joshua',
      'ru': 'Большой постоянный знак Джошуа',
      'uk': 'Великий стоїть знак Джошуа',
      'ko': '큰 서 있는 조슈아 사인',
      'zh': '大型站立约书亚标志',
      'ja': '大きな立っているジョシュアサイン'
    }, {
      'id': 'LargeStandingLumberSignItem',
      'en': 'Large Standing Lumber Sign',
      'fr': 'Grand panneau de bois debout',
      'es': 'Letrero grande de madera de pie',
      'de': 'Großes stehendes Holzschild',
      'pl': 'Duży stojący znak drewna',
      'ru': 'Большой стоячий знак пиломатериалов',
      'uk': 'Знак великий стоячий пиломатеріали',
      'ko': '대형 서 있는 목재 기호',
      'zh': '大型常设木材标志',
      'ja': '大きな立木看板'
    }, {
      'id': 'LargeStandingMortaredGraniteSignItem',
      'en': 'Large Standing Mortared Granite Sign',
      'fr': 'Grand panneau de granit mortier debout',
      'es': 'Letrero de granito con mortero de pie grande',
      'de': 'Großes stehendes Schild aus gemörteltem Granit',
      'pl': 'Duży stojący szyld z zaprawy granitowej',
      'ru': 'Большой стоячий гранитный знак из раствора',
      'uk': 'Великий стоячий знак з граніту',
      'ko': '대형 스탠딩 모르타르 화강암 사인',
      'zh': '大型立式砂浆花岗岩标志',
      'ja': '大きな立っているモルタル花崗岩のサイン'
    }, {
      'id': 'LargeStandingMortaredLimestoneSignItem',
      'en': 'Large Standing Mortared Limestone Sign',
      'fr': 'Grand panneau en calcaire mortier sur pied',
      'es': 'Letrero de piedra caliza con mortero de pie grande',
      'de': 'Großes stehendes Schild aus gemörteltem Kalkstein',
      'pl': 'Duży stojący znak wapienia z zaprawą murarską',
      'ru': 'Большой стоячий знак из известняка',
      'uk': 'Великий стоячий знак вапняку',
      'ko': '대형 스탠딩 모르타르 석회암 표지판',
      'zh': '大型立式砂浆石灰石标志',
      'ja': '大きな立っているモルタル石灰岩のサイン'
    }, {
      'id': 'LargeStandingMortaredSandstoneSignItem',
      'en': 'Large Standing Mortared Sandstone Sign',
      'fr': 'Grande enseigne en grès mortier sur pied',
      'es': 'Letrero de piedra arenisca con mortero de pie grande',
      'de': 'Großes stehendes Schild aus gemörteltem Sandstein',
      'pl': 'Duży stojący znak z zaprawionego piaskowca',
      'ru': 'Большой стоячий знак из песчаника с известковым раствором',
      'uk': 'Великий стоячий знак з пісковика',
      'ko': '대형 입석 모르타르 사암 기호',
      'zh': '大型立式砂岩砂岩标志',
      'ja': '大きな立っているモルタル砂岩のサイン'
    }, {
      'id': 'LargeStandingMortaredStoneSignItem',
      'en': 'Large Standing Mortared Stone Sign',
      'fr': 'Grand panneau de pierre mortier debout',
      'es': 'Letrero de piedra con mortero de pie grande',
      'de': 'Großes stehendes Schild aus gemörteltem Stein',
      'pl': 'Duży stojący znak z zaprawą murarską',
      'ru': 'Большой стоячий каменный знак из известкового раствора',
      'uk': 'Великий стоячий кам\u0027яний знак',
      'ko': '대형 서있는 모르타르 스톤 사인',
      'zh': '大型立式砂浆石标牌',
      'ja': '大きな立っているモルタル石の看板'
    }, {
      'id': 'LargeStandingOakSignItem',
      'en': 'Large Standing Oak Sign',
      'fr': 'Grande Enseigne En Chêne Debout',
      'es': 'Letrero grande de roble de pie',
      'de': 'Großes stehendes Eichenschild',
      'pl': 'Duży stojący szyld dębowy',
      'ru': 'Большой стоячий дубовый знак',
      'uk': 'Знак великий стоячий дуб',
      'ko': '대형 스탠딩 오크 사인',
      'zh': '大型站立橡木标志',
      'ja': '大きなスタンディングオークサイン'
    }, {
      'id': 'LargeStandingPalmSignItem',
      'en': 'Large Standing Palm Sign',
      'fr': 'Grand panneau de palmier debout',
      'es': 'Gran cartel de palma de pie.',
      'de': 'Großes stehendes Palmenschild',
      'pl': 'Duży stojący znak palmowy',
      'ru': 'Большой стоячий знак пальмы',
      'uk': 'Великий стоячи Palm знак',
      'ko': '대형 서있는 손바닥 기호',
      'zh': '大型站立棕榈标志',
      'ja': '大きなスタンディングパームサイン'
    }, {
      'id': 'LargeStandingRedwoodSignItem',
      'en': 'Large Standing Redwood Sign',
      'fr': 'Grande enseigne en séquoia sur pied',
      'es': 'Letrero grande de secoya de pie',
      'de': 'Großes stehendes Redwood-Schild',
      'pl': 'Duży stojący znak sekwoi',
      'ru': 'Большой постоянный знак из красного дерева',
      'uk': 'Великий стоїть Redwood знак',
      'ko': '대형 서 있는 레드우드 사인',
      'zh': '大型站立红木标志',
      'ja': '大きなスタンディングレッドウッドサイン'
    }, {
      'id': 'LargeStandingSaguaroSignItem',
      'en': 'Large Standing Saguaro Sign',
      'fr': 'Grand panneau Saguaro debout',
      'es': 'Gran cartel de Saguaro de pie',
      'de': 'Großes stehendes Saguaro-Schild',
      'pl': 'Duży stojący znak Saguaro',
      'ru': 'Большой постоянный знак Сагуаро',
      'uk': 'Великий стоячий знак Сагуаро',
      'ko': '대형 서 있는 사와로 기호',
      'zh': '大型立式仙人掌标志',
      'ja': '大きな立っているサグアロサイン'
    }, {
      'id': 'LargeStandingSoftwoodSignItem',
      'en': 'Large Standing Softwood Sign',
      'fr': 'Grande enseigne en bois résineux sur pied',
      'es': 'Letrero de madera blanda grande de pie',
      'de': 'Großes stehendes Weichholzschild',
      'pl': 'Duży stojący znak z drewna iglastego',
      'ru': 'Большой стоячий знак хвойных пород',
      'uk': 'Великий стоячий знак хвойних порід',
      'ko': '대형 스탠딩 침엽수 사인',
      'zh': '大型立式软木标志',
      'ja': '大きな立っている針葉樹の看板'
    }, {
      'id': 'LargeStandingSpruceSignItem',
      'en': 'Large Standing Spruce Sign',
      'fr': 'Grande enseigne debout en épicéa',
      'es': 'Gran cartel de abeto de pie',
      'de': 'Großes stehendes Fichtenschild',
      'pl': 'Duży stojący znak świerkowy',
      'ru': 'Большой стоячий еловый знак',
      'uk': 'Знак великий стоячи ялина',
      'ko': '대형 스탠딩 가문비나무 기호',
      'zh': '大型站立云杉标志',
      'ja': '大きなスタンディングスプルースサイン'
    }, {
      'id': 'LargeStandingStoneSignItem',
      'en': 'Large Standing Stone Sign',
      'fr': 'Grand panneau en pierre sur pied',
      'es': 'Gran letrero de piedra de pie',
      'de': 'Großes Stehendes Steinschild',
      'pl': 'Duży stojący kamienny znak',
      'ru': 'Большой стоящий каменный знак',
      'uk': 'Великий стоячий кам\u0027яний знак',
      'ko': '큰 서 있는 돌 표시',
      'zh': '大型立石标志',
      'ja': '大きな立っている石のサイン'
    }, {
      'id': 'LargeStandingWoodSignItem',
      'en': 'Large Standing Wood Sign',
      'fr': 'Grande enseigne en bois sur pied',
      'es': 'Letrero grande de madera de pie',
      'de': 'Großes stehendes Holzschild',
      'pl': 'Duży stojący znak drewna',
      'ru': 'Большой стоячий деревянный знак',
      'uk': 'Великий стоячий дерев\u0027яний знак',
      'ko': '대형 서 있는 나무 기호',
      'zh': '大型立木标志',
      'ja': '大きなスタンディングウッドサイン'
    }, {
      'id': 'LargeWindowedLumberDoorItem',
      'en': 'Large Windowed Lumber Door',
      'fr': 'Grande porte vitrée en bois',
      'es': 'Puerta de madera con ventana grande',
      'de': 'Große Fenstertür aus Holz',
      'pl': 'Duże okienne drzwi do drewna',
      'ru': 'Большая оконная деревянная дверь',
      'uk': 'Великі дерев\u0027яні двері з вікнами',
      'ko': '대형 창문 목재 도어',
      'zh': '大窗木门',
      'ja': '大きな窓付き材木ドア'
    }, {
      'id': 'LaserItem',
      'en': 'Laser',
      'fr': 'Laser',
      'es': 'Láser',
      'de': 'Laser',
      'pl': 'Laser',
      'ru': 'Лазер',
      'uk': 'Лазерний',
      'ko': '레이저',
      'zh': '激光',
      'ja': 'レーザ'
    }, {
      'id': 'LatheItem',
      'en': 'Lathe',
      'fr': 'Tour',
      'es': 'Torno',
      'de': 'Drehbank',
      'pl': 'Tokarka',
      'ru': 'токарный станок',
      'uk': 'Токарний верстат',
      'ko': '선반',
      'zh': '车床',
      'ja': '旋盤'
    }, {
      'id': 'LatticeMushroomSporesItem',
      'en': 'Lattice Mushroom Spores',
      'fr': 'Spores de champignons en treillis',
      'es': 'Esporas de hongos enrejados',
      'de': 'Gitterpilzsporen',
      'pl': 'Zarodniki grzybów kratowych',
      'ru': 'Споры решетчатых грибов',
      'uk': 'Гратчасті спори грибів',
      'ko': '격자 버섯 포자',
      'zh': '格子蘑菇孢子',
      'ja': 'ラティスマッシュルーム胞子'
    }, {
      'id': 'LeatherHideItem',
      'en': 'Leather Hide',
      'fr': 'Peau de cuir',
      'es': 'Piel de cuero',
      'de': 'Leder verstecken',
      'pl': 'Skóra Skóra',
      'ru': 'Кожаная шкура',
      'uk': 'Шкіряна шкура',
      'ko': '가죽 가죽',
      'zh': '皮革',
      'ja': 'レザーハイド'
    }, {
      'id': 'LeavenedDoughItem',
      'en': 'Leavened Dough',
      'fr': 'Pâte levée',
      'es': 'Masa con levadura',
      'de': 'Sauerteig',
      'pl': 'Ciasto Zaczynowe',
      'ru': 'дрожжевое тесто',
      'uk': 'Дріжджове тісто',
      'ko': '발효 반죽',
      'zh': '发酵面团',
      'ja': 'ふくらまし生地'
    }, {
      'id': 'LightBackpackItem',
      'en': 'Light Backpack',
      'fr': 'Sac à dos léger',
      'es': 'Mochila ligera',
      'de': 'Leichter Rucksack',
      'pl': 'Lekki plecak',
      'ru': 'Легкий рюкзак',
      'uk': 'Легкий рюкзак',
      'ko': '가벼운 배낭',
      'zh': '轻便背包',
      'ja': 'ライトバックパック'
    }, {
      'id': 'LightBulbItem',
      'en': 'Light Bulb',
      'fr': 'Ampoule',
      'es': 'Bombilla',
      'de': 'Die Glühbirne',
      'pl': 'Żarówka',
      'ru': 'Лампочка',
      'uk': 'Лампочка',
      'ko': '전구',
      'zh': '灯泡',
      'ja': '電球'
    }, {
      'id': 'LimestoneItem',
      'en': 'Limestone',
      'fr': 'Calcaire',
      'es': 'Caliza',
      'de': 'Kalkstein',
      'pl': 'Wapień',
      'ru': 'Известняк',
      'uk': 'Вапняк',
      'ko': '석회암',
      'zh': '石灰石',
      'ja': '石灰岩'
    }, {
      'id': 'LimestoneBisonStatueItem',
      'en': 'Limestone Bison Statue',
      'fr': 'Statue de bison en pierre calcaire',
      'es': 'Estatua de bisonte de piedra caliza',
      'de': 'Kalkstein-Bison-Statue',
      'pl': 'Wapienna statua żubra',
      'ru': 'Статуя известнякового бизона',
      'uk': 'Статуя бізона з вапняку',
      'ko': '석회암 들소 동상',
      'zh': '石灰石野牛雕像',
      'ja': '石灰岩のバイソン像'
    }, {
      'id': 'LimestoneOtterStatueItem',
      'en': 'Limestone Otter Statue',
      'fr': 'Statue de loutre en pierre calcaire',
      'es': 'Estatua de nutria de piedra caliza',
      'de': 'Otter-Statue aus Kalkstein',
      'pl': 'Wapienna wydra statua',
      'ru': 'Статуя известняковой выдры',
      'uk': 'Вапнякова статуя видри',
      'ko': '석회암 수달 동상',
      'zh': '石灰岩水獭雕像',
      'ja': '石灰岩のカワウソの像'
    }, {
      'id': 'LimestoneOwlStatueItem',
      'en': 'Limestone Owl Statue',
      'fr': 'Statue de hibou en calcaire',
      'es': 'Estatua de búho de piedra caliza',
      'de': 'Eulenstatue aus Kalkstein',
      'pl': 'Posąg wapiennej sowy',
      'ru': 'Статуя совы из известняка',
      'uk': 'Вапнякова статуя сови',
      'ko': '석회암 올빼미 동상',
      'zh': '石灰岩猫头鹰雕像',
      'ja': '石灰岩のフクロウの像'
    }, {
      'id': 'LimestoneWolfStatueItem',
      'en': 'Limestone Wolf Statue',
      'fr': 'Statue de loup en calcaire',
      'es': 'Estatua de lobo de piedra caliza',
      'de': 'Wolfsstatue aus Kalkstein',
      'pl': 'Posąg wapienny wilka',
      'ru': 'Статуя известнякового волка',
      'uk': 'Вапнякова статуя вовка',
      'ko': '석회암 늑대 동상',
      'zh': '石灰石狼雕像',
      'ja': '石灰岩のオオカミの像'
    }, {
      'id': 'LiquidNitrogenItem',
      'en': 'Liquid Nitrogen',
      'fr': 'L\u0027azote liquide',
      'es': 'Nitrógeno líquido',
      'de': 'Flüssigstickstoff',
      'pl': 'Ciekły azot',
      'ru': 'Жидкий азот',
      'uk': 'Рідкий азот',
      'ko': '액체 질소',
      'zh': '液氮',
      'ja': '液体窒素'
    }, {
      'id': 'LoadedTaroFriesItem',
      'en': 'Loaded Taro Fries',
      'fr': 'Frites Taro Chargées',
      'es': 'Patatas Fritas Taro Cargadas',
      'de': 'Geladene Taro-Pommes',
      'pl': 'Załadowane Frytki Taro',
      'ru': 'Загруженный картофель таро',
      'uk': 'Завантажена картопля фрі таро',
      'ko': '로드된 타로 프라이',
      'zh': '装芋头薯条',
      'ja': '里芋フライ'
    }, {
      'id': 'LogItem',
      'en': 'Log',
      'fr': 'Enregistrer',
      'es': 'Tronco',
      'de': 'Protokoll',
      'pl': 'Dziennik',
      'ru': 'Журнал',
      'uk': 'журнал',
      'ko': '통나무',
      'zh': '日志',
      'ja': 'ログ'
    }, {
      'id': 'LoggingAdvancedUpgradeItem',
      'en': 'Logging Advanced Upgrade',
      'fr': 'Mise à niveau avancée de la journalisation',
      'es': 'Actualización avanzada de registro',
      'de': 'Erweitertes Upgrade protokollieren',
      'pl': 'Zaawansowane rejestrowanie aktualizacji',
      'ru': 'Ведение журнала расширенного обновления',
      'uk': 'Розширене оновлення журналу',
      'ko': '로깅 고급 업그레이드',
      'zh': '记录高级升级',
      'ja': '高度なアップグレードのログ'
    }, {
      'id': 'LoggingBasicUpgradeItem',
      'en': 'Logging Basic Upgrade',
      'fr': 'Mise à niveau de base de la journalisation',
      'es': 'Actualización básica de registro',
      'de': 'Protokollieren des Basis-Upgrades',
      'pl': 'Rejestracja podstawowa aktualizacja',
      'ru': 'Ведение журнала базового обновления',
      'uk': 'Основне оновлення журналу',
      'ko': '로깅 기본 업그레이드',
      'zh': '记录基本升级',
      'ja': '基本的なアップグレードのログ'
    }, {
      'id': 'LoomItem',
      'en': 'Loom',
      'fr': 'Métier à tisser',
      'es': 'Telar',
      'de': 'Webstuhl',
      'pl': 'Warsztat tkacki',
      'ru': 'Ткацкий станок',
      'uk': 'Ткацький верстат',
      'ko': '직조기',
      'zh': '织机',
      'ja': '織機'
    }, {
      'id': 'LowTopShoesItem',
      'en': 'Low Top Shoes',
      'fr': 'Chaussures basses',
      'es': 'Zapatos bajos',
      'de': 'Low-Top-Schuhe',
      'pl': 'Niskie buty',
      'ru': 'Низкие туфли',
      'uk': 'Низькі туфлі',
      'ko': '로우탑 슈즈',
      'zh': '低帮鞋',
      'ja': 'ロートップシューズ'
    }, {
      'id': 'LumberItem',
      'en': 'Lumber',
      'fr': 'Bois de charpente',
      'es': 'Tablas de madera',
      'de': 'Holz',
      'pl': 'Graty',
      'ru': 'Пиломатериалы',
      'uk': 'Пиломатеріали',
      'ko': '재목',
      'zh': '木材',
      'ja': '木材'
    }, {
      'id': 'Lumber',
      'en': 'Lumber',
      'fr': 'Bois de charpente',
      'es': 'Tablas de madera',
      'de': 'Holz',
      'pl': 'Graty',
      'ru': 'Пиломатериалы',
      'uk': 'Пиломатеріали',
      'ko': '재목',
      'zh': '木材',
      'ja': '木材'
    }, {
      'id': 'LumberBenchItem',
      'en': 'Lumber Bench',
      'fr': 'Banc de bois',
      'es': 'banco de madera',
      'de': 'Holzbank',
      'pl': 'Ławka do drewna',
      'ru': 'Скамейка из пиломатериалов',
      'uk': 'Лавка для пиломатеріалів',
      'ko': '목재 벤치',
      'zh': '伐木台',
      'ja': '材木ベンチ'
    }, {
      'id': 'LumberChairItem',
      'en': 'Lumber Chair',
      'fr': 'Chaise en bois',
      'es': 'silla de madera',
      'de': 'Holzstuhl',
      'pl': 'Krzesło do drewna',
      'ru': 'Деревянный стул',
      'uk': 'Крісло пиломатеріалів',
      'ko': '목재 의자',
      'zh': '木椅',
      'ja': '材木椅子'
    }, {
      'id': 'LumberDoorItem',
      'en': 'Lumber Door',
      'fr': 'Porte bois',
      'es': 'puerta de madera',
      'de': 'Holztür',
      'pl': 'Drewno Drzwi',
      'ru': 'Деревянная дверь',
      'uk': 'Дерев\u0027яні двері',
      'ko': '목재 문',
      'zh': '木门',
      'ja': '材木ドア'
    }, {
      'id': 'LumberDresserItem',
      'en': 'Lumber Dresser',
      'fr': 'Commode à bois',
      'es': 'tocador de madera',
      'de': 'Holzkommode',
      'pl': 'Kredens do drewna',
      'ru': 'Комод пиломатериалов',
      'uk': 'Пиломатеріали',
      'ko': '목재 드레서',
      'zh': '木材梳妆台',
      'ja': 'ランバードレッサー'
    }, {
      'id': 'LumberStockpileItem',
      'en': 'Lumber Stockpile',
      'fr': 'Stock de bois',
      'es': 'Reserva de madera',
      'de': 'Holzvorrat',
      'pl': 'Skład drewna',
      'ru': 'Склад пиломатериалов',
      'uk': 'Запас пиломатеріалів',
      'ko': '목재 비축',
      'zh': '木材库存',
      'ja': '材木備蓄'
    }, {
      'id': 'LumberTableItem',
      'en': 'Lumber Table',
      'fr': 'Table de bois',
      'es': 'Mesa de madera',
      'de': 'Holztisch',
      'pl': 'Stół do tarcicy',
      'ru': 'Стол из пиломатериалов',
      'uk': 'Пиломатеріали Стіл',
      'ko': '목재 테이블',
      'zh': '木材表',
      'ja': '材木テーブル'
    }, {
      'id': 'LupineSeedItem',
      'en': 'Lupine Seed',
      'fr': 'Graine de lupin',
      'es': 'Semilla de lupino',
      'de': 'Lupinensamen',
      'pl': 'Nasiona łubinu',
      'ru': 'Семя люпина',
      'uk': 'Насіння люпину',
      'ko': '루팡 씨',
      'zh': '羽扇豆种子',
      'ja': 'ルパン三世の種'
    }, {
      'id': 'MacaroonsItem',
      'en': 'Macaroons',
      'fr': 'macarons',
      'es': 'macarrones',
      'de': 'Makronen',
      'pl': 'makaroniki',
      'ru': 'миндальное печенье',
      'uk': 'Макаруни',
      'ko': '마카롱',
      'zh': '杏仁饼',
      'ja': 'マカロン'
    }, {
      'id': 'MachinistTableItem',
      'en': 'Machinist Table',
      'fr': 'Table de machiniste',
      'es': 'Mesa de maquinista',
      'de': 'Maschinentisch',
      'pl': 'Stół maszynisty',
      'ru': 'Стол машиниста',
      'uk': 'Стіл машиніста',
      'ko': '기계공 테이블',
      'zh': '机械师表',
      'ja': 'マシニストテーブル'
    }, {
      'id': 'MailboxItem',
      'en': 'Mailbox',
      'fr': 'Boites aux lettres',
      'es': 'Buzón',
      'de': 'Briefkasten',
      'pl': 'Skrzynka pocztowa',
      'ru': 'Почтовый ящик',
      'uk': 'Поштова скринька',
      'ko': '사서함',
      'zh': '邮箱',
      'ja': 'メールボックス'
    }, {
      'id': 'MaltodextrinItem',
      'en': 'Maltodextrin',
      'fr': 'Maltodextrine',
      'es': 'maltodextrina',
      'de': 'Maltodextrin',
      'pl': 'Maltodekstryna',
      'ru': 'Мальтодекстрин',
      'uk': 'Мальтодекстрин',
      'ko': '말토덱스트린',
      'zh': '麦芽糊精',
      'ja': 'マルトデキストリン'
    }, {
      'id': 'MasonryAdvancedUpgradeItem',
      'en': 'Masonry Advanced Upgrade',
      'fr': 'Mise à niveau avancée de la maçonnerie',
      'es': 'Actualización avanzada de albañilería',
      'de': 'Fortgeschrittenes Upgrade für Mauerwerk',
      'pl': 'Zaawansowana modernizacja murów',
      'ru': 'Расширенное обновление масонства',
      'uk': 'Розширене оновлення Masonry',
      'ko': '벽돌 고급 업그레이드',
      'zh': '砌体高级升级',
      'ja': '組積造の高度なアップグレード'
    }, {
      'id': 'MasonryBasicUpgradeItem',
      'en': 'Masonry Basic Upgrade',
      'fr': 'Mise à niveau de base de la maçonnerie',
      'es': 'Actualización básica de albañilería',
      'de': 'Grundlegendes Upgrade für Mauerwerk',
      'pl': 'Podstawowe ulepszenie murów',
      'ru': 'Базовое обновление каменной кладки',
      'uk': 'Базове оновлення кладки',
      'ko': '벽돌 기본 업그레이드',
      'zh': '砌体基础升级',
      'ja': '組積造の基本的なアップグレード'
    }, {
      'id': 'MasonryTableItem',
      'en': 'Masonry Table',
      'fr': 'Tableau de maçonnerie',
      'es': 'Mesa de mampostería',
      'de': 'Mauerwerk Tisch',
      'pl': 'Stół murowany',
      'ru': 'Каменный стол',
      'uk': 'Кам\u0027яний стіл',
      'ko': '석조 테이블',
      'zh': '砌体表',
      'ja': '組積造テーブル'
    }, {
      'id': 'MeatPieItem',
      'en': 'Meat Pie',
      'fr': 'Tourte à la viande',
      'es': 'Pastel de carne',
      'de': 'Fleischpastete',
      'pl': 'Mięsny placek',
      'ru': 'Мясной пирог',
      'uk': 'М\u0027ясний пиріг',
      'ko': '고기 파이',
      'zh': '肉饼',
      'ja': 'ミートパイ'
    }, {
      'id': 'MeatStockItem',
      'en': 'Meat Stock',
      'fr': 'Stock de viande',
      'es': 'Caldo de carne',
      'de': 'Fleischbestand',
      'pl': 'Zapas mięsny',
      'ru': 'Мясной бульон',
      'uk': 'М\u0027ясний бульон',
      'ko': '육수',
      'zh': '肉汤',
      'ja': '肉ストック'
    }, {
      'id': 'MeatyStewItem',
      'en': 'Meaty Stew',
      'fr': 'Ragoût de viande',
      'es': 'Estofado de carne',
      'de': 'Fleischiger Eintopf',
      'pl': 'Mięsny Gulasz',
      'ru': 'Мясное рагу',
      'uk': 'М\u0027ясна рагу',
      'ko': '고기 스튜',
      'zh': '炖肉',
      'ja': '肉のシチュー'
    }, {
      'id': 'MechanicalWaterPumpItem',
      'en': 'Mechanical Water Pump',
      'fr': 'Pompe à eau mécanique',
      'es': 'Bomba de agua mecánica',
      'de': 'Mechanische Wasserpumpe',
      'pl': 'Mechaniczna pompa wodna',
      'ru': 'Механический водяной насос',
      'uk': 'Механічний водяний насос',
      'ko': '기계식 워터 펌프',
      'zh': '机械水泵',
      'ja': '機械式送水ポンプ'
    }, {
      'id': 'MechanicsAdvancedUpgradeItem',
      'en': 'Mechanics Advanced Upgrade',
      'fr': 'Mise à niveau avancée de la mécanique',
      'es': 'Actualización avanzada de mecánica',
      'de': 'Erweiterte Mechanik-Upgrade',
      'pl': 'Zaawansowane ulepszenie mechaniki',
      'ru': 'Продвинутое обновление механики',
      'uk': 'Розширене оновлення механіки',
      'ko': '역학 고급 업그레이드',
      'zh': '力学高级升级',
      'ja': '力学の高度なアップグレード'
    }, {
      'id': 'MechanicsModernUpgradeItem',
      'en': 'Mechanics Modern Upgrade',
      'fr': 'Mise à niveau moderne de la mécanique',
      'es': 'Mecánica Moderna Actualización',
      'de': 'Mechanik Modernes Upgrade',
      'pl': 'Modernizacja mechaniki',
      'ru': 'Механика Модерн Апгрейд',
      'uk': 'Сучасна модернізація механіки',
      'ko': '역학 현대 업그레이드',
      'zh': '力学现代升级',
      'ja': '力学の最新のアップグレード'
    }, {
      'id': 'MediumCarcass',
      'en': 'Medium Carcass',
      'fr': 'Carcasse moyenne',
      'es': 'Canal mediana',
      'de': 'Mittlere Karkasse',
      'pl': 'Średnia tusza',
      'ru': 'Средняя туша',
      'uk': 'Середня тушка',
      'ko': '중간 시체',
      'zh': '中型胴体',
      'ja': 'ミディアムカーカス'
    }, {
      'id': 'MediumFish',
      'en': 'Medium Fish',
      'fr': 'Poisson moyen',
      'es': 'Pescado mediano',
      'de': 'Mittlerer Fisch',
      'pl': 'Średnia ryba',
      'ru': 'Средняя рыба',
      'uk': 'Середня риба',
      'ko': '중간 물고기',
      'zh': '中型鱼',
      'ja': 'ミディアムフィッシュ'
    }, {
      'id': 'MediumLeatherCarcass',
      'en': 'Medium Leather Carcass',
      'fr': 'Carcasse en cuir moyen',
      'es': 'Carcasa de cuero mediana',
      'de': 'Mittlere Lederkarkasse',
      'pl': 'Średniej Skóry Tusza',
      'ru': 'Средний кожаный каркас',
      'uk': 'Середній шкіряний каркас',
      'ko': '미디엄 가죽 시체',
      'zh': '中号皮革胴体',
      'ja': 'ミディアムレザーカーカス'
    }, {
      'id': 'MediumWoolyCarcass',
      'en': 'Medium Wooly Carcass',
      'fr': 'Carcasse laineuse moyenne',
      'es': 'Canal mediana de lana',
      'de': 'Mittlere wollige Karkasse',
      'pl': 'Średnio wełnista tusza',
      'ru': 'Средняя шерстистая туша',
      'uk': 'Тушка середньої шерсті',
      'ko': '중간 양털 시체',
      'zh': '中等羊毛胴体',
      'ja': 'ミディアムウーリーカーカス'
    }, {
      'id': 'Metal',
      'en': 'Metal',
      'fr': 'Métal',
      'es': 'Metal',
      'de': 'Metall',
      'pl': 'Metal',
      'ru': 'Металл',
      'uk': 'Метал',
      'ko': '금속',
      'zh': '金属',
      'ja': '金属'
    }, {
      'id': 'MetallurgyResearchPaperAdvancedItem',
      'en': 'Metallurgy Research Paper Advanced',
      'fr': 'Document de recherche sur la métallurgie avancé',
      'es': 'Trabajo de investigación de metalurgia avanzado',
      'de': 'Forschungsbericht zur Metallurgie für Fortgeschrittene',
      'pl': 'Zaawansowany papier do badań metalurgicznych',
      'ru': 'Исследовательская работа по металлургии Advanced',
      'uk': 'Металургійна наукова робота Advanced',
      'ko': '야금 연구 논문 고급',
      'zh': '冶金研究论文高级',
      'ja': '冶金学研究論文Advanced'
    }, {
      'id': 'MetallurgyResearchPaperBasicItem',
      'en': 'Metallurgy Research Paper Basic',
      'fr': 'Document de recherche sur la métallurgie',
      'es': 'Papel de investigación de metalurgia básico',
      'de': 'Grundlegendes Forschungspapier zur Metallurgie',
      'pl': 'Podstawowy papier do badań metalurgicznych',
      'ru': 'Базовая исследовательская работа по металлургии',
      'uk': 'Металургія Наукова робота Основ',
      'ko': '야금 연구 논문 기초',
      'zh': '冶金研究论文基础',
      'ja': '冶金学研究論文基本'
    }, {
      'id': 'MetallurgyResearchPaperModernItem',
      'en': 'Metallurgy Research Paper Modern',
      'fr': 'Document de recherche sur la métallurgie moderne',
      'es': 'Papel de investigación de metalurgia moderno',
      'de': 'Metallurgisches Forschungspapier Modern',
      'pl': 'Nowoczesna praca naukowo-badawcza w dziedzinie metalurgii',
      'ru': 'Текст научной работы на тему «Модерн металлургии»',
      'uk': 'Металургія Наукова робота Сучасні',
      'ko': '야금 연구 논문 현대',
      'zh': '冶金研究论文现代',
      'ja': '現代の冶金学研究論文'
    }, {
      'id': 'MilkItem',
      'en': 'Milk',
      'fr': 'Du lait',
      'es': 'Leche',
      'de': 'Milch',
      'pl': 'mleko',
      'ru': 'Молоко',
      'uk': 'Молоко',
      'ko': '우유',
      'zh': '牛奶',
      'ja': '牛乳'
    }, {
      'id': 'MillItem',
      'en': 'Mill',
      'fr': 'Moulin',
      'es': 'Molino',
      'de': 'Mühle',
      'pl': 'Młyn',
      'ru': 'Мельница',
      'uk': 'млин',
      'ko': '밀',
      'zh': '磨',
      'ja': '工場'
    }, {
      'id': 'MillingUpgradeItem',
      'en': 'Milling Upgrade',
      'fr': 'Mise à niveau de fraisage',
      'es': 'Actualización de fresado',
      'de': 'Fräs-Upgrade',
      'pl': 'Ulepszenie frezowania',
      'ru': 'Модернизация фрезерования',
      'uk': 'Оновлення фрезерування',
      'ko': '밀링 업그레이드',
      'zh': '铣削升级',
      'ja': 'フライス盤のアップグレード'
    }, {
      'id': 'MillionairesSaladItem',
      'en': 'Millionaires Salad',
      'fr': 'Salade des millionnaires',
      'es': 'Ensalada De Millonarios',
      'de': 'Salat der Millionäre',
      'pl': 'Sałatka Milionerów',
      'ru': 'Салат Миллионеров',
      'uk': 'Салат Мільйонери',
      'ko': '백만장자 샐러드',
      'zh': '百万富翁沙拉',
      'ja': 'ミリオネアサラダ'
    }, {
      'id': 'MiningAdvancedUpgradeItem',
      'en': 'Mining Advanced Upgrade',
      'fr': 'Mise à niveau avancée de l\u0027exploitation minière',
      'es': 'Actualización avanzada de minería',
      'de': 'Erweitertes Mining-Upgrade',
      'pl': 'Zaawansowane ulepszenie górnictwa',
      'ru': 'Расширенное обновление майнинга',
      'uk': 'Розширене оновлення майнінгу',
      'ko': '마이닝 고급 업그레이드',
      'zh': '挖矿进阶升级',
      'ja': 'マイニングアドバンストアップグレード'
    }, {
      'id': 'MiningBasicUpgradeItem',
      'en': 'Mining Basic Upgrade',
      'fr': 'Mise à niveau de base de l\u0027exploitation minière',
      'es': 'Actualización básica de minería',
      'de': 'Bergbau-Basis-Upgrade',
      'pl': 'Podstawowe ulepszenie górnictwa',
      'ru': 'Базовое обновление майнинга',
      'uk': 'Базове оновлення майнінгу',
      'ko': '마이닝 기본 업그레이드',
      'zh': '挖矿基础升级',
      'ja': 'マイニングの基本的なアップグレード'
    }, {
      'id': 'MiningModernUpgradeItem',
      'en': 'Mining Modern Upgrade',
      'fr': 'Mise à niveau moderne de l\u0027exploitation minière',
      'es': 'Actualización moderna de minería',
      'de': 'Modernes Bergbau-Upgrade',
      'pl': 'Modernizacja górnicza',
      'ru': 'Современное обновление майнинга',
      'uk': 'Сучасне оновлення майнінгу',
      'ko': '마이닝 모던 업그레이드',
      'zh': '采矿现代升级',
      'ja': 'マイニングモダンアップグレード'
    }, {
      'id': 'MintItem',
      'en': 'Mint',
      'fr': 'menthe',
      'es': 'menta',
      'de': 'Minze',
      'pl': 'Mennica',
      'ru': 'Монетный двор',
      'uk': 'М\u0027ятний двір',
      'ko': '민트',
      'zh': '薄荷',
      'ja': 'ミント'
    }, {
      'id': 'MochiItem',
      'en': 'Mochi',
      'fr': 'Mochi',
      'es': 'Mochi',
      'de': 'Mochi',
      'pl': 'Mochi',
      'ru': 'моти',
      'uk': 'Мочі',
      'ko': '떡',
      'zh': '麻糬',
      'ja': '餅'
    }, {
      'id': 'ModernAxeItem',
      'en': 'Modern Axe',
      'fr': 'Hache moderne',
      'es': 'Hacha moderna',
      'de': 'Moderne Axt',
      'pl': 'Nowoczesna siekiera',
      'ru': 'Современный топор',
      'uk': 'Сучасна сокира',
      'ko': '현대 도끼',
      'zh': '现代斧头',
      'ja': '現代の斧'
    }, {
      'id': 'ModernDoubleStreetLightItem',
      'en': 'Modern Double Street Light',
      'fr': 'Réverbère double moderne',
      'es': 'Farola doble moderna',
      'de': 'Moderne Doppelstraßenlaterne',
      'pl': 'Nowoczesne podwójne oświetlenie uliczne',
      'ru': 'Современный двойной уличный фонарь',
      'uk': 'Сучасне подвійне вуличне освітлення',
      'ko': '현대 이중 가로등',
      'zh': '现代双路灯',
      'ja': 'モダンダブルストリートライト'
    }, {
      'id': 'ModernHammerItem',
      'en': 'Modern Hammer',
      'fr': 'Marteau moderne',
      'es': 'Martillo moderno',
      'de': 'Moderner Hammer',
      'pl': 'Nowoczesny młotek',
      'ru': 'Современный молот',
      'uk': 'Сучасний молоток',
      'ko': '현대 망치',
      'zh': '现代锤子',
      'ja': 'モダンハンマー'
    }, {
      'id': 'ModernHoeItem',
      'en': 'Modern Hoe',
      'fr': 'Houe moderne',
      'es': 'Azada moderna',
      'de': 'Moderne Hacke',
      'pl': 'nowoczesny motyka',
      'ru': 'Современная мотыга',
      'uk': 'Сучасна мотика',
      'ko': '현대 괭이',
      'zh': '现代锄头',
      'ja': '現代のくわ'
    }, {
      'id': 'ModernMacheteItem',
      'en': 'Modern Machete',
      'fr': 'Machette moderne',
      'es': 'Machete moderno',
      'de': 'Moderne Machete',
      'pl': 'Nowoczesna maczeta',
      'ru': 'Современное Мачете',
      'uk': 'Сучасне мачете',
      'ko': '모던 마체테',
      'zh': '现代弯刀',
      'ja': 'モダンマチェーテ'
    }, {
      'id': 'ModernPickaxeItem',
      'en': 'Modern Pickaxe',
      'fr': 'Pioche moderne',
      'es': 'Pico moderno',
      'de': 'Moderne Spitzhacke',
      'pl': 'Nowoczesny kilof',
      'ru': 'Современная кирка',
      'uk': 'Сучасна кирка',
      'ko': '현대 곡괭이',
      'zh': '现代镐',
      'ja': '現代のツルハシ'
    }, {
      'id': 'Modern Research',
      'en': 'Modern Research',
      'fr': 'Recherche moderne',
      'es': 'Investigación moderna',
      'de': 'Moderne Forschung',
      'pl': 'Nowoczesne badania',
      'ru': 'Современные исследования',
      'uk': 'Сучасні дослідження',
      'ko': '현대 연구',
      'zh': '现代研究',
      'ja': '現代研究'
    }, {
      'id': 'ModernRockDrillItem',
      'en': 'Modern Rock Drill',
      'fr': 'Perceuse à roche moderne',
      'es': 'Taladro de roca moderno',
      'de': 'Moderner Felsbohrer',
      'pl': 'Nowoczesna wiertarka do skał',
      'ru': 'Современная буровая установка',
      'uk': 'Сучасний бур',
      'ko': '현대 착암기',
      'zh': '现代凿岩机',
      'ja': 'モダンロックドリル'
    }, {
      'id': 'ModernScytheItem',
      'en': 'Modern Scythe',
      'fr': 'Faux moderne',
      'es': 'Guadaña moderna',
      'de': 'Moderne Sense',
      'pl': 'Nowoczesna kosa',
      'ru': 'Современная коса',
      'uk': 'Сучасна коса',
      'ko': '현대 낫',
      'zh': '现代镰刀',
      'ja': 'モダンサイス'
    }, {
      'id': 'ModernShovelItem',
      'en': 'Modern Shovel',
      'fr': 'Pelle moderne',
      'es': 'pala moderna',
      'de': 'Moderne Schaufel',
      'pl': 'Nowoczesna łopata',
      'ru': 'Современная лопата',
      'uk': 'Сучасна лопата',
      'ko': '현대 삽',
      'zh': '现代铲子',
      'ja': '現代のシャベル'
    }, {
      'id': 'ModernStreetLightItem',
      'en': 'Modern Street Light',
      'fr': 'Réverbère moderne',
      'es': 'Farola moderna',
      'de': 'Moderne Straßenlaterne',
      'pl': 'Nowoczesne oświetlenie uliczne',
      'ru': 'Современный уличный свет',
      'uk': 'Сучасне вуличне освітлення',
      'ko': '현대 가로등',
      'zh': '现代路灯',
      'ja': 'モダンな街路灯'
    }, {
      'id': 'ModernUpgradeLvl1Item',
      'en': 'Modern Upgrade 1',
      'fr': 'Mise à niveau moderne 1',
      'es': 'Actualización moderna 1',
      'de': 'Modernes Upgrade 1',
      'pl': 'Nowoczesna aktualizacja 1',
      'ru': 'Современное обновление 1',
      'uk': 'Сучасне оновлення 1',
      'ko': '현대 업그레이드 1',
      'zh': '现代升级 1',
      'ja': 'モダンアップグレード1'
    }, {
      'id': 'ModernUpgradeLvl2Item',
      'en': 'Modern Upgrade 2',
      'fr': 'Mise à niveau moderne 2',
      'es': 'Actualización moderna 2',
      'de': 'Modernes Upgrade 2',
      'pl': 'Nowoczesna aktualizacja 2',
      'ru': 'Современное обновление 2',
      'uk': 'Сучасне оновлення 2',
      'ko': '현대 업그레이드 2',
      'zh': '现代升级 2',
      'ja': 'モダンアップグレード2'
    }, {
      'id': 'ModernUpgradeLvl3Item',
      'en': 'Modern Upgrade 3',
      'fr': 'Mise à niveau moderne 3',
      'es': 'Actualización moderna 3',
      'de': 'Modernes Upgrade 3',
      'pl': 'Nowoczesna aktualizacja 3',
      'ru': 'Современное обновление 3',
      'uk': 'Сучасне оновлення 3',
      'ko': '현대 업그레이드 3',
      'zh': '现代升级 3',
      'ja': 'モダンアップグレード3'
    }, {
      'id': 'ModernUpgradeLvl4Item',
      'en': 'Modern Upgrade 4',
      'fr': 'Mise à niveau moderne 4',
      'es': 'Actualización moderna 4',
      'de': 'Modernes Upgrade 4',
      'pl': 'Nowoczesna aktualizacja 4',
      'ru': 'Современное обновление 4',
      'uk': 'Сучасне оновлення 4',
      'ko': '현대 업그레이드 4',
      'zh': '现代升级 4',
      'ja': 'モダンアップグレード4'
    }, {
      'id': 'MoonJellyfishItem',
      'en': 'Moon Jellyfish',
      'fr': 'Méduse lunaire',
      'es': 'Medusa Luna',
      'de': 'Mondqualle',
      'pl': 'Księżycowa Meduza',
      'ru': 'Лунная медуза',
      'uk': 'Місячна медуза',
      'ko': '달해파리',
      'zh': '月亮水母',
      'ja': 'ミズクラゲ'
    }, {
      'id': 'MortarItem',
      'en': 'Mortar',
      'fr': 'Mortier',
      'es': 'Mortero',
      'de': 'Granatwerfer',
      'pl': 'Moździerz',
      'ru': 'Миномет',
      'uk': 'Розчин',
      'ko': '박격포',
      'zh': '砂浆',
      'ja': 'モルタル'
    }, {
      'id': 'MortaredBasaltItem',
      'en': 'Mortared Basalt',
      'fr': 'Basalte mortier',
      'es': 'Basalto Mortero',
      'de': 'Gemörtelter Basalt',
      'pl': 'Zaprawiony Bazalt',
      'ru': 'Растворенный базальт',
      'uk': 'Розчинений базальт',
      'ko': '박격포 현무암',
      'zh': '砂浆玄武岩',
      'ja': '玄武岩'
    }, {
      'id': 'MortaredGneissItem',
      'en': 'Mortared Gneiss',
      'fr': 'Gneiss mortier',
      'es': 'Gneis en mortero',
      'de': 'Gemörtelter Gneis',
      'pl': 'Zaprawiony Gnejs',
      'ru': 'Известковый гнейс',
      'uk': 'Розчинений гнейс',
      'ko': '박격포 편마암',
      'zh': '砂浆片麻岩',
      'ja': 'モルタル片麻岩'
    }, {
      'id': 'MortaredGraniteItem',
      'en': 'Mortared Granite',
      'fr': 'Granit mortier',
      'es': 'Granito Mortero',
      'de': 'Gemörtelter Granit',
      'pl': 'Zaprawiony Granit',
      'ru': 'Измельченный гранит',
      'uk': 'Гранітний граніт',
      'ko': '모르타르 화강암',
      'zh': '砂浆花岗岩',
      'ja': 'モルタル花崗岩'
    }, {
      'id': 'MortaredGraniteBenchItem',
      'en': 'Mortared Granite Bench',
      'fr': 'Banc de granit mortier',
      'es': 'Banco de granito con mortero',
      'de': 'Bank aus gemörteltem Granit',
      'pl': 'Ławka z zaprawy granitowej',
      'ru': 'Известковая гранитная скамья',
      'uk': 'Гранітна лавка',
      'ko': '박격포 화강암 벤치',
      'zh': '砂浆花岗岩长凳',
      'ja': 'モルタル花崗岩のベンチ'
    }, {
      'id': 'MortaredGraniteChairItem',
      'en': 'Mortared Granite Chair',
      'fr': 'Chaise en granit mortier',
      'es': 'Silla de granito con mortero',
      'de': 'Gemörtelter Granit-Stuhl',
      'pl': 'Krzesło z zaprawy granitowej',
      'ru': 'Известковый гранитный стул',
      'uk': 'Крісло з граніту',
      'ko': '박격포 화강암 의자',
      'zh': '砂浆花岗岩椅子',
      'ja': 'モルタル花崗岩の椅子'
    }, {
      'id': 'MortaredGraniteDoorItem',
      'en': 'Mortared Granite Door',
      'fr': 'Porte en granit mortier',
      'es': 'Puerta de granito con mortero',
      'de': 'Gemörtelte Granittür',
      'pl': 'Zaprawa Granitowa Drzwi',
      'ru': 'Известковая гранитная дверь',
      'uk': 'Гранітні двері',
      'ko': '박격포 화강암 문',
      'zh': '砂浆花岗岩门',
      'ja': 'モルタル花崗岩のドア'
    }, {
      'id': 'MortaredGraniteFireplaceItem',
      'en': 'Mortared Granite Fireplace',
      'fr': 'Cheminée en granit mortier',
      'es': 'Chimenea de granito con argamasa',
      'de': 'Kamin aus gemörteltem Granit',
      'pl': 'Zaprawiony granitowy kominek',
      'ru': 'Известковый гранитный камин',
      'uk': 'Камін з граніту',
      'ko': '모르타르 화강암 벽난로',
      'zh': '砂浆花岗岩壁炉',
      'ja': 'モルタル花崗岩の暖炉'
    }, {
      'id': 'MortaredGraniteTableItem',
      'en': 'Mortared Granite Table',
      'fr': 'Table de granit mortier',
      'es': 'Mesa de granito con mortero',
      'de': 'Gemörtelter Granittisch',
      'pl': 'Stół z zaprawy granitowej',
      'ru': 'Гранитный стол с раствором',
      'uk': 'Стіл з граніту',
      'ko': '모르타르 화강암 테이블',
      'zh': '砂浆花岗岩台',
      'ja': 'モルタル花崗岩テーブル'
    }, {
      'id': 'MortaredLimestoneItem',
      'en': 'Mortared Limestone',
      'fr': 'Calcaire mortier',
      'es': 'Piedra caliza con mortero',
      'de': 'Gemörtelter Kalkstein',
      'pl': 'Zaprawiony Wapień',
      'ru': 'Растворенный известняк',
      'uk': 'Розчинений вапняк',
      'ko': '모르타르 석회암',
      'zh': '砂浆石灰石',
      'ja': 'モルタル石灰岩'
    }, {
      'id': 'MortaredLimestoneBenchItem',
      'en': 'Mortared Limestone Bench',
      'fr': 'Banc en calcaire mortier',
      'es': 'Banco de piedra caliza con mortero',
      'de': 'Bank aus gemörteltem Kalkstein',
      'pl': 'Ławka wapienna z zaprawą murarską',
      'ru': 'Скамья из известняка',
      'uk': 'Лавка з вапняку з розчином',
      'ko': '박격포 석회암 벤치',
      'zh': '砂浆石灰石长凳',
      'ja': 'モルタル石灰岩のベンチ'
    }, {
      'id': 'MortaredLimestoneChairItem',
      'en': 'Mortared Limestone Chair',
      'fr': 'Chaise en calcaire mortier',
      'es': 'Silla de piedra caliza con mortero',
      'de': 'Stuhl aus gemörteltem Kalkstein',
      'pl': 'Krzesło wapienne z zaprawą murarską',
      'ru': 'Известняковый стул',
      'uk': 'Стілець із вапнякового розчину',
      'ko': '박격포 석회석 의자',
      'zh': '砂浆石灰石椅子',
      'ja': 'モルタル石灰岩の椅子'
    }, {
      'id': 'MortaredLimestoneDoorItem',
      'en': 'Mortared Limestone Door',
      'fr': 'Porte en calcaire mortier',
      'es': 'Puerta de piedra caliza con mortero',
      'de': 'Gemörtelte Kalksteintür',
      'pl': 'Zaprawa murarska drzwi z wapienia',
      'ru': 'Известняковая дверь с раствором',
      'uk': 'Штукатурені вапнякові двері',
      'ko': '박격포 석회암 문',
      'zh': '石灰石砂浆门',
      'ja': 'モルタル石灰岩のドア'
    }, {
      'id': 'MortaredLimestoneFireplaceItem',
      'en': 'Mortared Limestone Fireplace',
      'fr': 'Cheminée en calcaire mortier',
      'es': 'Chimenea de piedra caliza con mortero',
      'de': 'Kamin aus gemörteltem Kalkstein',
      'pl': 'Zaprawiony kominek wapienny',
      'ru': 'Камин из известняка с раствором',
      'uk': 'Камін з вапняку з розчином',
      'ko': '박격포 석회암 벽난로',
      'zh': '砂浆石灰石壁炉',
      'ja': 'モルタル石灰岩の暖炉'
    }, {
      'id': 'MortaredLimestoneTableItem',
      'en': 'Mortared Limestone Table',
      'fr': 'Table en calcaire mortier',
      'es': 'Mesa de piedra caliza con mortero',
      'de': 'Tisch aus gemörteltem Kalkstein',
      'pl': 'Stół wapienny z zaprawą murarską',
      'ru': 'Стол из известняка с раствором',
      'uk': 'Стіл з вапняку з розчином',
      'ko': '모르타르 석회석 테이블',
      'zh': '砂浆石灰石桌',
      'ja': 'モルタル石灰岩テーブル'
    }, {
      'id': 'MortaredSandstoneItem',
      'en': 'Mortared Sandstone',
      'fr': 'Grès mortier',
      'es': 'Arenisca con mortero',
      'de': 'Gemörtelter Sandstein',
      'pl': 'Zaprawiony piaskowiec',
      'ru': 'Известковый песчаник',
      'uk': 'Розчинений піщаник',
      'ko': '모르타르 사암',
      'zh': '砂浆砂岩',
      'ja': 'モルタル砂岩'
    }, {
      'id': 'MortaredSandstoneBenchItem',
      'en': 'Mortared Sandstone Bench',
      'fr': 'Banc en grès mortier',
      'es': 'Banco de piedra arenisca con mortero',
      'de': 'Bank aus gemörteltem Sandstein',
      'pl': 'Ławka z zaprawy z piaskowca',
      'ru': 'Скамья из песчаника с известковым раствором',
      'uk': 'Лавка з пісковика',
      'ko': '박격포 사암 벤치',
      'zh': '砂岩台架',
      'ja': 'モルタル砂岩ベンチ'
    }, {
      'id': 'MortaredSandstoneChairItem',
      'en': 'Mortared Sandstone Chair',
      'fr': 'Chaise en grès mortier',
      'es': 'Silla de piedra arenisca con mortero',
      'de': 'Stuhl aus gemörteltem Sandstein',
      'pl': 'Krzesło z zaprawy z piaskowca',
      'ru': 'Стул из песчаника с известковым раствором',
      'uk': 'Стілець з пісковика',
      'ko': '박격포 사암 의자',
      'zh': '砂岩砂岩椅',
      'ja': 'モルタル砂岩の椅子'
    }, {
      'id': 'MortaredSandstoneDoorItem',
      'en': 'Mortared Sandstone Door',
      'fr': 'Porte en grès mortier',
      'es': 'Puerta de piedra arenisca con mortero',
      'de': 'Gemörtelte Sandsteintür',
      'pl': 'Zaprawa murarska drzwi z piaskowca',
      'ru': 'Дверь из песчаника с известковым раствором',
      'uk': 'Штукатурені двері з пісковика',
      'ko': '박격포 사암 문',
      'zh': '砂岩砂岩门',
      'ja': 'モルタル砂岩ドア'
    }, {
      'id': 'MortaredSandstoneFireplaceItem',
      'en': 'Mortared Sandstone Fireplace',
      'fr': 'Cheminée en grès mortier',
      'es': 'Chimenea de piedra arenisca con mortero',
      'de': 'Kamin aus gemörteltem Sandstein',
      'pl': 'Zaprawiony kominek z piaskowca',
      'ru': 'Камин из песчаника с известковым раствором',
      'uk': 'Камін з пісковика',
      'ko': '모르타르 사암 벽난로',
      'zh': '砂岩壁炉',
      'ja': 'モルタル砂岩暖炉'
    }, {
      'id': 'MortaredSandstoneTableItem',
      'en': 'Mortared Sandstone Table',
      'fr': 'Table en grès mortier',
      'es': 'Mesa de piedra arenisca con mortero',
      'de': 'Tisch aus gemörteltem Sandstein',
      'pl': 'Zaprawiony stół z piaskowca',
      'ru': 'Стол из песчаника с раствором',
      'uk': 'Стіл з пісковика з розчину',
      'ko': '모르타르 사암 테이블',
      'zh': '砂岩砂岩台',
      'ja': 'モルタル砂岩テーブル'
    }, {
      'id': 'MortaredShaleItem',
      'en': 'Mortared Shale',
      'fr': 'Schiste mortier',
      'es': 'Esquisto mortero',
      'de': 'Gemörtelter Schiefer',
      'pl': 'Zaprawiony łupek',
      'ru': 'Известковый сланец',
      'uk': 'Розчинений сланец',
      'ko': '박격포 셰일',
      'zh': '砂浆页岩',
      'ja': 'モルタル頁岩'
    }, {
      'id': 'MortaredStoneItem',
      'en': 'Mortared Stone',
      'fr': 'Pierre Mortier',
      'es': 'Piedra con mortero',
      'de': 'Gemörtelter Stein',
      'pl': 'Kamień zaprawy',
      'ru': 'Известковый камень',
      'uk': 'Розчинений камінь',
      'ko': '박격포',
      'zh': '砂浆石',
      'ja': 'モルタルストーン'
    }, {
      'id': 'MortaredStone',
      'en': 'Mortared Stone',
      'fr': 'Pierre Mortier',
      'es': 'Piedra con mortero',
      'de': 'Gemörtelter Stein',
      'pl': 'Kamień zaprawy',
      'ru': 'Известковый камень',
      'uk': 'Розчинений камінь',
      'ko': '박격포',
      'zh': '砂浆石',
      'ja': 'モルタルストーン'
    }, {
      'id': 'MortaredStoneBenchItem',
      'en': 'Mortared Stone Bench',
      'fr': 'Banc de pierre mortier',
      'es': 'Banco de piedra con mortero',
      'de': 'Bank aus gemörteltem Stein',
      'pl': 'Kamienna ławka z zaprawą murarską',
      'ru': 'Каменная скамья из раствора',
      'uk': 'Кам’яна лавка з розчину',
      'ko': '박격포 석재 벤치',
      'zh': '砂浆石凳',
      'ja': 'モルタル石のベンチ'
    }, {
      'id': 'MortaredStoneChairItem',
      'en': 'Mortared Stone Chair',
      'fr': 'Chaise en pierre mortier',
      'es': 'Silla de piedra con mortero',
      'de': 'Gemörtelter Steinstuhl',
      'pl': 'Kamienne krzesło z zaprawą murarską',
      'ru': 'Стул из известкового камня',
      'uk': 'Стілець із затираного каменю',
      'ko': '박격포 석재 의자',
      'zh': '砂浆石椅',
      'ja': 'モルタルストーンチェア'
    }, {
      'id': 'MortaredStoneDoorItem',
      'en': 'Mortared Stone Door',
      'fr': 'Porte en pierre mortier',
      'es': 'Puerta de piedra con mortero',
      'de': 'Gemörtelte Steintür',
      'pl': 'Zamurowane kamienne drzwi',
      'ru': 'Известковая каменная дверь',
      'uk': 'Заштукатурені кам\u0027яні двері',
      'ko': '박격포 돌 문',
      'zh': '砂浆石门',
      'ja': 'モルタル石のドア'
    }, {
      'id': 'MortaredStoneFireplaceItem',
      'en': 'Mortared Stone Fireplace',
      'fr': 'Foyer en pierre mortier',
      'es': 'Chimenea de piedra con argamasa',
      'de': 'Kamin aus gemörteltem Stein',
      'pl': 'Kominek z zaprawy murarskiej',
      'ru': 'Каменный камин из раствора',
      'uk': 'Кам\u0027яний камін з розчину',
      'ko': '박격포 석재 벽난로',
      'zh': '砂浆石壁炉',
      'ja': 'モルタル石の暖炉'
    }, {
      'id': 'MortaredStoneTableItem',
      'en': 'Mortared Stone Table',
      'fr': 'Table en pierre mortier',
      'es': 'Mesa de piedra con mortero',
      'de': 'Gemörtelter Steintisch',
      'pl': 'Kamienny stół z zaprawą murarską',
      'ru': 'Каменный стол с известковым раствором',
      'uk': 'Кам\u0027яний стіл з розчином',
      'ko': '박격포 석재 테이블',
      'zh': '砂浆石桌',
      'ja': 'モルタルストーンテーブル'
    }, {
      'id': 'MountainGoatCarcassItem',
      'en': 'Mountain Goat Carcass',
      'fr': 'Carcasse de chèvre de montagne',
      'es': 'Canal de cabra montés',
      'de': 'Bergziegenkadaver',
      'pl': 'Tusza kozy górskiej',
      'ru': 'Туша горного козла',
      'uk': 'Тушка гірської кози',
      'ko': '산양의 시체',
      'zh': '山羊尸体',
      'ja': 'シロイワヤギの死骸'
    }, {
      'id': 'NailItem',
      'en': 'Nail',
      'fr': 'Clou',
      'es': 'Uña',
      'de': 'Nagel',
      'pl': 'Gwóźdź',
      'ru': 'Ноготь',
      'uk': 'Цвях',
      'ko': '못',
      'zh': '指甲',
      'ja': '爪'
    }, {
      'id': 'NaturalFiber',
      'en': 'Natural Fiber',
      'fr': 'Fibre Naturelle',
      'es': 'Fibra natural',
      'de': 'Naturfasern',
      'pl': 'Włókno naturalne',
      'ru': 'Натуральное волокно',
      'uk': 'Натуральне волокно',
      'ko': '천연 섬유',
      'zh': '天然纤维',
      'ja': '天然繊維'
    }, {
      'id': 'NormalHairItem',
      'en': 'Normal Hair',
      'fr': 'Cheveux normaux',
      'es': 'cabello normal',
      'de': 'Normales Haar',
      'pl': 'Włosy normalne',
      'ru': 'Нормальные волосы',
      'uk': 'Нормальне волосся',
      'ko': '일반 모발',
      'zh': '正常头发',
      'ja': '普通の髪'
    }, {
      'id': 'NuclearFuelItem',
      'en': 'Nuclear Fuel',
      'fr': 'Combustible nucléaire',
      'es': 'Combustible nuclear',
      'de': 'Kernbrennstoff',
      'pl': 'Paliwo jądrowe',
      'ru': 'Ядерное топливо',
      'uk': 'Ядерне паливо',
      'ko': '핵연료',
      'zh': '核燃料',
      'ja': '核燃料'
    }, {
      'id': 'NylonItem',
      'en': 'Nylon',
      'fr': 'Nylon',
      'es': 'Nylon',
      'de': 'Nylon',
      'pl': 'Nylon',
      'ru': 'Нейлон',
      'uk': 'нейлон',
      'ko': '나일론',
      'zh': '尼龙',
      'ja': 'ナイロン'
    }, {
      'id': 'NylonCarpetItem',
      'en': 'Nylon Carpet',
      'fr': 'Tapis en nylon',
      'es': 'Alfombra de nailon',
      'de': 'Nylonteppich',
      'pl': 'Dywan nylonowy',
      'ru': 'Нейлоновый ковер',
      'uk': 'Нейлоновий килим',
      'ko': '나일론 카펫',
      'zh': '尼龙地毯',
      'ja': 'ナイロンカーペット'
    }, {
      'id': 'NylonChipsItem',
      'en': 'Nylon Chips',
      'fr': 'Copeaux de nylon',
      'es': 'Virutas de nailon',
      'de': 'Nylon-Chips',
      'pl': 'Chipy nylonowe',
      'ru': 'Нейлоновые чипсы',
      'uk': 'Нейлонові чіпси',
      'ko': '나일론 칩',
      'zh': '尼龙片',
      'ja': 'ナイロンチップス'
    }, {
      'id': 'NylonCurtainsItem',
      'en': 'Nylon Curtains',
      'fr': 'Rideaux en nylon',
      'es': 'Cortinas de nailon',
      'de': 'Nylonvorhänge',
      'pl': 'Zasłony nylonowe',
      'ru': 'Нейлоновые шторы',
      'uk': 'Нейлонові штори',
      'ko': '나일론 커튼',
      'zh': '尼龙窗帘',
      'ja': 'ナイロンカーテン'
    }, {
      'id': 'NylonFabricItem',
      'en': 'Nylon Fabric',
      'fr': 'Tissu en nylon',
      'es': 'tela de nailon',
      'de': 'Nylongewebe',
      'pl': 'Tkanina nylonowa',
      'ru': 'Нейлоновая ткань',
      'uk': 'Нейлонова тканина',
      'ko': '나일론 원단',
      'zh': '尼龙面料',
      'ja': 'ナイロン生地'
    }, {
      'id': 'NylonFutonBedItem',
      'en': 'Nylon Futon Bed',
      'fr': 'Lit futon en nylon',
      'es': 'Cama futón de nailon',
      'de': 'Nylon-Futon-Bett',
      'pl': 'Nylonowe łóżko z futonem',
      'ru': 'Нейлоновая кровать футон',
      'uk': 'Ліжко-футон з нейлону',
      'ko': '나일론 이불',
      'zh': '尼龙蒲团床',
      'ja': 'ナイロン布団ベッド'
    }, {
      'id': 'NylonFutonCouchItem',
      'en': 'Nylon Futon Couch',
      'fr': 'Canapé futon en nylon',
      'es': 'Sofá futón de nailon',
      'de': 'Nylon-Futon-Couch',
      'pl': 'Nylonowa kanapa futonowa',
      'ru': 'Нейлоновый диван-футон',
      'uk': 'Нейлоновий диван-футон',
      'ko': '나일론 이불 소파',
      'zh': '尼龙蒲团沙发',
      'ja': 'ナイロン布団カウチ'
    }, {
      'id': 'NylonThreadItem',
      'en': 'Nylon Thread',
      'fr': 'Fil de nylon',
      'es': 'Hilo de nylon',
      'de': 'Nylon Faden',
      'pl': 'Nici nylonowe',
      'ru': 'Нейлоновая нить',
      'uk': 'Нейлонова нитка',
      'ko': '나일론 실',
      'zh': '尼龙线',
      'ja': 'ナイロン糸'
    }, {
      'id': 'OakLogItem',
      'en': 'Oak Log',
      'fr': 'Rondin de chêne',
      'es': 'tronco de roble',
      'de': 'Eichenholz',
      'pl': 'kłoda dębowa',
      'ru': 'Дубовое бревно',
      'uk': 'Дубова колода',
      'ko': '오크 로그',
      'zh': '橡木原木',
      'ja': 'オークログ'
    }, {
      'id': 'OceanSpraySeedItem',
      'en': 'Ocean Spray Seed',
      'fr': 'Graine de pulvérisation d\u0027océan',
      'es': 'Semilla de spray oceánico',
      'de': 'Ozean-Spray-Samen',
      'pl': 'Nasiona w sprayu oceanicznym',
      'ru': 'Семя океанского брызга',
      'uk': 'Ocean Spray Seed',
      'ko': '오션 스프레이 씨앗',
      'zh': '海洋喷雾种子',
      'ja': 'オーシャンスプレーシード'
    }, {
      'id': 'OfficeMailboxItem',
      'en': 'Office Mailbox',
      'fr': 'Boîte aux lettres de bureau',
      'es': 'Buzón de oficina',
      'de': 'Office-Postfach',
      'pl': 'Skrzynka pocztowa w biurze',
      'ru': 'Офисный почтовый ящик',
      'uk': 'Офісна поштова скринька',
      'ko': '사무실 사서함',
      'zh': '办公室邮箱',
      'ja': 'Officeメールボックス'
    }, {
      'id': 'OilItem',
      'en': 'Oil',
      'fr': 'Pétrole',
      'es': 'Aceite',
      'de': 'Öl',
      'pl': 'Olej',
      'ru': 'Масло',
      'uk': 'нафта',
      'ko': '기름',
      'zh': '油',
      'ja': '油'
    }, {
      'id': 'OilDrillingUpgradeItem',
      'en': 'Oil Drilling Upgrade',
      'fr': 'Mise à niveau du forage pétrolier',
      'es': 'Actualización de perforación petrolera',
      'de': 'Ölbohr-Upgrade',
      'pl': 'Modernizacja odwiertów naftowych',
      'ru': 'Модернизация бурения нефтяных скважин',
      'uk': 'Оновлення буріння нафти',
      'ko': '석유 시추 업그레이드',
      'zh': '石油钻井升级',
      'ja': '石油掘削のアップグレード'
    }, {
      'id': 'OilRefineryItem',
      'en': 'Oil Refinery',
      'fr': 'Raffinerie de pétrole',
      'es': 'Refinería de petróleo',
      'de': 'Ölraffinerie',
      'pl': 'Rafineria ropy',
      'ru': 'Нефтеперегонный завод',
      'uk': 'Нафтопереробний завод',
      'ko': '정유',
      'zh': '炼油厂',
      'ja': '石油精製所'
    }, {
      'id': 'OrchidSeedItem',
      'en': 'Orchid Seed',
      'fr': 'Graine d\u0027orchidée',
      'es': 'Semilla de orquídea',
      'de': 'Orchideensamen',
      'pl': 'Nasiona orchidei',
      'ru': 'Семя орхидеи',
      'uk': 'Насіння орхідеї',
      'ko': '난초 씨앗',
      'zh': '兰花种子',
      'ja': '蘭の種'
    }, {
      'id': 'Ore',
      'en': 'Ore',
      'fr': 'Minerai',
      'es': 'Mineral',
      'de': 'Erz',
      'pl': 'Kruszec',
      'ru': 'руда',
      'uk': 'руда',
      'ko': '광석',
      'zh': '矿石',
      'ja': '鉱石'
    }, {
      'id': 'OtterCarcassItem',
      'en': 'Otter Carcass',
      'fr': 'Carcasse de loutre',
      'es': 'Cadáver de nutria',
      'de': 'Otter-Kadaver',
      'pl': 'Tusza wydry',
      'ru': 'Туша выдры',
      'uk': 'Туша видри',
      'ko': '수달 시체',
      'zh': '水獭尸体',
      'ja': 'カワウソの死骸'
    }, {
      'id': 'PacificSardineItem',
      'en': 'Pacific Sardine',
      'fr': 'Sardine du Pacifique',
      'es': 'Sardina del Pacífico',
      'de': 'Pazifische Sardine',
      'pl': 'Sardynka Pacyficzna',
      'ru': 'Тихоокеанская сардина',
      'uk': 'Тихоокеанська сардина',
      'ko': '태평양 정어리',
      'zh': '太平洋沙丁鱼',
      'ja': 'パシフィックイワシ'
    }, {
      'id': 'PaddedChairItem',
      'en': 'Padded Chair',
      'fr': 'Chaise rembourrée',
      'es': 'silla acolchada',
      'de': 'Gepolsterter Stuhl',
      'pl': 'Wyściełane krzesło',
      'ru': 'Мягкий стул',
      'uk': 'М\u0027який стілець',
      'ko': '푹신한 의자',
      'zh': '软垫椅子',
      'ja': 'パッド入りの椅子'
    }, {
      'id': 'PalmLogItem',
      'en': 'Palm Log',
      'fr': 'Bûche de palmier',
      'es': 'tronco de palma',
      'de': 'Palm-Protokoll',
      'pl': 'Dziennik palmowy',
      'ru': 'Пальмовое бревно',
      'uk': 'Palm Log',
      'ko': '팜 로그',
      'zh': '棕榈原木',
      'ja': 'パームログ'
    }, {
      'id': 'PalmSeedItem',
      'en': 'Palm Seed',
      'fr': 'Graine de palmier',
      'es': 'semilla de palma',
      'de': 'Palmensamen',
      'pl': 'Nasiona palmy',
      'ru': 'Семя пальмы',
      'uk': 'Насіння пальми',
      'ko': '야자씨',
      'zh': '棕榈种子',
      'ja': 'パームシード'
    }, {
      'id': 'PapayaItem',
      'en': 'Papaya',
      'fr': 'Papaye',
      'es': 'Papaya',
      'de': 'Papaya',
      'pl': 'Papaja',
      'ru': 'Папайя',
      'uk': 'папайя',
      'ko': '파파야',
      'zh': '番木瓜',
      'ja': 'パパイヤ'
    }, {
      'id': 'PapayaSeedItem',
      'en': 'Papaya Seed',
      'fr': 'Graine de papaye',
      'es': 'semilla de papaya',
      'de': 'Papayasamen',
      'pl': 'Nasiona papai',
      'ru': 'Семена папайи',
      'uk': 'Насіння папайї',
      'ko': '파파야 씨',
      'zh': '木瓜种子',
      'ja': 'パパイヤシード'
    }, {
      'id': 'PaperItem',
      'en': 'Paper',
      'fr': 'Papier',
      'es': 'Papel',
      'de': 'Papier',
      'pl': 'Papier',
      'ru': 'Бумага',
      'uk': 'Папір',
      'ko': '종이',
      'zh': '纸',
      'ja': '紙'
    }, {
      'id': 'PaperMachineItem',
      'en': 'Paper Machine',
      'fr': 'Machine à papier',
      'es': 'Máquina de papel',
      'de': 'Papiermaschine',
      'pl': 'Maszyna papiernicza',
      'ru': 'Бумажная машина',
      'uk': 'Паперова машина',
      'ko': '종이 기계',
      'zh': '造纸机',
      'ja': '抄紙機'
    }, {
      'id': 'PaperMillingUpgradeItem',
      'en': 'Paper Milling Upgrade',
      'fr': 'Mise à niveau de la papeterie',
      'es': 'Actualización de la molienda de papel',
      'de': 'Papiermühlen-Upgrade',
      'pl': 'Ulepszenie frezowania papieru',
      'ru': 'Модернизация бумажного производства',
      'uk': 'Оновлення паперового фрезерування',
      'ko': '제지 업그레이드',
      'zh': '造纸厂升级',
      'ja': '製紙工場のアップグレード'
    }, {
      'id': 'PastryDoughItem',
      'en': 'Pastry Dough',
      'fr': 'Pâte à tarte',
      'es': 'Masa de reposteria',
      'de': 'Teig',
      'pl': 'Ciasto Ciasto',
      'ru': 'Тесто для кондитерских изделий',
      'uk': 'Кондитерське тісто',
      'ko': '페이스트리 반죽',
      'zh': '糕点面团',
      'ja': 'ペストリー生地'
    }, {
      'id': 'PeasantHairItem',
      'en': 'Peasant Hair',
      'fr': 'Cheveux de paysan',
      'es': 'Cabello Campesino',
      'de': 'Bauernhaar',
      'pl': 'Chłopskie Włosy',
      'ru': 'Крестьянские Волосы',
      'uk': 'Селянське волосся',
      'ko': '농부 머리',
      'zh': '农民头发',
      'ja': '農民の髪'
    }, {
      'id': 'PeltFertilizerItem',
      'en': 'Pelt Fertilizer',
      'fr': 'Engrais pour peaux',
      'es': 'Fertilizante de piel',
      'de': 'Felldünger',
      'pl': 'Nawóz do skórek',
      'ru': 'Удобрение для шкур',
      'uk': 'Шкура добрива',
      'ko': '펠트 비료',
      'zh': '毛皮肥料',
      'ja': '毛皮肥料'
    }, {
      'id': 'PetroleumItem',
      'en': 'Petroleum',
      'fr': 'Pétrole',
      'es': 'Petróleo',
      'de': 'Petroleum',
      'pl': 'Ropa naftowa',
      'ru': 'Нефть',
      'uk': 'Нафта',
      'ko': '석유',
      'zh': '石油',
      'ja': '石油'
    }, {
      'id': 'PhadThaiItem',
      'en': 'Phad Thai',
      'fr': 'Phad thaï',
      'es': 'Phad tailandés',
      'de': 'Phad Thai',
      'pl': 'Phad Thai',
      'ru': 'Пад Тай',
      'uk': 'Phad Thai',
      'ko': '팟타이',
      'zh': '泰语',
      'ja': 'パッタイ'
    }, {
      'id': 'PhosphateFertilizerItem',
      'en': 'Phosphate Fertilizer',
      'fr': 'Engrais phosphaté',
      'es': 'Fertilizante de fosfato',
      'de': 'Phosphatdünger',
      'pl': 'Nawóz fosforanowy',
      'ru': 'Фосфорные удобрения',
      'uk': 'Фосфатне добриво',
      'ko': '인산염 비료',
      'zh': '磷肥',
      'ja': 'リン酸肥料'
    }, {
      'id': 'PickaxeItem',
      'en': 'Pickaxe',
      'fr': 'Pioche',
      'es': 'Pico',
      'de': 'Spitzhacke',
      'pl': 'Kilof',
      'ru': 'Кирка',
      'uk': 'Кирка',
      'ko': '곡괭이',
      'zh': '镐',
      'ja': 'つるはし'
    }, {
      'id': 'PineappleItem',
      'en': 'Pineapple',
      'fr': 'Ananas',
      'es': 'Piña',
      'de': 'Ananas',
      'pl': 'Ananas',
      'ru': 'Ананас',
      'uk': 'ананас',
      'ko': '파인애플',
      'zh': '菠萝',
      'ja': 'パイナップル'
    }, {
      'id': 'PineappleFriendRiceItem',
      'en': 'Pineapple Friend Rice',
      'fr': 'Riz d\u0027ami à l\u0027ananas',
      'es': 'Arroz Amigo De La Piña',
      'de': 'Ananas-Freund-Reis',
      'pl': 'Ananasowy Przyjaciel Ryż',
      'ru': 'Ананасовый друг рис',
      'uk': 'Ананас Друг Рис',
      'ko': '파인애플 프렌드 라이스',
      'zh': '菠萝朋友饭',
      'ja': 'パイナップルフレンドライス'
    }, {
      'id': 'PineappleSeedItem',
      'en': 'Pineapple Seed',
      'fr': 'Graine d\u0027Ananas',
      'es': 'Semilla de Piña',
      'de': 'Ananassamen',
      'pl': 'Nasiona ananasa',
      'ru': 'Семя ананаса',
      'uk': 'Насіння ананаса',
      'ko': '파인애플 씨',
      'zh': '菠萝籽',
      'ja': 'パイナップルシード'
    }, {
      'id': 'PirozhokItem',
      'en': 'Pirozhok',
      'fr': 'Pirozhok',
      'es': 'pirozhok',
      'de': 'Pirozhok',
      'pl': 'Pirozhok',
      'ru': 'Пирожок',
      'uk': 'Пірожок',
      'ko': '피로조크',
      'zh': '皮罗若克',
      'ja': 'ピロシキ'
    }, {
      'id': 'PlantFibersItem',
      'en': 'Plant Fibers',
      'fr': 'Fibres Végétales',
      'es': 'Fibras Vegetales',
      'de': 'Pflanzenfasern',
      'pl': 'Włókna roślinne',
      'ru': 'Растительные волокна',
      'uk': 'Рослинні волокна',
      'ko': '식물 섬유',
      'zh': '植物纤维',
      'ja': '植物繊維'
    }, {
      'id': 'PlasticItem',
      'en': 'Plastic',
      'fr': 'Plastique',
      'es': 'El plastico',
      'de': 'Kunststoff',
      'pl': 'Plastikowy',
      'ru': 'Пластик',
      'uk': 'Пластикові',
      'ko': '플라스틱',
      'zh': '塑料',
      'ja': 'プラスチック'
    }, {
      'id': 'PokeBowlItem',
      'en': 'Poke Bowl',
      'fr': 'Poké Bol',
      'es': 'Cuenco de poke',
      'de': 'Poke-Bowl',
      'pl': 'Poke Bowl',
      'ru': 'Поке Боул',
      'uk': 'Poke Bowl',
      'ko': '포크 볼',
      'zh': '戳碗',
      'ja': 'ポケボウル'
    }, {
      'id': 'PortableSteamEngineItem',
      'en': 'Portable Steam Engine',
      'fr': 'Machine à vapeur portative',
      'es': 'Máquina de vapor portátil',
      'de': 'Tragbare Dampfmaschine',
      'pl': 'Przenośny silnik parowy',
      'ru': 'Портативный паровой двигатель',
      'uk': 'Портативний паровий двигун',
      'ko': '휴대용 증기 기관',
      'zh': '便携式蒸汽机',
      'ja': 'ポータブル蒸気エンジン'
    }, {
      'id': 'PotteryUpgradeItem',
      'en': 'Pottery Upgrade',
      'fr': 'Amélioration de la poterie',
      'es': 'Actualización de cerámica',
      'de': 'Keramik-Upgrade',
      'pl': 'Ulepszenie ceramiki',
      'ru': 'Обновление керамики',
      'uk': 'Оновлення кераміки',
      'ko': '도자기 업그레이드',
      'zh': '陶器升级',
      'ja': '陶器のアップグレード'
    }, {
      'id': 'Power',
      'en': 'Power',
      'fr': 'Du pouvoir',
      'es': 'Energía',
      'de': 'Leistung',
      'pl': 'Moc',
      'ru': 'Сила',
      'uk': 'Потужність',
      'ko': '힘',
      'zh': '力量',
      'ja': '力'
    }, {
      'id': 'PoweredCartItem',
      'en': 'Powered Cart',
      'fr': 'Chariot motorisé',
      'es': 'Carro motorizado',
      'de': 'Angetriebener Wagen',
      'pl': 'Zasilany wózek',
      'ru': 'Тележка с электроприводом',
      'uk': 'Електричний кошик',
      'ko': '전원 카트',
      'zh': '电动推车',
      'ja': 'パワードカート'
    }, {
      'id': 'PoweredStorageSiloItem',
      'en': 'Powered Storage Silo',
      'fr': 'Silo de stockage alimenté',
      'es': 'Silo de almacenamiento motorizado',
      'de': 'Angetriebenes Lagersilo',
      'pl': 'Zasilany silos magazynowy',
      'ru': 'Бункер для хранения с электроприводом',
      'uk': 'Електричний силос для зберігання',
      'ko': '파워드 스토리지 사일로',
      'zh': '动力存储筒仓',
      'ja': 'パワードストレージサイロ'
    }, {
      'id': 'PrairieDogCarcassItem',
      'en': 'Prairie Dog Carcass',
      'fr': 'Carcasse de chien de prairie',
      'es': 'Cadáver de perrito de las praderas',
      'de': 'Präriehund-Kadaver',
      'pl': 'Tusza psa preriowego',
      'ru': 'Туша луговой собачки',
      'uk': 'Тушка лугового собаки',
      'ko': '프레리 도그 시체',
      'zh': '土拨鼠尸体',
      'ja': 'プレーリードッグの死骸'
    }, {
      'id': 'PreparedMeatItem',
      'en': 'Prepared Meat',
      'fr': 'Viande Préparée',
      'es': 'Carne Preparada',
      'de': 'Zubereitetes Fleisch',
      'pl': 'Mięso przetworzone',
      'ru': 'Готовое мясо',
      'uk': 'Готове м\u0027ясо',
      'ko': '준비된 고기',
      'zh': '熟肉',
      'ja': '準備された肉'
    }, {
      'id': 'PricklyPearFruitItem',
      'en': 'Prickly Pear Fruit',
      'fr': 'Figue de Barbarie',
      'es': 'Fruta de tuna',
      'de': 'Kaktusfeigenfrucht',
      'pl': 'Owoce Opuncji',
      'ru': 'Плод опунции',
      'uk': 'Плоди опунції',
      'ko': '의욕적인 배 과일',
      'zh': '刺梨果实',
      'ja': 'ウチワサボテンの果実'
    }, {
      'id': 'PricklyPearSeedItem',
      'en': 'Prickly Pear Seed',
      'fr': 'Graine de figue de barbarie',
      'es': 'Semilla de higo chumbo',
      'de': 'Kaktusfeige Samen',
      'pl': 'Nasiona opuncji',
      'ru': 'Семя опунции',
      'uk': 'Насіння опунції',
      'ko': '의욕적인 배 씨앗',
      'zh': '仙人掌种子',
      'ja': 'ウチワサボテンの種'
    }, {
      'id': 'PrimeCutItem',
      'en': 'Prime Cut',
      'fr': 'Premier coupe',
      'es': 'Primer corte',
      'de': 'Prime-Schnitt',
      'pl': 'Prime Cut',
      'ru': 'Прайм-срез',
      'uk': 'Prime Cut',
      'ko': '프라임 컷',
      'zh': '主要切割',
      'ja': 'プライムカット'
    }, {
      'id': 'PrintingPressItem',
      'en': 'Printing Press',
      'fr': 'Presse d\u0027imprimerie',
      'es': 'Imprenta',
      'de': 'Druckerpresse',
      'pl': 'Prasa drukarska',
      'ru': 'Печатный станок',
      'uk': 'Друкарський верстат',
      'ko': '인쇄기',
      'zh': '印刷机',
      'ja': '印刷機'
    }, {
      'id': 'PulpFillerItem',
      'en': 'Pulp Filler',
      'fr': 'Remplisseur de pulpe',
      'es': 'Relleno de pulpa',
      'de': 'Zellstoff-Füller',
      'pl': 'Wypełniacz miazgi',
      'ru': 'Целлюлозный наполнитель',
      'uk': 'Наповнювач целюлози',
      'ko': '펄프 필러',
      'zh': '纸浆填料',
      'ja': 'パルプフィラー'
    }, {
      'id': 'PumpJackItem',
      'en': 'Pump Jack',
      'fr': 'Cric à pompe',
      'es': 'Bomba extractora',
      'de': 'Pumpenheber',
      'pl': 'Pompa Jack',
      'ru': 'насос домкрат',
      'uk': 'Джек насоса',
      'ko': '펌프 잭',
      'zh': '泵千斤顶',
      'ja': 'ポンプジャック'
    }, {
      'id': 'PumpkinItem',
      'en': 'Pumpkin',
      'fr': 'Citrouille',
      'es': 'Calabaza',
      'de': 'Kürbis',
      'pl': 'Dynia',
      'ru': 'тыква',
      'uk': 'Гарбуз',
      'ko': '호박',
      'zh': '南瓜',
      'ja': 'かぼちゃ'
    }, {
      'id': 'PumpkinSeedItem',
      'en': 'Pumpkin Seed',
      'fr': 'Graine de citrouille',
      'es': 'Semilla de calabaza',
      'de': 'Kürbissamen',
      'pl': 'Nasiona dyni',
      'ru': 'Тыквенное семечко',
      'uk': 'Насіння гарбуза',
      'ko': '호박씨',
      'zh': '南瓜种子',
      'ja': 'カボチャの種'
    }, {
      'id': 'PupusasItem',
      'en': 'Pupusas',
      'fr': 'Pupuses',
      'es': 'pupusas',
      'de': 'pupusas',
      'pl': 'Pupusas',
      'ru': 'Куколки',
      'uk': 'Пупуси',
      'ko': '푸푸사스',
      'zh': '普普萨斯',
      'ja': 'ププサ'
    }, {
      'id': 'QuicklimeItem',
      'en': 'Quicklime',
      'fr': 'Chaux vive',
      'es': 'Cal viva',
      'de': 'Branntkalk',
      'pl': 'Wapno palone',
      'ru': 'негашеная известь',
      'uk': 'Негашене вапно',
      'ko': '생석회',
      'zh': '生石灰',
      'ja': '生石灰'
    }, {
      'id': 'RadiatorItem',
      'en': 'Radiator',
      'fr': 'Radiateur',
      'es': 'Radiador',
      'de': 'Kühler',
      'pl': 'Kaloryfer',
      'ru': 'Радиатор',
      'uk': 'Радіатор',
      'ko': '라디에이터',
      'zh': '散热器',
      'ja': 'ラジエーター'
    }, {
      'id': 'RawBaconItem',
      'en': 'Raw Bacon',
      'fr': 'Lard cru',
      'es': 'tocino crudo',
      'de': 'Roher Speck',
      'pl': 'Surowy Boczek',
      'ru': 'Сырой бекон',
      'uk': 'Сирий бекон',
      'ko': '생 베이컨',
      'zh': '生培根',
      'ja': '生ベーコン'
    }, {
      'id': 'RawFishItem',
      'en': 'Raw Fish',
      'fr': 'Poisson cru',
      'es': 'Pescado crudo',
      'de': 'Roher Fisch',
      'pl': 'Surowa ryba',
      'ru': 'Сырая рыба',
      'uk': 'Сира риба',
      'ko': '생선',
      'zh': '生鱼',
      'ja': '生の魚'
    }, {
      'id': 'RawFood',
      'en': 'Raw Food',
      'fr': 'Nourriture crue',
      'es': 'Alimentos crudos',
      'de': 'Rohkost',
      'pl': 'Surowe jedzenie',
      'ru': 'Сырая пища',
      'uk': 'Сира їжа',
      'ko': '생식',
      'zh': '生食',
      'ja': '生物'
    }, {
      'id': 'RawMeatItem',
      'en': 'Raw Meat',
      'fr': 'Viande crue',
      'es': 'Carne cruda',
      'de': 'Rohes Fleisch',
      'pl': 'Surowe mięso',
      'ru': 'Сырое мясо',
      'uk': 'Сире м\u0027ясо',
      'ko': '생고기',
      'zh': '生肉',
      'ja': '生肉'
    }, {
      'id': 'RawRoastItem',
      'en': 'Raw Roast',
      'fr': 'Rôti cru',
      'es': 'asado crudo',
      'de': 'Roher Braten',
      'pl': 'Surowa Pieczeń',
      'ru': 'Сырое жаркое',
      'uk': 'Сире смажене',
      'ko': '생 로스트',
      'zh': '生烤',
      'ja': '生焙煎'
    }, {
      'id': 'RawSausageItem',
      'en': 'Raw Sausage',
      'fr': 'Saucisse crue',
      'es': 'Salchicha Cruda',
      'de': 'Rohwurst',
      'pl': 'Kiełbasa Surowa',
      'ru': 'Сырая колбаса',
      'uk': 'Сира ковбаса',
      'ko': '생 소시지',
      'zh': '生香肠',
      'ja': '生ソーセージ'
    }, {
      'id': 'RealEstateDeskItem',
      'en': 'Real Estate Desk',
      'fr': 'Bureau de l\u0027immobilier',
      'es': 'Escritorio de Bienes Raíces',
      'de': 'Immobilien-Schreibtisch',
      'pl': 'Biuro nieruchomości',
      'ru': 'Отдел недвижимости',
      'uk': 'Бюро нерухомості',
      'ko': '부동산 데스크',
      'zh': '房地产服务台',
      'ja': '不動産デスク'
    }, {
      'id': 'RebarItem',
      'en': 'Rebar',
      'fr': 'Barre d\u0027armature',
      'es': 'barra de refuerzo',
      'de': 'Bewehrung',
      'pl': 'Zbrojenie',
      'ru': 'Арматура',
      'uk': 'Арматура',
      'ko': '철근',
      'zh': '钢筋',
      'ja': '鉄筋'
    }, {
      'id': 'RecurveBowItem',
      'en': 'Recurve Bow',
      'fr': 'Arc classique',
      'es': 'Arco recurvo',
      'de': 'Recurvebogen',
      'pl': 'Wygięty łuk',
      'ru': 'Изогнутый лук',
      'uk': 'Вигнутий лук',
      'ko': '리커브 보우',
      'zh': '反曲弓',
      'ja': '後ろに反らす弓'
    }, {
      'id': 'RedwoodLogItem',
      'en': 'Redwood Log',
      'fr': 'Bûche de séquoia',
      'es': 'Tronco de secoya',
      'de': 'Redwood-Protokoll',
      'pl': 'Kłoda sekwoja',
      'ru': 'Бревно красного дерева',
      'uk': 'Колода червоного дерева',
      'ko': '레드우드 로그',
      'zh': '红木原木',
      'ja': 'レッドウッドログ'
    }, {
      'id': 'RedwoodSeedItem',
      'en': 'Redwood Seed',
      'fr': 'Graine de séquoia',
      'es': 'Semilla de secoya',
      'de': 'Redwood-Samen',
      'pl': 'Nasiona sekwoi',
      'ru': 'Семена красного дерева',
      'uk': 'Насіння червоного дерева',
      'ko': '레드우드 씨앗',
      'zh': '红木种子',
      'ja': 'レッドウッドシード'
    }, {
      'id': 'RefrigeratorItem',
      'en': 'Refrigerator',
      'fr': 'Réfrigérateur',
      'es': 'Refrigerador',
      'de': 'Kühlschrank',
      'pl': 'Lodówka',
      'ru': 'Холодильник',
      'uk': 'Холодильник',
      'ko': '냉장고',
      'zh': '冰箱',
      'ja': '冷蔵庫'
    }, {
      'id': 'RegistrarItem',
      'en': 'Registrar',
      'fr': 'Greffier',
      'es': 'Registrador',
      'de': 'Registrator',
      'pl': 'Rejestrator',
      'ru': 'Регистратор',
      'uk': 'реєстратор',
      'ko': '기록 사무관',
      'zh': '注册商',
      'ja': 'レジストラ'
    }, {
      'id': 'ReinforcedConcreteItem',
      'en': 'Reinforced Concrete',
      'fr': 'Béton armé',
      'es': 'Concreto reforzado',
      'de': 'Verstärkter Beton',
      'pl': 'Żelbetowe',
      'ru': 'Железобетон',
      'uk': 'Залізобетон',
      'ko': '철근 콘크리트',
      'zh': '钢筋混凝土',
      'ja': '強化コンクリート'
    }, {
      'id': 'Research',
      'en': 'Research',
      'fr': 'Rechercher',
      'es': 'Investigar',
      'de': 'Forschung',
      'pl': 'Badania',
      'ru': 'Исследовательская работа',
      'uk': 'Дослідження',
      'ko': '연구',
      'zh': '研究',
      'ja': 'リサーチ'
    }, {
      'id': 'ResearchTableItem',
      'en': 'Research Table',
      'fr': 'Tableau de recherche',
      'es': 'Mesa de investigación',
      'de': 'Forschungstabelle',
      'pl': 'Tabela badawcza',
      'ru': 'Таблица исследований',
      'uk': 'Таблиця досліджень',
      'ko': '연구 테이블',
      'zh': '研究表',
      'ja': '調査表'
    }, {
      'id': 'RiceItem',
      'en': 'Rice',
      'fr': 'Riz',
      'es': 'Arroz',
      'de': 'Reis',
      'pl': 'Ryż',
      'ru': 'Рис',
      'uk': 'рис',
      'ko': '쌀',
      'zh': '米',
      'ja': '米'
    }, {
      'id': 'RiceFlourItem',
      'en': 'Rice Flour',
      'fr': 'Farine de riz',
      'es': 'Harina de arroz',
      'de': 'Reismehl',
      'pl': 'Mąka ryżowa',
      'ru': 'Рисовая мука',
      'uk': 'Рисове борошно',
      'ko': '쌀가루',
      'zh': '米粉',
      'ja': '米粉'
    }, {
      'id': 'RiceNoodlesItem',
      'en': 'Rice Noodles',
      'fr': 'Nouilles de riz',
      'es': 'Fideos de arroz',
      'de': 'Reisnudeln',
      'pl': 'Makaron ryżowy',
      'ru': 'Рисовая лапша',
      'uk': 'Рисова локшина',
      'ko': '쌀국수',
      'zh': '米粉',
      'ja': 'ライスヌードル'
    }, {
      'id': 'RivetItem',
      'en': 'Rivet',
      'fr': 'Rivet',
      'es': 'Remache',
      'de': 'Niet',
      'pl': 'Nit',
      'ru': 'Заклепка',
      'uk': 'Заклепка',
      'ko': '대갈못',
      'zh': '铆钉',
      'ja': 'リベット'
    }, {
      'id': 'RoastPumpkinItem',
      'en': 'Roast Pumpkin',
      'fr': 'Citrouille rôtie',
      'es': 'Calabaza Asada',
      'de': 'Gebratener Kürbis',
      'pl': 'Pieczona Dynia',
      'ru': 'Жареная тыква',
      'uk': 'Смажений гарбуз',
      'ko': '구운 호박',
      'zh': '烤南瓜',
      'ja': 'カボチャの焙煎'
    }, {
      'id': 'RoboticAssemblyLineItem',
      'en': 'Robotic Assembly Line',
      'fr': 'Chaîne de montage robotique',
      'es': 'Línea de montaje robótica',
      'de': 'Roboter-Fließband',
      'pl': 'Robotyczna linia montażowa',
      'ru': 'Роботизированная сборочная линия',
      'uk': 'Роботизована складальна лінія',
      'ko': '로봇 조립 라인',
      'zh': '机器人装配线',
      'ja': 'ロボット組立ライン'
    }, {
      'id': 'Rock',
      'en': 'Rock',
      'fr': 'Rock',
      'es': 'Roca',
      'de': 'Felsen',
      'pl': 'Głaz',
      'ru': 'Камень',
      'uk': 'Рок',
      'ko': '바위',
      'zh': '岩石',
      'ja': '石'
    }, {
      'id': 'RockerBoxItem',
      'en': 'Rocker Box',
      'fr': 'Boîte à bascule',
      'es': 'Caja de balancines',
      'de': 'Rocker-Box',
      'pl': 'Rocker Box',
      'ru': 'Рокер Коробка',
      'uk': 'Рокерна коробка',
      'ko': '로커 박스',
      'zh': '摇杆箱',
      'ja': 'ロッカーボックス'
    }, {
      'id': 'RollingMillItem',
      'en': 'Rolling Mill',
      'fr': 'Laminoir',
      'es': 'Taller de laminación',
      'de': 'Walzwerk',
      'pl': 'Walcownia',
      'ru': 'Прокатный стан',
      'uk': 'Прокатний стан',
      'ko': '압연 공장',
      'zh': '轧机',
      'ja': '圧延装置'
    }, {
      'id': 'RootCampfireSaladItem',
      'en': 'Root Campfire Salad',
      'fr': 'Salade de racines au feu de camp',
      'es': 'Ensalada De Fogata De Raíz',
      'de': 'Wurzel-Lagerfeuer-Salat',
      'pl': 'Sałatka z Ogniskiem Korzeń',
      'ru': 'Салат из корней у костра',
      'uk': 'Салат з коренем багаття',
      'ko': '루트 캠프파이어 샐러드',
      'zh': '根营火沙拉',
      'ja': 'ルートキャンプファイヤーサラダ'
    }, {
      'id': 'RootCampfireStewItem',
      'en': 'Root Campfire Stew',
      'fr': 'Ragoût de racine au feu de camp',
      'es': 'Guiso de hoguera de raíz',
      'de': 'Lagerfeuereintopf mit Wurzeln',
      'pl': 'Korzeń Ogniska Gulasz',
      'ru': 'Похлебка из корней у костра',
      'uk': 'Тушковане з коренеплоду багаття',
      'ko': '루트 모닥불 스튜',
      'zh': '根营火炖',
      'ja': 'ルートキャンプファイヤーシチュー'
    }, {
      'id': 'PlanterPotRoundItem',
      'en': 'Round Pot',
      'fr': 'Pot rond',
      'es': 'Olla Redonda',
      'de': 'Runder Topf',
      'pl': 'Okrągły garnek',
      'ru': 'Круглый горшок',
      'uk': 'Круглий горщик',
      'ko': '둥근 냄비',
      'zh': '圆锅',
      'ja': 'ラウンドポット'
    }, {
      'id': 'RubberWheelItem',
      'en': 'Rubber Wheel',
      'fr': 'Roue en caoutchouc',
      'es': 'rueda de goma',
      'de': 'Gummirad',
      'pl': 'Gumowe koło',
      'ru': 'Резиновое колесо',
      'uk': 'Гумове колесо',
      'ko': '고무 바퀴',
      'zh': '橡胶轮',
      'ja': 'ラバーホイール'
    }, {
      'id': 'RugLargeItem',
      'en': 'Rug Large',
      'fr': 'Tapis Grand',
      'es': 'Alfombra Grande',
      'de': 'Teppich groß',
      'pl': 'Dywan duży',
      'ru': 'Ковер Большой',
      'uk': 'Килимок великий',
      'ko': '러그 라지',
      'zh': '大地毯',
      'ja': 'ラグラージ'
    }, {
      'id': 'RugMediumItem',
      'en': 'Rug Medium',
      'fr': 'Tapis moyen',
      'es': 'Alfombra Mediana',
      'de': 'Teppich mittel',
      'pl': 'Dywan średni',
      'ru': 'Ковер Средний',
      'uk': 'Килимок середній',
      'ko': '러그 미디엄',
      'zh': '地毯中号',
      'ja': 'ラグミディアム'
    }, {
      'id': 'RugSmallItem',
      'en': 'Rug Small',
      'fr': 'Tapis Petit',
      'es': 'Alfombra Pequeña',
      'de': 'Teppich klein',
      'pl': 'Dywan Mały',
      'ru': 'Ковер Маленький',
      'uk': 'Килимок маленький',
      'ko': '러그 스몰',
      'zh': '小地毯',
      'ja': 'ラグスモール'
    }, {
      'id': 'RunningShoesItem',
      'en': 'Running Shoes',
      'fr': 'Chaussures de course',
      'es': 'Zapatos para correr',
      'de': 'Laufschuhe',
      'pl': 'Buty do biegania',
      'ru': 'Беговая обувь',
      'uk': 'Кросівки',
      'ko': '운동화',
      'zh': '跑鞋',
      'ja': 'ランニングシューズ'
    }, {
      'id': 'SaguaroRibItem',
      'en': 'Saguaro Rib',
      'fr': 'Côte de Saguaro',
      'es': 'Costilla Saguaro',
      'de': 'Saguaro-Rippe',
      'pl': 'Żebro Saguaro',
      'ru': 'Ребро Сагуаро',
      'uk': 'Ребро сагуаро',
      'ko': '사와로 갈비',
      'zh': '仙人掌肋骨',
      'ja': 'サグアロリブ'
    }, {
      'id': 'SaguaroSeedItem',
      'en': 'Saguaro Seed',
      'fr': 'Graine de Saguaro',
      'es': 'Semilla de saguaro',
      'de': 'Saguaro-Samen',
      'pl': 'Nasiona Saguaro',
      'ru': 'Семя Сагуаро',
      'uk': 'Насіння сагуаро',
      'ko': '이구아로 씨앗',
      'zh': '仙人掌种子',
      'ja': 'サグアロシード'
    }, {
      'id': 'Salad',
      'en': 'Salad',
      'fr': 'salade',
      'es': 'Ensalada',
      'de': 'Salat',
      'pl': 'Sałatka',
      'ru': 'Салат',
      'uk': 'Салат',
      'ko': '샐러드',
      'zh': '沙拉',
      'ja': 'サラダ'
    }, {
      'id': 'SalmonItem',
      'en': 'Salmon',
      'fr': 'Saumon',
      'es': 'Salmón',
      'de': 'Lachs',
      'pl': 'Łosoś',
      'ru': 'Лосось',
      'uk': 'Лосось',
      'ko': '연어',
      'zh': '三文鱼',
      'ja': '鮭'
    }, {
      'id': 'SaltBasketItem',
      'en': 'Salt Basket',
      'fr': 'Panier à sel',
      'es': 'Cesta de sal',
      'de': 'Salzkorb',
      'pl': 'Kosz na sól',
      'ru': 'Соляная корзина',
      'uk': 'Кошик для солі',
      'ko': '소금 바구니',
      'zh': '盐篮',
      'ja': '塩かご'
    }, {
      'id': 'SandItem',
      'en': 'Sand',
      'fr': 'Le sable',
      'es': 'Arena',
      'de': 'Sand',
      'pl': 'Piasek',
      'ru': 'Песок',
      'uk': 'Пісок',
      'ko': '모래',
      'zh': '沙',
      'ja': '砂'
    }, {
      'id': 'SandstoneItem',
      'en': 'Sandstone',
      'fr': 'Grès',
      'es': 'Arenisca',
      'de': 'Sandstein',
      'pl': 'Piaskowiec',
      'ru': 'Песчаник',
      'uk': 'Пісковик',
      'ko': '사암',
      'zh': '砂岩',
      'ja': '砂岩'
    }, {
      'id': 'SawmillItem',
      'en': 'Sawmill',
      'fr': 'Scierie',
      'es': 'Aserradero',
      'de': 'Sägewerk',
      'pl': 'Tartak',
      'ru': 'Лесопилка',
      'uk': 'Лісопильний завод',
      'ko': '제재소',
      'zh': '锯木厂',
      'ja': '製材所'
    }, {
      'id': 'SaxifrageSeedItem',
      'en': 'Saxifrage Seed',
      'fr': 'Graine de saxifrage',
      'es': 'Semilla de saxifraga',
      'de': 'Steinbrechsamen',
      'pl': 'Nasiona skalnicy',
      'ru': 'Семя камнеломки',
      'uk': 'Насіння камнеломки',
      'ko': '색소폰 씨앗',
      'zh': '虎耳草种子',
      'ja': 'ユキノシタの種'
    }, {
      'id': 'ScrapMeatItem',
      'en': 'Scrap Meat',
      'fr': 'Déchets de viande',
      'es': 'Carne de desecho',
      'de': 'Fleischreste',
      'pl': 'Złom Mięsa',
      'ru': 'Мясной лом',
      'uk': 'М\u0027ясний лом',
      'ko': '스크랩 미트',
      'zh': '废肉',
      'ja': 'スクラップミート'
    }, {
      'id': 'ScreeningMachineItem',
      'en': 'Screening Machine',
      'fr': 'Machine de criblage',
      'es': 'Máquina de cribado',
      'de': 'Siebmaschine',
      'pl': 'Maszyna do przesiewania',
      'ru': 'Просеивающая машина',
      'uk': 'Машина для просіювання',
      'ko': '스크리닝 머신',
      'zh': '筛分机',
      'ja': 'スクリーニング機'
    }, {
      'id': 'ScrewPressItem',
      'en': 'Screw Press',
      'fr': 'Presse à vis',
      'es': 'Tornillo prensado',
      'de': 'Schneckenpresse',
      'pl': 'Prasa śrubowa',
      'ru': 'Винтовой пресс',
      'uk': 'Гвинтовий прес',
      'ko': '스크류 프레스',
      'zh': '螺旋压力机',
      'ja': 'スクリュープレス'
    }, {
      'id': 'ScrewsItem',
      'en': 'Screws',
      'fr': 'Des vis',
      'es': 'Tornillos',
      'de': 'Schrauben',
      'pl': 'Śruby',
      'ru': 'Винты',
      'uk': 'Гвинти',
      'ko': '나사',
      'zh': '螺丝',
      'ja': 'ネジ'
    }, {
      'id': 'ScruffyHairItem',
      'en': 'Scruffy Hair',
      'fr': 'Cheveux ébouriffés',
      'es': 'cabello desaliñado',
      'de': 'Schäbiges Haar',
      'pl': 'niechlujne włosy',
      'ru': 'Неряшливые волосы',
      'uk': 'Неряке волосся',
      'ko': '지저분한 머리',
      'zh': '邋遢的头发',
      'ja': 'だらしない髪'
    }, {
      'id': 'SeagrassSeedItem',
      'en': 'Seagrass Seed',
      'fr': 'Graine d\u0027herbe de mer',
      'es': 'Semilla de pasto marino',
      'de': 'Seegrassamen',
      'pl': 'Nasiona trawy morskiej',
      'ru': 'Семена водорослей',
      'uk': 'Насіння морської трави',
      'ko': '해초 씨앗',
      'zh': '海草种子',
      'ja': 'シーグラスシード'
    }, {
      'id': 'SearedMeatItem',
      'en': 'Seared Meat',
      'fr': 'Viande Poêlée',
      'es': 'Carne Chamuscada',
      'de': 'Gebratenes Fleisch',
      'pl': 'Pieczone mięso',
      'ru': 'Жареное мясо',
      'uk': 'Обсмажене м\u0027ясо',
      'ko': '구운 고기',
      'zh': '烤肉',
      'ja': '焼き肉'
    }, {
      'id': 'SeededCamasRollItem',
      'en': 'Seeded Camas Roll',
      'fr': 'Rouleau de camas ensemencées',
      'es': 'Rollo de Camas con Semillas',
      'de': 'Gesäte Camas-Rolle',
      'pl': 'Rolka z nasionami Camas',
      'ru': 'Камас Ролл с семенами',
      'uk': 'Ролл Camas з насінням',
      'ko': '시드 카마스 롤',
      'zh': '种子卡马斯卷',
      'ja': 'シードキャマスロール'
    }, {
      'id': 'Seeds',
      'en': 'Seeds',
      'fr': 'Des graines',
      'es': 'Semillas',
      'de': 'Saatgut',
      'pl': 'Posiew',
      'ru': 'Семена',
      'uk': 'Насіння',
      'ko': '씨앗',
      'zh': '种子',
      'ja': 'シード'
    }, {
      'id': 'SensorBasedBeltSorterItem',
      'en': 'Sensor Based Belt Sorter',
      'fr': 'Trieur de bande basé sur capteur',
      'es': 'Clasificador de banda basado en sensores',
      'de': 'Sensorbasierter Bandsortierer',
      'pl': 'Sortownik taśmowy oparty na czujnikach',
      'ru': 'Сенсорный сортировщик лент',
      'uk': 'Сортувальник на основі датчиків',
      'ko': '센서 기반 벨트 분류기',
      'zh': '基于传感器的皮带分拣机',
      'ja': 'センサーベースのベルトソーター'
    }, {
      'id': 'SensuousSeaPizzaItem',
      'en': 'Sensuous Sea Pizza',
      'fr': 'Pizza sensuelle de la mer',
      'es': 'Pizza de mar sensual',
      'de': 'Sinnliche Meerespizza',
      'pl': 'Zmysłowa Morska Pizza',
      'ru': 'Чувственная морская пицца',
      'uk': 'Чуттєва морська піца',
      'ko': '센슈어스 씨피자',
      'zh': '感性海比萨',
      'ja': '官能的な海のピザ'
    }, {
      'id': 'ServoItem',
      'en': 'Servo',
      'fr': 'Servomoteur',
      'es': 'servo',
      'de': 'Servo',
      'pl': 'Serwo',
      'ru': 'Сервопривод',
      'uk': 'Сервопривод',
      'ko': '서보 기구',
      'zh': '伺服',
      'ja': 'サーボ'
    }, {
      'id': 'ShaleItem',
      'en': 'Shale',
      'fr': 'Schiste argileux',
      'es': 'Esquisto',
      'de': 'Schiefer',
      'pl': 'Łupek ilasty',
      'ru': 'Сланец',
      'uk': 'Сланець',
      'ko': '혈암',
      'zh': '页岩',
      'ja': '頁岩'
    }, {
      'id': 'ShaperItem',
      'en': 'Shaper',
      'fr': 'Façonneur',
      'es': 'Moldeador',
      'de': 'Former',
      'pl': 'Shaper',
      'ru': 'Шейпер',
      'uk': 'Формувач',
      'ko': '셰이퍼',
      'zh': '塑形者',
      'ja': '形作る人'
    }, {
      'id': 'SharkFilletSoupItem',
      'en': 'Shark Fillet Soup',
      'fr': 'Soupe au filet de requin',
      'es': 'Sopa De Filete De Tiburón',
      'de': 'Haifischfilet-Suppe',
      'pl': 'Zupa z Polędwicy Z Rekina',
      'ru': 'Суп из филе акулы',
      'uk': 'Суп з філе акули',
      'ko': '상어 필레 수프',
      'zh': '鲨鱼片汤',
      'ja': 'サメの切り身のスープ'
    }, {
      'id': 'SheepMountItem',
      'en': 'Sheep Mount',
      'fr': 'Mont Mouton',
      'es': 'Monte Ovejas',
      'de': 'Schafberg',
      'pl': 'Wierzchowiec owiec',
      'ru': 'Овечья гора',
      'uk': 'Овечий гора',
      'ko': '쉽마운트',
      'zh': '羊山',
      'ja': '羊の山'
    }, {
      'id': 'ShelfCabinetItem',
      'en': 'Shelf Cabinet',
      'fr': 'Armoire à étagères',
      'es': 'Gabinete de estantería',
      'de': 'Regalschrank',
      'pl': 'Szafka z półkami',
      'ru': 'Полка Шкаф',
      'uk': 'Стелаж',
      'ko': '선반 캐비닛',
      'zh': '货架柜',
      'ja': '棚キャビネット'
    }, {
      'id': 'ShippingContainerBlueItem',
      'en': 'Shipping Container Blue',
      'fr': 'Conteneur d\u0027expédition bleu',
      'es': 'Contenedor de envío azul',
      'de': 'Versandbehälter Blau',
      'pl': 'Kontener wysyłkowy niebieski',
      'ru': 'Морской контейнер синий',
      'uk': 'Транспортний контейнер синій',
      'ko': '배송 컨테이너 블루',
      'zh': '海运集装箱蓝色',
      'ja': '輸送コンテナブルー'
    }, {
      'id': 'ShippingContainerGreenItem',
      'en': 'Shipping Container Green',
      'fr': 'Conteneur d\u0027expédition vert',
      'es': 'Contenedor de envío verde',
      'de': 'Versandbehälter grün',
      'pl': 'Pojemnik wysyłkowy zielony',
      'ru': 'Морской контейнер зеленый',
      'uk': 'Транспортний контейнер Зелений',
      'ko': '선적 컨테이너 그린',
      'zh': '海运集装箱绿色',
      'ja': '輸送コンテナグリーン'
    }, {
      'id': 'ShippingContainerRedItem',
      'en': 'Shipping Container Red',
      'fr': 'Conteneur d\u0027expédition Rouge',
      'es': 'Contenedor de envío rojo',
      'de': 'Versandbehälter Rot',
      'pl': 'Kontener wysyłkowy czerwony',
      'ru': 'Морской контейнер красный',
      'uk': 'Транспортний контейнер Червоний',
      'ko': '선적 컨테이너 레드',
      'zh': '集装箱红色',
      'ja': '輸送コンテナ赤'
    }, {
      'id': 'ShornWoolItem',
      'en': 'Shorn Wool',
      'fr': 'Laine tondue',
      'es': 'lana esquilada',
      'de': 'Geschorene Wolle',
      'pl': 'Strzyżona wełna',
      'ru': 'стриженая шерсть',
      'uk': 'Обстрижена шерсть',
      'ko': '뿔양털',
      'zh': '剪羊毛',
      'ja': 'Shorn Wool'
    }, {
      'id': 'ShortBeardItem',
      'en': 'Short Beard',
      'fr': 'Barbe courte',
      'es': 'Barba corta',
      'de': 'Kurzer Bart',
      'pl': 'Krótka broda',
      'ru': 'Короткая борода',
      'uk': 'Коротка борода',
      'ko': '짧은 수염',
      'zh': '短胡子',
      'ja': '短いあごひげ'
    }, {
      'id': 'ShortsItem',
      'en': 'Shorts',
      'fr': 'Shorts',
      'es': 'Pantalones cortos',
      'de': 'Kurze Hose',
      'pl': 'Spodenki',
      'ru': 'Шорты',
      'uk': 'Шорти',
      'ko': '반바지',
      'zh': '短裤',
      'ja': 'ショーツ'
    }, {
      'id': 'ShovelItem',
      'en': 'Shovel',
      'fr': 'Pelle',
      'es': 'Pala',
      'de': 'Schaufel',
      'pl': 'Łopata',
      'ru': 'Лопата',
      'uk': 'Лопата',
      'ko': '삽',
      'zh': '铲',
      'ja': 'シャベル'
    }, {
      'id': 'Silica',
      'en': 'Silica',
      'fr': 'Silice',
      'es': 'Sílice',
      'de': 'Kieselsäure',
      'pl': 'Krzemionka',
      'ru': 'Кремнезем',
      'uk': 'кремнезем',
      'ko': '규토',
      'zh': '二氧化硅',
      'ja': 'シリカ'
    }, {
      'id': 'SimmeredMeatItem',
      'en': 'Simmered Meat',
      'fr': 'Viande Mijotée',
      'es': 'Carne cocida a fuego lento',
      'de': 'Gekochtes Fleisch',
      'pl': 'Mięso Duszone',
      'ru': 'Вареное мясо',
      'uk': 'Варене м\u0027ясо',
      'ko': '조림 고기',
      'zh': '卤肉',
      'ja': '煮込み肉'
    }, {
      'id': 'SimpleSyrupItem',
      'en': 'Simple Syrup',
      'fr': 'Sirop simple',
      'es': 'Jarabe sencillo',
      'de': 'Einfacher Syrup',
      'pl': 'Prosty syrop',
      'ru': 'Обычный сироп',
      'uk': 'Простий сироп',
      'ko': '슈가시럽',
      'zh': '简单糖浆',
      'ja': 'シンプルなシロップ'
    }, {
      'id': 'SinkItem',
      'en': 'Sink',
      'fr': 'Évier',
      'es': 'Pileta',
      'de': 'Waschbecken',
      'pl': 'Zlew',
      'ru': 'Раковина',
      'uk': 'Раковина',
      'ko': '싱크대',
      'zh': '下沉',
      'ja': 'シンク'
    }, {
      'id': 'SkidSteerItem',
      'en': 'Skid Steer',
      'fr': 'Skid Steer',
      'es': 'Minicargador',
      'de': 'Kompaktlader',
      'pl': 'Skid Steer',
      'ru': 'Погрузчик с бортовым поворотом',
      'uk': 'Міні навантажувач',
      'ko': '스키드 스티어',
      'zh': '滑移',
      'ja': 'スキッドステア'
    }, {
      'id': 'Skill Scrolls',
      'en': 'Skill Scrolls',
      'fr': 'Parchemins de compétence',
      'es': 'Pergaminos de habilidad',
      'de': 'Skill-Schriftrollen',
      'pl': 'Zwoje umiejętności',
      'ru': 'Свитки навыков',
      'uk': 'Сувої навичок',
      'ko': '스킬 스크롤',
      'zh': '技能卷轴',
      'ja': 'スキルスクロール'
    }, {
      'id': 'SlagItem',
      'en': 'Slag',
      'fr': 'Scories',
      'es': 'Escoria',
      'de': 'Schlacke',
      'pl': 'Żużel',
      'ru': 'Шлак',
      'uk': 'Шлак',
      'ko': '광재',
      'zh': '矿渣',
      'ja': 'スラグ'
    }, {
      'id': 'SmallBathMatItem',
      'en': 'Small Bath Mat',
      'fr': 'Petit tapis de bain',
      'es': 'Alfombra de baño pequeña',
      'de': 'Kleine Badematte',
      'pl': 'Mała mata do kąpieli',
      'ru': 'Маленький коврик для ванной',
      'uk': 'Маленький килимок для ванни',
      'ko': '작은 목욕 매트',
      'zh': '小浴垫',
      'ja': '小さなバスマット'
    }, {
      'id': 'SmallCarcass',
      'en': 'Small Carcass',
      'fr': 'Petite carcasse',
      'es': 'Carcasa pequeña',
      'de': 'Kleine Karkasse',
      'pl': 'Mała tusza',
      'ru': 'Маленькая туша',
      'uk': 'Маленька тушка',
      'ko': '작은 시체',
      'zh': '小胴体',
      'ja': '小さな死骸'
    }, {
      'id': 'SmallFish',
      'en': 'Small Fish',
      'fr': 'Petit poisson',
      'es': 'Pez pequeño',
      'de': 'Kleiner Fisch',
      'pl': 'Mała ryba',
      'ru': 'Маленькая рыба',
      'uk': 'Маленька рибка',
      'ko': '작은 물고기',
      'zh': '小鱼',
      'ja': '小魚'
    }, {
      'id': 'SmallHangingAshlarBasaltSignItem',
      'en': 'Small Hanging Ashlar Basalt Sign',
      'fr': 'Petite enseigne en basalte en pierre de taille suspendue',
      'es': 'Letrero Colgante Pequeño de Sillería de Basalto',
      'de': 'Kleines hängendes Quader-Basalt-Schild',
      'pl': 'Mały wiszący znak bazaltowy z Ashlar',
      'ru': 'Маленький висячий базальтовый знак из тесаного камня',
      'uk': 'Невеликий висячий висячий базальтовий знак',
      'ko': '작은 교수형 Ashlar 현무암 기호',
      'zh': '小挂方石玄武岩标志',
      'ja': '小さなぶら下がっている切石玄武岩のサイン'
    }, {
      'id': 'SmallHangingAshlarGneissSignItem',
      'en': 'Small Hanging Ashlar Gneiss Sign',
      'fr': 'Petite enseigne suspendue en gneiss en pierre de taille',
      'es': 'Letrero Colgante Pequeño de Sillería Gneis',
      'de': 'Kleines hängendes Quader-Gneis-Schild',
      'pl': 'Mały wiszący znak z gnejsu Ashlar',
      'ru': 'Маленький висячий знак из тесаного камня и гнейса',
      'uk': 'Невеликий висячий знак з тесеняного гнейсу',
      'ko': '작은 교수형 Ashlar 편마암 기호',
      'zh': '小挂方石片麻岩标志',
      'ja': '小さなぶら下がっている切石片麻岩のサイン'
    }, {
      'id': 'SmallHangingAshlarGraniteSignItem',
      'en': 'Small Hanging Ashlar Granite Sign',
      'fr': 'Petite enseigne suspendue en granit de pierre de taille',
      'es': 'Letrero colgante pequeño de granito de sillería',
      'de': 'Kleines Schild aus Granit zum Aufhängen',
      'pl': 'Mały wiszący znak granitowy Ashlar',
      'ru': 'Маленький висячий гранитный знак из тесаного камня',
      'uk': 'Невеликий висячий гранітний знак',
      'ko': '작은 교수형 Ashlar 화강암 기호',
      'zh': '小挂方石花岗岩标牌',
      'ja': '小さなぶら下がっている切石花崗岩のサイン'
    }, {
      'id': 'SmallHangingAshlarLimestoneSignItem',
      'en': 'Small Hanging Ashlar Limestone Sign',
      'fr': 'Petite enseigne suspendue en pierre calcaire',
      'es': 'Letrero colgante pequeño de piedra caliza de sillería',
      'de': 'Kleines hängendes Quader-Kalkstein-Schild',
      'pl': 'Mały wiszący znak wapienia Ashlar',
      'ru': 'Небольшой висячий знак из известняка из тесаного камня',
      'uk': 'Невеликий висить тесенний вапняк знак',
      'ko': '작은 매달려 Ashlar 석회암 기호',
      'zh': '小挂方石石灰石标志',
      'ja': '小さな切石石灰岩の看板'
    }, {
      'id': 'SmallHangingAshlarSandstoneSignItem',
      'en': 'Small Hanging Ashlar Sandstone Sign',
      'fr': 'Petite enseigne en grès à suspendre',
      'es': 'Letrero Colgante Pequeño de Arenisca de Sillería',
      'de': 'Kleines hängendes Quader-Sandstein-Schild',
      'pl': 'Mały wiszący znak z piaskowca Ashlar',
      'ru': 'Маленький висячий знак из песчаника из тесаного камня',
      'uk': 'Невеликий висячий знак з пісковика',
      'ko': '작은 교수형 Ashlar 사암 기호',
      'zh': '小挂方石砂岩标志',
      'ja': '小さなハンギング切石砂岩サイン'
    }, {
      'id': 'SmallHangingAshlarShaleSignItem',
      'en': 'Small Hanging Ashlar Shale Sign',
      'fr': 'Petite enseigne suspendue en schiste de pierre de taille',
      'es': 'Letrero colgante pequeño de esquisto de sillería',
      'de': 'Kleines Schild zum Aufhängen aus Quaderstein',
      'pl': 'Mały wiszący znak łupków Ashlar',
      'ru': 'Небольшой висячий сланцевый знак из тесаного камня',
      'uk': 'Невеликий висячий сланцевий знак',
      'ko': '작은 매달려 Ashlar 셰일 기호',
      'zh': '小挂方石页岩标志',
      'ja': '小さなぶら下がっている切石頁岩のサイン'
    }, {
      'id': 'SmallHangingAshlarStoneSignItem',
      'en': 'Small Hanging Ashlar Stone Sign',
      'fr': 'Petite enseigne en pierre de taille à suspendre',
      'es': 'Letrero Colgante Pequeño de Sillería',
      'de': 'Kleines hängendes Quadersteinschild',
      'pl': 'Mały wiszący znak z kamienia Ashlar',
      'ru': 'Маленький висячий знак из тесаного камня',
      'uk': 'Невеликий висячий кам\u0027яний знак',
      'ko': '작은 교수형 Ashlar 돌 기호',
      'zh': '小挂方石标牌',
      'ja': '小さなぶら下がっている切石の石のサイン'
    }, {
      'id': 'SmallHangingBirchSignItem',
      'en': 'Small Hanging Birch Sign',
      'fr': 'Petite enseigne suspendue en bouleau',
      'es': 'Letrero colgante pequeño de abedul',
      'de': 'Kleines Hängeschild aus Birke',
      'pl': 'Mały wiszący znak brzozy',
      'ru': 'Маленький висячий березовый знак',
      'uk': 'Невеликий висить береза знак',
      'ko': '작은 교수형 자작나무 기호',
      'zh': '小挂桦木标志',
      'ja': '小さなハンギングバーチサイン'
    }, {
      'id': 'SmallHangingCedarSignItem',
      'en': 'Small Hanging Cedar Sign',
      'fr': 'Petite enseigne suspendue en cèdre',
      'es': 'Letrero colgante pequeño de cedro',
      'de': 'Kleines hängendes Zedernschild',
      'pl': 'Mały wiszący znak cedrowy',
      'ru': 'Маленький висячий кедровый знак',
      'uk': 'Невеликий висить кедровий знак',
      'ko': '작은 교수형 삼나무 간판',
      'zh': '小挂雪松标志',
      'ja': '小さなハンギングシダーサイン'
    }, {
      'id': 'SmallHangingCeibaSignItem',
      'en': 'Small Hanging Ceiba Sign',
      'fr': 'Petite enseigne suspendue Ceiba',
      'es': 'Letrero de Ceiba Colgante Pequeño',
      'de': 'Kleines Ceiba-Schild zum Aufhängen',
      'pl': 'Mały wiszący znak Ceiba',
      'ru': 'Небольшой подвесной знак Ceiba',
      'uk': 'Невеликий висить знак Ceiba',
      'ko': '작은 매달려 Ceiba 사인',
      'zh': '木棉小挂牌',
      'ja': '小さなハンギングセイバサイン'
    }, {
      'id': 'SmallHangingFirSignItem',
      'en': 'Small Hanging Fir Sign',
      'fr': 'Petite enseigne suspendue en sapin',
      'es': 'Pequeño cartel colgante de abeto',
      'de': 'Kleines hängendes Tannenschild',
      'pl': 'Mały wiszący znak jodły',
      'ru': 'Маленький висячий еловый знак',
      'uk': 'Невеликий висить ялиця знак',
      'ko': '작은 교수형 전나무 기호',
      'zh': '小挂冷杉标志',
      'ja': '小さなハンギングファーサイン'
    }, {
      'id': 'SmallHangingHardwoodSignItem',
      'en': 'Small Hanging Hardwood Sign',
      'fr': 'Petite enseigne en bois dur suspendue',
      'es': 'Pequeño letrero colgante de madera dura',
      'de': 'Kleines Schild zum Aufhängen aus Hartholz',
      'pl': 'Mały wiszący znak z twardego drewna',
      'ru': 'Небольшой подвесной знак из твердой древесины',
      'uk': 'Невеликий висить листяних порід знак',
      'ko': '작은 교수형 나무 간판',
      'zh': '小挂硬木标牌',
      'ja': '小さなハンギング広葉樹サイン'
    }, {
      'id': 'SmallHangingJoshuaSignItem',
      'en': 'Small Hanging Joshua Sign',
      'fr': 'Petite enseigne Joshua à suspendre',
      'es': 'Pequeño cartel de Joshua para colgar',
      'de': 'Kleines hängendes Joshua-Schild',
      'pl': 'Mały wiszący znak Jozuego',
      'ru': 'Маленький висячий знак Джошуа',
      'uk': 'Невеликий висить знак Джошуа',
      'ko': '작은 교수형 조슈아 사인',
      'zh': '小挂约书亚标志',
      'ja': '小さなぶら下がっているジョシュアサイン'
    }, {
      'id': 'SmallHangingLumberSignItem',
      'en': 'Small Hanging Lumber Sign',
      'fr': 'Petit panneau de bois suspendu',
      'es': 'Letrero de madera colgante pequeño',
      'de': 'Kleines hängendes Holzschild',
      'pl': 'Mały wiszący znak drewna',
      'ru': 'Маленький висячий деревянный знак',
      'uk': 'Невеликий висить пиломатеріалів знак',
      'ko': '작은 교수형 목재 기호',
      'zh': '小挂木牌',
      'ja': '小さなぶら下がっている材木サイン'
    }, {
      'id': 'SmallHangingMortaredGraniteSignItem',
      'en': 'Small Hanging Mortared Granite Sign',
      'fr': 'Petite enseigne suspendue en granit mortier',
      'es': 'Pequeño letrero colgante de granito con mortero',
      'de': 'Kleines Schild aus Granit zum Aufhängen',
      'pl': 'Mały wiszący znak z zaprawy granitowej',
      'ru': 'Небольшой висячий гранитный знак из раствора',
      'uk': 'Невеликий висить гранітний гранітний знак',
      'ko': '작은 교수형 모르타르 화강암 사인',
      'zh': '小挂砂浆花岗岩标志',
      'ja': '小さなぶら下がっているモルタル花崗岩のサイン'
    }, {
      'id': 'SmallHangingMortaredLimestoneSignItem',
      'en': 'Small Hanging Mortared Limestone Sign',
      'fr': 'Petite enseigne suspendue en calcaire mortier',
      'es': 'Pequeño letrero colgante de piedra caliza con mortero',
      'de': 'Kleines Schild aus Kalkstein zum Aufhängen',
      'pl': 'Mały wiszący znak wapienia z zaprawą murarską',
      'ru': 'Небольшой висячий знак из известняка',
      'uk': 'Невеликий висячий знак вапняку',
      'ko': '작은 교수형 모르타르 석회암 기호',
      'zh': '小挂砂浆石灰石标志',
      'ja': '小さなぶら下がっているモルタル石灰岩のサイン'
    }, {
      'id': 'SmallHangingMortaredSandstoneSignItem',
      'en': 'Small Hanging Mortared Sandstone Sign',
      'fr': 'Petite enseigne suspendue en grès mortier',
      'es': 'Pequeño letrero colgante de piedra arenisca con mortero',
      'de': 'Kleines Schild zum Aufhängen aus gemörteltem Sandstein',
      'pl': 'Mały wiszący znak z zaprawionego piaskowca',
      'ru': 'Небольшой висящий знак из песчаника с известковым раствором',
      'uk': 'Невеликий висячий знак з пісковика',
      'ko': '작은 교수형 모르타르 사암 기호',
      'zh': '小挂砂岩标志',
      'ja': '小さなぶら下がっているモルタル砂岩のサイン'
    }, {
      'id': 'SmallHangingMortaredStoneSignItem',
      'en': 'Small Hanging Mortared Stone Sign',
      'fr': 'Petit panneau en pierre mortier suspendu',
      'es': 'Pequeño letrero colgante de piedra con mortero',
      'de': 'Kleines hängendes Schild aus gemörteltem Stein',
      'pl': 'Mały wiszący znak z zaprawą murarską',
      'ru': 'Небольшой висящий каменный знак из известкового раствора',
      'uk': 'Невеликий висячий кам\u0027яний знак',
      'ko': '작은 교수형 모르타르 스톤 사인',
      'zh': '小挂砂浆石标牌',
      'ja': '小さなぶら下がっているモルタル石の看板'
    }, {
      'id': 'SmallHangingOakSignItem',
      'en': 'Small Hanging Oak Sign',
      'fr': 'Petite enseigne suspendue en chêne',
      'es': 'Letrero colgante pequeño de roble',
      'de': 'Kleines Hängeschild aus Eiche',
      'pl': 'Mały wiszący znak dębu',
      'ru': 'Маленькая висячая дубовая вывеска',
      'uk': 'Невеликий висить дуб знак',
      'ko': '작은 교수형 오크 사인',
      'zh': '小挂橡木标志',
      'ja': '小さなハンギングオークサイン'
    }, {
      'id': 'SmallHangingPalmSignItem',
      'en': 'Small Hanging Palm Sign',
      'fr': 'Petit panneau de palmier suspendu',
      'es': 'Pequeño cartel colgante de palma',
      'de': 'Kleines Palmenschild zum Aufhängen',
      'pl': 'Mały wiszący znak dłoni',
      'ru': 'Маленькая висячая пальма',
      'uk': 'Невеликий висить Palm знак',
      'ko': '작은 교수형 팜 사인',
      'zh': '小挂掌标志',
      'ja': '小さなハンギングパームサイン'
    }, {
      'id': 'SmallHangingRedwoodSignItem',
      'en': 'Small Hanging Redwood Sign',
      'fr': 'Petite enseigne suspendue en séquoia',
      'es': 'Letrero colgante pequeño de secoya',
      'de': 'Kleines Redwood-Schild zum Aufhängen',
      'pl': 'Mały wiszący znak sekwoi',
      'ru': 'Маленький висящий знак из красного дерева',
      'uk': 'Невеликий висить Redwood знак',
      'ko': '작은 교수형 레드우드 사인',
      'zh': '小挂红木标志',
      'ja': '小さなハンギングレッドウッドサイン'
    }, {
      'id': 'SmallHangingSaguaroSignItem',
      'en': 'Small Hanging Saguaro Sign',
      'fr': 'Petite enseigne Saguaro à suspendre',
      'es': 'Letrero Saguaro Colgante Pequeño',
      'de': 'Kleines hängendes Saguaro-Schild',
      'pl': 'Mały wiszący znak Saguaro',
      'ru': 'Маленький висячий знак Сагуаро',
      'uk': 'Невеликий висить знак Saguaro',
      'ko': '작은 교수형 이구아로 표지판',
      'zh': '小挂仙人掌标志',
      'ja': '小さなぶら下がっているサグアロサイン'
    }, {
      'id': 'SmallHangingSoftwoodSignItem',
      'en': 'Small Hanging Softwood Sign',
      'fr': 'Petite enseigne en bois résineux suspendue',
      'es': 'Letrero colgante pequeño de madera blanda',
      'de': 'Kleines Schild zum Aufhängen aus Weichholz',
      'pl': 'Mały wiszący znak z drewna iglastego',
      'ru': 'Небольшой подвесной знак из хвойного дерева',
      'uk': 'Невеликий висить знак хвойних порід',
      'ko': '작은 교수형 침엽수 사인',
      'zh': '小挂软木标志',
      'ja': '小さなハンギング針葉樹サイン'
    }, {
      'id': 'SmallHangingSpruceSignItem',
      'en': 'Small Hanging Spruce Sign',
      'fr': 'Petite enseigne suspendue en épicéa',
      'es': 'Letrero colgante pequeño de abeto',
      'de': 'Kleines hängendes Fichtenschild',
      'pl': 'Mały wiszący znak świerkowy',
      'ru': 'Маленький висячий еловый знак',
      'uk': 'Невеликий висить ялина знак',
      'ko': '작은 매달려 가문비나무 로그인',
      'zh': '小挂云杉标志',
      'ja': '小さなハンギングスプルースサイン'
    }, {
      'id': 'SmallHangingStoneSignItem',
      'en': 'Small Hanging Stone Sign',
      'fr': 'Petite enseigne en pierre suspendue',
      'es': 'Letrero de piedra colgante pequeño',
      'de': 'Kleines hängendes Steinschild',
      'pl': 'Mały wiszący kamień znak',
      'ru': 'Маленький висячий каменный знак',
      'uk': 'Невеликий висить кам\u0027яний знак',
      'ko': '작은 교수형 돌 기호',
      'zh': '小挂石标牌',
      'ja': '小さなハンギングストーンサイン'
    }, {
      'id': 'SmallHangingWoodSignItem',
      'en': 'Small Hanging Wood Sign',
      'fr': 'Petite enseigne en bois suspendue',
      'es': 'Letrero de madera colgante pequeño',
      'de': 'Kleines hängendes Holzschild',
      'pl': 'Mały wiszący znak drewna',
      'ru': 'Маленький висячий деревянный знак',
      'uk': 'Невеликий висить дерев\u0027яний знак',
      'ko': '작은 교수형 나무 기호',
      'zh': '小挂木牌',
      'ja': '小さなハンギングウッドサイン'
    }, {
      'id': 'SmallSinkItem',
      'en': 'Small Sink',
      'fr': 'Petit évier',
      'es': 'fregadero pequeño',
      'de': 'Kleines Waschbecken',
      'pl': 'Mały zlew',
      'ru': 'Маленькая раковина',
      'uk': 'Маленька мийка',
      'ko': '작은 세면대',
      'zh': '小水槽',
      'ja': '小さなシンク'
    }, {
      'id': 'SmallStandingAshlarBasaltSignItem',
      'en': 'Small Standing Ashlar Basalt Sign',
      'fr': 'Petite enseigne en basalte en pierre de taille debout',
      'es': 'Letrero pequeño de pie de sillería de basalto',
      'de': 'Kleines stehendes Quader-Basalt-Schild',
      'pl': 'Mały stojący znak bazaltowy z Ashlar',
      'ru': 'Небольшой стоящий базальтовый знак из тесаного камня',
      'uk': 'Невеликий стоячий тесенний базальтовий знак',
      'ko': '작은 서 Ashlar 현무암 기호',
      'zh': '小型立式方石玄武岩标志',
      'ja': '小さな切石玄武岩の看板'
    }, {
      'id': 'SmallStandingAshlarGneissSignItem',
      'en': 'Small Standing Ashlar Gneiss Sign',
      'fr': 'Petite enseigne en gneiss en pierre de taille debout',
      'es': 'Letrero pequeño de pie de sillería gneis',
      'de': 'Kleines stehendes Quader-Gneis-Schild',
      'pl': 'Mały stojący znak z gnejsu Ashlar',
      'ru': 'Небольшой стоящий знак из тесаного камня',
      'uk': 'Невеликий стоячий знак з ялинового гнейсу',
      'ko': '작은 서 Ashlar 편마암 기호',
      'zh': '小型立式方石片麻岩标志',
      'ja': '小さな立っている切石片麻岩のサイン'
    }, {
      'id': 'SmallStandingAshlarGraniteSignItem',
      'en': 'Small Standing Ashlar Granite Sign',
      'fr': 'Petite enseigne en granit de pierre de taille debout',
      'es': 'Pequeño letrero de granito de sillar de pie',
      'de': 'Kleines stehendes Quader-Granit-Schild',
      'pl': 'Mały stojący znak z granitu Ashlar',
      'ru': 'Небольшой стоячий гранитный знак из тесаного камня',
      'uk': 'Невеликий стоячий гранітний знак',
      'ko': '작은 서 Ashlar 화강암 기호',
      'zh': '小型立式方石花岗岩标志',
      'ja': '小さな切石花崗岩の看板'
    }, {
      'id': 'SmallStandingAshlarLimestoneSignItem',
      'en': 'Small Standing Ashlar Limestone Sign',
      'fr': 'Petite enseigne en pierre calcaire sur pied',
      'es': 'Pequeño letrero de piedra caliza de sillería de pie',
      'de': 'Kleines stehendes Quader-Kalkstein-Schild',
      'pl': 'Mały stojący znak wapienia Ashlar',
      'ru': 'Небольшой знак из известняка из тесаного камня',
      'uk': 'Невеликий стоїть тесенний вапняк знак',
      'ko': '작은 서 Ashlar 석회암 표시',
      'zh': '小型立式方石石灰石标志',
      'ja': '小さな切石石灰岩の看板'
    }, {
      'id': 'SmallStandingAshlarSandstoneSignItem',
      'en': 'Small Standing Ashlar Sandstone Sign',
      'fr': 'Petite enseigne debout en grès de pierre de taille',
      'es': 'Pequeño letrero de pie de piedra arenisca de sillería',
      'de': 'Kleines stehendes Quader-Sandstein-Schild',
      'pl': 'Mały stojący znak z piaskowca Ashlar',
      'ru': 'Небольшой стоячий знак из песчаника из тесаного камня',
      'uk': 'Невеликий стоячий знак з тесеняного пісковика',
      'ko': '작은 서 Ashlar 사암 기호',
      'zh': '小型立式方石砂岩标志',
      'ja': '小さな切石の砂岩のサイン'
    }, {
      'id': 'SmallStandingAshlarShaleSignItem',
      'en': 'Small Standing Ashlar Shale Sign',
      'fr': 'Petit panneau de schiste en pierre de taille debout',
      'es': 'Letrero de esquisto de sillería pequeño de pie',
      'de': 'Kleines stehendes Quader-Schiefer-Schild',
      'pl': 'Mały stojący znak łupków Ashlar',
      'ru': 'Небольшой стоячий знак из сланцевого камня',
      'uk': 'Невеликий стоячий сланцевий знак',
      'ko': '작은 서 있는 Ashlar 셰일 표시',
      'zh': '小型常设方石页岩标志',
      'ja': '小さな切石頁岩サイン'
    }, {
      'id': 'SmallStandingAshlarStoneSignItem',
      'en': 'Small Standing Ashlar Stone Sign',
      'fr': 'Petite enseigne en pierre de taille debout',
      'es': 'Pequeño letrero de piedra de sillería de pie',
      'de': 'Kleines stehendes Quadersteinschild',
      'pl': 'Mały stojący znak z kamienia Ashlar',
      'ru': 'Небольшой стоящий знак из тесаного камня',
      'uk': 'Невеликий стоячий кам\u0027яний знак',
      'ko': '작은 서 Ashlar 돌 기호',
      'zh': '小型立式方石标志',
      'ja': '小さな切石の石の看板'
    }, {
      'id': 'SmallStandingBirchSignItem',
      'en': 'Small Standing Birch Sign',
      'fr': 'Petite enseigne debout en bouleau',
      'es': 'Letrero pequeño de abedul de pie',
      'de': 'Kleines stehendes Schild aus Birke',
      'pl': 'Mały stojący znak brzozy',
      'ru': 'Маленький стоячий березовый знак',
      'uk': 'Невеликий стоячий береза знак',
      'ko': '작은 서 있는 자작나무 기호',
      'zh': '小站立桦木标志',
      'ja': '小さな立っている白樺の看板'
    }, {
      'id': 'SmallStandingCedarSignItem',
      'en': 'Small Standing Cedar Sign',
      'fr': 'Petite enseigne en cèdre sur pied',
      'es': 'Pequeño letrero de cedro de pie',
      'de': 'Kleines stehendes Zedernschild',
      'pl': 'Mały stojący znak cedrowy',
      'ru': 'Маленький стоящий кедровый знак',
      'uk': 'Невеликий стоячий знак кедра',
      'ko': '작은 서 삼나무 기호',
      'zh': '小立雪松标志',
      'ja': '小さな立ち杉の看板'
    }, {
      'id': 'SmallStandingCeibaSignItem',
      'en': 'Small Standing Ceiba Sign',
      'fr': 'Petite Enseigne Ceiba Debout',
      'es': 'Letrero de Ceiba Pequeño de Pie',
      'de': 'Kleines stehendes Ceiba-Schild',
      'pl': 'Mały stojący znak Ceiba',
      'ru': 'Небольшой постоянный знак Ceiba',
      'uk': 'Невеликий стоячий знак Сейба',
      'ko': '작은 서 Ceiba 기호',
      'zh': '木棉小立牌',
      'ja': '小さな立ちセイバサイン'
    }, {
      'id': 'SmallStandingFirSignItem',
      'en': 'Small Standing Fir Sign',
      'fr': 'Petite enseigne en sapin debout',
      'es': 'Pequeño cartel de abeto de pie',
      'de': 'Kleines stehendes Tannenschild',
      'pl': 'Mały stojący znak jodły',
      'ru': 'Маленький стоячий еловый знак',
      'uk': 'Невеликий стоїть ялиця знак',
      'ko': '작은 서 전나무 기호',
      'zh': '小型常设冷杉标志',
      'ja': '小さな立っているモミのサイン'
    }, {
      'id': 'SmallStandingHardwoodSignItem',
      'en': 'Small Standing Hardwood Sign',
      'fr': 'Petite enseigne en bois dur sur pied',
      'es': 'Letrero de madera dura pequeño de pie',
      'de': 'Kleines stehendes Schild aus Hartholz',
      'pl': 'Mały stojący znak z twardego drewna',
      'ru': 'Небольшой стоячий знак из твердой древесины',
      'uk': 'Невеликий стоїть листяних порід знак',
      'ko': '작은 서 있는 나무 간판',
      'zh': '小型立式硬木标志',
      'ja': '小さな立っている広葉樹の看板'
    }, {
      'id': 'SmallStandingJoshuaSignItem',
      'en': 'Small Standing Joshua Sign',
      'fr': 'Petit signe Josué debout',
      'es': 'Pequeño cartel de Josué de pie',
      'de': 'Kleines stehendes Joshua-Schild',
      'pl': 'Mały stojący znak Joshua',
      'ru': 'Маленький стоящий знак Джошуа',
      'uk': 'Невеликий стоячий знак Джошуа',
      'ko': '스몰 스탠딩 조슈아 사인',
      'zh': '小站立约书亚标志',
      'ja': '小さな立っているジョシュアサイン'
    }, {
      'id': 'SmallStandingLumberSignItem',
      'en': 'Small Standing Lumber Sign',
      'fr': 'Petit panneau de bois debout',
      'es': 'Pequeño letrero de madera de pie',
      'de': 'Kleines stehendes Holzschild',
      'pl': 'Mały stojący znak drewna',
      'ru': 'Небольшой стоячий знак пиломатериалов',
      'uk': 'Невеликий стоячий пиломатеріали знак',
      'ko': '작은 서 목재 기호',
      'zh': '小立木标志',
      'ja': '小さな立っている材木サイン'
    }, {
      'id': 'SmallStandingMortaredGraniteSignItem',
      'en': 'Small Standing Mortared Granite Sign',
      'fr': 'Petite enseigne en granit mortier debout',
      'es': 'Pequeño letrero de granito con mortero de pie',
      'de': 'Kleines stehendes Schild aus gemörteltem Granit',
      'pl': 'Mały stojący znak z zaprawy granitowej',
      'ru': 'Небольшой стоячий гранитный знак из раствора',
      'uk': 'Невеликий стоячий знак з граніту',
      'ko': '작은 서있는 모르타르 화강암 기호',
      'zh': '小型立式砂浆花岗岩标志',
      'ja': '小さな立っているモルタル花崗岩のサイン'
    }, {
      'id': 'SmallStandingMortaredLimestoneSignItem',
      'en': 'Small Standing Mortared Limestone Sign',
      'fr': 'Petite enseigne en calcaire mortier sur pied',
      'es': 'Pequeño letrero de piedra caliza con mortero de pie',
      'de': 'Kleines stehendes Schild aus gemörteltem Kalkstein',
      'pl': 'Mały stojący znak zaprawy wapienia',
      'ru': 'Небольшой знак из известняка с известковым раствором',
      'uk': 'Невеликий стоячий знак вапняку',
      'ko': '작은 서있는 모르타르 석회암 기호',
      'zh': '小型立式砂浆石灰石标志',
      'ja': '小さな立っているモルタル石灰岩のサイン'
    }, {
      'id': 'SmallStandingMortaredSandstoneSignItem',
      'en': 'Small Standing Mortared Sandstone Sign',
      'fr': 'Petite enseigne en grès mortier sur pied',
      'es': 'Pequeño letrero de piedra arenisca con mortero de pie',
      'de': 'Kleines stehendes Schild aus gemörteltem Sandstein',
      'pl': 'Mały stojący znak z zaprawionego piaskowca',
      'ru': 'Небольшой стоячий знак из песчаника с известковым раствором',
      'uk': 'Невеликий стоячий знак з пісковика',
      'ko': '작은 서있는 모르타르 사암 기호',
      'zh': '小型立式砂岩砂岩标志',
      'ja': '小さな立っているモルタル砂岩のサイン'
    }, {
      'id': 'SmallStandingMortaredStoneSignItem',
      'en': 'Small Standing Mortared Stone Sign',
      'fr': 'Petit panneau de pierre mortier debout',
      'es': 'Pequeño letrero de piedra con mortero de pie',
      'de': 'Kleines stehendes Schild aus gemörteltem Stein',
      'pl': 'Mały stojący znak z zaprawą murarską',
      'ru': 'Небольшой стоячий каменный знак из известкового раствора',
      'uk': 'Невеликий стоячий кам\u0027яний знак',
      'ko': '작은 서 박격포 돌 기호',
      'zh': '小型立式砂浆石标牌',
      'ja': '小さな立っているモルタル石のサイン'
    }, {
      'id': 'SmallStandingOakSignItem',
      'en': 'Small Standing Oak Sign',
      'fr': 'Petite Enseigne En Chêne Debout',
      'es': 'Pequeño letrero de roble de pie',
      'de': 'Kleines stehendes Eichenschild',
      'pl': 'Mały stojący szyld dębowy',
      'ru': 'Небольшой стоящий дубовый знак',
      'uk': 'Невеликий стоячий дуб знак',
      'ko': '작은 스탠딩 오크 사인',
      'zh': '小橡木标志',
      'ja': '小さな立っているオークのサイン'
    }, {
      'id': 'SmallStandingPalmSignItem',
      'en': 'Small Standing Palm Sign',
      'fr': 'Petit panneau de palmier debout',
      'es': 'Pequeño cartel de palma de pie',
      'de': 'Kleines stehendes Palmenschild',
      'pl': 'Mały stojący znak dłoni',
      'ru': 'Маленький знак стоячей ладони',
      'uk': 'Невеликий стоячи Palm знак',
      'ko': '작은 스탠딩 팜 사인',
      'zh': '小型站立棕榈标志',
      'ja': '小さな立っている手のひらサイン'
    }, {
      'id': 'SmallStandingRedwoodSignItem',
      'en': 'Small Standing Redwood Sign',
      'fr': 'Petite enseigne en séquoia sur pied',
      'es': 'Pequeño letrero de secoya de pie',
      'de': 'Kleines stehendes Redwood-Schild',
      'pl': 'Mały stojący znak sekwoi',
      'ru': 'Небольшой знак красного дерева',
      'uk': 'Невеликий стоїть Redwood знак',
      'ko': '작은 서 있는 레드우드 사인',
      'zh': '小型站立红木标志',
      'ja': '小さな立っているレッドウッドサイン'
    }, {
      'id': 'SmallStandingSaguaroSignItem',
      'en': 'Small Standing Saguaro Sign',
      'fr': 'Petit panneau Saguaro debout',
      'es': 'Pequeño letrero de Saguaro de pie',
      'de': 'Kleines stehendes Saguaro-Schild',
      'pl': 'Mały stojący znak Saguaro',
      'ru': 'Маленький постоянный знак Сагуаро',
      'uk': 'Невеликий стоячий знак Сагуаро',
      'ko': '작은 서 사와로 기호',
      'zh': '小立柱仙人掌标志',
      'ja': '小さな立っているサグアロサイン'
    }, {
      'id': 'SmallStandingSoftwoodSignItem',
      'en': 'Small Standing Softwood Sign',
      'fr': 'Petite enseigne en bois résineux sur pied',
      'es': 'Pequeño letrero de madera blanda de pie',
      'de': 'Kleines stehendes Weichholz-Schild',
      'pl': 'Mały stojący znak z drewna iglastego',
      'ru': 'Небольшой знак из хвойных пород дерева',
      'uk': 'Невеликий стоячий знак хвойних порід',
      'ko': '작은 서 있는 침엽수 기호',
      'zh': '小型站立软木标志',
      'ja': '小さな立っている針葉樹のサイン'
    }, {
      'id': 'SmallStandingSpruceSignItem',
      'en': 'Small Standing Spruce Sign',
      'fr': 'Petite enseigne debout en épicéa',
      'es': 'Letrero de abeto pequeño de pie',
      'de': 'Kleines stehendes Fichtenschild',
      'pl': 'Mały stojący znak świerkowy',
      'ru': 'Небольшой знак стоячей ели',
      'uk': 'Невеликий стоїть ялина знак',
      'ko': '작은 서 가문비나무 로그인',
      'zh': '小型站立云杉标志',
      'ja': '小さなスタンディングスプルースサイン'
    }, {
      'id': 'SmallStandingStoneSignItem',
      'en': 'Small Standing Stone Sign',
      'fr': 'Petite enseigne en pierre debout',
      'es': 'Pequeño letrero de piedra de pie',
      'de': 'Kleines Stehendes Steinschild',
      'pl': 'Mały stojący kamienny znak',
      'ru': 'Маленький стоящий каменный знак',
      'uk': 'Невеликий стоячий кам\u0027яний знак',
      'ko': '작은 스탠딩 스톤 사인',
      'zh': '小立石标志',
      'ja': '小さな立っている石のサイン'
    }, {
      'id': 'SmallStandingWoodSignItem',
      'en': 'Small Standing Wood Sign',
      'fr': 'Petite enseigne en bois sur pied',
      'es': 'Pequeño letrero de madera de pie',
      'de': 'Kleines stehendes Holzschild',
      'pl': 'Mały stojący znak drewna',
      'ru': 'Небольшой деревянный знак',
      'uk': 'Невеликий стоячий дерев\u0027яний знак',
      'ko': '작은 서 나무 기호',
      'zh': '小立木标志',
      'ja': '小さな立っている木の看板'
    }, {
      'id': 'SmallStockpileItem',
      'en': 'Small Stockpile',
      'fr': 'Petit stock',
      'es': 'Pequeña reserva',
      'de': 'Kleiner Vorrat',
      'pl': 'Mały zapas',
      'ru': 'Малый запас',
      'uk': 'Невеликий запас',
      'ko': '작은 비축',
      'zh': '小库存',
      'ja': '小さな備蓄'
    }, {
      'id': 'SmallTableItem',
      'en': 'Small Table',
      'fr': 'Petite table',
      'es': 'Mesa pequeña',
      'de': 'Kleiner Tisch',
      'pl': 'Mały stół',
      'ru': 'Маленький стол',
      'uk': 'Маленький стіл',
      'ko': '작은 테이블',
      'zh': '小桌子',
      'ja': '小さいテーブル'
    }, {
      'id': 'SmallWoodCartItem',
      'en': 'Small Wood Cart',
      'fr': 'Petit chariot en bois',
      'es': 'Carro de madera pequeño',
      'de': 'Kleiner Holzwagen',
      'pl': 'Mały wózek na drewno',
      'ru': 'Маленькая деревянная тележка',
      'uk': 'Маленький дерев\u0027яний візок',
      'ko': '작은 나무 카트',
      'zh': '小木车',
      'ja': '小さな木製カート'
    }, {
      'id': 'SmeltingUpgradeItem',
      'en': 'Smelting Upgrade',
      'fr': 'Mise à niveau de la fusion',
      'es': 'Actualización de fundición',
      'de': 'Schmelz-Upgrade',
      'pl': 'Ulepszenie wytopu',
      'ru': 'Обновление плавки',
      'uk': 'Оновлення плавлення',
      'ko': '제련 업그레이드',
      'zh': '冶炼升级',
      'ja': '製錬のアップグレード'
    }, {
      'id': 'SmithApronItem',
      'en': 'Smith Apron',
      'fr': 'Tablier de forgeron',
      'es': 'delantal herrero',
      'de': 'Schmied Schürze',
      'pl': 'Smith Fartuch',
      'ru': 'Фартук Смита',
      'uk': 'Фартух Сміта',
      'ko': '스미스 앞치마',
      'zh': '史密斯围裙',
      'ja': 'スミスエプロン'
    }, {
      'id': 'SmithBandanaItem',
      'en': 'Smith Bandana',
      'fr': 'Bandana Smith',
      'es': 'Pañuelo Smith',
      'de': 'Schmied Bandana',
      'pl': 'Chustka Smith',
      'ru': 'Смит Бандана',
      'uk': 'Бандана Сміта',
      'ko': '스미스 반다나',
      'zh': '史密斯头巾',
      'ja': 'スミスバンダナ'
    }, {
      'id': 'SmithBootsItem',
      'en': 'Smith Boots',
      'fr': 'Bottes de forgeron',
      'es': 'Botas de herrero',
      'de': 'Smith-Stiefel',
      'pl': 'Kowalskie buty',
      'ru': 'Сапоги Смита',
      'uk': 'Черевики Сміта',
      'ko': '스미스 부츠',
      'zh': '史密斯靴',
      'ja': 'スミスブーツ'
    }, {
      'id': 'SmithGlovesItem',
      'en': 'Smith Gloves',
      'fr': 'Gants de forgeron',
      'es': 'Guantes de herrero',
      'de': 'Smith-Handschuhe',
      'pl': 'Rękawiczki Smitha',
      'ru': 'Смит перчатки',
      'uk': 'Рукавички Сміта',
      'ko': '스미스 장갑',
      'zh': '史密斯手套',
      'ja': 'スミスグローブ'
    }, {
      'id': 'SmithPantsItem',
      'en': 'Smith Pants',
      'fr': 'Pantalon Smith',
      'es': 'Pantalones Smith',
      'de': 'Smith-Hosen',
      'pl': 'Spodnie Smith',
      'ru': 'Штаны Смита',
      'uk': 'Штани Сміта',
      'ko': '스미스 팬츠',
      'zh': '史密斯裤',
      'ja': 'スミスパンツ'
    }, {
      'id': 'SmoothGutNoodleRollItem',
      'en': 'Smooth Gut Noodle Roll',
      'fr': 'Rouleau de nouilles au boyau lisse',
      'es': 'Rollo de fideos de tripa suave',
      'de': 'Glatte Darmnudelrolle',
      'pl': 'Gładka bułka z makaronem',
      'ru': 'Гладкий рулет с лапшой',
      'uk': 'Рулет з локшиною з гладкою кишкою',
      'ko': '부드러운 내장 국수 롤',
      'zh': '光滑肠面卷',
      'ja': 'なめらかなガットヌードルロール'
    }, {
      'id': 'SnappingTurtleCarcassItem',
      'en': 'Snapping Turtle Carcass',
      'fr': 'Carcasse de tortue serpentine',
      'es': 'Cadáver de tortuga mordedora',
      'de': 'Kadaver der Schnappschildkröte',
      'pl': 'Tusza Żółwia Jaszczurczego',
      'ru': 'Туша каймановой черепахи',
      'uk': 'Туша черепахи',
      'ko': '거북 사체',
      'zh': '鳄龟尸体',
      'ja': 'カミツキガメの死骸'
    }, {
      'id': 'Softwood',
      'en': 'Softwood',
      'fr': 'Bois tendre',
      'es': 'Madera blanda',
      'de': 'Weichholz',
      'pl': 'Drewno iglaste',
      'ru': 'Хвойная древесина',
      'uk': 'Деревина хвойних порід',
      'ko': '침엽수',
      'zh': '软木',
      'ja': '針葉樹'
    }, {
      'id': 'SoilSamplerItem',
      'en': 'Soil Sampler',
      'fr': 'Échantillonneur de sol',
      'es': 'Muestreador de suelo',
      'de': 'Bodenprobenehmer',
      'pl': 'Próbnik gleby',
      'ru': 'Пробоотборник почвы',
      'uk': 'Пробовідбірник ґрунту',
      'ko': '토양 샘플러',
      'zh': '土壤采样器',
      'ja': '土壌サンプラー'
    }, {
      'id': 'SolarGeneratorItem',
      'en': 'Solar Generator',
      'fr': 'Générateur solaire',
      'es': 'generador solar',
      'de': 'Solargenerator',
      'pl': 'Generator słoneczny',
      'ru': 'Солнечный генератор',
      'uk': 'Сонячний генератор',
      'ko': '태양열 발전기',
      'zh': '太阳能发电机',
      'ja': 'ソーラー発電機'
    }, {
      'id': 'SpikyRollItem',
      'en': 'Spiky Roll',
      'fr': 'Rouleau épineux',
      'es': 'rollo puntiagudo',
      'de': 'Stachelige Rolle',
      'pl': 'kolczasta bułka',
      'ru': 'Колючий ролл',
      'uk': 'Шипчатий рол',
      'ko': '뾰족한 롤',
      'zh': '尖刺卷',
      'ja': 'スパイキーロール'
    }, {
      'id': 'SpinMelterItem',
      'en': 'Spin Melter',
      'fr': 'Fondoir à rotation',
      'es': 'Fusor giratorio',
      'de': 'Schleuderschmelzer',
      'pl': 'Wirówka',
      'ru': 'Спин Плавильщик',
      'uk': 'Віджимний плавитель',
      'ko': '스핀 멜터',
      'zh': '旋转熔炉',
      'ja': 'スピンメルター'
    }, {
      'id': 'SpruceLogItem',
      'en': 'Spruce Log',
      'fr': 'Bûche d\u0027épinette',
      'es': 'tronco de abeto',
      'de': 'Fichte Protokoll',
      'pl': 'kłoda świerkowa',
      'ru': 'Еловое бревно',
      'uk': 'Ялиновий колод',
      'ko': '스프루스 로그',
      'zh': '云杉原木',
      'ja': 'スプルースログ'
    }, {
      'id': 'SpruceSeedItem',
      'en': 'Spruce Seed',
      'fr': 'Graine d\u0027épinette',
      'es': 'Semilla de abeto',
      'de': 'Fichtensamen',
      'pl': 'Nasiona świerka',
      'ru': 'Семя ели',
      'uk': 'Насіння ялини',
      'ko': '가문비 나무 씨앗',
      'zh': '云杉种子',
      'ja': 'スプルースシード'
    }, {
      'id': 'SquareBeltItem',
      'en': 'Square Belt',
      'fr': 'Ceinture carrée',
      'es': 'cinturón cuadrado',
      'de': 'Quadratischer Gürtel',
      'pl': 'Kwadratowy pasek',
      'ru': 'Квадратный пояс',
      'uk': 'Квадратний пояс',
      'ko': '사각 벨트',
      'zh': '方带',
      'ja': 'スクエアベルト'
    }, {
      'id': 'PlanterPotSquareItem',
      'en': 'Square Pot',
      'fr': 'Pot carré',
      'es': 'Olla cuadrada',
      'de': 'Quadratischer Topf',
      'pl': 'Kwadratowa doniczka',
      'ru': 'Квадратный горшок',
      'uk': 'Квадратний горщик',
      'ko': '사각 냄비',
      'zh': '方锅',
      'ja': 'スクエアポット'
    }, {
      'id': 'StampMillItem',
      'en': 'Stamp Mill',
      'fr': 'Moulin à timbres',
      'es': 'Molino de sellos',
      'de': 'Stempelmühle',
      'pl': 'Pieczęć Młyn',
      'ru': 'Штамповая мельница',
      'uk': 'Штамповий млин',
      'ko': '스탬프 밀',
      'zh': '邮票厂',
      'ja': 'スタンプミル'
    }, {
      'id': 'StandingGlassSignItem',
      'en': 'Standing Glass Sign',
      'fr': 'Signe de verre debout',
      'es': 'Letrero de vidrio de pie',
      'de': 'Stehendes Glasschild',
      'pl': 'Stojący szklany znak',
      'ru': 'Постоянный стеклянный знак',
      'uk': 'Стоячий скляний знак',
      'ko': '스탠딩 글라스 사인',
      'zh': '站立玻璃标志',
      'ja': 'スタンディンググラスサイン'
    }, {
      'id': 'StandingLongSteelSignItem',
      'en': 'Standing Long Steel Sign',
      'fr': 'Panneau en acier long debout',
      'es': 'Letrero de acero largo de pie',
      'de': 'Stehendes langes Stahlschild',
      'pl': 'Stojący długi znak ze stali',
      'ru': 'Постоянный длинный стальной знак',
      'uk': 'Стоячий довгий знак сталі',
      'ko': '서 있는 긴 강철 기호',
      'zh': '站立长钢标志',
      'ja': '立っている長い鋼の印'
    }, {
      'id': 'StandingSteelBrickSignItem',
      'en': 'Standing Steel Brick Sign',
      'fr': 'Panneau de brique en acier debout',
      'es': 'Letrero de ladrillo de acero de pie',
      'de': 'Stehendes Backsteinschild aus Stahl',
      'pl': 'Stojący znak ze stali ceglanej',
      'ru': 'Стальной кирпичный знак',
      'uk': 'Знак стоячи сталевої цегли',
      'ko': '서 있는 강철 벽돌 기호',
      'zh': '立式钢砖标志',
      'ja': '立っている鋼のレンガのサイン'
    }, {
      'id': 'SteamEngineItem',
      'en': 'Steam Engine',
      'fr': 'Machine à vapeur',
      'es': 'Máquina de vapor',
      'de': 'Dampfmaschine',
      'pl': 'Silnik parowy',
      'ru': 'Паровой двигатель',
      'uk': 'Паровий двигун',
      'ko': '증기 기관',
      'zh': '蒸汽机',
      'ja': '蒸気機関'
    }, {
      'id': 'SteamTractorItem',
      'en': 'Steam Tractor',
      'fr': 'Tracteur à vapeur',
      'es': 'Tractor de vapor',
      'de': 'Dampftraktor',
      'pl': 'Ciągnik parowy',
      'ru': 'Паровой трактор',
      'uk': 'Паровий трактор',
      'ko': '증기 트랙터',
      'zh': '蒸汽拖拉机',
      'ja': 'スチームトラクター'
    }, {
      'id': 'SteamTractorHarvesterItem',
      'en': 'Steam Tractor Harvester',
      'fr': 'Récolteuse de tracteur à vapeur',
      'es': 'Cosechadora de tractor de vapor',
      'de': 'Dampftraktor-Erntemaschine',
      'pl': 'Kombajn do ciągnika parowego',
      'ru': 'Комбайн парового трактора',
      'uk': 'Паровий тракторний комбайн',
      'ko': '증기 트랙터 수확기',
      'zh': '蒸汽拖拉机收割机',
      'ja': 'スチームトラクターハーベスタ'
    }, {
      'id': 'SteamTractorPlowItem',
      'en': 'Steam Tractor Plow',
      'fr': 'Charrue de tracteur à vapeur',
      'es': 'Arado de tractor de vapor',
      'de': 'Dampftraktor Pflug',
      'pl': 'Pług ciągnika parowego',
      'ru': 'Плуг для парового трактора',
      'uk': 'Паровий тракторний плуг',
      'ko': '증기 트랙터 쟁기',
      'zh': '蒸汽拖拉机犁',
      'ja': '蒸気トラクタープラウ'
    }, {
      'id': 'SteamTractorSowerItem',
      'en': 'Steam Tractor Sower',
      'fr': 'Semeur de tracteur à vapeur',
      'es': 'Sembradora de tractor de vapor',
      'de': 'Dampftraktor Sämann',
      'pl': 'Ciągnik parowy siewnik',
      'ru': 'Сеялка парового трактора',
      'uk': 'Парова тракторна сівалка',
      'ko': '증기 트랙터 파종기',
      'zh': '蒸汽拖拉机播种机',
      'ja': '蒸気トラクター種まき'
    }, {
      'id': 'SteamTruckItem',
      'en': 'Steam Truck',
      'fr': 'Camion à vapeur',
      'es': 'camión de vapor',
      'de': 'Dampfwagen',
      'pl': 'Ciężarówka parowa',
      'ru': 'Паровой грузовик',
      'uk': 'Парова вантажівка',
      'ko': '증기 트럭',
      'zh': '蒸汽卡车',
      'ja': '蒸気トラック'
    }, {
      'id': 'SteelAbstractFixtureItem',
      'en': 'Steel Abstract Fixture',
      'fr': 'Luminaire abstrait en acier',
      'es': 'Accesorio abstracto de acero',
      'de': 'Abstrakte Leuchte aus Stahl',
      'pl': 'Stalowa abstrakcyjna oprawa',
      'ru': 'Стальной абстрактный светильник',
      'uk': 'Сталевий абстрактний прилад',
      'ko': '강철 추상 정착물',
      'zh': '钢抽象夹具',
      'ja': 'スチールアブストラクトフィクスチャ'
    }, {
      'id': 'SteelAxeItem',
      'en': 'Steel Axe',
      'fr': 'Hache d\u0027acier',
      'es': 'Hacha de acero',
      'de': 'Stahlaxt',
      'pl': 'Stalowy Topór',
      'ru': 'Стальной топор',
      'uk': 'Сталева сокира',
      'ko': '강철 도끼',
      'zh': '钢斧',
      'ja': '鋼の斧'
    }, {
      'id': 'SteelAxleItem',
      'en': 'Steel Axle',
      'fr': 'Essieu en acier',
      'es': 'Eje de acero',
      'de': 'Stahlachse',
      'pl': 'Oś stalowa',
      'ru': 'Стальная ось',
      'uk': 'Сталева вісь',
      'ko': '스틸 액슬',
      'zh': '钢轴',
      'ja': 'スチールアクスル'
    }, {
      'id': 'SteelBarItem',
      'en': 'Steel Bar',
      'fr': 'Barre d\u0027acier',
      'es': 'Barra de acero',
      'de': 'Stahlstange',
      'pl': 'Sztabka stali',
      'ru': 'Стальной стержень',
      'uk': 'Сталевий пруток',
      'ko': '스틸 바',
      'zh': '金属棒',
      'ja': 'スチール棒'
    }, {
      'id': 'SteelCeilingLightItem',
      'en': 'Steel Ceiling Light',
      'fr': 'Plafonnier en acier',
      'es': 'Luz de techo de acero',
      'de': 'Deckenleuchte aus Stahl',
      'pl': 'Stalowe oświetlenie sufitowe',
      'ru': 'Стальной потолочный светильник',
      'uk': 'Сталевий стельовий світильник',
      'ko': '스틸 천장 조명',
      'zh': '钢吸顶灯',
      'ja': 'スチールシーリングライト'
    }, {
      'id': 'SteelFloorLampItem',
      'en': 'Steel Floor Lamp',
      'fr': 'Lampadaire en acier',
      'es': 'Lámpara de pie de acero',
      'de': 'Stehlampe aus Stahl',
      'pl': 'Stalowa lampa podłogowa',
      'ru': 'Стальной торшер',
      'uk': 'Сталевий торшер',
      'ko': '스틸 플로어 램프',
      'zh': '钢落地灯',
      'ja': 'スチールフロアランプ'
    }, {
      'id': 'SteelGearItem',
      'en': 'Steel Gear',
      'fr': 'Engrenage en acier',
      'es': 'Engranaje de acero',
      'de': 'Stahlzahnrad',
      'pl': 'Stalowy bieg',
      'ru': 'Стальная шестерня',
      'uk': 'Сталева шестерня',
      'ko': '스틸 기어',
      'zh': '钢齿轮',
      'ja': 'スチールギア'
    }, {
      'id': 'SteelGearboxItem',
      'en': 'Steel Gearbox',
      'fr': 'Boîte de vitesses en acier',
      'es': 'Caja de cambios de acero',
      'de': 'Getriebe aus Stahl',
      'pl': 'Stalowa skrzynia biegów',
      'ru': 'Стальная коробка передач',
      'uk': 'Сталева коробка передач',
      'ko': '강철 변속기',
      'zh': '钢齿轮箱',
      'ja': 'スチールギアボックス'
    }, {
      'id': 'SteelHammerItem',
      'en': 'Steel Hammer',
      'fr': 'Marteau en acier',
      'es': 'Martillo de acero',
      'de': 'Stahlhammer',
      'pl': 'Młot stalowy',
      'ru': 'Стальной молот',
      'uk': 'Сталевий молоток',
      'ko': '강철 망치',
      'zh': '钢锤',
      'ja': 'スチールハンマー'
    }, {
      'id': 'SteelHangingFixtureItem',
      'en': 'Steel Hanging Fixture',
      'fr': 'Luminaire suspendu en acier',
      'es': 'Accesorio colgante de acero',
      'de': 'Aufhängevorrichtung aus Stahl',
      'pl': 'Stalowa oprawa wisząca',
      'ru': 'Стальное подвесное приспособление',
      'uk': 'Сталева підвісна арматура',
      'ko': '강철 걸이 고정구',
      'zh': '钢制吊具',
      'ja': 'スチールハンギングフィクスチャ'
    }, {
      'id': 'SteelHangingLampItem',
      'en': 'Steel Hanging Lamp',
      'fr': 'Lampe suspendue en acier',
      'es': 'Lámpara colgante de acero',
      'de': 'Hängelampe aus Stahl',
      'pl': 'Stalowa lampa wisząca',
      'ru': 'Стальная подвесная лампа',
      'uk': 'Сталева підвісна лампа',
      'ko': '강철 교수형 램프',
      'zh': '钢吊灯',
      'ja': 'スチールハンギングランプ'
    }, {
      'id': 'SteelHoeItem',
      'en': 'Steel Hoe',
      'fr': 'Houe en acier',
      'es': 'Azada de acero',
      'de': 'Stahlhacke',
      'pl': 'Stalowa motyka',
      'ru': 'Стальная мотыга',
      'uk': 'Сталева мотика',
      'ko': '강철 괭이',
      'zh': '钢锄头',
      'ja': '鋼くわ'
    }, {
      'id': 'SteelKitchenLampItem',
      'en': 'Steel Kitchen Lamp',
      'fr': 'Lampe de cuisine en acier',
      'es': 'Lámpara de cocina de acero',
      'de': 'Küchenlampe aus Stahl',
      'pl': 'Stalowa lampa kuchenna',
      'ru': 'Стальная кухонная лампа',
      'uk': 'Сталева лампа для кухні',
      'ko': '스틸 주방 램프',
      'zh': '钢制厨房灯',
      'ja': 'スチールキッチンランプ'
    }, {
      'id': 'SteelMacheteItem',
      'en': 'Steel Machete',
      'fr': 'Machette en acier',
      'es': 'Machete de acero',
      'de': 'Machete aus Stahl',
      'pl': 'Stalowa maczeta',
      'ru': 'Стальной мачете',
      'uk': 'Сталеве мачете',
      'ko': '강철 마체테',
      'zh': '钢砍刀',
      'ja': 'スチールマチェーテ'
    }, {
      'id': 'SteelPickaxeItem',
      'en': 'Steel Pickaxe',
      'fr': 'Pioche en acier',
      'es': 'Pico de acero',
      'de': 'Spitzhacke aus Stahl',
      'pl': 'Kilof ze stali',
      'ru': 'Стальная кирка',
      'uk': 'Сталева кирка',
      'ko': '강철 곡괭이',
      'zh': '钢镐',
      'ja': '鋼のつるはし'
    }, {
      'id': 'SteelPipeItem',
      'en': 'Steel Pipe',
      'fr': 'Tuyaux en acier',
      'es': 'Tubo de acero',
      'de': 'Stahlrohr',
      'pl': 'Stalowa rura',
      'ru': 'Стальная труба',
      'uk': 'Сталева труба',
      'ko': '쇠 파이프',
      'zh': '钢管',
      'ja': '鋼管'
    }, {
      'id': 'SteelPlateItem',
      'en': 'Steel Plate',
      'fr': 'Plaque d\u0027acier',
      'es': 'Placa de acero',
      'de': 'Stahlplatte',
      'pl': 'Blachy stalowej',
      'ru': 'Стальная пластина',
      'uk': 'Сталева пластина',
      'ko': '강판',
      'zh': '铁盘子',
      'ja': '鋼板'
    }, {
      'id': 'SteelRoadToolItem',
      'en': 'Steel Road Tool',
      'fr': 'Outil de route en acier',
      'es': 'Herramienta de carretera de acero',
      'de': 'Stahlstraßenwerkzeug',
      'pl': 'Stalowe narzędzie drogowe',
      'ru': 'Стальной дорожный инструмент',
      'uk': 'Сталевий дорожній інструмент',
      'ko': '강철 도로 도구',
      'zh': '钢制道路工具',
      'ja': 'スチールロードツール'
    }, {
      'id': 'SteelSawBladeItem',
      'en': 'Steel Saw Blade',
      'fr': 'Lame de scie en acier',
      'es': 'Hoja de sierra de acero',
      'de': 'Sägeblatt aus Stahl',
      'pl': 'Stalowy brzeszczot',
      'ru': 'Стальной пильный диск',
      'uk': 'Сталева пилка',
      'ko': '강철 톱날',
      'zh': '钢锯片',
      'ja': 'スチールソーブレード'
    }, {
      'id': 'SteelSearchlightItem',
      'en': 'Steel Searchlight',
      'fr': 'Projecteur en acier',
      'es': 'Reflector de acero',
      'de': 'Suchscheinwerfer aus Stahl',
      'pl': 'Stalowy Reflektor',
      'ru': 'Стальной прожектор',
      'uk': 'Сталевий прожектор',
      'ko': '강철 탐조등',
      'zh': '钢探照灯',
      'ja': '鋼のサーチライト'
    }, {
      'id': 'SteelShovelItem',
      'en': 'Steel Shovel',
      'fr': 'Pelle en acier',
      'es': 'pala de acero',
      'de': 'Schaufel aus Stahl',
      'pl': 'Łopata ze stali',
      'ru': 'Стальная лопата',
      'uk': 'Сталева лопата',
      'ko': '강철 삽',
      'zh': '钢铲',
      'ja': 'スチールショベル'
    }, {
      'id': 'SteelSickleItem',
      'en': 'Steel Sickle',
      'fr': 'Faucille en acier',
      'es': 'Hoz de acero',
      'de': 'Sichel aus Stahl',
      'pl': 'Stalowy sierp',
      'ru': 'Стальной серп',
      'uk': 'Сталевий серп',
      'ko': '강철 낫',
      'zh': '钢镰',
      'ja': '鋼の鎌'
    }, {
      'id': 'SteelSquareFixtureItem',
      'en': 'Steel Square Fixture',
      'fr': 'Luminaire carré en acier',
      'es': 'Accesorio cuadrado de acero',
      'de': 'Quadratische Halterung aus Stahl',
      'pl': 'Stalowa oprawa kwadratowa',
      'ru': 'Стальное квадратное приспособление',
      'uk': 'Сталева квадратна арматура',
      'ko': '스틸 스퀘어 비품',
      'zh': '钢制方形夹具',
      'ja': 'スチールスクエアフィクスチャ'
    }, {
      'id': 'SteelTableLampItem',
      'en': 'Steel Table Lamp',
      'fr': 'Lampe de table en acier',
      'es': 'Lámpara de mesa de acero',
      'de': 'Tischlampe aus Stahl',
      'pl': 'Stalowa lampa stołowa',
      'ru': 'Стальная настольная лампа',
      'uk': 'Сталева настільна лампа',
      'ko': '스틸 테이블 램프',
      'zh': '钢台灯',
      'ja': 'スチールテーブルランプ'
    }, {
      'id': 'StockpileItem',
      'en': 'Stockpile',
      'fr': 'Stocker',
      'es': 'Reservas',
      'de': 'Vorrat',
      'pl': 'Robić zapasy żywności',
      'ru': 'Склад',
      'uk': 'Запаси',
      'ko': '비축',
      'zh': '储存',
      'ja': '備蓄'
    }, {
      'id': 'StoneItem',
      'en': 'Stone',
      'fr': 'Pierre',
      'es': 'Piedra',
      'de': 'Stein',
      'pl': 'Złóg',
      'ru': 'Камень',
      'uk': 'Камінь',
      'ko': '결석',
      'zh': '结石',
      'ja': '結石'
    }, {
      'id': 'StoneAxeItem',
      'en': 'Stone Axe',
      'fr': 'Hache de pierre',
      'es': 'Hacha de piedra',
      'de': 'Steinaxt',
      'pl': 'Kamienna siekiera',
      'ru': 'Каменный топор',
      'uk': 'Кам\u0027яна сокира',
      'ko': '돌 도끼',
      'zh': '石斧',
      'ja': '石斧'
    }, {
      'id': 'StoneBrazierItem',
      'en': 'Stone Brazier',
      'fr': 'Brasier en pierre',
      'es': 'Brasero de piedra',
      'de': 'Kohlebecken aus Stein',
      'pl': 'Kamienny Kocioł',
      'ru': 'Каменная жаровня',
      'uk': 'Кам\u0027яна жаровня',
      'ko': '돌 화로',
      'zh': '石火盆',
      'ja': 'ストーンブレイザー'
    }, {
      'id': 'StoneDoorItem',
      'en': 'Stone Door',
      'fr': 'Porte en pierre',
      'es': 'puerta de piedra',
      'de': 'Steintür',
      'pl': 'Kamienne drzwi',
      'ru': 'Каменная дверь',
      'uk': 'Кам\u0027яні двері',
      'ko': '스톤 도어',
      'zh': '石门',
      'ja': 'ストーンドア'
    }, {
      'id': 'StoneHammerItem',
      'en': 'Stone Hammer',
      'fr': 'Marteau de pierre',
      'es': 'Martillo de piedra',
      'de': 'Steinhammer',
      'pl': 'Kamienny Młot',
      'ru': 'Каменный молот',
      'uk': 'Кам\u0027яний молот',
      'ko': '스톤 해머',
      'zh': '石锤',
      'ja': 'ストーンハンマー'
    }, {
      'id': 'StoneMacheteItem',
      'en': 'Stone Machete',
      'fr': 'Machette en pierre',
      'es': 'Machete de piedra',
      'de': 'Machete aus Stein',
      'pl': 'Kamienna Maczeta',
      'ru': 'Каменный мачете',
      'uk': 'Кам\u0027яне мачете',
      'ko': '스톤 마체테',
      'zh': '石砍刀',
      'ja': 'ストーンマチェーテ'
    }, {
      'id': 'StonePickaxeItem',
      'en': 'Stone Pickaxe',
      'fr': 'Pioche en pierre',
      'es': 'Pico de piedra',
      'de': 'Spitzhacke aus Stein',
      'pl': 'Kamienny Kilof',
      'ru': 'Каменная кирка',
      'uk': 'Кам\u0027яна кирка',
      'ko': '돌 곡괭이',
      'zh': '石镐',
      'ja': 'ストーンツルハシ'
    }, {
      'id': 'StoneRampItem',
      'en': 'Stone Ramp',
      'fr': 'Rampe de pierre',
      'es': 'rampa de piedra',
      'de': 'Steinrampe',
      'pl': 'Kamienna rampa',
      'ru': 'Каменная рампа',
      'uk': 'Кам\u0027яна рампа',
      'ko': '스톤 램프',
      'zh': '石坡道',
      'ja': 'ストーンランプ'
    }, {
      'id': 'StoneRoadItem',
      'en': 'Stone Road',
      'fr': 'Route de pierre',
      'es': 'camino de piedra',
      'de': 'Steinstraße',
      'pl': 'Kamienna Droga',
      'ru': 'Каменная дорога',
      'uk': 'Кам\u0027яна дорога',
      'ko': '돌길',
      'zh': '石路',
      'ja': 'ストーンロード'
    }, {
      'id': 'StoneRoadToolItem',
      'en': 'Stone Road Tool',
      'fr': 'Outil de route en pierre',
      'es': 'Herramienta Camino de Piedra',
      'de': 'Steinstraßenwerkzeug',
      'pl': 'Narzędzie do kamiennej drogi',
      'ru': 'Каменный дорожный инструмент',
      'uk': 'Кам\u0027яний дорожній інструмент',
      'ko': '돌 도로 도구',
      'zh': '石路工具',
      'ja': 'ストーンロードツール'
    }, {
      'id': 'StoneSickleItem',
      'en': 'Stone Sickle',
      'fr': 'Faucille de pierre',
      'es': 'Hoz de piedra',
      'de': 'Sichel aus Stein',
      'pl': 'Kamienny Sierp',
      'ru': 'Каменный серп',
      'uk': 'Кам\u0027яний серп',
      'ko': '돌 낫',
      'zh': '石镰',
      'ja': 'ストーンシックル'
    }, {
      'id': 'StoneWellItem',
      'en': 'Stone Well',
      'fr': 'Puits en pierre',
      'es': 'pozo de piedra',
      'de': 'Steinbrunnen',
      'pl': 'Kamienna studnia',
      'ru': 'Каменный колодец',
      'uk': 'Кам\u0027яна криниця',
      'ko': '돌 우물',
      'zh': '石井',
      'ja': 'ストーンウェル'
    }, {
      'id': 'StopSignItem',
      'en': 'Stop Sign',
      'fr': 'Panneau stop',
      'es': 'Señal de stop',
      'de': 'Stoppschild',
      'pl': 'Znak stopu',
      'ru': 'Знак остановки',
      'uk': 'Знак зупинки',
      'ko': '정지 신호',
      'zh': '停止标志',
      'ja': '一時停止標識'
    }, {
      'id': 'StorageChestItem',
      'en': 'Storage Chest',
      'fr': 'Coffre de rangement',
      'es': 'Cofre de almacenamiento',
      'de': 'Aufbewahrungskiste',
      'pl': 'Skrzynia do przechowywania',
      'ru': 'Сундук для хранения',
      'uk': 'Скриня для зберігання',
      'ko': '보관함',
      'zh': '储物箱',
      'ja': '収納チェスト'
    }, {
      'id': 'StorageSiloItem',
      'en': 'Storage Silo',
      'fr': 'Silo de stockage',
      'es': 'silo de almacenamiento',
      'de': 'Lagersilo',
      'pl': 'Silos magazynowy',
      'ru': 'Бункер для хранения',
      'uk': 'Силос для зберігання',
      'ko': '스토리지 사일로',
      'zh': '存储筒仓',
      'ja': 'ストレージサイロ'
    }, {
      'id': 'StoreItem',
      'en': 'Store',
      'fr': 'Magasin',
      'es': 'Tienda',
      'de': 'Speichern',
      'pl': 'Sklep',
      'ru': 'Хранить',
      'uk': 'Магазин',
      'ko': '가게',
      'zh': '店铺',
      'ja': '店'
    }, {
      'id': 'StoveItem',
      'en': 'Stove',
      'fr': 'Le fourneau',
      'es': 'Estufa',
      'de': 'Herd',
      'pl': 'Kuchenka',
      'ru': 'Печь',
      'uk': 'піч',
      'ko': '난로',
      'zh': '火炉',
      'ja': 'ストーブ'
    }, {
      'id': 'StrangeFuelItem',
      'en': 'Strange Fuel',
      'fr': 'Carburant étrange',
      'es': 'Combustible extraño',
      'de': 'Seltsamer Treibstoff',
      'pl': 'Dziwne paliwo',
      'ru': 'Странное топливо',
      'uk': 'Дивне паливо',
      'ko': '이상한 연료',
      'zh': '奇怪的燃料',
      'ja': '奇妙な燃料'
    }, {
      'id': 'StreetSignItem',
      'en': 'Street Sign',
      'fr': 'Panneau de signalisation',
      'es': 'Cartel de la calle',
      'de': 'Straßenschild',
      'pl': 'Znak drogowy',
      'ru': 'Дорожный знак',
      'uk': 'Знак вулиці',
      'ko': '도로 표지판',
      'zh': '街道路标',
      'ja': '道路標識'
    }, {
      'id': 'StreetlampItem',
      'en': 'Streetlamp',
      'fr': 'Réverbère',
      'es': 'Farola',
      'de': 'Straßenlaterne',
      'pl': 'Lampa uliczna',
      'ru': 'Уличный фонарь',
      'uk': 'Вуличний ліхтар',
      'ko': '가로등',
      'zh': '路灯',
      'ja': '街灯'
    }, {
      'id': 'StuffedAlligatorItem',
      'en': 'Stuffed Alligator',
      'fr': 'Alligator farci',
      'es': 'Cocodrilo Relleno',
      'de': 'Gefüllter Alligator',
      'pl': 'Nadziewany aligator',
      'ru': 'Фаршированный аллигатор',
      'uk': 'Фарширований алігатор',
      'ko': '박제 악어',
      'zh': '填充鳄鱼',
      'ja': 'ワニのぬいぐるみ'
    }, {
      'id': 'StuffedBisonItem',
      'en': 'Stuffed Bison',
      'fr': 'Bison farci',
      'es': 'bisonte relleno',
      'de': 'Gefüllter Bison',
      'pl': 'Faszerowany żubr',
      'ru': 'Фаршированный бизон',
      'uk': 'Фарширований бізон',
      'ko': '박제 들소',
      'zh': '酿野牛',
      'ja': 'バイソンのぬいぐるみ'
    }, {
      'id': 'StuffedElkItem',
      'en': 'Stuffed Elk',
      'fr': 'Élan farci',
      'es': 'Alce Relleno',
      'de': 'Gefüllter Elch',
      'pl': 'Faszerowany Łoś',
      'ru': 'чучело лося',
      'uk': 'Фарширований лось',
      'ko': '박제 엘크',
      'zh': '酿麋鹿',
      'ja': 'ぬいぐるみエルク'
    }, {
      'id': 'StuffedGoatItem',
      'en': 'Stuffed Goat',
      'fr': 'Chèvre en peluche',
      'es': 'Cabra Rellena',
      'de': 'Gefüllte Ziege',
      'pl': 'Faszerowana Koza',
      'ru': 'Фаршированная коза',
      'uk': 'Фарширована коза',
      'ko': '박제 염소',
      'zh': '酿山羊',
      'ja': 'ヤギのぬいぐるみ'
    }, {
      'id': 'StuffedJaguarItem',
      'en': 'Stuffed Jaguar',
      'fr': 'Jaguar en peluche',
      'es': 'Jaguar relleno',
      'de': 'Ausgestopfter Jaguar',
      'pl': 'Nadziewany Jaguar',
      'ru': 'Чучело ягуара',
      'uk': 'Фарширований ягуар',
      'ko': '박제 재규어',
      'zh': '填充捷豹',
      'ja': 'ジャガーのぬいぐるみ'
    }, {
      'id': 'StuffedTurkeyItem',
      'en': 'Stuffed Turkey',
      'fr': 'Dinde farcie',
      'es': 'Pavo relleno',
      'de': 'Gefüllter Truthahn',
      'pl': 'Faszerowany indyk',
      'ru': 'Фаршированная индейка',
      'uk': 'Фарширована індичка',
      'ko': '속을 채운 칠면조',
      'zh': '酿火鸡',
      'ja': 'ぬいぐるみトルコ'
    }, {
      'id': 'StuffedWolfItem',
      'en': 'Stuffed Wolf',
      'fr': 'Loup en peluche',
      'es': 'Lobo relleno',
      'de': 'Ausgestopfter Wolf',
      'pl': 'wypchany wilk',
      'ru': 'чучело волка',
      'uk': 'Опудала вовка',
      'ko': '박제 늑대',
      'zh': '填充狼',
      'ja': 'オオカミのぬいぐるみ'
    }, {
      'id': 'SubstrateItem',
      'en': 'Substrate',
      'fr': 'Substrat',
      'es': 'Sustrato',
      'de': 'Substrat',
      'pl': 'Podłoże',
      'ru': 'Субстрат',
      'uk': 'Субстрат',
      'ko': '기판',
      'zh': '基质',
      'ja': '基板'
    }, {
      'id': 'SugarItem',
      'en': 'Sugar',
      'fr': 'Sucre',
      'es': 'Azúcar',
      'de': 'Zucker',
      'pl': 'Cukier',
      'ru': 'Сахар',
      'uk': 'Цукор',
      'ko': '설탕',
      'zh': '糖',
      'ja': '砂糖'
    }, {
      'id': 'SugarcaneItem',
      'en': 'Sugarcane',
      'fr': 'Canne à sucre',
      'es': 'Caña de azúcar',
      'de': 'Zuckerrohr',
      'pl': 'Trzcina cukrowa',
      'ru': 'Сахарный тростник',
      'uk': 'Цукрова тростина',
      'ko': '사탕 수수',
      'zh': '甘蔗',
      'ja': 'サトウキビ'
    }, {
      'id': 'SunCheeseItem',
      'en': 'Sun Cheese',
      'fr': 'Fromage du soleil',
      'es': 'Queso de sol',
      'de': 'Sonnenkäse',
      'pl': 'Ser Słoneczny',
      'ru': 'Солнечный сыр',
      'uk': 'Сонячний сир',
      'ko': '썬 치즈',
      'zh': '太阳奶酪',
      'ja': 'サンチーズ'
    }, {
      'id': 'SunflowerItem',
      'en': 'Sunflower Item',
      'fr': 'Article Tournesol',
      'es': 'Artículo de girasol',
      'de': 'Artikel Sonnenblume',
      'pl': 'Słonecznik!',
      'ru': 'Подсолнечник Пункт',
      'uk': 'Соняшник Пункт',
      'ko': '해바라기 아이템',
      'zh': '向日葵项目',
      'ja': 'ひまわりアイテム'
    }, {
      'id': 'SunflowerSeedItem',
      'en': 'Sunflower Seed',
      'fr': 'Graines de tournesol',
      'es': 'Semilla de girasol',
      'de': 'Sonnenblumensamen',
      'pl': 'Ziarna słonecznika',
      'ru': 'Семян подсолнечника',
      'uk': 'Насіння соняшника',
      'ko': '해바라기 씨',
      'zh': '葵花籽',
      'ja': 'ヒマワリの種'
    }, {
      'id': 'SweetSaladItem',
      'en': 'Sweet Salad',
      'fr': 'Salade Douce',
      'es': 'Ensalada Dulce',
      'de': 'Süßer Salat',
      'pl': 'Słodka Sałatka',
      'ru': 'Сладкий салат',
      'uk': 'Солодкий салат',
      'ko': '달콤한 샐러드',
      'zh': '甜沙拉',
      'ja': '甘いサラダ'
    }, {
      'id': 'SyntheticRubberItem',
      'en': 'Synthetic Rubber',
      'fr': 'Caoutchouc synthétique',
      'es': 'Caucho sintético',
      'de': 'Synthesekautschuk',
      'pl': 'Kauczuk syntetyczny',
      'ru': 'Синтетическая резина',
      'uk': 'Синтетичний каучук',
      'ko': '인조 고무',
      'zh': '合成橡胶',
      'ja': '合成ゴム'
    }, {
      'id': 'TableItem',
      'en': 'Table',
      'fr': 'Table',
      'es': 'Mesa',
      'de': 'Tisch',
      'pl': 'Stół',
      'ru': 'Стол',
      'uk': 'Таблиця',
      'ko': '테이블',
      'zh': '桌子',
      'ja': 'テーブル'
    }, {
      'id': 'TailingsItem',
      'en': 'Tailings',
      'fr': 'Résidus',
      'es': 'relaves',
      'de': 'Rückstände',
      'pl': 'Odpadki',
      'ru': 'Хвосты',
      'uk': 'Хвостосховища',
      'ko': '찌끼',
      'zh': '尾矿',
      'ja': '尾鉱'
    }, {
      'id': 'TailorBowlerHatItem',
      'en': 'Tailor Bowler Hat',
      'fr': 'Chapeau melon tailleur',
      'es': 'bombín de sastre',
      'de': 'Schneider Melone',
      'pl': 'Melonik krawiecki',
      'ru': 'Шляпа-котелок на заказ',
      'uk': 'Кравець капелюх-котел',
      'ko': '재단사 중산모',
      'zh': '裁缝圆顶礼帽',
      'ja': '山高帽の仕立て'
    }, {
      'id': 'TailorPantsItem',
      'en': 'Tailor Pants',
      'fr': 'Pantalon de tailleur',
      'es': 'pantalones de sastre',
      'de': 'Schneiderhosen',
      'pl': 'Spodnie krawieckie',
      'ru': 'Портной Брюки',
      'uk': 'Кравецькі штани',
      'ko': '재단사 바지',
      'zh': '裁缝裤',
      'ja': 'テーラーパンツ'
    }, {
      'id': 'TailorShirtItem',
      'en': 'Tailor Shirt',
      'fr': 'Chemise de tailleur',
      'es': 'Camisa a medida',
      'de': 'Schneiderhemd',
      'pl': 'Koszula krawiecka',
      'ru': 'Портной Рубашка',
      'uk': 'Кравецька сорочка',
      'ko': '재단사 셔츠',
      'zh': '裁缝衬衫',
      'ja': 'テーラーシャツ'
    }, {
      'id': 'TailorShoesItem',
      'en': 'Tailor Shoes',
      'fr': 'Chaussures de tailleur',
      'es': 'Zapatos de sastre',
      'de': 'Schneiderschuhe',
      'pl': 'Buty krawieckie',
      'ru': 'Портной Обувь',
      'uk': 'Кравецьке взуття',
      'ko': '재단사 신발',
      'zh': '裁缝鞋',
      'ja': 'テーラーシューズ'
    }, {
      'id': 'TailoringBasicUpgradeItem',
      'en': 'Tailoring Basic Upgrade',
      'fr': 'Adapter la mise à niveau de base',
      'es': 'Mejora básica de sastrería',
      'de': 'Anpassungs-Basis-Upgrade',
      'pl': 'Podstawowe uaktualnienie krawiectwa',
      'ru': 'Базовое обновление по пошиву одежды',
      'uk': 'Базове оновлення пошиття',
      'ko': '테일러링 베이직 업그레이드',
      'zh': '剪裁基础升级',
      'ja': '基本的なアップグレードの調整'
    }, {
      'id': 'TailoringModernUpgradeItem',
      'en': 'Tailoring Modern Upgrade',
      'fr': 'Mise à niveau moderne sur mesure',
      'es': 'Actualización moderna de sastrería',
      'de': 'Modernes Upgrade anpassen',
      'pl': 'Nowoczesna modernizacja na miarę',
      'ru': 'Пошив современного обновления',
      'uk': 'Пошиття Сучасне оновлення',
      'ko': '현대적인 업그레이드 조정',
      'zh': '剪裁现代升级',
      'ja': 'モダンアップグレードの調整'
    }, {
      'id': 'TailoringTableItem',
      'en': 'Tailoring Table',
      'fr': 'Tableau de couture',
      'es': 'Mesa de sastrería',
      'de': 'Schneidertisch',
      'pl': 'Stół krawiecki',
      'ru': 'Таблица пошива',
      'uk': 'Пошиття столу',
      'ko': '재봉 테이블',
      'zh': '裁缝台',
      'ja': '仕立てテーブル'
    }, {
      'id': 'TallBootsItem',
      'en': 'Tall Boots',
      'fr': 'Bottes hautes',
      'es': 'Botas altas',
      'de': 'Hohe Stiefel',
      'pl': 'Wysokie buty',
      'ru': 'Высокие сапоги',
      'uk': 'Високі чоботи',
      'ko': '톨부츠',
      'zh': '高筒靴',
      'ja': 'トールブーツ'
    }, {
      'id': 'TallowItem',
      'en': 'Tallow',
      'fr': 'Suif',
      'es': 'Sebo',
      'de': 'Talg',
      'pl': 'Łój',
      'ru': 'Сало',
      'uk': 'Сало',
      'ko': '수지 양초',
      'zh': '脂',
      'ja': '獣脂'
    }, {
      'id': 'TallowCandleItem',
      'en': 'Tallow Candle',
      'fr': 'Bougie de suif',
      'es': 'Vela de sebo',
      'de': 'Talgkerze',
      'pl': 'Świeca łojowa',
      'ru': 'сальная свеча',
      'uk': 'Сальна свічка',
      'ko': '탤로우 캔들',
      'zh': '牛油蜡烛',
      'ja': '獣脂ろうそく'
    }, {
      'id': 'TallowLampItem',
      'en': 'Tallow Lamp',
      'fr': 'Lampe à suif',
      'es': 'Lámpara de sebo',
      'de': 'Talg-Lampe',
      'pl': 'Lampa łojowa',
      'ru': 'Сальная лампа',
      'uk': 'Сальна лампа',
      'ko': '수지 램프',
      'zh': '牛油灯',
      'ja': '獣脂ランプ'
    }, {
      'id': 'TallowWallLampItem',
      'en': 'Tallow Wall Lamp',
      'fr': 'Applique murale en suif',
      'es': 'Lámpara de pared de sebo',
      'de': 'Talg Wandlampe',
      'pl': 'łojowy kinkiet',
      'ru': 'Настенный светильник из сала',
      'uk': 'Саловий настінний світильник',
      'ko': '수지 벽 램프',
      'zh': '牛油壁灯',
      'ja': '獣脂壁ランプ'
    }, {
      'id': 'TaroFriesItem',
      'en': 'Taro Fries',
      'fr': 'Frites Taro',
      'es': 'papas fritas',
      'de': 'Taro-Pommes',
      'pl': 'Frytki Taro',
      'ru': 'Таро Фрайс',
      'uk': 'Таро Фрі',
      'ko': '타로 프라이',
      'zh': '芋头薯条',
      'ja': '里芋フライ'
    }, {
      'id': 'TaroRootItem',
      'en': 'Taro Root',
      'fr': 'Racine de taro',
      'es': 'Raiz de Taro',
      'de': 'Taro-Wurzel',
      'pl': 'Korzeń Taro',
      'ru': 'Корень таро',
      'uk': 'Корінь Таро',
      'ko': '타로 뿌리',
      'zh': '芋头根',
      'ja': '里芋根'
    }, {
      'id': 'TaroSeedItem',
      'en': 'Taro Seed',
      'fr': 'Graine de Taro',
      'es': 'Semilla de Taro',
      'de': 'Taro-Samen',
      'pl': 'Nasiona Taro',
      'ru': 'Семя Таро',
      'uk': 'Насіння Таро',
      'ko': '타로 씨',
      'zh': '芋头',
      'ja': '里芋の種'
    }, {
      'id': 'TastyTropicalPizzaItem',
      'en': 'Tasty Tropical Pizza',
      'fr': 'Pizza tropicale savoureuse',
      'es': 'Sabrosa pizza tropical',
      'de': 'Leckere tropische Pizza',
      'pl': 'Smaczna Tropikalna Pizza',
      'ru': 'Вкусная Тропическая Пицца',
      'uk': 'Смачна тропічна піца',
      'ko': '맛있는 열대 피자',
      'zh': '美味的热带披萨',
      'ja': 'おいしいトロピカルピザ'
    }, {
      'id': 'TinyCarcass',
      'en': 'Tiny Carcass',
      'fr': 'Petite carcasse',
      'es': 'carcasa diminuta',
      'de': 'Winziger Kadaver',
      'pl': 'Drobna Tusza',
      'ru': 'Крошечная туша',
      'uk': 'Крихітна тушка',
      'ko': '작은 시체',
      'zh': '小尸体',
      'ja': '小さな死骸'
    }, {
      'id': 'TinyFurCarcass',
      'en': 'Tiny Fur Carcass',
      'fr': 'Petite carcasse de fourrure',
      'es': 'Carcasa de piel diminuta',
      'de': 'Winziger Fellkadaver',
      'pl': 'Tusz z małego futra',
      'ru': 'Крошечная меховая туша',
      'uk': 'Крихітна хутряна тушка',
      'ko': '작은 모피 시체',
      'zh': '小毛皮尸体',
      'ja': '小さな毛皮の死骸'
    }, {
      'id': 'TinyLeatherCarcass',
      'en': 'Tiny Leather Carcass',
      'fr': 'Petite carcasse en cuir',
      'es': 'Carcasa de cuero diminuta',
      'de': 'Winzige Lederkarkasse',
      'pl': 'Mały skórzany tusz',
      'ru': 'Крошечная кожаная туша',
      'uk': 'Крихітний шкіряний каркас',
      'ko': '작은 가죽 시체',
      'zh': '小皮胴体',
      'ja': '小さな革の死骸'
    }, {
      'id': 'TinyStockpileItem',
      'en': 'Tiny Stockpile',
      'fr': 'Petit stock',
      'es': 'Reserva minúscula',
      'de': 'Kleiner Vorrat',
      'pl': 'Mały zapas',
      'ru': 'Крошечный запас',
      'uk': 'Крихітний запас',
      'ko': '작은 비축',
      'zh': '小库存',
      'ja': '小さな備蓄'
    }, {
      'id': 'ToiletItem',
      'en': 'Toilet',
      'fr': 'Toilette',
      'es': 'Inodoro',
      'de': 'Toilette',
      'pl': 'Toaleta',
      'ru': 'Туалет',
      'uk': 'Туалет',
      'ko': '화장실',
      'zh': '洗手间',
      'ja': 'トイレ'
    }, {
      'id': 'TomatoItem',
      'en': 'Tomato',
      'fr': 'Tomate',
      'es': 'Tomate',
      'de': 'Tomate',
      'pl': 'Pomidor',
      'ru': 'Помидор',
      'uk': 'Томатний',
      'ko': '토마토',
      'zh': '番茄',
      'ja': 'トマト'
    }, {
      'id': 'TomatoSeedItem',
      'en': 'Tomato Seed',
      'fr': 'Graine de tomate',
      'es': 'Semilla de tomate',
      'de': 'Tomatensamen',
      'pl': 'Nasiona pomidora',
      'ru': 'Семена помидоров',
      'uk': 'Насіння томатів',
      'ko': '토마토 씨',
      'zh': '番茄种子',
      'ja': 'トマトの種'
    }, {
      'id': 'Tool',
      'en': 'Tool',
      'fr': 'Outil',
      'es': 'Herramienta',
      'de': 'Werkzeug',
      'pl': 'Narzędzie',
      'ru': 'Инструмент',
      'uk': 'Інструмент',
      'ko': '도구',
      'zh': '工具',
      'ja': '道具'
    }, {
      'id': 'ToolBenchItem',
      'en': 'Tool Bench',
      'fr': 'Banc d\u0027outils',
      'es': 'banco de herramientas',
      'de': 'Werkzeugbank',
      'pl': 'Ławka narzędziowa',
      'ru': 'Скамья для инструментов',
      'uk': 'Інструментальний столик',
      'ko': '도구 벤치',
      'zh': '工具台',
      'ja': 'ツールベンチ'
    }, {
      'id': 'ToppedPorridgeItem',
      'en': 'Topped Porridge',
      'fr': 'Bouillie garnie',
      'es': 'Gachas cubiertas',
      'de': 'Getoppter Brei',
      'pl': 'Zwieńczona Owsianka',
      'ru': 'Овсяная каша',
      'uk': 'Топлена каша',
      'ko': '토핑된 죽',
      'zh': '稀饭',
      'ja': 'トッピングのお粥'
    }, {
      'id': 'TorchItem',
      'en': 'Torch',
      'fr': 'Torche',
      'es': 'Antorcha',
      'de': 'Fackel',
      'pl': 'Latarka',
      'ru': 'Факел',
      'uk': 'Факел',
      'ko': '토치',
      'zh': '火炬',
      'ja': '松明'
    }, {
      'id': 'TorchStandItem',
      'en': 'Torch Stand',
      'fr': 'Support de torche',
      'es': 'Soporte de antorcha',
      'de': 'Fackelständer',
      'pl': 'Stojak na pochodnię',
      'ru': 'Подставка для факела',
      'uk': 'Підставка для факела',
      'ko': '토치 스탠드',
      'zh': '火炬架',
      'ja': 'トーチスタンド'
    }, {
      'id': 'TortillaItem',
      'en': 'Tortilla',
      'fr': 'Tortilla',
      'es': 'Tortilla',
      'de': 'Tortilla',
      'pl': 'Tortilla',
      'ru': 'Тортилья',
      'uk': 'Тортилья',
      'ko': '또띠아',
      'zh': '玉米饼',
      'ja': 'トルティーヤ'
    }, {
      'id': 'TowelRackItem',
      'en': 'Towel Rack',
      'fr': 'Porte-serviette',
      'es': 'toallero',
      'de': 'Handtuchhalter',
      'pl': 'Wieszak na ręczniki',
      'ru': 'Вешалка для полотенец',
      'uk': 'Вішалка для рушників',
      'ko': '수건 걸이',
      'zh': '毛巾架',
      'ja': 'タオル掛け'
    }, {
      'id': 'TransglutaminaseItem',
      'en': 'Transglutaminase',
      'fr': 'Transglutaminase',
      'es': 'transglutaminasa',
      'de': 'Transglutaminase',
      'pl': 'Transglutaminaza',
      'ru': 'трансглютаминаза',
      'uk': 'Трансглутаміназа',
      'ko': '트랜스글루타미나제',
      'zh': '转谷氨酰胺酶',
      'ja': 'トランスグルタミナーゼ'
    }, {
      'id': 'TransmissionPoleItem',
      'en': 'Transmission Pole',
      'fr': 'Pôle Transmission',
      'es': 'Poste de transmisión',
      'de': 'Übertragungsmast',
      'pl': 'Biegun transmisji',
      'ru': 'Передающий полюс',
      'uk': 'Полюс передачі',
      'ko': '전송 극',
      'zh': '输电杆',
      'ja': '電柱'
    }, {
      'id': 'TreasuryItem',
      'en': 'Treasury',
      'fr': 'Trésorerie',
      'es': 'Tesorería',
      'de': 'Schatzkammer',
      'pl': 'Skarbiec',
      'ru': 'Казначейство',
      'uk': 'казначейство',
      'ko': '국고',
      'zh': '国库',
      'ja': '財務省'
    }, {
      'id': 'TreeDebrisItem',
      'en': 'Tree Debris',
      'fr': 'Débris d\u0027arbre',
      'es': 'restos de árboles',
      'de': 'Baumschutt',
      'pl': 'Odpady drzew',
      'ru': 'Обломки деревьев',
      'uk': 'Уламки дерев',
      'ko': '나무 파편',
      'zh': '树碎片',
      'ja': '木の破片'
    }, {
      'id': 'TrilliumSeedItem',
      'en': 'Trillium Seed',
      'fr': 'Graine de trille',
      'es': 'Semilla de trilio',
      'de': 'Trilliumsamen',
      'pl': 'Nasiona Trillium',
      'ru': 'Семя триллиума',
      'uk': 'Trillium Seed',
      'ko': '트릴리움 씨앗',
      'zh': '延龄草种子',
      'ja': 'エンレイソウ種子'
    }, {
      'id': 'TrousersItem',
      'en': 'Trousers',
      'fr': 'Pantalon',
      'es': 'Pantalones',
      'de': 'Hose',
      'pl': 'Spodnie',
      'ru': 'Брюки',
      'uk': 'Штани',
      'ko': '바지',
      'zh': '裤子',
      'ja': 'ズボン'
    }, {
      'id': 'TroutItem',
      'en': 'Trout',
      'fr': 'Truite',
      'es': 'Trucha',
      'de': 'Forelle',
      'pl': 'Pstrąg',
      'ru': 'Форель',
      'uk': 'Форель',
      'ko': '송어',
      'zh': '鳟鱼',
      'ja': 'マス'
    }, {
      'id': 'TruckItem',
      'en': 'Truck',
      'fr': 'Camion',
      'es': 'Camión',
      'de': 'LKW',
      'pl': 'Ciężarówka',
      'ru': 'Грузовая машина',
      'uk': 'Вантажівка',
      'ko': '트럭',
      'zh': '卡车',
      'ja': 'トラック'
    }, {
      'id': 'TunaItem',
      'en': 'Tuna',
      'fr': 'Thon',
      'es': 'Atún',
      'de': 'Thunfisch',
      'pl': 'Tuńczyk',
      'ru': 'Тунец',
      'uk': 'тунець',
      'ko': '참치',
      'zh': '金枪鱼',
      'ja': 'シーチキン'
    }, {
      'id': 'TurkeyCarcassItem',
      'en': 'Turkey Carcass',
      'fr': 'Carcasse de dinde',
      'es': 'canal de pavo',
      'de': 'Putenkadaver',
      'pl': 'Tusza z indyka',
      'ru': 'Туша индейки',
      'uk': 'Туша індички',
      'ko': '칠면조 시체',
      'zh': '火鸡尸体',
      'ja': '七面鳥の死骸'
    }, {
      'id': 'Upgrade',
      'en': 'Upgrade',
      'fr': 'Mise à niveau',
      'es': 'Mejora',
      'de': 'Aktualisierung',
      'pl': 'Aktualizacja',
      'ru': 'Обновление',
      'uk': 'Оновлення',
      'ko': '업그레이드',
      'zh': '升级',
      'ja': 'アップグレード'
    }, {
      'id': 'UpholsteredChairItem',
      'en': 'Upholstered Chair',
      'fr': 'Chaise rembourrée',
      'es': 'Silla tapizada',
      'de': 'Gepolsterter Stuhl',
      'pl': 'Krzesło tapicerowane',
      'ru': 'Мягкий стул',
      'uk': 'М\u0027який стілець',
      'ko': '덮개를 씌운 의자',
      'zh': '软垫椅子',
      'ja': '布張りの椅子'
    }, {
      'id': 'UpholsteredCouchItem',
      'en': 'Upholstered Couch',
      'fr': 'Canapé rembourré',
      'es': 'Sofá tapizado',
      'de': 'Gepolsterte Couch',
      'pl': 'Tapicerowana kanapa',
      'ru': 'Мягкий диван',
      'uk': 'М\u0027який диван',
      'ko': '덮개를 씌운 소파',
      'zh': '软垫沙发',
      'ja': '布張りのソファ'
    }, {
      'id': 'UrchinItem',
      'en': 'Urchin',
      'fr': 'Oursin',
      'es': 'Pilluelo',
      'de': 'Seeigel',
      'pl': 'Urwis',
      'ru': 'Еж',
      'uk': 'їжак',
      'ko': '섬게',
      'zh': '顽童',
      'ja': 'ウニ'
    }, {
      'id': 'ValveItem',
      'en': 'Valve',
      'fr': 'Soupape',
      'es': 'Válvula',
      'de': 'Ventil',
      'pl': 'Zawór',
      'ru': 'Клапан',
      'uk': 'Клапан',
      'ko': '판막',
      'zh': '阀门',
      'ja': 'バルブ'
    }, {
      'id': 'Vegetable',
      'en': 'Vegetable',
      'fr': 'Légume',
      'es': 'Verdura',
      'de': 'Gemüse',
      'pl': 'Warzywo',
      'ru': 'овощ',
      'uk': 'Овочевий',
      'ko': '채소',
      'zh': '蔬菜',
      'ja': '野菜'
    }, {
      'id': 'VegetableMedleyItem',
      'en': 'Vegetable Medley',
      'fr': 'Mélange de légumes',
      'es': 'popurrí de verduras',
      'de': 'Gemüsemischung',
      'pl': 'Mieszanka warzywna',
      'ru': 'Овощная смесь',
      'uk': 'Овочеве пюре',
      'ko': '야채 메들리',
      'zh': '蔬菜混合泳',
      'ja': '野菜メドレー'
    }, {
      'id': 'VegetableSoupItem',
      'en': 'Vegetable Soup',
      'fr': 'Soupe aux légumes',
      'es': 'Sopa de verduras',
      'de': 'Gemüsesuppe',
      'pl': 'Zupa warzywna',
      'ru': 'Овощной суп',
      'uk': 'Овочевий суп',
      'ko': '야채 수프',
      'zh': '蔬菜汤',
      'ja': '野菜スープ'
    }, {
      'id': 'VegetableStockItem',
      'en': 'Vegetable Stock',
      'fr': 'Bouillon de légumes',
      'es': 'Caldo de verduras',
      'de': 'Gemüsebrühe',
      'pl': 'Zapas warzyw',
      'ru': 'Овощного бульона',
      'uk': 'Овочевий бульйон',
      'ko': '야채 스톡',
      'zh': '蔬菜汤',
      'ja': '野菜ストック'
    }, {
      'id': 'Vehicles',
      'en': 'Vehicles',
      'fr': 'Véhicules',
      'es': 'vehículos',
      'de': 'Fahrzeuge',
      'pl': 'Pojazdy',
      'ru': 'Транспорт',
      'uk': 'транспортні засоби',
      'ko': '차량',
      'zh': '车辆',
      'ja': '車両'
    }, {
      'id': 'WainwrightTableItem',
      'en': 'Wainwright Table',
      'fr': 'Table Wainwright',
      'es': 'Mesa Wainwright',
      'de': 'Wainwright-Tisch',
      'pl': 'Stół Wainwrighta',
      'ru': 'Стол Уэйнрайта',
      'uk': 'Стіл Уейнрайта',
      'ko': '웨인라이트 테이블',
      'zh': '温赖特表',
      'ja': 'ウェインライトテーブル'
    }, {
      'id': 'WallCandleItem',
      'en': 'Wall Candle',
      'fr': 'Bougie murale',
      'es': 'Vela de pared',
      'de': 'Wandkerze',
      'pl': 'Świeca ścienna',
      'ru': 'Настенная свеча',
      'uk': 'Настінна свічка',
      'ko': '벽 양초',
      'zh': '壁挂蜡烛',
      'ja': 'ウォールキャンドル'
    }, {
      'id': 'WashboardItem',
      'en': 'Washboard',
      'fr': 'Planche à laver',
      'es': 'tabla de lavar',
      'de': 'Waschbrett',
      'pl': 'Tarka do prania',
      'ru': 'Стиральная доска',
      'uk': 'Пральна дошка',
      'ko': '빨래판',
      'zh': '搓板',
      'ja': '洗濯板'
    }, {
      'id': 'WashingMachineItem',
      'en': 'Washing Machine',
      'fr': 'Machine à laver',
      'es': 'Lavadora',
      'de': 'Waschmaschine',
      'pl': 'Pralka',
      'ru': 'Стиральная машина',
      'uk': 'Пральна машина',
      'ko': '세탁기',
      'zh': '洗衣机',
      'ja': '洗濯機'
    }, {
      'id': 'WasteFilterItem',
      'en': 'Waste Filter',
      'fr': 'Filtre à déchets',
      'es': 'Filtro de residuos',
      'de': 'Abfallfilter',
      'pl': 'Filtr odpadów',
      'ru': 'Фильтр отходов',
      'uk': 'Фільтр для відходів',
      'ko': '폐기물 필터',
      'zh': '废物过滤器',
      'ja': '廃棄物フィルター'
    }, {
      'id': 'WaterweedSeedItem',
      'en': 'Waterweed Seed',
      'fr': 'Graine d\u0027élodée',
      'es': 'Semilla de alga acuática',
      'de': 'Seegras-Samen',
      'pl': 'Nasiona wodorostów',
      'ru': 'Семена водорослей',
      'uk': 'Насіння водоросту',
      'ko': '수초 씨앗',
      'zh': '水草种子',
      'ja': '水草の種'
    }, {
      'id': 'WaterwheelItem',
      'en': 'Waterwheel',
      'fr': 'Roue hydraulique',
      'es': 'Rueda de agua',
      'de': 'Wasserrad',
      'pl': 'Młyn wodny',
      'ru': 'Водяное колесо',
      'uk': 'Водяне колесо',
      'ko': '물레 방아',
      'zh': '水车',
      'ja': '水車'
    }, {
      'id': 'WetTailingsItem',
      'en': 'Wet Tailings',
      'fr': 'Résidus humides',
      'es': 'Relaves Húmedos',
      'de': 'Nasse Rückstände',
      'pl': 'Mokre odpady poflotacyjne',
      'ru': 'Мокрые хвосты',
      'uk': 'Вологі хвости',
      'ko': '젖은 광미',
      'zh': '湿尾矿',
      'ja': 'ウェットテール'
    }, {
      'id': 'WheatItem',
      'en': 'Wheat',
      'fr': 'Du blé',
      'es': 'Trigo',
      'de': 'Weizen',
      'pl': 'Pszenica',
      'ru': 'Пшеница',
      'uk': 'пшениця',
      'ko': '밀',
      'zh': '小麦',
      'ja': '小麦'
    }, {
      'id': 'WheatSeedItem',
      'en': 'Wheat Seed',
      'fr': 'Graine de blé',
      'es': 'Semilla de trigo',
      'de': 'Weizensamen',
      'pl': 'Nasiona pszenicy',
      'ru': 'Семена пшеницы',
      'uk': 'Насіння пшениці',
      'ko': '밀씨',
      'zh': '小麦种子',
      'ja': '小麦の種'
    }, {
      'id': 'WheelbarrowItem',
      'en': 'Wheelbarrow',
      'fr': 'Brouette',
      'es': 'Carretilla',
      'de': 'Schubkarre',
      'pl': 'Taczka',
      'ru': 'Тачка',
      'uk': 'Тачка',
      'ko': '일륜차',
      'zh': '独轮车',
      'ja': '手押し車'
    }, {
      'id': 'WhiteBursageSeedItem',
      'en': 'White Bursage Seed',
      'fr': 'Graine de Bursage blanc',
      'es': 'Semilla de bursage blanco',
      'de': 'Weißer Bursage-Samen',
      'pl': 'Białe nasiona bursage',
      'ru': 'Белое семя Bursage',
      'uk': 'Біле насіння бурса',
      'ko': '흰색 Bursage 씨앗',
      'zh': '白牛蒡子',
      'ja': 'ホワイトバーセージシード'
    }, {
      'id': 'WildMixItem',
      'en': 'Wild Mix',
      'fr': 'Mélange sauvage',
      'es': 'Mezcla salvaje',
      'de': 'Wilde Mischung',
      'pl': 'Dzika mieszanka',
      'ru': 'Дикий микс',
      'uk': 'Дика суміш',
      'ko': '와일드 믹스',
      'zh': '野生混合',
      'ja': 'ワイルドミックス'
    }, {
      'id': 'WildStewItem',
      'en': 'Wild Stew',
      'fr': 'Ragoût sauvage',
      'es': 'Estofado Salvaje',
      'de': 'Wilder Eintopf',
      'pl': 'Dziki Gulasz',
      'ru': 'Дикое рагу',
      'uk': 'Дике рагу',
      'ko': '와일드 스튜',
      'zh': '野炖',
      'ja': 'ワイルドシチュー'
    }, {
      'id': 'WiltedFiddleheadsItem',
      'en': 'Wilted Fiddleheads',
      'fr': 'Têtes de violon fanées',
      'es': 'Cabezas de violín marchitas',
      'de': 'Verwelkte Fiddleheads',
      'pl': 'Zwiędłe Fiddleheads',
      'ru': 'Увядшие фиддлхеды',
      'uk': 'Зів’ялі Скриплі',
      'ko': '시든 피들 헤드',
      'zh': '枯萎的提琴手',
      'ja': 'しおれた渦巻き状若葉'
    }, {
      'id': 'WindTurbineItem',
      'en': 'Wind Turbine',
      'fr': 'Éolienne',
      'es': 'Turbina eólica',
      'de': 'Windkraftanlage',
      'pl': 'Turbina wiatrowa',
      'ru': 'Ветряная турбина',
      'uk': 'Вітрових турбін',
      'ko': '풍력 터빈',
      'zh': '风力发电机',
      'ja': '風力タービン'
    }, {
      'id': 'WindmillItem',
      'en': 'Windmill',
      'fr': 'Moulin à vent',
      'es': 'Molino',
      'de': 'Windmühle',
      'pl': 'Wiatrak',
      'ru': 'Ветряная мельница',
      'uk': 'Вітряк',
      'ko': '풍차 비슷한 것',
      'zh': '风车',
      'ja': '風車'
    }, {
      'id': 'WolfCarcassItem',
      'en': 'Wolf Carcass',
      'fr': 'Carcasse de loup',
      'es': 'cadáver de lobo',
      'de': 'Wolfskadaver',
      'pl': 'truchło wilka',
      'ru': 'Туша волка',
      'uk': 'Тушка вовка',
      'ko': '늑대 시체',
      'zh': '狼尸体',
      'ja': 'オオカミの死骸'
    }, {
      'id': 'Wood',
      'en': 'Wood',
      'fr': 'Bois',
      'es': 'Madera',
      'de': 'Holz',
      'pl': 'Drewno',
      'ru': 'Древесина',
      'uk': 'Деревина',
      'ko': '목재',
      'zh': '木头',
      'ja': '木'
    }, {
      'id': 'WoodCartItem',
      'en': 'Wood Cart',
      'fr': 'Chariot en bois',
      'es': 'carro de madera',
      'de': 'Holzwagen',
      'pl': 'Wózek na drewno',
      'ru': 'Деревянная тележка',
      'uk': 'Дерев\u0027яний візок',
      'ko': '나무 카트',
      'zh': '木车',
      'ja': 'ウッドカート'
    }, {
      'id': 'WoodPulpItem',
      'en': 'Wood Pulp',
      'fr': 'Pâte de bois',
      'es': 'Pulpa de madera',
      'de': 'Zellstoff',
      'pl': 'Miazga drzewna',
      'ru': 'Древесная масса',
      'uk': 'Деревна целюлоза',
      'ko': '목재 펄프',
      'zh': '木浆',
      'ja': '木材パルプ'
    }, {
      'id': 'WoodSignItem',
      'en': 'Wood Sign',
      'fr': 'Panneau en bois',
      'es': 'letrero de madera',
      'de': 'Holzschild',
      'pl': 'Znak drewna',
      'ru': 'Деревянный Знак',
      'uk': 'Дерев\u0027яний знак',
      'ko': '나무 사인',
      'zh': '木牌',
      'ja': 'ウッドサイン'
    }, {
      'id': 'WoodenBowItem',
      'en': 'Wooden Bow',
      'fr': 'Arc en bois',
      'es': 'Arco de madera',
      'de': 'Bogen aus Holz',
      'pl': 'Drewniany łuk',
      'ru': 'Деревянный лук',
      'uk': 'Дерев\u0027яний лук',
      'ko': '나무 활',
      'zh': '木弓',
      'ja': '木製の弓'
    }, {
      'id': 'WoodenCeilingLightItem',
      'en': 'Wooden Ceiling Light',
      'fr': 'Plafonnier en bois',
      'es': 'Luz de techo de madera',
      'de': 'Deckenleuchte aus Holz',
      'pl': 'Drewniana lampa sufitowa',
      'ru': 'Деревянный потолочный светильник',
      'uk': 'Дерев\u0027яний стельовий світильник',
      'ko': '나무 천장 조명',
      'zh': '木制吸顶灯',
      'ja': '木製シーリングライト'
    }, {
      'id': 'WoodenElevatorItem',
      'en': 'Wooden Elevator',
      'fr': 'Ascenseur en bois',
      'es': 'Ascensor de madera',
      'de': 'Aufzug aus Holz',
      'pl': 'Drewniana Winda',
      'ru': 'Деревянный лифт',
      'uk': 'Дерев\u0027яний ліфт',
      'ko': '나무 엘리베이터',
      'zh': '木制电梯',
      'ja': '木製エレベーター'
    }, {
      'id': 'WoodenElevatorCallPostItem',
      'en': 'Wooden Elevator Call Post',
      'fr': 'Poteau d\u0027appel d\u0027ascenseur en bois',
      'es': 'Poste de llamada de ascensor de madera',
      'de': 'Aufzugrufsäule aus Holz',
      'pl': 'Drewniana winda Call Post',
      'ru': 'Деревянный столб вызова лифта',
      'uk': 'Дерев\u0027яний ліфт',
      'ko': '나무 엘리베이터 콜 포스트',
      'zh': '木制电梯呼叫站',
      'ja': '木製エレベーターコールポスト'
    }, {
      'id': 'WoodenFabricBedItem',
      'en': 'Wooden Fabric Bed',
      'fr': 'Lit en tissu en bois',
      'es': 'Cama de tela de madera',
      'de': 'Stoffbett aus Holz',
      'pl': 'Drewniane łóżko z tkaniny',
      'ru': 'Деревянная Тканевая Кровать',
      'uk': 'Ліжко з дерев\u0027яної тканини',
      'ko': '나무 패브릭 침대',
      'zh': '木制布艺床',
      'ja': '木製の布製ベッド'
    }, {
      'id': 'WoodenFloorLampItem',
      'en': 'Wooden Floor Lamp',
      'fr': 'Lampadaire en bois',
      'es': 'Lámpara de pie de madera',
      'de': 'Stehlampe aus Holz',
      'pl': 'Drewniana lampa podłogowa',
      'ru': 'Деревянный Торшер',
      'uk': 'Дерев\u0027яний торшер',
      'ko': '나무 바닥 램프',
      'zh': '木质落地灯',
      'ja': '木製フロアランプ'
    }, {
      'id': 'WoodenHoeItem',
      'en': 'Wooden Hoe',
      'fr': 'Houe en bois',
      'es': 'Azada de madera',
      'de': 'Holzhacke',
      'pl': 'Drewniana motyka',
      'ru': 'Деревянная мотыга',
      'uk': 'Дерев\u0027яна мотика',
      'ko': '나무 괭이',
      'zh': '木锄头',
      'ja': '木製のくわ'
    }, {
      'id': 'WoodenKitchenLampItem',
      'en': 'Wooden Kitchen Lamp',
      'fr': 'Lampe de cuisine en bois',
      'es': 'Lámpara de cocina de madera',
      'de': 'Küchenlampe aus Holz',
      'pl': 'Drewniana lampa kuchenna',
      'ru': 'Деревянная кухонная лампа',
      'uk': 'Дерев\u0027яна кухонна лампа',
      'ko': '나무 주방 램프',
      'zh': '木制厨房灯',
      'ja': '木製キッチンランプ'
    }, {
      'id': 'WoodenLatrineItem',
      'en': 'Wooden Latrine',
      'fr': 'Latrines en bois',
      'es': 'letrina de madera',
      'de': 'Latrine aus Holz',
      'pl': 'Drewniana latryna',
      'ru': 'Деревянный туалет',
      'uk': 'Дерев\u0027яний туалет',
      'ko': '나무 변소',
      'zh': '木制厕所',
      'ja': '木製のトイレ'
    }, {
      'id': 'WoodenShovelItem',
      'en': 'Wooden Shovel',
      'fr': 'Pelle en bois',
      'es': 'pala de madera',
      'de': 'Holzschaufel',
      'pl': 'Drewniana Łopata',
      'ru': 'Деревянная лопата',
      'uk': 'Дерев\u0027яна лопата',
      'ko': '나무 삽',
      'zh': '木铲',
      'ja': '木製シャベル'
    }, {
      'id': 'WoodenStrawBedItem',
      'en': 'Wooden Straw Bed',
      'fr': 'Lit de paille en bois',
      'es': 'Cama de paja de madera',
      'de': 'Strohbett aus Holz',
      'pl': 'Drewniane łóżko ze słomy',
      'ru': 'Деревянная соломенная кровать',
      'uk': 'Дерев\u0027яне ліжко з соломи',
      'ko': '나무 짚 침대',
      'zh': '木草床',
      'ja': '木製のわらのベッド'
    }, {
      'id': 'WoodenTableLampItem',
      'en': 'Wooden Table Lamp',
      'fr': 'Lampe de table en bois',
      'es': 'Lámpara de mesa de madera',
      'de': 'Tischlampe aus Holz',
      'pl': 'Drewniana lampa stołowa',
      'ru': 'Деревянная настольная лампа',
      'uk': 'Дерев\u0027яна настільна лампа',
      'ko': '나무 테이블 램프',
      'zh': '木制台灯',
      'ja': '木製のテーブルランプ'
    }, {
      'id': 'WoodenWheelItem',
      'en': 'Wooden Wheel',
      'fr': 'Roue en bois',
      'es': 'Rueda de madera',
      'de': 'Holzrad',
      'pl': 'Drewniane koło',
      'ru': 'Деревянное колесо',
      'uk': 'Дерев\u0027яне колесо',
      'ko': '나무 바퀴',
      'zh': '木轮',
      'ja': '木製ホイール'
    }, {
      'id': 'WoolCarpetItem',
      'en': 'Wool Carpet',
      'fr': 'Tapis en laine',
      'es': 'Alfombra de lana',
      'de': 'Wollteppich',
      'pl': 'Dywan wełniany',
      'ru': 'Шерстяной ковер',
      'uk': 'Вовняний килим',
      'ko': '양모 카펫',
      'zh': '羊毛地毯',
      'ja': 'ウールカーペット'
    }, {
      'id': 'WoolCurtainsItem',
      'en': 'Wool Curtains',
      'fr': 'Rideaux en laine',
      'es': 'Cortinas de lana',
      'de': 'Wollvorhänge',
      'pl': 'Zasłony wełniane',
      'ru': 'Шерстяные шторы',
      'uk': 'Вовняні штори',
      'ko': '울 커튼',
      'zh': '羊毛窗帘',
      'ja': 'ウールカーテン'
    }, {
      'id': 'WoolFabricItem',
      'en': 'Wool Fabric',
      'fr': 'Tissu en laine',
      'es': 'Tejido de lana',
      'de': 'Wollstoff',
      'pl': 'Tkanina wełniana',
      'ru': 'Шерстяная Ткань',
      'uk': 'Вовняна тканина',
      'ko': '울 원단',
      'zh': '羊毛面料',
      'ja': 'ウール生地'
    }, {
      'id': 'WoolYarnItem',
      'en': 'Wool Yarn',
      'fr': 'Fil de laine',
      'es': 'Hilados de lana',
      'de': 'Wollgarn',
      'pl': 'Przędza wełniana',
      'ru': 'Шерстяная пряжа',
      'uk': 'Вовняна пряжа',
      'ko': '양모사',
      'zh': '羊毛纱',
      'ja': 'ウール糸'
    }, {
      'id': 'WorkBackpackItem',
      'en': 'Work Backpack',
      'fr': 'Sac à dos de travail',
      'es': 'Mochila de trabajo',
      'de': 'Arbeitsrucksack',
      'pl': 'Plecak roboczy',
      'ru': 'Рабочий рюкзак',
      'uk': 'Робочий рюкзак',
      'ko': '작업 백팩',
      'zh': '工作背包',
      'ja': '仕事用バックパック'
    }, {
      'id': 'WorkBootsItem',
      'en': 'Work Boots',
      'fr': 'Bottes de travail',
      'es': 'Botas de trabajo',
      'de': 'Arbeitsschuhe',
      'pl': 'Buty robocze',
      'ru': 'Рабочие ботинки',
      'uk': 'Робочі черевики',
      'ko': '작업 부츠',
      'zh': '工作靴',
      'ja': 'ワークブーツ'
    }, {
      'id': 'WorkbenchItem',
      'en': 'Workbench',
      'fr': 'Table de travail',
      'es': 'banco de trabajo',
      'de': 'Werkbank',
      'pl': 'stoł warsztatowy',
      'ru': 'Верстак',
      'uk': 'Верстак',
      'ko': '작업대',
      'zh': '工作台',
      'ja': 'ワークベンチ'
    }, {
      'id': 'WorldlyDonutItem',
      'en': 'Worldly Donut',
      'fr': 'Beignet mondain',
      'es': 'Rosquilla mundana',
      'de': 'Weltlicher Donut',
      'pl': 'Światowy pączek',
      'ru': 'Мирской пончик',
      'uk': 'Світський пончик',
      'ko': '세속적인 도넛',
      'zh': '世俗的甜甜圈',
      'ja': '世俗的なドーナツ'
    }, {
      'id': 'YeastItem',
      'en': 'Yeast',
      'fr': 'Levure',
      'es': 'Levadura',
      'de': 'Hefe',
      'pl': 'Drożdże',
      'ru': 'Дрожжи',
      'uk': 'Дріжджі',
      'ko': '누룩',
      'zh': '酵母',
      'ja': '酵母'
    }, {
      'id': 'ZoningOfficeItem',
      'en': 'Zoning Office',
      'fr': 'Bureau de zonage',
      'es': 'Oficina de Zonificación',
      'de': 'Zonenamt',
      'pl': 'Biuro Zagospodarowania Przestrzennego',
      'ru': 'Зонирование офиса',
      'uk': 'Офіс зонування',
      'ko': '구역 사무소',
      'zh': '分区办公室',
      'ja': 'ゾーニングオフィス'
    }]
  }, {
    'type': 'recipes', 'entries': [{
      'id': 'AcornPowder',
      'en': 'Acorn Powder',
      'fr': 'Poudre de gland',
      'es': 'polvo de bellota',
      'de': 'Eichelpulver',
      'pl': 'Proszek żołędziowy',
      'ru': 'желудь порошок',
      'uk': 'Жолудевий порошок',
      'ko': '도토리가루',
      'zh': '橡子粉',
      'ja': 'どんぐり粉'
    }, {
      'id': 'AdornedAshlarStoneBench',
      'en': 'Adorned Ashlar Stone Bench',
      'fr': 'Banc en pierre de taille ornée',
      'es': 'Banco de sillería adornada',
      'de': 'Geschmückte Quadersteinbank',
      'pl': 'Zdobiona kamienna ławka Ashlar',
      'ru': 'Украшенная скамья из тесаного камня',
      'uk': 'Прикрашена кам’яна лавка з тесену',
      'ko': '장식된 Ashlar 돌 벤치',
      'zh': '装饰的 Ashlar 石凳',
      'ja': '飾られた切石の石のベンチ'
    }, {
      'id': 'AdornedAshlarStoneChair',
      'en': 'Adorned Ashlar Stone Chair',
      'fr': 'Chaise en pierre de taille ornée',
      'es': 'Silla de sillería adornada',
      'de': 'Geschmückter Quaderstein-Stuhl',
      'pl': 'Zdobione kamienne krzesło Ashlar',
      'ru': 'Украшенное каменное кресло из ашлара',
      'uk': 'Прикрашене кам\u0027яне крісло',
      'ko': '장식된 Ashlar 돌 의자',
      'zh': '装饰阿什拉石椅',
      'ja': '飾られた切石石の椅子'
    }, {
      'id': 'AdornedAshlarStoneTable',
      'en': 'Adorned Ashlar Stone Table',
      'fr': 'Table en pierre de taille ornée',
      'es': 'Mesa de sillería adornada',
      'de': 'Geschmückter Quadersteintisch',
      'pl': 'Zdobiony kamienny stół z Ashlar',
      'ru': 'Украшенный стол из тесаного камня',
      'uk': 'Прикрашений кам’яний стіл з тесену',
      'ko': '장식된 Ashlar 돌 테이블',
      'zh': '装饰的方石桌',
      'ja': '飾られた切石石のテーブル'
    }, {
      'id': 'AdvancedBakingUpgrade',
      'en': 'Advanced Baking Upgrade',
      'fr': 'Mise à niveau de cuisson avancée',
      'es': 'Actualización avanzada de horneado',
      'de': 'Fortgeschrittenes Back-Upgrade',
      'pl': 'Zaawansowana aktualizacja pieczenia',
      'ru': 'Расширенное обновление выпечки',
      'uk': 'Розширене оновлення випічки',
      'ko': '고급 베이킹 업그레이드',
      'zh': '高级烘焙升级',
      'ja': '高度なベーキングアップグレード'
    }, {
      'id': 'AdvancedCarpentryTable',
      'en': 'Advanced Carpentry Table',
      'fr': 'Table de menuiserie avancée',
      'es': 'Mesa de Carpintería Avanzada',
      'de': 'Tischlertisch für Fortgeschrittene',
      'pl': 'Zaawansowany stół stolarski',
      'ru': 'Усовершенствованный столярный стол',
      'uk': 'Розширений столярний стол',
      'ko': '고급 목공 테이블',
      'zh': '高级木工桌',
      'ja': '高度な木工テーブル'
    }, {
      'id': 'AdvancedCircuit',
      'en': 'Advanced Circuit',
      'fr': 'Circuit avancé',
      'es': 'Circuito Avanzado',
      'de': 'Erweiterte Schaltung',
      'pl': 'Zaawansowany obwód',
      'ru': 'Расширенная схема',
      'uk': 'Розширена схема',
      'ko': '고급 회로',
      'zh': '高级电路',
      'ja': '高度な回路'
    }, {
      'id': 'AdvancedCombustionEngine',
      'en': 'Advanced Combustion Engine',
      'fr': 'Moteur à combustion avancé',
      'es': 'Motor de combustión avanzado',
      'de': 'Fortschrittlicher Verbrennungsmotor',
      'pl': 'Zaawansowany silnik spalinowy',
      'ru': 'Усовершенствованный двигатель внутреннего сгорания',
      'uk': 'Розширений двигун внутрішнього згоряння',
      'ko': '고급 연소 엔진',
      'zh': '先进的内燃机',
      'ja': '高度な燃焼エンジン'
    }, {
      'id': 'AdvancedCookingUpgrade',
      'en': 'Advanced Cooking Upgrade',
      'fr': 'Amélioration de la cuisine avancée',
      'es': 'Actualización de cocina avanzada',
      'de': 'Fortgeschrittenes Koch-Upgrade',
      'pl': 'Zaawansowana aktualizacja gotowania',
      'ru': 'Расширенное кулинарное обновление',
      'uk': 'Розширене оновлення приготування їжі',
      'ko': '고급 요리 업그레이드',
      'zh': '高级烹饪升级',
      'ja': '高度な料理のアップグレード'
    }, {
      'id': 'AdvancedMasonryTable',
      'en': 'Advanced Masonry Table',
      'fr': 'Table de maçonnerie avancée',
      'es': 'Mesa de albañilería avanzada',
      'de': 'Fortgeschrittener Mauerwerkstisch',
      'pl': 'Zaawansowany stół murarski',
      'ru': 'Усовершенствованная таблица каменной кладки',
      'uk': 'Розширений стіл для кладки',
      'ko': '고급 벽돌 테이블',
      'zh': '高级砌体表',
      'ja': '高度な組積造テーブル'
    }, {
      'id': 'AdvancedMasonryUpgrade',
      'en': 'Advanced Masonry Upgrade',
      'fr': 'Mise à niveau avancée de la maçonnerie',
      'es': 'Actualización avanzada de mampostería',
      'de': 'Fortgeschrittenes Mauerwerk-Upgrade',
      'pl': 'Zaawansowana modernizacja murów',
      'ru': 'Продвинутое обновление каменной кладки',
      'uk': 'Розширене оновлення кладки',
      'ko': '고급 벽돌 업그레이드',
      'zh': '高级砌体升级',
      'ja': '高度な組積造のアップグレード'
    }, {
      'id': 'AdvancedSmeltingUpgrade',
      'en': 'Advanced Smelting Upgrade',
      'fr': 'Mise à niveau avancée de la fusion',
      'es': 'Actualización de fundición avanzada',
      'de': 'Fortgeschrittenes Schmelz-Upgrade',
      'pl': 'Zaawansowane Ulepszenie Wytapiania',
      'ru': 'Усовершенствованная плавка',
      'uk': 'Розширене оновлення плавлення',
      'ko': '고급 제련 업그레이드',
      'zh': '高级冶炼升级',
      'ja': '高度な製錬のアップグレード'
    }, {
      'id': 'AdvancedTailoringTable',
      'en': 'Advanced Tailoring Table',
      'fr': 'Table de couture avancée',
      'es': 'Mesa de Sastrería Avanzada',
      'de': 'Tabelle für fortgeschrittene Schneiderei',
      'pl': 'Zaawansowana tabela krawiectwa',
      'ru': 'Усовершенствованная таблица пошива',
      'uk': 'Розширений стіл для пошиття',
      'ko': '고급 재봉 테이블',
      'zh': '高级裁缝表',
      'ja': '高度な仕立てテーブル'
    }, {
      'id': 'AdvancedUpgradeLvl1',
      'en': 'Advanced Upgrade 1',
      'fr': 'Mise à niveau avancée 1',
      'es': 'Actualización avanzada 1',
      'de': 'Erweitertes Upgrade 1',
      'pl': 'Zaawansowana aktualizacja 1',
      'ru': 'Расширенное обновление 1',
      'uk': 'Розширене оновлення 1',
      'ko': '고급 업그레이드 1',
      'zh': '高级升级 1',
      'ja': '高度なアップグレード1'
    }, {
      'id': 'AdvancedUpgradeLvl2',
      'en': 'Advanced Upgrade 2',
      'fr': 'Mise à niveau avancée 2',
      'es': 'Actualización avanzada 2',
      'de': 'Erweitertes Upgrade 2',
      'pl': 'Zaawansowana aktualizacja 2',
      'ru': 'Расширенное обновление 2',
      'uk': 'Розширене оновлення 2',
      'ko': '고급 업그레이드 2',
      'zh': '高级升级 2',
      'ja': '高度なアップグレード2'
    }, {
      'id': 'AdvancedUpgradeLvl3',
      'en': 'Advanced Upgrade 3',
      'fr': 'Mise à niveau avancée 3',
      'es': 'Actualización avanzada 3',
      'de': 'Erweitertes Upgrade 3',
      'pl': 'Zaawansowana aktualizacja 3',
      'ru': 'Расширенное обновление 3',
      'uk': 'Розширене оновлення 3',
      'ko': '고급 업그레이드 3',
      'zh': '进阶升级 3',
      'ja': '高度なアップグレード3'
    }, {
      'id': 'AdvancedUpgradeLvl4',
      'en': 'Advanced Upgrade 4',
      'fr': 'Mise à niveau avancée 4',
      'es': 'Actualización avanzada 4',
      'de': 'Erweitertes Upgrade 4',
      'pl': 'Zaawansowana aktualizacja 4',
      'ru': 'Расширенное обновление 4',
      'uk': 'Розширене оновлення 4',
      'ko': '고급 업그레이드 4',
      'zh': '高级升级 4',
      'ja': '高度なアップグレード4'
    }, {
      'id': 'AgaveSeed',
      'en': 'Agave Seed',
      'fr': 'Graine d\u0027agave',
      'es': 'Semilla de agave',
      'de': 'Agavensamen',
      'pl': 'Nasiona agawy',
      'ru': 'Семена агавы',
      'uk': 'Насіння агави',
      'ko': '용설란 씨앗',
      'zh': '龙舌兰种子',
      'ja': 'リュウゼツランの種'
    }, {
      'id': 'AgoutiEnchiladas',
      'en': 'Agouti Enchiladas',
      'fr': 'Enchiladas agouti',
      'es': 'Enchiladas Agutí',
      'de': 'Agouti-Enchiladas',
      'pl': 'Aguti Enchiladas',
      'ru': 'Агути Энчиладас',
      'uk': 'Агуті Енчіладас',
      'ko': '아구티 엔칠라다스',
      'zh': '刺鼠辣酱',
      'ja': 'アグーチエンチラーダ'
    }, {
      'id': 'AgricultureResearchPaperAdvanced',
      'en': 'Agriculture Research Paper Advanced',
      'fr': 'Document de recherche agricole avancé',
      'es': 'Trabajo de investigación agrícola avanzado',
      'de': 'Landwirtschaftliches Forschungspapier für Fortgeschrittene',
      'pl': 'Zaawansowany dokument z badań rolnictwa',
      'ru': 'Сельскохозяйственная исследовательская работа Advanced',
      'uk': 'Дослідження сільського господарства Advanced',
      'ko': '농업 연구 논문 고급',
      'zh': '农业研究论文高级',
      'ja': '農業研究論文アドバンスト'
    }, {
      'id': 'AgricultureResearchPaperModern',
      'en': 'Agriculture Research Paper Modern',
      'fr': 'Document de recherche agricole moderne',
      'es': 'Papel de investigación agrícola moderno',
      'de': 'Agrarwissenschaftliches Papier Modern',
      'pl': 'Nowoczesna praca naukowa w dziedzinie rolnictwa',
      'ru': 'Современная сельскохозяйственная исследовательская работа',
      'uk': 'Дослідження сільського господарства Сучасні',
      'ko': '농업 연구 논문 현대',
      'zh': '现代农业研究论文',
      'ja': '現代農業研究論文'
    }, {
      'id': 'AmanitaMushroomSpores',
      'en': 'Amanita Mushroom Spores',
      'fr': 'Spores de champignons amanites',
      'es': 'Esporas de Hongo Amanita',
      'de': 'Amanita-Pilzsporen',
      'pl': 'Zarodniki grzybów Amanita',
      'ru': 'Споры мухомора',
      'uk': 'Спори грибів мухомору',
      'ko': '아마니타 버섯 포자',
      'zh': '鹅膏菌孢子',
      'ja': 'ベニテングタケの胞子'
    }, {
      'id': 'Anvil',
      'en': 'Anvil',
      'fr': 'Enclume',
      'es': 'Yunque',
      'de': 'Amboss',
      'pl': 'Kowadło',
      'ru': 'Наковальня',
      'uk': 'Наковадло',
      'ko': '모루',
      'zh': '砧',
      'ja': 'アンビル'
    }, {
      'id': 'Arrastra',
      'en': 'Arrastra',
      'fr': 'Arrastra',
      'es': 'arrastra',
      'de': 'Arrastra',
      'pl': 'Arrastra',
      'ru': 'Аррастра',
      'uk': 'Аррастра',
      'ko': '아라스트라',
      'zh': '阿拉斯特拉',
      'ja': 'アラストラ'
    }, {
      'id': 'AshlarBasalt',
      'en': 'Ashlar Basalt',
      'fr': 'Basalte de pierre de taille',
      'es': 'Basalto de sillería',
      'de': 'Basaltquader',
      'pl': 'Aszlar bazalt',
      'ru': 'Ашлар Базальт',
      'uk': 'Ашларовий базальт',
      'ko': 'Ashlar 현무암',
      'zh': '方石玄武岩',
      'ja': '切石玄武岩'
    }, {
      'id': 'AshlarGneiss',
      'en': 'Ashlar Gneiss',
      'fr': 'Gneiss de pierre de taille',
      'es': 'Gneis sillar',
      'de': 'Quader Gneis',
      'pl': 'Ashlar Gnejs',
      'ru': 'Ашлар Гнейс',
      'uk': 'Ашлар Гнейс',
      'ko': 'Ashlar 편마암',
      'zh': '方石片麻岩',
      'ja': '切石片麻岩'
    }, {
      'id': 'AshlarGranite',
      'en': 'Ashlar Granite',
      'fr': 'Granit de pierre de taille',
      'es': 'Granito sillar',
      'de': 'Quader Granit',
      'pl': 'Granit Ashlar',
      'ru': 'Ашлар Гранит',
      'uk': 'Ашларовий граніт',
      'ko': 'Ashlar 화강암',
      'zh': '方石花岗岩',
      'ja': '切石花崗岩'
    }, {
      'id': 'AshlarLargeStoneFountain',
      'en': 'Ashlar Large Stone Fountain',
      'fr': 'Grande fontaine en pierre de taille',
      'es': 'Fuente Grande de Piedra de Sillería',
      'de': 'Ashlar großer Steinbrunnen',
      'pl': 'Duża kamienna fontanna Ashlar',
      'ru': 'Большой каменный фонтан Ашлар',
      'uk': 'Великий кам\u0027яний фонтан',
      'ko': 'Ashlar 대형 돌 분수',
      'zh': '方石大石喷泉',
      'ja': '切石の大きな石の噴水'
    }, {
      'id': 'AshlarLimestone',
      'en': 'Ashlar Limestone',
      'fr': 'Calcaire de pierre de taille',
      'es': 'Piedra caliza sillar',
      'de': 'Quader Kalkstein',
      'pl': 'Wapień Ashlar',
      'ru': 'Ашлар Известняк',
      'uk': 'Тесниний вапняк',
      'ko': 'Ashlar 석회암',
      'zh': '方石石灰石',
      'ja': '切石石灰岩'
    }, {
      'id': 'AshlarSandstone',
      'en': 'Ashlar Sandstone',
      'fr': 'Grès de pierre de taille',
      'es': 'Arenisca sillar',
      'de': 'Quader Sandstein',
      'pl': 'Piaskowiec Ashlar',
      'ru': 'Ашлар Песчаник',
      'uk': 'Пісковик з каменю',
      'ko': 'Ashlar 사암',
      'zh': '方石砂岩',
      'ja': '切石砂岩'
    }, {
      'id': 'AshlarShale',
      'en': 'Ashlar Shale',
      'fr': 'Schiste de pierre de taille',
      'es': 'Esquisto de sillería',
      'de': 'Ashlar-Schiefer',
      'pl': 'Ashlar Shale',
      'ru': 'Ашлар Шейл',
      'uk': 'Ашлар Сланець',
      'ko': '애슐라 셰일',
      'zh': '方石页岩',
      'ja': '切石頁岩'
    }, {
      'id': 'AshlarSmallStoneFountain',
      'en': 'Ashlar Small Stone Fountain',
      'fr': 'Petite fontaine en pierre de taille',
      'es': 'Fuente Pequeña de Piedra de Sillería',
      'de': 'Ashlar kleiner Steinbrunnen',
      'pl': 'Mała kamienna fontanna Ashlar',
      'ru': 'Маленький каменный фонтан Ашлар',
      'uk': 'Невеликий кам\u0027яний фонтан з тесену',
      'ko': 'Ashlar 작은 돌 분수',
      'zh': '方石小石喷泉',
      'ja': '切石の小さな石の噴水'
    }, {
      'id': 'AshlarStoneBench',
      'en': 'Ashlar Stone Bench',
      'fr': 'Banc en pierre de taille',
      'es': 'Banco de piedra de sillería',
      'de': 'Ashlar Steinbank',
      'pl': 'Kamienna ławka Ashlar',
      'ru': 'Каменная скамья Ашлара',
      'uk': 'Кам\u0027яна лавка з тесену',
      'ko': 'Ashlar 돌 벤치',
      'zh': '阿什拉石凳',
      'ja': '切石ベンチ'
    }, {
      'id': 'AshlarStoneChair',
      'en': 'Ashlar Stone Chair',
      'fr': 'Chaise en pierre de taille',
      'es': 'Silla de piedra sillar',
      'de': 'Ashlar Steinstuhl',
      'pl': 'Kamienne krzesło Ashlar',
      'ru': 'Каменный стул Ашлар',
      'uk': 'Кам\u0027яний стілець Ashlar',
      'ko': 'Ashlar 돌 의자',
      'zh': '方石椅',
      'ja': '切石の椅子'
    }, {
      'id': 'AshlarStoneDoor',
      'en': 'Ashlar Stone Door',
      'fr': 'Porte en pierre de taille',
      'es': 'Puerta de piedra de sillería',
      'de': 'Quadersteintür',
      'pl': 'Kamienne drzwi z Ashlar',
      'ru': 'Ашларская каменная дверь',
      'uk': 'Кам\u0027яні двері',
      'ko': 'Ashlar 돌 문',
      'zh': '方石门',
      'ja': '切石の石の扉'
    }, {
      'id': 'AshlarStoneFireplace',
      'en': 'Ashlar Stone Fireplace',
      'fr': 'Cheminée en pierre de taille',
      'es': 'Chimenea de sillería',
      'de': 'Kamin aus Quaderstein',
      'pl': 'Kominek z kamienia Ashlar',
      'ru': 'Ашларский каменный камин',
      'uk': 'Камін з тесневого каменю',
      'ko': 'Ashlar 돌 벽난로',
      'zh': 'Ashlar石壁炉',
      'ja': '切石石暖炉'
    }, {
      'id': 'AshlarStoneTable',
      'en': 'Ashlar Stone Table',
      'fr': 'Table en pierre de taille',
      'es': 'Mesa de Piedra de Sillería',
      'de': 'Quadersteintisch',
      'pl': 'Kamienny stół z Ashlar',
      'ru': 'Каменный стол из ашлара',
      'uk': 'Кам\u0027яний стіл з тесену',
      'ko': 'Ashlar 돌 테이블',
      'zh': '方石桌',
      'ja': '切石テーブル'
    }, {
      'id': 'AsphaltConcrete',
      'en': 'Asphalt Concrete',
      'fr': 'Béton d\u0027asphalte',
      'es': 'Hormigón asfáltico',
      'de': 'Asphalt, Beton',
      'pl': 'Beton asfaltowy',
      'ru': 'Асфальт Бетон',
      'uk': 'Асфальтобетон',
      'ko': '아스팔트 콘크리트',
      'zh': '沥青混凝土',
      'ja': 'アスファルトコンクリート'
    }, {
      'id': 'AssemblyLine',
      'en': 'Assembly Line',
      'fr': 'Ligne d\u0027assemblage',
      'es': 'Linea de ensamblaje',
      'de': 'Fließband',
      'pl': 'Linia produkcyjna',
      'ru': 'Сборочная линия',
      'uk': 'Лінія збірки',
      'ko': '조립 라인',
      'zh': '流水线',
      'ja': '組み立てライン'
    }, {
      'id': 'AutomaticLoom',
      'en': 'Automatic Loom',
      'fr': 'Métier à tisser automatique',
      'es': 'Telar Automático',
      'de': 'Automatischer Webstuhl',
      'pl': 'Automatyczne krosno',
      'ru': 'Автоматический ткацкий станок',
      'uk': 'Автоматичний ткацький верстат',
      'ko': '자동 베틀',
      'zh': '自动织机',
      'ja': '自動織機'
    }, {
      'id': 'AutumnStew',
      'en': 'Autumn Stew',
      'fr': 'Ragoût d\u0027automne',
      'es': 'Estofado de Otoño',
      'de': 'Herbsteintopf',
      'pl': 'Jesienny Gulasz',
      'ru': 'Осеннее рагу',
      'uk': 'Осіннє рагу',
      'ko': '가을 스튜',
      'zh': '秋炖',
      'ja': '秋のシチュー'
    }, {
      'id': 'BakedAgave',
      'en': 'Baked Agave',
      'fr': 'Agave au four',
      'es': 'Agave al horno',
      'de': 'Gebackene Agave',
      'pl': 'Pieczona Agawa',
      'ru': 'Запеченная агава',
      'uk': 'Запечена агава',
      'ko': '구운 용설란',
      'zh': '烤龙舌兰',
      'ja': '焼きリュウゼツラン'
    }, {
      'id': 'BakedBeet',
      'en': 'Baked Beet',
      'fr': 'Betterave au four',
      'es': 'Remolacha al horno',
      'de': 'Gebackene Rübe',
      'pl': 'Pieczony Burak',
      'ru': 'Запеченная свекла',
      'uk': 'Запечений буряк',
      'ko': '구운 비트',
      'zh': '烤甜菜',
      'ja': '焼きたてのビート'
    }, {
      'id': 'BakedCorn',
      'en': 'Baked Corn',
      'fr': 'Maïs au four',
      'es': 'Maíz al horno',
      'de': 'Gebackener Mais',
      'pl': 'Pieczona Kukurydza',
      'ru': 'Запеченная кукуруза',
      'uk': 'Запечена кукурудза',
      'ko': '구운 옥수수',
      'zh': '烤玉米',
      'ja': '焼きとうもろこし'
    }, {
      'id': 'BakedHeartOfPalm',
      'en': 'Baked Heart Of Palm',
      'fr': 'Cœur de palmier au four',
      'es': 'Palmito al horno',
      'de': 'Gebackenes Palmenherz',
      'pl': 'Pieczone Serce Palmowe',
      'ru': 'Запеченное Сердце Пальмы',
      'uk': 'Запечене серце пальми',
      'ko': '구운된 야자수',
      'zh': '烤棕榈心',
      'ja': '焼きたてのハートオブパーム'
    }, {
      'id': 'BakedMeat',
      'en': 'Baked Meat',
      'fr': 'Viande au Four',
      'es': 'Carne al horno',
      'de': 'Gebackenes Fleisch',
      'pl': 'Pieczone Mięso',
      'ru': 'Запеченное мясо',
      'uk': 'Запечене м\u0027ясо',
      'ko': '구운 고기',
      'zh': '焗肉',
      'ja': '焼き肉'
    }, {
      'id': 'BakedRoast',
      'en': 'Baked Roast',
      'fr': 'Rôti au four',
      'es': 'Asado Al Horno',
      'de': 'Gebackener Braten',
      'pl': 'Pieczona Pieczeń',
      'ru': 'Запеченное жаркое',
      'uk': 'Запечена печеня',
      'ko': '구운 로스트',
      'zh': '焗烤',
      'ja': '焼きたての焙煎'
    }, {
      'id': 'BakedTaro',
      'en': 'Baked Taro',
      'fr': 'Taro au four',
      'es': 'Taro al horno',
      'de': 'Gebackener Taro',
      'pl': 'Pieczony Taro',
      'ru': 'Запеченное Таро',
      'uk': 'Запечене Таро',
      'ko': '구운 타로',
      'zh': '烤芋头',
      'ja': '焼き里芋'
    }, {
      'id': 'BakedTomato',
      'en': 'Baked Tomato',
      'fr': 'Tomate au Four',
      'es': 'tomate al horno',
      'de': 'Gebackene Tomate',
      'pl': 'Pieczony Pomidor',
      'ru': 'Запеченный помидор',
      'uk': 'Запечений помідор',
      'ko': '구운 토마토',
      'zh': '烤番茄',
      'ja': '焼きトマト'
    }, {
      'id': 'BakeryOven',
      'en': 'Bakery Oven',
      'fr': 'Four de boulangerie',
      'es': 'Horno de panadería',
      'de': 'Bäckerei Ofen',
      'pl': 'Piekarnik',
      'ru': 'Пекарня печь',
      'uk': 'Пекарня',
      'ko': '베이커리 오븐',
      'zh': '面包烤箱',
      'ja': 'ベーカリーオーブン'
    }, {
      'id': 'BakingUpgrade',
      'en': 'Baking Upgrade',
      'fr': 'Mise à niveau de cuisson',
      'es': 'Mejora para hornear',
      'de': 'Back-Upgrade',
      'pl': 'Ulepszenie pieczenia',
      'ru': 'Обновление выпечки',
      'uk': 'Оновлення випічки',
      'ko': '베이킹 업그레이드',
      'zh': '烘焙升级',
      'ja': 'ベーキングアップグレード'
    }, {
      'id': 'Bandana',
      'en': 'Bandana',
      'fr': 'Bandana',
      'es': 'Pañuelo',
      'de': 'Bandana',
      'pl': 'Chustka',
      'ru': 'Бандана',
      'uk': 'Бандана',
      'ko': '두건',
      'zh': '头巾',
      'ja': 'バンダナ'
    }, {
      'id': 'BanhXeo',
      'en': 'Banh Xeo',
      'fr': 'Banh Xéo',
      'es': 'Banh Xeo',
      'de': 'Banh Xeo',
      'pl': 'Banh Xeo',
      'ru': 'Банх Ксео',
      'uk': 'Banh Xeo',
      'ko': '반쎄오',
      'zh': 'Banh Xeo',
      'ja': 'バインセオ'
    }, {
      'id': 'Bank',
      'en': 'Bank',
      'fr': 'Banque',
      'es': 'Banco',
      'de': 'Bank',
      'pl': 'Bank',
      'ru': 'Банк',
      'uk': 'банк',
      'ko': '은행',
      'zh': '银行',
      'ja': '銀行'
    }, {
      'id': 'Bannock',
      'en': 'Bannock',
      'fr': 'Bannock',
      'es': 'Bannock',
      'de': 'Bannock',
      'pl': 'Bannock',
      'ru': 'Баннок',
      'uk': 'Беннок',
      'ko': '배녹',
      'zh': '班诺克',
      'ja': 'バノック'
    }, {
      'id': 'Barrel',
      'en': 'Barrel',
      'fr': 'Baril',
      'es': 'Barril',
      'de': 'Fass',
      'pl': 'Beczka',
      'ru': 'Бочка',
      'uk': 'Бочка',
      'ko': '통',
      'zh': '桶',
      'ja': 'たる'
    }, {
      'id': 'BasicCircuit',
      'en': 'Basic Circuit',
      'fr': 'Circuit de base',
      'es': 'Circuito básico',
      'de': 'Grundschaltung',
      'pl': 'Obwód podstawowy',
      'ru': 'Базовая схема',
      'uk': 'Базовий контур',
      'ko': '기본 회로',
      'zh': '基本电路',
      'ja': '基本回路'
    }, {
      'id': 'BasicEngineeringUpgrade',
      'en': 'Basic Engineering Upgrade',
      'fr': 'Mise à niveau d\u0027ingénierie de base',
      'es': 'Actualización de ingeniería básica',
      'de': 'Basic Engineering-Upgrade',
      'pl': 'Podstawowe ulepszenie inżynierii',
      'ru': 'Базовое техническое обновление',
      'uk': 'Базове інженерне оновлення',
      'ko': '기본 엔지니어링 업그레이드',
      'zh': '基础工程升级',
      'ja': '基本的なエンジニアリングのアップグレード'
    }, {
      'id': 'ExoticSalad',
      'en': 'Exotic Salad',
      'fr': 'Salade Exotique',
      'es': 'Ensalada Exótica',
      'de': 'Exotischer Salat',
      'pl': 'Sałatka Egzotyczna',
      'ru': 'Экзотический салат',
      'uk': 'Екзотичний салат',
      'ko': '이국적인 샐러드',
      'zh': '异国沙拉',
      'ja': 'エキゾチックサラダ'
    }, {
      'id': 'ForestSalad',
      'en': 'Forest Salad',
      'fr': 'Salade Forestière',
      'es': 'Ensalada del Bosque',
      'de': 'Waldsalat',
      'pl': 'Sałatka Leśna',
      'ru': 'Лесной салат',
      'uk': 'Лісовий салат',
      'ko': '포레스트 샐러드',
      'zh': '森林沙拉',
      'ja': '森のサラダ'
    }, {
      'id': 'GrasslandSalad',
      'en': 'Grassland Salad',
      'fr': 'Salade des Prairies',
      'es': 'Ensalada De Pastizales',
      'de': 'Grünlandsalat',
      'pl': 'Sałatka z Łąki',
      'ru': 'Пастбищный салат',
      'uk': 'Салат з лугу',
      'ko': '초원 샐러드',
      'zh': '草原沙拉',
      'ja': '草地サラダ'
    }, {
      'id': 'MixedSalad',
      'en': 'Mixed Salad',
      'fr': 'Salade composée',
      'es': 'Ensalada mixta',
      'de': 'Gemischter Salat',
      'pl': 'Sałatka Mieszana',
      'ru': 'Перемешанный салат',
      'uk': 'Салат',
      'ko': '믹스 샐러드',
      'zh': '混合沙拉',
      'ja': 'ミックスサラダ'
    }, {
      'id': 'RainforestSalad',
      'en': 'Rainforest Salad',
      'fr': 'Salade de la forêt tropicale',
      'es': 'Ensalada Selva Tropical',
      'de': 'Regenwaldsalat',
      'pl': 'Sałatka z Lasu Deszczowego',
      'ru': 'Салат «Тропический лес»',
      'uk': 'Салат тропічний ліс',
      'ko': '열대우림 샐러드',
      'zh': '雨林沙拉',
      'ja': '熱帯雨林のサラダ'
    }, {
      'id': 'BasicUpgradeLvl1',
      'en': 'Basic Upgrade 1',
      'fr': 'Mise à niveau de base 1',
      'es': 'Actualización básica 1',
      'de': 'Basis-Upgrade 1',
      'pl': 'Ulepszenie podstawowe 1',
      'ru': 'Базовое обновление 1',
      'uk': 'Базове оновлення 1',
      'ko': '기본 업그레이드 1',
      'zh': '基础升级1',
      'ja': '基本アップグレード1'
    }, {
      'id': 'BasicUpgradeLvl2',
      'en': 'Basic Upgrade 2',
      'fr': 'Mise à niveau de base 2',
      'es': 'Actualización básica 2',
      'de': 'Basis-Upgrade 2',
      'pl': 'Ulepszenie podstawowe 2',
      'ru': 'Базовое обновление 2',
      'uk': 'Базове оновлення 2',
      'ko': '기본 업그레이드 2',
      'zh': '基本升级 2',
      'ja': '基本アップグレード2'
    }, {
      'id': 'BasicUpgradeLvl3',
      'en': 'Basic Upgrade 3',
      'fr': 'Mise à niveau de base 3',
      'es': 'Actualización básica 3',
      'de': 'Basis-Upgrade 3',
      'pl': 'Ulepszenie podstawowe 3',
      'ru': 'Базовое обновление 3',
      'uk': 'Базове оновлення 3',
      'ko': '기본 업그레이드 3',
      'zh': '基本升级 3',
      'ja': '基本アップグレード3'
    }, {
      'id': 'BasicUpgradeLvl4',
      'en': 'Basic Upgrade 4',
      'fr': 'Mise à niveau de base 4',
      'es': 'Actualización básica 4',
      'de': 'Basis-Upgrade 4',
      'pl': 'Ulepszenie podstawowe 4',
      'ru': 'Базовое обновление 4',
      'uk': 'Базове оновлення 4',
      'ko': '기본 업그레이드 4',
      'zh': '基本升级 4',
      'ja': '基本アップグレード4'
    }, {
      'id': 'Bathtub',
      'en': 'Bathtub',
      'fr': 'Baignoire',
      'es': 'Bañera',
      'de': 'Badewanne',
      'pl': 'Wanna',
      'ru': 'Ванна',
      'uk': 'Ванна',
      'ko': '목욕통',
      'zh': '浴缸',
      'ja': 'バスタブ'
    }, {
      'id': 'BeanPaste',
      'en': 'Bean Paste',
      'fr': 'Pâte de haricots',
      'es': 'Pasta de judías',
      'de': 'Bohnen Paste',
      'pl': 'Pasta z fasoli',
      'ru': 'Бобовая паста',
      'uk': 'Бобова паста',
      'ko': '된장',
      'zh': '豆沙',
      'ja': '味噌'
    }, {
      'id': 'BeanSprout',
      'en': 'Bean Sprout',
      'fr': 'germe de haricot',
      'es': 'Brotes de soja',
      'de': 'Bohnensprosse',
      'pl': 'kiełki fasoli',
      'ru': 'Бобовый росток',
      'uk': 'Квасоля паросток',
      'ko': '콩나물',
      'zh': '豆芽',
      'ja': 'もやし'
    }, {
      'id': 'BearSUPREME',
      'en': 'Bear S U P R E M E',
      'fr': 'Ours S U P R E M E',
      'es': 'Oso SUPREMO',
      'de': 'Bär S U P R E M E',
      'pl': 'Niedźwiedź S U P R E M E',
      'ru': 'Медведь С У П Р Е М Е',
      'uk': 'Ведмідь С У П Р Е М Е',
      'ko': '베어 SU P R E M E',
      'zh': '熊 S U P R E M E',
      'ja': 'ベアSUP R E M E'
    }, {
      'id': 'Bearclaw',
      'en': 'Bearclaw',
      'fr': 'Griffe d\u0027ours',
      'es': 'Garra de oso',
      'de': 'Bärentatze',
      'pl': 'Niedźwiedzi pazur',
      'ru': 'Медвежий коготь',
      'uk': 'Ведмежий кіготь',
      'ko': '곰 발톱',
      'zh': '熊爪',
      'ja': 'ベアクロウ'
    }, {
      'id': 'Bearpack',
      'en': 'Bearpack',
      'fr': 'meute d\u0027ours',
      'es': 'manada de osos',
      'de': 'Bärenpack',
      'pl': 'Bearpack',
      'ru': 'Медвежья стая',
      'uk': 'Ведмежий ранець',
      'ko': '베어팩',
      'zh': '熊包',
      'ja': 'ベアパック'
    }, {
      'id': 'BeetCampfireSalad',
      'en': 'Beet Campfire Salad',
      'fr': 'Salade de feu de camp de betteraves',
      'es': 'Ensalada De Fogata De Remolacha',
      'de': 'Rote-Bete-Lagerfeuersalat',
      'pl': 'Sałatka Ogniskowa z Buraków',
      'ru': 'Салат из свеклы у костра',
      'uk': 'Салат з буряка',
      'ko': '비트 캠프파이어 샐러드',
      'zh': '甜菜篝火沙拉',
      'ja': 'ビートキャンプファイヤーサラダ'
    }, {
      'id': 'BeetSeed',
      'en': 'Beet Seed',
      'fr': 'Graine de betterave',
      'es': 'Semilla de remolacha',
      'de': 'Rübensamen',
      'pl': 'Nasiona buraka',
      'ru': 'Семена свеклы',
      'uk': 'Насіння буряка',
      'ko': '비트 씨',
      'zh': '甜菜种子',
      'ja': 'ビートシード'
    }, {
      'id': 'BerryExtractFertilizer',
      'en': 'Berry Extract Fertilizer',
      'fr': 'Engrais aux extraits de baies',
      'es': 'Fertilizante de extracto de bayas',
      'de': 'Dünger mit Beerenextrakt',
      'pl': 'Nawóz z ekstraktem z jagód',
      'ru': 'Удобрение из экстракта ягод',
      'uk': 'Добриво з екстрактом ягід',
      'ko': '베리 추출물 비료',
      'zh': '浆果提取物肥料',
      'ja': 'ベリーエキス肥料'
    }, {
      'id': 'BigBackpack',
      'en': 'Big Backpack',
      'fr': 'Grand sac à dos',
      'es': 'mochila grande',
      'de': 'Großer Rucksack',
      'pl': 'Duży plecak',
      'ru': 'Большой рюкзак',
      'uk': 'Великий рюкзак',
      'ko': '큰 배낭',
      'zh': '大背包',
      'ja': 'ビッグバックパック'
    }, {
      'id': 'Biodiesel',
      'en': 'Biodiesel',
      'fr': 'Biodiesel',
      'es': 'biodiésel',
      'de': 'Biodiesel',
      'pl': 'Biodiesel',
      'ru': 'Биодизель',
      'uk': 'Біодизель',
      'ko': '바이오디젤',
      'zh': '生物柴油',
      'ja': 'バイオディーゼル'
    }, {
      'id': 'BisonChowFun',
      'en': 'Bison Chow Fun',
      'fr': 'Plaisir de manger du bison',
      'es': 'bisonte chow divertido',
      'de': 'Bison-Chow-Spaß',
      'pl': 'Żubr chow zabawa',
      'ru': 'Развлечение с бизонами',
      'uk': 'Бізон-чау Fun',
      'ko': '들소 차우 재미',
      'zh': '野牛周乐趣',
      'ja': 'バイソンチョウフン'
    }, {
      'id': 'BisonMount',
      'en': 'Bison Mount',
      'fr': 'Mont bison',
      'es': 'Monte bisonte',
      'de': 'Bison-Berg',
      'pl': 'Góra żubra',
      'ru': 'Бизон Маунт',
      'uk': 'Гора бізона',
      'ko': '들소 산',
      'zh': '野牛山',
      'ja': 'バイソンマウント'
    }, {
      'id': 'BlastFurnace',
      'en': 'Blast Furnace',
      'fr': 'Haut fourneau',
      'es': 'Alto horno',
      'de': 'Hochofen',
      'pl': 'Wielki Piec',
      'ru': 'Доменная печь',
      'uk': 'Доменна піч',
      'ko': '고로',
      'zh': '高炉',
      'ja': '溶鉱炉'
    }, {
      'id': 'BloodMealFertilizer',
      'en': 'Blood Meal Fertilizer',
      'fr': 'Engrais de farine de sang',
      'es': 'Fertilizante de harina de sangre',
      'de': 'Blutmehldünger',
      'pl': 'Nawóz do mączki krwi',
      'ru': 'Удобрение для кровяной муки',
      'uk': 'Добриво з кров\u0027яного борошна',
      'ko': '혈식비료',
      'zh': '血粉肥',
      'ja': '血粉肥料'
    }, {
      'id': 'Bloomery',
      'en': 'Bloomery',
      'fr': 'Floraison',
      'es': 'Floración',
      'de': 'Bloomery',
      'pl': 'Bloomery',
      'ru': 'Блумери',
      'uk': 'Блумері',
      'ko': '블루메리',
      'zh': '布卢梅里',
      'ja': '塊鉄炉'
    }, {
      'id': 'Board',
      'en': 'Board',
      'fr': 'Planche',
      'es': 'Junta',
      'de': 'Tafel',
      'pl': 'Tablica',
      'ru': 'Доска',
      'uk': 'дошка',
      'ko': '판자',
      'zh': '木板',
      'ja': 'ボード'
    }, {
      'id': 'SawBoards',
      'en': 'Saw Boards',
      'fr': 'Planches de scie',
      'es': 'tablas de sierra',
      'de': 'Sägebretter',
      'pl': 'Piły Deski',
      'ru': 'Пильные доски',
      'uk': 'Пила дошки',
      'ko': '톱보드',
      'zh': '锯板',
      'ja': 'ボードを見た'
    }, {
      'id': 'BoiledGrains',
      'en': 'Boiled Grains',
      'fr': 'Céréales bouillies',
      'es': 'Granos hervidos',
      'de': 'Gekochte Körner',
      'pl': 'Gotowane Ziarna',
      'ru': 'Вареные зерна',
      'uk': 'Варені зерна',
      'ko': '삶은 곡물',
      'zh': '煮熟的谷物',
      'ja': 'ゆでた穀物'
    }, {
      'id': 'BoiledRice',
      'en': 'Boiled Rice',
      'fr': 'Riz bouilli',
      'es': 'Arroz hervido',
      'de': 'Gekochter Reis',
      'pl': 'Ugotowany ryż',
      'ru': 'Отварной рис',
      'uk': 'Варений рис',
      'ko': '삶은 쌀',
      'zh': '煮好的饭',
      'ja': 'ご飯'
    }, {
      'id': 'BoiledSausage',
      'en': 'Boiled Sausage',
      'fr': 'Saucisse bouillie',
      'es': 'Salchicha Cocida',
      'de': 'Brühwurst',
      'pl': 'Kiełbasa Gotowana',
      'ru': 'Вареная колбаса',
      'uk': 'Варена ковбаса',
      'ko': '삶은 소시지',
      'zh': '煮香肠',
      'ja': 'ゆでソーセージ'
    }, {
      'id': 'Boiler',
      'en': 'Boiler',
      'fr': 'Chaudière',
      'es': 'Caldera',
      'de': 'Kessel',
      'pl': 'Bojler',
      'ru': 'Паровой котел',
      'uk': 'Котел',
      'ko': '보일러',
      'zh': '锅炉',
      'ja': 'ボイラー'
    }, {
      'id': 'BoleteMushroomSpores',
      'en': 'Bolete Mushroom Spores',
      'fr': 'Spores de champignons bolets',
      'es': 'Esporas de hongos bolete',
      'de': 'Bolete-Pilz-Sporen',
      'pl': 'Zarodniki grzybów borowików',
      'ru': 'Споры грибов подберезовика',
      'uk': 'Спори грибів підберезників',
      'ko': '볼레트 버섯 포자',
      'zh': '牛肝菌蘑菇孢子',
      'ja': 'ヤマドリタケの胞子'
    }, {
      'id': 'Bookshelf',
      'en': 'Bookshelf',
      'fr': 'Étagère à livres',
      'es': 'Estante para libros',
      'de': 'Bücherregal',
      'pl': 'Półka na książki',
      'ru': 'Книжная полка',
      'uk': 'Книжкова полиця',
      'ko': '책장',
      'zh': '书架',
      'ja': '本棚'
    }, {
      'id': 'Brazier',
      'en': 'Brazier',
      'fr': 'Brasero',
      'es': 'Brasero',
      'de': 'Kohlebecken',
      'pl': 'Kotlarz',
      'ru': 'Мангал',
      'uk': 'Мангал',
      'ko': '화로',
      'zh': '火盆',
      'ja': '火鉢'
    }, {
      'id': 'Bread',
      'en': 'Bread',
      'fr': 'Pain',
      'es': 'Pan de molde',
      'de': 'Brot',
      'pl': 'Chleb',
      'ru': 'Хлеб',
      'uk': 'Хліб',
      'ko': '빵',
      'zh': '面包',
      'ja': 'パン'
    }, {
      'id': 'BrickFireplace',
      'en': 'Brick Fireplace',
      'fr': 'Cheminée en brique',
      'es': 'Chimenea de ladrillo',
      'de': 'Gemauerter Kamin',
      'pl': 'Kominek ceglany',
      'ru': 'Кирпичный камин',
      'uk': 'Цегляний камін',
      'ko': '벽돌 벽난로',
      'zh': '砖壁炉',
      'ja': 'レンガ造りの暖炉'
    }, {
      'id': 'Brick',
      'en': 'Brick',
      'fr': 'Brique',
      'es': 'Ladrillo',
      'de': 'Backstein',
      'pl': 'Cegła',
      'ru': 'Кирпич',
      'uk': 'Цегла',
      'ko': '벽돌',
      'zh': '砖',
      'ja': 'レンガ'
    }, {
      'id': 'ShaleBrick',
      'en': 'Shale Brick',
      'fr': 'Brique de schiste',
      'es': 'Ladrillo de esquisto',
      'de': 'Schieferziegel',
      'pl': 'Cegła łupkowa',
      'ru': 'Сланцевый кирпич',
      'uk': 'Сланцева цегла',
      'ko': '셰일 벽돌',
      'zh': '页岩砖',
      'ja': 'シェールブリック'
    }, {
      'id': 'BuilderBoots',
      'en': 'Builder Boots',
      'fr': 'Bottes de constructeur',
      'es': 'Botas de constructor',
      'de': 'Builder-Stiefel',
      'pl': 'Buty budowniczego',
      'ru': 'Сапоги строителя',
      'uk': 'Будівельні чоботи',
      'ko': '빌더 부츠',
      'zh': '建设者靴子',
      'ja': 'ビルダーブーツ'
    }, {
      'id': 'BuilderGloves',
      'en': 'Builder Gloves',
      'fr': 'Gants de constructeur',
      'es': 'Guantes de constructor',
      'de': 'Baumeister-Handschuhe',
      'pl': 'Rękawice Budownicze',
      'ru': 'Строительные перчатки',
      'uk': 'Рукавички будівельники',
      'ko': '빌더 장갑',
      'zh': '生成器手套',
      'ja': 'ビルダーグローブ'
    }, {
      'id': 'BuilderHelmet',
      'en': 'Builder Helmet',
      'fr': 'Casque de constructeur',
      'es': 'Casco de constructor',
      'de': 'Baumeister-Helm',
      'pl': 'Hełm budowniczego',
      'ru': 'Строительный шлем',
      'uk': 'Шолом будівельника',
      'ko': '빌더 헬멧',
      'zh': '生成器头盔',
      'ja': 'ビルダーヘルメット'
    }, {
      'id': 'BuilderOveralls',
      'en': 'Builder Overalls',
      'fr': 'Salopette de constructeur',
      'es': 'Overoles de constructor',
      'de': 'Builder-Overalls',
      'pl': 'Kombinezon budowniczego',
      'ru': 'Спецодежда строителя',
      'uk': 'Комбінезон будівельника',
      'ko': '빌더 작업복',
      'zh': '建设者工作服',
      'ja': 'ビルダーオーバーオール'
    }, {
      'id': 'BuilderShirt',
      'en': 'Builder Shirt',
      'fr': 'Chemise de constructeur',
      'es': 'Camisa de constructor',
      'de': 'Erbauer-Shirt',
      'pl': 'Koszula budowniczego',
      'ru': 'Рубашка строителя',
      'uk': 'Сорочка будівельника',
      'ko': '빌더 셔츠',
      'zh': '建设者衬衫',
      'ja': 'ビルダーシャツ'
    }, {
      'id': 'ButcheryTable',
      'en': 'Butchery Table',
      'fr': 'Table de boucherie',
      'es': 'Mesa de Carnicería',
      'de': 'Metzgerei-Tabelle',
      'pl': 'Stół rzeźniczy',
      'ru': 'Мясной стол',
      'uk': 'М\u0027ясний стіл',
      'ko': '도살 테이블',
      'zh': '屠宰台',
      'ja': '肉屋のテーブル'
    }, {
      'id': 'ButcheryUpgrade',
      'en': 'Butchery Upgrade',
      'fr': 'Amélioration de la boucherie',
      'es': 'Actualización de carnicería',
      'de': 'Metzgerei-Upgrade',
      'pl': 'Ulepszenie rzeźni',
      'ru': 'Обновление мясной лавки',
      'uk': 'Оновлення м\u0027ясних заводів',
      'ko': '도살 업그레이드',
      'zh': '屠宰场升级',
      'ja': '肉屋のアップグレード'
    }, {
      'id': 'CO2Canister',
      'en': 'CO2 Canister',
      'fr': 'Cartouche de CO2',
      'es': 'Bote de CO2',
      'de': 'CO2-Kanister',
      'pl': 'Kanister CO2',
      'ru': 'Канистра CO2',
      'uk': 'Каністра CO2',
      'ko': 'CO2 캐니스터',
      'zh': '二氧化碳罐',
      'ja': 'CO2キャニスター'
    }, {
      'id': 'CamasAshFertilizer',
      'en': 'Camas Ash Fertilizer',
      'fr': 'Engrais de cendres Camas',
      'es': 'Fertilizante Ceniza Camas',
      'de': 'Camas-Aschendünger',
      'pl': 'Nawóz Camas Ash',
      'ru': 'Камас Зола Удобрение',
      'uk': 'Добриво з попелу Камас',
      'ko': '카마스 재 비료',
      'zh': '卡马斯灰肥',
      'ja': 'カマス灰肥料'
    }, {
      'id': 'CamasBread',
      'en': 'Camas Bread',
      'fr': 'Pain Camas',
      'es': 'Pan Camas',
      'de': 'Camas-Brot',
      'pl': 'Chleb',
      'ru': 'Камас Хлеб',
      'uk': 'Камас Хліб',
      'ko': '카마스 빵',
      'zh': '卡马斯面包',
      'ja': 'キャマスパン'
    }, {
      'id': 'CamasBulbBake',
      'en': 'Camas Bulb Bake',
      'fr': 'Cuisson au bulbe de Camas',
      'es': 'Camas Bulbo Horneado',
      'de': 'Camas Bulb Bake',
      'pl': 'Camas Piec Żarówki',
      'ru': 'Выпечка из луковицы Камас',
      'uk': 'Випічка з цибулиною Camas',
      'ko': '카마스 전구 굽기',
      'zh': '卡马斯灯泡烘烤',
      'ja': 'カマス球根焼き'
    }, {
      'id': 'CamasPaste',
      'en': 'Camas Paste',
      'fr': 'Camas Pâte',
      'es': 'Pasta Camas',
      'de': 'Camas-Paste',
      'pl': 'Pasta Cama',
      'ru': 'Камас Паста',
      'uk': 'Камас паста',
      'ko': '카마스 페이스트',
      'zh': '卡马斯糊',
      'ja': 'カマスペースト'
    }, {
      'id': 'CamoPants',
      'en': 'Camo Pants',
      'fr': 'Pantalon camouflage',
      'es': 'Pantalones de camuflaje',
      'de': 'Camo-Hose',
      'pl': 'Spodnie moro',
      'ru': 'Камуфляжные штаны',
      'uk': 'Камуфляжні штани',
      'ko': '카모 팬츠',
      'zh': '迷彩裤',
      'ja': 'カモパンツ'
    }, {
      'id': 'CamoShirt',
      'en': 'Camo Shirt',
      'fr': 'Chemise camouflage',
      'es': 'Camisa de camuflaje',
      'de': 'Camo-Shirt',
      'pl': 'Koszula moro',
      'ru': 'Камуфляжная рубашка',
      'uk': 'камуфляжна сорочка',
      'ko': '카모 셔츠',
      'zh': '迷彩衬衫',
      'ja': 'カモシャツ'
    }, {
      'id': 'CampfireCookingUpgrade',
      'en': 'Campfire Cooking Upgrade',
      'fr': 'Amélioration de la cuisson au feu de camp',
      'es': 'Actualización de cocina de fogata',
      'de': 'Lagerfeuerkoch-Upgrade',
      'pl': 'Ulepszenie gotowania przy ognisku',
      'ru': 'Улучшение кулинарии у костра',
      'uk': 'Оновлення для приготування їжі на вогні',
      'ko': '캠프파이어 요리 업그레이드',
      'zh': '营火烹饪升级',
      'ja': 'キャンプファイヤークッキングのアップグレード'
    }, {
      'id': 'CampfireRoast',
      'en': 'Campfire Roast',
      'fr': 'Rôti de feu de camp',
      'es': 'asado de fogata',
      'de': 'Lagerfeuerbraten',
      'pl': 'Pieczeń przy ognisku',
      'ru': 'Жаркое у костра',
      'uk': 'Смаження на вогні',
      'ko': '캠프파이어 로스트',
      'zh': '营火烤',
      'ja': 'キャンプファイヤーロースト'
    }, {
      'id': 'Campsite',
      'en': 'Campsite',
      'fr': 'Site de camp',
      'es': 'Cámping',
      'de': 'Campingplatz',
      'pl': 'Obozowisko',
      'ru': 'Кемпинг',
      'uk': 'Кемпінг',
      'ko': '캠프장',
      'zh': '营地',
      'ja': 'キャンプ場'
    }, {
      'id': 'CandleStand',
      'en': 'Candle Stand',
      'fr': 'Chandelier',
      'es': 'Candelabro',
      'de': 'Kerzenständer',
      'pl': 'Świecznik',
      'ru': 'Подсвечник',
      'uk': 'Підсвічник',
      'ko': '캔들 스탠드',
      'zh': '烛台',
      'ja': 'ろうそく立て'
    }, {
      'id': 'Capris',
      'en': 'Capris',
      'fr': 'Capri',
      'es': 'Capris',
      'de': 'Caprihosen',
      'pl': 'Capris',
      'ru': 'Капри',
      'uk': 'Капрі',
      'ko': '카프리스',
      'zh': '七分裤',
      'ja': 'カプリパンツ'
    }, {
      'id': 'CarpentryAdvancedUpgrade',
      'en': 'Carpentry Advanced Upgrade',
      'fr': 'Mise à niveau avancée de la menuiserie',
      'es': 'Actualización avanzada de carpintería',
      'de': 'Zimmerei-Upgrade für Fortgeschrittene',
      'pl': 'Zaawansowana modernizacja stolarki',
      'ru': 'Столярное дело Продвинутое обновление',
      'uk': 'Розширене оновлення столярних виробів',
      'ko': '목공 고급 업그레이드',
      'zh': '木工高级升级',
      'ja': 'カーペントリーアドバンストアップグレード'
    }, {
      'id': 'CarpentryBasicUpgrade',
      'en': 'Carpentry Basic Upgrade',
      'fr': 'Mise à niveau de base de la menuiserie',
      'es': 'Actualización básica de carpintería',
      'de': 'Zimmerei-Basis-Upgrade',
      'pl': 'Podstawowe ulepszenie stolarki',
      'ru': 'Плотницкое базовое обновление',
      'uk': 'Базове оновлення столярних виробів',
      'ko': '목공 기본 업그레이드',
      'zh': '木工基础升级',
      'ja': '大工の基本的なアップグレード'
    }, {
      'id': 'CarvedPumpkin',
      'en': 'Carved Pumpkin',
      'fr': 'Citrouille sculptée',
      'es': 'Calabaza Tallada',
      'de': 'Geschnitzter Kürbis',
      'pl': 'Rzeźbiona Dynia',
      'ru': 'Резная тыква',
      'uk': 'Різьблений гарбуз',
      'ko': '새겨진 호박',
      'zh': '雕刻南瓜',
      'ja': '刻まれたカボチャ'
    }, {
      'id': 'CastIronBed',
      'en': 'Cast Iron Bed',
      'fr': 'Lit en fonte',
      'es': 'Cama de hierro fundido',
      'de': 'Bett aus Gusseisen',
      'pl': 'Żeliwne łóżko',
      'ru': 'Чугунная кровать',
      'uk': 'Чавунне ліжко',
      'ko': '무쇠 침대',
      'zh': '铸铁床',
      'ja': '鋳鉄製ベッド'
    }, {
      'id': 'CastIronRoyalBed',
      'en': 'Cast Iron Royal Bed',
      'fr': 'Lit royal en fonte',
      'es': 'Cama real de hierro fundido',
      'de': 'Königliches Bett aus Gusseisen',
      'pl': 'Żeliwne łóżko królewskie',
      'ru': 'Чугунная королевская кровать',
      'uk': 'Чавунне королівське ліжко',
      'ko': '무쇠 로얄 침대',
      'zh': '铸铁皇家床',
      'ja': '鋳鉄製ロイヤルベッド'
    }, {
      'id': 'CastIronStove',
      'en': 'Cast Iron Stove',
      'fr': 'Poêle en fonte',
      'es': 'Estufa de hierro fundido',
      'de': 'Ofen aus Gusseisen',
      'pl': 'Piec żeliwny',
      'ru': 'Чугунная печь',
      'uk': 'Чавунна піч',
      'ko': '무쇠 스토브',
      'zh': '铸铁炉',
      'ja': '鋳鉄ストーブ'
    }, {
      'id': 'CeilingCandle',
      'en': 'Ceiling Candle',
      'fr': 'Bougie de plafond',
      'es': 'Vela de techo',
      'de': 'Deckenkerze',
      'pl': 'Świeca sufitowa',
      'ru': 'Потолочная свеча',
      'uk': 'Стельова свічка',
      'ko': '천장 양초',
      'zh': '天花板蜡烛',
      'ja': 'シーリングキャンドル'
    }, {
      'id': 'CelluloseFiber',
      'en': 'Cellulose Fiber',
      'fr': 'Fibre cellulosique',
      'es': 'Fibra de celulosa',
      'de': 'Zellulosefaser',
      'pl': 'Włókno celulozowe',
      'ru': 'Целлюлозное волокно',
      'uk': 'Целюлозна клітковина',
      'ko': '셀룰로오스 섬유',
      'zh': '纤维素纤维',
      'ja': 'セルロース繊維'
    }, {
      'id': 'Cement',
      'en': 'Cement',
      'fr': 'Ciment',
      'es': 'Cemento',
      'de': 'Zement',
      'pl': 'Cement',
      'ru': 'Цемент',
      'uk': 'Цемент',
      'ko': '시멘트',
      'zh': '水泥',
      'ja': 'セメント'
    }, {
      'id': 'CementKiln',
      'en': 'Cement Kiln',
      'fr': 'Four à ciment',
      'es': 'horno de cemento',
      'de': 'Zementofen',
      'pl': 'Cementownia',
      'ru': 'Цементная печь',
      'uk': 'Цементна піч',
      'ko': '시멘트 가마',
      'zh': '水泥窑',
      'ja': 'セメントキルン'
    }, {
      'id': 'Chainsaw',
      'en': 'Chainsaw',
      'fr': 'Tronçonneuse',
      'es': 'motosierra',
      'de': 'Kettensäge',
      'pl': 'Piła łańcuchowa',
      'ru': 'Бензопила',
      'uk': 'Бензопила',
      'ko': '전기톱',
      'zh': '电锯',
      'ja': 'チェーンソー'
    }, {
      'id': 'Charcoal',
      'en': 'Charcoal',
      'fr': 'charbon',
      'es': 'Carbón',
      'de': 'Holzkohle',
      'pl': 'Węgiel drzewny',
      'ru': 'Древесный уголь',
      'uk': 'Деревне вугілля',
      'ko': '숯',
      'zh': '木炭',
      'ja': '木炭'
    }, {
      'id': 'CharredAgave',
      'en': 'Charred Agave',
      'fr': 'Agave carbonisé',
      'es': 'Agave carbonizado',
      'de': 'Verkohlte Agave',
      'pl': 'Zwęglona agawa',
      'ru': 'Обугленная агава',
      'uk': 'Обвуглена агава',
      'ko': '그을린 용설란',
      'zh': '烧焦的龙舌兰',
      'ja': '焦げたリュウゼツラン'
    }, {
      'id': 'CharredBeans',
      'en': 'Charred Beans',
      'fr': 'Haricots carbonisés',
      'es': 'Frijoles Carbonizados',
      'de': 'Verkohlte Bohnen',
      'pl': 'Zwęglona Fasola',
      'ru': 'Обугленные бобы',
      'uk': 'Обвуглені боби',
      'ko': '그을린 콩',
      'zh': '烧焦的豆子',
      'ja': '焦げた豆'
    }, {
      'id': 'CharredBeet',
      'en': 'Charred Beet',
      'fr': 'Betterave carbonisée',
      'es': 'Remolacha carbonizada',
      'de': 'Verkohlte Rüben',
      'pl': 'Zwęglony Burak',
      'ru': 'Обугленная свекла',
      'uk': 'Обвуглений буряк',
      'ko': '그을린 비트',
      'zh': '烧焦的甜菜',
      'ja': '焦げたビート'
    }, {
      'id': 'CharredCactusFruit',
      'en': 'Charred Cactus Fruit',
      'fr': 'Fruit de cactus carbonisé',
      'es': 'Fruta de cactus carbonizada',
      'de': 'Verkohlte Kaktusfrucht',
      'pl': 'Zwęglony owoc kaktusa',
      'ru': 'Обугленный плод кактуса',
      'uk': 'Плоди обвугленого кактуса',
      'ko': '그을린 선인장 열매',
      'zh': '烧焦的仙人掌果实',
      'ja': '焦げたサボテンの果実'
    }, {
      'id': 'CharredCamasBulb',
      'en': 'Charred Camas Bulb',
      'fr': 'Ampoule Camas carbonisée',
      'es': 'Bulbo de Camas carbonizado',
      'de': 'Verkohlte Camas-Birne',
      'pl': 'Zwęglona żarówka Cama',
      'ru': 'Обугленная лампочка Камас',
      'uk': 'Обвуглена лампа Камас',
      'ko': '그을린 카마스 전구',
      'zh': '烧焦的卡马斯灯泡',
      'ja': '焦げたカマッシア球根'
    }, {
      'id': 'CharredCorn',
      'en': 'Charred Corn',
      'fr': 'Maïs carbonisé',
      'es': 'Maíz carbonizado',
      'de': 'Verkohlter Mais',
      'pl': 'Zwęglona Kukurydza',
      'ru': 'Обугленная кукуруза',
      'uk': 'Обвуглена кукурудза',
      'ko': '그을린 옥수수',
      'zh': '烧焦的玉米',
      'ja': '焦げたトウモロコシ'
    }, {
      'id': 'CharredFireweedShoots',
      'en': 'Charred Fireweed Shoots',
      'fr': 'Pousses d\u0027épilobe carbonisées',
      'es': 'Brotes carbonizados de hierba de fuego',
      'de': 'Verkohlte Fireweed-Triebe',
      'pl': 'Zwęglone pędy Fireweed',
      'ru': 'Обугленные побеги кипрея',
      'uk': 'Пагони обвугленого вогнища',
      'ko': '그을린 Fireweed 싹',
      'zh': '烧焦的杂草芽',
      'ja': '焦げたヤナギランのシュート'
    }, {
      'id': 'CampfireFishLarge',
      'en': 'Campfire Fish Large',
      'fr': 'Grand poisson de feu de camp',
      'es': 'Pez Fogata Grande',
      'de': 'Lagerfeuerfisch groß',
      'pl': 'Duża ryba przy ognisku',
      'ru': 'Рыба у костра большая',
      'uk': 'Риба багаття Велика',
      'ko': '캠프파이어 피쉬 라지',
      'zh': '营火鱼大',
      'ja': 'キャンプファイヤーフィッシュラージ'
    }, {
      'id': 'CampfireFishMedium',
      'en': 'Campfire Fish Medium',
      'fr': 'Poisson de feu de camp moyen',
      'es': 'Pez Fogata Mediano',
      'de': 'Lagerfeuerfisch Medium',
      'pl': 'Ognisko Ryba Średnia',
      'ru': 'Рыба у костра средняя',
      'uk': 'Вогняна риба середня',
      'ko': '캠프파이어 피쉬 미디엄',
      'zh': '营火鱼中号',
      'ja': 'キャンプファイヤーフィッシュミディアム'
    }, {
      'id': 'CampfireFishSmall',
      'en': 'Campfire Fish Small',
      'fr': 'Petit poisson de feu de camp',
      'es': 'Pez Fogata Pequeño',
      'de': 'Lagerfeuerfisch klein',
      'pl': 'Ryba przy ognisku Mała',
      'ru': 'Рыба у костра маленькая',
      'uk': 'Риба вогнища маленька',
      'ko': '캠프파이어 피쉬 스몰',
      'zh': '营火鱼小',
      'ja': 'キャンプファイヤーフィッシュスモール'
    }, {
      'id': 'CampfirePacificSardine',
      'en': 'Campfire Pacific Sardine',
      'fr': 'Feu de camp Pacific Sardine',
      'es': 'Sardina del Pacífico Fogata',
      'de': 'Lagerfeuer Pazifische Sardine',
      'pl': 'Ognisko Sardynka Pacyficzna',
      'ru': 'У костра тихоокеанская сардина',
      'uk': 'Тихоокеанська сардина для багаття',
      'ko': '캠프파이어 태평양 정어리',
      'zh': '营火太平洋沙丁鱼',
      'ja': 'キャンプファイヤーパシフィックイワシ'
    }, {
      'id': 'CharredFish',
      'en': 'Charred Fish',
      'fr': 'Poisson carbonisé',
      'es': 'pescado carbonizado',
      'de': 'Verkohlter Fisch',
      'pl': 'Zwęglona Ryba',
      'ru': 'Обугленная рыба',
      'uk': 'Обвуглена риба',
      'ko': '그을린 생선',
      'zh': '烧焦的鱼',
      'ja': '焦げた魚'
    }, {
      'id': 'CharredHeartOfPalm',
      'en': 'Charred Heart Of Palm',
      'fr': 'Coeur de palmier carbonisé',
      'es': 'Corazón de palmito carbonizado',
      'de': 'Verkohltes Herz der Palme',
      'pl': 'Zwęglone Serce Palmy',
      'ru': 'Обугленное сердце пальмы',
      'uk': 'Обвуглене серце пальми',
      'ko': '손바닥의 그을린 심장',
      'zh': '烧焦的棕榈心',
      'ja': '焦げたハートオブパーム'
    }, {
      'id': 'CampfireAnimalMedium',
      'en': 'Campfire Animal Medium',
      'fr': 'Feu de camp animal moyen',
      'es': 'Fogata Animal Medio',
      'de': 'Lagerfeuertier Medium',
      'pl': 'Ognisko Zwierzę Średnie',
      'ru': 'У костра Животное Среднее',
      'uk': 'Тварина для вогнища',
      'ko': '모닥불 동물 매체',
      'zh': '营火动物培养基',
      'ja': 'キャンプファイヤーアニマルミディアム'
    }, {
      'id': 'CampfireAnimalSmall',
      'en': 'Campfire Animal Small',
      'fr': 'Petit animal de feu de camp',
      'es': 'Fogata Animal Pequeño',
      'de': 'Lagerfeuertier klein',
      'pl': 'Małe zwierzątko przy ognisku',
      'ru': 'У костра Животное Маленькое',
      'uk': 'Тварина вогнища маленька',
      'ko': '캠프파이어 애니멀 스몰',
      'zh': '营火动物小',
      'ja': 'キャンプファイヤーアニマルスモール'
    }, {
      'id': 'CampfireAnimalTiny',
      'en': 'Campfire Animal Tiny',
      'fr': 'Petit animal de feu de camp',
      'es': 'Fogata Animal Minúsculo',
      'de': 'Lagerfeuertier Winzig',
      'pl': 'Małe zwierzątko przy ognisku',
      'ru': 'У костра Животное Маленькое',
      'uk': 'Тварина для вогнища',
      'ko': '캠프파이어 애니멀 타이니',
      'zh': '篝火小动物',
      'ja': 'キャンプファイヤーアニマルタイニー'
    }, {
      'id': 'CampfireBison',
      'en': 'Campfire Bison',
      'fr': 'Bison de feu de camp',
      'es': 'Bisonte de fogata',
      'de': 'Lagerfeuer-Bison',
      'pl': 'Ognisko Żubr',
      'ru': 'Бизон у костра',
      'uk': 'Вогняний бізон',
      'ko': '캠프파이어 들소',
      'zh': '营火野牛',
      'ja': 'キャンプファイヤーバイソン'
    }, {
      'id': 'CharredMeat',
      'en': 'Charred Meat',
      'fr': 'Viande carbonisée',
      'es': 'Carne Carbonizada',
      'de': 'Verkohltes Fleisch',
      'pl': 'Zwęglone Mięso',
      'ru': 'Обугленное мясо',
      'uk': 'Обвуглене м\u0027ясо',
      'ko': '그을린 고기',
      'zh': '烧焦的肉',
      'ja': '焦げた肉'
    }, {
      'id': 'CharredMushrooms',
      'en': 'Charred Mushrooms',
      'fr': 'Champignons carbonisés',
      'es': 'Champiñones carbonizados',
      'de': 'Verkohlte Pilze',
      'pl': 'Zwęglone Grzyby',
      'ru': 'Обугленные грибы',
      'uk': 'Обвуглені гриби',
      'ko': '그을린 버섯',
      'zh': '烧焦的蘑菇',
      'ja': '焦げたきのこ'
    }, {
      'id': 'CharredPapaya',
      'en': 'Charred Papaya',
      'fr': 'Papaye carbonisée',
      'es': 'Papaya carbonizada',
      'de': 'Verkohlte Papaya',
      'pl': 'Zwęglona Papaja',
      'ru': 'Обугленная папайя',
      'uk': 'Обвуглена папайя',
      'ko': '그을린 파파야',
      'zh': '烧焦的木瓜',
      'ja': '焦げたパパイヤ'
    }, {
      'id': 'CharredPineapple',
      'en': 'Charred Pineapple',
      'fr': 'Ananas carbonisé',
      'es': 'Piña carbonizada',
      'de': 'Verkohlte Ananas',
      'pl': 'Zwęglony Ananas',
      'ru': 'Обугленный ананас',
      'uk': 'Обвуглений ананас',
      'ko': '그을린 파인애플',
      'zh': '烧焦的菠萝',
      'ja': '焦げたパイナップル'
    }, {
      'id': 'CharredSausage',
      'en': 'Charred Sausage',
      'fr': 'Saucisse carbonisée',
      'es': 'salchicha carbonizada',
      'de': 'Verkohlte Wurst',
      'pl': 'Pieczona Kiełbasa',
      'ru': 'Обугленная колбаса',
      'uk': 'Обвуглена ковбаса',
      'ko': '그을린 소시지',
      'zh': '烧焦的香肠',
      'ja': '焦げたソーセージ'
    }, {
      'id': 'CharredTaro',
      'en': 'Charred Taro',
      'fr': 'Taro carbonisé',
      'es': 'Taro carbonizado',
      'de': 'Verkohlter Taro',
      'pl': 'Zwęglony Taro',
      'ru': 'Обугленное Таро',
      'uk': 'Обвуглене Таро',
      'ko': '그을린 타로',
      'zh': '烧焦芋头',
      'ja': '焦げた太郎'
    }, {
      'id': 'CharredTomato',
      'en': 'Charred Tomato',
      'fr': 'Tomate carbonisée',
      'es': 'tomate asado',
      'de': 'Verkohlte Tomate',
      'pl': 'Zwęglony Pomidor',
      'ru': 'Обугленный помидор',
      'uk': 'Обвуглений помідор',
      'ko': '그을린 토마토',
      'zh': '烧焦的番茄',
      'ja': '焦げたトマト'
    }, {
      'id': 'ChefHat',
      'en': 'Chef Hat',
      'fr': 'Toque',
      'es': 'Sombrero de cocinero',
      'de': 'Kochmütze',
      'pl': 'Kapelusz szefa kuchni',
      'ru': 'Шляпа шеф-повара',
      'uk': 'Капелюх шеф-кухаря',
      'ko': '요리사 모자',
      'zh': '厨师帽',
      'ja': 'シェフハット'
    }, {
      'id': 'ChefPants',
      'en': 'Chef Pants',
      'fr': 'Pantalon de cuisine',
      'es': 'Pantalones de cocinero',
      'de': 'Kochhose',
      'pl': 'Spodnie szefa kuchni',
      'ru': 'Брюки шеф-повара',
      'uk': 'Штани шеф-кухаря',
      'ko': '요리사 바지',
      'zh': '厨师裤',
      'ja': 'シェフパンツ'
    }, {
      'id': 'ChefShirt',
      'en': 'Chef Shirt',
      'fr': 'Chemise de chef',
      'es': 'Camisa de cocinero',
      'de': 'Koch-Shirt',
      'pl': 'Koszula szefa kuchni',
      'ru': 'Рубашка шеф-повара',
      'uk': 'Сорочка шеф-кухаря',
      'ko': '요리사 셔츠',
      'zh': '厨师衬衫',
      'ja': 'シェフシャツ'
    }, {
      'id': 'ChefShoes',
      'en': 'Chef Shoes',
      'fr': 'Chaussures de cuisine',
      'es': 'Zapatos de cocinero',
      'de': 'Kochschuhe',
      'pl': 'Buty szefa kuchni',
      'ru': 'Обувь для поваров',
      'uk': 'Взуття шеф-кухаря',
      'ko': '요리사 신발',
      'zh': '厨师鞋',
      'ja': 'シェフの靴'
    }, {
      'id': 'ClamChowder',
      'en': 'Clam Chowder',
      'fr': 'Chaudrée de palourdes',
      'es': 'Sopa de almejas',
      'de': 'Muschelsuppe',
      'pl': 'Chowder z mięczaków',
      'ru': 'Похлебка из моллюсков',
      'uk': 'Юшка з молюсків',
      'ko': '옥수수 잡탕',
      'zh': '蛤蜊杂烩',
      'ja': 'クラムチャウダー'
    }, {
      'id': 'ClothBelt',
      'en': 'Cloth Belt',
      'fr': 'Ceinture en tissu',
      'es': 'Cinturón de tela',
      'de': 'Stoffgürtel',
      'pl': 'Płócienny pasek',
      'ru': 'Тканевый пояс',
      'uk': 'Пояс із тканини',
      'ko': '천 벨트',
      'zh': '布腰带',
      'ja': '布ベルト'
    }, {
      'id': 'ClothCape',
      'en': 'Cloth Cape',
      'fr': 'Cape en tissu',
      'es': 'capa de tela',
      'de': 'Stoffumhang',
      'pl': 'Peleryna z materiału',
      'ru': 'Тканевая накидка',
      'uk': 'Накидка з тканини',
      'ko': '천망토',
      'zh': '布斗篷',
      'ja': '布ケープ'
    }, {
      'id': 'Cloth',
      'en': 'Cloth',
      'fr': 'Chiffon',
      'es': 'Tela',
      'de': 'Tuch',
      'pl': 'Płótno',
      'ru': 'Ткань',
      'uk': 'Тканина',
      'ko': '천',
      'zh': '布',
      'ja': '布'
    }, {
      'id': 'CombustionEngine',
      'en': 'Combustion Engine',
      'fr': 'Moteur à combustion',
      'es': 'Motor de combustión',
      'de': 'Verbrennungsmotor',
      'pl': 'Silnik spalinowy',
      'ru': 'Двигатель внутреннего сгорания',
      'uk': 'Двигун внутрішнього згоряння',
      'ko': '연소 엔진',
      'zh': '内燃机',
      'ja': '燃焼エンジン'
    }, {
      'id': 'CombustionGenerator',
      'en': 'Combustion Generator',
      'fr': 'Générateur de combustion',
      'es': 'Generador de combustión',
      'de': 'Verbrennungsgenerator',
      'pl': 'Generator spalania',
      'ru': 'Генератор внутреннего сгорания',
      'uk': 'Генератор горіння',
      'ko': '연소 발생기',
      'zh': '燃烧发生器',
      'ja': '燃焼発生器'
    }, {
      'id': 'CompositeBow',
      'en': 'Composite Bow',
      'fr': 'Arc composite',
      'es': 'Arco compuesto',
      'de': 'Zusammengesetzter Bogen',
      'pl': 'Kompozytowy łuk',
      'ru': 'Композитный лук',
      'uk': 'Композитний лук',
      'ko': '합성 활',
      'zh': '复合弓',
      'ja': '複合弓'
    }, {
      'id': 'CompositeFiller',
      'en': 'Composite Filler',
      'fr': 'Charge composite',
      'es': 'Relleno compuesto',
      'de': 'Komposit-Füller',
      'pl': 'Wypełniacz kompozytowy',
      'ru': 'Композитный наполнитель',
      'uk': 'Композитний наповнювач',
      'ko': '복합 필러',
      'zh': '复合填料',
      'ja': '複合フィラー'
    }, {
      'id': 'CompositeLumberBench',
      'en': 'Composite Lumber Bench',
      'fr': 'Banc en bois composite',
      'es': 'Banco de madera compuesta',
      'de': 'Verbundholzbank',
      'pl': 'Kompozytowa ławka do drewna',
      'ru': 'Композитная скамейка из пиломатериалов',
      'uk': 'Композитний пиломатеріал',
      'ko': '합성목재 벤치',
      'zh': '复合木材工作台',
      'ja': '複合材木ベンチ'
    }, {
      'id': 'CompositeLumberChair',
      'en': 'Composite Lumber Chair',
      'fr': 'Chaise en bois composite',
      'es': 'Silla de madera compuesta',
      'de': 'Stuhl aus zusammengesetztem Bauholz',
      'pl': 'Krzesło z drewna kompozytowego',
      'ru': 'Композитный деревянный стул',
      'uk': 'Крісло з композитного пиломатеріалу',
      'ko': '합성목재 의자',
      'zh': '复合木椅',
      'ja': '複合材木椅子'
    }, {
      'id': 'CompositeLumberDoor',
      'en': 'Composite Lumber Door',
      'fr': 'Porte en bois composite',
      'es': 'Puerta de madera compuesta',
      'de': 'Verbundholztür',
      'pl': 'Drzwi z kompozytu drewna',
      'ru': 'Композитная деревянная дверь',
      'uk': 'Композитні двері з деревини',
      'ko': '합성목재 문',
      'zh': '复合木门',
      'ja': '複合材木ドア'
    }, {
      'id': 'CompositeLumber',
      'en': 'Composite Lumber',
      'fr': 'Bois composite',
      'es': 'madera compuesta',
      'de': 'Verbundholz',
      'pl': 'Tarcica kompozytowa',
      'ru': 'Композитный пиломатериал',
      'uk': 'Композитні пиломатеріали',
      'ko': '합성목재',
      'zh': '复合木材',
      'ja': '複合材'
    }, {
      'id': 'CompositeLumberTable',
      'en': 'Composite Lumber Table',
      'fr': 'Table de bois composite',
      'es': 'Mesa de madera compuesta',
      'de': 'Tisch aus Verbundholz',
      'pl': 'Kompozytowy stół do tarcicy',
      'ru': 'Композитный стол из пиломатериалов',
      'uk': 'Композитний пиломатеріал',
      'ko': '합성목재 테이블',
      'zh': '复合木材表',
      'ja': '複合材木テーブル'
    }, {
      'id': 'CompositesUpgrade',
      'en': 'Composites Upgrade',
      'fr': 'Mise à niveau des composites',
      'es': 'Actualización de compuestos',
      'de': 'Composites-Upgrade',
      'pl': 'Uaktualnienie kompozytów',
      'ru': 'Обновление композитов',
      'uk': 'Оновлення композитів',
      'ko': '합성물 업그레이드',
      'zh': '复合材料升级',
      'ja': 'コンポジットのアップグレード'
    }, {
      'id': 'CompostFertilizer',
      'en': 'Compost Fertilizer',
      'fr': 'Engrais composté',
      'es': 'Fertilizante de compost',
      'de': 'Kompostdünger',
      'pl': 'Nawóz kompostowy',
      'ru': 'Компостное удобрение',
      'uk': 'Компостне добриво',
      'ko': '퇴비 비료',
      'zh': '堆肥',
      'ja': '堆肥肥料'
    }, {
      'id': 'ComputerLab',
      'en': 'Computer Lab',
      'fr': 'Salle informatique',
      'es': 'Laboratorio de computación',
      'de': 'Computerlabor',
      'pl': 'Laboratorium komputerowe',
      'ru': 'Компьютерная лаборатория',
      'uk': 'Комп\u0027ютерна лабораторія',
      'ko': '컴퓨터 실',
      'zh': '计算机实验室',
      'ja': 'コンピューター室'
    }, {
      'id': 'CookeinaMushroomSpores',
      'en': 'Cookeina Mushroom Spores',
      'fr': 'Spores de champignons Cookeina',
      'es': 'Esporas de hongos Cookeina',
      'de': 'Cookeina Pilzsporen',
      'pl': 'Zarodniki grzybów Cookeina',
      'ru': 'Споры грибов кукеины',
      'uk': 'Спори грибів Cookeina',
      'ko': '쿠케이나 버섯 포자',
      'zh': 'Cookeina蘑菇孢子',
      'ja': 'クッケイナきのこ胞子'
    }, {
      'id': 'CookingUpgrade',
      'en': 'Cooking Upgrade',
      'fr': 'Amélioration de la cuisine',
      'es': 'Mejora de cocina',
      'de': 'Koch-Upgrade',
      'pl': 'Ulepszenie gotowania',
      'ru': 'Кулинарное обновление',
      'uk': 'Оновлення приготування їжі',
      'ko': '요리 업그레이드',
      'zh': '烹饪升级',
      'ja': '料理のアップグレード'
    }, {
      'id': 'CopperBar',
      'en': 'Copper Bar',
      'fr': 'Barre de cuivre',
      'es': 'Barra de cobre',
      'de': 'Kupfer Barren',
      'pl': 'Miedziana sztabka',
      'ru': 'Медный слиток',
      'uk': 'Мідний злиток',
      'ko': '구리 바',
      'zh': '铜条',
      'ja': '銅棒'
    }, {
      'id': 'SmeltCopper',
      'en': 'Smelt Copper',
      'fr': 'Faire fondre le cuivre',
      'es': 'Cobre fundido',
      'de': 'Kupfer schmelzen',
      'pl': 'Wytop miedzi',
      'ru': 'Плавить медь',
      'uk': 'Виплавка міді',
      'ko': '제련 구리',
      'zh': '冶炼铜',
      'ja': '製錬銅'
    }, {
      'id': 'ConcentrateCopperLv2',
      'en': 'Concentrate Copper Lv2',
      'fr': 'Cuivre concentré Lv2',
      'es': 'Cobre Concentrado Lv2',
      'de': 'Kupferkonzentrat Lv2',
      'pl': 'Koncentrat Miedź Lv2',
      'ru': 'Концентрат меди Lv2',
      'uk': 'Мідний концентрат Lv2',
      'ko': '농축 구리 Lv2',
      'zh': '精铜 Lv2',
      'ja': '銅Lv2を濃縮する'
    }, {
      'id': 'CopperConcentrate',
      'en': 'Copper Concentrate',
      'fr': 'Concentré de cuivre',
      'es': 'Concentrado de cobre',
      'de': 'Kupferkonzentrat',
      'pl': 'Koncentrat miedzi',
      'ru': 'Медный концентрат',
      'uk': 'Мідний концентрат',
      'ko': '구리 정광',
      'zh': '铜精矿',
      'ja': '銅精鉱'
    }, {
      'id': 'CopperPipe',
      'en': 'Copper Pipe',
      'fr': 'Tuyau de cuivre',
      'es': 'Tubo de cobre',
      'de': 'Kupferrohr',
      'pl': 'Miedziana rura',
      'ru': 'Медная труба',
      'uk': 'Мідна труба',
      'ko': '구리 파이프',
      'zh': '铜管',
      'ja': '銅管'
    }, {
      'id': 'CopperWiring',
      'en': 'Copper Wiring',
      'fr': 'Câblage en cuivre',
      'es': 'Cableado de cobre',
      'de': 'Kupferverdrahtung',
      'pl': 'Okablowanie miedziane',
      'ru': 'Медная проводка',
      'uk': 'Мідна проводка',
      'ko': '구리 배선',
      'zh': '铜线',
      'ja': '銅配線'
    }, {
      'id': 'CornFritters',
      'en': 'Corn Fritters',
      'fr': 'Beignets de maïs',
      'es': 'Frituras de maíz',
      'de': 'Mais-Krapfen',
      'pl': 'Placki Kukurydziane',
      'ru': 'Кукурузные оладьи',
      'uk': 'Кукурудзяні оладки',
      'ko': '옥수수 튀김',
      'zh': '玉米油条',
      'ja': 'コーンフリッター'
    }, {
      'id': 'CornSeed',
      'en': 'Corn Seed',
      'fr': 'Graine de maïs',
      'es': 'Semilla de maiz',
      'de': 'Maissamen',
      'pl': 'Nasiona kukurydzy',
      'ru': 'Семена кукурузы',
      'uk': 'Насіння кукурудзи',
      'ko': '옥수수 씨',
      'zh': '玉米种子',
      'ja': 'とうもろこしの種'
    }, {
      'id': 'CornStarch',
      'en': 'Corn Starch',
      'fr': 'Fécule de maïs',
      'es': 'Maicena',
      'de': 'Maisstärke',
      'pl': 'Skrobia kukurydziana',
      'ru': 'Кукурузный крахмал',
      'uk': 'Кукурудзяний крохмаль',
      'ko': '옥수수 전분',
      'zh': '玉米淀粉',
      'ja': 'コーンスターチ'
    }, {
      'id': 'Cornmeal',
      'en': 'Cornmeal',
      'fr': 'semoule de maïs',
      'es': 'Harina de maíz',
      'de': 'Mahlzeit mit Getreide',
      'pl': 'Mąka kukurydziana',
      'ru': 'Кукурузная мука',
      'uk': 'Кукурудзяне борошно',
      'ko': '옥수수 가루',
      'zh': '棒子面',
      'ja': 'コーンミール'
    }, {
      'id': 'CorrugatedSteelDoor',
      'en': 'Corrugated Steel Door',
      'fr': 'Porte en acier ondulé',
      'es': 'Puerta de acero corrugado',
      'de': 'Wellblechtür',
      'pl': 'Drzwi ze stali falistej',
      'ru': 'Дверь из гофрированной стали',
      'uk': 'Гофровані сталеві двері',
      'ko': '골판지 강철 문',
      'zh': '波纹钢门',
      'ja': '段ボール鋼製ドア'
    }, {
      'id': 'CorrugatedSteelFenceDoor',
      'en': 'Corrugated Steel Fence Door',
      'fr': 'Porte de clôture en acier ondulé',
      'es': 'Puerta de valla de acero corrugado',
      'de': 'Gewellte Stahlzaun-Tür',
      'pl': 'Drzwi ogrodzeniowe ze stali falistej',
      'ru': 'Дверь забора из гофрированной стали',
      'uk': 'Двері з гофрованої сталі',
      'ko': '골판지 강철 울타리 문',
      'zh': '波纹钢栅栏门',
      'ja': '段ボール鋼製柵ドア'
    }, {
      'id': 'CorrugatedSteel',
      'en': 'Corrugated Steel',
      'fr': 'Acier ondulé',
      'es': 'Acero corrugado',
      'de': 'Wellblech',
      'pl': 'Stal falista',
      'ru': 'Гофрированная сталь',
      'uk': 'Гофрована сталь',
      'ko': '골판지 강철',
      'zh': '波纹钢',
      'ja': '段ボール鋼'
    }, {
      'id': 'CottonCarpet',
      'en': 'Cotton Carpet',
      'fr': 'Tapis en coton',
      'es': 'Alfombra de algodón',
      'de': 'Baumwollteppich',
      'pl': 'Dywan bawełniany',
      'ru': 'Хлопковый ковер',
      'uk': 'Бавовняний килим',
      'ko': '면 카펫',
      'zh': '棉地毯',
      'ja': 'コットンカーペット'
    }, {
      'id': 'CottonCurtains',
      'en': 'Cotton Curtains',
      'fr': 'Rideaux en coton',
      'es': 'Cortinas de algodón',
      'de': 'Baumwollvorhänge',
      'pl': 'Zasłony bawełniane',
      'ru': 'Хлопковые шторы',
      'uk': 'Бавовняні штори',
      'ko': '면 커튼',
      'zh': '棉窗帘',
      'ja': '綿のカーテン'
    }, {
      'id': 'WeaveCottonCurtains',
      'en': 'Weave Cotton Curtains',
      'fr': 'Tisser des rideaux en coton',
      'es': 'Cortinas de algodón tejido',
      'de': 'Weben Sie Baumwollvorhänge',
      'pl': 'Tkane bawełniane zasłony',
      'ru': 'Тканые хлопковые шторы',
      'uk': 'Плетіть бавовняні штори',
      'ko': '면 커튼을 짜다',
      'zh': '编织棉窗帘',
      'ja': '織り綿のカーテン'
    }, {
      'id': 'CottonFabric',
      'en': 'Cotton Fabric',
      'fr': 'Tissu en coton',
      'es': 'Tela de algodón',
      'de': 'Baumwollfabrik',
      'pl': 'Tkanina bawełniana',
      'ru': 'Хлопковая фабрика',
      'uk': 'Бавовняна тканина',
      'ko': '코튼 원단',
      'zh': '棉织物',
      'ja': '綿織物'
    }, {
      'id': 'WeaveCottonFabric',
      'en': 'Weave Cotton Fabric',
      'fr': 'Tissu en coton tissé',
      'es': 'tejido de tela de algodón',
      'de': 'Baumwollstoff weben',
      'pl': 'Splot tkaniny bawełnianej',
      'ru': 'Ткать хлопчатобумажную ткань',
      'uk': 'Плетіть бавовняну тканину',
      'ko': '면직물을 짜다',
      'zh': '编织棉布',
      'ja': '織り綿生地'
    }, {
      'id': 'CottonThread',
      'en': 'Cotton Thread',
      'fr': 'Fil de coton',
      'es': 'Hilo de algodón',
      'de': 'Baumwollfaden',
      'pl': 'Nici bawełniane',
      'ru': 'Хлопковая нить',
      'uk': 'Бавовняна нитка',
      'ko': '면사',
      'zh': '棉线',
      'ja': '綿糸'
    }, {
      'id': 'Couch',
      'en': 'Couch',
      'fr': 'Canapé',
      'es': 'Sofá',
      'de': 'Couch',
      'pl': 'Kanapa',
      'ru': 'Диван',
      'uk': 'Диван',
      'ko': '침상',
      'zh': '长椅',
      'ja': 'ソファー'
    }, {
      'id': 'CrabPot',
      'en': 'Crab Pot',
      'fr': 'Casserole de crabe',
      'es': 'olla de cangrejo',
      'de': 'Krabbentopf',
      'pl': 'Garnek z krabem',
      'ru': 'Крабовый горшок',
      'uk': 'Крабовий горщик',
      'ko': '게 냄비',
      'zh': '蟹锅',
      'ja': 'カニ鍋'
    }, {
      'id': 'Crane',
      'en': 'Crane',
      'fr': 'Grue',
      'es': 'Grua',
      'de': 'Kran',
      'pl': 'Dźwig',
      'ru': 'кран',
      'uk': 'Журавель',
      'ko': '두루미',
      'zh': '起重机',
      'ja': 'クレーン'
    }, {
      'id': 'CriminiMushroomSpores',
      'en': 'Crimini Mushroom Spores',
      'fr': 'Spores de champignons Crimini',
      'es': 'Esporas de Hongo Crimini',
      'de': 'Crimini-Pilzsporen',
      'pl': 'Zarodniki grzybów Crimini',
      'ru': 'Споры грибов кримини',
      'uk': 'Спори грибів Криміні',
      'ko': '크리미니 버섯 포자',
      'zh': '克里米尼蘑菇孢子',
      'ja': 'クリミニマッシュルーム胞子'
    }, {
      'id': 'CrimsonSalad',
      'en': 'Crimson Salad',
      'fr': 'Salade Pourpre',
      'es': 'Ensalada Carmesí',
      'de': 'Purpurroter Salat',
      'pl': 'Sałatka Karmazynowa',
      'ru': 'Малиновый салат',
      'uk': 'Багряний салат',
      'ko': '크림슨 샐러드',
      'zh': '深红色沙拉',
      'ja': 'クリムゾンサラダ'
    }, {
      'id': 'CrispyBacon',
      'en': 'Crispy Bacon',
      'fr': 'Bacon croustillant',
      'es': 'Tocino crujiente',
      'de': 'Knuspriger Schinken',
      'pl': 'Chrupiący bekon',
      'ru': 'Хрустящий бекон',
      'uk': 'Хрусткий бекон',
      'ko': '바삭한 베이컨',
      'zh': '脆培根',
      'ja': 'クリスピーベーコン'
    }, {
      'id': 'CrushedBasaltLv2',
      'en': 'Crushed Basalt Lv2',
      'fr': 'Basalte concassé Lv2',
      'es': 'Basalto triturado Lv2',
      'de': 'Zerkleinerter Basalt Lv2',
      'pl': 'Kruszony Bazalt Lv2',
      'ru': 'Дробленый базальт Lv2',
      'uk': 'Подрібнений базальт Lv2',
      'ko': '으깬 현무암 Lv2',
      'zh': '碎玄武岩 Lv2',
      'ja': '砕いた玄武岩Lv2'
    }, {
      'id': 'CrushedBasaltLv3',
      'en': 'Crushed Basalt Lv3',
      'fr': 'Basalte concassé Lv3',
      'es': 'Basalto triturado Lv3',
      'de': 'Zerkleinerter Basalt Lv3',
      'pl': 'Kruszony Bazalt Lv3',
      'ru': 'Измельченный базальт Lv3',
      'uk': 'Подрібнений базальт Lv3',
      'ko': '으깬 현무암 Lv3',
      'zh': '碎玄武岩 Lv3',
      'ja': '砕いた玄武岩Lv3'
    }, {
      'id': 'CrushedCopperLv2',
      'en': 'Crushed Copper Lv2',
      'fr': 'Cuivre concassé Lv2',
      'es': 'Cobre triturado Lv2',
      'de': 'Zerkleinertes Kupfer Lv2',
      'pl': 'Kruszona miedź Lv2',
      'ru': 'Дробленая медь Lv2',
      'uk': 'Подрібнена мідь Lv2',
      'ko': '으깬 구리 Lv2',
      'zh': '碎铜 Lv2',
      'ja': '砕いた銅Lv2'
    }, {
      'id': 'CrushedCopperLv3',
      'en': 'Crushed Copper Lv3',
      'fr': 'Cuivre concassé Lv3',
      'es': 'Cobre triturado Lv3',
      'de': 'Zerkleinertes Kupfer Lv3',
      'pl': 'Kruszona miedź Lv3',
      'ru': 'Дробленая медь Lv3',
      'uk': 'Подрібнена мідь Lv3',
      'ko': '으깬 구리 Lv3',
      'zh': '碎铜 Lv3',
      'ja': '砕いた銅Lv3'
    }, {
      'id': 'CrushedCopperOre',
      'en': 'Crushed Copper Ore',
      'fr': 'Minerai de cuivre broyé',
      'es': 'Mineral de cobre triturado',
      'de': 'Zerkleinertes Kupfererz',
      'pl': 'Kruszona Ruda Miedzi',
      'ru': 'Дробленая медная руда',
      'uk': 'Подрібнена мідна руда',
      'ko': '분쇄된 구리 광석',
      'zh': '碎铜矿石',
      'ja': '砕いた銅鉱石'
    }, {
      'id': 'CrushedGneissLv2',
      'en': 'Crushed Gneiss Lv2',
      'fr': 'Gneiss concassé Lv2',
      'es': 'Gneis triturado Lv2',
      'de': 'Zerkleinerter Gneis Lv2',
      'pl': 'Zmiażdżony Gnejs Lv2',
      'ru': 'Измельченный гнейс Lv2',
      'uk': 'Подрібнений гнейс Lv2',
      'ko': '으깬 편마암 Lv2',
      'zh': '碎片麻岩 Lv2',
      'ja': '砕いた片麻岩Lv2'
    }, {
      'id': 'CrushedGneissLv3',
      'en': 'Crushed Gneiss Lv3',
      'fr': 'Gneiss concassé Lv3',
      'es': 'Gneis triturado Lv3',
      'de': 'Zerkleinerter Gneis Lv3',
      'pl': 'Zmiażdżony Gnejs Lv3',
      'ru': 'Измельченный гнейс Lv3',
      'uk': 'Подрібнений гнейс Lv3',
      'ko': '으깬 편마암 Lv3',
      'zh': '碎片麻岩 Lv3',
      'ja': '砕いた片麻岩Lv3'
    }, {
      'id': 'CrushedGoldLv2',
      'en': 'Crushed Gold Lv2',
      'fr': 'Or concassé Lv2',
      'es': 'Oro triturado Lv2',
      'de': 'Zerkleinertes Gold Lv2',
      'pl': 'Zmiażdżone złoto Lv2',
      'ru': 'Дробленое золото Lv2',
      'uk': 'Подрібнене золото Lv2',
      'ko': '크러쉬드 골드 Lv2',
      'zh': '碎金 Lv2',
      'ja': '砕いた金Lv2'
    }, {
      'id': 'CrushedGoldLv3',
      'en': 'Crushed Gold Lv3',
      'fr': 'Or concassé Lv3',
      'es': 'Oro triturado Lv3',
      'de': 'Zerkleinertes Gold Lv3',
      'pl': 'Zmiażdżone złoto Lv3',
      'ru': 'Дробленое золото Lv3',
      'uk': 'Подрібнене золото Lv3',
      'ko': '크러쉬드 골드 Lv3',
      'zh': '碎金 Lv3',
      'ja': '砕いた金Lv3'
    }, {
      'id': 'CrushedGoldOre',
      'en': 'Crushed Gold Ore',
      'fr': 'Minerai d\u0027or broyé',
      'es': 'Mineral de oro triturado',
      'de': 'Zerkleinertes Golderz',
      'pl': 'Kruszona Ruda Złota',
      'ru': 'Дробленая золотая руда',
      'uk': 'Подрібнена золота руда',
      'ko': '으깬 금광석',
      'zh': '碎金矿石',
      'ja': '砕いた金鉱石'
    }, {
      'id': 'CrushedGranite',
      'en': 'Crushed Granite',
      'fr': 'Granit concassé',
      'es': 'granito triturado',
      'de': 'Zerkleinerter Granit',
      'pl': 'Kruszony Granit',
      'ru': 'Дробленый гранит',
      'uk': 'Щебінь Гранітний',
      'ko': '분쇄된 화강암',
      'zh': '碎花岗岩',
      'ja': '砕いた花崗岩'
    }, {
      'id': 'CrushedGraniteLv2',
      'en': 'Crushed Granite Lv2',
      'fr': 'Granit concassé Lv2',
      'es': 'Granito triturado Lv2',
      'de': 'Zerkleinerter Granit Lv2',
      'pl': 'Kruszony Granit Lv2',
      'ru': 'Дробленый гранит Lv2',
      'uk': 'Щебінь Граніт Lv2',
      'ko': '분쇄된 화강암 Lv2',
      'zh': '碎花岗岩 Lv2',
      'ja': '砕いた花崗岩Lv2'
    }, {
      'id': 'CrushedGraniteLv3',
      'en': 'Crushed Granite Lv3',
      'fr': 'Granit concassé Lv3',
      'es': 'Granito triturado Lv3',
      'de': 'Zerkleinerter Granit Lv3',
      'pl': 'Kruszony Granit Lv3',
      'ru': 'Дробленый гранит Lv3',
      'uk': 'Щебінь Граніт Lv3',
      'ko': '분쇄된 화강암 Lv3',
      'zh': '碎花岗岩 Lv3',
      'ja': '砕いた花崗岩Lv3'
    }, {
      'id': 'CrushedIronLv2',
      'en': 'Crushed Iron Lv2',
      'fr': 'Fer broyé Lv2',
      'es': 'Hierro triturado Lv2',
      'de': 'Zerkleinertes Eisen Lv2',
      'pl': 'Kruszone Żelazo Lv2',
      'ru': 'Дробленое железо Lv2',
      'uk': 'Щебень Lv2',
      'ko': '분쇄된 철 Lv2',
      'zh': '碎铁 Lv2',
      'ja': '砕いた鉄Lv2'
    }, {
      'id': 'CrushedIronLv3',
      'en': 'Crushed Iron Lv3',
      'fr': 'Fer broyé Lv3',
      'es': 'Hierro triturado Lv3',
      'de': 'Zerkleinertes Eisen Lv3',
      'pl': 'Kruszone Żelazo Lv3',
      'ru': 'Дробленое железо Lv3',
      'uk': 'Щебене залізо Lv3',
      'ko': '분쇄된 철 Lv3',
      'zh': '碎铁 Lv3',
      'ja': '砕いた鉄Lv3'
    }, {
      'id': 'CrushedIronOre',
      'en': 'Crushed Iron Ore',
      'fr': 'Minerai de fer broyé',
      'es': 'Mineral de hierro triturado',
      'de': 'Zerkleinertes Eisenerz',
      'pl': 'Kruszona Ruda Żelaza',
      'ru': 'Дробленая железная руда',
      'uk': 'Подрібнена залізна руда',
      'ko': '분쇄된 철광석',
      'zh': '碎铁矿石',
      'ja': '砕いた鉄鉱石'
    }, {
      'id': 'CrushedLimestone',
      'en': 'Crushed Limestone',
      'fr': 'Calcaire concassé',
      'es': 'piedra caliza triturada',
      'de': 'Zerkleinerter Kalkstein',
      'pl': 'Kruszony Wapień',
      'ru': 'Известняковый щебень',
      'uk': 'Подрібнений вапняк',
      'ko': '분쇄된 석회암',
      'zh': '碎石灰石',
      'ja': '砕いた石灰岩'
    }, {
      'id': 'CrushedLimestoneLv2',
      'en': 'Crushed Limestone Lv2',
      'fr': 'Calcaire concassé Lv2',
      'es': 'Piedra caliza triturada Lv2',
      'de': 'Zerkleinerter Kalkstein Lv2',
      'pl': 'Kruszony Wapień Lv2',
      'ru': 'Дробленый известняк Lv2',
      'uk': 'Щебінь вапняку Lv2',
      'ko': '분쇄된 석회암 Lv2',
      'zh': '碎石灰石 Lv2',
      'ja': '砕いた石灰石Lv2'
    }, {
      'id': 'CrushedLimestoneLv3',
      'en': 'Crushed Limestone Lv3',
      'fr': 'Calcaire concassé Lv3',
      'es': 'Piedra caliza triturada Lv3',
      'de': 'Zerkleinerter Kalkstein Lv3',
      'pl': 'Kruszony Wapień Lv3',
      'ru': 'Дробленый известняк Lv3',
      'uk': 'Щебінь вапняку Lv3',
      'ko': '분쇄된 석회암 Lv3',
      'zh': '碎石灰石 Lv3',
      'ja': '砕いた石灰石Lv3'
    }, {
      'id': 'CrushedMortaredStone',
      'en': 'Crushed Mortared Stone',
      'fr': 'Pierre de mortier concassée',
      'es': 'Piedra triturada con mortero',
      'de': 'Zerkleinerter Mörtelstein',
      'pl': 'Kruszony Zaprawiony Kamień',
      'ru': 'Щебень известкового камня',
      'uk': 'Щебінь розтираний',
      'ko': '깔린 박격포 돌',
      'zh': '碎砂浆',
      'ja': '砕いたモルタル石'
    }, {
      'id': 'CrushedMortaredStoneLv2',
      'en': 'Crushed Mortared Stone Lv2',
      'fr': 'Pierre de mortier concassée Lv2',
      'es': 'Piedra triturada con mortero Lv2',
      'de': 'Zerkleinerter Mörserstein Lv2',
      'pl': 'Kruszony zaprawiony kamień Lv2',
      'ru': 'Измельченный известковый камень Lv2',
      'uk': 'Щебінь 2 рівня',
      'ko': '으깬 박격석 Lv2',
      'zh': '粉碎的砂浆 Lv2',
      'ja': '砕いたモルタル石Lv2'
    }, {
      'id': 'CrushedStoneRamp',
      'en': 'Crushed Stone Ramp',
      'fr': 'Rampe en pierre concassée',
      'es': 'Rampa de piedra triturada',
      'de': 'Schotterrampe',
      'pl': 'Rampa z kruszonego kamienia',
      'ru': 'Рампа из щебня',
      'uk': 'Пандус із щебеню',
      'ko': '깔린 돌 경사로',
      'zh': '碎石坡道',
      'ja': '砕石ランプ'
    }, {
      'id': 'CrushedStoneRampLv2',
      'en': 'Crushed Stone Ramp Lv2',
      'fr': 'Rampe en pierre concassée Lv2',
      'es': 'Rampa de piedra triturada Lv2',
      'de': 'Schotterrampe Lv2',
      'pl': 'Zmiażdżona Kamienna Rampa Lv2',
      'ru': 'Каменная рампа Lv2',
      'uk': 'Рамп з щебеню Lv2',
      'ko': '크러쉬드 스톤 램프 Lv2',
      'zh': '碎石坡道 Lv2',
      'ja': '砕石ランプLv2'
    }, {
      'id': 'CrushedStoneRoad',
      'en': 'Crushed Stone Road',
      'fr': 'Route de la pierre concassée',
      'es': 'Camino de piedra triturada',
      'de': 'Schotterstraße',
      'pl': 'Kruszona kamienna droga',
      'ru': 'Дорога из щебня',
      'uk': 'Щебінь Дорога',
      'ko': '깔린 돌길',
      'zh': '碎石路',
      'ja': '砕石道路'
    }, {
      'id': 'CrushedStoneRoadLv2',
      'en': 'Crushed Stone Road Lv2',
      'fr': 'Route de pierre concassée Lv2',
      'es': 'Camino de piedra triturada Lv2',
      'de': 'Schotterstraße Lv2',
      'pl': 'Kruszona kamienna droga Lv2',
      'ru': 'Дорога из щебня Lv2',
      'uk': 'Щебінь Дорога Lv2',
      'ko': '깔린 돌길 Lv2',
      'zh': '碎石路 Lv2',
      'ja': '砕石道路Lv2'
    }, {
      'id': 'CrushedSandstone',
      'en': 'Crushed Sandstone',
      'fr': 'Grès concassé',
      'es': 'Arenisca triturada',
      'de': 'Zerkleinerter Sandstein',
      'pl': 'Kruszony Piaskowiec',
      'ru': 'Щебень песчаник',
      'uk': 'Щебінь піщаник',
      'ko': '분쇄된 사암',
      'zh': '碎砂岩',
      'ja': '砕いた砂岩'
    }, {
      'id': 'CrushedSandstoneLv2',
      'en': 'Crushed Sandstone Lv2',
      'fr': 'Grès concassé Lv2',
      'es': 'Arenisca triturada Lv2',
      'de': 'Zerkleinerter Sandstein Lv2',
      'pl': 'Kruszony piaskowiec Lv2',
      'ru': 'Дробленый песчаник Lv2',
      'uk': 'Щебінь пісковика Lv2',
      'ko': '분쇄 사암 Lv2',
      'zh': '碎砂岩 Lv2',
      'ja': '砕いた砂岩Lv2'
    }, {
      'id': 'CrushedSandstoneLv3',
      'en': 'Crushed Sandstone Lv3',
      'fr': 'Grès concassé Lv3',
      'es': 'Arenisca triturada Lv3',
      'de': 'Zerkleinerter Sandstein Lv3',
      'pl': 'Kruszony Piaskowiec Lv3',
      'ru': 'Дробленый песчаник Lv3',
      'uk': 'Щебінь пісковика Lv3',
      'ko': '분쇄된 사암 Lv3',
      'zh': '碎砂岩 Lv3',
      'ja': '砕いた砂岩Lv3'
    }, {
      'id': 'CrushedShale',
      'en': 'Crushed Shale',
      'fr': 'Schiste concassé',
      'es': 'esquisto triturado',
      'de': 'Zerkleinerter Schiefer',
      'pl': 'Kruszony łupek',
      'ru': 'Дробленый сланец',
      'uk': 'Подрібнений сланец',
      'ko': '분쇄된 혈암',
      'zh': '碎页岩',
      'ja': '砕いた頁岩'
    }, {
      'id': 'CrushedShaleLv2',
      'en': 'Crushed Shale Lv2',
      'fr': 'Schiste concassé Lv2',
      'es': 'Esquisto triturado Lv2',
      'de': 'Zerkleinerter Schiefer Lv2',
      'pl': 'Kruszony łupek Lv2',
      'ru': 'Дробленый сланец Lv2',
      'uk': 'Подрібнений сланець Lv2',
      'ko': '분쇄된 혈암 Lv2',
      'zh': '碎页岩 Lv2',
      'ja': '砕いた頁岩Lv2'
    }, {
      'id': 'CrushedShaleLv3',
      'en': 'Crushed Shale Lv3',
      'fr': 'Schiste concassé Lv3',
      'es': 'Esquisto triturado Lv3',
      'de': 'Zerkleinerter Schiefer Lv3',
      'pl': 'Skruszony łupek Lv3',
      'ru': 'Измельченный сланец Lv3',
      'uk': 'Подрібнений сланець Lv3',
      'ko': '분쇄된 혈암 Lv3',
      'zh': '碎页岩 Lv3',
      'ja': '砕いた頁岩Lv3'
    }, {
      'id': 'CrushedSlagLv2',
      'en': 'Crushed Slag Lv2',
      'fr': 'Laitier concassé Lv2',
      'es': 'Escoria triturada Lv2',
      'de': 'Zerkleinerte Schlacke Lv2',
      'pl': 'Skruszony Żużel Lv2',
      'ru': 'Измельченный шлак Lv2',
      'uk': 'Подрібнений шлак Lv2',
      'ko': '크러쉬드 슬래그 Lv2',
      'zh': '碎渣 Lv2',
      'ja': '破砕スラグLv2'
    }, {
      'id': 'CrushedSlagLv3',
      'en': 'Crushed Slag Lv3',
      'fr': 'Laitier concassé Lv3',
      'es': 'Escoria triturada Lv3',
      'de': 'Zerkleinerte Schlacke Lv3',
      'pl': 'Skruszony Żużel Lv3',
      'ru': 'Измельченный шлак Lv3',
      'uk': 'Подрібнений шлак Lv3',
      'ko': '크러쉬드 슬래그 Lv3',
      'zh': '碎渣 Lv3',
      'ja': '破砕スラグLv3'
    }, {
      'id': 'CulinaryResearchPaperAdvanced',
      'en': 'Culinary Research Paper Advanced',
      'fr': 'Document de recherche culinaire avancé',
      'es': 'Trabajo de investigación culinaria avanzada',
      'de': 'Kulinarisches Forschungspapier für Fortgeschrittene',
      'pl': 'Zaawansowany artykuł do badań kulinarnych',
      'ru': 'Кулинарная исследовательская работа Advanced',
      'uk': 'Кулінарна наукова робота Advanced',
      'ko': '요리 연구 논문 고급',
      'zh': '烹饪研究论文高级',
      'ja': '料理研究論文Advanced'
    }, {
      'id': 'CulinaryResearchPaperAdvancedMeat',
      'en': 'Culinary Research Paper Advanced Meat',
      'fr': 'Document de recherche culinaire Viande avancée',
      'es': 'Trabajo de investigación culinaria Carne avanzada',
      'de': 'Kulinarisches Forschungspapier Advanced Meat',
      'pl': 'Papier do badań kulinarnych Zaawansowane mięso',
      'ru': 'Кулинарная исследовательская работа Advanced Meat',
      'uk': 'Кулінарні дослідження Advanced Meat',
      'ko': '요리 연구 논문 고급 고기',
      'zh': '烹饪研究论文高级肉类',
      'ja': '料理研究論文AdvancedMeat'
    }, {
      'id': 'CulinaryResearchPaperBasic',
      'en': 'Culinary Research Paper Basic',
      'fr': 'Document de recherche culinaire de base',
      'es': 'Trabajo básico de investigación culinaria',
      'de': 'Kulinarisches Forschungspapier Basic',
      'pl': 'Artykuł do badań kulinarnych Basic',
      'ru': 'Кулинарная исследовательская работа Basic',
      'uk': 'Кулінарна наукова робота Basic',
      'ko': '요리연구논문 기초',
      'zh': '烹饪研究论文基础',
      'ja': '料理研究論文基本'
    }, {
      'id': 'CulinaryResearchPaperBasicFish',
      'en': 'Culinary Research Paper Basic Fish',
      'fr': 'Document de recherche culinaire Basic Fish',
      'es': 'Trabajo de investigación culinaria Pescado básico',
      'de': 'Kulinarisches Forschungspapier Basic Fish',
      'pl': 'Artykuł do badań kulinarnych Podstawowe ryby',
      'ru': 'Кулинарная исследовательская работа Basic Fish',
      'uk': 'Кулінарні дослідження Основні риби',
      'ko': '요리 연구 논문 기초 생선',
      'zh': '烹饪研究论文基本鱼',
      'ja': '料理研究論文基礎魚'
    }, {
      'id': 'CulinaryResearchPaperBasicMeat',
      'en': 'Culinary Research Paper Basic Meat',
      'fr': 'Document de recherche culinaire Viande de base',
      'es': 'Documento de investigación culinaria Carne básica',
      'de': 'Kulinarisches Forschungspapier Basic Meat',
      'pl': 'Papier do badań kulinarnych Mięso podstawowe',
      'ru': 'Кулинарная исследовательская работа Basic Meat',
      'uk': 'Кулінарні дослідження Основне м\u0027ясо',
      'ko': '요리 연구 논문 기초 고기',
      'zh': '烹饪研究论文基本肉类',
      'ja': '料理研究論文基礎肉'
    }, {
      'id': 'CulinaryResearchPaperModern',
      'en': 'Culinary Research Paper Modern',
      'fr': 'Document de recherche culinaire moderne',
      'es': 'Documento de investigación culinaria moderno',
      'de': 'Kulinarisches Forschungspapier Modern',
      'pl': 'Artykuł do badań kulinarnych Nowoczesny',
      'ru': 'Кулинарная исследовательская работа Модерн',
      'uk': 'Кулінарні дослідження Сучасні',
      'ko': '요리 연구 논문 현대',
      'zh': '现代烹饪研究论文',
      'ja': '現代料理研究論文'
    }, {
      'id': 'CurrencyExchange',
      'en': 'Currency Exchange',
      'fr': 'Échange de devises',
      'es': 'Cambio de divisas',
      'de': 'Geldwechsel',
      'pl': 'Wymiana walut',
      'ru': 'Обмен валюты',
      'uk': 'Обмін валюти',
      'ko': '환전소',
      'zh': '货币兑换',
      'ja': '為替'
    }, {
      'id': 'CuttingEdgeCookingUpgrade',
      'en': 'Cutting Edge Cooking Upgrade',
      'fr': 'Mise à niveau de cuisson de pointe',
      'es': 'Actualización de cocina de vanguardia',
      'de': 'Modernstes Koch-Upgrade',
      'pl': 'Najnowocześniejsze ulepszenie gotowania',
      'ru': 'Новейшее обновление кулинарии',
      'uk': 'Новітнє оновлення кулінарії',
      'ko': '최첨단 요리 업그레이드',
      'zh': '尖端烹饪升级',
      'ja': '最先端の料理のアップグレード'
    }, {
      'id': 'DendrologyResearchPaperAdvanced',
      'en': 'Dendrology Research Paper Advanced',
      'fr': 'Document de recherche en dendrologie avancé',
      'es': 'Trabajo de investigación de dendrología avanzada',
      'de': 'Dendrologische Forschungsarbeit Fortgeschritten',
      'pl': 'Zaawansowany artykuł badawczy dendrologiczny',
      'ru': 'Дендрологическая исследовательская работа Advanced',
      'uk': 'Дослідницька робота з дендрології Advanced',
      'ko': '덴드롤로지 연구 논문 고급',
      'zh': '树木学研究论文高级',
      'ja': '樹木学研究論文Advanced'
    }, {
      'id': 'DendrologyResearchPaperBasic',
      'en': 'Dendrology Research Paper Basic',
      'fr': 'Document de recherche sur la dendrologie',
      'es': 'Documento de investigación de dendrología básico',
      'de': 'Dendrologisches Forschungspapier Basic',
      'pl': 'Podstawowy papier do badań dendrologicznych',
      'ru': 'Базовый исследовательский документ по дендрологии',
      'uk': 'Дендрологічна наукова робота Basic',
      'ko': '덴드로로지 연구논문 기초',
      'zh': '树木学研究论文基础',
      'ja': '樹木学研究論文基本'
    }, {
      'id': 'DendrologyResearchPaperModern',
      'en': 'Dendrology Research Paper Modern',
      'fr': 'Document de recherche sur la dendrologie moderne',
      'es': 'Documento de investigación de dendrología moderno',
      'de': 'Dendrologische Forschungsarbeit Modern',
      'pl': 'Nowoczesny papier do badań dendrologicznych',
      'ru': 'Дендрологическая исследовательская работа «Современный»',
      'uk': 'Дендрологічна наукова робота Сучасні',
      'ko': '덴드롤로지 연구 논문 모던',
      'zh': '现代树木学研究论文',
      'ja': '樹木学研究論文モダン'
    }, {
      'id': 'DerpyHat',
      'en': 'Derpy Hat',
      'fr': 'Chapeau Derpy',
      'es': 'Sombrero Derpy',
      'de': 'Derpy-Hut',
      'pl': 'Derpy kapelusz',
      'ru': 'Дерпи Шляпа',
      'uk': 'Капелюх Дерпі',
      'ko': '더피 모자',
      'zh': '小呆帽',
      'ja': 'ダーピーハット'
    }, {
      'id': 'DistributionStation',
      'en': 'Distribution Station',
      'fr': 'Poste de distribution',
      'es': 'Estación de distribución',
      'de': 'Verteilerstation',
      'pl': 'Stacja dystrybucyjna',
      'ru': 'Распределительная станция',
      'uk': 'Розподільна станція',
      'ko': '유통 스테이션',
      'zh': '配送站',
      'ja': '配電所'
    }, {
      'id': 'ElectricLathe',
      'en': 'Electric Lathe',
      'fr': 'Tour électrique',
      'es': 'torno electrico',
      'de': 'Elektrische Drehmaschine',
      'pl': 'Tokarka elektryczna',
      'ru': 'Электрический токарный станок',
      'uk': 'Електричний токарний верстат',
      'ko': '전동선반',
      'zh': '电动车床',
      'ja': '電気旋盤'
    }, {
      'id': 'ElectricMachinistTable',
      'en': 'Electric Machinist Table',
      'fr': 'Table de machiniste électrique',
      'es': 'Mesa de maquinista eléctrico',
      'de': 'Elektrischer Maschinistentisch',
      'pl': 'Elektryczny stół mechanika',
      'ru': 'Электромеханический стол',
      'uk': 'Стіл електричного машиніста',
      'ko': '전기 기계공 테이블',
      'zh': '电动机械师表',
      'ja': '電気機械工テーブル'
    }, {
      'id': 'ElectricMotor',
      'en': 'Electric Motor',
      'fr': 'Moteur électrique',
      'es': 'Motor eléctrico',
      'de': 'Elektromotor',
      'pl': 'Silnik elektryczny',
      'ru': 'Электродвигатель',
      'uk': 'Електричний двигун',
      'ko': '전기 모터',
      'zh': '电动马达',
      'ja': '電気モーター'
    }, {
      'id': 'ElectricPlaner',
      'en': 'Electric Planer',
      'fr': 'Rabot électrique',
      'es': 'Cepilladora eléctrica',
      'de': 'Elektrohobel',
      'pl': 'Strugarka elektryczna',
      'ru': 'Электрический рубанок',
      'uk': 'Електричний рубанок',
      'ko': '전기 대패',
      'zh': '电刨',
      'ja': '電気かんなな'
    }, {
      'id': 'ElectricStampingPress',
      'en': 'Electric Stamping Press',
      'fr': 'Presse à emboutir électrique',
      'es': 'Prensa de estampado eléctrica',
      'de': 'Elektrische Stanzpresse',
      'pl': 'Elektryczna prasa do tłoczenia',
      'ru': 'Электрический штамповочный пресс',
      'uk': 'Електричний штампувальний прес',
      'ko': '전기 스탬핑 프레스',
      'zh': '电动冲压机',
      'ja': '電気スタンピングプレス'
    }, {
      'id': 'ElectricWallLamp',
      'en': 'Electric Wall Lamp',
      'fr': 'Applique murale électrique',
      'es': 'Lámpara de pared eléctrica',
      'de': 'Elektrische Wandleuchte',
      'pl': 'Elektryczna lampa ścienna',
      'ru': 'Электрическая настенная лампа',
      'uk': 'Електричний настінний світильник',
      'ko': '전기 벽 램프',
      'zh': '电动壁灯',
      'ja': '電気ウォールランプ'
    }, {
      'id': 'ElectricWaterPump',
      'en': 'Electric Water Pump',
      'fr': 'Pompe à eau électrique',
      'es': 'Bomba de agua eléctrica',
      'de': 'Elektrische Wasserpumpe',
      'pl': 'Elektryczna pompa wodna',
      'ru': 'Электрический водяной насос',
      'uk': 'Електричний водяний насос',
      'ko': '전기 워터 펌프',
      'zh': '电动水泵',
      'ja': '電動送水ポンプ'
    }, {
      'id': 'ElectronicsAssembly',
      'en': 'Electronics Assembly',
      'fr': 'Assemblage électronique',
      'es': 'Montaje de electrónica',
      'de': 'Elektronikmontage',
      'pl': 'Montaż elektroniki',
      'ru': 'Сборка электроники',
      'uk': 'Збірка електроніки',
      'ko': '전자제품 조립',
      'zh': '电子组装',
      'ja': 'エレクトロニクスアセンブリ'
    }, {
      'id': 'ElectronicsUpgrade',
      'en': 'Electronics Upgrade',
      'fr': 'Mise à niveau électronique',
      'es': 'Actualización de la electrónica',
      'de': 'Elektronik-Upgrade',
      'pl': 'Aktualizacja elektroniki',
      'ru': 'Модернизация электроники',
      'uk': 'Оновлення електроніки',
      'ko': '전자제품 업그레이드',
      'zh': '电子升级',
      'ja': 'エレクトロニクスのアップグレード'
    }, {
      'id': 'ElevatorCallPost',
      'en': 'Elevator Call Post',
      'fr': 'Poste d\u0027appel d\u0027ascenseur',
      'es': 'Puesto de llamada de ascensor',
      'de': 'Aufzugrufstelle',
      'pl': 'Winda Call Post',
      'ru': 'Сообщение вызова лифта',
      'uk': 'Пост виклику ліфта',
      'ko': '엘리베이터 호출 포스트',
      'zh': '电梯呼叫站',
      'ja': 'エレベーターコールポスト'
    }, {
      'id': 'ElkMount',
      'en': 'Elk Mount',
      'fr': 'Mont Elk',
      'es': 'Monte alce',
      'de': 'Elchberg',
      'pl': 'Góra Łosia',
      'ru': 'Лось Маунт',
      'uk': 'Лосина гора',
      'ko': '엘크 마운트',
      'zh': '麋鹿山',
      'ja': 'エルクマウント'
    }, {
      'id': 'ElkTaco',
      'en': 'Elk Taco',
      'fr': 'Taco au wapiti',
      'es': 'Taco de alce',
      'de': 'Elch-Taco',
      'pl': 'Ełk Taco',
      'ru': 'Лосиный тако',
      'uk': 'Лось тако',
      'ko': '엘크 타코',
      'zh': '麋鹿塔可',
      'ja': 'エルクタコス'
    }, {
      'id': 'ElkWellington',
      'en': 'Elk Wellington',
      'fr': 'Wapiti Wellington',
      'es': 'Alce Wellington',
      'de': 'Elch Wellington',
      'pl': 'Ełk Wellington',
      'ru': 'Лось Веллингтон',
      'uk': 'Лось Веллінгтон',
      'ko': '엘크 웰링턴',
      'zh': '麋鹿惠灵顿',
      'ja': 'エルクウェリントン'
    }, {
      'id': 'EngineeringResearchPaperAdvanced',
      'en': 'Engineering Research Paper Advanced',
      'fr': 'Document de recherche en ingénierie avancé',
      'es': 'Trabajo de investigación de ingeniería avanzado',
      'de': 'Technisches Forschungspapier für Fortgeschrittene',
      'pl': 'Zaawansowany papier badawczy inżynierski',
      'ru': 'Инженерно-исследовательская работа Advanced',
      'uk': 'Інженерно-дослідницька робота Advanced',
      'ko': '공학 연구 논문 고급',
      'zh': '工程研究论文高级',
      'ja': '工学研究論文Advanced'
    }, {
      'id': 'EngineeringResearchPaperModern',
      'en': 'Engineering Research Paper Modern',
      'fr': 'Document de recherche en ingénierie moderne',
      'es': 'Papel de investigación de ingeniería moderno',
      'de': 'Engineering Research Paper Modern',
      'pl': 'Nowoczesny papier do badań inżynierskich',
      'ru': 'Инженерно-исследовательская работа Модерн',
      'uk': 'Інженерно-дослідна робота Сучасні',
      'ko': '공학 연구 논문 현대',
      'zh': '现代工程研究论文',
      'ja': '現代工学研究論文'
    }, {
      'id': 'Epoxy',
      'en': 'Epoxy',
      'fr': 'Époxy',
      'es': 'Epoxy',
      'de': 'Epoxid',
      'pl': 'Żywica epoksydowa',
      'ru': 'Эпоксидная смола',
      'uk': 'Епоксидна смола',
      'ko': '에폭시',
      'zh': '环氧树脂',
      'ja': 'エポキシ'
    }, {
      'id': 'CornEthanol',
      'en': 'Corn Ethanol',
      'fr': 'Éthanol de maïs',
      'es': 'Etanol de Maíz',
      'de': 'Mais-Ethanol',
      'pl': 'Etanol kukurydziany',
      'ru': 'Кукурузный этанол',
      'uk': 'Кукурудзяний етанол',
      'ko': '옥수수 에탄올',
      'zh': '玉米乙醇',
      'ja': 'コーンエタノール'
    }, {
      'id': 'WheatEthanol',
      'en': 'Wheat Ethanol',
      'fr': 'Éthanol de blé',
      'es': 'Etanol de trigo',
      'de': 'Weizen-Ethanol',
      'pl': 'Etanol pszeniczny',
      'ru': 'Пшеничный этанол',
      'uk': 'Пшеничний етанол',
      'ko': '밀 에탄올',
      'zh': '小麦乙醇',
      'ja': '小麦エタノール'
    }, {
      'id': 'Excavator',
      'en': 'Excavator',
      'fr': 'Excavatrice',
      'es': 'Excavador',
      'de': 'Bagger',
      'pl': 'Koparka',
      'ru': 'Экскаватор',
      'uk': 'Екскаватор',
      'ko': '굴착기',
      'zh': '挖掘机',
      'ja': '掘削機'
    }, {
      'id': 'ExplorerBelt',
      'en': 'Explorer Belt',
      'fr': 'Ceinture d\u0027explorateur',
      'es': 'Cinturón de explorador',
      'de': 'Explorer-Gürtel',
      'pl': 'Pas Odkrywcy',
      'ru': 'Пояс исследователя',
      'uk': 'Пояс дослідника',
      'ko': '탐험가 허리띠',
      'zh': '探险者腰带',
      'ja': 'エクスプローラーベルト'
    }, {
      'id': 'ExplorerBoots',
      'en': 'Explorer Boots',
      'fr': 'Bottes d\u0027explorateur',
      'es': 'Botas de explorador',
      'de': 'Explorer-Stiefel',
      'pl': 'Buty Odkrywcy',
      'ru': 'Ботинки исследователя',
      'uk': 'Черевики Explorer',
      'ko': '익스플로러 부츠',
      'zh': '探险者靴子',
      'ja': 'エクスプローラーブーツ'
    }, {
      'id': 'ExplorerGloves',
      'en': 'Explorer Gloves',
      'fr': 'Gants d\u0027explorateur',
      'es': 'Guantes de explorador',
      'de': 'Explorer-Handschuhe',
      'pl': 'Rękawiczki Odkrywcy',
      'ru': 'Перчатки исследователя',
      'uk': 'Рукавички Explorer',
      'ko': '탐험가 장갑',
      'zh': '探险者手套',
      'ja': 'エクスプローラーグローブ'
    }, {
      'id': 'ExplorerHat',
      'en': 'Explorer Hat',
      'fr': 'Chapeau d\u0027explorateur',
      'es': 'Sombrero de explorador',
      'de': 'Explorer-Hut',
      'pl': 'Kapelusz Odkrywcy',
      'ru': 'Шляпа исследователя',
      'uk': 'Капелюх дослідника',
      'ko': '탐험가 모자',
      'zh': '探险者帽',
      'ja': 'エクスプローラーハット'
    }, {
      'id': 'ExplorerPants',
      'en': 'Explorer Pants',
      'fr': 'Pantalon d\u0027explorateur',
      'es': 'Pantalones de explorador',
      'de': 'Explorer-Hose',
      'pl': 'Spodnie Odkrywcy',
      'ru': 'Брюки исследователя',
      'uk': 'Штани Explorer',
      'ko': '탐험가 바지',
      'zh': '探险家裤',
      'ja': 'エクスプローラーパンツ'
    }, {
      'id': 'ExplorerShirt',
      'en': 'Explorer Shirt',
      'fr': 'Chemise d\u0027explorateur',
      'es': 'Camisa de explorador',
      'de': 'Explorer-Shirt',
      'pl': 'Koszula Odkrywcy',
      'ru': 'Рубашка исследователя',
      'uk': 'Сорочка Explorer',
      'ko': '탐험가 셔츠',
      'zh': '探险者衬衫',
      'ja': 'エクスプローラーシャツ'
    }, {
      'id': 'FantasticForestPizza',
      'en': 'Fantastic Forest Pizza',
      'fr': 'Pizza fantastique de la forêt',
      'es': 'Fantástica pizza del bosque',
      'de': 'Fantastische Waldpizza',
      'pl': 'Fantastyczna Leśna Pizza',
      'ru': 'Фантастическая лесная пицца',
      'uk': 'Фантастична лісова піца',
      'ko': '판타스틱 포레스트 피자',
      'zh': '神奇的森林披萨',
      'ja': 'ファンタスティックフォレストピザ'
    }, {
      'id': 'FarmerBoots',
      'en': 'Farmer Boots',
      'fr': 'Bottes de fermier',
      'es': 'Botas de granjero',
      'de': 'Bauernstiefel',
      'pl': 'Buty Rolnika',
      'ru': 'Ботинки фермера',
      'uk': 'Фермерські чоботи',
      'ko': '농부 부츠',
      'zh': '农夫靴',
      'ja': 'ファーマーブーツ'
    }, {
      'id': 'FarmerGloves',
      'en': 'Farmer Gloves',
      'fr': 'Gants de fermier',
      'es': 'Guantes de granjero',
      'de': 'Bauernhandschuhe',
      'pl': 'Rękawice rolnika',
      'ru': 'Фермерские перчатки',
      'uk': 'Фермерські рукавички',
      'ko': '농부 장갑',
      'zh': '农夫手套',
      'ja': 'ファーマーグローブ'
    }, {
      'id': 'FarmerHat',
      'en': 'Farmer Hat',
      'fr': 'Chapeau de fermier',
      'es': 'Sombrero de granjero',
      'de': 'Bauernhut',
      'pl': 'Kapelusz Rolnika',
      'ru': 'Шляпа фермера',
      'uk': 'Фермерський капелюх',
      'ko': '농부 모자',
      'zh': '农夫帽',
      'ja': 'ファーマーハット'
    }, {
      'id': 'FarmerOveralls',
      'en': 'Farmer Overalls',
      'fr': 'Salopette de fermier',
      'es': 'overoles de granjero',
      'de': 'Landwirt-Overalls',
      'pl': 'Kombinezon rolnika',
      'ru': 'Фермерский комбинезон',
      'uk': 'Фермерський комбінезон',
      'ko': '농부 작업복',
      'zh': '农民工装裤',
      'ja': 'ファーマーオーバーオール'
    }, {
      'id': 'FarmerShirt',
      'en': 'Farmer Shirt',
      'fr': 'Chemise de fermier',
      'es': 'Camisa de granjero',
      'de': 'Bauern-Shirt',
      'pl': 'Koszula Rolnika',
      'ru': 'Рубашка фермера',
      'uk': 'Фермерська сорочка',
      'ko': '농부 셔츠',
      'zh': '农夫衬衫',
      'ja': 'ファーマーシャツ'
    }, {
      'id': 'FarmersTable',
      'en': 'Farmers Table',
      'fr': 'Tableau des agriculteurs',
      'es': 'Mesa de agricultores',
      'de': 'Bauerntisch',
      'pl': 'Tabela rolników',
      'ru': 'Таблица фермеров',
      'uk': 'Фермерський стіл',
      'ko': '농부 테이블',
      'zh': '农民表',
      'ja': 'ファーマーズテーブル'
    }, {
      'id': 'FarmingUpgrade',
      'en': 'Farming Upgrade',
      'fr': 'Amélioration de l\u0027agriculture',
      'es': 'Mejora agrícola',
      'de': 'Landwirtschafts-Upgrade',
      'pl': 'Ulepszenie rolnictwa',
      'ru': 'Улучшение сельского хозяйства',
      'uk': 'Оновлення сільського господарства',
      'ko': '파밍 업그레이드',
      'zh': '农业升级',
      'ja': '農業のアップグレード'
    }, {
      'id': 'FernCampfireSalad',
      'en': 'Fern Campfire Salad',
      'fr': 'Salade de feu de camp de fougère',
      'es': 'Ensalada de fogata de helecho',
      'de': 'Farn-Lagerfeuer-Salat',
      'pl': 'Sałatka z Ogniskiem Paproci',
      'ru': 'Салат из папоротника у костра',
      'uk': 'Салат з папороті',
      'ko': '고사리 모닥불 샐러드',
      'zh': '蕨类篝火沙拉',
      'ja': 'シダキャンプファイヤーサラダ'
    }, {
      'id': 'FernSpore',
      'en': 'Fern Spore',
      'fr': 'Spore de fougère',
      'es': 'Espora de helecho',
      'de': 'Farnspore',
      'pl': 'Zarodnik paproci',
      'ru': 'споры папоротника',
      'uk': 'Спор папороті',
      'ko': '고사리 포자',
      'zh': '蕨类孢子',
      'ja': 'シダの胞子'
    }, {
      'id': 'FertilizersUpgrade',
      'en': 'Fertilizers Upgrade',
      'fr': 'Amélioration des engrais',
      'es': 'Actualización de fertilizantes',
      'de': 'Düngemittel-Upgrade',
      'pl': 'Ulepszenie nawozów',
      'ru': 'Обновление удобрений',
      'uk': 'Оновлення добрив',
      'ko': '비료 업그레이드',
      'zh': '肥料升级',
      'ja': '肥料のアップグレード'
    }, {
      'id': 'FiberFiller',
      'en': 'Fiber Filler',
      'fr': 'Remplissage de fibres',
      'es': 'Relleno de fibra',
      'de': 'Faserfüller',
      'pl': 'Wypełniacz włóknisty',
      'ru': 'Волокнистый наполнитель',
      'uk': 'Волокнистий наповнювач',
      'ko': '섬유 충전재',
      'zh': '纤维填料',
      'ja': 'ファイバーフィラー'
    }, {
      'id': 'Fiberglass',
      'en': 'Fiberglass',
      'fr': 'Fibre de verre',
      'es': 'Fibra de vidrio',
      'de': 'Fiberglas',
      'pl': 'Włókno szklane',
      'ru': 'Стекловолокно',
      'uk': 'Скловолокно',
      'ko': '유리 섬유',
      'zh': '玻璃纤维',
      'ja': 'グラスファイバー'
    }, {
      'id': 'FieldCampfireStew',
      'en': 'Field Campfire Stew',
      'fr': 'Ragoût de feu de camp',
      'es': 'Estofado de fogata de campo',
      'de': 'Eintopf am Lagerfeuer',
      'pl': 'Gulasz z Ogniska Polowego',
      'ru': 'Похлебка на полевом костре',
      'uk': 'Тушковане польове багаття',
      'ko': '필드 캠프파이어 스튜',
      'zh': '野营火炖菜',
      'ja': 'フィールドキャンプファイヤーシチュー'
    }, {
      'id': 'FireweedSeed',
      'en': 'Fireweed Seed',
      'fr': 'Graine d\u0027épilobe',
      'es': 'Semilla de hierba de fuego',
      'de': 'Fireweed-Samen',
      'pl': 'Nasiona Fireweed',
      'ru': 'Семя кипрея',
      'uk': 'Насіння вогневого водоросту',
      'ko': '파이어위드 씨',
      'zh': '杂草种子',
      'ja': 'ファイアウィードシード'
    }, {
      'id': 'FishNChips',
      'en': 'Fish N Chips',
      'fr': 'Poisson et frites',
      'es': 'Pescado y patatas fritas',
      'de': 'Fisch und Pommes',
      'pl': 'Ryba z frytkami',
      'ru': 'Рыба и чипсы',
      'uk': 'Фіш-н-чіпси',
      'ko': '피쉬앤칩스',
      'zh': '炸鱼薯条',
      'ja': 'フィッシュアンドチップス'
    }, {
      'id': 'FishTrap',
      'en': 'Fish Trap',
      'fr': 'Piège à poisson',
      'es': 'Trampa para peces',
      'de': 'Fischfalle',
      'pl': 'Pułapka na ryby',
      'ru': 'Рыбная ловушка',
      'uk': 'Пастка для риби',
      'ko': '물고기 덫',
      'zh': '捕鱼器',
      'ja': 'フィッシュトラップ'
    }, {
      'id': 'Fishery',
      'en': 'Fishery',
      'fr': 'Pêcherie',
      'es': 'Pesquería',
      'de': 'Fischerei',
      'pl': 'Rybołówstwo',
      'ru': 'Рыболовство',
      'uk': 'Рибальство',
      'ko': '어업',
      'zh': '渔业',
      'ja': '水産'
    }, {
      'id': 'FlatSteelDoor',
      'en': 'Flat Steel Door',
      'fr': 'Porte en acier plat',
      'es': 'Puerta de acero plana',
      'de': 'Flache Stahltür',
      'pl': 'Płaskie drzwi stalowe',
      'ru': 'Плоская стальная дверь',
      'uk': 'Плоскі сталеві двері',
      'ko': '플랫 스틸 도어',
      'zh': '扁钢门',
      'ja': 'フラットスチールドア'
    }, {
      'id': 'FlatSteel',
      'en': 'Flat Steel',
      'fr': 'Acier plat',
      'es': 'Acero plano',
      'de': 'Flachstahl',
      'pl': 'Płaska stal',
      'ru': 'Плоская сталь',
      'uk': 'Плоска сталь',
      'ko': '플랫 스틸',
      'zh': '扁钢',
      'ja': '平鋼'
    }, {
      'id': 'Flatbread',
      'en': 'Flatbread',
      'fr': 'Galette',
      'es': 'Pan plano',
      'de': 'Fladenbrot',
      'pl': 'Podpłomyk',
      'ru': 'Лепешка',
      'uk': 'лепешки',
      'ko': '플랫브레드',
      'zh': '大饼',
      'ja': 'フラットブレッド'
    }, {
      'id': 'Flour',
      'en': 'Flour',
      'fr': 'Farine',
      'es': 'Harina',
      'de': 'Mehl',
      'pl': 'Mąka',
      'ru': 'Мука',
      'uk': 'Борошно',
      'ko': '밀가루',
      'zh': '面粉',
      'ja': '小麦粉'
    }, {
      'id': 'FramedGlassDoor',
      'en': 'Framed Glass Door',
      'fr': 'Porte en verre encadrée',
      'es': 'puerta de vidrio enmarcada',
      'de': 'Gerahmte Glastür',
      'pl': 'Oprawione szklane drzwi',
      'ru': 'Стеклянная дверь в рамке',
      'uk': 'Скляні двері в рамці',
      'ko': '액자 유리 도어',
      'zh': '框架玻璃门',
      'ja': '額入りガラスドア'
    }, {
      'id': 'FramedGlass',
      'en': 'Framed Glass',
      'fr': 'Verre encadré',
      'es': 'Vidrio enmarcado',
      'de': 'Gerahmtes Glas',
      'pl': 'Oprawione szkło',
      'ru': 'Стекло в рамке',
      'uk': 'Скло в рамці',
      'ko': '액자 유리',
      'zh': '框架玻璃',
      'ja': '額入りガラス'
    }, {
      'id': 'FriedCamas',
      'en': 'Fried Camas',
      'fr': 'Camas frits',
      'es': 'Camas Fritas',
      'de': 'Gebratene Camas',
      'pl': 'smażone kamasze',
      'ru': 'Жареный Камас',
      'uk': 'Смажений Камас',
      'ko': '튀긴 카마스',
      'zh': '炸卡马斯',
      'ja': '揚げキャマス'
    }, {
      'id': 'FriedFiddleheads',
      'en': 'Fried Fiddleheads',
      'fr': 'Têtes de violon frites',
      'es': 'Cabezas de violín fritas',
      'de': 'Gebratene Fiddleheads',
      'pl': 'Smażone Fiddleheads',
      'ru': 'Жареные Фиддлхеды',
      'uk': 'Смажені Фіддлхеси',
      'ko': '튀긴 피들 헤드',
      'zh': '炸蕨菜',
      'ja': '揚げ渦巻き状若葉'
    }, {
      'id': 'FriedHareHaunches',
      'en': 'Fried Hare Haunches',
      'fr': 'Cuissots de lièvre frits',
      'es': 'Ancas de liebre fritas',
      'de': 'Gebratene Hasenkeulen',
      'pl': 'Smażony Udziec Zająca',
      'ru': 'Жареные заячьи бедра',
      'uk': 'Смажені заячі горби',
      'ko': '튀긴 토끼',
      'zh': '炸兔腿',
      'ja': 'フライドヘアハンチ'
    }, {
      'id': 'FriedHeartsOfPalm',
      'en': 'Fried Hearts Of Palm',
      'fr': 'Coeurs de palmier frits',
      'es': 'Corazones De Palm Fritos',
      'de': 'Gebratene Palmenherzen',
      'pl': 'Smażone Serca Palmowe',
      'ru': 'Жареные сердца пальмы',
      'uk': 'Смажені пальмові серця',
      'ko': '튀긴 하트 오브 팜',
      'zh': '油炸棕榈心',
      'ja': '手のひらの揚げハート'
    }, {
      'id': 'FriedTaro',
      'en': 'Fried Taro',
      'fr': 'Taro frit',
      'es': 'Taro Frito',
      'de': 'Gebratener Taro',
      'pl': 'Smażony Taro',
      'ru': 'Жареное Таро',
      'uk': 'Смажене Таро',
      'ko': '튀긴 타로',
      'zh': '炸芋头',
      'ja': '揚げ太郎'
    }, {
      'id': 'FriedTomatoes',
      'en': 'Fried Tomatoes',
      'fr': 'Tomates Frites',
      'es': 'tomates fritos',
      'de': 'Gebratene Tomaten',
      'pl': 'Smażone Pomidory',
      'ru': 'Жареные помидоры',
      'uk': 'Смажені помідори',
      'ko': '튀긴 토마토',
      'zh': '炸番茄',
      'ja': '揚げトマト'
    }, {
      'id': 'FrothFloatationCell',
      'en': 'Froth Floatation Cell',
      'fr': 'Cellule de flottation de mousse',
      'es': 'Celda de flotación de espuma',
      'de': 'Schaumflotationszelle',
      'pl': 'Komórka flotacyjna piany',
      'ru': 'Ячейка пенной флотации',
      'uk': 'Піна флотаційна комірка',
      'ko': '거품 부유 셀',
      'zh': '泡沫浮选池',
      'ja': '泡浮選セル'
    }, {
      'id': 'FruitMuffin',
      'en': 'Fruit Muffin',
      'fr': 'Muffin aux fruits',
      'es': 'Magdalena de frutas',
      'de': 'Frucht-Muffin',
      'pl': 'babeczka owocowa',
      'ru': 'Фруктовый кекс',
      'uk': 'Фруктовий мафін',
      'ko': '과일 머핀',
      'zh': '水果松饼',
      'ja': 'フルーツマフィン'
    }, {
      'id': 'ExoticFruitSalad',
      'en': 'Exotic Fruit Salad',
      'fr': 'Salade de fruits exotiques',
      'es': 'Ensalada De Frutas Exóticas',
      'de': 'Exotischer Obstsalat',
      'pl': 'Sałatka z Egzotycznych Owoców',
      'ru': 'Экзотический фруктовый салат',
      'uk': 'Екзотичний фруктовий салат',
      'ko': '이국적인 과일 샐러드',
      'zh': '异国水果沙拉',
      'ja': 'エキゾチックなフルーツサラダ'
    }, {
      'id': 'MixedFruitSalad',
      'en': 'Mixed Fruit Salad',
      'fr': 'Salade de fruits mélangés',
      'es': 'Ensalada De Frutas Mixtas',
      'de': 'Gemischter Obstsalat',
      'pl': 'Sałatka Z Mieszanych Owoców',
      'ru': 'Смешанный фруктовый салат',
      'uk': 'Змішаний фруктовий салат',
      'ko': '혼합 과일 샐러드',
      'zh': '什锦水果沙拉',
      'ja': 'ミックスフルーツサラダ'
    }, {
      'id': 'RainforestFruitSalad',
      'en': 'Rainforest Fruit Salad',
      'fr': 'Salade de fruits de la forêt tropicale',
      'es': 'Ensalada De Frutas De La Selva',
      'de': 'Regenwald-Obstsalat',
      'pl': 'Sałatka Owocowa z Lasu Deszczowego',
      'ru': 'Фруктовый салат из тропических лесов',
      'uk': 'Фруктовий салат Rainforest',
      'ko': '열대우림 과일 샐러드',
      'zh': '雨林水果沙拉',
      'ja': '熱帯雨林のフルーツサラダ'
    }, {
      'id': 'FruitTart',
      'en': 'Fruit Tart',
      'fr': 'Tarte aux fruits',
      'es': 'Pastel de fruta',
      'de': 'Obstkuchen',
      'pl': 'tarta owocowa',
      'ru': 'Фруктовый пирог',
      'uk': 'Фруктовий тарт',
      'ko': '과일 타르트',
      'zh': '水果挞',
      'ja': 'フルーツタルト'
    }, {
      'id': 'GardenBoots',
      'en': 'Garden Boots',
      'fr': 'Bottes de jardin',
      'es': 'Botas de jardín',
      'de': 'Gartenstiefel',
      'pl': 'Buty ogrodowe',
      'ru': 'Садовые сапоги',
      'uk': 'Садові чоботи',
      'ko': '가든 부츠',
      'zh': '花园靴',
      'ja': 'ガーデンブーツ'
    }, {
      'id': 'Gasoline',
      'en': 'Gasoline',
      'fr': 'De l\u0027essence',
      'es': 'Gasolina',
      'de': 'Benzin',
      'pl': 'Benzyna',
      'ru': 'Бензин',
      'uk': 'Бензин',
      'ko': '가솔린',
      'zh': '汽油',
      'ja': 'ガソリン'
    }, {
      'id': 'GatheringResearchPaperBasic',
      'en': 'Gathering Research Paper Basic',
      'fr': 'Collecte de documents de recherche de base',
      'es': 'Recopilación de trabajos de investigación básicos',
      'de': 'Sammeln von Forschungspapieren Basic',
      'pl': 'Zbieranie podstawowego papieru badawczego',
      'ru': 'Сбор исследовательской работы Базовый',
      'uk': 'Збір наукової роботи Basic',
      'ko': '연구논문 기초수집',
      'zh': '收集研究论文基础',
      'ja': '研究論文の基本'
    }, {
      'id': 'Gearbox',
      'en': 'Gearbox',
      'fr': 'Boîte de vitesses',
      'es': 'Caja de cambios',
      'de': 'Getriebe',
      'pl': 'Skrzynia biegów',
      'ru': 'Коробка передач',
      'uk': 'Коробка передач',
      'ko': '변속 장치',
      'zh': '变速箱',
      'ja': 'ギアボックス'
    }, {
      'id': 'GeologyResearchPaperAdvanced',
      'en': 'Geology Research Paper Advanced',
      'fr': 'Document de recherche en géologie avancé',
      'es': 'Trabajo de investigación de geología avanzada',
      'de': 'Geologisches Forschungspapier für Fortgeschrittene',
      'pl': 'Zaawansowany artykuł badawczy z zakresu geologii',
      'ru': 'Исследовательская работа по геологии Advanced',
      'uk': 'Геологічна наукова робота Advanced',
      'ko': '지질학 연구 논문 고급',
      'zh': '地质研究论文高级',
      'ja': '地質学研究論文Advanced'
    }, {
      'id': 'GeologyResearchPaperBasic',
      'en': 'Geology Research Paper Basic',
      'fr': 'Document de recherche en géologie de base',
      'es': 'Trabajo de investigación de geología básico',
      'de': 'Geologisches Forschungspapier Basic',
      'pl': 'Podstawowy artykuł badawczy z geologii',
      'ru': 'Базовая исследовательская работа по геологии',
      'uk': 'Геологічна наукова робота Basic',
      'ko': '지질학 연구논문 기초',
      'zh': '地质研究论文基础',
      'ja': '地質学研究論文基本'
    }, {
      'id': 'GeologyResearchPaperModern',
      'en': 'Geology Research Paper Modern',
      'fr': 'Document de recherche en géologie moderne',
      'es': 'Papel de investigación de geología moderno',
      'de': 'Geologische Forschungsarbeit Modern',
      'pl': 'Współczesna praca naukowa z zakresu geologii',
      'ru': 'Геологическая исследовательская работа Модерн',
      'uk': 'Наукова робота з геології Сучасний',
      'ko': '지질학 연구 논문 현대',
      'zh': '地质研究论文现代',
      'ja': '地質学研究論文モダン'
    }, {
      'id': 'GigotSleeveShirt',
      'en': 'Gigot Sleeve Shirt',
      'fr': 'Chemise à manches Gigot',
      'es': 'Camisa de manga Gigot',
      'de': 'Hemd mit Gigot-Ärmeln',
      'pl': 'Koszula z rękawami Gigot',
      'ru': 'Рубашка с рукавами Gigot',
      'uk': 'Сорочка з рукавом Gigot',
      'ko': '지고트 슬리브 셔츠',
      'zh': 'Gigot 袖衬衫',
      'ja': 'ギゴットスリーブシャツ'
    }, {
      'id': 'Glass',
      'en': 'Glass',
      'fr': 'Verre',
      'es': 'Vidrio',
      'de': 'Glas',
      'pl': 'Szkło',
      'ru': 'Стакан',
      'uk': 'Скло',
      'ko': '유리',
      'zh': '玻璃',
      'ja': 'ガラス'
    }, {
      'id': 'GlassworkingAdvancedUpgrade',
      'en': 'Glassworking Advanced Upgrade',
      'fr': 'Mise à niveau avancée du travail du verre',
      'es': 'Actualización avanzada de cristalería',
      'de': 'Erweitertes Upgrade für die Glasbearbeitung',
      'pl': 'Zaawansowana modernizacja obróbki szkła',
      'ru': 'Расширенное обновление стеклообработки',
      'uk': 'Розширене оновлення скла',
      'ko': '유리세공 고급 업그레이드',
      'zh': '玻璃加工高级升级',
      'ja': 'Glassworking Advanced Upgrade'
    }, {
      'id': 'GlassworkingModernUpgrade',
      'en': 'Glassworking Modern Upgrade',
      'fr': 'Mise à niveau moderne du travail du verre',
      'es': 'Actualización moderna de cristalería',
      'de': 'Glasverarbeitung Modernes Upgrade',
      'pl': 'Nowoczesna modernizacja obróbki szkła',
      'ru': 'Стеклообработка Современное обновление',
      'uk': 'Сучасне оновлення склообробки',
      'ko': '유리세공 모던 업그레이드',
      'zh': '玻璃加工现代升级',
      'ja': 'Glassworkingモダンアップグレード'
    }, {
      'id': 'GoatMount',
      'en': 'Goat Mount',
      'fr': 'Monture de chèvre',
      'es': 'Monte Cabra',
      'de': 'Ziegenberg',
      'pl': 'Koza Góra',
      'ru': 'Козья гора',
      'uk': 'Козячий гора',
      'ko': '염소 산',
      'zh': '山羊山',
      'ja': 'ヤギの山'
    }, {
      'id': 'GoldBar',
      'en': 'Gold Bar',
      'fr': 'Lingot d\u0027or',
      'es': 'Barra de oro',
      'de': 'Goldbarren',
      'pl': 'Sztabka złota',
      'ru': 'Золотой слиток',
      'uk': 'Золотий бар',
      'ko': '골드 바',
      'zh': '金条',
      'ja': 'ゴールドバー'
    }, {
      'id': 'SmeltGold',
      'en': 'Smelt Gold',
      'fr': 'Faire fondre l\u0027or',
      'es': 'oro fundido',
      'de': 'Gold schmelzen',
      'pl': 'Pachniał złotem',
      'ru': 'Плавить золото',
      'uk': 'Виплавка золота',
      'ko': '제련 금',
      'zh': '熔炼黄金',
      'ja': '製錬金'
    }, {
      'id': 'ConcentrateGoldLv2',
      'en': 'Concentrate Gold Lv2',
      'fr': 'Concentré d\u0027or Lv2',
      'es': 'Concentrado Oro Lv2',
      'de': 'Konzentrat Gold Lv2',
      'pl': 'Koncentrat Złoto Lv2',
      'ru': 'Концентрат золота Lv2',
      'uk': 'Золотий концентрат Lv2',
      'ko': '컨센트레이트 골드 Lv2',
      'zh': '集中金 Lv2',
      'ja': 'コンセントレートゴールドLv2'
    }, {
      'id': 'GoldConcentrate',
      'en': 'Gold Concentrate',
      'fr': 'Concentré d\u0027or',
      'es': 'concentrado de oro',
      'de': 'Goldkonzentrat',
      'pl': 'Złoty Koncentrat',
      'ru': 'Золотой концентрат',
      'uk': 'Золотий концентрат',
      'ko': '금 농축액',
      'zh': '金精矿',
      'ja': '金精鉱'
    }, {
      'id': 'GoldFlakes',
      'en': 'Gold Flakes',
      'fr': 'Paillettes d\u0027or',
      'es': 'Copos de oro',
      'de': 'Goldflocken',
      'pl': 'Złote płatki',
      'ru': 'Золотые хлопья',
      'uk': 'Золоті пластівці',
      'ko': '골드 플레이크',
      'zh': '金箔',
      'ja': 'ゴールドフレーク'
    }, {
      'id': 'GoldWiring',
      'en': 'Gold Wiring',
      'fr': 'Câblage doré',
      'es': 'Cableado de oro',
      'de': 'Goldverdrahtung',
      'pl': 'Złote okablowanie',
      'ru': 'Золотая проводка',
      'uk': 'Золота проводка',
      'ko': '금 배선',
      'zh': '金线',
      'ja': 'ゴールド配線'
    }, {
      'id': 'HandPlow',
      'en': 'Hand Plow',
      'fr': 'Charrue à main',
      'es': 'Arado de mano',
      'de': 'Handpflug',
      'pl': 'Pług ręczny',
      'ru': 'Ручной плуг',
      'uk': 'Ручний плуг',
      'ko': '손 쟁기',
      'zh': '手犁',
      'ja': 'ハンドプラウ'
    }, {
      'id': 'HangingLongSteelSign',
      'en': 'Hanging Long Steel Sign',
      'fr': 'Long signe en acier suspendu',
      'es': 'Letrero colgante de acero largo',
      'de': 'Hängendes langes Stahlschild',
      'pl': 'Wiszący długi znak ze stali',
      'ru': 'Подвесной длинный стальной знак',
      'uk': 'Висяча довга сталь знак',
      'ko': '교수형 긴 강철 기호',
      'zh': '悬挂长钢标志',
      'ja': '長い鋼の看板をぶら下げ'
    }, {
      'id': 'HangingSteelFramedSign',
      'en': 'Hanging Steel Framed Sign',
      'fr': 'Enseigne suspendue en acier',
      'es': 'Letrero colgante con marco de acero',
      'de': 'Schild zum Aufhängen mit Stahlrahmen',
      'pl': 'Wiszący znak ze stalową ramą',
      'ru': 'Подвесной стальной каркасный знак',
      'uk': 'Висячі сталевий каркас знак',
      'ko': '교수형 강철 액자 기호',
      'zh': '悬挂钢架标志',
      'ja': 'ぶら下げ鉄骨看板'
    }, {
      'id': 'HangingSteelMineSign',
      'en': 'Hanging Steel Mine Sign',
      'fr': 'Signe de mine d\u0027acier suspendu',
      'es': 'Letrero colgante de mina de acero',
      'de': 'Hängendes Stahlbergwerk-Schild',
      'pl': 'Wiszący znak kopalni stali',
      'ru': 'Подвесной стальной знак шахты',
      'uk': 'Знак висячої сталі міни',
      'ko': '교수형 철강 광산 기호',
      'zh': '悬挂钢矿标志',
      'ja': 'ぶら下がっている鋼鉱山の看板'
    }, {
      'id': 'HangingSteelPlainSign',
      'en': 'Hanging Steel Plain Sign',
      'fr': 'Signe uni en acier suspendu',
      'es': 'Letrero simple de acero colgante',
      'de': 'Schild zum Aufhängen aus Stahl',
      'pl': 'Wiszący zwykły znak ze stali',
      'ru': 'Подвесной стальной простой знак',
      'uk': 'Висячі сталевий простий знак',
      'ko': '교수형 강철 일반 기호',
      'zh': '挂钢平原标志',
      'ja': 'ぶら下がっている鋼のプレーンサイン'
    }, {
      'id': 'HangingSteelShopSign',
      'en': 'Hanging Steel Shop Sign',
      'fr': 'Enseigne de magasin en acier suspendue',
      'es': 'Letrero de tienda de acero colgante',
      'de': 'Hängendes Ladenschild aus Stahl',
      'pl': 'Wiszący znak sklepu ze stali',
      'ru': 'Висячий стальной знак магазина',
      'uk': 'Висить сталевий магазин знак',
      'ko': '교수형 철강 상점 기호',
      'zh': '挂钢店招牌',
      'ja': 'ぶら下がっている鉄鋼店の看板'
    }, {
      'id': 'HeartyHometownPizza',
      'en': 'Hearty Hometown Pizza',
      'fr': 'Pizza copieuse de la ville natale',
      'es': 'Pizza abundante de la ciudad natal',
      'de': 'Herzhafte Pizza aus der Heimatstadt',
      'pl': 'Obfita rodzinna pizza',
      'ru': 'Сытная пицца в родном городе',
      'uk': 'Сердечна піца рідного міста',
      'ko': '푸짐한 고향 피자',
      'zh': '丰盛的家乡披萨',
      'ja': '心のこもった故郷のピザ'
    }, {
      'id': 'HeatSink',
      'en': 'Heat Sink',
      'fr': 'Dissipateur de chaleur',
      'es': 'Disipador de calor',
      'de': 'Kühlkörper',
      'pl': 'Radiator',
      'ru': 'Радиатор',
      'uk': 'Тепловідвід',
      'ko': '방열판',
      'zh': '散热器',
      'ja': 'ヒートシンク'
    }, {
      'id': 'Henley',
      'en': 'Henley',
      'fr': 'Henley',
      'es': 'henley',
      'de': 'Henley',
      'pl': 'Henley',
      'ru': 'Хенли',
      'uk': 'Хенлі',
      'ko': '헨리',
      'zh': '亨利',
      'ja': 'ヘンリー'
    }, {
      'id': 'HewnBench',
      'en': 'Hewn Bench',
      'fr': 'Banc taillé',
      'es': 'banco tallado',
      'de': 'Behauene Bank',
      'pl': 'Ciosana Ławka',
      'ru': 'Тесаная скамейка',
      'uk': 'Тесана лава',
      'ko': '깎은 벤치',
      'zh': '凿好的长凳',
      'ja': '切りっぱなしのベンチ'
    }, {
      'id': 'HewnChair',
      'en': 'Hewn Chair',
      'fr': 'Chaise taillée',
      'es': 'silla tallada',
      'de': 'Behauener Stuhl',
      'pl': 'Ciosane krzesło',
      'ru': 'Тесаный стул',
      'uk': 'Тесаний стілець',
      'ko': '깎은 의자',
      'zh': '椅子',
      'ja': '切りっぱなしの椅子'
    }, {
      'id': 'HewnDoor',
      'en': 'Hewn Door',
      'fr': 'Porte taillée',
      'es': 'puerta tallada',
      'de': 'Behauene Tür',
      'pl': 'Ociosane drzwi',
      'ru': 'Высеченная дверь',
      'uk': 'Тесані двері',
      'ko': '깎은 문',
      'zh': '凿门',
      'ja': '切りっぱなしのドア'
    }, {
      'id': 'HewnDresser',
      'en': 'Hewn Dresser',
      'fr': 'Commode taillée',
      'es': 'Cómoda tallada',
      'de': 'Behauene Kommode',
      'pl': 'Ciosy Kredens',
      'ru': 'Тесаный комод',
      'uk': 'Тесаний комод',
      'ko': '손질한 드레서',
      'zh': '修整梳妆台',
      'ja': '切りっぱなしドレッサー'
    }, {
      'id': 'HewnLogs',
      'en': 'Hewn Logs',
      'fr': 'Grumes taillées',
      'es': 'Troncos tallados',
      'de': 'Behauene Protokolle',
      'pl': 'Ciosane kłody',
      'ru': 'Тесаные бревна',
      'uk': 'Тесані колоди',
      'ko': '깎은 통나무',
      'zh': '砍伐原木',
      'ja': '切りっぱなしのログ'
    }, {
      'id': 'HewnNightstand',
      'en': 'Hewn Nightstand',
      'fr': 'Table de chevet taillée',
      'es': 'Mesita de noche tallada',
      'de': 'Behauener Nachttisch',
      'pl': 'Ciosana szafka nocna',
      'ru': 'Тесаная тумбочка',
      'uk': 'Тесана тумбочка',
      'ko': '깎은 협탁',
      'zh': '凿好的床头柜',
      'ja': '切りっぱなしのナイトスタンド'
    }, {
      'id': 'HewnTable',
      'en': 'Hewn Table',
      'fr': 'Table taillée',
      'es': 'Mesa tallada',
      'de': 'Behauener Tisch',
      'pl': 'Ciosany stół',
      'ru': 'Тесаный стол',
      'uk': 'Тесаний стіл',
      'ko': '깎은 테이블',
      'zh': '凿好的桌子',
      'ja': '切りっぱなしのテーブル'
    }, {
      'id': 'HideAshFertilizer',
      'en': 'Hide Ash Fertilizer',
      'fr': 'Masquer l\u0027engrais de cendres',
      'es': 'Ocultar fertilizante de cenizas',
      'de': 'Aschedünger verstecken',
      'pl': 'Ukryj nawóz popiołowy',
      'ru': 'Скрыть удобрение золы',
      'uk': 'Сховати золу добрива',
      'ko': '재 비료 숨기기',
      'zh': '皮灰肥',
      'ja': '灰肥料を隠す'
    }, {
      'id': 'Hosomaki',
      'en': 'Hosomaki',
      'fr': 'Hosomaki',
      'es': 'Hosomaki',
      'de': 'Hosomaki',
      'pl': 'Hosomaki',
      'ru': 'Хосомаки',
      'uk': 'Хосомакі',
      'ko': '호소마키',
      'zh': '细卷',
      'ja': '細巻'
    }, {
      'id': 'HuckleberryExtract',
      'en': 'Huckleberry Extract',
      'fr': 'Extrait de myrtille',
      'es': 'Extracto de arándano',
      'de': 'Heidelbeerextrakt',
      'pl': 'Ekstrakt z Borówki',
      'ru': 'Экстракт черники',
      'uk': 'Екстракт Гекльберрі',
      'ko': '허클베리 추출물',
      'zh': '越橘提取物',
      'ja': 'ハックルベリーエキス'
    }, {
      'id': 'HuckleberryFritter',
      'en': 'Huckleberry Fritter',
      'fr': 'Beignet aux myrtilles',
      'es': 'buñuelo de arándanos',
      'de': 'Heidelbeer-Fritte',
      'pl': 'Placki z Huckleberry',
      'ru': 'Гекльберри оладьи',
      'uk': 'Оладка Гекльберрі',
      'ko': '허클베리 튀김',
      'zh': '哈克贝利油条',
      'ja': 'ハックルベリーフリッター'
    }, {
      'id': 'HuckleberryPie',
      'en': 'Huckleberry Pie',
      'fr': 'Tarte aux myrtilles',
      'es': 'Pastel de arándanos',
      'de': 'Heidelbeerkuchen',
      'pl': 'Ciasto Huckleberry',
      'ru': 'Гекльберри пирог',
      'uk': 'Пиріг Гекльберрі',
      'ko': '허클베리 파이',
      'zh': '哈克贝利派',
      'ja': 'ハックルベリーパイ'
    }, {
      'id': 'HuckleberrySeed',
      'en': 'Huckleberry Seed',
      'fr': 'Graine de myrtille',
      'es': 'Semilla de arándano',
      'de': 'Heidelbeersamen',
      'pl': 'Nasiona Huckleberry',
      'ru': 'Семя Гекльберри',
      'uk': 'Насіння гекльберрі',
      'ko': '허클베리 씨',
      'zh': '越橘种子',
      'ja': 'ハックベリーシード'
    }, {
      'id': 'Hydrocolloids',
      'en': 'Hydrocolloids',
      'fr': 'Hydrocolloïdes',
      'es': 'hidrocoloides',
      'de': 'Hydrokolloide',
      'pl': 'hydrokoloidy',
      'ru': 'Гидроколлоиды',
      'uk': 'Гідроколоїди',
      'ko': '하이드로콜로이드',
      'zh': '水胶体',
      'ja': '親水コロイド'
    }, {
      'id': 'RefineFish',
      'en': 'Refine Fish',
      'fr': 'Affiner le poisson',
      'es': 'Pescado refinado',
      'de': 'Fisch verfeinern',
      'pl': 'Udoskonal ryby',
      'ru': 'Уточнить рыбу',
      'uk': 'Очищення риби',
      'ko': '생선 정제',
      'zh': '精制鱼',
      'ja': '魚を精製する'
    }, {
      'id': 'RefineKelp',
      'en': 'Refine Kelp',
      'fr': 'Affiner le varech',
      'es': 'Refinar algas',
      'de': 'Seetang verfeinern',
      'pl': 'Udoskonal wodorosty',
      'ru': 'Уточнить водоросли',
      'uk': 'Очищення ламінарії',
      'ko': '다시마 정제',
      'zh': '精制海带',
      'ja': '昆布を精製する'
    }, {
      'id': 'RefineMeat',
      'en': 'Refine Meat',
      'fr': 'Affiner la viande',
      'es': 'Carne refinada',
      'de': 'Fleisch verfeinern',
      'pl': 'Uszlachetnianie mięsa',
      'ru': 'Очищение мяса',
      'uk': 'Очищення м\u0027яса',
      'ko': '정련 고기',
      'zh': '精制肉类',
      'ja': '肉を精製する'
    }, {
      'id': 'Icebox',
      'en': 'Icebox',
      'fr': 'Glacière',
      'es': 'Nevera',
      'de': 'Eisfach',
      'pl': 'Lodówka',
      'ru': 'Холодильник',
      'uk': 'Icebox',
      'ko': '아이스박스',
      'zh': '冰箱',
      'ja': 'アイスボックス'
    }, {
      'id': 'IndustrialElevator',
      'en': 'Industrial Elevator',
      'fr': 'Ascenseur industriel',
      'es': 'Ascensor Industrial',
      'de': 'Industrieller Aufzug',
      'pl': 'Winda przemysłowa',
      'ru': 'Промышленный лифт',
      'uk': 'Промисловий ліфт',
      'ko': '산업용 엘리베이터',
      'zh': '工业电梯',
      'ja': '産業用エレベーター'
    }, {
      'id': 'IndustryUpgrade',
      'en': 'Industry Upgrade',
      'fr': 'Mise à niveau de l\u0027industrie',
      'es': 'Actualización de la industria',
      'de': 'Industrie-Upgrade',
      'pl': 'Modernizacja przemysłu',
      'ru': 'Обновление отрасли',
      'uk': 'Оновлення промисловості',
      'ko': '산업 업그레이드',
      'zh': '产业升级',
      'ja': '業界のアップグレード'
    }, {
      'id': 'InfusedOil',
      'en': 'Infused Oil',
      'fr': 'Huile infusée',
      'es': 'Aceite infundido',
      'de': 'Infundiertes Öl',
      'pl': 'Olej w parze',
      'ru': 'Настоянное масло',
      'uk': 'Настояне масло',
      'ko': '주입 오일',
      'zh': '注入油',
      'ja': '注入オイル'
    }, {
      'id': 'IronAxe',
      'en': 'Iron Axe',
      'fr': 'Hache de fer',
      'es': 'hacha de hierro',
      'de': 'Eiserne Axt',
      'pl': 'Żelazny Topór',
      'ru': 'Железный топор',
      'uk': 'Залізна сокира',
      'ko': '철 도끼',
      'zh': '铁斧',
      'ja': '鉄の斧'
    }, {
      'id': 'IronAxle',
      'en': 'Iron Axle',
      'fr': 'Essieu en fer',
      'es': 'Eje de hierro',
      'de': 'Eiserne Achse',
      'pl': 'Żelazna oś',
      'ru': 'Железная ось',
      'uk': 'Залізна вісь',
      'ko': '아이언 액슬',
      'zh': '铁轴',
      'ja': 'アイアンアクスル'
    }, {
      'id': 'IronBar',
      'en': 'Iron Bar',
      'fr': 'Barre de fer',
      'es': 'Barra de acero',
      'de': 'Eisenstange',
      'pl': 'Żelazna sztabka',
      'ru': 'Железный слиток',
      'uk': 'Залізний злиток',
      'ko': '철괴',
      'zh': '铁条',
      'ja': '鉄棒'
    }, {
      'id': 'SmeltIron',
      'en': 'Smelt Iron',
      'fr': 'Faire fondre le fer',
      'es': 'hierro fundido',
      'de': 'Eisen schmelzen',
      'pl': 'Wytop żelazo',
      'ru': 'Плавить железо',
      'uk': 'Виплавка заліза',
      'ko': '제련',
      'zh': '冶炼铁',
      'ja': '製錬鉄'
    }, {
      'id': 'ConcentrateDryIron',
      'en': 'Concentrate Dry Iron',
      'fr': 'Fer à repasser concentré',
      'es': 'Hierro Seco Concentrado',
      'de': 'Konzentrat Trockenbügeln',
      'pl': 'Skoncentruj suche żelazko',
      'ru': 'Концентрат сухого железа',
      'uk': 'Концентрат сухого заліза',
      'ko': '농축 건조 다리미',
      'zh': '浓缩干铁',
      'ja': 'ドライアイロンを濃縮する'
    }, {
      'id': 'ConcentrateDryIronLv2',
      'en': 'Concentrate Dry Iron Lv2',
      'fr': 'Fer sec concentré Lv2',
      'es': 'Hierro Seco Concentrado Lv2',
      'de': 'Konzentrat Trockenbügeln Lv2',
      'pl': 'Koncentrat suchego żelaza Lv2',
      'ru': 'Концентрат сухого железа Lv2',
      'uk': 'Концентрат сухого заліза Lv2',
      'ko': '농축 건조철 Lv2',
      'zh': '浓缩干铁 Lv2',
      'ja': '濃縮ドライアイロンLv2'
    }, {
      'id': 'ConcentrateIronLv2',
      'en': 'Concentrate Iron Lv2',
      'fr': 'Fer concentré Lv2',
      'es': 'Hierro concentrado Lv2',
      'de': 'Konzentrat Eisen Lv2',
      'pl': 'Koncentrat żelaza Lv2',
      'ru': 'Концентрат железа Lv2',
      'uk': 'Концентрат заліза Lv2',
      'ko': '농축철 Lv2',
      'zh': '精铁 Lv2',
      'ja': '濃縮鉄Lv2'
    }, {
      'id': 'IronConcentrate',
      'en': 'Iron Concentrate',
      'fr': 'Concentré de fer',
      'es': 'concentrado de hierro',
      'de': 'Eisenkonzentrat',
      'pl': 'Koncentrat żelaza',
      'ru': 'Концентрат железа',
      'uk': 'Концентрат заліза',
      'ko': '철 농축액',
      'zh': '铁精矿',
      'ja': '鉄精鉱'
    }, {
      'id': 'IronGear',
      'en': 'Iron Gear',
      'fr': 'Engrenage de fer',
      'es': 'Engranaje de hierro',
      'de': 'Eisenzahnrad',
      'pl': 'Żelazny sprzęt',
      'ru': 'Железная шестерня',
      'uk': 'Iron Gear',
      'ko': '아이언 기어',
      'zh': '铁齿轮',
      'ja': 'アイアンギア'
    }, {
      'id': 'IronHammer',
      'en': 'Iron Hammer',
      'fr': 'Marteau de fer',
      'es': 'Martillo de hierro',
      'de': 'Eiserner Hammer',
      'pl': 'Żelazny Młot',
      'ru': 'Железный молот',
      'uk': 'Залізний молот',
      'ko': '철 망치',
      'zh': '铁锤',
      'ja': 'アイアンハンマー'
    }, {
      'id': 'IronHoe',
      'en': 'Iron Hoe',
      'fr': 'Fer Houe',
      'es': 'Azada de hierro',
      'de': 'Eiserne Hacke',
      'pl': 'żelazna motyka',
      'ru': 'Железная мотыга',
      'uk': 'Залізна мотика',
      'ko': '아이언 괭이',
      'zh': '铁锄',
      'ja': 'アイアンホー'
    }, {
      'id': 'IronMachete',
      'en': 'Iron Machete',
      'fr': 'Machette en fer',
      'es': 'Machete de hierro',
      'de': 'Eiserne Machete',
      'pl': 'Żelazna maczeta',
      'ru': 'Железный мачете',
      'uk': 'Залізне мачете',
      'ko': '아이언 마체테',
      'zh': '铁砍刀',
      'ja': '鉄マチェーテ'
    }, {
      'id': 'IronPickaxe',
      'en': 'Iron Pickaxe',
      'fr': 'Pioche en fer',
      'es': 'Pico de hierro',
      'de': 'Eiserne Spitzhacke',
      'pl': 'Żelazny Kilof',
      'ru': 'Железная кирка',
      'uk': 'Залізна кирка',
      'ko': '철 곡괭이',
      'zh': '铁镐',
      'ja': '鉄のつるはし'
    }, {
      'id': 'IronPipe',
      'en': 'Iron Pipe',
      'fr': 'Tuyau de fer',
      'es': 'Tubería de hierro',
      'de': 'Eisenrohr',
      'pl': 'Żelazna rura',
      'ru': 'Железная труба',
      'uk': 'Залізна труба',
      'ko': '철 파이프',
      'zh': '铁管',
      'ja': '鉄パイプ'
    }, {
      'id': 'IronPlate',
      'en': 'Iron Plate',
      'fr': 'Plat en fer',
      'es': 'Placa de hierro',
      'de': 'Eisenplatte',
      'pl': 'Żelazny talerz',
      'ru': 'Железная пластина',
      'uk': 'Залізна плита',
      'ko': '철판',
      'zh': '铁板',
      'ja': '鉄板'
    }, {
      'id': 'IronRockDrill',
      'en': 'Iron Rock Drill',
      'fr': 'Perceuse à roche en fer',
      'es': 'Taladro de roca de hierro',
      'de': 'Iron Rock-Bohrer',
      'pl': 'Żelazna wiertarka do skał',
      'ru': 'Железная дрель',
      'uk': 'Залізна гірська дриль',
      'ko': '철 착암기',
      'zh': '铁凿岩机',
      'ja': 'アイアンロックドリル'
    }, {
      'id': 'IronSawBlade',
      'en': 'Iron Saw Blade',
      'fr': 'Lame de scie en fer',
      'es': 'hoja de sierra de hierro',
      'de': 'Sägeblatt aus Eisen',
      'pl': 'Żelazne ostrze piły',
      'ru': 'Железная пила',
      'uk': 'Залізна пилка',
      'ko': '철 톱날',
      'zh': '铁锯片',
      'ja': 'アイアンソーブレード'
    }, {
      'id': 'IronShovel',
      'en': 'Iron Shovel',
      'fr': 'Pelle en fer',
      'es': 'pala de hierro',
      'de': 'Eiserne Schaufel',
      'pl': 'Żelazna Łopata',
      'ru': 'Железная лопата',
      'uk': 'Залізна лопата',
      'ko': '철 삽',
      'zh': '铁锹',
      'ja': '鉄のシャベル'
    }, {
      'id': 'IronSickle',
      'en': 'Iron Sickle',
      'fr': 'Faucille de fer',
      'es': 'Hoz de hierro',
      'de': 'Eiserne Sichel',
      'pl': 'Żelazny Sierp',
      'ru': 'Железный серп',
      'uk': 'Залізний серп',
      'ko': '철 낫',
      'zh': '铁镰',
      'ja': 'アイアンシックル'
    }, {
      'id': 'IronWheel',
      'en': 'Iron Wheel',
      'fr': 'Roue de fer',
      'es': 'rueda de hierro',
      'de': 'Eisernes Rad',
      'pl': 'Żelazne koło',
      'ru': 'Железное колесо',
      'uk': 'Залізне колесо',
      'ko': '철 바퀴',
      'zh': '铁轮',
      'ja': 'アイアンホイール'
    }, {
      'id': 'JawCrusher',
      'en': 'Jaw Crusher',
      'fr': 'Concasseur à mâchoires',
      'es': 'Rompe mandíbulas',
      'de': 'Kieferbrecher',
      'pl': 'Miażdżyciel szczęk',
      'ru': 'Зубодробилка, мордоворот',
      'uk': 'Щекова дробарка',
      'ko': '조 크러셔',
      'zh': '颚式破碎机',
      'ja': 'ジョークラッシャー'
    }, {
      'id': 'JungleCampfireSalad',
      'en': 'Jungle Campfire Salad',
      'fr': 'Salade de feu de camp de la jungle',
      'es': 'Ensalada de fogata de la jungla',
      'de': 'Dschungel-Lagerfeuer-Salat',
      'pl': 'Sałatka z ogniska w dżungli',
      'ru': 'Салат у костра в джунглях',
      'uk': 'Салат з багаття в джунглях',
      'ko': '정글 캠프파이어 샐러드',
      'zh': '丛林营火沙拉',
      'ja': 'ジャングルキャンプファイヤーサラダ'
    }, {
      'id': 'JungleCampfireStew',
      'en': 'Jungle Campfire Stew',
      'fr': 'Ragoût de feu de camp dans la jungle',
      'es': 'Estofado de fogata en la jungla',
      'de': 'Eintopf am Lagerfeuer im Dschungel',
      'pl': 'Gulasz z ogniska w dżungli',
      'ru': 'Похлебка из джунглей у костра',
      'uk': 'Тушковане багаття в джунглях',
      'ko': '정글 캠프파이어 스튜',
      'zh': '丛林篝火炖菜',
      'ja': 'ジャングルキャンプファイヤーシチュー'
    }, {
      'id': 'KelpyCrabRoll',
      'en': 'Kelpy Crab Roll',
      'fr': 'Rouleau de crabe Kelpy',
      'es': 'Rollo de cangrejo Kelpy',
      'de': 'Kelpy Crab Roll',
      'pl': 'Krab Kelpy',
      'ru': 'Келпи Краб Ролл',
      'uk': 'Крабовий рулет Келпі',
      'ko': '켈피 크랩 롤',
      'zh': '海带蟹卷',
      'ja': 'ケルピークラブロール'
    }, {
      'id': 'Kiln',
      'en': 'Kiln',
      'fr': 'Four',
      'es': 'Horno',
      'de': 'Ofen',
      'pl': 'Suszarnia',
      'ru': 'печь',
      'uk': 'піч',
      'ko': '가마',
      'zh': '窑',
      'ja': '窯'
    }, {
      'id': 'Kitchen',
      'en': 'Kitchen',
      'fr': 'Cuisine',
      'es': 'Cocina',
      'de': 'Küche',
      'pl': 'Kuchnia',
      'ru': 'Кухня',
      'uk': 'Кухня',
      'ko': '주방',
      'zh': '厨房',
      'ja': 'キッチン'
    }, {
      'id': 'Laboratory',
      'en': 'Laboratory',
      'fr': 'Laboratoire',
      'es': 'Laboratorio',
      'de': 'Labor',
      'pl': 'Laboratorium',
      'ru': 'Лаборатория',
      'uk': 'лабораторія',
      'ko': '실혐실',
      'zh': '实验室',
      'ja': 'ラボ'
    }, {
      'id': 'LargeBathMat',
      'en': 'Large Bath Mat',
      'fr': 'Grand tapis de bain',
      'es': 'Alfombra de baño grande',
      'de': 'Große Badematte',
      'pl': 'Duża mata do kąpieli',
      'ru': 'Большой коврик для ванной',
      'uk': 'Великий килимок для ванни',
      'ko': '대형 목욕 매트',
      'zh': '大浴垫',
      'ja': 'ラージバスマット'
    }, {
      'id': 'WeaveLargeBathMat',
      'en': 'Weave Large Bath Mat',
      'fr': 'Grand tapis de bain tissé',
      'es': 'Alfombrilla de baño grande de tejido',
      'de': 'Weben Sie große Badematte',
      'pl': 'Splot duża mata do kąpieli',
      'ru': 'Соткать большой коврик для ванной',
      'uk': 'Плетіть великий килимок для ванни',
      'ko': '큰 목욕 매트 위브',
      'zh': '编织大浴垫',
      'ja': '大きなバスマットを編む'
    }, {
      'id': 'LargeCorrugatedSteelDoor',
      'en': 'Large Corrugated Steel Door',
      'fr': 'Grande porte en acier ondulé',
      'es': 'Gran puerta de acero corrugado',
      'de': 'Große Wellblechtür',
      'pl': 'Duże drzwi ze stali falistej',
      'ru': 'Большая дверь из гофрированной стали',
      'uk': 'Великі гофровані сталеві двері',
      'ko': '대형 골판지 스틸 도어',
      'zh': '大型波纹钢门',
      'ja': '大きな段ボール鋼のドア'
    }, {
      'id': 'LargeHangingAshlarStoneSign',
      'en': 'Large Hanging Ashlar Stone Sign',
      'fr': 'Grande enseigne en pierre de taille à suspendre',
      'es': 'Letrero Colgante Grande de Sillería',
      'de': 'Großes hängendes Quadersteinschild',
      'pl': 'Duży wiszący znak z kamienia Ashlar',
      'ru': 'Большой висящий знак из тесаного камня',
      'uk': 'Великий висячий кам\u0027яний знак',
      'ko': '큰 교수형 Ashlar 돌 기호',
      'zh': '大型悬挂式方石标志',
      'ja': '大きなハンギング切石サイン'
    }, {
      'id': 'LargeHangingLumberSign',
      'en': 'Large Hanging Lumber Sign',
      'fr': 'Grand panneau de bois suspendu',
      'es': 'Letrero de madera colgante grande',
      'de': 'Großes hängendes Holzschild',
      'pl': 'Duży wiszący znak drewna',
      'ru': 'Большой висячий деревянный знак',
      'uk': 'Великий висить пиломатеріали знак',
      'ko': '대형 교수형 목재 기호',
      'zh': '大型悬挂木材标志',
      'ja': '大きなハンギング材木看板'
    }, {
      'id': 'LargeHangingMortaredStoneSign',
      'en': 'Large Hanging Mortared Stone Sign',
      'fr': 'Grand panneau en pierre mortier suspendu',
      'es': 'Letrero colgante grande de piedra con mortero',
      'de': 'Großes hängendes Schild aus gemörteltem Stein',
      'pl': 'Duży wiszący znak z zaprawą murarską',
      'ru': 'Большой висящий каменный знак из известкового раствора',
      'uk': 'Великий висячий кам\u0027яний знак',
      'ko': '대형 교수형 모르타르 스톤 사인',
      'zh': '大型悬挂式砂浆石标牌',
      'ja': '大きなハンギングモルタルストーンサイン'
    }, {
      'id': 'LargeHangingWoodSign',
      'en': 'Large Hanging Wood Sign',
      'fr': 'Grande enseigne en bois à suspendre',
      'es': 'Letrero de madera colgante grande',
      'de': 'Großes hängendes Holzschild',
      'pl': 'Duży wiszący znak drewna',
      'ru': 'Большой висячий деревянный знак',
      'uk': 'Великий висить дерев\u0027яний знак',
      'ko': '대형 교수형 나무 간판',
      'zh': '大挂木牌',
      'ja': '大きなハンギングウッドサイン'
    }, {
      'id': 'LargeLumberDoor',
      'en': 'Large Lumber Door',
      'fr': 'Grande porte en bois',
      'es': 'Puerta de madera grande',
      'de': 'Große Holztür',
      'pl': 'Duże drzwi do tarcicy',
      'ru': 'Большая деревянная дверь',
      'uk': 'Великі дерев\u0027яні двері',
      'ko': '대형 목재 문',
      'zh': '大木门',
      'ja': '大きな材木ドア'
    }, {
      'id': 'LargeLumberStockpile',
      'en': 'Large Lumber Stockpile',
      'fr': 'Grand stock de bois',
      'es': 'Gran reserva de madera',
      'de': 'Großer Holzvorrat',
      'pl': 'Duże zapasy drewna',
      'ru': 'Большой склад пиломатериалов',
      'uk': 'Великий запас пиломатеріалів',
      'ko': '대형 목재 비축',
      'zh': '大型木材库存',
      'ja': '大きな材木備蓄'
    }, {
      'id': 'LargeStandingAshlarStoneSign',
      'en': 'Large Standing Ashlar Stone Sign',
      'fr': 'Grand panneau en pierre de taille debout',
      'es': 'Cartel grande de piedra de sillería de pie',
      'de': 'Großes stehendes Quadersteinschild',
      'pl': 'Duży stojący znak z kamienia Ashlar',
      'ru': 'Большой стоящий знак из тесаного камня',
      'uk': 'Великий стоячий знак з каменю',
      'ko': '큰 서 Ashlar 돌 기호',
      'zh': '大型立式方石标志',
      'ja': '大きな切石の石の看板'
    }, {
      'id': 'LargeStandingLumberSign',
      'en': 'Large Standing Lumber Sign',
      'fr': 'Grand panneau de bois debout',
      'es': 'Letrero grande de madera de pie',
      'de': 'Großes stehendes Holzschild',
      'pl': 'Duży stojący znak drewna',
      'ru': 'Большой стоячий знак пиломатериалов',
      'uk': 'Знак великий стоячий пиломатеріали',
      'ko': '대형 서 있는 목재 기호',
      'zh': '大型常设木材标志',
      'ja': '大きな立木看板'
    }, {
      'id': 'LargeStandingMortaredStoneSign',
      'en': 'Large Standing Mortared Stone Sign',
      'fr': 'Grand panneau de pierre mortier debout',
      'es': 'Letrero de piedra con mortero de pie grande',
      'de': 'Großes stehendes Schild aus gemörteltem Stein',
      'pl': 'Duży stojący znak z zaprawą murarską',
      'ru': 'Большой стоячий каменный знак из известкового раствора',
      'uk': 'Великий стоячий кам\u0027яний знак',
      'ko': '대형 서있는 모르타르 스톤 사인',
      'zh': '大型立式砂浆石标牌',
      'ja': '大きな立っているモルタル石の看板'
    }, {
      'id': 'LargeStandingWoodSign',
      'en': 'Large Standing Wood Sign',
      'fr': 'Grande enseigne en bois sur pied',
      'es': 'Letrero grande de madera de pie',
      'de': 'Großes stehendes Holzschild',
      'pl': 'Duży stojący znak drewna',
      'ru': 'Большой стоячий деревянный знак',
      'uk': 'Великий стоячий дерев\u0027яний знак',
      'ko': '대형 서 있는 나무 기호',
      'zh': '大型立木标志',
      'ja': '大きなスタンディングウッドサイン'
    }, {
      'id': 'LargeWindowedLumberDoor',
      'en': 'Large Windowed Lumber Door',
      'fr': 'Grande porte vitrée en bois',
      'es': 'Puerta de madera con ventana grande',
      'de': 'Große Fenstertür aus Holz',
      'pl': 'Duże okienne drzwi do drewna',
      'ru': 'Большая оконная деревянная дверь',
      'uk': 'Великі дерев\u0027яні двері з вікнами',
      'ko': '대형 창문 목재 도어',
      'zh': '大窗木门',
      'ja': '大きな窓付き材木ドア'
    }, {
      'id': 'Laser',
      'en': 'Laser',
      'fr': 'Laser',
      'es': 'Láser',
      'de': 'Laser',
      'pl': 'Laser',
      'ru': 'Лазер',
      'uk': 'Лазерний',
      'ko': '레이저',
      'zh': '激光',
      'ja': 'レーザ'
    }, {
      'id': 'Lathe',
      'en': 'Lathe',
      'fr': 'Tour',
      'es': 'Torno',
      'de': 'Drehbank',
      'pl': 'Tokarka',
      'ru': 'токарный станок',
      'uk': 'Токарний верстат',
      'ko': '선반',
      'zh': '车床',
      'ja': '旋盤'
    }, {
      'id': 'LeavenedDough',
      'en': 'Leavened Dough',
      'fr': 'Pâte levée',
      'es': 'Masa con levadura',
      'de': 'Sauerteig',
      'pl': 'Ciasto Zaczynowe',
      'ru': 'дрожжевое тесто',
      'uk': 'Дріжджове тісто',
      'ko': '발효 반죽',
      'zh': '发酵面团',
      'ja': 'ふくらまし生地'
    }, {
      'id': 'LightBackpack',
      'en': 'Light Backpack',
      'fr': 'Sac à dos léger',
      'es': 'Mochila ligera',
      'de': 'Leichter Rucksack',
      'pl': 'Lekki plecak',
      'ru': 'Легкий рюкзак',
      'uk': 'Легкий рюкзак',
      'ko': '가벼운 배낭',
      'zh': '轻便背包',
      'ja': 'ライトバックパック'
    }, {
      'id': 'LightBulb',
      'en': 'Light Bulb',
      'fr': 'Ampoule',
      'es': 'Bombilla',
      'de': 'Die Glühbirne',
      'pl': 'Żarówka',
      'ru': 'Лампочка',
      'uk': 'Лампочка',
      'ko': '전구',
      'zh': '灯泡',
      'ja': '電球'
    }, {
      'id': 'LimestoneBisonStatue',
      'en': 'Limestone Bison Statue',
      'fr': 'Statue de bison en pierre calcaire',
      'es': 'Estatua de bisonte de piedra caliza',
      'de': 'Kalkstein-Bison-Statue',
      'pl': 'Wapienna statua żubra',
      'ru': 'Статуя известнякового бизона',
      'uk': 'Статуя бізона з вапняку',
      'ko': '석회암 들소 동상',
      'zh': '石灰石野牛雕像',
      'ja': '石灰岩のバイソン像'
    }, {
      'id': 'LimestoneOtterStatue',
      'en': 'Limestone Otter Statue',
      'fr': 'Statue de loutre en pierre calcaire',
      'es': 'Estatua de nutria de piedra caliza',
      'de': 'Otter-Statue aus Kalkstein',
      'pl': 'Wapienna wydra statua',
      'ru': 'Статуя известняковой выдры',
      'uk': 'Вапнякова статуя видри',
      'ko': '석회암 수달 동상',
      'zh': '石灰岩水獭雕像',
      'ja': '石灰岩のカワウソの像'
    }, {
      'id': 'LimestoneOwlStatue',
      'en': 'Limestone Owl Statue',
      'fr': 'Statue de hibou en calcaire',
      'es': 'Estatua de búho de piedra caliza',
      'de': 'Eulenstatue aus Kalkstein',
      'pl': 'Posąg wapiennej sowy',
      'ru': 'Статуя совы из известняка',
      'uk': 'Вапнякова статуя сови',
      'ko': '석회암 올빼미 동상',
      'zh': '石灰岩猫头鹰雕像',
      'ja': '石灰岩のフクロウの像'
    }, {
      'id': 'LimestoneWolfStatue',
      'en': 'Limestone Wolf Statue',
      'fr': 'Statue de loup en calcaire',
      'es': 'Estatua de lobo de piedra caliza',
      'de': 'Wolfsstatue aus Kalkstein',
      'pl': 'Posąg wapienny wilka',
      'ru': 'Статуя известнякового волка',
      'uk': 'Вапнякова статуя вовка',
      'ko': '석회암 늑대 동상',
      'zh': '石灰石狼雕像',
      'ja': '石灰岩のオオカミの像'
    }, {
      'id': 'LiquidNitrogen',
      'en': 'Liquid Nitrogen',
      'fr': 'L\u0027azote liquide',
      'es': 'Nitrógeno líquido',
      'de': 'Flüssigstickstoff',
      'pl': 'Ciekły azot',
      'ru': 'Жидкий азот',
      'uk': 'Рідкий азот',
      'ko': '액체 질소',
      'zh': '液氮',
      'ja': '液体窒素'
    }, {
      'id': 'LoadedTaroFries',
      'en': 'Loaded Taro Fries',
      'fr': 'Frites Taro Chargées',
      'es': 'Patatas Fritas Taro Cargadas',
      'de': 'Geladene Taro-Pommes',
      'pl': 'Załadowane Frytki Taro',
      'ru': 'Загруженный картофель таро',
      'uk': 'Завантажена картопля фрі таро',
      'ko': '로드된 타로 프라이',
      'zh': '装芋头薯条',
      'ja': '里芋フライ'
    }, {
      'id': 'LoggingAdvancedUpgrade',
      'en': 'Logging Advanced Upgrade',
      'fr': 'Mise à niveau avancée de la journalisation',
      'es': 'Actualización avanzada de registro',
      'de': 'Erweitertes Upgrade protokollieren',
      'pl': 'Zaawansowane rejestrowanie aktualizacji',
      'ru': 'Ведение журнала расширенного обновления',
      'uk': 'Розширене оновлення журналу',
      'ko': '로깅 고급 업그레이드',
      'zh': '记录高级升级',
      'ja': '高度なアップグレードのログ'
    }, {
      'id': 'LoggingBasicUpgrade',
      'en': 'Logging Basic Upgrade',
      'fr': 'Mise à niveau de base de la journalisation',
      'es': 'Actualización básica de registro',
      'de': 'Protokollieren des Basis-Upgrades',
      'pl': 'Rejestracja podstawowa aktualizacja',
      'ru': 'Ведение журнала базового обновления',
      'uk': 'Основне оновлення журналу',
      'ko': '로깅 기본 업그레이드',
      'zh': '记录基本升级',
      'ja': '基本的なアップグレードのログ'
    }, {
      'id': 'Loom',
      'en': 'Loom',
      'fr': 'Métier à tisser',
      'es': 'Telar',
      'de': 'Webstuhl',
      'pl': 'Warsztat tkacki',
      'ru': 'Ткацкий станок',
      'uk': 'Ткацький верстат',
      'ko': '직조기',
      'zh': '织机',
      'ja': '織機'
    }, {
      'id': 'LowTopShoes',
      'en': 'Low Top Shoes',
      'fr': 'Chaussures basses',
      'es': 'Zapatos bajos',
      'de': 'Low-Top-Schuhe',
      'pl': 'Niskie buty',
      'ru': 'Низкие туфли',
      'uk': 'Низькі туфлі',
      'ko': '로우탑 슈즈',
      'zh': '低帮鞋',
      'ja': 'ロートップシューズ'
    }, {
      'id': 'LumberBench',
      'en': 'Lumber Bench',
      'fr': 'Banc de bois',
      'es': 'banco de madera',
      'de': 'Holzbank',
      'pl': 'Ławka do drewna',
      'ru': 'Скамейка из пиломатериалов',
      'uk': 'Лавка для пиломатеріалів',
      'ko': '목재 벤치',
      'zh': '伐木台',
      'ja': '材木ベンチ'
    }, {
      'id': 'LumberChair',
      'en': 'Lumber Chair',
      'fr': 'Chaise en bois',
      'es': 'silla de madera',
      'de': 'Holzstuhl',
      'pl': 'Krzesło do drewna',
      'ru': 'Деревянный стул',
      'uk': 'Крісло пиломатеріалів',
      'ko': '목재 의자',
      'zh': '木椅',
      'ja': '材木椅子'
    }, {
      'id': 'LumberDoor',
      'en': 'Lumber Door',
      'fr': 'Porte bois',
      'es': 'puerta de madera',
      'de': 'Holztür',
      'pl': 'Drewno Drzwi',
      'ru': 'Деревянная дверь',
      'uk': 'Дерев\u0027яні двері',
      'ko': '목재 문',
      'zh': '木门',
      'ja': '材木ドア'
    }, {
      'id': 'LumberDresser',
      'en': 'Lumber Dresser',
      'fr': 'Commode à bois',
      'es': 'tocador de madera',
      'de': 'Holzkommode',
      'pl': 'Kredens do drewna',
      'ru': 'Комод пиломатериалов',
      'uk': 'Пиломатеріали',
      'ko': '목재 드레서',
      'zh': '木材梳妆台',
      'ja': 'ランバードレッサー'
    }, {
      'id': 'Lumber',
      'en': 'Lumber',
      'fr': 'Bois de charpente',
      'es': 'Tablas de madera',
      'de': 'Holz',
      'pl': 'Graty',
      'ru': 'Пиломатериалы',
      'uk': 'Пиломатеріали',
      'ko': '재목',
      'zh': '木材',
      'ja': '木材'
    }, {
      'id': 'LumberStockpile',
      'en': 'Lumber Stockpile',
      'fr': 'Stock de bois',
      'es': 'Reserva de madera',
      'de': 'Holzvorrat',
      'pl': 'Skład drewna',
      'ru': 'Склад пиломатериалов',
      'uk': 'Запас пиломатеріалів',
      'ko': '목재 비축',
      'zh': '木材库存',
      'ja': '材木備蓄'
    }, {
      'id': 'LumberTable',
      'en': 'Lumber Table',
      'fr': 'Table de bois',
      'es': 'Mesa de Madera',
      'de': 'Holztisch',
      'pl': 'Stół do tarcicy',
      'ru': 'Стол из пиломатериалов',
      'uk': 'Пиломатеріали Стіл',
      'ko': '목재 테이블',
      'zh': '木材表',
      'ja': '材木テーブル'
    }, {
      'id': 'Macarons',
      'en': 'Macarons',
      'fr': 'Macarons',
      'es': 'macarrones',
      'de': 'Makronen',
      'pl': 'Makaroniki',
      'ru': 'Макароны',
      'uk': 'Макарони',
      'ko': '마카롱',
      'zh': '马卡龙',
      'ja': 'マカロン'
    }, {
      'id': 'MachinistTable',
      'en': 'Machinist Table',
      'fr': 'Table de machiniste',
      'es': 'Mesa de maquinista',
      'de': 'Maschinentisch',
      'pl': 'Stół maszynisty',
      'ru': 'Стол машиниста',
      'uk': 'Стіл машиніста',
      'ko': '기계공 테이블',
      'zh': '机械师表',
      'ja': 'マシニストテーブル'
    }, {
      'id': 'Maltodextrin',
      'en': 'Maltodextrin',
      'fr': 'Maltodextrine',
      'es': 'maltodextrina',
      'de': 'Maltodextrin',
      'pl': 'Maltodekstryna',
      'ru': 'Мальтодекстрин',
      'uk': 'Мальтодекстрин',
      'ko': '말토덱스트린',
      'zh': '麦芽糊精',
      'ja': 'マルトデキストリン'
    }, {
      'id': 'MasonryAdvancedUpgrade',
      'en': 'Masonry Advanced Upgrade',
      'fr': 'Mise à niveau avancée de la maçonnerie',
      'es': 'Actualización avanzada de albañilería',
      'de': 'Fortgeschrittenes Upgrade für Mauerwerk',
      'pl': 'Zaawansowana modernizacja murów',
      'ru': 'Расширенное обновление масонства',
      'uk': 'Розширене оновлення Masonry',
      'ko': '벽돌 고급 업그레이드',
      'zh': '砌体高级升级',
      'ja': '組積造の高度なアップグレード'
    }, {
      'id': 'MasonryBasicUpgrade',
      'en': 'Masonry Basic Upgrade',
      'fr': 'Mise à niveau de base de la maçonnerie',
      'es': 'Actualización básica de albañilería',
      'de': 'Grundlegendes Upgrade für Mauerwerk',
      'pl': 'Podstawowe ulepszenie murów',
      'ru': 'Базовое обновление каменной кладки',
      'uk': 'Базове оновлення кладки',
      'ko': '벽돌 기본 업그레이드',
      'zh': '砌体基础升级',
      'ja': '組積造の基本的なアップグレード'
    }, {
      'id': 'MeatPie',
      'en': 'Meat Pie',
      'fr': 'Tourte à la viande',
      'es': 'Pastel de carne',
      'de': 'Fleischpastete',
      'pl': 'Mięsny placek',
      'ru': 'Мясной пирог',
      'uk': 'М\u0027ясний пиріг',
      'ko': '고기 파이',
      'zh': '肉饼',
      'ja': 'ミートパイ'
    }, {
      'id': 'MeatStock',
      'en': 'Meat Stock',
      'fr': 'Stock de viande',
      'es': 'Caldo de carne',
      'de': 'Fleischbestand',
      'pl': 'Zapas mięsny',
      'ru': 'Мясной бульон',
      'uk': 'М\u0027ясний бульон',
      'ko': '육수',
      'zh': '肉汤',
      'ja': '肉ストック'
    }, {
      'id': 'FishStew',
      'en': 'Fish Stew',
      'fr': 'Ragoût de poisson',
      'es': 'Estofado de pescado',
      'de': 'Fischeintopf',
      'pl': 'Gulasz rybny',
      'ru': 'Рыбное рагу',
      'uk': 'Рибне рагу',
      'ko': '생선 스튜',
      'zh': '鱼汤',
      'ja': '魚のシチュー'
    }, {
      'id': 'MeatyStew',
      'en': 'Meaty Stew',
      'fr': 'Ragoût de viande',
      'es': 'Estofado de carne',
      'de': 'Fleischiger Eintopf',
      'pl': 'Mięsny Gulasz',
      'ru': 'Мясное рагу',
      'uk': 'М\u0027ясна рагу',
      'ko': '고기 스튜',
      'zh': '炖肉',
      'ja': '肉のシチュー'
    }, {
      'id': 'MechanicalWaterPump',
      'en': 'Mechanical Water Pump',
      'fr': 'Pompe à eau mécanique',
      'es': 'Bomba de agua mecánica',
      'de': 'Mechanische Wasserpumpe',
      'pl': 'Mechaniczna pompa wodna',
      'ru': 'Механический водяной насос',
      'uk': 'Механічний водяний насос',
      'ko': '기계식 워터 펌프',
      'zh': '机械水泵',
      'ja': '機械式送水ポンプ'
    }, {
      'id': 'MechanicsAdvancedUpgrade',
      'en': 'Mechanics Advanced Upgrade',
      'fr': 'Mise à niveau avancée de la mécanique',
      'es': 'Actualización avanzada de mecánica',
      'de': 'Erweiterte Mechanik-Upgrade',
      'pl': 'Zaawansowane ulepszenie mechaniki',
      'ru': 'Продвинутое обновление механики',
      'uk': 'Розширене оновлення механіки',
      'ko': '역학 고급 업그레이드',
      'zh': '力学高级升级',
      'ja': '力学の高度なアップグレード'
    }, {
      'id': 'MechanicsModernUpgrade',
      'en': 'Mechanics Modern Upgrade',
      'fr': 'Mise à niveau moderne de la mécanique',
      'es': 'Mecánica Moderna Actualización',
      'de': 'Mechanik Modernes Upgrade',
      'pl': 'Modernizacja mechaniki',
      'ru': 'Механика Модерн Апгрейд',
      'uk': 'Сучасна модернізація механіки',
      'ko': '역학 현대 업그레이드',
      'zh': '力学现代升级',
      'ja': '力学の最新のアップグレード'
    }, {
      'id': 'MetallurgyResearchPaperAdvanced',
      'en': 'Metallurgy Research Paper Advanced',
      'fr': 'Document de recherche sur la métallurgie avancé',
      'es': 'Trabajo de investigación de metalurgia avanzado',
      'de': 'Forschungsbericht zur Metallurgie für Fortgeschrittene',
      'pl': 'Zaawansowany papier do badań metalurgicznych',
      'ru': 'Исследовательская работа по металлургии Advanced',
      'uk': 'Металургійна наукова робота Advanced',
      'ko': '야금 연구 논문 고급',
      'zh': '冶金研究论文高级',
      'ja': '冶金学研究論文Advanced'
    }, {
      'id': 'MetallurgyResearchPaperBasic',
      'en': 'Metallurgy Research Paper Basic',
      'fr': 'Document de recherche sur la métallurgie',
      'es': 'Papel de investigación de metalurgia básico',
      'de': 'Grundlegendes Forschungspapier zur Metallurgie',
      'pl': 'Podstawowy papier do badań metalurgicznych',
      'ru': 'Базовая исследовательская работа по металлургии',
      'uk': 'Металургія Наукова робота Основ',
      'ko': '야금 연구 논문 기초',
      'zh': '冶金研究论文基础',
      'ja': '冶金学研究論文基本'
    }, {
      'id': 'MetallurgyResearchPaperModern',
      'en': 'Metallurgy Research Paper Modern',
      'fr': 'Document de recherche sur la métallurgie moderne',
      'es': 'Papel de investigación de metalurgia moderno',
      'de': 'Metallurgisches Forschungspapier Modern',
      'pl': 'Nowoczesna praca naukowo-badawcza w dziedzinie metalurgii',
      'ru': 'Текст научной работы на тему «Модерн металлургии»',
      'uk': 'Металургія Наукова робота Сучасні',
      'ko': '야금 연구 논문 현대',
      'zh': '冶金研究论文现代',
      'ja': '現代の冶金学研究論文'
    }, {
      'id': 'Mill',
      'en': 'Mill',
      'fr': 'Moulin',
      'es': 'Molino',
      'de': 'Mühle',
      'pl': 'Młyn',
      'ru': 'Мельница',
      'uk': 'млин',
      'ko': '밀',
      'zh': '磨',
      'ja': '工場'
    }, {
      'id': 'MillingUpgrade',
      'en': 'Milling Upgrade',
      'fr': 'Mise à niveau de fraisage',
      'es': 'Actualización de fresado',
      'de': 'Fräs-Upgrade',
      'pl': 'Ulepszenie frezowania',
      'ru': 'Модернизация фрезерования',
      'uk': 'Оновлення фрезерування',
      'ko': '밀링 업그레이드',
      'zh': '铣削升级',
      'ja': 'フライス盤のアップグレード'
    }, {
      'id': 'MillionairesSalad',
      'en': 'Millionaires Salad',
      'fr': 'Salade des millionnaires',
      'es': 'Ensalada De Millonarios',
      'de': 'Salat der Millionäre',
      'pl': 'Sałatka Milionerów',
      'ru': 'Салат Миллионеров',
      'uk': 'Салат Мільйонери',
      'ko': '백만장자 샐러드',
      'zh': '百万富翁沙拉',
      'ja': 'ミリオネアサラダ'
    }, {
      'id': 'MiningAdvancedUpgrade',
      'en': 'Mining Advanced Upgrade',
      'fr': 'Mise à niveau avancée de l\u0027exploitation minière',
      'es': 'Actualización avanzada de minería',
      'de': 'Erweitertes Mining-Upgrade',
      'pl': 'Zaawansowane ulepszenie górnictwa',
      'ru': 'Расширенное обновление майнинга',
      'uk': 'Розширене оновлення майнінгу',
      'ko': '마이닝 고급 업그레이드',
      'zh': '挖矿进阶升级',
      'ja': 'マイニングアドバンストアップグレード'
    }, {
      'id': 'MiningBasicUpgrade',
      'en': 'Mining Basic Upgrade',
      'fr': 'Mise à niveau de base de l\u0027exploitation minière',
      'es': 'Actualización básica de minería',
      'de': 'Bergbau-Basis-Upgrade',
      'pl': 'Podstawowe ulepszenie górnictwa',
      'ru': 'Базовое обновление майнинга',
      'uk': 'Базове оновлення майнінгу',
      'ko': '마이닝 기본 업그레이드',
      'zh': '挖矿基础升级',
      'ja': 'マイニングの基本的なアップグレード'
    }, {
      'id': 'MiningModernUpgrade',
      'en': 'Mining Modern Upgrade',
      'fr': 'Mise à niveau moderne de l\u0027exploitation minière',
      'es': 'Actualización moderna de minería',
      'de': 'Modernes Bergbau-Upgrade',
      'pl': 'Modernizacja górnicza',
      'ru': 'Современное обновление майнинга',
      'uk': 'Сучасне оновлення майнінгу',
      'ko': '마이닝 모던 업그레이드',
      'zh': '采矿现代升级',
      'ja': 'マイニングモダンアップグレード'
    }, {
      'id': 'Mint',
      'en': 'Mint',
      'fr': 'menthe',
      'es': 'menta',
      'de': 'Minze',
      'pl': 'Mennica',
      'ru': 'Монетный двор',
      'uk': 'М\u0027ятний двір',
      'ko': '민트',
      'zh': '薄荷',
      'ja': 'ミント'
    }, {
      'id': 'Mochi',
      'en': 'Mochi',
      'fr': 'Mochi',
      'es': 'Mochi',
      'de': 'Mochi',
      'pl': 'Mochi',
      'ru': 'моти',
      'uk': 'Мочі',
      'ko': '떡',
      'zh': '麻糬',
      'ja': '餅'
    }, {
      'id': 'ModernAxe',
      'en': 'Modern Axe',
      'fr': 'Hache moderne',
      'es': 'Hacha moderna',
      'de': 'Moderne Axt',
      'pl': 'Nowoczesna siekiera',
      'ru': 'Современный топор',
      'uk': 'Сучасна сокира',
      'ko': '현대 도끼',
      'zh': '现代斧头',
      'ja': '現代の斧'
    }, {
      'id': 'ModernDoubleStreetLight',
      'en': 'Modern Double Street Light',
      'fr': 'Réverbère double moderne',
      'es': 'Farola doble moderna',
      'de': 'Moderne Doppelstraßenlaterne',
      'pl': 'Nowoczesne podwójne oświetlenie uliczne',
      'ru': 'Современный двойной уличный фонарь',
      'uk': 'Сучасне подвійне вуличне освітлення',
      'ko': '현대 이중 가로등',
      'zh': '现代双路灯',
      'ja': 'モダンダブルストリートライト'
    }, {
      'id': 'ModernHammer',
      'en': 'Modern Hammer',
      'fr': 'Marteau moderne',
      'es': 'Martillo moderno',
      'de': 'Moderner Hammer',
      'pl': 'Nowoczesny młotek',
      'ru': 'Современный молот',
      'uk': 'Сучасний молоток',
      'ko': '현대 망치',
      'zh': '现代锤子',
      'ja': 'モダンハンマー'
    }, {
      'id': 'ModernHoe',
      'en': 'Modern Hoe',
      'fr': 'Houe moderne',
      'es': 'Azada moderna',
      'de': 'Moderne Hacke',
      'pl': 'nowoczesny motyka',
      'ru': 'Современная мотыга',
      'uk': 'Сучасна мотика',
      'ko': '현대 괭이',
      'zh': '现代锄头',
      'ja': '現代のくわ'
    }, {
      'id': 'ModernMachete',
      'en': 'Modern Machete',
      'fr': 'Machette moderne',
      'es': 'Machete moderno',
      'de': 'Moderne Machete',
      'pl': 'Nowoczesna maczeta',
      'ru': 'Современное Мачете',
      'uk': 'Сучасне мачете',
      'ko': '모던 마체테',
      'zh': '现代弯刀',
      'ja': 'モダンマチェーテ'
    }, {
      'id': 'ModernPickaxe',
      'en': 'Modern Pickaxe',
      'fr': 'Pioche moderne',
      'es': 'Pico moderno',
      'de': 'Moderne Spitzhacke',
      'pl': 'Nowoczesny kilof',
      'ru': 'Современная кирка',
      'uk': 'Сучасна кирка',
      'ko': '현대 곡괭이',
      'zh': '现代镐',
      'ja': '現代のツルハシ'
    }, {
      'id': 'ModernRockDrill',
      'en': 'Modern Rock Drill',
      'fr': 'Perceuse à roche moderne',
      'es': 'Taladro de roca moderno',
      'de': 'Moderner Felsbohrer',
      'pl': 'Nowoczesna wiertarka do skał',
      'ru': 'Современная буровая установка',
      'uk': 'Сучасний бур',
      'ko': '현대 착암기',
      'zh': '现代凿岩机',
      'ja': 'モダンロックドリル'
    }, {
      'id': 'ModernScythe',
      'en': 'Modern Scythe',
      'fr': 'Faux moderne',
      'es': 'Guadaña moderna',
      'de': 'Moderne Sense',
      'pl': 'Nowoczesna kosa',
      'ru': 'Современная коса',
      'uk': 'Сучасна коса',
      'ko': '현대 낫',
      'zh': '现代镰刀',
      'ja': 'モダンサイス'
    }, {
      'id': 'ModernShovel',
      'en': 'Modern Shovel',
      'fr': 'Pelle moderne',
      'es': 'pala moderna',
      'de': 'Moderne Schaufel',
      'pl': 'Nowoczesna łopata',
      'ru': 'Современная лопата',
      'uk': 'Сучасна лопата',
      'ko': '현대 삽',
      'zh': '现代铲子',
      'ja': '現代のシャベル'
    }, {
      'id': 'ModernStreetLight',
      'en': 'Modern Street Light',
      'fr': 'Réverbère moderne',
      'es': 'Farola moderna',
      'de': 'Moderne Straßenlaterne',
      'pl': 'Nowoczesne oświetlenie uliczne',
      'ru': 'Современный уличный свет',
      'uk': 'Сучасне вуличне освітлення',
      'ko': '현대 가로등',
      'zh': '现代路灯',
      'ja': 'モダンな街路灯'
    }, {
      'id': 'ModernUpgradeLvl1',
      'en': 'Modern Upgrade 1',
      'fr': 'Mise à niveau moderne 1',
      'es': 'Actualización moderna 1',
      'de': 'Modernes Upgrade 1',
      'pl': 'Nowoczesna aktualizacja 1',
      'ru': 'Современное обновление 1',
      'uk': 'Сучасне оновлення 1',
      'ko': '현대 업그레이드 1',
      'zh': '现代升级 1',
      'ja': 'モダンアップグレード1'
    }, {
      'id': 'ModernUpgradeLvl2',
      'en': 'Modern Upgrade 2',
      'fr': 'Mise à niveau moderne 2',
      'es': 'Actualización moderna 2',
      'de': 'Modernes Upgrade 2',
      'pl': 'Nowoczesna aktualizacja 2',
      'ru': 'Современное обновление 2',
      'uk': 'Сучасне оновлення 2',
      'ko': '현대 업그레이드 2',
      'zh': '现代升级 2',
      'ja': 'モダンアップグレード2'
    }, {
      'id': 'ModernUpgradeLvl3',
      'en': 'Modern Upgrade 3',
      'fr': 'Mise à niveau moderne 3',
      'es': 'Actualización moderna 3',
      'de': 'Modernes Upgrade 3',
      'pl': 'Nowoczesna aktualizacja 3',
      'ru': 'Современное обновление 3',
      'uk': 'Сучасне оновлення 3',
      'ko': '현대 업그레이드 3',
      'zh': '现代升级 3',
      'ja': 'モダンアップグレード3'
    }, {
      'id': 'ModernUpgradeLvl4',
      'en': 'Modern Upgrade 4',
      'fr': 'Mise à niveau moderne 4',
      'es': 'Actualización moderna 4',
      'de': 'Modernes Upgrade 4',
      'pl': 'Nowoczesna aktualizacja 4',
      'ru': 'Современное обновление 4',
      'uk': 'Сучасне оновлення 4',
      'ko': '현대 업그레이드 4',
      'zh': '现代升级 4',
      'ja': 'モダンアップグレード4'
    }, {
      'id': 'BakedMortar',
      'en': 'Baked Mortar',
      'fr': 'Mortier cuit',
      'es': 'Mortero horneado',
      'de': 'Gebackener Mörser',
      'pl': 'Pieczona Moździerz',
      'ru': 'Запеченная ступка',
      'uk': 'Запечена ступка',
      'ko': '구운 모르타르',
      'zh': '烤砂浆',
      'ja': '焼きモルタル'
    }, {
      'id': 'MasonryMortar',
      'en': 'Masonry Mortar',
      'fr': 'Mortier de maçonnerie',
      'es': 'Mortero de albañilería',
      'de': 'Mauermörtel',
      'pl': 'Zaprawa murarska',
      'ru': 'Кладочный раствор',
      'uk': 'Розчин для кладки',
      'ko': '석조 모르타르',
      'zh': '砌筑砂浆',
      'ja': '組積造モルタル'
    }, {
      'id': 'WheatMortar',
      'en': 'Wheat Mortar',
      'fr': 'Mortier de blé',
      'es': 'Mortero de Trigo',
      'de': 'Weizenmörser',
      'pl': 'Zaprawa Pszenna',
      'ru': 'Пшеничная ступка',
      'uk': 'Пшенична ступка',
      'ko': '밀 모르타르',
      'zh': '小麦砂浆',
      'ja': '小麦モルタル'
    }, {
      'id': 'MortaredStoneBench',
      'en': 'Mortared Stone Bench',
      'fr': 'Banc de pierre mortier',
      'es': 'Banco de piedra con mortero',
      'de': 'Bank aus gemörteltem Stein',
      'pl': 'Kamienna ławka z zaprawą murarską',
      'ru': 'Каменная скамья из раствора',
      'uk': 'Кам’яна лавка з розчину',
      'ko': '박격포 석재 벤치',
      'zh': '砂浆石凳',
      'ja': 'モルタル石のベンチ'
    }, {
      'id': 'MortaredStoneChair',
      'en': 'Mortared Stone Chair',
      'fr': 'Chaise en pierre mortier',
      'es': 'Silla de piedra con mortero',
      'de': 'Gemörtelter Steinstuhl',
      'pl': 'Kamienne krzesło z zaprawą murarską',
      'ru': 'Стул из известкового камня',
      'uk': 'Стілець із затираного каменю',
      'ko': '박격포 석재 의자',
      'zh': '砂浆石椅',
      'ja': 'モルタルストーンチェア'
    }, {
      'id': 'MortaredStoneDoor',
      'en': 'Mortared Stone Door',
      'fr': 'Porte en pierre mortier',
      'es': 'Puerta de piedra con mortero',
      'de': 'Gemörtelte Steintür',
      'pl': 'Zamurowane kamienne drzwi',
      'ru': 'Известковая каменная дверь',
      'uk': 'Заштукатурені кам\u0027яні двері',
      'ko': '박격포 돌 문',
      'zh': '砂浆石门',
      'ja': 'モルタル石のドア'
    }, {
      'id': 'MortaredStoneFireplace',
      'en': 'Mortared Stone Fireplace',
      'fr': 'Foyer en pierre mortier',
      'es': 'Chimenea de piedra con argamasa',
      'de': 'Kamin aus gemörteltem Stein',
      'pl': 'Kominek z zaprawy murarskiej',
      'ru': 'Каменный камин из раствора',
      'uk': 'Кам\u0027яний камін з розчину',
      'ko': '박격포 석재 벽난로',
      'zh': '砂浆石壁炉',
      'ja': 'モルタル石の暖炉'
    }, {
      'id': 'MortaredStone',
      'en': 'Mortared Stone',
      'fr': 'Pierre Mortier',
      'es': 'Piedra con mortero',
      'de': 'Gemörtelter Stein',
      'pl': 'Kamień zaprawy',
      'ru': 'Известковый камень',
      'uk': 'Розчинений камінь',
      'ko': '박격포',
      'zh': '砂浆石',
      'ja': 'モルタルストーン'
    }, {
      'id': 'MortaredStoneTable',
      'en': 'Mortared Stone Table',
      'fr': 'Table en pierre mortier',
      'es': 'Mesa de piedra con mortero',
      'de': 'Gemörtelter Steintisch',
      'pl': 'Kamienny stół z zaprawą murarską',
      'ru': 'Каменный стол с известковым раствором',
      'uk': 'Кам\u0027яний стіл з розчином',
      'ko': '박격포 석재 테이블',
      'zh': '砂浆石桌',
      'ja': 'モルタルストーンテーブル'
    }, {
      'id': 'Nail',
      'en': 'Nail',
      'fr': 'Clou',
      'es': 'Uña',
      'de': 'Nagel',
      'pl': 'Gwóźdź',
      'ru': 'Ноготь',
      'uk': 'Цвях',
      'ko': '못',
      'zh': '指甲',
      'ja': '爪'
    }, {
      'id': 'NylonCarpet',
      'en': 'Nylon Carpet',
      'fr': 'Tapis en nylon',
      'es': 'Alfombra de nailon',
      'de': 'Nylonteppich',
      'pl': 'Dywan nylonowy',
      'ru': 'Нейлоновый ковер',
      'uk': 'Нейлоновий килим',
      'ko': '나일론 카펫',
      'zh': '尼龙地毯',
      'ja': 'ナイロンカーペット'
    }, {
      'id': 'WeaveNylonCurtains',
      'en': 'Weave Nylon Curtains',
      'fr': 'Tisser des rideaux en nylon',
      'es': 'Cortinas de nailon tejido',
      'de': 'Weben Sie Nylonvorhänge',
      'pl': 'Splot nylonowych zasłon',
      'ru': 'ткать нейлоновые шторы',
      'uk': 'Плетіть нейлонові штори',
      'ko': '나일론 커튼을 짜다',
      'zh': '编织尼龙窗帘',
      'ja': 'ナイロンカーテンを織ります'
    }, {
      'id': 'WeaveNylonFabric',
      'en': 'Weave Nylon Fabric',
      'fr': 'Tissu en nylon tissé',
      'es': 'Tejido de nailon',
      'de': 'Weben Sie Nylongewebe',
      'pl': 'Splot tkaniny nylonowej',
      'ru': 'Ткань нейлона плетения',
      'uk': 'Плетіть нейлонову тканину',
      'ko': '나일론 원단을 짜다',
      'zh': '编织尼龙布',
      'ja': 'ナイロン生地を織ります'
    }, {
      'id': 'NylonFutonBed',
      'en': 'Nylon Futon Bed',
      'fr': 'Lit futon en nylon',
      'es': 'Cama futón de nailon',
      'de': 'Nylon-Futon-Bett',
      'pl': 'Nylonowe łóżko z futonem',
      'ru': 'Нейлоновая кровать футон',
      'uk': 'Ліжко-футон з нейлону',
      'ko': '나일론 이불',
      'zh': '尼龙蒲团床',
      'ja': 'ナイロン布団ベッド'
    }, {
      'id': 'NylonFutonCouch',
      'en': 'Nylon Futon Couch',
      'fr': 'Canapé futon en nylon',
      'es': 'Sofá futón de nailon',
      'de': 'Nylon-Futon-Couch',
      'pl': 'Nylonowa kanapa futonowa',
      'ru': 'Нейлоновый диван-футон',
      'uk': 'Нейлоновий диван-футон',
      'ko': '나일론 이불 소파',
      'zh': '尼龙蒲团沙发',
      'ja': 'ナイロン布団カウチ'
    }, {
      'id': 'Nylon',
      'en': 'Nylon',
      'fr': 'Nylon',
      'es': 'Nylon',
      'de': 'Nylon',
      'pl': 'Nylon',
      'ru': 'Нейлон',
      'uk': 'нейлон',
      'ko': '나일론',
      'zh': '尼龙',
      'ja': 'ナイロン'
    }, {
      'id': 'NylonThread',
      'en': 'Nylon Thread',
      'fr': 'Fil de nylon',
      'es': 'Hilo de nylon',
      'de': 'Nylon Faden',
      'pl': 'Nici nylonowe',
      'ru': 'Нейлоновая нить',
      'uk': 'Нейлонова нитка',
      'ko': '나일론 실',
      'zh': '尼龙线',
      'ja': 'ナイロン糸'
    }, {
      'id': 'OilDrillingUpgrade',
      'en': 'Oil Drilling Upgrade',
      'fr': 'Mise à niveau du forage pétrolier',
      'es': 'Actualización de perforación petrolera',
      'de': 'Ölbohr-Upgrade',
      'pl': 'Modernizacja odwiertów naftowych',
      'ru': 'Модернизация бурения нефтяных скважин',
      'uk': 'Оновлення буріння нафти',
      'ko': '석유 시추 업그레이드',
      'zh': '石油钻井升级',
      'ja': '石油掘削のアップグレード'
    }, {
      'id': 'Oil',
      'en': 'Oil',
      'fr': 'Pétrole',
      'es': 'Aceite',
      'de': 'Öl',
      'pl': 'Olej',
      'ru': 'Масло',
      'uk': 'нафта',
      'ko': '기름',
      'zh': '油',
      'ja': '油'
    }, {
      'id': 'RefineTallow',
      'en': 'Refine Tallow',
      'fr': 'Affiner le suif',
      'es': 'Sebo refinado',
      'de': 'Talg verfeinern',
      'pl': 'Udoskonal łój',
      'ru': 'Уточнить жир',
      'uk': 'Refine Tallow',
      'ko': '정제 수지',
      'zh': '精炼牛脂',
      'ja': '獣脂を精製する'
    }, {
      'id': 'SunflowerOil',
      'en': 'Sunflower Oil',
      'fr': 'Huile de tournesol',
      'es': 'Aceite de girasol',
      'de': 'Sonnenblumenöl',
      'pl': 'Olej słonecznikowy',
      'ru': 'Подсолнечное масло',
      'uk': 'Соняшникова олія',
      'ko': '해바라기 유',
      'zh': '葵花籽油',
      'ja': 'ひまわり油'
    }, {
      'id': 'OilRefinery',
      'en': 'Oil Refinery',
      'fr': 'Raffinerie de pétrole',
      'es': 'Refinería de petróleo',
      'de': 'Ölraffinerie',
      'pl': 'Rafineria ropy',
      'ru': 'Нефтеперегонный завод',
      'uk': 'Нафтопереробний завод',
      'ko': '정유',
      'zh': '炼油厂',
      'ja': '石油精製所'
    }, {
      'id': 'PaddedChair',
      'en': 'Padded Chair',
      'fr': 'Chaise rembourrée',
      'es': 'silla acolchada',
      'de': 'Gepolsterter Stuhl',
      'pl': 'Wyściełane krzesło',
      'ru': 'Мягкий стул',
      'uk': 'М\u0027який стілець',
      'ko': '푹신한 의자',
      'zh': '软垫椅子',
      'ja': 'パッド入りの椅子'
    }, {
      'id': 'PapayaSeed',
      'en': 'Papaya Seed',
      'fr': 'Graine de papaye',
      'es': 'semilla de papaya',
      'de': 'Papayasamen',
      'pl': 'Nasiona papai',
      'ru': 'Семена папайи',
      'uk': 'Насіння папайї',
      'ko': '파파야 씨',
      'zh': '木瓜种子',
      'ja': 'パパイヤシード'
    }, {
      'id': 'Paper',
      'en': 'Paper',
      'fr': 'Papier',
      'es': 'Papel',
      'de': 'Papier',
      'pl': 'Papier',
      'ru': 'Бумага',
      'uk': 'Папір',
      'ko': '종이',
      'zh': '纸',
      'ja': '紙'
    }, {
      'id': 'PaperMillingUpgrade',
      'en': 'Paper Milling Upgrade',
      'fr': 'Mise à niveau de la papeterie',
      'es': 'Actualización de la molienda de papel',
      'de': 'Papiermühlen-Upgrade',
      'pl': 'Ulepszenie frezowania papieru',
      'ru': 'Модернизация бумажного производства',
      'uk': 'Оновлення паперового фрезерування',
      'ko': '제지 업그레이드',
      'zh': '造纸厂升级',
      'ja': '製紙工場のアップグレード'
    }, {
      'id': 'PastryDough',
      'en': 'Pastry Dough',
      'fr': 'Pâte à tarte',
      'es': 'Masa de reposteria',
      'de': 'Teig',
      'pl': 'Ciasto Ciasto',
      'ru': 'Тесто для кондитерских изделий',
      'uk': 'Кондитерське тісто',
      'ko': '페이스트리 반죽',
      'zh': '糕点面团',
      'ja': 'ペストリー生地'
    }, {
      'id': 'PeltFertilizer',
      'en': 'Pelt Fertilizer',
      'fr': 'Engrais pour peaux',
      'es': 'Fertilizante de piel',
      'de': 'Felldünger',
      'pl': 'Nawóz do skórek',
      'ru': 'Удобрение для шкур',
      'uk': 'Шкура добрива',
      'ko': '펠트 비료',
      'zh': '毛皮肥料',
      'ja': '毛皮肥料'
    }, {
      'id': 'Petroleum',
      'en': 'Petroleum',
      'fr': 'Pétrole',
      'es': 'Petróleo',
      'de': 'Petroleum',
      'pl': 'Ropa naftowa',
      'ru': 'Нефть',
      'uk': 'Нафта',
      'ko': '석유',
      'zh': '石油',
      'ja': '石油'
    }, {
      'id': 'PhadThai',
      'en': 'Phad Thai',
      'fr': 'Phad thaï',
      'es': 'Phad tailandés',
      'de': 'Phad Thai',
      'pl': 'Phad Thai',
      'ru': 'Пад Тай',
      'uk': 'Phad Thai',
      'ko': '팟타이',
      'zh': '泰语',
      'ja': 'パッタイ'
    }, {
      'id': 'PhosphateFertilizer',
      'en': 'Phosphate Fertilizer',
      'fr': 'Engrais phosphaté',
      'es': 'Fertilizante de fosfato',
      'de': 'Phosphatdünger',
      'pl': 'Nawóz fosforanowy',
      'ru': 'Фосфорные удобрения',
      'uk': 'Фосфатне добриво',
      'ko': '인산염 비료',
      'zh': '磷肥',
      'ja': 'リン酸肥料'
    }, {
      'id': 'PineappleFriendRice',
      'en': 'Pineapple Friend Rice',
      'fr': 'Riz d\u0027ami à l\u0027ananas',
      'es': 'Arroz Amigo De La Piña',
      'de': 'Ananas-Freund-Reis',
      'pl': 'Ananasowy Przyjaciel Ryż',
      'ru': 'Ананасовый друг рис',
      'uk': 'Ананас Друг Рис',
      'ko': '파인애플 프렌드 라이스',
      'zh': '菠萝朋友饭',
      'ja': 'パイナップルフレンドライス'
    }, {
      'id': 'PineappleSeed',
      'en': 'Pineapple Seed',
      'fr': 'Graine d\u0027Ananas',
      'es': 'Semilla de Piña',
      'de': 'Ananassamen',
      'pl': 'Nasiona ananasa',
      'ru': 'Семя ананаса',
      'uk': 'Насіння ананаса',
      'ko': '파인애플 씨',
      'zh': '菠萝籽',
      'ja': 'パイナップルシード'
    }, {
      'id': 'Pirozhok',
      'en': 'Pirozhok',
      'fr': 'Pirozhok',
      'es': 'pirozhok',
      'de': 'Pirozhok',
      'pl': 'Pirozhok',
      'ru': 'Пирожок',
      'uk': 'Пірожок',
      'ko': '피로조크',
      'zh': '皮罗若克',
      'ja': 'ピロシキ'
    }, {
      'id': 'Piston',
      'en': 'Piston',
      'fr': 'Piston',
      'es': 'Pistón',
      'de': 'Kolben',
      'pl': 'Tłok',
      'ru': 'Поршень',
      'uk': 'Поршнева',
      'ko': '피스톤',
      'zh': '活塞',
      'ja': 'ピストン'
    }, {
      'id': 'RoundPot',
      'en': 'Round Pot',
      'fr': 'Pot rond',
      'es': 'Olla Redonda',
      'de': 'Runder Topf',
      'pl': 'Okrągły garnek',
      'ru': 'Круглый горшок',
      'uk': 'Круглий горщик',
      'ko': '둥근 냄비',
      'zh': '圆锅',
      'ja': 'ラウンドポット'
    }, {
      'id': 'SquarePot',
      'en': 'Square Pot',
      'fr': 'Pot carré',
      'es': 'Olla cuadrada',
      'de': 'Quadratischer Topf',
      'pl': 'Kwadratowa doniczka',
      'ru': 'Квадратный горшок',
      'uk': 'Квадратний горщик',
      'ko': '사각 냄비',
      'zh': '方锅',
      'ja': 'スクエアポット'
    }, {
      'id': 'Plastic',
      'en': 'Plastic',
      'fr': 'Plastique',
      'es': 'El plastico',
      'de': 'Kunststoff',
      'pl': 'Plastikowy',
      'ru': 'Пластик',
      'uk': 'Пластикові',
      'ko': '플라스틱',
      'zh': '塑料',
      'ja': 'プラスチック'
    }, {
      'id': 'PokeBowl',
      'en': 'Poke Bowl',
      'fr': 'Poké Bol',
      'es': 'Cuenco de poke',
      'de': 'Poke-Bowl',
      'pl': 'Poke Bowl',
      'ru': 'Поке Боул',
      'uk': 'Poke Bowl',
      'ko': '포크 볼',
      'zh': '戳碗',
      'ja': 'ポケボウル'
    }, {
      'id': 'PortableSteamEngine',
      'en': 'Portable Steam Engine',
      'fr': 'Machine à vapeur portative',
      'es': 'Máquina de vapor portátil',
      'de': 'Tragbare Dampfmaschine',
      'pl': 'Przenośny silnik parowy',
      'ru': 'Портативный паровой двигатель',
      'uk': 'Портативний паровий двигун',
      'ko': '휴대용 증기 기관',
      'zh': '便携式蒸汽机',
      'ja': 'ポータブル蒸気エンジン'
    }, {
      'id': 'PotteryUpgrade',
      'en': 'Pottery Upgrade',
      'fr': 'Amélioration de la poterie',
      'es': 'Actualización de cerámica',
      'de': 'Keramik-Upgrade',
      'pl': 'Ulepszenie ceramiki',
      'ru': 'Обновление керамики',
      'uk': 'Оновлення кераміки',
      'ko': '도자기 업그레이드',
      'zh': '陶器升级',
      'ja': '陶器のアップグレード'
    }, {
      'id': 'PoweredCart',
      'en': 'Powered Cart',
      'fr': 'Chariot motorisé',
      'es': 'Carro motorizado',
      'de': 'Angetriebener Wagen',
      'pl': 'Zasilany wózek',
      'ru': 'Тележка с электроприводом',
      'uk': 'Електричний кошик',
      'ko': '전원 카트',
      'zh': '电动推车',
      'ja': 'パワードカート'
    }, {
      'id': 'PreparedMeat',
      'en': 'Prepared Meat',
      'fr': 'Viande Préparée',
      'es': 'Carne Preparada',
      'de': 'Zubereitetes Fleisch',
      'pl': 'Mięso przetworzone',
      'ru': 'Готовое мясо',
      'uk': 'Готове м\u0027ясо',
      'ko': '준비된 고기',
      'zh': '熟肉',
      'ja': '準備された肉'
    }, {
      'id': 'PricklyPearSeed',
      'en': 'Prickly Pear Seed',
      'fr': 'Graine de figue de barbarie',
      'es': 'Semilla de higo chumbo',
      'de': 'Kaktusfeige Samen',
      'pl': 'Nasiona opuncji',
      'ru': 'Семя опунции',
      'uk': 'Насіння опунції',
      'ko': '의욕적인 배 씨앗',
      'zh': '仙人掌种子',
      'ja': 'ウチワサボテンの種'
    }, {
      'id': 'PrimeCut',
      'en': 'Prime Cut',
      'fr': 'Premier coupe',
      'es': 'Primer corte',
      'de': 'Prime-Schnitt',
      'pl': 'Prime Cut',
      'ru': 'Прайм-срез',
      'uk': 'Prime Cut',
      'ko': '프라임 컷',
      'zh': '主要切割',
      'ja': 'プライムカット'
    }, {
      'id': 'PulpFiller',
      'en': 'Pulp Filler',
      'fr': 'Remplisseur de pulpe',
      'es': 'Relleno de pulpa',
      'de': 'Zellstoff-Füller',
      'pl': 'Wypełniacz miazgi',
      'ru': 'Целлюлозный наполнитель',
      'uk': 'Наповнювач целюлози',
      'ko': '펄프 필러',
      'zh': '纸浆填料',
      'ja': 'パルプフィラー'
    }, {
      'id': 'PumpJack',
      'en': 'Pump Jack',
      'fr': 'Cric à pompe',
      'es': 'Bomba extractora',
      'de': 'Pumpenheber',
      'pl': 'Pompa Jack',
      'ru': 'насос домкрат',
      'uk': 'Джек насоса',
      'ko': '펌프 잭',
      'zh': '泵千斤顶',
      'ja': 'ポンプジャック'
    }, {
      'id': 'PumpkinSeed',
      'en': 'Pumpkin Seed',
      'fr': 'Graine de citrouille',
      'es': 'Semilla de calabaza',
      'de': 'Kürbissamen',
      'pl': 'Nasiona dyni',
      'ru': 'Тыквенное семечко',
      'uk': 'Насіння гарбуза',
      'ko': '호박씨',
      'zh': '南瓜种子',
      'ja': 'カボチャの種'
    }, {
      'id': 'Pupusas',
      'en': 'Pupusas',
      'fr': 'Pupuses',
      'es': 'pupusas',
      'de': 'pupusas',
      'pl': 'Pupusas',
      'ru': 'Куколки',
      'uk': 'Пупуси',
      'ko': '푸푸사스',
      'zh': '普普萨斯',
      'ja': 'ププサ'
    }, {
      'id': 'Quicklime',
      'en': 'Quicklime',
      'fr': 'Chaux vive',
      'es': 'Cal viva',
      'de': 'Branntkalk',
      'pl': 'Wapno palone',
      'ru': 'негашеная известь',
      'uk': 'Негашене вапно',
      'ko': '생석회',
      'zh': '生石灰',
      'ja': '生石灰'
    }, {
      'id': 'Radiator',
      'en': 'Radiator',
      'fr': 'Radiateur',
      'es': 'Radiador',
      'de': 'Kühler',
      'pl': 'Kaloryfer',
      'ru': 'Радиатор',
      'uk': 'Радіатор',
      'ko': '라디에이터',
      'zh': '散热器',
      'ja': 'ラジエーター'
    }, {
      'id': 'RawBacon',
      'en': 'Raw Bacon',
      'fr': 'Lard cru',
      'es': 'tocino crudo',
      'de': 'Roher Speck',
      'pl': 'Surowy Boczek',
      'ru': 'Сырой бекон',
      'uk': 'Сирий бекон',
      'ko': '생 베이컨',
      'zh': '生培根',
      'ja': '生ベーコン'
    }, {
      'id': 'ButcherBison',
      'en': 'Butcher Bison',
      'fr': 'Bison boucher',
      'es': 'carnicero bisonte',
      'de': 'Metzger Bison',
      'pl': 'żubr rzeźnik',
      'ru': 'Мясник Бизон',
      'uk': 'М\u0027ясний бізон',
      'ko': '정육점 들소',
      'zh': '屠夫野牛',
      'ja': 'ブッチャーバイソン'
    }, {
      'id': 'ButcherHare',
      'en': 'Butcher Hare',
      'fr': 'Lièvre boucher',
      'es': 'liebre de carnicero',
      'de': 'Metzger Hase',
      'pl': 'Zając Rzeźnik',
      'ru': 'Заяц-мясник',
      'uk': 'Заєць-м\u0027ясник',
      'ko': '정육점 토끼',
      'zh': '屠夫野兔',
      'ja': 'ブッチャーうさぎ'
    }, {
      'id': 'ButcherMediumAnimal',
      'en': 'Butcher Medium Animal',
      'fr': 'Boucher Moyen Animal',
      'es': 'Carnicero Medio Animal',
      'de': 'Metzger Mittleres Tier',
      'pl': 'Rzeźnik średnie zwierzę',
      'ru': 'Мясник Среднее животное',
      'uk': 'М\u0027ясник середня тварина',
      'ko': '정육점 중간 동물',
      'zh': '屠夫中型动物',
      'ja': 'ブッチャーミディアムアニマル'
    }, {
      'id': 'ButcherMediumWoolyAnimal',
      'en': 'Butcher Medium Wooly Animal',
      'fr': 'Animal laineux moyen boucher',
      'es': 'Carnicero Medio Lanudo Animal',
      'de': 'Metzger Medium Wooly Animal',
      'pl': 'Rzeźnik Średni Wooly Animal',
      'ru': 'Мясник Среднее Шерстистое Животное',
      'uk': 'М’ясник середньої шерсті',
      'ko': '정육점 중간 양털 동물',
      'zh': '屠夫中等毛茸茸的动物',
      'ja': 'ブッチャーミディアムウーリーアニマル'
    }, {
      'id': 'ButcherSmallAnimal',
      'en': 'Butcher Small Animal',
      'fr': 'Boucher Petit Animal',
      'es': 'Carnicero Pequeño Animal',
      'de': 'Metzger Kleintier',
      'pl': 'Rzeźnik Małe Zwierzę',
      'ru': 'Мясник Маленькое животное',
      'uk': 'М\u0027ясний дрібний звір',
      'ko': '정육점 작은 동물',
      'zh': '屠夫小动物',
      'ja': '肉屋小動物'
    }, {
      'id': 'ButcherTinyFurAnimal',
      'en': 'Butcher Tiny Fur Animal',
      'fr': 'Boucher petit animal à fourrure',
      'es': 'Carnicero Tiny Fur Animal',
      'de': 'Metzger Winziges Pelztier',
      'pl': 'Rzeźnik Małe Futro Zwierzę',
      'ru': 'Мясник Крошечное меховое животное',
      'uk': 'М\u0027ясник крихітних хутрових тварин',
      'ko': '정육점 작은 모피 동물',
      'zh': '屠夫小毛皮动物',
      'ja': '肉屋の小さな毛皮の動物'
    }, {
      'id': 'ButcherTinyLeatherAnimal',
      'en': 'Butcher Tiny Leather Animal',
      'fr': 'Boucher petit animal en cuir',
      'es': 'Carnicero Tiny Animal de cuero',
      'de': 'Metzger kleines Ledertier',
      'pl': 'Rzeźnik Tiny Leather Animal',
      'ru': 'Мясник Маленькое кожаное животное',
      'uk': 'М\u0027ясник крихітних шкіряних тварин',
      'ko': '정육점 작은 가죽 동물',
      'zh': '屠夫小皮革动物',
      'ja': 'ブッチャータイニーレザーアニマル'
    }, {
      'id': 'RawRoast',
      'en': 'Raw Roast',
      'fr': 'Rôti cru',
      'es': 'asado crudo',
      'de': 'Roher Braten',
      'pl': 'Surowa Pieczeń',
      'ru': 'Сырое жаркое',
      'uk': 'Сире смажене',
      'ko': '생 로스트',
      'zh': '生烤',
      'ja': '生焙煎'
    }, {
      'id': 'RawSausage',
      'en': 'Raw Sausage',
      'fr': 'Saucisse crue',
      'es': 'Salchicha Cruda',
      'de': 'Rohwurst',
      'pl': 'Kiełbasa Surowa',
      'ru': 'Сырая колбаса',
      'uk': 'Сира ковбаса',
      'ko': '생 소시지',
      'zh': '生香肠',
      'ja': '生ソーセージ'
    }, {
      'id': 'RealEstateDesk',
      'en': 'Real Estate Desk',
      'fr': 'Bureau de l\u0027immobilier',
      'es': 'Escritorio de Bienes Raíces',
      'de': 'Immobilien-Schreibtisch',
      'pl': 'Biuro nieruchomości',
      'ru': 'Отдел недвижимости',
      'uk': 'Бюро нерухомості',
      'ko': '부동산 데스크',
      'zh': '房地产服务台',
      'ja': '不動産デスク'
    }, {
      'id': 'Rebar',
      'en': 'Rebar',
      'fr': 'Barre d\u0027armature',
      'es': 'barra de refuerzo',
      'de': 'Bewehrung',
      'pl': 'Zbrojenie',
      'ru': 'Арматура',
      'uk': 'Арматура',
      'ko': '철근',
      'zh': '钢筋',
      'ja': '鉄筋'
    }, {
      'id': 'RecurveBow',
      'en': 'Recurve Bow',
      'fr': 'Arc classique',
      'es': 'Arco recurvo',
      'de': 'Recurvebogen',
      'pl': 'Wygięty łuk',
      'ru': 'Изогнутый лук',
      'uk': 'Вигнутий лук',
      'ko': '리커브 보우',
      'zh': '反曲弓',
      'ja': '後ろに反らす弓'
    }, {
      'id': 'Refrigerator',
      'en': 'Refrigerator',
      'fr': 'Réfrigérateur',
      'es': 'Refrigerador',
      'de': 'Kühlschrank',
      'pl': 'Lodówka',
      'ru': 'Холодильник',
      'uk': 'Холодильник',
      'ko': '냉장고',
      'zh': '冰箱',
      'ja': '冷蔵庫'
    }, {
      'id': 'Registrar',
      'en': 'Registrar',
      'fr': 'Greffier',
      'es': 'Registrador',
      'de': 'Registrator',
      'pl': 'Rejestrator',
      'ru': 'Регистратор',
      'uk': 'реєстратор',
      'ko': '기록 사무관',
      'zh': '注册商',
      'ja': 'レジストラ'
    }, {
      'id': 'ReinforcedConcrete',
      'en': 'Reinforced Concrete',
      'fr': 'Béton armé',
      'es': 'Concreto reforzado',
      'de': 'Verstärkter Beton',
      'pl': 'Żelbetowe',
      'ru': 'Железобетон',
      'uk': 'Залізобетон',
      'ko': '철근 콘크리트',
      'zh': '钢筋混凝土',
      'ja': '強化コンクリート'
    }, {
      'id': 'RiceFlour',
      'en': 'Rice Flour',
      'fr': 'Farine de riz',
      'es': 'Harina de arroz',
      'de': 'Reismehl',
      'pl': 'Mąka ryżowa',
      'ru': 'Рисовая мука',
      'uk': 'Рисове борошно',
      'ko': '쌀가루',
      'zh': '米粉',
      'ja': '米粉'
    }, {
      'id': 'RiceNoodles',
      'en': 'Rice Noodles',
      'fr': 'Nouilles de riz',
      'es': 'Fideos de arroz',
      'de': 'Reisnudeln',
      'pl': 'Makaron ryżowy',
      'ru': 'Рисовая лапша',
      'uk': 'Рисова локшина',
      'ko': '쌀국수',
      'zh': '米粉',
      'ja': 'ライスヌードル'
    }, {
      'id': 'Rivet',
      'en': 'Rivet',
      'fr': 'Rivet',
      'es': 'Remache',
      'de': 'Niet',
      'pl': 'Nit',
      'ru': 'Заклепка',
      'uk': 'Заклепка',
      'ko': '대갈못',
      'zh': '铆钉',
      'ja': 'リベット'
    }, {
      'id': 'RoastPumpkin',
      'en': 'Roast Pumpkin',
      'fr': 'Citrouille rôtie',
      'es': 'Calabaza Asada',
      'de': 'Gebratener Kürbis',
      'pl': 'Pieczona Dynia',
      'ru': 'Жареная тыква',
      'uk': 'Смажений гарбуз',
      'ko': '구운 호박',
      'zh': '烤南瓜',
      'ja': 'カボチャの焙煎'
    }, {
      'id': 'RoboticAssemblyLine',
      'en': 'Robotic Assembly Line',
      'fr': 'Chaîne de montage robotique',
      'es': 'Línea de montaje robótica',
      'de': 'Roboter-Fließband',
      'pl': 'Robotyczna linia montażowa',
      'ru': 'Роботизированная сборочная линия',
      'uk': 'Роботизована складальна лінія',
      'ko': '로봇 조립 라인',
      'zh': '机器人装配线',
      'ja': 'ロボット組立ライン'
    }, {
      'id': 'RockerBox',
      'en': 'Rocker Box',
      'fr': 'Boîte à bascule',
      'es': 'Caja de balancines',
      'de': 'Rocker-Box',
      'pl': 'Rocker Box',
      'ru': 'Рокер Коробка',
      'uk': 'Рокерна коробка',
      'ko': '로커 박스',
      'zh': '摇杆箱',
      'ja': 'ロッカーボックス'
    }, {
      'id': 'RollingMill',
      'en': 'Rolling Mill',
      'fr': 'Laminoir',
      'es': 'Taller de laminación',
      'de': 'Walzwerk',
      'pl': 'Walcownia',
      'ru': 'Прокатный стан',
      'uk': 'Прокатний стан',
      'ko': '압연 공장',
      'zh': '轧机',
      'ja': '圧延装置'
    }, {
      'id': 'RootCampfireSalad',
      'en': 'Root Campfire Salad',
      'fr': 'Salade de racines au feu de camp',
      'es': 'Ensalada De Fogata De Raíz',
      'de': 'Wurzel-Lagerfeuer-Salat',
      'pl': 'Sałatka z Ogniskiem Korzeń',
      'ru': 'Салат из корней у костра',
      'uk': 'Салат з коренем багаття',
      'ko': '루트 캠프파이어 샐러드',
      'zh': '根营火沙拉',
      'ja': 'ルートキャンプファイヤーサラダ'
    }, {
      'id': 'RootCampfireStew',
      'en': 'Root Campfire Stew',
      'fr': 'Ragoût de racine au feu de camp',
      'es': 'Guiso de hoguera de raíz',
      'de': 'Lagerfeuereintopf mit Wurzeln',
      'pl': 'Korzeń Ogniska Gulasz',
      'ru': 'Похлебка из корней у костра',
      'uk': 'Тушковане з коренеплоду багаття',
      'ko': '루트 모닥불 스튜',
      'zh': '根营火炖',
      'ja': 'ルートキャンプファイヤーシチュー'
    }, {
      'id': 'RubberWheel',
      'en': 'Rubber Wheel',
      'fr': 'Roue en caoutchouc',
      'es': 'rueda de goma',
      'de': 'Gummirad',
      'pl': 'Gumowe koło',
      'ru': 'Резиновое колесо',
      'uk': 'Гумове колесо',
      'ko': '고무 바퀴',
      'zh': '橡胶轮',
      'ja': 'ラバーホイール'
    }, {
      'id': 'RugLarge',
      'en': 'Rug Large',
      'fr': 'Tapis Grand',
      'es': 'Alfombra Grande',
      'de': 'Teppich groß',
      'pl': 'Dywan duży',
      'ru': 'Ковер Большой',
      'uk': 'Килимок великий',
      'ko': '러그 라지',
      'zh': '大地毯',
      'ja': 'ラグラージ'
    }, {
      'id': 'RugMedium',
      'en': 'Rug Medium',
      'fr': 'Tapis moyen',
      'es': 'Alfombra Mediana',
      'de': 'Teppich mittel',
      'pl': 'Dywan średni',
      'ru': 'Ковер Средний',
      'uk': 'Килимок середній',
      'ko': '러그 미디엄',
      'zh': '地毯中号',
      'ja': 'ラグミディアム'
    }, {
      'id': 'RugSmall',
      'en': 'Rug Small',
      'fr': 'Tapis Petit',
      'es': 'Alfombra Pequeña',
      'de': 'Teppich klein',
      'pl': 'Dywan Mały',
      'ru': 'Ковер Маленький',
      'uk': 'Килимок маленький',
      'ko': '러그 스몰',
      'zh': '小地毯',
      'ja': 'ラグスモール'
    }, {
      'id': 'RunningShoes',
      'en': 'Running Shoes',
      'fr': 'Chaussures de course',
      'es': 'Zapatos para correr',
      'de': 'Laufschuhe',
      'pl': 'Buty do biegania',
      'ru': 'Беговая обувь',
      'uk': 'Кросівки',
      'ko': '운동화',
      'zh': '跑鞋',
      'ja': 'ランニングシューズ'
    }, {
      'id': 'SaltBasket',
      'en': 'Salt Basket',
      'fr': 'Panier à sel',
      'es': 'Cesta de sal',
      'de': 'Salzkorb',
      'pl': 'Kosz na sól',
      'ru': 'Соляная корзина',
      'uk': 'Кошик для солі',
      'ko': '소금 바구니',
      'zh': '盐篮',
      'ja': '塩かご'
    }, {
      'id': 'SandConcentrate',
      'en': 'Sand Concentrate',
      'fr': 'Concentré de sable',
      'es': 'concentrado de arena',
      'de': 'Sandkonzentrat',
      'pl': 'Koncentrat piasku',
      'ru': 'Концентрат песка',
      'uk': 'Концентрат піску',
      'ko': '모래 농축액',
      'zh': '砂精矿',
      'ja': '砂濃縮物'
    }, {
      'id': 'SandConcentrateLv2',
      'en': 'Sand Concentrate Lv2',
      'fr': 'Concentré de sable Lv2',
      'es': 'Arena concentrada Lv2',
      'de': 'Sandkonzentrat Lv2',
      'pl': 'Koncentrat piasku Lv2',
      'ru': 'Песчаный концентрат Lv2',
      'uk': 'Концентрат піску Lv2',
      'ko': '모래 농축 Lv2',
      'zh': '砂浓缩 Lv2',
      'ja': 'サンドコンセントレートLv2'
    }, {
      'id': 'SandConcentrateLv3',
      'en': 'Sand Concentrate Lv3',
      'fr': 'Concentré de sable Lv3',
      'es': 'Arena concentrada Lv3',
      'de': 'Sandkonzentrat Lv3',
      'pl': 'Koncentrat piasku Lv3',
      'ru': 'Концентрат песка Lv3',
      'uk': 'Концентрат піску Lv3',
      'ko': '모래 농축 Lv3',
      'zh': '砂浓缩 Lv3',
      'ja': 'サンドコンセントレートLv3'
    }, {
      'id': 'Sawmill',
      'en': 'Sawmill',
      'fr': 'Scierie',
      'es': 'Aserradero',
      'de': 'Sägewerk',
      'pl': 'Tartak',
      'ru': 'Лесопилка',
      'uk': 'Лісопильний завод',
      'ko': '제재소',
      'zh': '锯木厂',
      'ja': '製材所'
    }, {
      'id': 'ScrapMeat',
      'en': 'Scrap Meat',
      'fr': 'Déchets de viande',
      'es': 'Carne de desecho',
      'de': 'Fleischreste',
      'pl': 'Złom Mięsa',
      'ru': 'Мясной лом',
      'uk': 'М\u0027ясний лом',
      'ko': '스크랩 미트',
      'zh': '废肉',
      'ja': 'スクラップミート'
    }, {
      'id': 'ScreeningMachine',
      'en': 'Screening Machine',
      'fr': 'Machine de criblage',
      'es': 'Máquina de cribado',
      'de': 'Siebmaschine',
      'pl': 'Maszyna do przesiewania',
      'ru': 'Просеивающая машина',
      'uk': 'Машина для просіювання',
      'ko': '스크리닝 머신',
      'zh': '筛分机',
      'ja': 'スクリーニング機'
    }, {
      'id': 'ScrewPress',
      'en': 'Screw Press',
      'fr': 'Presse à vis',
      'es': 'Tornillo prensado',
      'de': 'Schneckenpresse',
      'pl': 'Prasa śrubowa',
      'ru': 'Винтовой пресс',
      'uk': 'Гвинтовий прес',
      'ko': '스크류 프레스',
      'zh': '螺旋压力机',
      'ja': 'スクリュープレス'
    }, {
      'id': 'Screws',
      'en': 'Screws',
      'fr': 'Des vis',
      'es': 'Tornillos',
      'de': 'Schrauben',
      'pl': 'Śruby',
      'ru': 'Винты',
      'uk': 'Гвинти',
      'ko': '나사',
      'zh': '螺丝',
      'ja': 'ネジ'
    }, {
      'id': 'SearedMeat',
      'en': 'Seared Meat',
      'fr': 'Viande Poêlée',
      'es': 'Carne Chamuscada',
      'de': 'Gebratenes Fleisch',
      'pl': 'Pieczone mięso',
      'ru': 'Жареное мясо',
      'uk': 'Обсмажене м\u0027ясо',
      'ko': '구운 고기',
      'zh': '烤肉',
      'ja': '焼き肉'
    }, {
      'id': 'SeededCamasRoll',
      'en': 'Seeded Camas Roll',
      'fr': 'Rouleau de camas ensemencées',
      'es': 'Rollo de Camas con Semillas',
      'de': 'Gesäte Camas-Rolle',
      'pl': 'Rolka z nasionami Camas',
      'ru': 'Камас Ролл с семенами',
      'uk': 'Ролл Camas з насінням',
      'ko': '시드 카마스 롤',
      'zh': '种子卡马斯卷',
      'ja': 'シードキャマスロール'
    }, {
      'id': 'SensorBasedBeltSorter',
      'en': 'Sensor Based Belt Sorter',
      'fr': 'Trieur de bande basé sur capteur',
      'es': 'Clasificador de banda basado en sensor',
      'de': 'Sensorbasierter Bandsortierer',
      'pl': 'Sortownik taśmowy oparty na czujnikach',
      'ru': 'Сенсорный сортировщик лент',
      'uk': 'Сортувальник на основі датчиків',
      'ko': '센서 기반 벨트 분류기',
      'zh': '基于传感器的皮带分拣机',
      'ja': 'センサーベースのベルトソーター'
    }, {
      'id': 'SensuousSeaPizza',
      'en': 'Sensuous Sea Pizza',
      'fr': 'Pizza sensuelle de la mer',
      'es': 'Pizza de mar sensual',
      'de': 'Sinnliche Meerespizza',
      'pl': 'Zmysłowa Morska Pizza',
      'ru': 'Чувственная морская пицца',
      'uk': 'Чуттєва морська піца',
      'ko': '센슈어스 씨피자',
      'zh': '感性海比萨',
      'ja': '官能的な海のピザ'
    }, {
      'id': 'Servo',
      'en': 'Servo',
      'fr': 'Servomoteur',
      'es': 'servo',
      'de': 'Servo',
      'pl': 'Serwo',
      'ru': 'Сервопривод',
      'uk': 'Сервопривод',
      'ko': '서보 기구',
      'zh': '伺服',
      'ja': 'サーボ'
    }, {
      'id': 'Shaper',
      'en': 'Shaper',
      'fr': 'Façonneur',
      'es': 'Moldeador',
      'de': 'Former',
      'pl': 'Shaper',
      'ru': 'Шейпер',
      'uk': 'Формувач',
      'ko': '셰이퍼',
      'zh': '塑形者',
      'ja': '形作る人'
    }, {
      'id': 'SharkFilletSoup',
      'en': 'Shark Fillet Soup',
      'fr': 'Soupe au filet de requin',
      'es': 'Sopa De Filete De Tiburón',
      'de': 'Haifischfilet-Suppe',
      'pl': 'Zupa z Polędwicy Z Rekina',
      'ru': 'Суп из филе акулы',
      'uk': 'Суп з філе акули',
      'ko': '상어 필레 수프',
      'zh': '鲨鱼片汤',
      'ja': 'サメの切り身のスープ'
    }, {
      'id': 'SheepMount',
      'en': 'Sheep Mount',
      'fr': 'Mont Mouton',
      'es': 'Monte Ovejas',
      'de': 'Schafberg',
      'pl': 'Wierzchowiec owiec',
      'ru': 'Овечья гора',
      'uk': 'Овечий гора',
      'ko': '쉽마운트',
      'zh': '羊山',
      'ja': '羊の山'
    }, {
      'id': 'ShelfCabinet',
      'en': 'Shelf Cabinet',
      'fr': 'Armoire à étagères',
      'es': 'Gabinete de estantería',
      'de': 'Regalschrank',
      'pl': 'Szafka z półkami',
      'ru': 'Полка Шкаф',
      'uk': 'Стелаж',
      'ko': '선반 캐비닛',
      'zh': '货架柜',
      'ja': '棚キャビネット'
    }, {
      'id': 'Shorts',
      'en': 'Shorts',
      'fr': 'Shorts',
      'es': 'Pantalones cortos',
      'de': 'Kurze Hose',
      'pl': 'Spodenki',
      'ru': 'Шорты',
      'uk': 'Шорти',
      'ko': '반바지',
      'zh': '短裤',
      'ja': 'ショーツ'
    }, {
      'id': 'SimmeredMeat',
      'en': 'Simmered Meat',
      'fr': 'Viande Mijotée',
      'es': 'Carne cocida a fuego lento',
      'de': 'Gekochtes Fleisch',
      'pl': 'Mięso Duszone',
      'ru': 'Вареное мясо',
      'uk': 'Варене м\u0027ясо',
      'ko': '조림 고기',
      'zh': '卤肉',
      'ja': '煮込み肉'
    }, {
      'id': 'SimpleSyrup',
      'en': 'Simple Syrup',
      'fr': 'Sirop simple',
      'es': 'Jarabe sencillo',
      'de': 'Einfacher Syrup',
      'pl': 'Prosty syrop',
      'ru': 'Обычный сироп',
      'uk': 'Простий сироп',
      'ko': '슈가시럽',
      'zh': '简单糖浆',
      'ja': 'シンプルなシロップ'
    }, {
      'id': 'Sink',
      'en': 'Sink',
      'fr': 'Évier',
      'es': 'Pileta',
      'de': 'Waschbecken',
      'pl': 'Zlew',
      'ru': 'Раковина',
      'uk': 'Раковина',
      'ko': '싱크대',
      'zh': '下沉',
      'ja': 'シンク'
    }, {
      'id': 'SkidSteer',
      'en': 'Skid Steer',
      'fr': 'Skid Steer',
      'es': 'Minicargador',
      'de': 'Kompaktlader',
      'pl': 'Skid Steer',
      'ru': 'Погрузчик с бортовым поворотом',
      'uk': 'Міні навантажувач',
      'ko': '스키드 스티어',
      'zh': '滑移',
      'ja': 'スキッドステア'
    }, {
      'id': 'SmallBathMat',
      'en': 'Small Bath Mat',
      'fr': 'Petit tapis de bain',
      'es': 'Alfombra de baño pequeña',
      'de': 'Kleine Badematte',
      'pl': 'Mała mata do kąpieli',
      'ru': 'Маленький коврик для ванной',
      'uk': 'Маленький килимок для ванни',
      'ko': '작은 목욕 매트',
      'zh': '小浴垫',
      'ja': '小さなバスマット'
    }, {
      'id': 'WeaveSmallBathMat',
      'en': 'Weave Small Bath Mat',
      'fr': 'Petit tapis de bain tissé',
      'es': 'Alfombrilla de baño pequeña de tejido',
      'de': 'Weben Sie kleine Badematte',
      'pl': 'Splot mała mata do kąpieli',
      'ru': 'Соткать маленький коврик для ванной',
      'uk': 'Плетіть маленький килимок для ванни',
      'ko': '작은 목욕 매트 위브',
      'zh': '编织小浴垫',
      'ja': '小さなバスマットを編む'
    }, {
      'id': 'SmallHangingAshlarStoneSign',
      'en': 'Small Hanging Ashlar Stone Sign',
      'fr': 'Petite enseigne en pierre de taille à suspendre',
      'es': 'Letrero Colgante Pequeño de Sillería',
      'de': 'Kleines hängendes Quadersteinschild',
      'pl': 'Mały wiszący znak z kamienia Ashlar',
      'ru': 'Маленький висячий знак из тесаного камня',
      'uk': 'Невеликий висячий кам\u0027яний знак',
      'ko': '작은 교수형 Ashlar 돌 기호',
      'zh': '小挂方石标牌',
      'ja': '小さなぶら下がっている切石の石のサイン'
    }, {
      'id': 'SmallHangingLumberSign',
      'en': 'Small Hanging Lumber Sign',
      'fr': 'Petit panneau de bois suspendu',
      'es': 'Letrero de madera colgante pequeño',
      'de': 'Kleines hängendes Holzschild',
      'pl': 'Mały wiszący znak drewna',
      'ru': 'Маленький висячий деревянный знак',
      'uk': 'Невеликий висить пиломатеріалів знак',
      'ko': '작은 교수형 목재 기호',
      'zh': '小挂木牌',
      'ja': '小さなぶら下がっている材木サイン'
    }, {
      'id': 'SmallHangingMortaredStoneSign',
      'en': 'Small Hanging Mortared Stone Sign',
      'fr': 'Petit panneau en pierre mortier suspendu',
      'es': 'Pequeño letrero colgante de piedra con mortero',
      'de': 'Kleines hängendes Schild aus gemörteltem Stein',
      'pl': 'Mały wiszący znak z zaprawą murarską',
      'ru': 'Небольшой висящий каменный знак из известкового раствора',
      'uk': 'Невеликий висячий кам\u0027яний знак',
      'ko': '작은 교수형 모르타르 스톤 사인',
      'zh': '小挂砂浆石标牌',
      'ja': '小さなぶら下がっているモルタル石の看板'
    }, {
      'id': 'SmallHangingWoodSign',
      'en': 'Small Hanging Wood Sign',
      'fr': 'Petite enseigne en bois suspendue',
      'es': 'Letrero de madera colgante pequeño',
      'de': 'Kleines hängendes Holzschild',
      'pl': 'Mały wiszący znak drewna',
      'ru': 'Маленький висячий деревянный знак',
      'uk': 'Невеликий висить дерев\u0027яний знак',
      'ko': '작은 교수형 나무 기호',
      'zh': '小挂木牌',
      'ja': '小さなハンギングウッドサイン'
    }, {
      'id': 'SmallSink',
      'en': 'Small Sink',
      'fr': 'Petit évier',
      'es': 'fregadero pequeño',
      'de': 'Kleines Waschbecken',
      'pl': 'Mały zlew',
      'ru': 'Маленькая раковина',
      'uk': 'Маленька мийка',
      'ko': '작은 세면대',
      'zh': '小水槽',
      'ja': '小さなシンク'
    }, {
      'id': 'SmallStandingAshlarStoneSign',
      'en': 'Small Standing Ashlar Stone Sign',
      'fr': 'Petite enseigne en pierre de taille debout',
      'es': 'Pequeño letrero de piedra de sillería de pie',
      'de': 'Kleines stehendes Quadersteinschild',
      'pl': 'Mały stojący znak z kamienia Ashlar',
      'ru': 'Небольшой стоящий знак из тесаного камня',
      'uk': 'Невеликий стоячий кам\u0027яний знак',
      'ko': '작은 서 Ashlar 돌 기호',
      'zh': '小型立式方石标志',
      'ja': '小さな切石の石の看板'
    }, {
      'id': 'SmallStandingLumberSign',
      'en': 'Small Standing Lumber Sign',
      'fr': 'Petit panneau de bois debout',
      'es': 'Pequeño letrero de madera de pie',
      'de': 'Kleines stehendes Holzschild',
      'pl': 'Mały stojący znak drewna',
      'ru': 'Небольшой стоячий знак пиломатериалов',
      'uk': 'Невеликий стоячий пиломатеріали знак',
      'ko': '작은 서 목재 기호',
      'zh': '小立木标志',
      'ja': '小さな立っている材木サイン'
    }, {
      'id': 'SmallStandingMortaredStoneSign',
      'en': 'Small Standing Mortared Stone Sign',
      'fr': 'Petit panneau de pierre mortier debout',
      'es': 'Pequeño letrero de piedra con mortero de pie',
      'de': 'Kleines stehendes Schild aus gemörteltem Stein',
      'pl': 'Mały stojący znak z zaprawą murarską',
      'ru': 'Небольшой стоячий каменный знак из известкового раствора',
      'uk': 'Невеликий стоячий кам\u0027яний знак',
      'ko': '작은 서 박격포 돌 기호',
      'zh': '小型立式砂浆石标牌',
      'ja': '小さな立っているモルタル石のサイン'
    }, {
      'id': 'SmallStandingWoodSign',
      'en': 'Small Standing Wood Sign',
      'fr': 'Petite enseigne en bois sur pied',
      'es': 'Pequeño letrero de madera de pie',
      'de': 'Kleines stehendes Holzschild',
      'pl': 'Mały stojący znak drewna',
      'ru': 'Небольшой деревянный знак',
      'uk': 'Невеликий стоячий дерев\u0027яний знак',
      'ko': '작은 서 나무 기호',
      'zh': '小立木标志',
      'ja': '小さな立っている木の看板'
    }, {
      'id': 'SmallWoodCart',
      'en': 'Small Wood Cart',
      'fr': 'Petit chariot en bois',
      'es': 'Carro de madera pequeño',
      'de': 'Kleiner Holzwagen',
      'pl': 'Mały wózek na drewno',
      'ru': 'Маленькая деревянная тележка',
      'uk': 'Маленький дерев\u0027яний візок',
      'ko': '작은 나무 카트',
      'zh': '小木车',
      'ja': '小さな木製カート'
    }, {
      'id': 'SmeltingUpgrade',
      'en': 'Smelting Upgrade',
      'fr': 'Mise à niveau de la fusion',
      'es': 'Actualización de fundición',
      'de': 'Schmelz-Upgrade',
      'pl': 'Ulepszenie wytopu',
      'ru': 'Обновление плавки',
      'uk': 'Оновлення плавлення',
      'ko': '제련 업그레이드',
      'zh': '冶炼升级',
      'ja': '製錬のアップグレード'
    }, {
      'id': 'SmithApron',
      'en': 'Smith Apron',
      'fr': 'Tablier de forgeron',
      'es': 'delantal herrero',
      'de': 'Schmied Schürze',
      'pl': 'Smith Fartuch',
      'ru': 'Фартук Смита',
      'uk': 'Фартух Сміта',
      'ko': '스미스 앞치마',
      'zh': '史密斯围裙',
      'ja': 'スミスエプロン'
    }, {
      'id': 'SmithBandana',
      'en': 'Smith Bandana',
      'fr': 'Bandana Smith',
      'es': 'Pañuelo Smith',
      'de': 'Schmied Bandana',
      'pl': 'Chustka Smith',
      'ru': 'Смит Бандана',
      'uk': 'Бандана Сміта',
      'ko': '스미스 반다나',
      'zh': '史密斯头巾',
      'ja': 'スミスバンダナ'
    }, {
      'id': 'SmithBoots',
      'en': 'Smith Boots',
      'fr': 'Bottes de forgeron',
      'es': 'Botas de herrero',
      'de': 'Smith-Stiefel',
      'pl': 'Kowalskie buty',
      'ru': 'Сапоги Смита',
      'uk': 'Черевики Сміта',
      'ko': '스미스 부츠',
      'zh': '史密斯靴',
      'ja': 'スミスブーツ'
    }, {
      'id': 'SmithGloves',
      'en': 'Smith Gloves',
      'fr': 'Gants de forgeron',
      'es': 'Guantes de herrero',
      'de': 'Smith-Handschuhe',
      'pl': 'Rękawiczki Smitha',
      'ru': 'Смит перчатки',
      'uk': 'Рукавички Сміта',
      'ko': '스미스 장갑',
      'zh': '史密斯手套',
      'ja': 'スミスグローブ'
    }, {
      'id': 'SmithPants',
      'en': 'Smith Pants',
      'fr': 'Pantalon Smith',
      'es': 'Pantalones Smith',
      'de': 'Smith-Hosen',
      'pl': 'Spodnie Smith',
      'ru': 'Штаны Смита',
      'uk': 'Штани Сміта',
      'ko': '스미스 팬츠',
      'zh': '史密斯裤',
      'ja': 'スミスパンツ'
    }, {
      'id': 'SmoothGutNoodleRoll',
      'en': 'Smooth Gut Noodle Roll',
      'fr': 'Rouleau de nouilles au boyau lisse',
      'es': 'Rollo de fideos de tripa suave',
      'de': 'Glatte Darmnudelrolle',
      'pl': 'Gładka bułka z makaronem',
      'ru': 'Гладкий рулет с лапшой',
      'uk': 'Рулет з локшиною з гладкою кишкою',
      'ko': '부드러운 내장 국수 롤',
      'zh': '光滑肠面卷',
      'ja': 'なめらかなガットヌードルロール'
    }, {
      'id': 'SoilSampler',
      'en': 'Soil Sampler',
      'fr': 'Échantillonneur de sol',
      'es': 'Muestreador de suelo',
      'de': 'Bodenprobenehmer',
      'pl': 'Próbnik gleby',
      'ru': 'Пробоотборник почвы',
      'uk': 'Пробовідбірник ґрунту',
      'ko': '토양 샘플러',
      'zh': '土壤采样器',
      'ja': '土壌サンプラー'
    }, {
      'id': 'SolarGenerator',
      'en': 'Solar Generator',
      'fr': 'Générateur solaire',
      'es': 'generador solar',
      'de': 'Solargenerator',
      'pl': 'Generator słoneczny',
      'ru': 'Солнечный генератор',
      'uk': 'Сонячний генератор',
      'ko': '태양열 발전기',
      'zh': '太阳能发电机',
      'ja': 'ソーラー発電機'
    }, {
      'id': 'SpikyRoll',
      'en': 'Spiky Roll',
      'fr': 'Rouleau épineux',
      'es': 'rollo puntiagudo',
      'de': 'Stachelige Rolle',
      'pl': 'kolczasta bułka',
      'ru': 'Колючий ролл',
      'uk': 'Шипчатий рол',
      'ko': '뾰족한 롤',
      'zh': '尖刺卷',
      'ja': 'スパイキーロール'
    }, {
      'id': 'SpinMelter',
      'en': 'Spin Melter',
      'fr': 'Fondoir à rotation',
      'es': 'Fusor giratorio',
      'de': 'Schleuderschmelzer',
      'pl': 'Wirówka',
      'ru': 'Спин Плавильщик',
      'uk': 'Віджимний плавитель',
      'ko': '스핀 멜터',
      'zh': '旋转熔炉',
      'ja': 'スピンメルター'
    }, {
      'id': 'SquareBelt',
      'en': 'Square Belt',
      'fr': 'Ceinture carrée',
      'es': 'cinturón cuadrado',
      'de': 'Quadratischer Gürtel',
      'pl': 'Kwadratowy pasek',
      'ru': 'Квадратный пояс',
      'uk': 'Квадратний пояс',
      'ko': '사각 벨트',
      'zh': '方带',
      'ja': 'スクエアベルト'
    }, {
      'id': 'StampMill',
      'en': 'Stamp Mill',
      'fr': 'Moulin à timbres',
      'es': 'Molino de sellos',
      'de': 'Stempelmühle',
      'pl': 'Pieczęć Młyn',
      'ru': 'Штамповая мельница',
      'uk': 'Штамповий млин',
      'ko': '스탬프 밀',
      'zh': '邮票厂',
      'ja': 'スタンプミル'
    }, {
      'id': 'StandingGlassSign',
      'en': 'Standing Glass Sign',
      'fr': 'Signe de verre debout',
      'es': 'Letrero de vidrio de pie',
      'de': 'Stehendes Glasschild',
      'pl': 'Stojący szklany znak',
      'ru': 'Постоянный стеклянный знак',
      'uk': 'Стоячий скляний знак',
      'ko': '스탠딩 글라스 사인',
      'zh': '站立玻璃标志',
      'ja': 'スタンディンググラスサイン'
    }, {
      'id': 'StandingLongSteelSign',
      'en': 'Standing Long Steel Sign',
      'fr': 'Panneau en acier long debout',
      'es': 'Letrero de acero largo de pie',
      'de': 'Stehendes langes Stahlschild',
      'pl': 'Stojący długi znak ze stali',
      'ru': 'Постоянный длинный стальной знак',
      'uk': 'Стоячий довгий знак сталі',
      'ko': '서 있는 긴 강철 기호',
      'zh': '站立长钢标志',
      'ja': '立っている長い鋼の印'
    }, {
      'id': 'StandingSteelBrickSign',
      'en': 'Standing Steel Brick Sign',
      'fr': 'Panneau de brique en acier debout',
      'es': 'Letrero de ladrillo de acero de pie',
      'de': 'Stehendes Backsteinschild aus Stahl',
      'pl': 'Stojący znak ze stali ceglanej',
      'ru': 'Стальной кирпичный знак',
      'uk': 'Знак стоячи сталевої цегли',
      'ko': '서 있는 강철 벽돌 기호',
      'zh': '立式钢砖标志',
      'ja': '立っている鋼のレンガのサイン'
    }, {
      'id': 'SteamEngine',
      'en': 'Steam Engine',
      'fr': 'Machine à vapeur',
      'es': 'Máquina de vapor',
      'de': 'Dampfmaschine',
      'pl': 'Silnik parowy',
      'ru': 'Паровой двигатель',
      'uk': 'Паровий двигун',
      'ko': '증기 기관',
      'zh': '蒸汽机',
      'ja': '蒸気機関'
    }, {
      'id': 'SteamTractorHarvester',
      'en': 'Steam Tractor Harvester',
      'fr': 'Récolteuse de tracteur à vapeur',
      'es': 'Cosechadora de tractor de vapor',
      'de': 'Dampftraktor-Erntemaschine',
      'pl': 'Kombajn do ciągnika parowego',
      'ru': 'Комбайн парового трактора',
      'uk': 'Паровий тракторний комбайн',
      'ko': '증기 트랙터 수확기',
      'zh': '蒸汽拖拉机收割机',
      'ja': 'スチームトラクターハーベスタ'
    }, {
      'id': 'SteamTractor',
      'en': 'Steam Tractor',
      'fr': 'Tracteur à vapeur',
      'es': 'Tractor de vapor',
      'de': 'Dampftraktor',
      'pl': 'Ciągnik parowy',
      'ru': 'Паровой трактор',
      'uk': 'Паровий трактор',
      'ko': '증기 트랙터',
      'zh': '蒸汽拖拉机',
      'ja': 'スチームトラクター'
    }, {
      'id': 'SteamTractorPlow',
      'en': 'Steam Tractor Plow',
      'fr': 'Charrue de tracteur à vapeur',
      'es': 'Arado de tractor de vapor',
      'de': 'Dampftraktor Pflug',
      'pl': 'Pług ciągnika parowego',
      'ru': 'Плуг для парового трактора',
      'uk': 'Паровий тракторний плуг',
      'ko': '증기 트랙터 쟁기',
      'zh': '蒸汽拖拉机犁',
      'ja': '蒸気トラクタープラウ'
    }, {
      'id': 'SteamTractorSower',
      'en': 'Steam Tractor Sower',
      'fr': 'Semeur de tracteur à vapeur',
      'es': 'Sembradora de tractor de vapor',
      'de': 'Dampftraktor Sämann',
      'pl': 'Ciągnik parowy siewnik',
      'ru': 'Сеялка парового трактора',
      'uk': 'Парова тракторна сівалка',
      'ko': '증기 트랙터 파종기',
      'zh': '蒸汽拖拉机播种机',
      'ja': '蒸気トラクター種まき'
    }, {
      'id': 'SteamTruck',
      'en': 'Steam Truck',
      'fr': 'Camion à vapeur',
      'es': 'camión de vapor',
      'de': 'Dampfwagen',
      'pl': 'Ciężarówka parowa',
      'ru': 'Паровой грузовик',
      'uk': 'Парова вантажівка',
      'ko': '증기 트럭',
      'zh': '蒸汽卡车',
      'ja': '蒸気トラック'
    }, {
      'id': 'SteelAxe',
      'en': 'Steel Axe',
      'fr': 'Hache d\u0027acier',
      'es': 'Hacha de acero',
      'de': 'Stahlaxt',
      'pl': 'Stalowy Topór',
      'ru': 'Стальной топор',
      'uk': 'Сталева сокира',
      'ko': '강철 도끼',
      'zh': '钢斧',
      'ja': '鋼の斧'
    }, {
      'id': 'SteelAxle',
      'en': 'Steel Axle',
      'fr': 'Essieu en acier',
      'es': 'Eje de acero',
      'de': 'Stahlachse',
      'pl': 'Oś stalowa',
      'ru': 'Стальная ось',
      'uk': 'Сталева вісь',
      'ko': '스틸 액슬',
      'zh': '钢轴',
      'ja': 'スチールアクスル'
    }, {
      'id': 'SteelBar',
      'en': 'Steel Bar',
      'fr': 'Barre d\u0027acier',
      'es': 'Barra de acero',
      'de': 'Stahlstange',
      'pl': 'Sztabka stali',
      'ru': 'Стальной стержень',
      'uk': 'Сталевий пруток',
      'ko': '스틸 바',
      'zh': '金属棒',
      'ja': 'スチール棒'
    }, {
      'id': 'SteelCeilingLight',
      'en': 'Steel Ceiling Light',
      'fr': 'Plafonnier en acier',
      'es': 'Luz de techo de acero',
      'de': 'Deckenleuchte aus Stahl',
      'pl': 'Stalowe oświetlenie sufitowe',
      'ru': 'Стальной потолочный светильник',
      'uk': 'Сталевий стельовий світильник',
      'ko': '스틸 천장 조명',
      'zh': '钢吸顶灯',
      'ja': 'スチールシーリングライト'
    }, {
      'id': 'SteelFloorLamp',
      'en': 'Steel Floor Lamp',
      'fr': 'Lampadaire en acier',
      'es': 'Lámpara de pie de acero',
      'de': 'Stehlampe aus Stahl',
      'pl': 'Stalowa lampa podłogowa',
      'ru': 'Стальной торшер',
      'uk': 'Сталевий торшер',
      'ko': '스틸 플로어 램프',
      'zh': '钢落地灯',
      'ja': 'スチールフロアランプ'
    }, {
      'id': 'SteelGear',
      'en': 'Steel Gear',
      'fr': 'Engrenage en acier',
      'es': 'Engranaje de acero',
      'de': 'Stahlzahnrad',
      'pl': 'Stalowy bieg',
      'ru': 'Стальная шестерня',
      'uk': 'Сталева шестерня',
      'ko': '스틸 기어',
      'zh': '钢齿轮',
      'ja': 'スチールギア'
    }, {
      'id': 'SteelGearbox',
      'en': 'Steel Gearbox',
      'fr': 'Boîte de vitesses en acier',
      'es': 'Caja de cambios de acero',
      'de': 'Getriebe aus Stahl',
      'pl': 'Stalowa skrzynia biegów',
      'ru': 'Стальная коробка передач',
      'uk': 'Сталева коробка передач',
      'ko': '강철 변속기',
      'zh': '钢齿轮箱',
      'ja': 'スチールギアボックス'
    }, {
      'id': 'SteelHammer',
      'en': 'Steel Hammer',
      'fr': 'Marteau en acier',
      'es': 'Martillo de acero',
      'de': 'Stahlhammer',
      'pl': 'Młot stalowy',
      'ru': 'Стальной молот',
      'uk': 'Сталевий молоток',
      'ko': '강철 망치',
      'zh': '钢锤',
      'ja': 'スチールハンマー'
    }, {
      'id': 'SteelHoe',
      'en': 'Steel Hoe',
      'fr': 'Houe en acier',
      'es': 'Azada de acero',
      'de': 'Stahlhacke',
      'pl': 'Stalowa motyka',
      'ru': 'Стальная мотыга',
      'uk': 'Сталева мотика',
      'ko': '강철 괭이',
      'zh': '钢锄头',
      'ja': '鋼くわ'
    }, {
      'id': 'SteelMachete',
      'en': 'Steel Machete',
      'fr': 'Machette en acier',
      'es': 'Machete de acero',
      'de': 'Machete aus Stahl',
      'pl': 'Stalowa maczeta',
      'ru': 'Стальной мачете',
      'uk': 'Сталеве мачете',
      'ko': '강철 마체테',
      'zh': '钢砍刀',
      'ja': 'スチールマチェーテ'
    }, {
      'id': 'SteelPickaxe',
      'en': 'Steel Pickaxe',
      'fr': 'Pioche en acier',
      'es': 'Pico de acero',
      'de': 'Spitzhacke aus Stahl',
      'pl': 'Kilof ze stali',
      'ru': 'Стальная кирка',
      'uk': 'Сталева кирка',
      'ko': '강철 곡괭이',
      'zh': '钢镐',
      'ja': '鋼のつるはし'
    }, {
      'id': 'SteelPipe',
      'en': 'Steel Pipe',
      'fr': 'Tuyaux en acier',
      'es': 'Tubo de acero',
      'de': 'Stahlrohr',
      'pl': 'Stalowa rura',
      'ru': 'Стальная труба',
      'uk': 'Сталева труба',
      'ko': '쇠 파이프',
      'zh': '钢管',
      'ja': '鋼管'
    }, {
      'id': 'SteelPlate',
      'en': 'Steel Plate',
      'fr': 'Plaque d\u0027acier',
      'es': 'Placa de acero',
      'de': 'Stahlplatte',
      'pl': 'Blachy stalowej',
      'ru': 'Стальная пластина',
      'uk': 'Сталева пластина',
      'ko': '강판',
      'zh': '铁盘子',
      'ja': '鋼板'
    }, {
      'id': 'SteelRoadTool',
      'en': 'Steel Road Tool',
      'fr': 'Outil de route en acier',
      'es': 'Herramienta de carretera de acero',
      'de': 'Stahlstraßenwerkzeug',
      'pl': 'Stalowe narzędzie drogowe',
      'ru': 'Стальной дорожный инструмент',
      'uk': 'Сталевий дорожній інструмент',
      'ko': '강철 도로 도구',
      'zh': '钢制道路工具',
      'ja': 'スチールロードツール'
    }, {
      'id': 'SteelSawBlade',
      'en': 'Steel Saw Blade',
      'fr': 'Lame de scie en acier',
      'es': 'Hoja de sierra de acero',
      'de': 'Sägeblatt aus Stahl',
      'pl': 'Stalowy brzeszczot',
      'ru': 'Стальной пильный диск',
      'uk': 'Сталева пилка',
      'ko': '강철 톱날',
      'zh': '钢锯片',
      'ja': 'スチールソーブレード'
    }, {
      'id': 'SteelShovel',
      'en': 'Steel Shovel',
      'fr': 'Pelle en acier',
      'es': 'pala de acero',
      'de': 'Schaufel aus Stahl',
      'pl': 'Łopata ze stali',
      'ru': 'Стальная лопата',
      'uk': 'Сталева лопата',
      'ko': '강철 삽',
      'zh': '钢铲',
      'ja': 'スチールショベル'
    }, {
      'id': 'SteelSickle',
      'en': 'Steel Sickle',
      'fr': 'Faucille en acier',
      'es': 'Hoz de acero',
      'de': 'Sichel aus Stahl',
      'pl': 'Stalowy sierp',
      'ru': 'Стальной серп',
      'uk': 'Сталевий серп',
      'ko': '강철 낫',
      'zh': '钢镰',
      'ja': '鋼の鎌'
    }, {
      'id': 'SteelTableLamp',
      'en': 'Steel Table Lamp',
      'fr': 'Lampe de table en acier',
      'es': 'Lámpara de mesa de acero',
      'de': 'Tischlampe aus Stahl',
      'pl': 'Stalowa lampa stołowa',
      'ru': 'Стальная настольная лампа',
      'uk': 'Сталева настільна лампа',
      'ko': '스틸 테이블 램프',
      'zh': '钢台灯',
      'ja': 'スチールテーブルランプ'
    }, {
      'id': 'StoneBrazier',
      'en': 'Stone Brazier',
      'fr': 'Brasier en pierre',
      'es': 'Brasero de piedra',
      'de': 'Kohlebecken aus Stein',
      'pl': 'Kamienny Kocioł',
      'ru': 'Каменная жаровня',
      'uk': 'Кам\u0027яна жаровня',
      'ko': '돌 화로',
      'zh': '石火盆',
      'ja': 'ストーンブレイザー'
    }, {
      'id': 'StoneRamp',
      'en': 'Stone Ramp',
      'fr': 'Rampe de pierre',
      'es': 'rampa de piedra',
      'de': 'Steinrampe',
      'pl': 'Kamienna rampa',
      'ru': 'Каменная рампа',
      'uk': 'Кам\u0027яна рампа',
      'ko': '스톤 램프',
      'zh': '石坡道',
      'ja': 'ストーンランプ'
    }, {
      'id': 'StoneRoad',
      'en': 'Stone Road',
      'fr': 'Route de pierre',
      'es': 'camino de piedra',
      'de': 'Steinstraße',
      'pl': 'Kamienna Droga',
      'ru': 'Каменная дорога',
      'uk': 'Кам\u0027яна дорога',
      'ko': '돌길',
      'zh': '石路',
      'ja': 'ストーンロード'
    }, {
      'id': 'StoneRoadTool',
      'en': 'Stone Road Tool',
      'fr': 'Outil de route en pierre',
      'es': 'Herramienta Camino de Piedra',
      'de': 'Steinstraßenwerkzeug',
      'pl': 'Narzędzie do kamiennej drogi',
      'ru': 'Каменный дорожный инструмент',
      'uk': 'Кам\u0027яний дорожній інструмент',
      'ko': '돌 도로 도구',
      'zh': '石路工具',
      'ja': 'ストーンロードツール'
    }, {
      'id': 'StopSign',
      'en': 'Stop Sign',
      'fr': 'Panneau stop',
      'es': 'Señal de stop',
      'de': 'Stoppschild',
      'pl': 'Znak stopu',
      'ru': 'Знак остановки',
      'uk': 'Знак зупинки',
      'ko': '정지 신호',
      'zh': '停止标志',
      'ja': '一時停止標識'
    }, {
      'id': 'StorageSilo',
      'en': 'Storage Silo',
      'fr': 'Silo de stockage',
      'es': 'silo de almacenamiento',
      'de': 'Lagersilo',
      'pl': 'Silos magazynowy',
      'ru': 'Бункер для хранения',
      'uk': 'Силос для зберігання',
      'ko': '스토리지 사일로',
      'zh': '存储筒仓',
      'ja': 'ストレージサイロ'
    }, {
      'id': 'Stove',
      'en': 'Stove',
      'fr': 'Le fourneau',
      'es': 'Estufa',
      'de': 'Herd',
      'pl': 'Kuchenka',
      'ru': 'Печь',
      'uk': 'піч',
      'ko': '난로',
      'zh': '火炉',
      'ja': 'ストーブ'
    }, {
      'id': 'StreetSign',
      'en': 'Street Sign',
      'fr': 'Panneau de signalisation',
      'es': 'Cartel de la calle',
      'de': 'Straßenschild',
      'pl': 'Znak drogowy',
      'ru': 'Дорожный знак',
      'uk': 'Знак вулиці',
      'ko': '도로 표지판',
      'zh': '街道路标',
      'ja': '道路標識'
    }, {
      'id': 'Streetlamp',
      'en': 'Streetlamp',
      'fr': 'Réverbère',
      'es': 'Farola',
      'de': 'Straßenlaterne',
      'pl': 'Lampa uliczna',
      'ru': 'Уличный фонарь',
      'uk': 'Вуличний ліхтар',
      'ko': '가로등',
      'zh': '路灯',
      'ja': '街灯'
    }, {
      'id': 'StuffedAlligator',
      'en': 'Stuffed Alligator',
      'fr': 'Alligator farci',
      'es': 'Cocodrilo Relleno',
      'de': 'Gefüllter Alligator',
      'pl': 'Nadziewany aligator',
      'ru': 'Фаршированный аллигатор',
      'uk': 'Фарширований алігатор',
      'ko': '박제 악어',
      'zh': '填充鳄鱼',
      'ja': 'ワニのぬいぐるみ'
    }, {
      'id': 'StuffedBison',
      'en': 'Stuffed Bison',
      'fr': 'Bison Farci',
      'es': 'bisonte relleno',
      'de': 'Gefüllter Bison',
      'pl': 'Faszerowany żubr',
      'ru': 'Фаршированный бизон',
      'uk': 'Фарширований бізон',
      'ko': '박제 들소',
      'zh': '酿野牛',
      'ja': 'バイソンのぬいぐるみ'
    }, {
      'id': 'StuffedElk',
      'en': 'Stuffed Elk',
      'fr': 'Élan farci',
      'es': 'Alce Relleno',
      'de': 'Gefüllter Elch',
      'pl': 'Faszerowany Łoś',
      'ru': 'чучело лося',
      'uk': 'Фарширований лось',
      'ko': '박제 엘크',
      'zh': '酿麋鹿',
      'ja': 'ぬいぐるみエルク'
    }, {
      'id': 'StuffedGoat',
      'en': 'Stuffed Goat',
      'fr': 'Chèvre en peluche',
      'es': 'Cabra Rellena',
      'de': 'Gefüllte Ziege',
      'pl': 'Faszerowana Koza',
      'ru': 'Фаршированная коза',
      'uk': 'Фарширована коза',
      'ko': '박제 염소',
      'zh': '酿山羊',
      'ja': 'ヤギのぬいぐるみ'
    }, {
      'id': 'StuffedJaguar',
      'en': 'Stuffed Jaguar',
      'fr': 'Jaguar en peluche',
      'es': 'Jaguar relleno',
      'de': 'Ausgestopfter Jaguar',
      'pl': 'Nadziewany Jaguar',
      'ru': 'Чучело ягуара',
      'uk': 'Фарширований ягуар',
      'ko': '박제 재규어',
      'zh': '填充捷豹',
      'ja': 'ジャガーのぬいぐるみ'
    }, {
      'id': 'StuffedTurkey',
      'en': 'Stuffed Turkey',
      'fr': 'Dinde farcie',
      'es': 'Pavo relleno',
      'de': 'Gefüllter Truthahn',
      'pl': 'Faszerowany indyk',
      'ru': 'Фаршированная индейка',
      'uk': 'Фарширована індичка',
      'ko': '속을 채운 칠면조',
      'zh': '酿火鸡',
      'ja': 'ぬいぐるみトルコ'
    }, {
      'id': 'StuffedWolf',
      'en': 'Stuffed Wolf',
      'fr': 'Loup en peluche',
      'es': 'Lobo relleno',
      'de': 'Ausgestopfter Wolf',
      'pl': 'wypchany wilk',
      'ru': 'чучело волка',
      'uk': 'Опудала вовка',
      'ko': '박제 늑대',
      'zh': '填充狼',
      'ja': 'オオカミのぬいぐるみ'
    }, {
      'id': 'Substrate',
      'en': 'Substrate',
      'fr': 'Substrat',
      'es': 'Sustrato',
      'de': 'Substrat',
      'pl': 'Podłoże',
      'ru': 'Субстрат',
      'uk': 'Субстрат',
      'ko': '기판',
      'zh': '基质',
      'ja': '基板'
    }, {
      'id': 'BeetSugar',
      'en': 'Beet Sugar',
      'fr': 'Sucre de betterave',
      'es': 'Azúcar de remolacha',
      'de': 'Zuckerrübe',
      'pl': 'Cukier buraczany',
      'ru': 'Свекольный сахар',
      'uk': 'Буряковий цукор',
      'ko': '사탕무',
      'zh': '甜菜糖',
      'ja': 'ビートシュガー'
    }, {
      'id': 'Sugar',
      'en': 'Sugar',
      'fr': 'Sucre',
      'es': 'Azúcar',
      'de': 'Zucker',
      'pl': 'Cukier',
      'ru': 'Сахар',
      'uk': 'Цукор',
      'ko': '설탕',
      'zh': '糖',
      'ja': '砂糖'
    }, {
      'id': 'SunCheese',
      'en': 'Sun Cheese',
      'fr': 'Fromage du soleil',
      'es': 'Queso de sol',
      'de': 'Sonnenkäse',
      'pl': 'Ser Słoneczny',
      'ru': 'Солнечный сыр',
      'uk': 'Сонячний сир',
      'ko': '썬 치즈',
      'zh': '太阳奶酪',
      'ja': 'サンチーズ'
    }, {
      'id': 'SunflowerSeed',
      'en': 'Sunflower Seed',
      'fr': 'Graines de tournesol',
      'es': 'Semilla de girasol',
      'de': 'Sonnenblumensamen',
      'pl': 'Ziarna słonecznika',
      'ru': 'Семян подсолнечника',
      'uk': 'Насіння соняшника',
      'ko': '해바라기 씨',
      'zh': '葵花籽',
      'ja': 'ヒマワリの種'
    }, {
      'id': 'SweetSalad',
      'en': 'Sweet Salad',
      'fr': 'Salade Douce',
      'es': 'Ensalada Dulce',
      'de': 'Süßer Salat',
      'pl': 'Słodka Sałatka',
      'ru': 'Сладкий салат',
      'uk': 'Солодкий салат',
      'ko': '달콤한 샐러드',
      'zh': '甜沙拉',
      'ja': '甘いサラダ'
    }, {
      'id': 'SyntheticRubber',
      'en': 'Synthetic Rubber',
      'fr': 'Caoutchouc synthétique',
      'es': 'Caucho sintético',
      'de': 'Synthesekautschuk',
      'pl': 'Kauczuk syntetyczny',
      'ru': 'Синтетическая резина',
      'uk': 'Синтетичний каучук',
      'ko': '인조 고무',
      'zh': '合成橡胶',
      'ja': '合成ゴム'
    }, {
      'id': 'TailorBowlerHat',
      'en': 'Tailor Bowler Hat',
      'fr': 'Chapeau melon tailleur',
      'es': 'bombín de sastre',
      'de': 'Schneider Melone',
      'pl': 'Melonik krawiecki',
      'ru': 'Шляпа-котелок на заказ',
      'uk': 'Кравець капелюх-котел',
      'ko': '재단사 중산모',
      'zh': '裁缝圆顶礼帽',
      'ja': '山高帽の仕立て'
    }, {
      'id': 'TailorPants',
      'en': 'Tailor Pants',
      'fr': 'Pantalon de tailleur',
      'es': 'pantalones de sastre',
      'de': 'Schneiderhosen',
      'pl': 'Spodnie krawieckie',
      'ru': 'Портной Брюки',
      'uk': 'Кравецькі штани',
      'ko': '재단사 바지',
      'zh': '裁缝裤',
      'ja': 'テーラーパンツ'
    }, {
      'id': 'TailorShirt',
      'en': 'Tailor Shirt',
      'fr': 'Chemise de tailleur',
      'es': 'Camisa a medida',
      'de': 'Schneiderhemd',
      'pl': 'Koszula krawiecka',
      'ru': 'Портной Рубашка',
      'uk': 'Кравецька сорочка',
      'ko': '재단사 셔츠',
      'zh': '裁缝衬衫',
      'ja': 'テーラーシャツ'
    }, {
      'id': 'TailorShoes',
      'en': 'Tailor Shoes',
      'fr': 'Chaussures de tailleur',
      'es': 'Zapatos de sastre',
      'de': 'Schneiderschuhe',
      'pl': 'Buty krawieckie',
      'ru': 'Портной Обувь',
      'uk': 'Кравецьке взуття',
      'ko': '재단사 신발',
      'zh': '裁缝鞋',
      'ja': 'テーラーシューズ'
    }, {
      'id': 'TailoringBasicUpgrade',
      'en': 'Tailoring Basic Upgrade',
      'fr': 'Adapter la mise à niveau de base',
      'es': 'Mejora básica de sastrería',
      'de': 'Anpassungs-Basis-Upgrade',
      'pl': 'Podstawowe uaktualnienie krawiectwa',
      'ru': 'Базовое обновление по пошиву одежды',
      'uk': 'Базове оновлення пошиття',
      'ko': '테일러링 베이직 업그레이드',
      'zh': '剪裁基础升级',
      'ja': '基本的なアップグレードの調整'
    }, {
      'id': 'TailoringModernUpgrade',
      'en': 'Tailoring Modern Upgrade',
      'fr': 'Mise à niveau moderne sur mesure',
      'es': 'Actualización moderna de sastrería',
      'de': 'Modernes Upgrade anpassen',
      'pl': 'Nowoczesna modernizacja na miarę',
      'ru': 'Пошив современного обновления',
      'uk': 'Пошиття Сучасне оновлення',
      'ko': '현대적인 업그레이드 조정',
      'zh': '剪裁现代升级',
      'ja': 'モダンアップグレードの調整'
    }, {
      'id': 'TailoringTable',
      'en': 'Tailoring Table',
      'fr': 'Tableau de couture',
      'es': 'Mesa de sastrería',
      'de': 'Schneidertisch',
      'pl': 'Stół krawiecki',
      'ru': 'Таблица пошива',
      'uk': 'Пошиття столу',
      'ko': '재봉 테이블',
      'zh': '裁缝台',
      'ja': '仕立てテーブル'
    }, {
      'id': 'TallBoots',
      'en': 'Tall Boots',
      'fr': 'Bottes hautes',
      'es': 'Botas altas',
      'de': 'Hohe Stiefel',
      'pl': 'Wysokie buty',
      'ru': 'Высокие сапоги',
      'uk': 'Високі чоботи',
      'ko': '톨부츠',
      'zh': '高筒靴',
      'ja': 'トールブーツ'
    }, {
      'id': 'TallowCandle',
      'en': 'Tallow Candle',
      'fr': 'Bougie de suif',
      'es': 'Vela de sebo',
      'de': 'Talgkerze',
      'pl': 'Świeca łojowa',
      'ru': 'сальная свеча',
      'uk': 'Сальна свічка',
      'ko': '탤로우 캔들',
      'zh': '牛油蜡烛',
      'ja': '獣脂ろうそく'
    }, {
      'id': 'MeltingFat',
      'en': 'Melting Fat',
      'fr': 'Faire fondre la graisse',
      'es': 'Derretir grasa',
      'de': 'Fett schmelzen',
      'pl': 'Topienie tłuszczu',
      'ru': 'Тающий жир',
      'uk': 'Танення жиру',
      'ko': '녹는 지방',
      'zh': '融化脂肪',
      'ja': '溶ける脂肪'
    }, {
      'id': 'RenderFat',
      'en': 'Render Fat',
      'fr': 'Graisse de rendu',
      'es': 'hacer grasa',
      'de': 'Fett rendern',
      'pl': 'Renderuj tłuszcz',
      'ru': 'Рендер жир',
      'uk': 'Зробити жир',
      'ko': '렌더 팻',
      'zh': '渲染脂肪',
      'ja': '脂肪をレンダリングする'
    }, {
      'id': 'TallowLamp',
      'en': 'Tallow Lamp',
      'fr': 'Lampe à suif',
      'es': 'Lámpara de sebo',
      'de': 'Talg-Lampe',
      'pl': 'Lampa łojowa',
      'ru': 'Сальная лампа',
      'uk': 'Сальна лампа',
      'ko': '수지 램프',
      'zh': '牛油灯',
      'ja': '獣脂ランプ'
    }, {
      'id': 'TallowWallLamp',
      'en': 'Tallow Wall Lamp',
      'fr': 'Applique murale en suif',
      'es': 'Lámpara de pared de sebo',
      'de': 'Talg Wandlampe',
      'pl': 'łojowy kinkiet',
      'ru': 'Настенный светильник из сала',
      'uk': 'Саловий настінний світильник',
      'ko': '수지 벽 램프',
      'zh': '牛油壁灯',
      'ja': '獣脂壁ランプ'
    }, {
      'id': 'TaroFries',
      'en': 'Taro Fries',
      'fr': 'Frites Taro',
      'es': 'papas fritas',
      'de': 'Taro-Pommes',
      'pl': 'Frytki Taro',
      'ru': 'Таро Фрайс',
      'uk': 'Таро Фрі',
      'ko': '타로 프라이',
      'zh': '芋头薯条',
      'ja': '里芋フライ'
    }, {
      'id': 'TaroSeed',
      'en': 'Taro Seed',
      'fr': 'Graine de Taro',
      'es': 'Semilla de Taro',
      'de': 'Taro-Samen',
      'pl': 'Nasiona Taro',
      'ru': 'Семя Таро',
      'uk': 'Насіння Таро',
      'ko': '타로 씨',
      'zh': '芋头',
      'ja': '里芋の種'
    }, {
      'id': 'TastyTropicalPizza',
      'en': 'Tasty Tropical Pizza',
      'fr': 'Pizza tropicale savoureuse',
      'es': 'Sabrosa pizza tropical',
      'de': 'Leckere tropische Pizza',
      'pl': 'Smaczna Tropikalna Pizza',
      'ru': 'Вкусная Тропическая Пицца',
      'uk': 'Смачна тропічна піца',
      'ko': '맛있는 열대 피자',
      'zh': '美味的热带披萨',
      'ja': 'おいしいトロピカルピザ'
    }, {
      'id': 'Toilet',
      'en': 'Toilet',
      'fr': 'Toilette',
      'es': 'Inodoro',
      'de': 'Toilette',
      'pl': 'Toaleta',
      'ru': 'Туалет',
      'uk': 'Туалет',
      'ko': '화장실',
      'zh': '洗手间',
      'ja': 'トイレ'
    }, {
      'id': 'TomatoSeed',
      'en': 'Tomato Seed',
      'fr': 'Graine de tomate',
      'es': 'Semilla de tomate',
      'de': 'Tomatensamen',
      'pl': 'Nasiona pomidora',
      'ru': 'Семена помидоров',
      'uk': 'Насіння томатів',
      'ko': '토마토 씨',
      'zh': '番茄种子',
      'ja': 'トマトの種'
    }, {
      'id': 'ToppedPorridge',
      'en': 'Topped Porridge',
      'fr': 'Bouillie garnie',
      'es': 'Gachas cubiertas',
      'de': 'Getoppter Brei',
      'pl': 'Zwieńczona Owsianka',
      'ru': 'Овсяная каша',
      'uk': 'Топлена каша',
      'ko': '토핑된 죽',
      'zh': '稀饭',
      'ja': 'トッピングのお粥'
    }, {
      'id': 'Tortilla',
      'en': 'Tortilla',
      'fr': 'Tortilla',
      'es': 'Tortilla',
      'de': 'Tortilla',
      'pl': 'Tortilla',
      'ru': 'Тортилья',
      'uk': 'Тортилья',
      'ko': '또띠아',
      'zh': '玉米饼',
      'ja': 'トルティーヤ'
    }, {
      'id': 'TowelRack',
      'en': 'Towel Rack',
      'fr': 'Porte-serviette',
      'es': 'toallero',
      'de': 'Handtuchhalter',
      'pl': 'Wieszak na ręczniki',
      'ru': 'Вешалка для полотенец',
      'uk': 'Вішалка для рушників',
      'ko': '수건 걸이',
      'zh': '毛巾架',
      'ja': 'タオル掛け'
    }, {
      'id': 'Transglutaminase',
      'en': 'Transglutaminase',
      'fr': 'Transglutaminase',
      'es': 'transglutaminasa',
      'de': 'Transglutaminase',
      'pl': 'Transglutaminaza',
      'ru': 'трансглютаминаза',
      'uk': 'Трансглутаміназа',
      'ko': '트랜스글루타미나제',
      'zh': '转谷氨酰胺酶',
      'ja': 'トランスグルタミナーゼ'
    }, {
      'id': 'TransmissionPole',
      'en': 'Transmission Pole',
      'fr': 'Pôle Transmission',
      'es': 'Poste de transmisión',
      'de': 'Übertragungsmast',
      'pl': 'Biegun transmisji',
      'ru': 'Передающий полюс',
      'uk': 'Полюс передачі',
      'ko': '전송 극',
      'zh': '输电杆',
      'ja': '電柱'
    }, {
      'id': 'Treasury',
      'en': 'Treasury',
      'fr': 'Trésorerie',
      'es': 'Tesorería',
      'de': 'Schatzkammer',
      'pl': 'Skarbiec',
      'ru': 'Казначейство',
      'uk': 'казначейство',
      'ko': '국고',
      'zh': '国库',
      'ja': '財務省'
    }, {
      'id': 'Trousers',
      'en': 'Trousers',
      'fr': 'Pantalon',
      'es': 'Pantalones',
      'de': 'Hose',
      'pl': 'Spodnie',
      'ru': 'Брюки',
      'uk': 'Штани',
      'ko': '바지',
      'zh': '裤子',
      'ja': 'ズボン'
    }, {
      'id': 'Truck',
      'en': 'Truck',
      'fr': 'Camion',
      'es': 'Camión',
      'de': 'LKW',
      'pl': 'Ciężarówka',
      'ru': 'Грузовая машина',
      'uk': 'Вантажівка',
      'ko': '트럭',
      'zh': '卡车',
      'ja': 'トラック'
    }, {
      'id': 'UpholsteredChair',
      'en': 'Upholstered Chair',
      'fr': 'Chaise rembourrée',
      'es': 'Silla tapizada',
      'de': 'Gepolsterter Stuhl',
      'pl': 'Krzesło tapicerowane',
      'ru': 'Мягкий стул',
      'uk': 'М\u0027який стілець',
      'ko': '덮개를 씌운 의자',
      'zh': '软垫椅子',
      'ja': '布張りの椅子'
    }, {
      'id': 'UpholsteredCouch',
      'en': 'Upholstered Couch',
      'fr': 'Canapé rembourré',
      'es': 'Sofá tapizado',
      'de': 'Gepolsterte Couch',
      'pl': 'Tapicerowana kanapa',
      'ru': 'Мягкий диван',
      'uk': 'М\u0027який диван',
      'ko': '덮개를 씌운 소파',
      'zh': '软垫沙发',
      'ja': '布張りのソファ'
    }, {
      'id': 'Valve',
      'en': 'Valve',
      'fr': 'Soupape',
      'es': 'Válvula',
      'de': 'Ventil',
      'pl': 'Zawór',
      'ru': 'Клапан',
      'uk': 'Клапан',
      'ko': '판막',
      'zh': '阀门',
      'ja': 'バルブ'
    }, {
      'id': 'ExoticVegetableMedley',
      'en': 'Exotic Vegetable Medley',
      'fr': 'Mélange de légumes exotiques',
      'es': 'Mezcla de verduras exóticas',
      'de': 'Exotische Gemüsemischung',
      'pl': 'Egzotyczna Mieszanka Warzywna',
      'ru': 'Экзотическая овощная смесь',
      'uk': 'Екзотична овочева суміш',
      'ko': '이국적인 야채 메들리',
      'zh': '异国情调的蔬菜混合泳',
      'ja': 'エキゾチックベジタブルメドレー'
    }, {
      'id': 'MixedVegetableMedley',
      'en': 'Mixed Vegetable Medley',
      'fr': 'Mélange de légumes mélangés',
      'es': 'Mezcla de Verduras Mixtas',
      'de': 'Gemischter Gemüsemix',
      'pl': 'Mieszanka Warzywna',
      'ru': 'Смешанная овощная смесь',
      'uk': 'Овочева суміш',
      'ko': '혼합 야채 메들리',
      'zh': '混合蔬菜混合泳',
      'ja': 'ミックスベジタブルメドレー'
    }, {
      'id': 'MushroomMedley',
      'en': 'Mushroom Medley',
      'fr': 'Mélange de champignons',
      'es': 'popurrí de setas',
      'de': 'Pilz-Medley',
      'pl': 'Mieszanka grzybowa',
      'ru': 'Грибная смесь',
      'uk': 'Грибна суміш',
      'ko': '버섯 메들리',
      'zh': '蘑菇混合泳',
      'ja': 'きのこメドレー'
    }, {
      'id': 'VegetableSoup',
      'en': 'Vegetable Soup',
      'fr': 'Soupe aux légumes',
      'es': 'Sopa de verduras',
      'de': 'Gemüsesuppe',
      'pl': 'Zupa warzywna',
      'ru': 'Овощной суп',
      'uk': 'Овочевий суп',
      'ko': '야채 수프',
      'zh': '蔬菜汤',
      'ja': '野菜スープ'
    }, {
      'id': 'VegetableStock',
      'en': 'Vegetable Stock',
      'fr': 'Bouillon de légumes',
      'es': 'Caldo de verduras',
      'de': 'Gemüsebrühe',
      'pl': 'Zapas warzyw',
      'ru': 'Овощного бульона',
      'uk': 'Овочевий бульйон',
      'ko': '야채 스톡',
      'zh': '蔬菜汤',
      'ja': '野菜ストック'
    }, {
      'id': 'WainwrightTable',
      'en': 'Wainwright Table',
      'fr': 'Table Wainwright',
      'es': 'Mesa Wainwright',
      'de': 'Wainwright-Tisch',
      'pl': 'Stół Wainwrighta',
      'ru': 'Стол Уэйнрайта',
      'uk': 'Стіл Уейнрайта',
      'ko': '웨인라이트 테이블',
      'zh': '温赖特表',
      'ja': 'ウェインライトテーブル'
    }, {
      'id': 'WallCandle',
      'en': 'Wall Candle',
      'fr': 'Bougie murale',
      'es': 'Vela de pared',
      'de': 'Wandkerze',
      'pl': 'Świeca ścienna',
      'ru': 'Настенная свеча',
      'uk': 'Настінна свічка',
      'ko': '벽 양초',
      'zh': '壁挂蜡烛',
      'ja': 'ウォールキャンドル'
    }, {
      'id': 'Washboard',
      'en': 'Washboard',
      'fr': 'Planche à laver',
      'es': 'tabla de lavar',
      'de': 'Waschbrett',
      'pl': 'Tarka do prania',
      'ru': 'Стиральная доска',
      'uk': 'Пральна дошка',
      'ko': '빨래판',
      'zh': '搓板',
      'ja': '洗濯板'
    }, {
      'id': 'WashingMachine',
      'en': 'Washing Machine',
      'fr': 'Machine à laver',
      'es': 'Lavadora',
      'de': 'Waschmaschine',
      'pl': 'Pralka',
      'ru': 'Стиральная машина',
      'uk': 'Пральна машина',
      'ko': '세탁기',
      'zh': '洗衣机',
      'ja': '洗濯機'
    }, {
      'id': 'WasteFilter',
      'en': 'Waste Filter',
      'fr': 'Filtre à déchets',
      'es': 'Filtro de residuos',
      'de': 'Abfallfilter',
      'pl': 'Filtr odpadów',
      'ru': 'Фильтр отходов',
      'uk': 'Фільтр для відходів',
      'ko': '폐기물 필터',
      'zh': '废物过滤器',
      'ja': '廃棄物フィルター'
    }, {
      'id': 'Waterwheel',
      'en': 'Waterwheel',
      'fr': 'Roue hydraulique',
      'es': 'Rueda de agua',
      'de': 'Wasserrad',
      'pl': 'Młyn wodny',
      'ru': 'Водяное колесо',
      'uk': 'Водяне колесо',
      'ko': '물레 방아',
      'zh': '水车',
      'ja': '水車'
    }, {
      'id': 'WheatSeed',
      'en': 'Wheat Seed',
      'fr': 'Graine de blé',
      'es': 'Semilla de trigo',
      'de': 'Weizensamen',
      'pl': 'Nasiona pszenicy',
      'ru': 'Семена пшеницы',
      'uk': 'Насіння пшениці',
      'ko': '밀씨',
      'zh': '小麦种子',
      'ja': '小麦の種'
    }, {
      'id': 'Wheelbarrow',
      'en': 'Wheelbarrow',
      'fr': 'Brouette',
      'es': 'Carretilla',
      'de': 'Schubkarre',
      'pl': 'Taczka',
      'ru': 'Тачка',
      'uk': 'Тачка',
      'ko': '일륜차',
      'zh': '独轮车',
      'ja': '手押し車'
    }, {
      'id': 'WildMix',
      'en': 'Wild Mix',
      'fr': 'Mélange sauvage',
      'es': 'Mezcla salvaje',
      'de': 'Wilde Mischung',
      'pl': 'Dzika mieszanka',
      'ru': 'Дикий микс',
      'uk': 'Дика суміш',
      'ko': '와일드 믹스',
      'zh': '野生混合',
      'ja': 'ワイルドミックス'
    }, {
      'id': 'WildStew',
      'en': 'Wild Stew',
      'fr': 'Ragoût sauvage',
      'es': 'Estofado Salvaje',
      'de': 'Wilder Eintopf',
      'pl': 'Dziki Gulasz',
      'ru': 'Дикое рагу',
      'uk': 'Дике рагу',
      'ko': '와일드 스튜',
      'zh': '野炖',
      'ja': 'ワイルドシチュー'
    }, {
      'id': 'WiltedFiddleheads',
      'en': 'Wilted Fiddleheads',
      'fr': 'Têtes de violon fanées',
      'es': 'Cabezas de violín marchitas',
      'de': 'Verwelkte Fiddleheads',
      'pl': 'Zwiędłe Fiddleheads',
      'ru': 'Увядшие фиддлхеды',
      'uk': 'Зів’ялі Скриплі',
      'ko': '시든 피들 헤드',
      'zh': '枯萎的提琴手',
      'ja': 'しおれた渦巻き状若葉'
    }, {
      'id': 'WindTurbine',
      'en': 'Wind Turbine',
      'fr': 'Éolienne',
      'es': 'Turbina eólica',
      'de': 'Windkraftanlage',
      'pl': 'Turbina wiatrowa',
      'ru': 'Ветряная турбина',
      'uk': 'Вітрових турбін',
      'ko': '풍력 터빈',
      'zh': '风力发电机',
      'ja': '風力タービン'
    }, {
      'id': 'Windmill',
      'en': 'Windmill',
      'fr': 'Moulin à vent',
      'es': 'Molino',
      'de': 'Windmühle',
      'pl': 'Wiatrak',
      'ru': 'Ветряная мельница',
      'uk': 'Вітряк',
      'ko': '풍차 비슷한 것',
      'zh': '风车',
      'ja': '風車'
    }, {
      'id': 'WoodCart',
      'en': 'Wood Cart',
      'fr': 'Chariot en bois',
      'es': 'carro de madera',
      'de': 'Holzwagen',
      'pl': 'Wózek na drewno',
      'ru': 'Деревянная тележка',
      'uk': 'Дерев\u0027яний візок',
      'ko': '나무 카트',
      'zh': '木车',
      'ja': 'ウッドカート'
    }, {
      'id': 'WoodenCeilingLight',
      'en': 'Wooden Ceiling Light',
      'fr': 'Plafonnier en bois',
      'es': 'Luz de techo de madera',
      'de': 'Deckenleuchte aus Holz',
      'pl': 'Drewniana lampa sufitowa',
      'ru': 'Деревянный потолочный светильник',
      'uk': 'Дерев\u0027яний стельовий світильник',
      'ko': '나무 천장 조명',
      'zh': '木制吸顶灯',
      'ja': '木製シーリングライト'
    }, {
      'id': 'WoodenElevator',
      'en': 'Wooden Elevator',
      'fr': 'Ascenseur en bois',
      'es': 'Ascensor de madera',
      'de': 'Aufzug aus Holz',
      'pl': 'Drewniana Winda',
      'ru': 'Деревянный лифт',
      'uk': 'Дерев\u0027яний ліфт',
      'ko': '나무 엘리베이터',
      'zh': '木制电梯',
      'ja': '木製エレベーター'
    }, {
      'id': 'WoodenFabricBed',
      'en': 'Wooden Fabric Bed',
      'fr': 'Lit en tissu en bois',
      'es': 'Cama de tela de madera',
      'de': 'Stoffbett aus Holz',
      'pl': 'Drewniane łóżko z tkaniny',
      'ru': 'Деревянная Тканевая Кровать',
      'uk': 'Ліжко з дерев\u0027яної тканини',
      'ko': '나무 패브릭 침대',
      'zh': '木制布艺床',
      'ja': '木製の布製ベッド'
    }, {
      'id': 'WoodenFloorLamp',
      'en': 'Wooden Floor Lamp',
      'fr': 'Lampadaire en bois',
      'es': 'Lámpara de pie de madera',
      'de': 'Stehlampe aus Holz',
      'pl': 'Drewniana lampa podłogowa',
      'ru': 'Деревянный Торшер',
      'uk': 'Дерев\u0027яний торшер',
      'ko': '나무 바닥 램프',
      'zh': '木质落地灯',
      'ja': '木製フロアランプ'
    }, {
      'id': 'WoodenKitchenLamp',
      'en': 'Wooden Kitchen Lamp',
      'fr': 'Lampe de cuisine en bois',
      'es': 'Lámpara de cocina de madera',
      'de': 'Küchenlampe aus Holz',
      'pl': 'Drewniana lampa kuchenna',
      'ru': 'Деревянная кухонная лампа',
      'uk': 'Дерев\u0027яна кухонна лампа',
      'ko': '나무 주방 램프',
      'zh': '木制厨房灯',
      'ja': '木製キッチンランプ'
    }, {
      'id': 'WoodenLatrine',
      'en': 'Wooden Latrine',
      'fr': 'Latrines en bois',
      'es': 'letrina de madera',
      'de': 'Latrine aus Holz',
      'pl': 'Drewniana latryna',
      'ru': 'Деревянный туалет',
      'uk': 'Дерев\u0027яний туалет',
      'ko': '나무 변소',
      'zh': '木制厕所',
      'ja': '木製のトイレ'
    }, {
      'id': 'WoodenStrawBed',
      'en': 'Wooden Straw Bed',
      'fr': 'Lit de paille en bois',
      'es': 'Cama de paja de madera',
      'de': 'Strohbett aus Holz',
      'pl': 'Drewniane łóżko ze słomy',
      'ru': 'Деревянная соломенная кровать',
      'uk': 'Дерев\u0027яне ліжко з соломи',
      'ko': '나무 짚 침대',
      'zh': '木草床',
      'ja': '木製のわらのベッド'
    }, {
      'id': 'WoodenTableLamp',
      'en': 'Wooden Table Lamp',
      'fr': 'Lampe de table en bois',
      'es': 'Lámpara de mesa de madera',
      'de': 'Tischlampe aus Holz',
      'pl': 'Drewniana lampa stołowa',
      'ru': 'Деревянная настольная лампа',
      'uk': 'Дерев\u0027яна настільна лампа',
      'ko': '나무 테이블 램프',
      'zh': '木制台灯',
      'ja': '木製のテーブルランプ'
    }, {
      'id': 'WoodenWheel',
      'en': 'Wooden Wheel',
      'fr': 'Roue en bois',
      'es': 'Rueda de madera',
      'de': 'Holzrad',
      'pl': 'Drewniane koło',
      'ru': 'Деревянное колесо',
      'uk': 'Дерев\u0027яне колесо',
      'ko': '나무 바퀴',
      'zh': '木轮',
      'ja': '木製ホイール'
    }, {
      'id': 'WoolCarpet',
      'en': 'Wool Carpet',
      'fr': 'Tapis en laine',
      'es': 'Alfombra de lana',
      'de': 'Wollteppich',
      'pl': 'Dywan wełniany',
      'ru': 'Шерстяной ковер',
      'uk': 'Вовняний килим',
      'ko': '양모 카펫',
      'zh': '羊毛地毯',
      'ja': 'ウールカーペット'
    }, {
      'id': 'WeaveWoolCurtains',
      'en': 'Weave Wool Curtains',
      'fr': 'Tisser des rideaux de laine',
      'es': 'Cortinas de lana tejida',
      'de': 'Weben Sie Wollvorhänge',
      'pl': 'Splot wełnianych zasłon',
      'ru': 'ткать шерстяные шторы',
      'uk': 'Плетіть вовняні штори',
      'ko': '양모 커튼을 짜다',
      'zh': '编织羊毛窗帘',
      'ja': '織りウールカーテン'
    }, {
      'id': 'WoolCurtains',
      'en': 'Wool Curtains',
      'fr': 'Rideaux en laine',
      'es': 'Cortinas de lana',
      'de': 'Wollvorhänge',
      'pl': 'Zasłony wełniane',
      'ru': 'Шерстяные шторы',
      'uk': 'Вовняні штори',
      'ko': '울 커튼',
      'zh': '羊毛窗帘',
      'ja': 'ウールカーテン'
    }, {
      'id': 'WeaveWoolFabric',
      'en': 'Weave Wool Fabric',
      'fr': 'Tissu en laine tissée',
      'es': 'tejido de lana',
      'de': 'Weben Sie Wollstoff',
      'pl': 'Splot tkaniny wełny',
      'ru': 'шерстяная ткань',
      'uk': 'Ткання вовняної тканини',
      'ko': '양모 원단을 짜다',
      'zh': '编织羊毛面料',
      'ja': '織りウール生地'
    }, {
      'id': 'WoolFabric',
      'en': 'Wool Fabric',
      'fr': 'Tissu en laine',
      'es': 'Tejido de lana',
      'de': 'Wollstoff',
      'pl': 'Tkanina wełniana',
      'ru': 'Шерстяная Ткань',
      'uk': 'Вовняна тканина',
      'ko': '울 원단',
      'zh': '羊毛面料',
      'ja': 'ウール生地'
    }, {
      'id': 'SpinWoolYarn',
      'en': 'Spin Wool Yarn',
      'fr': 'Fil de laine',
      'es': 'Hilado de lana',
      'de': 'Wollgarn spinnen',
      'pl': 'Przędza z wełny przędzalniczej',
      'ru': 'шерстяная пряжа',
      'uk': 'Пряжа вовняна пряжа',
      'ko': '방적사',
      'zh': '纺毛纱',
      'ja': 'スピンウール糸'
    }, {
      'id': 'WoolYarn',
      'en': 'Wool Yarn',
      'fr': 'Fil de laine',
      'es': 'Hilados de lana',
      'de': 'Wollgarn',
      'pl': 'Przędza wełniana',
      'ru': 'Шерстяная пряжа',
      'uk': 'Вовняна пряжа',
      'ko': '양모사',
      'zh': '羊毛纱',
      'ja': 'ウール糸'
    }, {
      'id': 'WorkBackpack',
      'en': 'Work Backpack',
      'fr': 'Sac à dos de travail',
      'es': 'Mochila de trabajo',
      'de': 'Arbeitsrucksack',
      'pl': 'Plecak roboczy',
      'ru': 'Рабочий рюкзак',
      'uk': 'Робочий рюкзак',
      'ko': '작업 백팩',
      'zh': '工作背包',
      'ja': '仕事用バックパック'
    }, {
      'id': 'WorkBoots',
      'en': 'Work Boots',
      'fr': 'Bottes de travail',
      'es': 'Botas de trabajo',
      'de': 'Arbeitsschuhe',
      'pl': 'Buty robocze',
      'ru': 'Рабочие ботинки',
      'uk': 'Робочі черевики',
      'ko': '작업 부츠',
      'zh': '工作靴',
      'ja': 'ワークブーツ'
    }, {
      'id': 'WorldlyDonut',
      'en': 'Worldly Donut',
      'fr': 'Beignet mondain',
      'es': 'Rosquilla mundana',
      'de': 'Weltlicher Donut',
      'pl': 'Światowy pączek',
      'ru': 'Мирской пончик',
      'uk': 'Світський пончик',
      'ko': '세속적인 도넛',
      'zh': '世俗的甜甜圈',
      'ja': '世俗的なドーナツ'
    }, {
      'id': 'Yeast',
      'en': 'Yeast',
      'fr': 'Levure',
      'es': 'Levadura',
      'de': 'Hefe',
      'pl': 'Drożdże',
      'ru': 'Дрожжи',
      'uk': 'Дріжджі',
      'ko': '누룩',
      'zh': '酵母',
      'ja': '酵母'
    }]
  }, {
    'type': 'skills', 'entries': [{
      'id': 'AdvancedBakingSkill',
      'en': 'Advanced Baking',
      'fr': 'Cuisson avancée',
      'es': 'Horneado avanzado',
      'de': 'Fortgeschrittenes Backen',
      'pl': 'Zaawansowane pieczenie',
      'ru': 'Продвинутая выпечка',
      'uk': 'Розширена випічка',
      'ko': '고급 베이킹',
      'zh': '高级烘焙',
      'ja': '高度なベーキング'
    }, {
      'id': 'AdvancedCookingSkill',
      'en': 'Advanced Cooking',
      'fr': 'Cuisine avancée',
      'es': 'Cocina avanzada',
      'de': 'Fortgeschrittenes Kochen',
      'pl': 'Zaawansowane gotowanie',
      'ru': 'Продвинутая кулинария',
      'uk': 'Розширене приготування їжі',
      'ko': '고급 요리',
      'zh': '高级烹饪',
      'ja': '高度な料理'
    }, {
      'id': 'AdvancedMasonrySkill',
      'en': 'Advanced Masonry',
      'fr': 'Maçonnerie avancée',
      'es': 'Albañilería avanzada',
      'de': 'Fortgeschrittenes Mauerwerk',
      'pl': 'Zaawansowane murowanie',
      'ru': 'Продвинутая кладка',
      'uk': 'Розширена кладка',
      'ko': '고급 벽돌',
      'zh': '高级砌筑',
      'ja': '高度な組積造'
    }, {
      'id': 'AdvancedSmeltingSkill',
      'en': 'Advanced Smelting',
      'fr': 'Fusion avancée',
      'es': 'Fundición avanzada',
      'de': 'Fortgeschrittenes Schmelzen',
      'pl': 'Zaawansowane wytapianie',
      'ru': 'Продвинутая плавка',
      'uk': 'Розширена плавка',
      'ko': '고급 제련',
      'zh': '高级冶炼',
      'ja': '高度な製錬'
    }, {
      'id': 'BakingSkill',
      'en': 'Baking',
      'fr': 'Pâtisserie',
      'es': 'Horneando',
      'de': 'Backen',
      'pl': 'Pieczenie',
      'ru': 'Выпечка',
      'uk': 'Випічка',
      'ko': '빵 굽기',
      'zh': '烘烤',
      'ja': 'ベーキング'
    }, {
      'id': 'BasicEngineeringSkill',
      'en': 'Basic Engineering',
      'fr': 'Ingénierie de base',
      'es': 'Ingeniería básica',
      'de': 'Grundlagentechnik',
      'pl': 'Inżynieria podstawowa',
      'ru': 'Базовое проектирование',
      'uk': 'Основна інженерія',
      'ko': '기초공학',
      'zh': '基础工程',
      'ja': '基礎工学'
    }, {
      'id': 'ButcherySkill',
      'en': 'Butchery',
      'fr': 'Boucherie',
      'es': 'Carnicería',
      'de': 'Metzgerei',
      'pl': 'Rzeź',
      'ru': 'Мясная лавка',
      'uk': 'Різниця',
      'ko': '도살장',
      'zh': '屠宰场',
      'ja': '肉屋'
    }, {
      'id': 'CampfireCookingSkill',
      'en': 'Campfire Cooking',
      'fr': 'Cuisine au feu de camp',
      'es': 'Cocina de fogata',
      'de': 'Kochen am Lagerfeuer',
      'pl': 'Gotowanie przy ognisku',
      'ru': 'Приготовление на костре',
      'uk': 'Приготування на вогні',
      'ko': '모닥불 요리',
      'zh': '篝火烹饪',
      'ja': 'キャンプファイヤークッキング'
    }, {
      'id': 'CarpentrySkill',
      'en': 'Carpentry',
      'fr': 'Charpenterie',
      'es': 'Carpintería',
      'de': 'Zimmerei',
      'pl': 'Stolarstwo',
      'ru': 'Плотницкие работы',
      'uk': 'Столярні вироби',
      'ko': '목공',
      'zh': '木工',
      'ja': '大工仕事'
    }, {
      'id': 'CompositesSkill',
      'en': 'Composites',
      'fr': 'Matériaux composites',
      'es': 'Composicion',
      'de': 'Verbundwerkstoffe',
      'pl': 'Kompozyty',
      'ru': 'Композиты',
      'uk': 'Композити',
      'ko': '합성물',
      'zh': '复合材料',
      'ja': 'コンポジット'
    }, {
      'id': 'CookingSkill',
      'en': 'Cooking',
      'fr': 'Cuisson',
      'es': 'Cocinando',
      'de': 'Kochen',
      'pl': 'Gotowanie',
      'ru': 'Готовка',
      'uk': 'Приготування їжі',
      'ko': '요리',
      'zh': '烹饪',
      'ja': '調理'
    }, {
      'id': 'CuttingEdgeCookingSkill',
      'en': 'Cutting Edge Cooking',
      'fr': 'Cuisine de pointe',
      'es': 'Cocina de vanguardia',
      'de': 'Spitzenkochen',
      'pl': 'Gotowanie na najwyższym poziomie',
      'ru': 'Передовая кухня',
      'uk': 'Кулінарне приготування',
      'ko': '최첨단 요리',
      'zh': '尖端烹饪',
      'ja': '最先端の料理'
    }, {
      'id': 'ElectronicsSkill',
      'en': 'Electronics',
      'fr': 'Électronique',
      'es': 'Electrónica',
      'de': 'Elektronik',
      'pl': 'Elektronika',
      'ru': 'Электроника',
      'uk': 'Електроніка',
      'ko': '전자제품',
      'zh': '电子产品',
      'ja': 'エレクトロニクス'
    }, {
      'id': 'FarmingSkill',
      'en': 'Farming',
      'fr': 'Agriculture',
      'es': 'Agricultura',
      'de': 'Landwirtschaft',
      'pl': 'Rolnictwo',
      'ru': 'Сельское хозяйство',
      'uk': 'Сільське господарство',
      'ko': '농업',
      'zh': '农业',
      'ja': '農業'
    }, {
      'id': 'FertilizersSkill',
      'en': 'Fertilizers',
      'fr': 'Les engrais',
      'es': 'Fertilizantes',
      'de': 'Düngemittel',
      'pl': 'Nawozy',
      'ru': 'Удобрения',
      'uk': 'Добрива',
      'ko': '비료',
      'zh': '肥料',
      'ja': '肥料'
    }, {
      'id': 'GatheringSkill',
      'en': 'Gathering',
      'fr': 'La cueillette',
      'es': 'Reunión',
      'de': 'Sammeln',
      'pl': 'Zgromadzenie',
      'ru': 'Встреча',
      'uk': 'Збір',
      'ko': '모임',
      'zh': '搜集',
      'ja': '収集'
    }, {
      'id': 'GlassworkingSkill',
      'en': 'Glassworking',
      'fr': 'Travail du verre',
      'es': 'Vidrio',
      'de': 'Glasbearbeitung',
      'pl': 'Obróbka szkła',
      'ru': 'Стеклообработка',
      'uk': 'Обробка скла',
      'ko': '유리세공',
      'zh': '玻璃加工',
      'ja': 'ガラス細工'
    }, {
      'id': 'HuntingSkill',
      'en': 'Hunting',
      'fr': 'Chasse',
      'es': 'Caza',
      'de': 'Jagd',
      'pl': 'Polowanie',
      'ru': 'Охота',
      'uk': 'Полювання',
      'ko': '수렵',
      'zh': '打猎',
      'ja': '狩猟'
    }, {
      'id': 'IndustrySkill',
      'en': 'Industry',
      'fr': 'Industrie',
      'es': 'Industria',
      'de': 'Industrie',
      'pl': 'Przemysł',
      'ru': 'Промышленность',
      'uk': 'Промисловість',
      'ko': '산업',
      'zh': '行业',
      'ja': '業界'
    }, {
      'id': 'LoggingSkill',
      'en': 'Logging',
      'fr': 'Enregistrement',
      'es': 'Inicio sesión',
      'de': 'Protokollierung',
      'pl': 'Logowanie',
      'ru': 'логирование',
      'uk': 'Ведення журналу',
      'ko': '벌채 반출',
      'zh': '日志记录',
      'ja': 'ロギング'
    }, {
      'id': 'MasonrySkill',
      'en': 'Masonry',
      'fr': 'Maçonnerie',
      'es': 'Albañilería',
      'de': 'Mauerwerk',
      'pl': 'Kamieniarstwo',
      'ru': 'Каменная кладка',
      'uk': 'Кладка',
      'ko': '석공 직',
      'zh': '石工',
      'ja': '組積造'
    }, {
      'id': 'MechanicsSkill',
      'en': 'Mechanics',
      'fr': 'Mécanique',
      'es': 'Mecánica',
      'de': 'Mechanik',
      'pl': 'Mechanika',
      'ru': 'Механика',
      'uk': 'Механіка',
      'ko': '역학',
      'zh': '力学',
      'ja': '力学'
    }, {
      'id': 'MillingSkill',
      'en': 'Milling',
      'fr': 'Fraisage',
      'es': 'Molienda',
      'de': 'Mahlen',
      'pl': 'Przemiał',
      'ru': 'Фрезерование',
      'uk': 'Фрезерування',
      'ko': '갈기',
      'zh': '铣削',
      'ja': 'フライス盤'
    }, {
      'id': 'MiningSkill',
      'en': 'Mining',
      'fr': 'Exploitation minière',
      'es': 'Minería',
      'de': 'Bergbau',
      'pl': 'Górnictwo',
      'ru': 'Добыча полезных ископаемых',
      'uk': 'Видобуток корисних копалин',
      'ko': '채광',
      'zh': '矿业',
      'ja': '鉱業'
    }, {
      'id': 'OilDrillingSkill',
      'en': 'Oil Drilling',
      'fr': 'Forage pétrolier',
      'es': 'La extracción de petróleo',
      'de': 'Ölbohrung',
      'pl': 'Drążenie w poszukiwaniu ropy',
      'ru': 'Бурение нефтяных скважин',
      'uk': 'Буріння нафти',
      'ko': '석유 시추',
      'zh': '石油钻井',
      'ja': '石油の掘削'
    }, {
      'id': 'PaperMillingSkill',
      'en': 'Paper Milling',
      'fr': 'Fraisage du papier',
      'es': 'Fresado de papel',
      'de': 'Papierfräsen',
      'pl': 'Frezowanie papieru',
      'ru': 'Бумажное фрезерование',
      'uk': 'Фрезерування паперу',
      'ko': '제지 밀링',
      'zh': '造纸',
      'ja': '製紙'
    }, {
      'id': 'PotterySkill',
      'en': 'Pottery',
      'fr': 'Poterie',
      'es': 'cerámica',
      'de': 'Keramik',
      'pl': 'Garncarstwo',
      'ru': 'Керамика',
      'uk': 'Кераміка',
      'ko': '도기류',
      'zh': '陶器',
      'ja': '陶器'
    }, {
      'id': 'SmeltingSkill',
      'en': 'Smelting',
      'fr': 'Fonte',
      'es': 'Fundición',
      'de': 'Schmelzen',
      'pl': 'Wytapianie',
      'ru': 'Плавка',
      'uk': 'Виплавка',
      'ko': '제련',
      'zh': '冶炼',
      'ja': '製錬'
    }, {
      'id': 'TailoringSkill',
      'en': 'Tailoring',
      'fr': 'Adaptation',
      'es': 'Sastrería',
      'de': 'Schneiderei',
      'pl': 'Krawiectwo',
      'ru': 'Портняжное дело',
      'uk': 'Пошиття одягу',
      'ko': '양복점 경영',
      'zh': '剪裁',
      'ja': '仕立て'
    }]
  }, {
    'type': 'tables', 'entries': [{
      'id': 'AdvancedCarpentryTableObject',
      'en': 'Advanced Carpentry Table',
      'fr': 'Table de menuiserie avancée',
      'es': 'Mesa de carpintería avanzada',
      'de': 'Fortgeschrittener Tischlertisch',
      'pl': 'Zaawansowany stół stolarski',
      'ru': 'Продвинутый плотницкий стол',
      'uk': 'Розширений столярний стіл',
      'ko': '고급 목공 테이블',
      'zh': '高级木工台',
      'ja': '高度な大工テーブル'
    }, {
      'id': 'AdvancedMasonryTableObject',
      'en': 'Advanced Masonry Table',
      'fr': 'Table de maçonnerie avancée',
      'es': 'Mesa de mampostería avanzada',
      'de': 'Erweiterter Mauerwerkstisch',
      'pl': 'Zaawansowany stół murarski',
      'ru': 'Расширенный стол для кладки',
      'uk': 'Розширений стіл кладки',
      'ko': '고급 벽돌 테이블',
      'zh': '高级砌石桌',
      'ja': '高度な組積造テーブル'
    }, {
      'id': 'AdvancedTailoringTableObject',
      'en': 'Advanced Tailoring Table',
      'fr': 'Table de couture avancée',
      'es': 'Mesa de sastrería avanzada',
      'de': 'Erweiterter Schneidertisch',
      'pl': 'Zaawansowana tabela krawiectwa',
      'ru': 'Расширенный портной стол',
      'uk': 'Розширений пошивний стіл',
      'ko': '고급 재봉 테이블',
      'zh': '高级裁缝台',
      'ja': '高度な仕立てテーブル'
    }, {
      'id': 'AnvilObject',
      'en': 'Anvil',
      'fr': 'Enclume',
      'es': 'Yunque',
      'de': 'Amboss',
      'pl': 'Kowadło',
      'ru': 'Наковальня',
      'uk': 'Ковадло',
      'ko': '모루',
      'zh': '砧',
      'ja': 'アンビル'
    }, {
      'id': 'ArrastraObject',
      'en': 'Arrastra',
      'fr': 'Arrastra',
      'es': 'Arrastra',
      'de': 'Arrastra',
      'pl': 'Arrastra',
      'ru': 'Arrastra',
      'uk': 'Аррастра',
      'ko': '아라스트라',
      'zh': '阿拉斯特拉',
      'ja': 'アラストラ'
    }, {
      'id': 'AssemblyLineObject',
      'en': 'Assembly Line',
      'fr': 'Ligne d\u0027assemblage',
      'es': 'Linea de ensamblaje',
      'de': 'Fließband',
      'pl': 'Linia produkcyjna',
      'ru': 'Сборочная линия',
      'uk': 'Лінія збірки',
      'ko': '조립 라인',
      'zh': '流水线',
      'ja': '組み立てライン'
    }, {
      'id': 'AutomaticLoomObject',
      'en': 'Automatic Loom',
      'fr': 'Métier à tisser automatique',
      'es': 'Telar automático',
      'de': 'Automatischer Webstuhl',
      'pl': 'Automatyczne krosno',
      'ru': 'Автоматический ткацкий станок',
      'uk': 'Автоматичний ткацький верстат',
      'ko': '자동 베틀',
      'zh': '自动织机',
      'ja': '自動織機'
    }, {
      'id': 'BakeryOvenObject',
      'en': 'Bakery Oven',
      'fr': 'Four de boulangerie',
      'es': 'Horno de panadería',
      'de': 'Backofen',
      'pl': 'Piekarnik',
      'ru': 'Пекарня Духовка',
      'uk': 'Хлібопекарська духовка',
      'ko': '베이커리 오븐',
      'zh': '面包烤箱',
      'ja': 'ベーカリーオーブン'
    }, {
      'id': 'BlastFurnaceObject',
      'en': 'Blast Furnace',
      'fr': 'Haut fourneau',
      'es': 'Alto horno',
      'de': 'Hochofen',
      'pl': 'Wielki Piec',
      'ru': 'Доменная печь',
      'uk': 'Доменна піч',
      'ko': '고로',
      'zh': '高炉',
      'ja': '溶鉱炉'
    }, {
      'id': 'BloomeryObject',
      'en': 'Bloomery',
      'fr': 'Floraison',
      'es': 'Bloomery',
      'de': 'Bloomery',
      'pl': 'Bloomery',
      'ru': 'Bloomery',
      'uk': 'Блумер',
      'ko': '블루메리',
      'zh': '繁花似锦',
      'ja': '塊鉄炉'
    }, {
      'id': 'ButcheryTableObject',
      'en': 'Butchery Table',
      'fr': 'Table de boucherie',
      'es': 'Mesa de carnicería',
      'de': 'Metzgereitisch',
      'pl': 'Stół rzeźniczy',
      'ru': 'Стол для мясной лавки',
      'uk': 'М\u0027ясний стіл',
      'ko': '도살 테이블',
      'zh': '屠宰台',
      'ja': '肉屋のテーブル'
    }, {
      'id': 'CampfireObject',
      'en': 'Campfire',
      'fr': 'Feu de camp',
      'es': 'Hoguera',
      'de': 'Lagerfeuer',
      'pl': 'Ognisko',
      'ru': 'Костер',
      'uk': 'Багаття',
      'ko': '캠프 불',
      'zh': '营火',
      'ja': 'キャンプファイヤー'
    }, {
      'id': 'CampsiteObject',
      'en': 'Campsite',
      'fr': 'Site de camp',
      'es': 'Cámping',
      'de': 'Campingplatz',
      'pl': 'Obozowisko',
      'ru': 'Лагерь',
      'uk': 'Кемпінг',
      'ko': '캠프장',
      'zh': '营地',
      'ja': 'キャンプ場'
    }, {
      'id': 'CapitolObject',
      'en': 'Capitol',
      'fr': 'Capitole',
      'es': 'Capitolio',
      'de': 'Kapitol',
      'pl': 'Kapitol',
      'ru': 'Капитолий',
      'uk': 'Капітолій',
      'ko': '국회 의사당',
      'zh': '国会大厦',
      'ja': '国会議事堂'
    }, {
      'id': 'CarpentryTableObject',
      'en': 'Carpentry Table',
      'fr': 'Table de menuiserie',
      'es': 'Mesa de carpintería',
      'de': 'Tischlerei',
      'pl': 'Stół stolarski',
      'ru': 'Плотницкий стол',
      'uk': 'Столярний стіл',
      'ko': '목공 테이블',
      'zh': '木工台',
      'ja': '大工テーブル'
    }, {
      'id': 'CastIronStoveObject',
      'en': 'Cast Iron Stove',
      'fr': 'Poêle en fonte',
      'es': 'Estufa de hierro fundido',
      'de': 'Gusseisenherd',
      'pl': 'Piec żeliwny',
      'ru': 'Чугунная печь',
      'uk': 'Чавунна піч',
      'ko': '무쇠 스토브',
      'zh': '铸铁炉',
      'ja': '鋳鉄ストーブ'
    }, {
      'id': 'CementKilnObject',
      'en': 'Cement Kiln',
      'fr': 'Four à Ciment',
      'es': 'Horno de cemento',
      'de': 'Zementofen',
      'pl': 'Piec cementowy',
      'ru': 'Цементная печь',
      'uk': 'Цементна піч',
      'ko': '시멘트 가마',
      'zh': '水泥窑',
      'ja': 'セメントキルン'
    }, {
      'id': 'ElectricLatheObject',
      'en': 'Electric Lathe',
      'fr': 'Tour électrique',
      'es': 'Torno electrico',
      'de': 'Elektrische Drehmaschine',
      'pl': 'Tokarka elektryczna',
      'ru': 'Электрический токарный станок',
      'uk': 'Електричний токарний верстат',
      'ko': '전동선반',
      'zh': '电动车床',
      'ja': '電気旋盤'
    }, {
      'id': 'ElectricMachinistTableObject',
      'en': 'Electric Machinist Table',
      'fr': 'Table de machiniste électrique',
      'es': 'Mesa de maquinista eléctrico',
      'de': 'Tisch für Elektromechaniker',
      'pl': 'Elektryczny stół mechanika',
      'ru': 'Стол электромеханика',
      'uk': 'Стіл електричного машиніста',
      'ko': '전기 기계공 테이블',
      'zh': '电工台',
      'ja': '電気機械工テーブル'
    }, {
      'id': 'ElectricPlanerObject',
      'en': 'Electric Planer',
      'fr': 'Rabot électrique',
      'es': 'Cepillo eléctrico',
      'de': 'Elektrohobel',
      'pl': 'Strugarka elektryczna',
      'ru': 'Электрический Рубанок',
      'uk': 'Електричний рубанок',
      'ko': '전기 대패',
      'zh': '电刨',
      'ja': '電気プレーナー'
    }, {
      'id': 'ElectricStampingPressObject',
      'en': 'Electric Stamping Press',
      'fr': 'Presse d\u0027estampage électrique',
      'es': 'Prensa de estampado eléctrica',
      'de': 'Elektrische Stanzpresse',
      'pl': 'Elektryczna prasa do tłoczenia',
      'ru': 'Электрический штамповочный пресс',
      'uk': 'Електричний прес для штампування',
      'ko': '전기 스탬핑 프레스',
      'zh': '电动冲压机',
      'ja': '電気プレスプレス'
    }, {
      'id': 'ElectronicsAssemblyObject',
      'en': 'Electronics Assembly',
      'fr': 'Assemblage électronique',
      'es': 'Ensamblaje de electrónica',
      'de': 'Elektronikmontage',
      'pl': 'Montaż elektroniki',
      'ru': 'Сборка электроники',
      'uk': 'Збірка електроніки',
      'ko': '전자제품 조립',
      'zh': '电子组装',
      'ja': 'エレクトロニクスアセンブリ'
    }, {
      'id': 'FarmersTableObject',
      'en': 'Farmers Table',
      'fr': 'Tableau des agriculteurs',
      'es': 'Mesa de agricultores',
      'de': 'Bauerntisch',
      'pl': 'Tabela rolników',
      'ru': 'Таблица фермеров',
      'uk': 'Таблиця фермерів',
      'ko': '농부 테이블',
      'zh': '农民表',
      'ja': 'ファーマーズテーブル'
    }, {
      'id': 'FisheryObject',
      'en': 'Fishery',
      'fr': 'Pêcherie',
      'es': 'Pesquería',
      'de': 'Fischerei',
      'pl': 'Rybołówstwo',
      'ru': 'Рыболовство',
      'uk': 'Рибальство',
      'ko': '어업',
      'zh': '渔业',
      'ja': '漁業'
    }, {
      'id': 'FrothFloatationCellObject',
      'en': 'Froth Floatation Cell',
      'fr': 'Cellule de flottation de mousse',
      'es': 'Celda de flotación de espuma',
      'de': 'Schaum-Flotationszelle',
      'pl': 'Komórka flotacyjna piany',
      'ru': 'Ячейка пенной флотации',
      'uk': 'Ячейка плаваючої піни',
      'ko': '거품 부유 셀',
      'zh': '泡沫浮选槽',
      'ja': '泡浮きセル'
    }, {
      'id': 'JawCrusherObject',
      'en': 'Jaw Crusher',
      'fr': 'Concasseur à mâchoires',
      'es': 'Rompe mandíbulas',
      'de': 'Kieferbrecher',
      'pl': 'Łamacz szczęk',
      'ru': 'Зубодробилка, мордоворот',
      'uk': 'Щекову дробарку',
      'ko': '조 크러셔',
      'zh': '颚式破碎机',
      'ja': 'ジョークラッシャー'
    }, {
      'id': 'KilnObject',
      'en': 'Kiln',
      'fr': 'Four',
      'es': 'Horno',
      'de': 'Ofen',
      'pl': 'Suszarnia',
      'ru': 'Печь',
      'uk': 'Піч',
      'ko': '가마',
      'zh': '窑',
      'ja': '窯'
    }, {
      'id': 'KitchenObject',
      'en': 'Kitchen',
      'fr': 'Cuisine',
      'es': 'Cocina',
      'de': 'Küche',
      'pl': 'Kuchnia',
      'ru': 'Кухня',
      'uk': 'Кухня',
      'ko': '부엌',
      'zh': '厨房',
      'ja': 'キッチン'
    }, {
      'id': 'LaboratoryObject',
      'en': 'Laboratory',
      'fr': 'Laboratoire',
      'es': 'Laboratorio',
      'de': 'Labor',
      'pl': 'Laboratorium',
      'ru': 'Лаборатория',
      'uk': 'Лабораторія',
      'ko': '실 혐실',
      'zh': '实验室',
      'ja': 'ラボ'
    }, {
      'id': 'LatheObject',
      'en': 'Lathe',
      'fr': 'Tour',
      'es': 'Torno',
      'de': 'Drehbank',
      'pl': 'Tokarka',
      'ru': 'Токарный станок',
      'uk': 'Токарний верстат',
      'ko': '선반',
      'zh': '车床',
      'ja': '旋盤'
    }, {
      'id': 'LoomObject',
      'en': 'Loom',
      'fr': 'Métier à tisser',
      'es': 'Telar',
      'de': 'Webstuhl',
      'pl': 'Warsztat tkacki',
      'ru': 'Ткацкий станок',
      'uk': 'Ткацький верстат',
      'ko': '직조기',
      'zh': '织机',
      'ja': '織機'
    }, {
      'id': 'MachinistTableObject',
      'en': 'Machinist Table',
      'fr': 'Table de machiniste',
      'es': 'Mesa de maquinista',
      'de': 'Maschinentisch',
      'pl': 'Stół maszynisty',
      'ru': 'Стол машиниста',
      'uk': 'Таблиця машиніста',
      'ko': '기계공 테이블',
      'zh': '机械师桌',
      'ja': 'マシニストテーブル'
    }, {
      'id': 'MasonryTableObject',
      'en': 'Masonry Table',
      'fr': 'Table de maçonnerie',
      'es': 'Mesa de mampostería',
      'de': 'Mauerwerkstisch',
      'pl': 'Stół murowany',
      'ru': 'Стол для кладки',
      'uk': 'Мурований стіл',
      'ko': '벽돌 테이블',
      'zh': '石工台',
      'ja': '組積造テーブル'
    }, {
      'id': 'MillObject',
      'en': 'Mill',
      'fr': 'Moulin',
      'es': 'Molino',
      'de': 'Mühle',
      'pl': 'Młyn',
      'ru': 'Мельница',
      'uk': 'Млин',
      'ko': '밀',
      'zh': '磨',
      'ja': '工場'
    }, {
      'id': 'OilRefineryObject',
      'en': 'Oil Refinery',
      'fr': 'Raffinerie de pétrole',
      'es': 'Refinería de petróleo',
      'de': 'Ölraffinerie',
      'pl': 'Rafineria ropy',
      'ru': 'Нефтеперегонный завод',
      'uk': 'НПЗ',
      'ko': '정유',
      'zh': '炼油厂',
      'ja': '石油精製所'
    }, {
      'id': 'PumpJackObject',
      'en': 'Pump Jack',
      'fr': 'Cric de pompe',
      'es': 'Bomba extractora',
      'de': 'Pumpenheber',
      'pl': 'Pompa Jack',
      'ru': 'Насос Джек',
      'uk': 'Насос Джек',
      'ko': '펌프 잭',
      'zh': '泵插孔',
      'ja': 'ポンプジャック'
    }, {
      'id': 'ResearchTableObject',
      'en': 'Research Table',
      'fr': 'Tableau de recherche',
      'es': 'Mesa de investigación',
      'de': 'Forschungstabelle',
      'pl': 'Tabela badawcza',
      'ru': 'Таблица исследований',
      'uk': 'Таблиця досліджень',
      'ko': '연구 테이블',
      'zh': '研究表',
      'ja': '研究表'
    }, {
      'id': 'RoboticAssemblyLineObject',
      'en': 'Robotic Assembly Line',
      'fr': 'Ligne d\u0027assemblage robotique',
      'es': 'Línea de montaje robótica',
      'de': 'Robotermontagelinie',
      'pl': 'Robotyczna linia montażowa',
      'ru': 'Роботизированная сборочная линия',
      'uk': 'Роботизована конвеєрна лінія',
      'ko': '로봇 조립 라인',
      'zh': '机器人装配线',
      'ja': 'ロボット組立ライン'
    }, {
      'id': 'RockerBoxObject',
      'en': 'Rocker Box',
      'fr': 'Boîte à bascule',
      'es': 'Caja de balancines',
      'de': 'Rockerbox',
      'pl': 'Pudełko na biegunach',
      'ru': 'Коробка рокера',
      'uk': 'Коробочка',
      'ko': '로커 박스',
      'zh': '摇杆箱',
      'ja': 'ロッカーボックス'
    }, {
      'id': 'RollingMillObject',
      'en': 'Rolling Mill',
      'fr': 'Laminoir',
      'es': 'Taller de laminación',
      'de': 'Walzwerk',
      'pl': 'Walcownia',
      'ru': 'Прокатный стан',
      'uk': 'Прокатний стан',
      'ko': '압연 공장',
      'zh': '轧机',
      'ja': '圧延装置'
    }, {
      'id': 'SawmillObject',
      'en': 'Sawmill',
      'fr': 'Scierie',
      'es': 'Aserradero',
      'de': 'Sägewerk',
      'pl': 'Tartak',
      'ru': 'Лесопильный завод',
      'uk': 'Пилорама',
      'ko': '제재소',
      'zh': '锯木厂',
      'ja': '製材所'
    }, {
      'id': 'ScreeningMachineObject',
      'en': 'Screening Machine',
      'fr': 'Machine de criblage',
      'es': 'Máquina de cribado',
      'de': 'Siebmaschine',
      'pl': 'Maszyna do przesiewania',
      'ru': 'Просеивающая машина',
      'uk': 'Машина для просіювання',
      'ko': '스크리닝 머신',
      'zh': '筛选机',
      'ja': 'スクリーニング機'
    }, {
      'id': 'ScrewPressObject',
      'en': 'Screw Press',
      'fr': 'Presse à vis',
      'es': 'Tornillo prensado',
      'de': 'Schneckenpresse',
      'pl': 'Prasa śrubowa',
      'ru': 'Винтовой пресс',
      'uk': 'Гвинтовий прес',
      'ko': '스크류 프레스',
      'zh': '螺旋压力机',
      'ja': 'スクリュープレス'
    }, {
      'id': 'SensorBasedBeltSorterObject',
      'en': 'Sensor Based Belt Sorter',
      'fr': 'Trieur de bande à capteur',
      'es': 'Clasificador de banda basado en sensores',
      'de': 'Sensorbasierter Bandsortierer',
      'pl': 'Sortownik taśmowy oparty na czujniku',
      'ru': 'Сенсорный ленточный сортировщик',
      'uk': 'Сортувальник стрічок на основі датчиків',
      'ko': '센서 기반 벨트 분류기',
      'zh': '基于传感器的皮带分拣机',
      'ja': 'センサーベースのベルトソーター'
    }, {
      'id': 'ShaperObject',
      'en': 'Shaper',
      'fr': 'Façonneur',
      'es': 'Moldeador',
      'de': 'Former',
      'pl': 'Shaper',
      'ru': 'Шейпер',
      'uk': 'Формувач',
      'ko': '셰이퍼',
      'zh': '塑造者',
      'ja': '形作る人'
    }, {
      'id': 'SpinMelterObject',
      'en': 'Spin Melter',
      'fr': 'Fondoir à essorage',
      'es': 'Spin Melter',
      'de': 'Schleuderschmelzer',
      'pl': 'Wirówka',
      'ru': 'Прядильная машина',
      'uk': 'Віджимач',
      'ko': '스핀 멜터',
      'zh': '旋转熔胶机',
      'ja': 'スピンメルター'
    }, {
      'id': 'StampMillObject',
      'en': 'Stamp Mill',
      'fr': 'Moulin à timbres',
      'es': 'Molino de sellos',
      'de': 'Stempelmühle',
      'pl': 'Pieczęć Młyn',
      'ru': 'Штамповая фабрика',
      'uk': 'Штамповий млин',
      'ko': '스탬프 밀',
      'zh': '邮票厂',
      'ja': 'スタンプミル'
    }, {
      'id': 'StoveObject',
      'en': 'Stove',
      'fr': 'Poêle',
      'es': 'Cocina',
      'de': 'Herd',
      'pl': 'Kuchenka',
      'ru': 'Печь',
      'uk': 'Піч',
      'ko': '난로',
      'zh': '火炉',
      'ja': 'ストーブ'
    }, {
      'id': 'TailoringTableObject',
      'en': 'Tailoring Table',
      'fr': 'Tableau de couture',
      'es': 'Mesa de sastrería',
      'de': 'Schneidertisch',
      'pl': 'Stół krawiecki',
      'ru': 'Стол для пошива',
      'uk': 'Пошивний стіл',
      'ko': '재봉 테이블',
      'zh': '裁缝台',
      'ja': '仕立てテーブル'
    }, {
      'id': 'ToolBenchObject',
      'en': 'Tool Bench',
      'fr': 'Banc à outils',
      'es': 'Banco de herramientas',
      'de': 'Werkzeugbank',
      'pl': 'Ławka narzędziowa',
      'ru': 'Инструментальная скамья',
      'uk': 'Інструментальна лавка',
      'ko': '도구 벤치',
      'zh': '工具台',
      'ja': 'ツールベンチ'
    }, {
      'id': 'WainwrightTableObject',
      'en': 'Wainwright Table',
      'fr': 'Tableau de Wainwright',
      'es': 'Mesa Wainwright',
      'de': 'Wainwright-Tisch',
      'pl': 'Stół Wainwrighta',
      'ru': 'Стол Уэйнрайта',
      'uk': 'Стіл Уейнрайта',
      'ko': '웨인라이트 테이블',
      'zh': '温赖特表',
      'ja': 'ウェインライトテーブル'
    }, {
      'id': 'WorkbenchObject',
      'en': 'Workbench',
      'fr': 'Table de travail',
      'es': 'Banco de trabajo',
      'de': 'Werkbank',
      'pl': 'stoł warsztatowy',
      'ru': 'Верстак',
      'uk': 'Верстак',
      'ko': '작업대',
      'zh': '工作台',
      'ja': 'ワークベンチ'
    }]
  }, {
    'type': 'upgrades', 'entries': [{
      'id': 'AdvancedUpgrade1',
      'en': 'Advanced Upgrade 1',
      'fr': 'Mise à niveau avancée 1',
      'es': 'Actualización avanzada 1',
      'de': 'Erweitertes Upgrade 1',
      'pl': 'Zaawansowana aktualizacja 1',
      'ru': 'Расширенное обновление 1',
      'uk': 'Розширене оновлення 1',
      'ko': '고급 업그레이드 1',
      'zh': '高级升级 1',
      'ja': '高度なアップグレード1'
    }, {
      'id': 'AdvancedUpgrade2',
      'en': 'Advanced Upgrade 2',
      'fr': 'Mise à niveau avancée 2',
      'es': 'Actualización avanzada 2',
      'de': 'Erweitertes Upgrade 2',
      'pl': 'Zaawansowana aktualizacja 2',
      'ru': 'Расширенное обновление 2',
      'uk': 'Розширене оновлення 2',
      'ko': '고급 업그레이드 2',
      'zh': '高级升级 2',
      'ja': '高度なアップグレード2'
    }, {
      'id': 'AdvancedUpgrade3',
      'en': 'Advanced Upgrade 3',
      'fr': 'Mise à niveau avancée 3',
      'es': 'Actualización avanzada 3',
      'de': 'Erweitertes Upgrade 3',
      'pl': 'Zaawansowana aktualizacja 3',
      'ru': 'Расширенное обновление 3',
      'uk': 'Розширене оновлення 3',
      'ko': '고급 업그레이드 3',
      'zh': '进阶升级3',
      'ja': '高度なアップグレード3'
    }, {
      'id': 'AdvancedUpgrade4',
      'en': 'Advanced Upgrade 4',
      'fr': 'Mise à niveau avancée 4',
      'es': 'Actualización avanzada 4',
      'de': 'Erweitertes Upgrade 4',
      'pl': 'Zaawansowana aktualizacja 4',
      'ru': 'Расширенное обновление 4',
      'uk': 'Розширене оновлення 4',
      'ko': '고급 업그레이드 4',
      'zh': '进阶升级 4',
      'ja': '高度なアップグレード4'
    }, {
      'id': 'BasicUpgrade1',
      'en': 'Basic Upgrade 1',
      'fr': 'Mise à niveau de base 1',
      'es': 'Actualización básica 1',
      'de': 'Basis-Upgrade 1',
      'pl': 'Ulepszenie podstawowe 1',
      'ru': 'Базовое обновление 1',
      'uk': 'Основне оновлення 1',
      'ko': '기본 업그레이드 1',
      'zh': '基本升级 1',
      'ja': '基本アップグレード1'
    }, {
      'id': 'BasicUpgrade2',
      'en': 'Basic Upgrade 2',
      'fr': 'Mise à niveau de base 2',
      'es': 'Actualización básica 2',
      'de': 'Basis-Upgrade 2',
      'pl': 'Ulepszenie podstawowe 2',
      'ru': 'Базовое обновление 2',
      'uk': 'Основне оновлення 2',
      'ko': '기본 업그레이드 2',
      'zh': '基本升级 2',
      'ja': '基本アップグレード2'
    }, {
      'id': 'BasicUpgrade3',
      'en': 'Basic Upgrade 3',
      'fr': 'Mise à niveau de base 3',
      'es': 'Actualización básica 3',
      'de': 'Basis-Upgrade 3',
      'pl': 'Ulepszenie podstawowe 3',
      'ru': 'Базовое обновление 3',
      'uk': 'Основне оновлення 3',
      'ko': '기본 업그레이드 3',
      'zh': '基本升级 3',
      'ja': '基本アップグレード3'
    }, {
      'id': 'BasicUpgrade4',
      'en': 'Basic Upgrade 4',
      'fr': 'Mise à niveau de base 4',
      'es': 'Actualización básica 4',
      'de': 'Basis-Upgrade 4',
      'pl': 'Ulepszenie podstawowe 4',
      'ru': 'Базовое обновление 4',
      'uk': 'Основне оновлення 4',
      'ko': '기본 업그레이드 4',
      'zh': '基本升级 4',
      'ja': '基本アップグレード4'
    }, {
      'id': 'ModernUpgrade1',
      'en': 'Modern Upgrade 1',
      'fr': 'Mise à niveau moderne 1',
      'es': 'Actualización moderna 1',
      'de': 'Modernes Upgrade 1',
      'pl': 'Nowoczesna aktualizacja 1',
      'ru': 'Современное обновление 1',
      'uk': 'Сучасне оновлення 1',
      'ko': '현대 업그레이드 1',
      'zh': '现代升级 1',
      'ja': 'モダンアップグレード1'
    }, {
      'id': 'ModernUpgrade2',
      'en': 'Modern Upgrade 2',
      'fr': 'Mise à niveau moderne 2',
      'es': 'Actualización moderna 2',
      'de': 'Modernes Upgrade 2',
      'pl': 'Nowoczesna aktualizacja 2',
      'ru': 'Современное обновление 2',
      'uk': 'Сучасне оновлення 2',
      'ko': '현대 업그레이드 2',
      'zh': '现代升级 2',
      'ja': 'モダンアップグレード2'
    }, {
      'id': 'ModernUpgrade3',
      'en': 'Modern Upgrade 3',
      'fr': 'Mise à niveau moderne 3',
      'es': 'Actualización moderna 3',
      'de': 'Modernes Upgrade 3',
      'pl': 'Nowoczesna aktualizacja 3',
      'ru': 'Современное обновление 3',
      'uk': 'Сучасне оновлення 3',
      'ko': '현대 업그레이드 3',
      'zh': '现代升级 3',
      'ja': 'モダンアップグレード3'
    }, {
      'id': 'ModernUpgrade4',
      'en': 'Modern Upgrade 4',
      'fr': 'Modernisation de la mise à niveau 4',
      'es': 'Actualización moderna 4',
      'de': 'Modernes Upgrade 4',
      'pl': 'Nowoczesna aktualizacja 4',
      'ru': 'Современное обновление 4',
      'uk': 'Сучасне оновлення 4',
      'ko': '현대 업그레이드 4',
      'zh': '现代升级 4',
      'ja': 'モダンアップグレード4'
    }, {
      'id': 'NoUpgradeBasic',
      'en': 'No Upgrade',
      'fr': 'Pas de mise à niveau',
      'es': 'Sin actualización',
      'de': 'Kein Upgrade',
      'pl': 'Bez aktualizacji',
      'ru': 'Без обновления',
      'uk': 'Без оновлення',
      'ko': '업그레이드 없음',
      'zh': '无升级',
      'ja': 'アップグレードなし'
    }, {
      'id': 'NoUpgradeAdvanced',
      'en': 'No Upgrade',
      'fr': 'Pas de mise à niveau',
      'es': 'Sin actualización',
      'de': 'Kein Upgrade',
      'pl': 'Bez aktualizacji',
      'ru': 'Без обновления',
      'uk': 'Без оновлення',
      'ko': '업그레이드 없음',
      'zh': '无升级',
      'ja': 'アップグレードなし'
    }, {
      'id': 'NoUpgradeModern',
      'en': 'No Upgrade',
      'fr': 'Pas de mise à niveau',
      'es': 'Sin actualización',
      'de': 'Kein Upgrade',
      'pl': 'Bez aktualizacji',
      'ru': 'Без обновления',
      'uk': 'Без оновлення',
      'ko': '업그레이드 없음',
      'zh': '无升级',
      'ja': 'アップグレードなし'
    }, {
      'id': 'NoUpgradeNone',
      'en': 'No Upgrade',
      'fr': 'Pas de mise à niveau',
      'es': 'Sin actualización',
      'de': 'Kein Upgrade',
      'pl': 'Bez aktualizacji',
      'ru': 'Без обновления',
      'uk': 'Без оновлення',
      'ko': '업그레이드 없음',
      'zh': '无升级',
      'ja': 'アップグレードなし'
    }, {
      'id': 'SpecializedAdvancedUpgrade',
      'en': 'Specialized Advanced Upgrade',
      'fr': 'Mise à niveau avancée spécialisée',
      'es': 'Actualización avanzada especializada',
      'de': 'Spezialisiertes erweitertes Upgrade',
      'pl': 'Specjalistyczne zaawansowane ulepszenie',
      'ru': 'Специализированное расширенное обновление',
      'uk': 'Спеціалізоване розширене оновлення',
      'ko': '전문화된 고급 업그레이드',
      'zh': '专业进阶升级',
      'ja': '専門の高度なアップグレード'
    }, {
      'id': 'SpecializedBasicUpgrade',
      'en': 'Specialized Basic Upgrade',
      'fr': 'Mise à niveau de base spécialisée',
      'es': 'Actualización básica especializada',
      'de': 'Spezialisiertes Basis-Upgrade',
      'pl': 'Specjalistyczne podstawowe ulepszenie',
      'ru': 'Специализированное базовое обновление',
      'uk': 'Спеціалізоване базове оновлення',
      'ko': '전문화된 기본 업그레이드',
      'zh': '专业基础升级',
      'ja': '専門の基本アップグレード'
    }, {
      'id': 'SpecializedModernUpgrade',
      'en': 'Specialized Modern Upgrade',
      'fr': 'Mise à niveau moderne spécialisée',
      'es': 'Actualización moderna especializada',
      'de': 'Spezialisiertes modernes Upgrade',
      'pl': 'Specjalistyczne nowoczesne ulepszenie',
      'ru': 'Специализированное современное обновление',
      'uk': 'Спеціалізоване сучасне оновлення',
      'ko': '전문화된 현대 업그레이드',
      'zh': '专业现代升级',
      'ja': 'スペシャライズドモダンアップグレード'
    }]
  }];
